/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* global document */
	/* global localStorage */
	
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactMdl = __webpack_require__(47);
	
	__webpack_require__(247);
	
	__webpack_require__(388);
	
	__webpack_require__(246);
	
	var _src = __webpack_require__(240);
	
	var _src2 = _interopRequireDefault(_src);
	
	var _srcDialogsCustomLinkDialog = __webpack_require__(235);
	
	var _srcDialogsCustomLinkDialog2 = _interopRequireDefault(_srcDialogsCustomLinkDialog);
	
	var _srcDialogsCustomImageDialog = __webpack_require__(234);
	
	var _srcDialogsCustomImageDialog2 = _interopRequireDefault(_srcDialogsCustomImageDialog);
	
	var Demo = _react2['default'].createClass({
	  displayName: 'Demo',
	
	  getInitialState: function getInitialState() {
	    return {
	      'editing': true,
	      'content': JSON.parse(localStorage.getItem('content'))
	    };
	  },
	
	  onChange: function onChange(content) {
	    this.setState({
	      content: content
	    });
	  },
	
	  onEdit: function onEdit() {
	    this.setState({
	      'editing': true
	    });
	  },
	
	  onSave: function onSave() {
	    localStorage.setItem('content', JSON.stringify(this.state.content));
	
	    this.setState({
	      'editing': false
	    });
	  },
	
	  render: function render() {
	    var onChange = this.onChange;
	    var onEdit = this.onEdit;
	    var onSave = this.onSave;
	    var _state = this.state;
	    var content = _state.content;
	    var editing = _state.editing;
	
	    return _react2['default'].createElement(
	      'section',
	      { style: { 'width': 1288, 'margin': '10px auto' } },
	      _react2['default'].createElement(
	        'section',
	        { className: 'clearfix' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'TinyMCE component with default (Material Design Lite) React Dialog'
	        ),
	        _react2['default'].createElement(_src2['default'], {
	          mode: editing ? '' : 'readonly',
	          content: content,
	          onChange: onChange,
	          imageDialog: _srcDialogsCustomImageDialog2['default']
	        }),
	        _react2['default'].createElement(
	          'div',
	          { style: { 'marginTop': 10, 'float': 'right' } },
	          _react2['default'].createElement(
	            _reactMdl.Button,
	            { colored: true, raised: true, ripple: true, onClick: onSave },
	            'Save (local storage)'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'section',
	        { className: 'clearfix' },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'TinyMCE component with custom (Bootstrap) React Dialog'
	        ),
	        _react2['default'].createElement(_src2['default'], {
	          mode: editing ? '' : 'readonly',
	          content: content,
	          onChange: onChange,
	          linkDialog: _srcDialogsCustomLinkDialog2['default']
	        }),
	        _react2['default'].createElement(
	          'div',
	          { style: { 'marginTop': 10, 'float': 'right' } },
	          _react2['default'].createElement(
	            _reactMdl.Button,
	            { colored: true, raised: true, ripple: true, onClick: onSave },
	            'Save (local storage)'
	          )
	        )
	      )
	    );
	  }
	
	});
	
	(0, _reactDom.render)(_react2['default'].createElement(Demo, null), document.querySelector('#demo'));
	/*
	 <div style={{ 'marginTop': 10, 'float': 'left' }}>
	   <Button colored raised ripple onClick={onEdit}>Edit</Button>
	 </div>
	*/

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(443);


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(317);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(316);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(95);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(95);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(162);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(163);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(112);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2['default'])(false, 'A `bsClass` prop is required for this component') : (0, _invariant2['default'])(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _react.PropTypes.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _react.PropTypes.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = propType._values = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _react.PropTypes.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3['default'])({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref) {
	    var propName = _ref[0];
	    var propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2['default'])(props).forEach(function (_ref2) {
	    var propName = _ref2[0];
	    var propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 9 */
7,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(77);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(447);


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMProperty = __webpack_require__(50);
	var ReactDOMComponentFlags = __webpack_require__(199);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports['default'] = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MDLComponent = __webpack_require__(119);
	
	var _MDLComponent2 = _interopRequireDefault(_MDLComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    var render = Component.prototype.render;
	
	    Component.prototype.render = function rendr() {
	        // eslint-disable-line no-param-reassign
	        var renderBound = render.bind(this);
	        return _react2.default.createElement(
	            _MDLComponent2.default,
	            null,
	            renderBound()
	        );
	    };
	
	    return Component;
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2['default'].Children.map(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = undefined;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (!_react2['default'].isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports['default'] = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  tabIndex: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3['default'])(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3['default'])(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var href = _props.href;
	    var onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props;
	    var Component = _props2.componentClass;
	    var disabled = _props2.disabled;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'disabled']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3['default'])({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	      onClick: this.handleClick
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2['default'].Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports['default'] = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 26 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(105)('wks')
	  , uid        = __webpack_require__(71)
	  , Symbol     = __webpack_require__(33).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactCurrentOwner = __webpack_require__(36);
	
	var warning = __webpack_require__(12);
	var canDefineProperty = __webpack_require__(212);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(195);
	var PooledClass = __webpack_require__(35);
	var ReactFeatureFlags = __webpack_require__(202);
	var ReactReconciler = __webpack_require__(51);
	var Transaction = __webpack_require__(65);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(88);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(35);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(12);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(33)
	  , core      = __webpack_require__(26)
	  , ctx       = __webpack_require__(97)
	  , hide      = __webpack_require__(44)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 33 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(166)
	  , defined = __webpack_require__(98);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 38 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(42)
	  , IE8_DOM_DEFINE = __webpack_require__(165)
	  , toPrimitive    = __webpack_require__(108)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(43) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(325), __esModule: true };

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(53)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(39)
	  , createDesc = __webpack_require__(57);
	module.exports = __webpack_require__(43) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(170)
	  , enumBugKeys = __webpack_require__(99);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mdlUpgrade = __webpack_require__(19);
	
	Object.defineProperty(exports, 'mdlUpgrade', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_mdlUpgrade).default;
	    }
	});
	
	var _MDLComponent = __webpack_require__(119);
	
	Object.defineProperty(exports, 'MDLComponent', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MDLComponent).default;
	    }
	});
	
	var _Badge = __webpack_require__(389);
	
	Object.defineProperty(exports, 'Badge', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Badge).default;
	    }
	});
	
	var _Button = __webpack_require__(116);
	
	Object.defineProperty(exports, 'Button', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Button).default;
	    }
	});
	
	var _Card = __webpack_require__(393);
	
	Object.defineProperty(exports, 'Card', {
	    enumerable: true,
	    get: function get() {
	        return _Card.Card;
	    }
	});
	Object.defineProperty(exports, 'CardTitle', {
	    enumerable: true,
	    get: function get() {
	        return _Card.CardTitle;
	    }
	});
	Object.defineProperty(exports, 'CardActions', {
	    enumerable: true,
	    get: function get() {
	        return _Card.CardActions;
	    }
	});
	Object.defineProperty(exports, 'CardMedia', {
	    enumerable: true,
	    get: function get() {
	        return _Card.CardMedia;
	    }
	});
	Object.defineProperty(exports, 'CardText', {
	    enumerable: true,
	    get: function get() {
	        return _Card.CardText;
	    }
	});
	Object.defineProperty(exports, 'CardMenu', {
	    enumerable: true,
	    get: function get() {
	        return _Card.CardMenu;
	    }
	});
	
	var _Checkbox = __webpack_require__(187);
	
	Object.defineProperty(exports, 'Checkbox', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Checkbox).default;
	    }
	});
	
	var _Chip = __webpack_require__(394);
	
	Object.defineProperty(exports, 'Chip', {
	    enumerable: true,
	    get: function get() {
	        return _Chip.Chip;
	    }
	});
	Object.defineProperty(exports, 'ChipContact', {
	    enumerable: true,
	    get: function get() {
	        return _Chip.ChipContact;
	    }
	});
	
	var _DataTable = __webpack_require__(398);
	
	Object.defineProperty(exports, 'DataTable', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DataTable).default;
	    }
	});
	Object.defineProperty(exports, 'Table', {
	    enumerable: true,
	    get: function get() {
	        return _DataTable.Table;
	    }
	});
	Object.defineProperty(exports, 'TableHeader', {
	    enumerable: true,
	    get: function get() {
	        return _DataTable.TableHeader;
	    }
	});
	
	var _Dialog = __webpack_require__(402);
	
	Object.defineProperty(exports, 'Dialog', {
	    enumerable: true,
	    get: function get() {
	        return _Dialog.Dialog;
	    }
	});
	Object.defineProperty(exports, 'DialogTitle', {
	    enumerable: true,
	    get: function get() {
	        return _Dialog.DialogTitle;
	    }
	});
	Object.defineProperty(exports, 'DialogContent', {
	    enumerable: true,
	    get: function get() {
	        return _Dialog.DialogContent;
	    }
	});
	Object.defineProperty(exports, 'DialogActions', {
	    enumerable: true,
	    get: function get() {
	        return _Dialog.DialogActions;
	    }
	});
	
	var _FABButton = __webpack_require__(403);
	
	Object.defineProperty(exports, 'FABButton', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FABButton).default;
	    }
	});
	
	var _Footer = __webpack_require__(408);
	
	Object.defineProperty(exports, 'Footer', {
	    enumerable: true,
	    get: function get() {
	        return _Footer.Footer;
	    }
	});
	Object.defineProperty(exports, 'FooterSection', {
	    enumerable: true,
	    get: function get() {
	        return _Footer.FooterSection;
	    }
	});
	Object.defineProperty(exports, 'FooterDropDownSection', {
	    enumerable: true,
	    get: function get() {
	        return _Footer.FooterDropDownSection;
	    }
	});
	Object.defineProperty(exports, 'FooterLinkList', {
	    enumerable: true,
	    get: function get() {
	        return _Footer.FooterLinkList;
	    }
	});
	
	var _Grid = __webpack_require__(411);
	
	Object.defineProperty(exports, 'Grid', {
	    enumerable: true,
	    get: function get() {
	        return _Grid.Grid;
	    }
	});
	Object.defineProperty(exports, 'Cell', {
	    enumerable: true,
	    get: function get() {
	        return _Grid.Cell;
	    }
	});
	
	var _Icon = __webpack_require__(60);
	
	Object.defineProperty(exports, 'Icon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Icon).default;
	    }
	});
	
	var _IconButton = __webpack_require__(412);
	
	Object.defineProperty(exports, 'IconButton', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_IconButton).default;
	    }
	});
	
	var _IconToggle = __webpack_require__(413);
	
	Object.defineProperty(exports, 'IconToggle', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_IconToggle).default;
	    }
	});
	
	var _Layout = __webpack_require__(419);
	
	Object.defineProperty(exports, 'Layout', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Layout;
	    }
	});
	Object.defineProperty(exports, 'Header', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Header;
	    }
	});
	Object.defineProperty(exports, 'Drawer', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Drawer;
	    }
	});
	Object.defineProperty(exports, 'HeaderRow', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.HeaderRow;
	    }
	});
	Object.defineProperty(exports, 'HeaderTabs', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.HeaderTabs;
	    }
	});
	Object.defineProperty(exports, 'Spacer', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Spacer;
	    }
	});
	Object.defineProperty(exports, 'Navigation', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Navigation;
	    }
	});
	Object.defineProperty(exports, 'Content', {
	    enumerable: true,
	    get: function get() {
	        return _Layout.Content;
	    }
	});
	
	var _List = __webpack_require__(422);
	
	Object.defineProperty(exports, 'List', {
	    enumerable: true,
	    get: function get() {
	        return _List.List;
	    }
	});
	Object.defineProperty(exports, 'ListItem', {
	    enumerable: true,
	    get: function get() {
	        return _List.ListItem;
	    }
	});
	Object.defineProperty(exports, 'ListItemAction', {
	    enumerable: true,
	    get: function get() {
	        return _List.ListItemAction;
	    }
	});
	Object.defineProperty(exports, 'ListItemContent', {
	    enumerable: true,
	    get: function get() {
	        return _List.ListItemContent;
	    }
	});
	
	var _Menu = __webpack_require__(423);
	
	Object.defineProperty(exports, 'Menu', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Menu).default;
	    }
	});
	Object.defineProperty(exports, 'MenuItem', {
	    enumerable: true,
	    get: function get() {
	        return _Menu.MenuItem;
	    }
	});
	
	var _ProgressBar = __webpack_require__(424);
	
	Object.defineProperty(exports, 'ProgressBar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ProgressBar).default;
	    }
	});
	
	var _Radio = __webpack_require__(191);
	
	Object.defineProperty(exports, 'Radio', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Radio).default;
	    }
	});
	
	var _RadioGroup = __webpack_require__(425);
	
	Object.defineProperty(exports, 'RadioGroup', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RadioGroup).default;
	    }
	});
	
	var _Slider = __webpack_require__(426);
	
	Object.defineProperty(exports, 'Slider', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Slider).default;
	    }
	});
	
	var _Snackbar = __webpack_require__(427);
	
	Object.defineProperty(exports, 'Snackbar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Snackbar).default;
	    }
	});
	
	var _Spinner = __webpack_require__(428);
	
	Object.defineProperty(exports, 'Spinner', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Spinner).default;
	    }
	});
	
	var _Switch = __webpack_require__(429);
	
	Object.defineProperty(exports, 'Switch', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Switch).default;
	    }
	});
	
	var _Tabs = __webpack_require__(431);
	
	Object.defineProperty(exports, 'Tabs', {
	    enumerable: true,
	    get: function get() {
	        return _Tabs.Tabs;
	    }
	});
	Object.defineProperty(exports, 'Tab', {
	    enumerable: true,
	    get: function get() {
	        return _Tabs.Tab;
	    }
	});
	Object.defineProperty(exports, 'TabBar', {
	    enumerable: true,
	    get: function get() {
	        return _Tabs.TabBar;
	    }
	});
	
	var _Textfield = __webpack_require__(432);
	
	Object.defineProperty(exports, 'Textfield', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Textfield).default;
	    }
	});
	
	var _Tooltip = __webpack_require__(193);
	
	Object.defineProperty(exports, 'Tooltip', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Tooltip).default;
	    }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (displayName, defaultClassName) {
	    var element = arguments.length <= 2 || arguments[2] === undefined ? 'div' : arguments[2];
	
	    var fn = function fn(props) {
	        var className = props.className;
	        var children = props.children;
	
	        var otherProps = _objectWithoutProperties(props, ['className', 'children']);
	
	        return _react2.default.createElement(element, _extends({
	            className: (0, _classnames2.default)(defaultClassName, className)
	        }, otherProps), children);
	    };
	
	    fn.displayName = displayName;
	    fn.propTypes = {
	        className: _react.PropTypes.string
	    };
	
	    return fn;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(121);
	var setInnerHTML = __webpack_require__(87);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(135);
	var setTextContent = __webpack_require__(219);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(471);
	var ReactInstrumentation = __webpack_require__(23);
	
	var warning = __webpack_require__(12);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  block: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  componentClass: _elementType2['default'],
	  href: _react2['default'].PropTypes.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _react2['default'].PropTypes.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3['default'])(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3['default'])(this, Button);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass;
	    var elementProps = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var active = _props.active;
	    var block = _props.block;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2['default'])(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2['default'].Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 56 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(40);
	
	var contains = (function () {
	  var root = canUseDOM && document.documentElement;
	
	  return root && root.contains ? function (context, node) {
	    return context.contains(node);
	  } : root && root.compareDocumentPosition ? function (context, node) {
	    return context === node || !!(context.compareDocumentPosition(node) & 16);
	  } : function (context, node) {
	    if (node) do {
	      if (node === context) return true;
	    } while (node = node.parentNode);
	
	    return false;
	  };
	})();
	
	module.exports = contains;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(46);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    name: _react.PropTypes.string.isRequired
	};
	
	var Icon = function Icon(props) {
	    var className = props.className;
	    var name = props.name;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'name']);
	
	    var classes = (0, _classnames2.default)('material-icons', className);
	
	    return _react2.default.createElement(
	        'i',
	        _extends({ className: classes }, otherProps),
	        name
	    );
	};
	
	Icon.propTypes = propTypes;
	
	exports.default = Icon;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventPluginRegistry = __webpack_require__(122);
	var EventPluginUtils = __webpack_require__(123);
	var ReactErrorUtils = __webpack_require__(129);
	
	var accumulateInto = __webpack_require__(211);
	var forEachAccumulated = __webpack_require__(213);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(61);
	var EventPluginUtils = __webpack_require__(123);
	
	var accumulateInto = __webpack_require__(211);
	var forEachAccumulated = __webpack_require__(213);
	var warning = __webpack_require__(12);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	var getEventTarget = __webpack_require__(138);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 67 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	    try {
	        cachedSetTimeout = setTimeout;
	    } catch (e) {
	        cachedSetTimeout = function () {
	            throw new Error('setTimeout is not defined');
	        }
	    }
	    try {
	        cachedClearTimeout = clearTimeout;
	    } catch (e) {
	        cachedClearTimeout = function () {
	            throw new Error('clearTimeout is not defined');
	        }
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        return setTimeout(fun, 0);
	    } else {
	        return cachedSetTimeout.call(null, fun, 0);
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        clearTimeout(marker);
	    } else {
	        cachedClearTimeout.call(null, marker);
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(175);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(58);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(113);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(75);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(76);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(78);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(145);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(262);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(147);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(311);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2['default'].defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2['default'].defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _react2['default'].PropTypes.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  componentClass: _elementType2['default'],
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2['default'])((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the Dropdown closes.
	   */
	  onClose: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value.
	   *
	   * ```js
	   * function(Boolean isOpen) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2['default']
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3['default'])(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3['default'])(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2['default'])(_reactDom2['default'].findDOMNode(this.menu), (0, _activeElement2['default'])(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu lets return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick() {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen('click');
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        if (!this.props.open) {
	          this.toggleOpen('keydown');
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.handleClose(event);
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(eventType) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventType;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open);
	    }
	  };
	
	  Dropdown.prototype.handleClose = function handleClose() {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(null);
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2['default'].findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this2 = this;
	
	    var ref = function ref(c) {
	      _this2.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2['default'])(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this3 = this;
	
	    var id = _ref.id;
	    var onClose = _ref.onClose;
	    var onSelect = _ref.onSelect;
	    var props = (0, _objectWithoutProperties3['default'])(_ref, ['id', 'onClose', 'onSelect']);
	
	    var ref = function ref(c) {
	      _this3.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2['default'])(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2['default'])(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3['default'])({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2['default'])(child.props.onClose, onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, this.handleClose)
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var id = _props.id;
	    var dropup = _props.dropup;
	    var disabled = _props.disabled;
	    var pullRight = _props.pullRight;
	    var open = _props.open;
	    var onClose = _props.onClose;
	    var onSelect = _props.onSelect;
	    var role = _props.role;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onClose', 'onSelect', 'role', 'bsClass', 'className', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onClose: onClose, onSelect: onSelect
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2['default'].Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2['default'])(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2['default'];
	UncontrolledDropdown.Menu = _DropdownMenu2['default'];
	
	exports['default'] = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(184);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3['default'])(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3['default'])(this, Fade);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, this.props, {
	      className: (0, _classnames2['default'])(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2['default'].Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports['default'] = Fade;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(163);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports["default"] = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2["default"])(props).forEach(function (_ref) {
	    var propName = _ref[0];
	    var propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 71 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var camelize = __webpack_require__(180),
	    hyphenate = __webpack_require__(377),
	    _getComputedStyle = __webpack_require__(372),
	    removeStyle = __webpack_require__(373);
	
	var has = Object.prototype.hasOwnProperty;
	
	module.exports = function style(node, property, value) {
	  var css = '',
	      props = property;
	
	  if (typeof property === 'string') {
	
	    if (value === undefined) return node.style[camelize(property)] || _getComputedStyle(node).getPropertyValue(hyphenate(property));else (props = {})[property] = value;
	  }
	
	  for (var key in props) if (has.call(props, key)) {
	    !props[key] && props[key] !== 0 ? removeStyle(node, hyphenate(key)) : css += hyphenate(key) + ':' + props[key] + ';';
	  }
	
	  node.style.cssText += ';' + css;
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    factory(exports);
	  } else {
	    factory(root.babelHelpers = {});
	  }
	})(this, function (global) {
	  var babelHelpers = global;
	
	  babelHelpers.interopRequireDefault = function (obj) {
	    return obj && obj.__esModule ? obj : {
	      "default": obj
	    };
	  };
	
	  babelHelpers._extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	})

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(77);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(386);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (component.isMounted()) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)([mixin], set);
	module.exports = exports['default'];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tooltip = __webpack_require__(193);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    cellFormatter: _react.PropTypes.func, // Used by the Table component to format the cell content for this "column"
	    className: _react.PropTypes.string,
	    name: _react.PropTypes.string.isRequired,
	    numeric: _react.PropTypes.bool,
	    onClick: _react.PropTypes.func,
	    nosort: _react.PropTypes.bool,
	    sortFn: _react.PropTypes.func, // Used by the Sortable component
	    tooltip: _react.PropTypes.node
	};
	
	var TableHeader = function TableHeader(props) {
	    var className = props.className;
	    var name = props.name;
	    var numeric = props.numeric;
	    var onClick = props.onClick;
	    var nosort = props.nosort;
	    var tooltip = props.tooltip;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'name', 'numeric', 'onClick', 'nosort', 'tooltip', 'children']);
	
	    // remove unwanted props
	    // see https://github.com/Hacker0x01/react-datepicker/issues/517#issuecomment-230171426
	
	
	    delete otherProps.cellFormatter;
	    delete otherProps.sortFn;
	
	    var classes = (0, _classnames2.default)({
	        'mdl-data-table__cell--non-numeric': !numeric
	    }, className);
	
	    var clickFn = !nosort && onClick ? function (e) {
	        return onClick(e, name);
	    } : null;
	
	    return _react2.default.createElement(
	        'th',
	        _extends({ className: classes, onClick: clickFn }, otherProps),
	        !!tooltip ? _react2.default.createElement(
	            _Tooltip2.default,
	            { label: tooltip },
	            children
	        ) : children
	    );
	};
	
	TableHeader.propTypes = propTypes;
	
	exports.default = TableHeader;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (children, props) {
	    return _react2.default.Children.map(children, function (child) {
	        if (!child) return child;
	        var newProps = typeof props === 'function' ? props(child) : props;
	        return _react2.default.cloneElement(child, newProps);
	    });
	};

/***/ },
/* 81 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var values = [2, 3, 4, 6, 8, 16, 24];
	exports.default = values.map(function (v) {
	  return "mdl-shadow--" + v + "dp";
	});

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = clamp
	
	function clamp(value, min, max) {
	  return min < max
	    ? (value < min ? min : value > max ? max : value)
	    : (value < max ? max : value > min ? min : value)
	}


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventConstants = __webpack_require__(30);
	var EventPluginRegistry = __webpack_require__(122);
	var ReactEventEmitterMixin = __webpack_require__(463);
	var ViewportMetrics = __webpack_require__(210);
	
	var getVendorPrefixedEventName = __webpack_require__(494);
	var isEventSupported = __webpack_require__(139);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	var ViewportMetrics = __webpack_require__(210);
	
	var getEventModifierState = __webpack_require__(137);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	var DOMNamespaces = __webpack_require__(121);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(135);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(67).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89).setImmediate, __webpack_require__(89).clearImmediate))

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(73);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(184);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(161);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2['default'])(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2['default'])(elem, margins[0]), 10) + parseInt((0, _style2['default'])(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  'in': _react2['default'].PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2['default'].PropTypes.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _react2['default'].PropTypes.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _react2['default'].PropTypes.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.oneOf(['height', 'width']), _react2['default'].PropTypes.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  'in': false,
	  timeout: 300,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3['default'])(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3['default'])(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	
	    triggerBrowserReflow(elem);
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2['default'])(dimension)] + 'px';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props;
	    var onEnter = _props.onEnter;
	    var onEntering = _props.onEntering;
	    var onEntered = _props.onEntered;
	    var onExit = _props.onExit;
	    var onExiting = _props.onExiting;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2['default'])(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2['default'])(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2['default'])(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2['default'])(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2['default'])(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2['default'].createElement(_Transition2['default'], (0, _extends3['default'])({}, props, {
	      'aria-expanded': props.role ? props['in'] : null,
	      className: (0, _classnames2['default'])(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2['default'].Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An icon name. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _react2['default'].PropTypes.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3['default'])(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3['default'])(this, Glyphicon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var glyph = _props.glyph;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2['default'].createElement('span', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2['default'].Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(276);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(277);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(278);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(279);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(280);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(281);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3['default'])(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3['default'])(this, Media);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2['default'].Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2['default'];
	Media.Body = _MediaBody2['default'];
	Media.Left = _MediaLeft2['default'];
	Media.Right = _MediaRight2['default'];
	Media.List = _MediaList2['default'];
	Media.ListItem = _MediaListItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uncontrollable = __webpack_require__(78);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _react.PropTypes.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react.PropTypes.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react.PropTypes.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react.PropTypes.any,
	    onSelect: _react.PropTypes.func.isRequired,
	    getTabId: _react.PropTypes.func.isRequired,
	    getPaneId: _react.PropTypes.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3['default'])(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3['default'])(this, TabContainer);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var activeKey = _props.activeKey;
	    var onSelect = _props.onSelect;
	    var generateChildId = _props.generateChildId;
	    var id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props;
	    var children = _props2.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2['default'].cloneElement(_react2['default'].Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2['default'].Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _uncontrollable2['default'])(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    activeKey: _react.PropTypes.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3['default'])(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var bsClass = _props.bsClass;
	    var animation = _props.animation;
	    var unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props;
	    var Component = _props2.componentClass;
	    var className = _props2.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'unmountOnExit']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2['default'].Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(319);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(318);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 96 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(328);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(42)
	  , dPs         = __webpack_require__(344)
	  , enumBugKeys = __webpack_require__(99)
	  , IE_PROTO    = __webpack_require__(104)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(164)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(334).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(39).f
	  , has = __webpack_require__(38)
	  , TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(105)('keys')
	  , uid    = __webpack_require__(71);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(33)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 106 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(98);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(54);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(33)
	  , core           = __webpack_require__(26)
	  , LIBRARY        = __webpack_require__(100)
	  , wksExt         = __webpack_require__(110)
	  , defineProperty = __webpack_require__(39).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(27);

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(40);
	var on = function on() {};
	
	if (canUseDOM) {
	  on = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = on;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 113 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(77);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    accent: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    colored: _react.PropTypes.bool,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    href: _react.PropTypes.string,
	    primary: _react.PropTypes.bool,
	    raised: _react.PropTypes.bool,
	    ripple: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button() {
	        _classCallCheck(this, Button);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Button).apply(this, arguments));
	    }
	
	    _createClass(Button, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var accent = _props.accent;
	            var className = _props.className;
	            var colored = _props.colored;
	            var primary = _props.primary;
	            var raised = _props.raised;
	            var ripple = _props.ripple;
	            var component = _props.component;
	            var href = _props.href;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['accent', 'className', 'colored', 'primary', 'raised', 'ripple', 'component', 'href', 'children']);
	
	            var buttonClasses = (0, _classnames2.default)('mdl-button mdl-js-button', {
	                'mdl-js-ripple-effect': ripple,
	                'mdl-button--raised': raised,
	                'mdl-button--colored': colored,
	                'mdl-button--primary': primary,
	                'mdl-button--accent': accent
	            }, className);
	
	            return _react2.default.createElement(component || (href ? 'a' : 'button'), _extends({
	                className: buttonClasses,
	                href: href
	            }, otherProps), children);
	        }
	    }]);
	
	    return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Button);

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _basicClassCreator2.default)('Spacer', 'mdl-layout-spacer');

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    activeTab: _react.PropTypes.number,
	    className: _react.PropTypes.string,
	    cssPrefix: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func
	};
	
	var defaultProps = {
	    activeTab: 0
	};
	
	var TabBar = function (_React$Component) {
	    _inherits(TabBar, _React$Component);
	
	    function TabBar(props) {
	        _classCallCheck(this, TabBar);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TabBar).call(this, props));
	
	        _this.handleClickTab = _this.handleClickTab.bind(_this);
	        return _this;
	    }
	
	    _createClass(TabBar, [{
	        key: 'handleClickTab',
	        value: function handleClickTab(tabId) {
	            if (this.props.onChange) {
	                this.props.onChange(tabId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var activeTab = _props.activeTab;
	            var className = _props.className;
	            var cssPrefix = _props.cssPrefix;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['activeTab', 'className', 'cssPrefix', 'children']);
	
	            var classes = (0, _classnames2.default)(_defineProperty({}, cssPrefix + '__tab-bar', true), className);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: classes }, otherProps),
	                _react2.default.Children.map(children, function (child, tabId) {
	                    return _react2.default.cloneElement(child, {
	                        cssPrefix: cssPrefix,
	                        tabId: tabId,
	                        active: tabId === activeTab,
	                        onTabClick: _this2.handleClickTab
	                    });
	                })
	            );
	        }
	    }]);
	
	    return TabBar;
	}(_react2.default.Component);
	
	TabBar.propTypes = propTypes;
	TabBar.defaultProps = defaultProps;
	
	exports.default = TabBar;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(15);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MDLComponent = function (_Component) {
	    _inherits(MDLComponent, _Component);
	
	    function MDLComponent() {
	        _classCallCheck(this, MDLComponent);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(MDLComponent).apply(this, arguments));
	    }
	
	    _createClass(MDLComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.componentHandler.upgradeElement((0, _reactDom.findDOMNode)(this));
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.componentHandler.downgradeElements((0, _reactDom.findDOMNode)(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react.Children.only(this.props.children);
	        }
	    }]);
	
	    return MDLComponent;
	}(_react.Component);
	
	exports.default = MDLComponent;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(49);
	var Danger = __webpack_require__(438);
	var ReactMultiChildUpdateTypes = __webpack_require__(206);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(23);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(135);
	var setInnerHTML = __webpack_require__(87);
	var setTextContent = __webpack_require__(219);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventConstants = __webpack_require__(30);
	var ReactErrorUtils = __webpack_require__(129);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactPropTypes = __webpack_require__(208);
	var ReactPropTypeLocations = __webpack_require__(132);
	var ReactPropTypesSecret = __webpack_require__(133);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactNoopUpdateQueue = __webpack_require__(130);
	
	var canDefineProperty = __webpack_require__(212);
	var emptyObject = __webpack_require__(66);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeHook
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(36);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var itemMap;
	var rootIDSet;
	
	var itemByKey;
	var rootByKey;
	
	if (canUseCollections) {
	  itemMap = new Map();
	  rootIDSet = new Set();
	} else {
	  itemByKey = {};
	  rootByKey = {};
	}
	
	var unmountedIDs = [];
	
	// Use non-numeric keys to prevent V8 performance issues:
	// https://github.com/facebook/react/pull/7232
	function getKeyFromID(id) {
	  return '.' + id;
	}
	function getIDFromKey(key) {
	  return parseInt(key.substr(1), 10);
	}
	
	function get(id) {
	  if (canUseCollections) {
	    return itemMap.get(id);
	  } else {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  }
	}
	
	function remove(id) {
	  if (canUseCollections) {
	    itemMap['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  }
	}
	
	function create(id, element, parentID) {
	  var item = {
	    element: element,
	    parentID: parentID,
	    text: null,
	    childIDs: [],
	    isMounted: false,
	    updateCount: 0
	  };
	
	  if (canUseCollections) {
	    itemMap.set(id, item);
	  } else {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  }
	}
	
	function addRoot(id) {
	  if (canUseCollections) {
	    rootIDSet.add(id);
	  } else {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  }
	}
	
	function removeRoot(id) {
	  if (canUseCollections) {
	    rootIDSet['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  }
	}
	
	function getRegisteredIDs() {
	  if (canUseCollections) {
	    return Array.from(itemMap.keys());
	  } else {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  }
	}
	
	function getRootIDs() {
	  if (canUseCollections) {
	    return Array.from(rootIDSet.keys());
	  } else {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  }
	}
	
	function purgeDeep(id) {
	  var item = get(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    remove(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = get(id);
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = get(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent ID is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    create(id, element, parentID);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = get(id);
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = get(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = get(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = get(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = get(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = get(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = get(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = get(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRegisteredIDs: getRegisteredIDs,
	
	  getRootIDs: getRootIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(88);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 133 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 140 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactElement = __webpack_require__(28);
	
	var getIteratorFn = __webpack_require__(215);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(124);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(12);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _react2['default'].PropTypes.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _react2['default'].PropTypes.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _react2['default'].PropTypes.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var href = _props.href;
	    var title = _props.title;
	    var target = _props.target;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: (0, _classnames2['default'])(className, { active: active }) },
	      active ? _react2['default'].createElement('span', props) : _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2['default'].Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports['default'] = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(75);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(52);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  vertical: _react2['default'].PropTypes.bool,
	  justified: _react2['default'].PropTypes.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var block = _ref.block;
	    var vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3['default'])(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var block = _props.block;
	    var justified = _props.justified;
	    var vertical = _props.vertical;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2['default'].defaultProps, 'block')] = block, _extends2));
	
	    return _react2['default'].createElement('div', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2['default'].Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(312);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _react2['default'].PropTypes.func,
	  active: _react2['default'].PropTypes.bool,
	  animateIn: _react2['default'].PropTypes.bool,
	  animateOut: _react2['default'].PropTypes.bool,
	  index: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3['default'])(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2['default'].addEndEventListener(_reactDom2['default'].findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props;
	    var direction = _props.direction;
	    var active = _props.active;
	    var animateIn = _props.animateIn;
	    var animateOut = _props.animateOut;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2['default'].Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports['default'] = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(52);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  noCaret: _react2['default'].PropTypes.bool,
	  open: _react2['default'].PropTypes.bool,
	  title: _react2['default'].PropTypes.string,
	  useAnchor: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3['default'])(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props;
	    var noCaret = _props.noCaret;
	    var open = _props.open;
	    var useAnchor = _props.useAnchor;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2['default'] : _Button2['default'];
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, props, {
	        role: 'button',
	        className: (0, _classnames2['default'])(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2['default'].createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2['default'].Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _react2['default'].PropTypes.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3['default'])(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3['default'])(this, Grid);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props;
	    var fluid = _props.fluid;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2['default'].Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.any,
	  header: _react2['default'].PropTypes.node,
	  listItem: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  href: _react2['default'].PropTypes.string,
	  type: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3['default'])(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2['default'].isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var disabled = _props.disabled;
	    var className = _props.className;
	    var header = _props.header;
	    var listItem = _props.listItem;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2['default'])(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2['default'].createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2['default'].createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2['default'].Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3['default'])(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3['default'])(this, ModalBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3['default'])(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3['default'])(this, ModalFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * The 'aria-label' attribute provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  'aria-label': _react2['default'].PropTypes.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  'aria-label': 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3['default'])(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3['default'])(this, ModalHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props;
	    var label = _props['aria-label'];
	    var closeButton = _props.closeButton;
	    var onHide = _props.onHide;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['aria-label', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      closeButton && _react2['default'].createElement(
	        'button',
	        {
	          type: 'button',
	          className: 'close',
	          'aria-label': label,
	          onClick: (0, _createChainedFunction2['default'])(modal.onHide, onHide)
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '×'
	        )
	      ),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2['default'].Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3['default'])(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3['default'])(this, ModalTitle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('h4', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(113);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(75);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _react2['default'].PropTypes.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _react2['default'].PropTypes.bool,
	
	  justified: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var justified = _ref.justified;
	    var navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _react2['default'].PropTypes.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _react2['default'].PropTypes.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  }),
	
	  $bs_tabContainer: _react2['default'].PropTypes.shape({
	    activeKey: _react2['default'].PropTypes.any,
	    onSelect: _react2['default'].PropTypes.func.isRequired,
	    getTabId: _react2['default'].PropTypes.func.isRequired,
	    getPaneId: _react2['default'].PropTypes.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3['default'])(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps();
	
	    var activeKey = _getActiveProps.activeKey;
	    var activeHref = _getActiveProps.activeHref;
	
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2['default'].toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2['default'].findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.left:
	      case _keycode2['default'].codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2['default'].codes.right:
	      case _keycode2['default'].codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps();
	
	    var activeKey = _getActiveProps2.activeKey;
	    var activeHref = _getActiveProps2.activeHref;
	
	
	    var activeChild = _ValidComponentChildren2['default'].find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props;
	    var id = _child$props.id;
	    var controls = _child$props['aria-controls'];
	    var eventKey = _child$props.eventKey;
	    var role = _child$props.role;
	    var onKeyDown = _child$props.onKeyDown;
	    var tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2['default'])(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props;
	    var stacked = _props.stacked;
	    var justified = _props.justified;
	    var onSelect = _props.onSelect;
	    var propsRole = _props.role;
	    var propsNavbar = _props.navbar;
	    var pullRight = _props.pullRight;
	    var pullLeft = _props.pullLeft;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps();
	
	    var activeKey = _getActiveProps3.activeKey;
	    var activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: role,
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4['default'])({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2['default'].Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  active: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  role: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3['default'])(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3['default'])(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props;
	    var active = _props.active;
	    var disabled = _props.disabled;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var style = _props.style;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2['default'].Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports['default'] = NavItem;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3['default'])(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2['default'].isValidElement(children)) {
	      return _react2['default'].cloneElement(children, {
	        className: (0, _classnames2['default'])(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2['default'].Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports['default'] = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Overlay = __webpack_require__(380);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2['default'].PropTypes.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _react2['default'].PropTypes.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Use animation
	   */
	  animation: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _elementType2['default']]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func
	});
	
	var defaultProps = {
	  animation: _Fade2['default'],
	  rootClose: false,
	  show: false
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3['default'])(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3['default'])(this, Overlay);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props;
	    var animation = _props.animation;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2['default'] : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2['default'])(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2['default'].Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports['default'] = Overlay;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  disabled: _react2['default'].PropTypes.bool,
	  previous: _react2['default'].PropTypes.bool,
	  next: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func,
	  onSelect: _react2['default'].PropTypes.func,
	  eventKey: _react2['default'].PropTypes.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3['default'])(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3['default'])(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var onSelect = _props.onSelect;
	    var eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props;
	    var disabled = _props2.disabled;
	    var previous = _props2.previous;
	    var next = _props2.next;
	    var onClick = _props2.onClick;
	    var className = _props2.className;
	    var style = _props2.style;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2['default'].Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports['default'] = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(162);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  accordion: _react2['default'].PropTypes.bool,
	  activeKey: _react2['default'].PropTypes.any,
	  defaultActiveKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  role: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3['default'])(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3['default'])(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props;
	    var accordion = _props.accordion;
	    var propsActiveKey = _props.activeKey;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2['default'])(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2['default'])(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2['default'].Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _react.PropTypes.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	
	  /** @private **/
	  id: _react.PropTypes.string,
	
	  /** @private **/
	  'aria-labelledby': _react.PropTypes.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _react2['default'].PropTypes.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _react.PropTypes.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _react.PropTypes.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _react.PropTypes.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _react.PropTypes.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _react.PropTypes.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _react.PropTypes.func,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react.PropTypes.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _react.PropTypes.shape({
	    getId: _react.PropTypes.func,
	    unmountOnExit: _react.PropTypes.bool
	  }),
	  $bs_tabContent: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    animation: _react.PropTypes.oneOfType([_react.PropTypes.bool, _elementType2['default']]),
	    activeKey: _react.PropTypes.any,
	    unmountOnExit: _react.PropTypes.bool,
	    onPaneEnter: _react.PropTypes.func.isRequired,
	    onPaneExited: _react.PropTypes.func.isRequired,
	    exiting: _react.PropTypes.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _react.PropTypes.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3['default'])(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this['in'] = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this['in']) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this['in']) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this['in'] = false;
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props;
	    var eventKey = _props.eventKey;
	    var className = _props.className;
	    var onEnter = _props.onEnter;
	    var onEntering = _props.onEntering;
	    var onEntered = _props.onEntered;
	    var onExit = _props.onExit;
	    var onExiting = _props.onExiting;
	    var onExited = _props.onExited;
	    var propsUnmountOnExit = _props.unmountOnExit;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'unmountOnExit']);
	    var _context = this.context;
	    var tabContent = _context.$bs_tabContent;
	    var tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2['default'] : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2['default'])(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2['default'].createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2['default'])(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2['default'])(this.handleExited, onExited),
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2['default'].Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(54)
	  , document = __webpack_require__(33).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(43) && !__webpack_require__(53)(function(){
	  return Object.defineProperty(__webpack_require__(164)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(96);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(100)
	  , $export        = __webpack_require__(32)
	  , redefine       = __webpack_require__(172)
	  , hide           = __webpack_require__(44)
	  , has            = __webpack_require__(38)
	  , Iterators      = __webpack_require__(55)
	  , $iterCreate    = __webpack_require__(338)
	  , setToStringTag = __webpack_require__(103)
	  , getPrototypeOf = __webpack_require__(346)
	  , ITERATOR       = __webpack_require__(27)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(56)
	  , createDesc     = __webpack_require__(57)
	  , toIObject      = __webpack_require__(34)
	  , toPrimitive    = __webpack_require__(108)
	  , has            = __webpack_require__(38)
	  , IE8_DOM_DEFINE = __webpack_require__(165)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(43) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(170)
	  , hiddenKeys = __webpack_require__(99).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(38)
	  , toIObject    = __webpack_require__(34)
	  , arrayIndexOf = __webpack_require__(330)(false)
	  , IE_PROTO     = __webpack_require__(104)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(45)
	  , toIObject = __webpack_require__(34)
	  , isEnum    = __webpack_require__(56).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(44);

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(106)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(348)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(167)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(74);
	
	exports.__esModule = true;
	
	/**
	 * document.activeElement
	 */
	exports['default'] = activeElement;
	
	var _ownerDocument = __webpack_require__(46);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	function activeElement() {
	  var doc = arguments[0] === undefined ? document : arguments[0];
	
	  try {
	    return doc.activeElement;
	  } catch (e) {}
	}
	
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1;
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(40);
	var off = function off() {};
	
	if (canUseDOM) {
	
	  off = (function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  })();
	}
	
	module.exports = off;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var contains = __webpack_require__(58),
	    getWindow = __webpack_require__(72),
	    ownerDocument = __webpack_require__(46);
	
	module.exports = function offset(node) {
	  var doc = ownerDocument(node),
	      win = getWindow(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!contains(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  if (box.width || box.height) {
	
	    box = {
	      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	      width: (box.width == null ? node.offsetWidth : box.width) || 0,
	      height: (box.height == null ? node.offsetHeight : box.height) || 0
	    };
	  }
	
	  return box;
	};

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(72);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	
	'use strict';
	var camelize = __webpack_require__(375);
	var msPattern = /^-ms-/;
	
	module.exports = function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var canUseDOM = __webpack_require__(40);
	
	var size;
	
	module.exports = function (recalc) {
	  if (!size || recalc) {
	    if (canUseDOM) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(115);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _ownerDocument = __webpack_require__(59);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _getContainer = __webpack_require__(114);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = _react2.default.createClass({
	
	  displayName: 'Portal',
	
	  propTypes: {
	    /**
	     * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	     * appended to it.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._renderOverlay();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._renderOverlay();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  },
	  _mountOverlayTarget: function _mountOverlayTarget() {
	    if (!this._overlayTarget) {
	      this._overlayTarget = document.createElement('div');
	      this._portalContainerNode = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  },
	  _unmountOverlayTarget: function _unmountOverlayTarget() {
	    if (this._overlayTarget) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._overlayTarget = null;
	    }
	    this._portalContainerNode = null;
	  },
	  _renderOverlay: function _renderOverlay() {
	
	    var overlay = !this.props.children ? null : _react2.default.Children.only(this.props.children);
	
	    // Save reference for future access.
	    if (overlay !== null) {
	      this._mountOverlayTarget();
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	    } else {
	      // Unrender if the component is null for transitions to null
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  },
	  _unrenderOverlay: function _unrenderOverlay() {
	    if (this._overlayTarget) {
	      _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  },
	  render: function render() {
	    return null;
	  },
	  getMountNode: function getMountNode() {
	    return this._overlayTarget;
	  },
	  getOverlayDOMNode: function getOverlayDOMNode() {
	    if (!this.isMounted()) {
	      throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	    }
	
	    if (this._overlayInstance) {
	      if (this._overlayInstance.getWrappedDOMNode) {
	        return this._overlayInstance.getWrappedDOMNode();
	      } else {
	        return _reactDom2.default.findDOMNode(this._overlayInstance);
	      }
	    }
	
	    return null;
	  }
	});
	
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(185);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _createChainedFunction = __webpack_require__(384);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ownerDocument = __webpack_require__(59);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: Consider using an ES6 symbol here, once we use babel-runtime.
	var CLICK_WAS_INSIDE = '__click_was_inside';
	
	var counter = 0;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	function getSuppressRootClose() {
	  var id = CLICK_WAS_INSIDE + '_' + counter++;
	  return {
	    id: id,
	    suppressRootClose: function suppressRootClose(event) {
	      // Tag the native event to prevent the root close logic on document click.
	      // This seems safer than using event.nativeEvent.stopImmediatePropagation(),
	      // which is only supported in IE >= 9.
	      event.nativeEvent[id] = true;
	    }
	  };
	}
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RootCloseWrapper).call(this, props));
	
	    _this.handleDocumentMouse = _this.handleDocumentMouse.bind(_this);
	    _this.handleDocumentKeyUp = _this.handleDocumentKeyUp.bind(_this);
	
	    var _getSuppressRootClose = getSuppressRootClose();
	
	    var id = _getSuppressRootClose.id;
	    var suppressRootClose = _getSuppressRootClose.suppressRootClose;
	
	
	    _this._suppressRootId = id;
	
	    _this._suppressRootCloseHandler = suppressRootClose;
	    return _this;
	  }
	
	  _createClass(RootCloseWrapper, [{
	    key: 'bindRootCloseHandlers',
	    value: function bindRootCloseHandlers() {
	      var doc = (0, _ownerDocument2.default)(this);
	
	      this._onDocumentMouseListener = (0, _addEventListener2.default)(doc, this.props.event, this.handleDocumentMouse);
	
	      this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	    }
	  }, {
	    key: 'handleDocumentMouse',
	    value: function handleDocumentMouse(e) {
	      // This is now the native event.
	      if (e[this._suppressRootId]) {
	        return;
	      }
	
	      if (this.props.disabled || isModifiedEvent(e) || !isLeftClickEvent(e)) {
	        return;
	      }
	
	      this.props.onRootClose && this.props.onRootClose();
	    }
	  }, {
	    key: 'handleDocumentKeyUp',
	    value: function handleDocumentKeyUp(e) {
	      if (e.keyCode === 27 && this.props.onRootClose) {
	        this.props.onRootClose();
	      }
	    }
	  }, {
	    key: 'unbindRootCloseHandlers',
	    value: function unbindRootCloseHandlers() {
	      if (this._onDocumentMouseListener) {
	        this._onDocumentMouseListener.remove();
	      }
	
	      if (this._onDocumentKeyupListener) {
	        this._onDocumentKeyupListener.remove();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.bindRootCloseHandlers();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var event = _props.event;
	      var noWrap = _props.noWrap;
	      var children = _props.children;
	
	      var child = _react2.default.Children.only(children);
	
	      var handlerName = event == 'click' ? 'onClick' : 'onMouseDown';
	
	      if (noWrap) {
	        return _react2.default.cloneElement(child, _defineProperty({}, handlerName, (0, _createChainedFunction2.default)(this._suppressRootCloseHandler, child.props[handlerName])));
	      }
	
	      // Wrap the child in a new element, so the child won't have to handle
	      // potentially combining multiple onClick listeners.
	      return _react2.default.createElement(
	        'div',
	        _defineProperty({}, handlerName, this._suppressRootCloseHandler),
	        child
	      );
	    }
	  }, {
	    key: 'getWrappedDOMNode',
	    value: function getWrappedDOMNode() {
	      // We can't use a ref to identify the wrapped child, since we might be
	      // stealing the ref from the owner, but we know exactly the DOM structure
	      // that will be rendered, so we can just do this to get the child's DOM
	      // node for doing size calculations in OverlayMixin.
	      var node = _reactDom2.default.findDOMNode(this);
	      return this.props.noWrap ? node : node.firstChild;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindRootCloseHandlers();
	    }
	  }]);
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	exports.default = RootCloseWrapper;
	
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  onRootClose: _react2.default.PropTypes.func,
	
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering
	   * `onRootClose`.
	   */
	  disabled: _react2.default.PropTypes.bool,
	  /**
	   * Passes the suppress click handler directly to the child component instead
	   * of placing it on a wrapping div. Only use when you can be sure the child
	   * properly handle the click event.
	   */
	  noWrap: _react2.default.PropTypes.bool,
	  /**
	   * Choose which document mouse event to bind to
	   */
	  event: _react2.default.PropTypes.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _properties = __webpack_require__(374);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _on = __webpack_require__(111);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecyle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Transition).call(this, props, context));
	
	    var initialStatus = void 0;
	    if (props.in) {
	      // Start enter transition in componentDidMount.
	      initialStatus = props.transitionAppear ? EXITED : ENTERED;
	    } else {
	      initialStatus = props.unmountOnExit ? UNMOUNTED : EXITED;
	    }
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  _createClass(Transition, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.transitionAppear && this.props.in) {
	        this.performEnter(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.in && this.props.unmountOnExit) {
	        if (this.state.status === UNMOUNTED) {
	          // Start enter transition in componentDidUpdate.
	          this.setState({ status: EXITED });
	        }
	      } else {
	        this._needsUpdate = true;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var status = this.state.status;
	
	      if (this.props.unmountOnExit && status === EXITED) {
	        // EXITED is always a transitional state to either ENTERING or UNMOUNTED
	        // when using unmountOnExit.
	        if (this.props.in) {
	          this.performEnter(this.props);
	        } else {
	          this.setState({ status: UNMOUNTED });
	        }
	
	        return;
	      }
	
	      // guard ensures we are only responding to prop changes
	      if (this._needsUpdate) {
	        this._needsUpdate = false;
	
	        if (this.props.in) {
	          if (status === EXITING) {
	            this.performEnter(this.props);
	          } else if (status === EXITED) {
	            this.performEnter(this.props);
	          }
	          // Otherwise we're already entering or entered.
	        } else {
	          if (status === ENTERING || status === ENTERED) {
	            this.performExit(this.props);
	          }
	          // Otherwise we're already exited or exiting.
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'performEnter',
	    value: function performEnter(props) {
	      var _this2 = this;
	
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      // Not this.props, because we might be about to receive new props.
	      props.onEnter(node);
	
	      this.safeSetState({ status: ENTERING }, function () {
	        _this2.props.onEntering(node);
	
	        _this2.onTransitionEnd(node, function () {
	          _this2.safeSetState({ status: ENTERED }, function () {
	            _this2.props.onEntered(node);
	          });
	        });
	      });
	    }
	  }, {
	    key: 'performExit',
	    value: function performExit(props) {
	      var _this3 = this;
	
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      // Not this.props, because we might be about to receive new props.
	      props.onExit(node);
	
	      this.safeSetState({ status: EXITING }, function () {
	        _this3.props.onExiting(node);
	
	        _this3.onTransitionEnd(node, function () {
	          _this3.safeSetState({ status: EXITED }, function () {
	            _this3.props.onExited(node);
	          });
	        });
	      });
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this4 = this;
	
	      var active = true;
	
	      this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this4.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(node, handler) {
	      this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, this.nextCallback);
	        setTimeout(this.nextCallback, this.props.timeout);
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      Object.keys(Transition.propTypes).forEach(function (key) {
	        return delete childProps[key];
	      });
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, _extends({}, childProps, {
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }));
	    }
	  }]);
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _react2.default.PropTypes.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _react2.default.PropTypes.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _react2.default.PropTypes.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _react2.default.PropTypes.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _react2.default.PropTypes.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _react2.default.PropTypes.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _react2.default.PropTypes.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _react2.default.PropTypes.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _react2.default.PropTypes.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler) {
	  (0, _on2.default)(node, event, handler);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler);
	    }
	  };
	};
	
	var _on = __webpack_require__(111);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(177);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(72);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(46);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    checked: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    label: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	var Checkbox = function (_React$Component) {
	    _inherits(Checkbox, _React$Component);
	
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Checkbox).apply(this, arguments));
	    }
	
	    _createClass(Checkbox, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.disabled !== prevProps.disabled) {
	                var fnName = this.props.disabled ? 'disable' : 'enable';
	                (0, _reactDom.findDOMNode)(this).MaterialCheckbox[fnName]();
	            }
	            if (this.props.checked !== prevProps.checked) {
	                var _fnName = this.props.checked ? 'check' : 'uncheck';
	                (0, _reactDom.findDOMNode)(this).MaterialCheckbox[_fnName]();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var label = _props.label;
	            var ripple = _props.ripple;
	
	            var inputProps = _objectWithoutProperties(_props, ['className', 'label', 'ripple']);
	
	            var classes = (0, _classnames2.default)('mdl-checkbox mdl-js-checkbox', {
	                'mdl-js-ripple-effect': ripple
	            }, className);
	
	            return _react2.default.createElement(
	                'label',
	                { className: classes },
	                _react2.default.createElement('input', _extends({
	                    type: 'checkbox',
	                    className: 'mdl-checkbox__input'
	                }, inputProps)),
	                label && _react2.default.createElement(
	                    'span',
	                    { className: 'mdl-checkbox__label' },
	                    label
	                )
	            );
	        }
	    }]);
	
	    return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Checkbox);

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Spacer = __webpack_require__(117);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeaderRow = function HeaderRow(props) {
	    var className = props.className;
	    var title = props.title;
	    var children = props.children;
	    var hideSpacer = props.hideSpacer;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'title', 'children', 'hideSpacer']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__header-row', className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title && _react2.default.createElement(
	            'span',
	            { className: 'mdl-layout-title' },
	            title
	        ),
	        title && !hideSpacer && _react2.default.createElement(_Spacer2.default, null),
	        children
	    );
	};
	HeaderRow.propTypes = {
	    className: _react.PropTypes.string,
	    title: _react.PropTypes.node,
	    hideSpacer: _react.PropTypes.bool
	};
	
	exports.default = HeaderRow;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TabBar = __webpack_require__(118);
	
	var _TabBar2 = _interopRequireDefault(_TabBar);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HeaderTabs = function HeaderTabs(props) {
	    var className = props.className;
	    var ripple = props.ripple;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'ripple', 'children']);
	
	    var classes = (0, _classnames2.default)({
	        'mdl-js-ripple-effect': ripple
	    }, className);
	
	    return _react2.default.createElement(
	        _TabBar2.default,
	        _extends({ cssPrefix: 'mdl-layout', className: classes }, otherProps),
	        children
	    );
	};
	HeaderTabs.propTypes = {
	    activeTab: _react.PropTypes.number,
	    className: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	exports.default = (0, _mdlUpgrade2.default)(HeaderTabs);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(60);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    avatar: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    icon: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	    subtitle: _react.PropTypes.node,
	    useBodyClass: _react.PropTypes.bool
	};
	
	function createIcon(type, icon) {
	    if (typeof icon === 'string') {
	        return _react2.default.createElement(_Icon2.default, { className: 'mdl-list__item-' + type, name: icon });
	    }
	    return _react2.default.cloneElement(icon, { className: 'mdl-list__item-' + type });
	}
	
	var ListItemContent = function ListItemContent(props) {
	    var avatar = props.avatar;
	    var children = props.children;
	    var className = props.className;
	    var icon = props.icon;
	    var subtitle = props.subtitle;
	    var useBodyClass = props.useBodyClass;
	
	    var otherProps = _objectWithoutProperties(props, ['avatar', 'children', 'className', 'icon', 'subtitle', 'useBodyClass']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item-primary-content', className);
	    var subtitleClassName = useBodyClass ? 'mdl-list__item-text-body' : 'mdl-list__item-sub-title';
	
	    var iconElement = null;
	    if (icon) {
	        iconElement = createIcon('icon', icon);
	    } else if (avatar) {
	        iconElement = createIcon('avatar', avatar);
	    }
	
	    return _react2.default.createElement(
	        'span',
	        _extends({ className: classes }, otherProps),
	        iconElement,
	        _react2.default.createElement(
	            'span',
	            null,
	            children
	        ),
	        subtitle && _react2.default.createElement(
	            'span',
	            { className: subtitleClassName },
	            subtitle
	        )
	    );
	};
	
	ListItemContent.propTypes = propTypes;
	
	exports.default = ListItemContent;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    checked: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    name: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
	};
	
	var Radio = function (_React$Component) {
	    _inherits(Radio, _React$Component);
	
	    function Radio() {
	        _classCallCheck(this, Radio);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Radio).apply(this, arguments));
	    }
	
	    _createClass(Radio, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.disabled !== prevProps.disabled) {
	                var fnName = this.props.disabled ? 'disable' : 'enable';
	                (0, _reactDom.findDOMNode)(this).MaterialRadio[fnName]();
	            }
	            if (this.props.checked !== prevProps.checked) {
	                var _fnName = this.props.checked ? 'check' : 'uncheck';
	                (0, _reactDom.findDOMNode)(this).MaterialRadio[_fnName]();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var children = _props.children;
	            var className = _props.className;
	            var name = _props.name;
	            var ripple = _props.ripple;
	            var value = _props.value;
	
	            var inputProps = _objectWithoutProperties(_props, ['children', 'className', 'name', 'ripple', 'value']);
	
	            var classes = (0, _classnames2.default)('mdl-radio mdl-js-radio', {
	                'mdl-js-ripple-effect': ripple
	            }, className);
	
	            return _react2.default.createElement(
	                'label',
	                { className: classes },
	                _react2.default.createElement('input', _extends({
	                    type: 'radio',
	                    className: 'mdl-radio__button',
	                    value: value,
	                    name: name
	                }, inputProps)),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mdl-radio__label' },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Radio;
	}(_react2.default.Component);
	
	Radio.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Radio);

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    active: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    cssPrefix: _react.PropTypes.string,
	    onTabClick: _react.PropTypes.func,
	    style: _react.PropTypes.object,
	    tabId: _react.PropTypes.number
	};
	
	var defaultProps = {
	    style: {}
	};
	
	var Tab = function Tab(props) {
	    var _classNames;
	
	    var active = props.active;
	    var className = props.className;
	    var component = props.component;
	    var children = props.children;
	    var cssPrefix = props.cssPrefix;
	    var onTabClick = props.onTabClick;
	    var style = props.style;
	    var tabId = props.tabId;
	
	    var otherProps = _objectWithoutProperties(props, ['active', 'className', 'component', 'children', 'cssPrefix', 'onTabClick', 'style', 'tabId']);
	
	    var classes = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, cssPrefix + '__tab', true), _defineProperty(_classNames, 'is-active', active), _classNames), className);
	
	    style.cursor = 'pointer';
	
	    return _react2.default.createElement(component || 'a', _extends({
	        className: classes,
	        onClick: function onClick() {
	            return onTabClick(tabId);
	        },
	        style: style
	    }, otherProps), children);
	};
	
	Tab.propTypes = propTypes;
	Tab.defaultProps = defaultProps;
	
	exports.default = Tab;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MDLComponent = __webpack_require__(119);
	
	var _MDLComponent2 = _interopRequireDefault(_MDLComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tooltip = function Tooltip(props) {
	    var label = props.label;
	    var large = props.large;
	    var children = props.children;
	    var position = props.position;
	
	    var otherProps = _objectWithoutProperties(props, ['label', 'large', 'children', 'position']);
	
	    var id = Math.random().toString(36).substr(2);
	
	    var newLabel = typeof label === 'string' ? _react2.default.createElement(
	        'span',
	        null,
	        label
	    ) : label;
	
	    var element = void 0;
	    if (typeof children === 'string') {
	        element = _react2.default.createElement(
	            'span',
	            null,
	            children
	        );
	    } else {
	        element = _react2.default.Children.only(children);
	    }
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ style: { display: 'inline-block' } }, otherProps),
	        _react2.default.cloneElement(element, { id: id }),
	        _react2.default.createElement(
	            _MDLComponent2.default,
	            null,
	            _react2.default.cloneElement(newLabel, {
	                htmlFor: id,
	                className: (0, _classnames2.default)('mdl-tooltip', _defineProperty({
	                    'mdl-tooltip--large': large
	                }, 'mdl-tooltip--' + position, typeof position !== 'undefined'))
	            })
	        )
	    );
	};
	
	Tooltip.propTypes = {
	    children: _react.PropTypes.node.isRequired,
	    label: _react.PropTypes.node.isRequired,
	    large: _react.PropTypes.bool,
	    position: _react.PropTypes.oneOf(['left', 'right', 'top', 'bottom'])
	};
	
	exports.default = Tooltip;

/***/ },
/* 194 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(35);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstrumentation = __webpack_require__(23);
	
	var quoteAttributeValueForBrowser = __webpack_require__(496);
	var warning = __webpack_require__(12);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(35);
	var ReactElement = __webpack_require__(28);
	
	var emptyFunction = __webpack_require__(24);
	var traverseAllChildren = __webpack_require__(141);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var ReactComponent = __webpack_require__(126);
	var ReactElement = __webpack_require__(28);
	var ReactPropTypeLocations = __webpack_require__(132);
	var ReactPropTypeLocationNames = __webpack_require__(131);
	var ReactNoopUpdateQueue = __webpack_require__(130);
	
	var emptyObject = __webpack_require__(66);
	var invariant = __webpack_require__(10);
	var keyMirror = __webpack_require__(88);
	var keyOf = __webpack_require__(37);
	var warning = __webpack_require__(12);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var DisabledInputUtils = __webpack_require__(83);
	var LinkedValueUtils = __webpack_require__(125);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(29);
	
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 202 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(457);
	
	var containsNode = __webpack_require__(500);
	var focusNode = __webpack_require__(221);
	var getActiveElement = __webpack_require__(222);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(49);
	var DOMProperty = __webpack_require__(50);
	var ReactBrowserEventEmitter = __webpack_require__(84);
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMContainerInfo = __webpack_require__(450);
	var ReactDOMFeatureFlags = __webpack_require__(453);
	var ReactElement = __webpack_require__(28);
	var ReactFeatureFlags = __webpack_require__(202);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMarkupChecksum = __webpack_require__(466);
	var ReactReconciler = __webpack_require__(51);
	var ReactUpdateQueue = __webpack_require__(134);
	var ReactUpdates = __webpack_require__(29);
	
	var emptyObject = __webpack_require__(66);
	var instantiateReactComponent = __webpack_require__(217);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(87);
	var shouldUpdateReactComponent = __webpack_require__(140);
	var warning = __webpack_require__(12);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(88);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactElement = __webpack_require__(28);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(28);
	var ReactPropTypeLocationNames = __webpack_require__(131);
	var ReactPropTypesSecret = __webpack_require__(133);
	
	var emptyFunction = __webpack_require__(24);
	var getIteratorFn = __webpack_require__(215);
	var warning = __webpack_require__(12);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.2';

/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 213 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(207);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var ReactCompositeComponent = __webpack_require__(446);
	var ReactEmptyComponent = __webpack_require__(201);
	var ReactHostComponent = __webpack_require__(203);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	var escapeTextContentForBrowser = __webpack_require__(86);
	var setInnerHTML = __webpack_require__(87);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	// 4.4.3 (2016-09-01)
	
	/**
	 * Compiled inline version. (Library mode)
	 */
	
	/*jshint smarttabs:true, undef:true, latedef:true, curly:true, bitwise:true, camelcase:true */
	/*globals $code */
	
	(function(exports, undefined) {
		"use strict";
	
		var modules = {};
	
		function require(ids, callback) {
			var module, defs = [];
	
			for (var i = 0; i < ids.length; ++i) {
				module = modules[ids[i]] || resolve(ids[i]);
				if (!module) {
					throw 'module definition dependecy not found: ' + ids[i];
				}
	
				defs.push(module);
			}
	
			callback.apply(null, defs);
		}
	
		function define(id, dependencies, definition) {
			if (typeof id !== 'string') {
				throw 'invalid module definition, module id must be defined and be a string';
			}
	
			if (dependencies === undefined) {
				throw 'invalid module definition, dependencies must be specified';
			}
	
			if (definition === undefined) {
				throw 'invalid module definition, definition function must be specified';
			}
	
			require(dependencies, function() {
				modules[id] = definition.apply(null, arguments);
			});
		}
	
		function defined(id) {
			return !!modules[id];
		}
	
		function resolve(id) {
			var target = exports;
			var fragments = id.split(/[.\/]/);
	
			for (var fi = 0; fi < fragments.length; ++fi) {
				if (!target[fragments[fi]]) {
					return;
				}
	
				target = target[fragments[fi]];
			}
	
			return target;
		}
	
		function expose(ids) {
			var i, target, id, fragments, privateModules;
	
			for (i = 0; i < ids.length; i++) {
				target = exports;
				id = ids[i];
				fragments = id.split(/[.\/]/);
	
				for (var fi = 0; fi < fragments.length - 1; ++fi) {
					if (target[fragments[fi]] === undefined) {
						target[fragments[fi]] = {};
					}
	
					target = target[fragments[fi]];
				}
	
				target[fragments[fragments.length - 1]] = modules[id];
			}
			
			// Expose private modules for unit tests
			if (exports.AMDLC_TESTS) {
				privateModules = exports.privateModules || {};
	
				for (id in modules) {
					privateModules[id] = modules[id];
				}
	
				for (i = 0; i < ids.length; i++) {
					delete privateModules[ids[i]];
				}
	
				exports.privateModules = privateModules;
			}
		}
	
	// Included from: js/tinymce/classes/geom/Rect.js
	
	/**
	 * Rect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains various tools for rect/position calculation.
	 *
	 * @class tinymce.geom.Rect
	 */
	define("tinymce/geom/Rect", [
	], function() {
		"use strict";
	
		var min = Math.min, max = Math.max, round = Math.round;
	
		/**
		 * Returns the rect positioned based on the relative position name
		 * to the target rect.
		 *
		 * @method relativePosition
		 * @param {Rect} rect Source rect to modify into a new rect.
		 * @param {Rect} targetRect Rect to move relative to based on the rel option.
		 * @param {String} rel Relative position. For example: tr-bl.
		 */
		function relativePosition(rect, targetRect, rel) {
			var x, y, w, h, targetW, targetH;
	
			x = targetRect.x;
			y = targetRect.y;
			w = rect.w;
			h = rect.h;
			targetW = targetRect.w;
			targetH = targetRect.h;
	
			rel = (rel || '').split('');
	
			if (rel[0] === 'b') {
				y += targetH;
			}
	
			if (rel[1] === 'r') {
				x += targetW;
			}
	
			if (rel[0] === 'c') {
				y += round(targetH / 2);
			}
	
			if (rel[1] === 'c') {
				x += round(targetW / 2);
			}
	
			if (rel[3] === 'b') {
				y -= h;
			}
	
			if (rel[4] === 'r') {
				x -= w;
			}
	
			if (rel[3] === 'c') {
				y -= round(h / 2);
			}
	
			if (rel[4] === 'c') {
				x -= round(w / 2);
			}
	
			return create(x, y, w, h);
		}
	
		/**
		 * Tests various positions to get the most suitable one.
		 *
		 * @method findBestRelativePosition
		 * @param {Rect} rect Rect to use as source.
		 * @param {Rect} targetRect Rect to move relative to.
		 * @param {Rect} constrainRect Rect to constrain within.
		 * @param {Array} rels Array of relative positions to test against.
		 */
		function findBestRelativePosition(rect, targetRect, constrainRect, rels) {
			var pos, i;
	
			for (i = 0; i < rels.length; i++) {
				pos = relativePosition(rect, targetRect, rels[i]);
	
				if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x &&
					pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
					return rels[i];
				}
			}
	
			return null;
		}
	
		/**
		 * Inflates the rect in all directions.
		 *
		 * @method inflate
		 * @param {Rect} rect Rect to expand.
		 * @param {Number} w Relative width to expand by.
		 * @param {Number} h Relative height to expand by.
		 * @return {Rect} New expanded rect.
		 */
		function inflate(rect, w, h) {
			return create(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
		}
	
		/**
		 * Returns the intersection of the specified rectangles.
		 *
		 * @method intersect
		 * @param {Rect} rect The first rectangle to compare.
		 * @param {Rect} cropRect The second rectangle to compare.
		 * @return {Rect} The intersection of the two rectangles or null if they don't intersect.
		 */
		function intersect(rect, cropRect) {
			var x1, y1, x2, y2;
	
			x1 = max(rect.x, cropRect.x);
			y1 = max(rect.y, cropRect.y);
			x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
			y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
	
			if (x2 - x1 < 0 || y2 - y1 < 0) {
				return null;
			}
	
			return create(x1, y1, x2 - x1, y2 - y1);
		}
	
		/**
		 * Returns a rect clamped within the specified clamp rect. This forces the
		 * rect to be inside the clamp rect.
		 *
		 * @method clamp
		 * @param {Rect} rect Rectangle to force within clamp rect.
		 * @param {Rect} clampRect Rectable to force within.
		 * @param {Boolean} fixedSize True/false if size should be fixed.
		 * @return {Rect} Clamped rect.
		 */
		function clamp(rect, clampRect, fixedSize) {
			var underflowX1, underflowY1, overflowX2, overflowY2,
				x1, y1, x2, y2, cx2, cy2;
	
			x1 = rect.x;
			y1 = rect.y;
			x2 = rect.x + rect.w;
			y2 = rect.y + rect.h;
			cx2 = clampRect.x + clampRect.w;
			cy2 = clampRect.y + clampRect.h;
	
			underflowX1 = max(0, clampRect.x - x1);
			underflowY1 = max(0, clampRect.y - y1);
			overflowX2 = max(0, x2 - cx2);
			overflowY2 = max(0, y2 - cy2);
	
			x1 += underflowX1;
			y1 += underflowY1;
	
			if (fixedSize) {
				x2 += underflowX1;
				y2 += underflowY1;
				x1 -= overflowX2;
				y1 -= overflowY2;
			}
	
			x2 -= overflowX2;
			y2 -= overflowY2;
	
			return create(x1, y1, x2 - x1, y2 - y1);
		}
	
		/**
		 * Creates a new rectangle object.
		 *
		 * @method create
		 * @param {Number} x Rectangle x location.
		 * @param {Number} y Rectangle y location.
		 * @param {Number} w Rectangle width.
		 * @param {Number} h Rectangle height.
		 * @return {Rect} New rectangle object.
		 */
		function create(x, y, w, h) {
			return {x: x, y: y, w: w, h: h};
		}
	
		/**
		 * Creates a new rectangle object form a clientRects object.
		 *
		 * @method fromClientRect
		 * @param {ClientRect} clientRect DOM ClientRect object.
		 * @return {Rect} New rectangle object.
		 */
		function fromClientRect(clientRect) {
			return create(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
		}
	
		return {
			inflate: inflate,
			relativePosition: relativePosition,
			findBestRelativePosition: findBestRelativePosition,
			intersect: intersect,
			clamp: clamp,
			create: create,
			fromClientRect: fromClientRect
		};
	});
	
	// Included from: js/tinymce/classes/util/Promise.js
	
	/**
	 * Promise.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * Promise polyfill under MIT license: https://github.com/taylorhakes/promise-polyfill
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/* eslint-disable */
	/* jshint ignore:start */
	
	/**
	 * Modifed to be a feature fill and wrapped as tinymce module.
	 */
	define("tinymce/util/Promise", [], function() {
		if (window.Promise) {
			return window.Promise;
		}
	
		// Use polyfill for setImmediate for performance gains
		var asap = Promise.immediateFn || (typeof setImmediate === 'function' && setImmediate) ||
			function(fn) { setTimeout(fn, 1); };
	
		// Polyfill for Function.prototype.bind
		function bind(fn, thisArg) {
			return function() {
				fn.apply(thisArg, arguments);
			};
		}
	
		var isArray = Array.isArray || function(value) { return Object.prototype.toString.call(value) === "[object Array]"; };
	
		function Promise(fn) {
			if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
			if (typeof fn !== 'function') throw new TypeError('not a function');
			this._state = null;
			this._value = null;
			this._deferreds = [];
	
			doResolve(fn, bind(resolve, this), bind(reject, this));
		}
	
		function handle(deferred) {
			var me = this;
			if (this._state === null) {
				this._deferreds.push(deferred);
				return;
			}
			asap(function() {
				var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
				if (cb === null) {
					(me._state ? deferred.resolve : deferred.reject)(me._value);
					return;
				}
				var ret;
				try {
					ret = cb(me._value);
				}
				catch (e) {
					deferred.reject(e);
					return;
				}
				deferred.resolve(ret);
			});
		}
	
		function resolve(newValue) {
			try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
				if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
				if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
					var then = newValue.then;
					if (typeof then === 'function') {
						doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
						return;
					}
				}
				this._state = true;
				this._value = newValue;
				finale.call(this);
			} catch (e) { reject.call(this, e); }
		}
	
		function reject(newValue) {
			this._state = false;
			this._value = newValue;
			finale.call(this);
		}
	
		function finale() {
			for (var i = 0, len = this._deferreds.length; i < len; i++) {
				handle.call(this, this._deferreds[i]);
			}
			this._deferreds = null;
		}
	
		function Handler(onFulfilled, onRejected, resolve, reject){
			this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
			this.onRejected = typeof onRejected === 'function' ? onRejected : null;
			this.resolve = resolve;
			this.reject = reject;
		}
	
		/**
		 * Take a potentially misbehaving resolver function and make sure
		 * onFulfilled and onRejected are only called once.
		 *
		 * Makes no guarantees about asynchrony.
		 */
		function doResolve(fn, onFulfilled, onRejected) {
			var done = false;
			try {
				fn(function (value) {
					if (done) return;
					done = true;
					onFulfilled(value);
				}, function (reason) {
					if (done) return;
					done = true;
					onRejected(reason);
				});
			} catch (ex) {
				if (done) return;
				done = true;
				onRejected(ex);
			}
		}
	
		Promise.prototype['catch'] = function (onRejected) {
			return this.then(null, onRejected);
		};
	
		Promise.prototype.then = function(onFulfilled, onRejected) {
			var me = this;
			return new Promise(function(resolve, reject) {
				handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
			});
		};
	
		Promise.all = function () {
			var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
	
			return new Promise(function (resolve, reject) {
				if (args.length === 0) return resolve([]);
				var remaining = args.length;
				function res(i, val) {
					try {
						if (val && (typeof val === 'object' || typeof val === 'function')) {
							var then = val.then;
							if (typeof then === 'function') {
								then.call(val, function (val) { res(i, val); }, reject);
								return;
							}
						}
						args[i] = val;
						if (--remaining === 0) {
							resolve(args);
						}
					} catch (ex) {
						reject(ex);
					}
				}
				for (var i = 0; i < args.length; i++) {
					res(i, args[i]);
				}
			});
		};
	
		Promise.resolve = function (value) {
			if (value && typeof value === 'object' && value.constructor === Promise) {
				return value;
			}
	
			return new Promise(function (resolve) {
				resolve(value);
			});
		};
	
		Promise.reject = function (value) {
			return new Promise(function (resolve, reject) {
				reject(value);
			});
		};
	
		Promise.race = function (values) {
			return new Promise(function (resolve, reject) {
				for(var i = 0, len = values.length; i < len; i++) {
					values[i].then(resolve, reject);
				}
			});
		};
	
		return Promise;
	});
	
	/* jshint ignore:end */
	/* eslint-enable */
	
	// Included from: js/tinymce/classes/util/Delay.js
	
	/**
	 * Delay.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for working with delayed actions like setTimeout.
	 *
	 * @class tinymce.util.Delay
	 */
	define("tinymce/util/Delay", [
		"tinymce/util/Promise"
	], function(Promise) {
		var requestAnimationFramePromise;
	
		function requestAnimationFrame(callback, element) {
			var i, requestAnimationFrameFunc = window.requestAnimationFrame, vendors = ['ms', 'moz', 'webkit'];
	
			function featurefill(callback) {
				window.setTimeout(callback, 0);
			}
	
			for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
				requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
			}
	
			if (!requestAnimationFrameFunc) {
				requestAnimationFrameFunc = featurefill;
			}
	
			requestAnimationFrameFunc(callback, element);
		}
	
		function wrappedSetTimeout(callback, time) {
			if (typeof time != 'number') {
				time = 0;
			}
	
			return setTimeout(callback, time);
		}
	
		function wrappedSetInterval(callback, time) {
			if (typeof time != 'number') {
				time = 1; // IE 8 needs it to be > 0
			}
	
			return setInterval(callback, time);
		}
	
		function wrappedClearTimeout(id) {
			return clearTimeout(id);
		}
	
		function wrappedClearInterval(id) {
			return clearInterval(id);
		}
	
		return {
			/**
			 * Requests an animation frame and fallbacks to a timeout on older browsers.
			 *
			 * @method requestAnimationFrame
			 * @param {function} callback Callback to execute when a new frame is available.
			 * @param {DOMElement} element Optional element to scope it to.
			 */
			requestAnimationFrame: function(callback, element) {
				if (requestAnimationFramePromise) {
					requestAnimationFramePromise.then(callback);
					return;
				}
	
				requestAnimationFramePromise = new Promise(function(resolve) {
					if (!element) {
						element = document.body;
					}
	
					requestAnimationFrame(resolve, element);
				}).then(callback);
			},
	
			/**
			 * Sets a timer in ms and executes the specified callback when the timer runs out.
			 *
			 * @method setTimeout
			 * @param {function} callback Callback to execute when timer runs out.
			 * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
			 * @return {Number} Timeout id number.
			 */
			setTimeout: wrappedSetTimeout,
	
			/**
			 * Sets an interval timer in ms and executes the specified callback at every interval of that time.
			 *
			 * @method setInterval
			 * @param {function} callback Callback to execute when interval time runs out.
			 * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
			 * @return {Number} Timeout id number.
			 */
			setInterval: wrappedSetInterval,
	
			/**
			 * Sets an editor timeout it's similar to setTimeout except that it checks if the editor instance is
			 * still alive when the callback gets executed.
			 *
			 * @method setEditorTimeout
			 * @param {tinymce.Editor} editor Editor instance to check the removed state on.
			 * @param {function} callback Callback to execute when timer runs out.
			 * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
			 * @return {Number} Timeout id number.
			 */
			setEditorTimeout: function(editor, callback, time) {
				return wrappedSetTimeout(function() {
					if (!editor.removed) {
						callback();
					}
				}, time);
			},
	
			/**
			 * Sets an interval timer it's similar to setInterval except that it checks if the editor instance is
			 * still alive when the callback gets executed.
			 *
			 * @method setEditorInterval
			 * @param {function} callback Callback to execute when interval time runs out.
			 * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
			 * @return {Number} Timeout id number.
			 */
			setEditorInterval: function(editor, callback, time) {
				var timer;
	
				timer = wrappedSetInterval(function() {
					if (!editor.removed) {
						callback();
					} else {
						clearInterval(timer);
					}
				}, time);
	
				return timer;
			},
	
			/**
			 * Creates throttled callback function that only gets executed once within the specified time.
			 *
			 * @method throttle
			 * @param {function} callback Callback to execute when timer finishes.
			 * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
			 * @return {Function} Throttled function callback.
			 */
			throttle: function(callback, time) {
				var timer, func;
	
				func = function() {
					var args = arguments;
	
					clearTimeout(timer);
	
					timer = wrappedSetTimeout(function() {
						callback.apply(this, args);
					}, time);
				};
	
				func.stop = function() {
					clearTimeout(timer);
				};
	
				return func;
			},
	
			/**
			 * Clears an interval timer so it won't execute.
			 *
			 * @method clearInterval
			 * @param {Number} Interval timer id number.
			 */
			clearInterval: wrappedClearInterval,
	
			/**
			 * Clears an timeout timer so it won't execute.
			 *
			 * @method clearTimeout
			 * @param {Number} Timeout timer id number.
			 */
			clearTimeout: wrappedClearTimeout
		};
	});
	
	// Included from: js/tinymce/classes/Env.js
	
	/**
	 * Env.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various environment constants like browser versions etc.
	 * Normally you don't want to sniff specific browser versions but sometimes you have
	 * to when it's impossible to feature detect. So use this with care.
	 *
	 * @class tinymce.Env
	 * @static
	 */
	define("tinymce/Env", [], function() {
		var nav = navigator, userAgent = nav.userAgent;
		var opera, webkit, ie, ie11, ie12, gecko, mac, iDevice, android, fileApi, phone, tablet, windowsPhone;
	
		function matchMediaQuery(query) {
			return "matchMedia" in window ? matchMedia(query).matches : false;
		}
	
		opera = window.opera && window.opera.buildNumber;
		android = /Android/.test(userAgent);
		webkit = /WebKit/.test(userAgent);
		ie = !webkit && !opera && (/MSIE/gi).test(userAgent) && (/Explorer/gi).test(nav.appName);
		ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
		ie11 = userAgent.indexOf('Trident/') != -1 && (userAgent.indexOf('rv:') != -1 || nav.appName.indexOf('Netscape') != -1) ? 11 : false;
		ie12 = (userAgent.indexOf('Edge/') != -1 && !ie && !ie11) ? 12 : false;
		ie = ie || ie11 || ie12;
		gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
		mac = userAgent.indexOf('Mac') != -1;
		iDevice = /(iPad|iPhone)/.test(userAgent);
		fileApi = "FormData" in window && "FileReader" in window && "URL" in window && !!URL.createObjectURL;
		phone = matchMediaQuery("only screen and (max-device-width: 480px)") && (android || iDevice);
		tablet = matchMediaQuery("only screen and (min-width: 800px)") && (android || iDevice);
		windowsPhone = userAgent.indexOf('Windows Phone') != -1;
	
		if (ie12) {
			webkit = false;
		}
	
		// Is a iPad/iPhone and not on iOS5 sniff the WebKit version since older iOS WebKit versions
		// says it has contentEditable support but there is no visible caret.
		var contentEditable = !iDevice || fileApi || userAgent.match(/AppleWebKit\/(\d*)/)[1] >= 534;
	
		return {
			/**
			 * Constant that is true if the browser is Opera.
			 *
			 * @property opera
			 * @type Boolean
			 * @final
			 */
			opera: opera,
	
			/**
			 * Constant that is true if the browser is WebKit (Safari/Chrome).
			 *
			 * @property webKit
			 * @type Boolean
			 * @final
			 */
			webkit: webkit,
	
			/**
			 * Constant that is more than zero if the browser is IE.
			 *
			 * @property ie
			 * @type Boolean
			 * @final
			 */
			ie: ie,
	
			/**
			 * Constant that is true if the browser is Gecko.
			 *
			 * @property gecko
			 * @type Boolean
			 * @final
			 */
			gecko: gecko,
	
			/**
			 * Constant that is true if the os is Mac OS.
			 *
			 * @property mac
			 * @type Boolean
			 * @final
			 */
			mac: mac,
	
			/**
			 * Constant that is true if the os is iOS.
			 *
			 * @property iOS
			 * @type Boolean
			 * @final
			 */
			iOS: iDevice,
	
			/**
			 * Constant that is true if the os is android.
			 *
			 * @property android
			 * @type Boolean
			 * @final
			 */
			android: android,
	
			/**
			 * Constant that is true if the browser supports editing.
			 *
			 * @property contentEditable
			 * @type Boolean
			 * @final
			 */
			contentEditable: contentEditable,
	
			/**
			 * Transparent image data url.
			 *
			 * @property transparentSrc
			 * @type Boolean
			 * @final
			 */
			transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
	
			/**
			 * Returns true/false if the browser can or can't place the caret after a inline block like an image.
			 *
			 * @property noCaretAfter
			 * @type Boolean
			 * @final
			 */
			caretAfter: ie != 8,
	
			/**
			 * Constant that is true if the browser supports native DOM Ranges. IE 9+.
			 *
			 * @property range
			 * @type Boolean
			 */
			range: window.getSelection && "Range" in window,
	
			/**
			 * Returns the IE document mode for non IE browsers this will fake IE 10.
			 *
			 * @property documentMode
			 * @type Number
			 */
			documentMode: ie && !ie12 ? (document.documentMode || 7) : 10,
	
			/**
			 * Constant that is true if the browser has a modern file api.
			 *
			 * @property fileApi
			 * @type Boolean
			 */
			fileApi: fileApi,
	
			/**
			 * Constant that is true if the browser supports contentEditable=false regions.
			 *
			 * @property ceFalse
			 * @type Boolean
			 */
			ceFalse: (ie === false || ie > 8),
	
			/**
			 * Constant if CSP mode is possible or not. Meaning we can't use script urls for the iframe.
			 */
			canHaveCSP: (ie === false || ie > 11),
	
			desktop: !phone && !tablet,
			windowsPhone: windowsPhone
		};
	});
	
	// Included from: js/tinymce/classes/dom/EventUtils.js
	
	/**
	 * EventUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint loopfunc:true*/
	/*eslint no-loop-func:0 */
	
	/**
	 * This class wraps the browsers native event logic with more convenient methods.
	 *
	 * @class tinymce.dom.EventUtils
	 */
	define("tinymce/dom/EventUtils", [
		"tinymce/util/Delay",
		"tinymce/Env"
	], function(Delay, Env) {
		"use strict";
	
		var eventExpandoPrefix = "mce-data-";
		var mouseEventRe = /^(?:mouse|contextmenu)|click/;
		var deprecated = {
			keyLocation: 1, layerX: 1, layerY: 1, returnValue: 1,
			webkitMovementX: 1, webkitMovementY: 1, keyIdentifier: 1
		};
	
		/**
		 * Binds a native event to a callback on the speified target.
		 */
		function addEvent(target, name, callback, capture) {
			if (target.addEventListener) {
				target.addEventListener(name, callback, capture || false);
			} else if (target.attachEvent) {
				target.attachEvent('on' + name, callback);
			}
		}
	
		/**
		 * Unbinds a native event callback on the specified target.
		 */
		function removeEvent(target, name, callback, capture) {
			if (target.removeEventListener) {
				target.removeEventListener(name, callback, capture || false);
			} else if (target.detachEvent) {
				target.detachEvent('on' + name, callback);
			}
		}
	
		/**
		 * Gets the event target based on shadow dom properties like path and deepPath.
		 */
		function getTargetFromShadowDom(event, defaultTarget) {
			var path, target = defaultTarget;
	
			// When target element is inside Shadow DOM we need to take first element from path
			// otherwise we'll get Shadow Root parent, not actual target element
	
			// Normalize target for WebComponents v0 implementation (in Chrome)
			path = event.path;
			if (path && path.length > 0) {
				target = path[0];
			}
	
			// Normalize target for WebComponents v1 implementation (standard)
			if (event.deepPath) {
				path = event.deepPath();
				if (path && path.length > 0) {
					target = path[0];
				}
			}
	
			return target;
		}
	
		/**
		 * Normalizes a native event object or just adds the event specific methods on a custom event.
		 */
		function fix(originalEvent, data) {
			var name, event = data || {}, undef;
	
			// Dummy function that gets replaced on the delegation state functions
			function returnFalse() {
				return false;
			}
	
			// Dummy function that gets replaced on the delegation state functions
			function returnTrue() {
				return true;
			}
	
			// Copy all properties from the original event
			for (name in originalEvent) {
				// layerX/layerY is deprecated in Chrome and produces a warning
				if (!deprecated[name]) {
					event[name] = originalEvent[name];
				}
			}
	
			// Normalize target IE uses srcElement
			if (!event.target) {
				event.target = event.srcElement || document;
			}
	
			// Experimental shadow dom support
			if (Env.experimentalShadowDom) {
				event.target = getTargetFromShadowDom(originalEvent, event.target);
			}
	
			// Calculate pageX/Y if missing and clientX/Y available
			if (originalEvent && mouseEventRe.test(originalEvent.type) && originalEvent.pageX === undef && originalEvent.clientX !== undef) {
				var eventDoc = event.target.ownerDocument || document;
				var doc = eventDoc.documentElement;
				var body = eventDoc.body;
	
				event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
					(doc && doc.clientLeft || body && body.clientLeft || 0);
	
				event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) -
					(doc && doc.clientTop || body && body.clientTop || 0);
			}
	
			// Add preventDefault method
			event.preventDefault = function() {
				event.isDefaultPrevented = returnTrue;
	
				// Execute preventDefault on the original event object
				if (originalEvent) {
					if (originalEvent.preventDefault) {
						originalEvent.preventDefault();
					} else {
						originalEvent.returnValue = false; // IE
					}
				}
			};
	
			// Add stopPropagation
			event.stopPropagation = function() {
				event.isPropagationStopped = returnTrue;
	
				// Execute stopPropagation on the original event object
				if (originalEvent) {
					if (originalEvent.stopPropagation) {
						originalEvent.stopPropagation();
					} else {
						originalEvent.cancelBubble = true; // IE
					}
				}
			};
	
			// Add stopImmediatePropagation
			event.stopImmediatePropagation = function() {
				event.isImmediatePropagationStopped = returnTrue;
				event.stopPropagation();
			};
	
			// Add event delegation states
			if (!event.isDefaultPrevented) {
				event.isDefaultPrevented = returnFalse;
				event.isPropagationStopped = returnFalse;
				event.isImmediatePropagationStopped = returnFalse;
			}
	
			// Add missing metaKey for IE 8
			if (typeof event.metaKey == 'undefined') {
				event.metaKey = false;
			}
	
			return event;
		}
	
		/**
		 * Bind a DOMContentLoaded event across browsers and executes the callback once the page DOM is initialized.
		 * It will also set/check the domLoaded state of the event_utils instance so ready isn't called multiple times.
		 */
		function bindOnReady(win, callback, eventUtils) {
			var doc = win.document, event = {type: 'ready'};
	
			if (eventUtils.domLoaded) {
				callback(event);
				return;
			}
	
			// Gets called when the DOM is ready
			function readyHandler() {
				if (!eventUtils.domLoaded) {
					eventUtils.domLoaded = true;
					callback(event);
				}
			}
	
			function waitForDomLoaded() {
				// Check complete or interactive state if there is a body
				// element on some iframes IE 8 will produce a null body
				if (doc.readyState === "complete" || (doc.readyState === "interactive" && doc.body)) {
					removeEvent(doc, "readystatechange", waitForDomLoaded);
					readyHandler();
				}
			}
	
			function tryScroll() {
				try {
					// If IE is used, use the trick by Diego Perini licensed under MIT by request to the author.
					// http://javascript.nwbox.com/IEContentLoaded/
					doc.documentElement.doScroll("left");
				} catch (ex) {
					Delay.setTimeout(tryScroll);
					return;
				}
	
				readyHandler();
			}
	
			// Use W3C method
			if (doc.addEventListener) {
				if (doc.readyState === "complete") {
					readyHandler();
				} else {
					addEvent(win, 'DOMContentLoaded', readyHandler);
				}
			} else {
				// Use IE method
				addEvent(doc, "readystatechange", waitForDomLoaded);
	
				// Wait until we can scroll, when we can the DOM is initialized
				if (doc.documentElement.doScroll && win.self === win.top) {
					tryScroll();
				}
			}
	
			// Fallback if any of the above methods should fail for some odd reason
			addEvent(win, 'load', readyHandler);
		}
	
		/**
		 * This class enables you to bind/unbind native events to elements and normalize it's behavior across browsers.
		 */
		function EventUtils() {
			var self = this, events = {}, count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
	
			expando = eventExpandoPrefix + (+new Date()).toString(32);
			hasMouseEnterLeave = "onmouseenter" in document.documentElement;
			hasFocusIn = "onfocusin" in document.documentElement;
			mouseEnterLeave = {mouseenter: 'mouseover', mouseleave: 'mouseout'};
			count = 1;
	
			// State if the DOMContentLoaded was executed or not
			self.domLoaded = false;
			self.events = events;
	
			/**
			 * Executes all event handler callbacks for a specific event.
			 *
			 * @private
			 * @param {Event} evt Event object.
			 * @param {String} id Expando id value to look for.
			 */
			function executeHandlers(evt, id) {
				var callbackList, i, l, callback, container = events[id];
	
				callbackList = container && container[evt.type];
				if (callbackList) {
					for (i = 0, l = callbackList.length; i < l; i++) {
						callback = callbackList[i];
	
						// Check if callback exists might be removed if a unbind is called inside the callback
						if (callback && callback.func.call(callback.scope, evt) === false) {
							evt.preventDefault();
						}
	
						// Should we stop propagation to immediate listeners
						if (evt.isImmediatePropagationStopped()) {
							return;
						}
					}
				}
			}
	
			/**
			 * Binds a callback to an event on the specified target.
			 *
			 * @method bind
			 * @param {Object} target Target node/window or custom object.
			 * @param {String} names Name of the event to bind.
			 * @param {function} callback Callback function to execute when the event occurs.
			 * @param {Object} scope Scope to call the callback function on, defaults to target.
			 * @return {function} Callback function that got bound.
			 */
			self.bind = function(target, names, callback, scope) {
				var id, callbackList, i, name, fakeName, nativeHandler, capture, win = window;
	
				// Native event handler function patches the event and executes the callbacks for the expando
				function defaultNativeHandler(evt) {
					executeHandlers(fix(evt || win.event), id);
				}
	
				// Don't bind to text nodes or comments
				if (!target || target.nodeType === 3 || target.nodeType === 8) {
					return;
				}
	
				// Create or get events id for the target
				if (!target[expando]) {
					id = count++;
					target[expando] = id;
					events[id] = {};
				} else {
					id = target[expando];
				}
	
				// Setup the specified scope or use the target as a default
				scope = scope || target;
	
				// Split names and bind each event, enables you to bind multiple events with one call
				names = names.split(' ');
				i = names.length;
				while (i--) {
					name = names[i];
					nativeHandler = defaultNativeHandler;
					fakeName = capture = false;
	
					// Use ready instead of DOMContentLoaded
					if (name === "DOMContentLoaded") {
						name = "ready";
					}
	
					// DOM is already ready
					if (self.domLoaded && name === "ready" && target.readyState == 'complete') {
						callback.call(scope, fix({type: name}));
						continue;
					}
	
					// Handle mouseenter/mouseleaver
					if (!hasMouseEnterLeave) {
						fakeName = mouseEnterLeave[name];
	
						if (fakeName) {
							nativeHandler = function(evt) {
								var current, related;
	
								current = evt.currentTarget;
								related = evt.relatedTarget;
	
								// Check if related is inside the current target if it's not then the event should
								// be ignored since it's a mouseover/mouseout inside the element
								if (related && current.contains) {
									// Use contains for performance
									related = current.contains(related);
								} else {
									while (related && related !== current) {
										related = related.parentNode;
									}
								}
	
								// Fire fake event
								if (!related) {
									evt = fix(evt || win.event);
									evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
									evt.target = current;
									executeHandlers(evt, id);
								}
							};
						}
					}
	
					// Fake bubbling of focusin/focusout
					if (!hasFocusIn && (name === "focusin" || name === "focusout")) {
						capture = true;
						fakeName = name === "focusin" ? "focus" : "blur";
						nativeHandler = function(evt) {
							evt = fix(evt || win.event);
							evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
							executeHandlers(evt, id);
						};
					}
	
					// Setup callback list and bind native event
					callbackList = events[id][name];
					if (!callbackList) {
						events[id][name] = callbackList = [{func: callback, scope: scope}];
						callbackList.fakeName = fakeName;
						callbackList.capture = capture;
						//callbackList.callback = callback;
	
						// Add the nativeHandler to the callback list so that we can later unbind it
						callbackList.nativeHandler = nativeHandler;
	
						// Check if the target has native events support
	
						if (name === "ready") {
							bindOnReady(target, nativeHandler, self);
						} else {
							addEvent(target, fakeName || name, nativeHandler, capture);
						}
					} else {
						if (name === "ready" && self.domLoaded) {
							callback({type: name});
						} else {
							// If it already has an native handler then just push the callback
							callbackList.push({func: callback, scope: scope});
						}
					}
				}
	
				target = callbackList = 0; // Clean memory for IE
	
				return callback;
			};
	
			/**
			 * Unbinds the specified event by name, name and callback or all events on the target.
			 *
			 * @method unbind
			 * @param {Object} target Target node/window or custom object.
			 * @param {String} names Optional event name to unbind.
			 * @param {function} callback Optional callback function to unbind.
			 * @return {EventUtils} Event utils instance.
			 */
			self.unbind = function(target, names, callback) {
				var id, callbackList, i, ci, name, eventMap;
	
				// Don't bind to text nodes or comments
				if (!target || target.nodeType === 3 || target.nodeType === 8) {
					return self;
				}
	
				// Unbind event or events if the target has the expando
				id = target[expando];
				if (id) {
					eventMap = events[id];
	
					// Specific callback
					if (names) {
						names = names.split(' ');
						i = names.length;
						while (i--) {
							name = names[i];
							callbackList = eventMap[name];
	
							// Unbind the event if it exists in the map
							if (callbackList) {
								// Remove specified callback
								if (callback) {
									ci = callbackList.length;
									while (ci--) {
										if (callbackList[ci].func === callback) {
											var nativeHandler = callbackList.nativeHandler;
											var fakeName = callbackList.fakeName, capture = callbackList.capture;
	
											// Clone callbackList since unbind inside a callback would otherwise break the handlers loop
											callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
											callbackList.nativeHandler = nativeHandler;
											callbackList.fakeName = fakeName;
											callbackList.capture = capture;
	
											eventMap[name] = callbackList;
										}
									}
								}
	
								// Remove all callbacks if there isn't a specified callback or there is no callbacks left
								if (!callback || callbackList.length === 0) {
									delete eventMap[name];
									removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
								}
							}
						}
					} else {
						// All events for a specific element
						for (name in eventMap) {
							callbackList = eventMap[name];
							removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
						}
	
						eventMap = {};
					}
	
					// Check if object is empty, if it isn't then we won't remove the expando map
					for (name in eventMap) {
						return self;
					}
	
					// Delete event object
					delete events[id];
	
					// Remove expando from target
					try {
						// IE will fail here since it can't delete properties from window
						delete target[expando];
					} catch (ex) {
						// IE will set it to null
						target[expando] = null;
					}
				}
	
				return self;
			};
	
			/**
			 * Fires the specified event on the specified target.
			 *
			 * @method fire
			 * @param {Object} target Target node/window or custom object.
			 * @param {String} name Event name to fire.
			 * @param {Object} args Optional arguments to send to the observers.
			 * @return {EventUtils} Event utils instance.
			 */
			self.fire = function(target, name, args) {
				var id;
	
				// Don't bind to text nodes or comments
				if (!target || target.nodeType === 3 || target.nodeType === 8) {
					return self;
				}
	
				// Build event object by patching the args
				args = fix(null, args);
				args.type = name;
				args.target = target;
	
				do {
					// Found an expando that means there is listeners to execute
					id = target[expando];
					if (id) {
						executeHandlers(args, id);
					}
	
					// Walk up the DOM
					target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
				} while (target && !args.isPropagationStopped());
	
				return self;
			};
	
			/**
			 * Removes all bound event listeners for the specified target. This will also remove any bound
			 * listeners to child nodes within that target.
			 *
			 * @method clean
			 * @param {Object} target Target node/window object.
			 * @return {EventUtils} Event utils instance.
			 */
			self.clean = function(target) {
				var i, children, unbind = self.unbind;
	
				// Don't bind to text nodes or comments
				if (!target || target.nodeType === 3 || target.nodeType === 8) {
					return self;
				}
	
				// Unbind any element on the specified target
				if (target[expando]) {
					unbind(target);
				}
	
				// Target doesn't have getElementsByTagName it's probably a window object then use it's document to find the children
				if (!target.getElementsByTagName) {
					target = target.document;
				}
	
				// Remove events from each child element
				if (target && target.getElementsByTagName) {
					unbind(target);
	
					children = target.getElementsByTagName('*');
					i = children.length;
					while (i--) {
						target = children[i];
	
						if (target[expando]) {
							unbind(target);
						}
					}
				}
	
				return self;
			};
	
			/**
			 * Destroys the event object. Call this on IE to remove memory leaks.
			 */
			self.destroy = function() {
				events = {};
			};
	
			// Legacy function for canceling events
			self.cancel = function(e) {
				if (e) {
					e.preventDefault();
					e.stopImmediatePropagation();
				}
	
				return false;
			};
		}
	
		EventUtils.Event = new EventUtils();
		EventUtils.Event.bind(window, 'ready', function() {});
	
		return EventUtils;
	});
	
	// Included from: js/tinymce/classes/dom/Sizzle.js
	
	/**
	 * Sizzle.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 *
	 * @ignore-file
	 */
	
	/*jshint bitwise:false, expr:true, noempty:false, sub:true, eqnull:true, latedef:false, maxlen:255 */
	/*eslint-disable */
	
	/**
	 * Sizzle CSS Selector Engine v@VERSION
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: @DATE
	 */
	define("tinymce/dom/Sizzle", [], function() {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + -(new Date()),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		strundefined = typeof undefined,
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf if we can't use a native one
		indexOf = arr.indexOf || function( elem ) {
			var i = 0,
				len = this.length;
			for ( ; i < len; i++ ) {
				if ( this[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
	
		if ( !selector || typeof selector !== "string" ) {
			return results;
		}
	
		if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
			return [];
		}
	
		if ( documentIsHTML && !seed ) {
	
			// Shortcuts
			if ( (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType === 9 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== strundefined && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare,
			doc = node ? node.ownerDocument || node : preferredDoc,
			parent = doc.defaultView;
	
		function getTop(win) {
			// Edge throws a lovely Object expected if you try to get top on a detached reference see #2642
			try {
				return win.top;
			} catch (ex) {
				// Ignore
			}
	
			return null;
		}
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
	
		// Support tests
		documentIsHTML = !isXML( doc );
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== getTop(parent) ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", function() {
					setDocument();
				}, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", function() {
					setDocument();
				});
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== strundefined ) {
					return context.getElementsByTagName( tag );
				}
			} :
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				div.innerHTML = "<select msallowcapture=''><option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch(e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	// EXPOSE
	return Sizzle;
	});
	
	/*eslint-enable */
	
	// Included from: js/tinymce/classes/util/Arr.js
	
	/**
	 * Arr.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Array utility class.
	 *
	 * @private
	 * @class tinymce.util.Arr
	 */
	define("tinymce/util/Arr", [], function() {
		var isArray = Array.isArray || function(obj) {
			return Object.prototype.toString.call(obj) === "[object Array]";
		};
	
		function toArray(obj) {
			var array = obj, i, l;
	
			if (!isArray(obj)) {
				array = [];
				for (i = 0, l = obj.length; i < l; i++) {
					array[i] = obj[i];
				}
			}
	
			return array;
		}
	
		function each(o, cb, s) {
			var n, l;
	
			if (!o) {
				return 0;
			}
	
			s = s || o;
	
			if (o.length !== undefined) {
				// Indexed arrays, needed for Safari
				for (n = 0, l = o.length; n < l; n++) {
					if (cb.call(s, o[n], n, o) === false) {
						return 0;
					}
				}
			} else {
				// Hashtables
				for (n in o) {
					if (o.hasOwnProperty(n)) {
						if (cb.call(s, o[n], n, o) === false) {
							return 0;
						}
					}
				}
			}
	
			return 1;
		}
	
		function map(array, callback) {
			var out = [];
	
			each(array, function(item, index) {
				out.push(callback(item, index, array));
			});
	
			return out;
		}
	
		function filter(a, f) {
			var o = [];
	
			each(a, function(v, index) {
				if (!f || f(v, index, a)) {
					o.push(v);
				}
			});
	
			return o;
		}
	
		function indexOf(a, v) {
			var i, l;
	
			if (a) {
				for (i = 0, l = a.length; i < l; i++) {
					if (a[i] === v) {
						return i;
					}
				}
			}
	
			return -1;
		}
	
		function reduce(collection, iteratee, accumulator, thisArg) {
			var i = 0;
	
			if (arguments.length < 3) {
				accumulator = collection[0];
			}
	
			for (; i < collection.length; i++) {
				accumulator = iteratee.call(thisArg, accumulator, collection[i], i);
			}
	
			return accumulator;
		}
	
		function findIndex(array, predicate, thisArg) {
			var i, l;
	
			for (i = 0, l = array.length; i < l; i++) {
				if (predicate.call(thisArg, array[i], i, array)) {
					return i;
				}
			}
	
			return -1;
		}
	
		function find(array, predicate, thisArg) {
			var idx = findIndex(array, predicate, thisArg);
	
			if (idx !== -1) {
				return array[idx];
			}
	
			return undefined;
		}
	
		function last(collection) {
			return collection[collection.length - 1];
		}
	
		return {
			isArray: isArray,
			toArray: toArray,
			each: each,
			map: map,
			filter: filter,
			indexOf: indexOf,
			reduce: reduce,
			findIndex: findIndex,
			find: find,
			last: last
		};
	});
	
	// Included from: js/tinymce/classes/util/Tools.js
	
	/**
	 * Tools.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various utlity functions. These are also exposed
	 * directly on the tinymce namespace.
	 *
	 * @class tinymce.util.Tools
	 */
	define("tinymce/util/Tools", [
		"tinymce/Env",
		"tinymce/util/Arr"
	], function(Env, Arr) {
		/**
		 * Removes whitespace from the beginning and end of a string.
		 *
		 * @method trim
		 * @param {String} s String to remove whitespace from.
		 * @return {String} New string with removed whitespace.
		 */
		var whiteSpaceRegExp = /^\s*|\s*$/g;
	
		function trim(str) {
			return (str === null || str === undefined) ? '' : ("" + str).replace(whiteSpaceRegExp, '');
		}
	
		/**
		 * Checks if a object is of a specific type for example an array.
		 *
		 * @method is
		 * @param {Object} obj Object to check type of.
		 * @param {string} type Optional type to check for.
		 * @return {Boolean} true/false if the object is of the specified type.
		 */
		function is(obj, type) {
			if (!type) {
				return obj !== undefined;
			}
	
			if (type == 'array' && Arr.isArray(obj)) {
				return true;
			}
	
			return typeof obj == type;
		}
	
		/**
		 * Makes a name/object map out of an array with names.
		 *
		 * @method makeMap
		 * @param {Array/String} items Items to make map out of.
		 * @param {String} delim Optional delimiter to split string by.
		 * @param {Object} map Optional map to add items to.
		 * @return {Object} Name/value map of items.
		 */
		function makeMap(items, delim, map) {
			var i;
	
			items = items || [];
			delim = delim || ',';
	
			if (typeof items == "string") {
				items = items.split(delim);
			}
	
			map = map || {};
	
			i = items.length;
			while (i--) {
				map[items[i]] = {};
			}
	
			return map;
		}
	
		/**
		 * Creates a class, subclass or static singleton.
		 * More details on this method can be found in the Wiki.
		 *
		 * @method create
		 * @param {String} s Class name, inheritance and prefix.
		 * @param {Object} p Collection of methods to add to the class.
		 * @param {Object} root Optional root object defaults to the global window object.
		 * @example
		 * // Creates a basic class
		 * tinymce.create('tinymce.somepackage.SomeClass', {
		 *     SomeClass: function() {
		 *         // Class constructor
		 *     },
		 *
		 *     method: function() {
		 *         // Some method
		 *     }
		 * });
		 *
		 * // Creates a basic subclass class
		 * tinymce.create('tinymce.somepackage.SomeSubClass:tinymce.somepackage.SomeClass', {
		 *     SomeSubClass: function() {
		 *         // Class constructor
		 *         this.parent(); // Call parent constructor
		 *     },
		 *
		 *     method: function() {
		 *         // Some method
		 *         this.parent(); // Call parent method
		 *     },
		 *
		 *     'static': {
		 *         staticMethod: function() {
		 *             // Static method
		 *         }
		 *     }
		 * });
		 *
		 * // Creates a singleton/static class
		 * tinymce.create('static tinymce.somepackage.SomeSingletonClass', {
		 *     method: function() {
		 *         // Some method
		 *     }
		 * });
		 */
		function create(s, p, root) {
			var self = this, sp, ns, cn, scn, c, de = 0;
	
			// Parse : <prefix> <class>:<super class>
			s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
			cn = s[3].match(/(^|\.)(\w+)$/i)[2]; // Class name
	
			// Create namespace for new class
			ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	
			// Class already exists
			if (ns[cn]) {
				return;
			}
	
			// Make pure static class
			if (s[2] == 'static') {
				ns[cn] = p;
	
				if (this.onCreate) {
					this.onCreate(s[2], s[3], ns[cn]);
				}
	
				return;
			}
	
			// Create default constructor
			if (!p[cn]) {
				p[cn] = function() {};
				de = 1;
			}
	
			// Add constructor and methods
			ns[cn] = p[cn];
			self.extend(ns[cn].prototype, p);
	
			// Extend
			if (s[5]) {
				sp = self.resolve(s[5]).prototype;
				scn = s[5].match(/\.(\w+)$/i)[1]; // Class name
	
				// Extend constructor
				c = ns[cn];
				if (de) {
					// Add passthrough constructor
					ns[cn] = function() {
						return sp[scn].apply(this, arguments);
					};
				} else {
					// Add inherit constructor
					ns[cn] = function() {
						this.parent = sp[scn];
						return c.apply(this, arguments);
					};
				}
				ns[cn].prototype[cn] = ns[cn];
	
				// Add super methods
				self.each(sp, function(f, n) {
					ns[cn].prototype[n] = sp[n];
				});
	
				// Add overridden methods
				self.each(p, function(f, n) {
					// Extend methods if needed
					if (sp[n]) {
						ns[cn].prototype[n] = function() {
							this.parent = sp[n];
							return f.apply(this, arguments);
						};
					} else {
						if (n != cn) {
							ns[cn].prototype[n] = f;
						}
					}
				});
			}
	
			// Add static methods
			/*jshint sub:true*/
			/*eslint dot-notation:0*/
			self.each(p['static'], function(f, n) {
				ns[cn][n] = f;
			});
		}
	
		function extend(obj, ext) {
			var i, l, name, args = arguments, value;
	
			for (i = 1, l = args.length; i < l; i++) {
				ext = args[i];
				for (name in ext) {
					if (ext.hasOwnProperty(name)) {
						value = ext[name];
	
						if (value !== undefined) {
							obj[name] = value;
						}
					}
				}
			}
	
			return obj;
		}
	
		/**
		 * Executed the specified function for each item in a object tree.
		 *
		 * @method walk
		 * @param {Object} o Object tree to walk though.
		 * @param {function} f Function to call for each item.
		 * @param {String} n Optional name of collection inside the objects to walk for example childNodes.
		 * @param {String} s Optional scope to execute the function in.
		 */
		function walk(o, f, n, s) {
			s = s || this;
	
			if (o) {
				if (n) {
					o = o[n];
				}
	
				Arr.each(o, function(o, i) {
					if (f.call(s, o, i, n) === false) {
						return false;
					}
	
					walk(o, f, n, s);
				});
			}
		}
	
		/**
		 * Creates a namespace on a specific object.
		 *
		 * @method createNS
		 * @param {String} n Namespace to create for example a.b.c.d.
		 * @param {Object} o Optional object to add namespace to, defaults to window.
		 * @return {Object} New namespace object the last item in path.
		 * @example
		 * // Create some namespace
		 * tinymce.createNS('tinymce.somepackage.subpackage');
		 *
		 * // Add a singleton
		 * var tinymce.somepackage.subpackage.SomeSingleton = {
		 *     method: function() {
		 *         // Some method
		 *     }
		 * };
		 */
		function createNS(n, o) {
			var i, v;
	
			o = o || window;
	
			n = n.split('.');
			for (i = 0; i < n.length; i++) {
				v = n[i];
	
				if (!o[v]) {
					o[v] = {};
				}
	
				o = o[v];
			}
	
			return o;
		}
	
		/**
		 * Resolves a string and returns the object from a specific structure.
		 *
		 * @method resolve
		 * @param {String} n Path to resolve for example a.b.c.d.
		 * @param {Object} o Optional object to search though, defaults to window.
		 * @return {Object} Last object in path or null if it couldn't be resolved.
		 * @example
		 * // Resolve a path into an object reference
		 * var obj = tinymce.resolve('a.b.c.d');
		 */
		function resolve(n, o) {
			var i, l;
	
			o = o || window;
	
			n = n.split('.');
			for (i = 0, l = n.length; i < l; i++) {
				o = o[n[i]];
	
				if (!o) {
					break;
				}
			}
	
			return o;
		}
	
		/**
		 * Splits a string but removes the whitespace before and after each value.
		 *
		 * @method explode
		 * @param {string} s String to split.
		 * @param {string} d Delimiter to split by.
		 * @example
		 * // Split a string into an array with a,b,c
		 * var arr = tinymce.explode('a, b,   c');
		 */
		function explode(s, d) {
			if (!s || is(s, 'array')) {
				return s;
			}
	
			return Arr.map(s.split(d || ','), trim);
		}
	
		function _addCacheSuffix(url) {
			var cacheSuffix = Env.cacheSuffix;
	
			if (cacheSuffix) {
				url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
			}
	
			return url;
		}
	
		return {
			trim: trim,
	
			/**
			 * Returns true/false if the object is an array or not.
			 *
			 * @method isArray
			 * @param {Object} obj Object to check.
			 * @return {boolean} true/false state if the object is an array or not.
			 */
			isArray: Arr.isArray,
	
			is: is,
	
			/**
			 * Converts the specified object into a real JavaScript array.
			 *
			 * @method toArray
			 * @param {Object} obj Object to convert into array.
			 * @return {Array} Array object based in input.
			 */
			toArray: Arr.toArray,
			makeMap: makeMap,
	
			/**
			 * Performs an iteration of all items in a collection such as an object or array. This method will execure the
			 * callback function for each item in the collection, if the callback returns false the iteration will terminate.
			 * The callback has the following format: cb(value, key_or_index).
			 *
			 * @method each
			 * @param {Object} o Collection to iterate.
			 * @param {function} cb Callback function to execute for each item.
			 * @param {Object} s Optional scope to execute the callback in.
			 * @example
			 * // Iterate an array
			 * tinymce.each([1,2,3], function(v, i) {
			 *     console.debug("Value: " + v + ", Index: " + i);
			 * });
			 *
			 * // Iterate an object
			 * tinymce.each({a: 1, b: 2, c: 3], function(v, k) {
			 *     console.debug("Value: " + v + ", Key: " + k);
			 * });
			 */
			each: Arr.each,
	
			/**
			 * Creates a new array by the return value of each iteration function call. This enables you to convert
			 * one array list into another.
			 *
			 * @method map
			 * @param {Array} array Array of items to iterate.
			 * @param {function} callback Function to call for each item. It's return value will be the new value.
			 * @return {Array} Array with new values based on function return values.
			 */
			map: Arr.map,
	
			/**
			 * Filters out items from the input array by calling the specified function for each item.
			 * If the function returns false the item will be excluded if it returns true it will be included.
			 *
			 * @method grep
			 * @param {Array} a Array of items to loop though.
			 * @param {function} f Function to call for each item. Include/exclude depends on it's return value.
			 * @return {Array} New array with values imported and filtered based in input.
			 * @example
			 * // Filter out some items, this will return an array with 4 and 5
			 * var items = tinymce.grep([1,2,3,4,5], function(v) {return v > 3;});
			 */
			grep: Arr.filter,
	
			/**
			 * Returns true/false if the object is an array or not.
			 *
			 * @method isArray
			 * @param {Object} obj Object to check.
			 * @return {boolean} true/false state if the object is an array or not.
			 */
			inArray: Arr.indexOf,
	
			extend: extend,
			create: create,
			walk: walk,
			createNS: createNS,
			resolve: resolve,
			explode: explode,
			_addCacheSuffix: _addCacheSuffix
		};
	});
	
	// Included from: js/tinymce/classes/dom/DomQuery.js
	
	/**
	 * DomQuery.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class mimics most of the jQuery API:
	 *
	 * This is whats currently implemented:
	 * - Utility functions
	 * - DOM traversial
	 * - DOM manipulation
	 * - Event binding
	 *
	 * This is not currently implemented:
	 * - Dimension
	 * - Ajax
	 * - Animation
	 * - Advanced chaining
	 *
	 * @example
	 * var $ = tinymce.dom.DomQuery;
	 * $('p').attr('attr', 'value').addClass('class');
	 *
	 * @class tinymce.dom.DomQuery
	 */
	define("tinymce/dom/DomQuery", [
		"tinymce/dom/EventUtils",
		"tinymce/dom/Sizzle",
		"tinymce/util/Tools",
		"tinymce/Env"
	], function(EventUtils, Sizzle, Tools, Env) {
		var doc = document, push = Array.prototype.push, slice = Array.prototype.slice;
		var rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
		var Event = EventUtils.Event, undef;
		var skipUniques = Tools.makeMap('children,contents,next,prev');
	
		function isDefined(obj) {
			return typeof obj !== 'undefined';
		}
	
		function isString(obj) {
			return typeof obj === 'string';
		}
	
		function isWindow(obj) {
			return obj && obj == obj.window;
		}
	
		function createFragment(html, fragDoc) {
			var frag, node, container;
	
			fragDoc = fragDoc || doc;
			container = fragDoc.createElement('div');
			frag = fragDoc.createDocumentFragment();
			container.innerHTML = html;
	
			while ((node = container.firstChild)) {
				frag.appendChild(node);
			}
	
			return frag;
		}
	
		function domManipulate(targetNodes, sourceItem, callback, reverse) {
			var i;
	
			if (isString(sourceItem)) {
				sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
			} else if (sourceItem.length && !sourceItem.nodeType) {
				sourceItem = DomQuery.makeArray(sourceItem);
	
				if (reverse) {
					for (i = sourceItem.length - 1; i >= 0; i--) {
						domManipulate(targetNodes, sourceItem[i], callback, reverse);
					}
				} else {
					for (i = 0; i < sourceItem.length; i++) {
						domManipulate(targetNodes, sourceItem[i], callback, reverse);
					}
				}
	
				return targetNodes;
			}
	
			if (sourceItem.nodeType) {
				i = targetNodes.length;
				while (i--) {
					callback.call(targetNodes[i], sourceItem);
				}
			}
	
			return targetNodes;
		}
	
		function hasClass(node, className) {
			return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
		}
	
		function wrap(elements, wrapper, all) {
			var lastParent, newWrapper;
	
			wrapper = DomQuery(wrapper)[0];
	
			elements.each(function() {
				var self = this;
	
				if (!all || lastParent != self.parentNode) {
					lastParent = self.parentNode;
					newWrapper = wrapper.cloneNode(false);
					self.parentNode.insertBefore(newWrapper, self);
					newWrapper.appendChild(self);
				} else {
					newWrapper.appendChild(self);
				}
			});
	
			return elements;
		}
	
		var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
		var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
		var propFix = {
			'for': 'htmlFor',
			'class': 'className',
			'readonly': 'readOnly'
		};
		var cssFix = {
			'float': 'cssFloat'
		};
	
		var attrHooks = {}, cssHooks = {};
	
		function DomQuery(selector, context) {
			/*eslint new-cap:0 */
			return new DomQuery.fn.init(selector, context);
		}
	
		function inArray(item, array) {
			var i;
	
			if (array.indexOf) {
				return array.indexOf(item);
			}
	
			i = array.length;
			while (i--) {
				if (array[i] === item) {
					return i;
				}
			}
	
			return -1;
		}
	
		var whiteSpaceRegExp = /^\s*|\s*$/g;
	
		function trim(str) {
			return (str === null || str === undef) ? '' : ("" + str).replace(whiteSpaceRegExp, '');
		}
	
		function each(obj, callback) {
			var length, key, i, undef, value;
	
			if (obj) {
				length = obj.length;
	
				if (length === undef) {
					// Loop object items
					for (key in obj) {
						if (obj.hasOwnProperty(key)) {
							value = obj[key];
							if (callback.call(value, key, value) === false) {
								break;
							}
						}
					}
				} else {
					// Loop array items
					for (i = 0; i < length; i++) {
						value = obj[i];
						if (callback.call(value, i, value) === false) {
							break;
						}
					}
				}
			}
	
			return obj;
		}
	
		function grep(array, callback) {
			var out = [];
	
			each(array, function(i, item) {
				if (callback(item, i)) {
					out.push(item);
				}
			});
	
			return out;
		}
	
		function getElementDocument(element) {
			if (!element) {
				return doc;
			}
	
			if (element.nodeType == 9) {
				return element;
			}
	
			return element.ownerDocument;
		}
	
		DomQuery.fn = DomQuery.prototype = {
			constructor: DomQuery,
	
			/**
			 * Selector for the current set.
			 *
			 * @property selector
			 * @type String
			 */
			selector: "",
	
			/**
			 * Context used to create the set.
			 *
			 * @property context
			 * @type Element
			 */
			context: null,
	
			/**
			 * Number of items in the current set.
			 *
			 * @property length
			 * @type Number
			 */
			length: 0,
	
			/**
			 * Constructs a new DomQuery instance with the specified selector or context.
			 *
			 * @constructor
			 * @method init
			 * @param {String/Array/DomQuery} selector Optional CSS selector/Array or array like object or HTML string.
			 * @param {Document/Element} context Optional context to search in.
			 */
			init: function(selector, context) {
				var self = this, match, node;
	
				if (!selector) {
					return self;
				}
	
				if (selector.nodeType) {
					self.context = self[0] = selector;
					self.length = 1;
	
					return self;
				}
	
				if (context && context.nodeType) {
					self.context = context;
				} else {
					if (context) {
						return DomQuery(selector).attr(context);
					}
	
					self.context = context = document;
				}
	
				if (isString(selector)) {
					self.selector = selector;
	
					if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
						match = [null, selector, null];
					} else {
						match = rquickExpr.exec(selector);
					}
	
					if (match) {
						if (match[1]) {
							node = createFragment(selector, getElementDocument(context)).firstChild;
	
							while (node) {
								push.call(self, node);
								node = node.nextSibling;
							}
						} else {
							node = getElementDocument(context).getElementById(match[2]);
	
							if (!node) {
								return self;
							}
	
							if (node.id !== match[2]) {
								return self.find(selector);
							}
	
							self.length = 1;
							self[0] = node;
						}
					} else {
						return DomQuery(context).find(selector);
					}
				} else {
					this.add(selector, false);
				}
	
				return self;
			},
	
			/**
			 * Converts the current set to an array.
			 *
			 * @method toArray
			 * @return {Array} Array of all nodes in set.
			 */
			toArray: function() {
				return Tools.toArray(this);
			},
	
			/**
			 * Adds new nodes to the set.
			 *
			 * @method add
			 * @param {Array/tinymce.dom.DomQuery} items Array of all nodes to add to set.
			 * @param {Boolean} sort Optional sort flag that enables sorting of elements.
			 * @return {tinymce.dom.DomQuery} New instance with nodes added.
			 */
			add: function(items, sort) {
				var self = this, nodes, i;
	
				if (isString(items)) {
					return self.add(DomQuery(items));
				}
	
				if (sort !== false) {
					nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
					self.length = nodes.length;
					for (i = 0; i < nodes.length; i++) {
						self[i] = nodes[i];
					}
				} else {
					push.apply(self, DomQuery.makeArray(items));
				}
	
				return self;
			},
	
			/**
			 * Sets/gets attributes on the elements in the current set.
			 *
			 * @method attr
			 * @param {String/Object} name Name of attribute to get or an object with attributes to set.
			 * @param {String} value Optional value to set.
			 * @return {tinymce.dom.DomQuery/String} Current set or the specified attribute when only the name is specified.
			 */
			attr: function(name, value) {
				var self = this, hook;
	
				if (typeof name === "object") {
					each(name, function(name, value) {
						self.attr(name, value);
					});
				} else if (isDefined(value)) {
					this.each(function() {
						var hook;
	
						if (this.nodeType === 1) {
							hook = attrHooks[name];
							if (hook && hook.set) {
								hook.set(this, value);
								return;
							}
	
							if (value === null) {
								this.removeAttribute(name, 2);
							} else {
								this.setAttribute(name, value, 2);
							}
						}
					});
				} else {
					if (self[0] && self[0].nodeType === 1) {
						hook = attrHooks[name];
						if (hook && hook.get) {
							return hook.get(self[0], name);
						}
	
						if (booleanMap[name]) {
							return self.prop(name) ? name : undef;
						}
	
						value = self[0].getAttribute(name, 2);
	
						if (value === null) {
							value = undef;
						}
					}
	
					return value;
				}
	
				return self;
			},
	
			/**
			 * Removes attributse on the elements in the current set.
			 *
			 * @method removeAttr
			 * @param {String/Object} name Name of attribute to remove.
			 * @return {tinymce.dom.DomQuery/String} Current set.
			 */
			removeAttr: function(name) {
				return this.attr(name, null);
			},
	
			/**
			 * Sets/gets properties on the elements in the current set.
			 *
			 * @method attr
			 * @param {String/Object} name Name of property to get or an object with properties to set.
			 * @param {String} value Optional value to set.
			 * @return {tinymce.dom.DomQuery/String} Current set or the specified property when only the name is specified.
			 */
			prop: function(name, value) {
				var self = this;
	
				name = propFix[name] || name;
	
				if (typeof name === "object") {
					each(name, function(name, value) {
						self.prop(name, value);
					});
				} else if (isDefined(value)) {
					this.each(function() {
						if (this.nodeType == 1) {
							this[name] = value;
						}
					});
				} else {
					if (self[0] && self[0].nodeType && name in self[0]) {
						return self[0][name];
					}
	
					return value;
				}
	
				return self;
			},
	
			/**
			 * Sets/gets styles on the elements in the current set.
			 *
			 * @method css
			 * @param {String/Object} name Name of style to get or an object with styles to set.
			 * @param {String} value Optional value to set.
			 * @return {tinymce.dom.DomQuery/String} Current set or the specified style when only the name is specified.
			 */
			css: function(name, value) {
				var self = this, elm, hook;
	
				function camel(name) {
					return name.replace(/-(\D)/g, function(a, b) {
						return b.toUpperCase();
					});
				}
	
				function dashed(name) {
					return name.replace(/[A-Z]/g, function(a) {
						return '-' + a;
					});
				}
	
				if (typeof name === "object") {
					each(name, function(name, value) {
						self.css(name, value);
					});
				} else {
					if (isDefined(value)) {
						name = camel(name);
	
						// Default px suffix on these
						if (typeof value === 'number' && !numericCssMap[name]) {
							value += 'px';
						}
	
						self.each(function() {
							var style = this.style;
	
							hook = cssHooks[name];
							if (hook && hook.set) {
								hook.set(this, value);
								return;
							}
	
							try {
								this.style[cssFix[name] || name] = value;
							} catch (ex) {
								// Ignore
							}
	
							if (value === null || value === '') {
								if (style.removeProperty) {
									style.removeProperty(dashed(name));
								} else {
									style.removeAttribute(name);
								}
							}
						});
					} else {
						elm = self[0];
	
						hook = cssHooks[name];
						if (hook && hook.get) {
							return hook.get(elm);
						}
	
						if (elm.ownerDocument.defaultView) {
							try {
								return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
							} catch (ex) {
								return undef;
							}
						} else if (elm.currentStyle) {
							return elm.currentStyle[camel(name)];
						}
					}
				}
	
				return self;
			},
	
			/**
			 * Removes all nodes in set from the document.
			 *
			 * @method remove
			 * @return {tinymce.dom.DomQuery} Current set with the removed nodes.
			 */
			remove: function() {
				var self = this, node, i = this.length;
	
				while (i--) {
					node = self[i];
					Event.clean(node);
	
					if (node.parentNode) {
						node.parentNode.removeChild(node);
					}
				}
	
				return this;
			},
	
			/**
			 * Empties all elements in set.
			 *
			 * @method empty
			 * @return {tinymce.dom.DomQuery} Current set with the empty nodes.
			 */
			empty: function() {
				var self = this, node, i = this.length;
	
				while (i--) {
					node = self[i];
					while (node.firstChild) {
						node.removeChild(node.firstChild);
					}
				}
	
				return this;
			},
	
			/**
			 * Sets or gets the HTML of the current set or first set node.
			 *
			 * @method html
			 * @param {String} value Optional innerHTML value to set on each element.
			 * @return {tinymce.dom.DomQuery/String} Current set or the innerHTML of the first element.
			 */
			html: function(value) {
				var self = this, i;
	
				if (isDefined(value)) {
					i = self.length;
	
					try {
						while (i--) {
							self[i].innerHTML = value;
						}
					} catch (ex) {
						// Workaround for "Unknown runtime error" when DIV is added to P on IE
						DomQuery(self[i]).empty().append(value);
					}
	
					return self;
				}
	
				return self[0] ? self[0].innerHTML : '';
			},
	
			/**
			 * Sets or gets the text of the current set or first set node.
			 *
			 * @method text
			 * @param {String} value Optional innerText value to set on each element.
			 * @return {tinymce.dom.DomQuery/String} Current set or the innerText of the first element.
			 */
			text: function(value) {
				var self = this, i;
	
				if (isDefined(value)) {
					i = self.length;
					while (i--) {
						if ("innerText" in self[i]) {
							self[i].innerText = value;
						} else {
							self[0].textContent = value;
						}
					}
	
					return self;
				}
	
				return self[0] ? (self[0].innerText || self[0].textContent) : '';
			},
	
			/**
			 * Appends the specified node/html or node set to the current set nodes.
			 *
			 * @method append
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to append to each element in set.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			append: function() {
				return domManipulate(this, arguments, function(node) {
					// Either element or Shadow Root
					if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
						this.appendChild(node);
					}
				});
			},
	
			/**
			 * Prepends the specified node/html or node set to the current set nodes.
			 *
			 * @method prepend
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to prepend to each element in set.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			prepend: function() {
				return domManipulate(this, arguments, function(node) {
					// Either element or Shadow Root
					if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
						this.insertBefore(node, this.firstChild);
					}
				}, true);
			},
	
			/**
			 * Adds the specified elements before current set nodes.
			 *
			 * @method before
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to add before to each element in set.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			before: function() {
				var self = this;
	
				if (self[0] && self[0].parentNode) {
					return domManipulate(self, arguments, function(node) {
						this.parentNode.insertBefore(node, this);
					});
				}
	
				return self;
			},
	
			/**
			 * Adds the specified elements after current set nodes.
			 *
			 * @method after
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to add after to each element in set.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			after: function() {
				var self = this;
	
				if (self[0] && self[0].parentNode) {
					return domManipulate(self, arguments, function(node) {
						this.parentNode.insertBefore(node, this.nextSibling);
					}, true);
				}
	
				return self;
			},
	
			/**
			 * Appends the specified set nodes to the specified selector/instance.
			 *
			 * @method appendTo
			 * @param {String/Element/Array/tinymce.dom.DomQuery} val Item to append the current set to.
			 * @return {tinymce.dom.DomQuery} Current set with the appended nodes.
			 */
			appendTo: function(val) {
				DomQuery(val).append(this);
	
				return this;
			},
	
			/**
			 * Prepends the specified set nodes to the specified selector/instance.
			 *
			 * @method prependTo
			 * @param {String/Element/Array/tinymce.dom.DomQuery} val Item to prepend the current set to.
			 * @return {tinymce.dom.DomQuery} Current set with the prepended nodes.
			 */
			prependTo: function(val) {
				DomQuery(val).prepend(this);
	
				return this;
			},
	
			/**
			 * Replaces the nodes in set with the specified content.
			 *
			 * @method replaceWith
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to replace nodes with.
			 * @return {tinymce.dom.DomQuery} Set with replaced nodes.
			 */
			replaceWith: function(content) {
				return this.before(content).remove();
			},
	
			/**
			 * Wraps all elements in set with the specified wrapper.
			 *
			 * @method wrap
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
			 * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
			 */
			wrap: function(content) {
				return wrap(this, content);
			},
	
			/**
			 * Wraps all nodes in set with the specified wrapper. If the nodes are siblings all of them
			 * will be wrapped in the same wrapper.
			 *
			 * @method wrapAll
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
			 * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
			 */
			wrapAll: function(content) {
				return wrap(this, content, true);
			},
	
			/**
			 * Wraps all elements inner contents in set with the specified wrapper.
			 *
			 * @method wrapInner
			 * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
			 * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
			 */
			wrapInner: function(content) {
				this.each(function() {
					DomQuery(this).contents().wrapAll(content);
				});
	
				return this;
			},
	
			/**
			 * Unwraps all elements by removing the parent element of each item in set.
			 *
			 * @method unwrap
			 * @return {tinymce.dom.DomQuery} Set with unwrapped nodes.
			 */
			unwrap: function() {
				return this.parent().each(function() {
					DomQuery(this).replaceWith(this.childNodes);
				});
			},
	
			/**
			 * Clones all nodes in set.
			 *
			 * @method clone
			 * @return {tinymce.dom.DomQuery} Set with cloned nodes.
			 */
			clone: function() {
				var result = [];
	
				this.each(function() {
					result.push(this.cloneNode(true));
				});
	
				return DomQuery(result);
			},
	
			/**
			 * Adds the specified class name to the current set elements.
			 *
			 * @method addClass
			 * @param {String} className Class name to add.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			addClass: function(className) {
				return this.toggleClass(className, true);
			},
	
			/**
			 * Removes the specified class name to the current set elements.
			 *
			 * @method removeClass
			 * @param {String} className Class name to remove.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			removeClass: function(className) {
				return this.toggleClass(className, false);
			},
	
			/**
			 * Toggles the specified class name on the current set elements.
			 *
			 * @method toggleClass
			 * @param {String} className Class name to add/remove.
			 * @param {Boolean} state Optional state to toggle on/off.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			toggleClass: function(className, state) {
				var self = this;
	
				// Functions are not supported
				if (typeof className != 'string') {
					return self;
				}
	
				if (className.indexOf(' ') !== -1) {
					each(className.split(' '), function() {
						self.toggleClass(this, state);
					});
				} else {
					self.each(function(index, node) {
						var existingClassName, classState;
	
						classState = hasClass(node, className);
						if (classState !== state) {
							existingClassName = node.className;
	
							if (classState) {
								node.className = trim((" " + existingClassName + " ").replace(' ' + className + ' ', ' '));
							} else {
								node.className += existingClassName ? ' ' + className : className;
							}
						}
					});
				}
	
				return self;
			},
	
			/**
			 * Returns true/false if the first item in set has the specified class.
			 *
			 * @method hasClass
			 * @param {String} className Class name to check for.
			 * @return {Boolean} True/false if the set has the specified class.
			 */
			hasClass: function(className) {
				return hasClass(this[0], className);
			},
	
			/**
			 * Executes the callback function for each item DomQuery collection. If you return false in the
			 * callback it will break the loop.
			 *
			 * @method each
			 * @param {function} callback Callback function to execute for each item.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			each: function(callback) {
				return each(this, callback);
			},
	
			/**
			 * Binds an event with callback function to the elements in set.
			 *
			 * @method on
			 * @param {String} name Name of the event to bind.
			 * @param {function} callback Callback function to execute when the event occurs.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			on: function(name, callback) {
				return this.each(function() {
					Event.bind(this, name, callback);
				});
			},
	
			/**
			 * Unbinds an event with callback function to the elements in set.
			 *
			 * @method off
			 * @param {String} name Optional name of the event to bind.
			 * @param {function} callback Optional callback function to execute when the event occurs.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			off: function(name, callback) {
				return this.each(function() {
					Event.unbind(this, name, callback);
				});
			},
	
			/**
			 * Triggers the specified event by name or event object.
			 *
			 * @method trigger
			 * @param {String/Object} name Name of the event to trigger or event object.
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			trigger: function(name) {
				return this.each(function() {
					if (typeof name == 'object') {
						Event.fire(this, name.type, name);
					} else {
						Event.fire(this, name);
					}
				});
			},
	
			/**
			 * Shows all elements in set.
			 *
			 * @method show
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			show: function() {
				return this.css('display', '');
			},
	
			/**
			 * Hides all elements in set.
			 *
			 * @method hide
			 * @return {tinymce.dom.DomQuery} Current set.
			 */
			hide: function() {
				return this.css('display', 'none');
			},
	
			/**
			 * Slices the current set.
			 *
			 * @method slice
			 * @param {Number} start Start index to slice at.
			 * @param {Number} end Optional end index to end slice at.
			 * @return {tinymce.dom.DomQuery} Sliced set.
			 */
			slice: function() {
				return new DomQuery(slice.apply(this, arguments));
			},
	
			/**
			 * Makes the set equal to the specified index.
			 *
			 * @method eq
			 * @param {Number} index Index to set it equal to.
			 * @return {tinymce.dom.DomQuery} Single item set.
			 */
			eq: function(index) {
				return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
			},
	
			/**
			 * Makes the set equal to first element in set.
			 *
			 * @method first
			 * @return {tinymce.dom.DomQuery} Single item set.
			 */
			first: function() {
				return this.eq(0);
			},
	
			/**
			 * Makes the set equal to last element in set.
			 *
			 * @method last
			 * @return {tinymce.dom.DomQuery} Single item set.
			 */
			last: function() {
				return this.eq(-1);
			},
	
			/**
			 * Finds elements by the specified selector for each element in set.
			 *
			 * @method find
			 * @param {String} selector Selector to find elements by.
			 * @return {tinymce.dom.DomQuery} Set with matches elements.
			 */
			find: function(selector) {
				var i, l, ret = [];
	
				for (i = 0, l = this.length; i < l; i++) {
					DomQuery.find(selector, this[i], ret);
				}
	
				return DomQuery(ret);
			},
	
			/**
			 * Filters the current set with the specified selector.
			 *
			 * @method filter
			 * @param {String/function} selector Selector to filter elements by.
			 * @return {tinymce.dom.DomQuery} Set with filtered elements.
			 */
			filter: function(selector) {
				if (typeof selector == 'function') {
					return DomQuery(grep(this.toArray(), function(item, i) {
						return selector(i, item);
					}));
				}
	
				return DomQuery(DomQuery.filter(selector, this.toArray()));
			},
	
			/**
			 * Gets the current node or any parent matching the specified selector.
			 *
			 * @method closest
			 * @param {String/Element/tinymce.dom.DomQuery} selector Selector or element to find.
			 * @return {tinymce.dom.DomQuery} Set with closest elements.
			 */
			closest: function(selector) {
				var result = [];
	
				if (selector instanceof DomQuery) {
					selector = selector[0];
				}
	
				this.each(function(i, node) {
					while (node) {
						if (typeof selector == 'string' && DomQuery(node).is(selector)) {
							result.push(node);
							break;
						} else if (node == selector) {
							result.push(node);
							break;
						}
	
						node = node.parentNode;
					}
				});
	
				return DomQuery(result);
			},
	
			/**
			 * Returns the offset of the first element in set or sets the top/left css properties of all elements in set.
			 *
			 * @method offset
			 * @param {Object} offset Optional offset object to set on each item.
			 * @return {Object/tinymce.dom.DomQuery} Returns the first element offset or the current set if you specified an offset.
			 */
			offset: function(offset) {
				var elm, doc, docElm;
				var x = 0, y = 0, pos;
	
				if (!offset) {
					elm = this[0];
	
					if (elm) {
						doc = elm.ownerDocument;
						docElm = doc.documentElement;
	
						if (elm.getBoundingClientRect) {
							pos = elm.getBoundingClientRect();
							x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
							y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
						}
					}
	
					return {
						left: x,
						top: y
					};
				}
	
				return this.css(offset);
			},
	
			push: push,
			sort: [].sort,
			splice: [].splice
		};
	
		// Static members
		Tools.extend(DomQuery, {
			/**
			 * Extends the specified object with one or more objects.
			 *
			 * @static
			 * @method extend
			 * @param {Object} target Target object to extend with new items.
			 * @param {Object..} object Object to extend the target with.
			 * @return {Object} Extended input object.
			 */
			extend: Tools.extend,
	
			/**
			 * Creates an array out of an array like object.
			 *
			 * @static
			 * @method makeArray
			 * @param {Object} object Object to convert to array.
			 * @return {Array} Array produced from object.
			 */
			makeArray: function(object) {
				if (isWindow(object) || object.nodeType) {
					return [object];
				}
	
				return Tools.toArray(object);
			},
	
			/**
			 * Returns the index of the specified item inside the array.
			 *
			 * @static
			 * @method inArray
			 * @param {Object} item Item to look for.
			 * @param {Array} array Array to look for item in.
			 * @return {Number} Index of the item or -1.
			 */
			inArray: inArray,
	
			/**
			 * Returns true/false if the specified object is an array or not.
			 *
			 * @static
			 * @method isArray
			 * @param {Object} array Object to check if it's an array or not.
			 * @return {Boolean} True/false if the object is an array.
			 */
			isArray: Tools.isArray,
	
			/**
			 * Executes the callback function for each item in array/object. If you return false in the
			 * callback it will break the loop.
			 *
			 * @static
			 * @method each
			 * @param {Object} obj Object to iterate.
			 * @param {function} callback Callback function to execute for each item.
			 */
			each: each,
	
			/**
			 * Removes whitespace from the beginning and end of a string.
			 *
			 * @static
			 * @method trim
			 * @param {String} str String to remove whitespace from.
			 * @return {String} New string with removed whitespace.
			 */
			trim: trim,
	
			/**
			 * Filters out items from the input array by calling the specified function for each item.
			 * If the function returns false the item will be excluded if it returns true it will be included.
			 *
			 * @static
			 * @method grep
			 * @param {Array} array Array of items to loop though.
			 * @param {function} callback Function to call for each item. Include/exclude depends on it's return value.
			 * @return {Array} New array with values imported and filtered based in input.
			 * @example
			 * // Filter out some items, this will return an array with 4 and 5
			 * var items = DomQuery.grep([1, 2, 3, 4, 5], function(v) {return v > 3;});
			 */
			grep: grep,
	
			// Sizzle
			find: Sizzle,
			expr: Sizzle.selectors,
			unique: Sizzle.uniqueSort,
			text: Sizzle.getText,
			contains: Sizzle.contains,
			filter: function(expr, elems, not) {
				var i = elems.length;
	
				if (not) {
					expr = ":not(" + expr + ")";
				}
	
				while (i--) {
					if (elems[i].nodeType != 1) {
						elems.splice(i, 1);
					}
				}
	
				if (elems.length === 1) {
					elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
				} else {
					elems = DomQuery.find.matches(expr, elems);
				}
	
				return elems;
			}
		});
	
		function dir(el, prop, until) {
			var matched = [], cur = el[prop];
	
			if (typeof until != 'string' && until instanceof DomQuery) {
				until = until[0];
			}
	
			while (cur && cur.nodeType !== 9) {
				if (until !== undefined) {
					if (cur === until) {
						break;
					}
	
					if (typeof until == 'string' && DomQuery(cur).is(until)) {
						break;
					}
				}
	
				if (cur.nodeType === 1) {
					matched.push(cur);
				}
	
				cur = cur[prop];
			}
	
			return matched;
		}
	
		function sibling(node, siblingName, nodeType, until) {
			var result = [];
	
			if (until instanceof DomQuery) {
				until = until[0];
			}
	
			for (; node; node = node[siblingName]) {
				if (nodeType && node.nodeType !== nodeType) {
					continue;
				}
	
				if (until !== undefined) {
					if (node === until) {
						break;
					}
	
					if (typeof until == 'string' && DomQuery(node).is(until)) {
						break;
					}
				}
	
				result.push(node);
			}
	
			return result;
		}
	
		function firstSibling(node, siblingName, nodeType) {
			for (node = node[siblingName]; node; node = node[siblingName]) {
				if (node.nodeType == nodeType) {
					return node;
				}
			}
	
			return null;
		}
	
		each({
			/**
			 * Returns a new collection with the parent of each item in current collection matching the optional selector.
			 *
			 * @method parent
			 * @param {Element/tinymce.dom.DomQuery} node Node to match parents against.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
			 */
			parent: function(node) {
				var parent = node.parentNode;
	
				return parent && parent.nodeType !== 11 ? parent : null;
			},
	
			/**
			 * Returns a new collection with the all the parents of each item in current collection matching the optional selector.
			 *
			 * @method parents
			 * @param {Element/tinymce.dom.DomQuery} node Node to match parents against.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
			 */
			parents: function(node) {
				return dir(node, "parentNode");
			},
	
			/**
			 * Returns a new collection with next sibling of each item in current collection matching the optional selector.
			 *
			 * @method next
			 * @param {Element/tinymce.dom.DomQuery} node Node to match the next element against.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			next: function(node) {
				return firstSibling(node, 'nextSibling', 1);
			},
	
			/**
			 * Returns a new collection with previous sibling of each item in current collection matching the optional selector.
			 *
			 * @method prev
			 * @param {Element/tinymce.dom.DomQuery} node Node to match the previous element against.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			prev: function(node) {
				return firstSibling(node, 'previousSibling', 1);
			},
	
			/**
			 * Returns all child elements matching the optional selector.
			 *
			 * @method children
			 * @param {Element/tinymce.dom.DomQuery} node Node to match the elements against.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			children: function(node) {
				return sibling(node.firstChild, 'nextSibling', 1);
			},
	
			/**
			 * Returns all child nodes matching the optional selector.
			 *
			 * @method contents
			 * @param {Element/tinymce.dom.DomQuery} node Node to get the contents of.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			contents: function(node) {
				return Tools.toArray((node.nodeName === "iframe" ? node.contentDocument || node.contentWindow.document : node).childNodes);
			}
		}, function(name, fn) {
			DomQuery.fn[name] = function(selector) {
				var self = this, result = [];
	
				self.each(function() {
					var nodes = fn.call(result, this, selector, result);
	
					if (nodes) {
						if (DomQuery.isArray(nodes)) {
							result.push.apply(result, nodes);
						} else {
							result.push(nodes);
						}
					}
				});
	
				// If traversing on multiple elements we might get the same elements twice
				if (this.length > 1) {
					if (!skipUniques[name]) {
						result = DomQuery.unique(result);
					}
	
					if (name.indexOf('parents') === 0) {
						result = result.reverse();
					}
				}
	
				result = DomQuery(result);
	
				if (selector) {
					return result.filter(selector);
				}
	
				return result;
			};
		});
	
		each({
			/**
			 * Returns a new collection with the all the parents until the matching selector/element
			 * of each item in current collection matching the optional selector.
			 *
			 * @method parentsUntil
			 * @param {Element/tinymce.dom.DomQuery} node Node to find parent of.
			 * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
			 */
			parentsUntil: function(node, until) {
				return dir(node, "parentNode", until);
			},
	
			/**
			 * Returns a new collection with all next siblings of each item in current collection matching the optional selector.
			 *
			 * @method nextUntil
			 * @param {Element/tinymce.dom.DomQuery} node Node to find next siblings on.
			 * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			nextUntil: function(node, until) {
				return sibling(node, 'nextSibling', 1, until).slice(1);
			},
	
			/**
			 * Returns a new collection with all previous siblings of each item in current collection matching the optional selector.
			 *
			 * @method prevUntil
			 * @param {Element/tinymce.dom.DomQuery} node Node to find previous siblings on.
			 * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
			 * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
			 */
			prevUntil: function(node, until) {
				return sibling(node, 'previousSibling', 1, until).slice(1);
			}
		}, function(name, fn) {
			DomQuery.fn[name] = function(selector, filter) {
				var self = this, result = [];
	
				self.each(function() {
					var nodes = fn.call(result, this, selector, result);
	
					if (nodes) {
						if (DomQuery.isArray(nodes)) {
							result.push.apply(result, nodes);
						} else {
							result.push(nodes);
						}
					}
				});
	
				// If traversing on multiple elements we might get the same elements twice
				if (this.length > 1) {
					result = DomQuery.unique(result);
	
					if (name.indexOf('parents') === 0 || name === 'prevUntil') {
						result = result.reverse();
					}
				}
	
				result = DomQuery(result);
	
				if (filter) {
					return result.filter(filter);
				}
	
				return result;
			};
		});
	
		/**
		 * Returns true/false if the current set items matches the selector.
		 *
		 * @method is
		 * @param {String} selector Selector to match the elements against.
		 * @return {Boolean} True/false if the current set matches the selector.
		 */
		DomQuery.fn.is = function(selector) {
			return !!selector && this.filter(selector).length > 0;
		};
	
		DomQuery.fn.init.prototype = DomQuery.fn;
	
		DomQuery.overrideDefaults = function(callback) {
			var defaults;
	
			function sub(selector, context) {
				defaults = defaults || callback();
	
				if (arguments.length === 0) {
					selector = defaults.element;
				}
	
				if (!context) {
					context = defaults.context;
				}
	
				return new sub.fn.init(selector, context);
			}
	
			DomQuery.extend(sub, this);
	
			return sub;
		};
	
		function appendHooks(targetHooks, prop, hooks) {
			each(hooks, function(name, func) {
				targetHooks[name] = targetHooks[name] || {};
				targetHooks[name][prop] = func;
			});
		}
	
		if (Env.ie && Env.ie < 8) {
			appendHooks(attrHooks, 'get', {
				maxlength: function(elm) {
					var value = elm.maxLength;
	
					if (value === 0x7fffffff) {
						return undef;
					}
	
					return value;
				},
	
				size: function(elm) {
					var value = elm.size;
	
					if (value === 20) {
						return undef;
					}
	
					return value;
				},
	
				'class': function(elm) {
					return elm.className;
				},
	
				style: function(elm) {
					var value = elm.style.cssText;
	
					if (value.length === 0) {
						return undef;
					}
	
					return value;
				}
			});
	
			appendHooks(attrHooks, 'set', {
				'class': function(elm, value) {
					elm.className = value;
				},
	
				style: function(elm, value) {
					elm.style.cssText = value;
				}
			});
		}
	
		if (Env.ie && Env.ie < 9) {
			/*jshint sub:true */
			/*eslint dot-notation: 0*/
			cssFix['float'] = 'styleFloat';
	
			appendHooks(cssHooks, 'set', {
				opacity: function(elm, value) {
					var style = elm.style;
	
					if (value === null || value === '') {
						style.removeAttribute('filter');
					} else {
						style.zoom = 1;
						style.filter = 'alpha(opacity=' + (value * 100) + ')';
					}
				}
			});
		}
	
		DomQuery.attrHooks = attrHooks;
		DomQuery.cssHooks = cssHooks;
	
		return DomQuery;
	});
	
	// Included from: js/tinymce/classes/html/Styles.js
	
	/**
	 * Styles.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to parse CSS styles it also compresses styles to reduce the output size.
	 *
	 * @example
	 * var Styles = new tinymce.html.Styles({
	 *    url_converter: function(url) {
	 *       return url;
	 *    }
	 * });
	 *
	 * styles = Styles.parse('border: 1px solid red');
	 * styles.color = 'red';
	 *
	 * console.log(new tinymce.html.StyleSerializer().serialize(styles));
	 *
	 * @class tinymce.html.Styles
	 * @version 3.4
	 */
	define("tinymce/html/Styles", [], function() {
		return function(settings, schema) {
			/*jshint maxlen:255 */
			/*eslint max-len:0 */
			var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi,
				urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi,
				styleRegExp = /\s*([^:]+):\s*([^;]+);?/g,
				trimRightRegExp = /\s+$/,
				undef, i, encodingLookup = {}, encodingItems, validStyles, invalidStyles, invisibleChar = '\uFEFF';
	
			settings = settings || {};
	
			if (schema) {
				validStyles = schema.getValidStyles();
				invalidStyles = schema.getInvalidStyles();
			}
	
			encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
			for (i = 0; i < encodingItems.length; i++) {
				encodingLookup[encodingItems[i]] = invisibleChar + i;
				encodingLookup[invisibleChar + i] = encodingItems[i];
			}
	
			function toHex(match, r, g, b) {
				function hex(val) {
					val = parseInt(val, 10).toString(16);
	
					return val.length > 1 ? val : '0' + val; // 0 -> 00
				}
	
				return '#' + hex(r) + hex(g) + hex(b);
			}
	
			return {
				/**
				 * Parses the specified RGB color value and returns a hex version of that color.
				 *
				 * @method toHex
				 * @param {String} color RGB string value like rgb(1,2,3)
				 * @return {String} Hex version of that RGB value like #FF00FF.
				 */
				toHex: function(color) {
					return color.replace(rgbRegExp, toHex);
				},
	
				/**
				 * Parses the specified style value into an object collection. This parser will also
				 * merge and remove any redundant items that browsers might have added. It will also convert non hex
				 * colors to hex values. Urls inside the styles will also be converted to absolute/relative based on settings.
				 *
				 * @method parse
				 * @param {String} css Style value to parse for example: border:1px solid red;.
				 * @return {Object} Object representation of that style like {border: '1px solid red'}
				 */
				parse: function(css) {
					var styles = {}, matches, name, value, isEncoded, urlConverter = settings.url_converter;
					var urlConverterScope = settings.url_converter_scope || this;
	
					function compress(prefix, suffix, noJoin) {
						var top, right, bottom, left;
	
						top = styles[prefix + '-top' + suffix];
						if (!top) {
							return;
						}
	
						right = styles[prefix + '-right' + suffix];
						if (!right) {
							return;
						}
	
						bottom = styles[prefix + '-bottom' + suffix];
						if (!bottom) {
							return;
						}
	
						left = styles[prefix + '-left' + suffix];
						if (!left) {
							return;
						}
	
						var box = [top, right, bottom, left];
						i = box.length - 1;
						while (i--) {
							if (box[i] !== box[i + 1]) {
								break;
							}
						}
	
						if (i > -1 && noJoin) {
							return;
						}
	
						styles[prefix + suffix] = i == -1 ? box[0] : box.join(' ');
						delete styles[prefix + '-top' + suffix];
						delete styles[prefix + '-right' + suffix];
						delete styles[prefix + '-bottom' + suffix];
						delete styles[prefix + '-left' + suffix];
					}
	
					/**
					 * Checks if the specific style can be compressed in other words if all border-width are equal.
					 */
					function canCompress(key) {
						var value = styles[key], i;
	
						if (!value) {
							return;
						}
	
						value = value.split(' ');
						i = value.length;
						while (i--) {
							if (value[i] !== value[0]) {
								return false;
							}
						}
	
						styles[key] = value[0];
	
						return true;
					}
	
					/**
					 * Compresses multiple styles into one style.
					 */
					function compress2(target, a, b, c) {
						if (!canCompress(a)) {
							return;
						}
	
						if (!canCompress(b)) {
							return;
						}
	
						if (!canCompress(c)) {
							return;
						}
	
						// Compress
						styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
						delete styles[a];
						delete styles[b];
						delete styles[c];
					}
	
					// Encodes the specified string by replacing all \" \' ; : with _<num>
					function encode(str) {
						isEncoded = true;
	
						return encodingLookup[str];
					}
	
					// Decodes the specified string by replacing all _<num> with it's original value \" \' etc
					// It will also decode the \" \' if keep_slashes is set to fale or omitted
					function decode(str, keep_slashes) {
						if (isEncoded) {
							str = str.replace(/\uFEFF[0-9]/g, function(str) {
								return encodingLookup[str];
							});
						}
	
						if (!keep_slashes) {
							str = str.replace(/\\([\'\";:])/g, "$1");
						}
	
						return str;
					}
	
					function processUrl(match, url, url2, url3, str, str2) {
						str = str || str2;
	
						if (str) {
							str = decode(str);
	
							// Force strings into single quote format
							return "'" + str.replace(/\'/g, "\\'") + "'";
						}
	
						url = decode(url || url2 || url3);
	
						if (!settings.allow_script_urls) {
							var scriptUrl = url.replace(/[\s\r\n]+/, '');
	
							if (/(java|vb)script:/i.test(scriptUrl)) {
								return "";
							}
	
							if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
								return "";
							}
						}
	
						// Convert the URL to relative/absolute depending on config
						if (urlConverter) {
							url = urlConverter.call(urlConverterScope, url, 'style');
						}
	
						// Output new URL format
						return "url('" + url.replace(/\'/g, "\\'") + "')";
					}
	
					if (css) {
						css = css.replace(/[\u0000-\u001F]/g, '');
	
						// Encode \" \' % and ; and : inside strings so they don't interfere with the style parsing
						css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function(str) {
							return str.replace(/[;:]/g, encode);
						});
	
						// Parse styles
						while ((matches = styleRegExp.exec(css))) {
							name = matches[1].replace(trimRightRegExp, '').toLowerCase();
							value = matches[2].replace(trimRightRegExp, '');
	
							// Decode escaped sequences like \65 -> e
							/*jshint loopfunc:true*/
							/*eslint no-loop-func:0 */
							value = value.replace(/\\[0-9a-f]+/g, function(e) {
								return String.fromCharCode(parseInt(e.substr(1), 16));
							});
	
							if (name && value.length > 0) {
								// Don't allow behavior name or expression/comments within the values
								if (!settings.allow_script_urls && (name == "behavior" || /expression\s*\(|\/\*|\*\//.test(value))) {
									continue;
								}
	
								// Opera will produce 700 instead of bold in their style values
								if (name === 'font-weight' && value === '700') {
									value = 'bold';
								} else if (name === 'color' || name === 'background-color') { // Lowercase colors like RED
									value = value.toLowerCase();
								}
	
								// Convert RGB colors to HEX
								value = value.replace(rgbRegExp, toHex);
	
								// Convert URLs and force them into url('value') format
								value = value.replace(urlOrStrRegExp, processUrl);
								styles[name] = isEncoded ? decode(value, true) : value;
							}
	
							styleRegExp.lastIndex = matches.index + matches[0].length;
						}
						// Compress the styles to reduce it's size for example IE will expand styles
						compress("border", "", true);
						compress("border", "-width");
						compress("border", "-color");
						compress("border", "-style");
						compress("padding", "");
						compress("margin", "");
						compress2('border', 'border-width', 'border-style', 'border-color');
	
						// Remove pointless border, IE produces these
						if (styles.border === 'medium none') {
							delete styles.border;
						}
	
						// IE 11 will produce a border-image: none when getting the style attribute from <p style="border: 1px solid red"></p>
						// So let us assume it shouldn't be there
						if (styles['border-image'] === 'none') {
							delete styles['border-image'];
						}
					}
	
					return styles;
				},
	
				/**
				 * Serializes the specified style object into a string.
				 *
				 * @method serialize
				 * @param {Object} styles Object to serialize as string for example: {border: '1px solid red'}
				 * @param {String} elementName Optional element name, if specified only the styles that matches the schema will be serialized.
				 * @return {String} String representation of the style object for example: border: 1px solid red.
				 */
				serialize: function(styles, elementName) {
					var css = '', name, value;
	
					function serializeStyles(name) {
						var styleList, i, l, value;
	
						styleList = validStyles[name];
						if (styleList) {
							for (i = 0, l = styleList.length; i < l; i++) {
								name = styleList[i];
								value = styles[name];
	
								if (value !== undef && value.length > 0) {
									css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
								}
							}
						}
					}
	
					function isValid(name, elementName) {
						var styleMap;
	
						styleMap = invalidStyles['*'];
						if (styleMap && styleMap[name]) {
							return false;
						}
	
						styleMap = invalidStyles[elementName];
						if (styleMap && styleMap[name]) {
							return false;
						}
	
						return true;
					}
	
					// Serialize styles according to schema
					if (elementName && validStyles) {
						// Serialize global styles and element specific styles
						serializeStyles('*');
						serializeStyles(elementName);
					} else {
						// Output the styles in the order they are inside the object
						for (name in styles) {
							value = styles[name];
	
							if (value !== undef && value.length > 0) {
								if (!invalidStyles || isValid(name, elementName)) {
									css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
								}
							}
						}
					}
	
					return css;
				}
			};
		};
	});
	
	// Included from: js/tinymce/classes/dom/TreeWalker.js
	
	/**
	 * TreeWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * TreeWalker class enables you to walk the DOM in a linear manner.
	 *
	 * @class tinymce.dom.TreeWalker
	 * @example
	 * var walker = new tinymce.dom.TreeWalker(startNode);
	 *
	 * do {
	 *     console.log(walker.current());
	 * } while (walker.next());
	 */
	define("tinymce/dom/TreeWalker", [], function() {
		/**
		 * Constructs a new TreeWalker instance.
		 *
		 * @constructor
		 * @method TreeWalker
		 * @param {Node} startNode Node to start walking from.
		 * @param {node} rootNode Optional root node to never walk out of.
		 */
		return function(startNode, rootNode) {
			var node = startNode;
	
			function findSibling(node, startName, siblingName, shallow) {
				var sibling, parent;
	
				if (node) {
					// Walk into nodes if it has a start
					if (!shallow && node[startName]) {
						return node[startName];
					}
	
					// Return the sibling if it has one
					if (node != rootNode) {
						sibling = node[siblingName];
						if (sibling) {
							return sibling;
						}
	
						// Walk up the parents to look for siblings
						for (parent = node.parentNode; parent && parent != rootNode; parent = parent.parentNode) {
							sibling = parent[siblingName];
							if (sibling) {
								return sibling;
							}
						}
					}
				}
			}
	
			function findPreviousNode(node, startName, siblingName, shallow) {
				var sibling, parent, child;
	
				if (node) {
					sibling = node[siblingName];
					if (rootNode && sibling === rootNode) {
						return;
					}
	
					if (sibling) {
						if (!shallow) {
							// Walk up the parents to look for siblings
							for (child = sibling[startName]; child; child = child[startName]) {
								if (!child[startName]) {
									return child;
								}
							}
						}
	
						return sibling;
					}
	
					parent = node.parentNode;
					if (parent && parent !== rootNode) {
						return parent;
					}
				}
			}
	
			/**
			 * Returns the current node.
			 *
			 * @method current
			 * @return {Node} Current node where the walker is.
			 */
			this.current = function() {
				return node;
			};
	
			/**
			 * Walks to the next node in tree.
			 *
			 * @method next
			 * @return {Node} Current node where the walker is after moving to the next node.
			 */
			this.next = function(shallow) {
				node = findSibling(node, 'firstChild', 'nextSibling', shallow);
				return node;
			};
	
			/**
			 * Walks to the previous node in tree.
			 *
			 * @method prev
			 * @return {Node} Current node where the walker is after moving to the previous node.
			 */
			this.prev = function(shallow) {
				node = findSibling(node, 'lastChild', 'previousSibling', shallow);
				return node;
			};
	
			this.prev2 = function(shallow) {
				node = findPreviousNode(node, 'lastChild', 'previousSibling', shallow);
				return node;
			};
		};
	});
	
	// Included from: js/tinymce/classes/dom/Range.js
	
	/**
	 * Range.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Old IE Range.
	 *
	 * @private
	 * @class tinymce.dom.Range
	 */
	define("tinymce/dom/Range", [
		"tinymce/util/Tools"
	], function(Tools) {
		// Range constructor
		function Range(dom) {
			var self = this,
				doc = dom.doc,
				EXTRACT = 0,
				CLONE = 1,
				DELETE = 2,
				TRUE = true,
				FALSE = false,
				START_OFFSET = 'startOffset',
				START_CONTAINER = 'startContainer',
				END_CONTAINER = 'endContainer',
				END_OFFSET = 'endOffset',
				extend = Tools.extend,
				nodeIndex = dom.nodeIndex;
	
			function createDocumentFragment() {
				return doc.createDocumentFragment();
			}
	
			function setStart(n, o) {
				_setEndPoint(TRUE, n, o);
			}
	
			function setEnd(n, o) {
				_setEndPoint(FALSE, n, o);
			}
	
			function setStartBefore(n) {
				setStart(n.parentNode, nodeIndex(n));
			}
	
			function setStartAfter(n) {
				setStart(n.parentNode, nodeIndex(n) + 1);
			}
	
			function setEndBefore(n) {
				setEnd(n.parentNode, nodeIndex(n));
			}
	
			function setEndAfter(n) {
				setEnd(n.parentNode, nodeIndex(n) + 1);
			}
	
			function collapse(ts) {
				if (ts) {
					self[END_CONTAINER] = self[START_CONTAINER];
					self[END_OFFSET] = self[START_OFFSET];
				} else {
					self[START_CONTAINER] = self[END_CONTAINER];
					self[START_OFFSET] = self[END_OFFSET];
				}
	
				self.collapsed = TRUE;
			}
	
			function selectNode(n) {
				setStartBefore(n);
				setEndAfter(n);
			}
	
			function selectNodeContents(n) {
				setStart(n, 0);
				setEnd(n, n.nodeType === 1 ? n.childNodes.length : n.nodeValue.length);
			}
	
			function compareBoundaryPoints(h, r) {
				var sc = self[START_CONTAINER], so = self[START_OFFSET], ec = self[END_CONTAINER], eo = self[END_OFFSET],
				rsc = r.startContainer, rso = r.startOffset, rec = r.endContainer, reo = r.endOffset;
	
				// Check START_TO_START
				if (h === 0) {
					return _compareBoundaryPoints(sc, so, rsc, rso);
				}
	
				// Check START_TO_END
				if (h === 1) {
					return _compareBoundaryPoints(ec, eo, rsc, rso);
				}
	
				// Check END_TO_END
				if (h === 2) {
					return _compareBoundaryPoints(ec, eo, rec, reo);
				}
	
				// Check END_TO_START
				if (h === 3) {
					return _compareBoundaryPoints(sc, so, rec, reo);
				}
			}
	
			function deleteContents() {
				_traverse(DELETE);
			}
	
			function extractContents() {
				return _traverse(EXTRACT);
			}
	
			function cloneContents() {
				return _traverse(CLONE);
			}
	
			function insertNode(n) {
				var startContainer = this[START_CONTAINER],
					startOffset = this[START_OFFSET], nn, o;
	
				// Node is TEXT_NODE or CDATA
				if ((startContainer.nodeType === 3 || startContainer.nodeType === 4) && startContainer.nodeValue) {
					if (!startOffset) {
						// At the start of text
						startContainer.parentNode.insertBefore(n, startContainer);
					} else if (startOffset >= startContainer.nodeValue.length) {
						// At the end of text
						dom.insertAfter(n, startContainer);
					} else {
						// Middle, need to split
						nn = startContainer.splitText(startOffset);
						startContainer.parentNode.insertBefore(n, nn);
					}
				} else {
					// Insert element node
					if (startContainer.childNodes.length > 0) {
						o = startContainer.childNodes[startOffset];
					}
	
					if (o) {
						startContainer.insertBefore(n, o);
					} else {
						if (startContainer.nodeType == 3) {
							dom.insertAfter(n, startContainer);
						} else {
							startContainer.appendChild(n);
						}
					}
				}
			}
	
			function surroundContents(n) {
				var f = self.extractContents();
	
				self.insertNode(n);
				n.appendChild(f);
				self.selectNode(n);
			}
	
			function cloneRange() {
				return extend(new Range(dom), {
					startContainer: self[START_CONTAINER],
					startOffset: self[START_OFFSET],
					endContainer: self[END_CONTAINER],
					endOffset: self[END_OFFSET],
					collapsed: self.collapsed,
					commonAncestorContainer: self.commonAncestorContainer
				});
			}
	
			// Private methods
	
			function _getSelectedNode(container, offset) {
				var child;
	
				// TEXT_NODE
				if (container.nodeType == 3) {
					return container;
				}
	
				if (offset < 0) {
					return container;
				}
	
				child = container.firstChild;
				while (child && offset > 0) {
					--offset;
					child = child.nextSibling;
				}
	
				if (child) {
					return child;
				}
	
				return container;
			}
	
			function _isCollapsed() {
				return (self[START_CONTAINER] == self[END_CONTAINER] && self[START_OFFSET] == self[END_OFFSET]);
			}
	
			function _compareBoundaryPoints(containerA, offsetA, containerB, offsetB) {
				var c, offsetC, n, cmnRoot, childA, childB;
	
				// In the first case the boundary-points have the same container. A is before B
				// if its offset is less than the offset of B, A is equal to B if its offset is
				// equal to the offset of B, and A is after B if its offset is greater than the
				// offset of B.
				if (containerA == containerB) {
					if (offsetA == offsetB) {
						return 0; // equal
					}
	
					if (offsetA < offsetB) {
						return -1; // before
					}
	
					return 1; // after
				}
	
				// In the second case a child node C of the container of A is an ancestor
				// container of B. In this case, A is before B if the offset of A is less than or
				// equal to the index of the child node C and A is after B otherwise.
				c = containerB;
				while (c && c.parentNode != containerA) {
					c = c.parentNode;
				}
	
				if (c) {
					offsetC = 0;
					n = containerA.firstChild;
	
					while (n != c && offsetC < offsetA) {
						offsetC++;
						n = n.nextSibling;
					}
	
					if (offsetA <= offsetC) {
						return -1; // before
					}
	
					return 1; // after
				}
	
				// In the third case a child node C of the container of B is an ancestor container
				// of A. In this case, A is before B if the index of the child node C is less than
				// the offset of B and A is after B otherwise.
				c = containerA;
				while (c && c.parentNode != containerB) {
					c = c.parentNode;
				}
	
				if (c) {
					offsetC = 0;
					n = containerB.firstChild;
	
					while (n != c && offsetC < offsetB) {
						offsetC++;
						n = n.nextSibling;
					}
	
					if (offsetC < offsetB) {
						return -1; // before
					}
	
					return 1; // after
				}
	
				// In the fourth case, none of three other cases hold: the containers of A and B
				// are siblings or descendants of sibling nodes. In this case, A is before B if
				// the container of A is before the container of B in a pre-order traversal of the
				// Ranges' context tree and A is after B otherwise.
				cmnRoot = dom.findCommonAncestor(containerA, containerB);
				childA = containerA;
	
				while (childA && childA.parentNode != cmnRoot) {
					childA = childA.parentNode;
				}
	
				if (!childA) {
					childA = cmnRoot;
				}
	
				childB = containerB;
				while (childB && childB.parentNode != cmnRoot) {
					childB = childB.parentNode;
				}
	
				if (!childB) {
					childB = cmnRoot;
				}
	
				if (childA == childB) {
					return 0; // equal
				}
	
				n = cmnRoot.firstChild;
				while (n) {
					if (n == childA) {
						return -1; // before
					}
	
					if (n == childB) {
						return 1; // after
					}
	
					n = n.nextSibling;
				}
			}
	
			function _setEndPoint(st, n, o) {
				var ec, sc;
	
				if (st) {
					self[START_CONTAINER] = n;
					self[START_OFFSET] = o;
				} else {
					self[END_CONTAINER] = n;
					self[END_OFFSET] = o;
				}
	
				// If one boundary-point of a Range is set to have a root container
				// other than the current one for the Range, the Range is collapsed to
				// the new position. This enforces the restriction that both boundary-
				// points of a Range must have the same root container.
				ec = self[END_CONTAINER];
				while (ec.parentNode) {
					ec = ec.parentNode;
				}
	
				sc = self[START_CONTAINER];
				while (sc.parentNode) {
					sc = sc.parentNode;
				}
	
				if (sc == ec) {
					// The start position of a Range is guaranteed to never be after the
					// end position. To enforce this restriction, if the start is set to
					// be at a position after the end, the Range is collapsed to that
					// position.
					if (_compareBoundaryPoints(self[START_CONTAINER], self[START_OFFSET], self[END_CONTAINER], self[END_OFFSET]) > 0) {
						self.collapse(st);
					}
				} else {
					self.collapse(st);
				}
	
				self.collapsed = _isCollapsed();
				self.commonAncestorContainer = dom.findCommonAncestor(self[START_CONTAINER], self[END_CONTAINER]);
			}
	
			function _traverse(how) {
				var c, endContainerDepth = 0, startContainerDepth = 0, p, depthDiff, startNode, endNode, sp, ep;
	
				if (self[START_CONTAINER] == self[END_CONTAINER]) {
					return _traverseSameContainer(how);
				}
	
				for (c = self[END_CONTAINER], p = c.parentNode; p; c = p, p = p.parentNode) {
					if (p == self[START_CONTAINER]) {
						return _traverseCommonStartContainer(c, how);
					}
	
					++endContainerDepth;
				}
	
				for (c = self[START_CONTAINER], p = c.parentNode; p; c = p, p = p.parentNode) {
					if (p == self[END_CONTAINER]) {
						return _traverseCommonEndContainer(c, how);
					}
	
					++startContainerDepth;
				}
	
				depthDiff = startContainerDepth - endContainerDepth;
	
				startNode = self[START_CONTAINER];
				while (depthDiff > 0) {
					startNode = startNode.parentNode;
					depthDiff--;
				}
	
				endNode = self[END_CONTAINER];
				while (depthDiff < 0) {
					endNode = endNode.parentNode;
					depthDiff++;
				}
	
				// ascend the ancestor hierarchy until we have a common parent.
				for (sp = startNode.parentNode, ep = endNode.parentNode; sp != ep; sp = sp.parentNode, ep = ep.parentNode) {
					startNode = sp;
					endNode = ep;
				}
	
				return _traverseCommonAncestors(startNode, endNode, how);
			}
	
			function _traverseSameContainer(how) {
				var frag, s, sub, n, cnt, sibling, xferNode, start, len;
	
				if (how != DELETE) {
					frag = createDocumentFragment();
				}
	
				// If selection is empty, just return the fragment
				if (self[START_OFFSET] == self[END_OFFSET]) {
					return frag;
				}
	
				// Text node needs special case handling
				if (self[START_CONTAINER].nodeType == 3) { // TEXT_NODE
					// get the substring
					s = self[START_CONTAINER].nodeValue;
					sub = s.substring(self[START_OFFSET], self[END_OFFSET]);
	
					// set the original text node to its new value
					if (how != CLONE) {
						n = self[START_CONTAINER];
						start = self[START_OFFSET];
						len = self[END_OFFSET] - self[START_OFFSET];
	
						if (start === 0 && len >= n.nodeValue.length - 1) {
							n.parentNode.removeChild(n);
						} else {
							n.deleteData(start, len);
						}
	
						// Nothing is partially selected, so collapse to start point
						self.collapse(TRUE);
					}
	
					if (how == DELETE) {
						return;
					}
	
					if (sub.length > 0) {
						frag.appendChild(doc.createTextNode(sub));
					}
	
					return frag;
				}
	
				// Copy nodes between the start/end offsets.
				n = _getSelectedNode(self[START_CONTAINER], self[START_OFFSET]);
				cnt = self[END_OFFSET] - self[START_OFFSET];
	
				while (n && cnt > 0) {
					sibling = n.nextSibling;
					xferNode = _traverseFullySelected(n, how);
	
					if (frag) {
						frag.appendChild(xferNode);
					}
	
					--cnt;
					n = sibling;
				}
	
				// Nothing is partially selected, so collapse to start point
				if (how != CLONE) {
					self.collapse(TRUE);
				}
	
				return frag;
			}
	
			function _traverseCommonStartContainer(endAncestor, how) {
				var frag, n, endIdx, cnt, sibling, xferNode;
	
				if (how != DELETE) {
					frag = createDocumentFragment();
				}
	
				n = _traverseRightBoundary(endAncestor, how);
	
				if (frag) {
					frag.appendChild(n);
				}
	
				endIdx = nodeIndex(endAncestor);
				cnt = endIdx - self[START_OFFSET];
	
				if (cnt <= 0) {
					// Collapse to just before the endAncestor, which
					// is partially selected.
					if (how != CLONE) {
						self.setEndBefore(endAncestor);
						self.collapse(FALSE);
					}
	
					return frag;
				}
	
				n = endAncestor.previousSibling;
				while (cnt > 0) {
					sibling = n.previousSibling;
					xferNode = _traverseFullySelected(n, how);
	
					if (frag) {
						frag.insertBefore(xferNode, frag.firstChild);
					}
	
					--cnt;
					n = sibling;
				}
	
				// Collapse to just before the endAncestor, which
				// is partially selected.
				if (how != CLONE) {
					self.setEndBefore(endAncestor);
					self.collapse(FALSE);
				}
	
				return frag;
			}
	
			function _traverseCommonEndContainer(startAncestor, how) {
				var frag, startIdx, n, cnt, sibling, xferNode;
	
				if (how != DELETE) {
					frag = createDocumentFragment();
				}
	
				n = _traverseLeftBoundary(startAncestor, how);
				if (frag) {
					frag.appendChild(n);
				}
	
				startIdx = nodeIndex(startAncestor);
				++startIdx; // Because we already traversed it
	
				cnt = self[END_OFFSET] - startIdx;
				n = startAncestor.nextSibling;
				while (n && cnt > 0) {
					sibling = n.nextSibling;
					xferNode = _traverseFullySelected(n, how);
	
					if (frag) {
						frag.appendChild(xferNode);
					}
	
					--cnt;
					n = sibling;
				}
	
				if (how != CLONE) {
					self.setStartAfter(startAncestor);
					self.collapse(TRUE);
				}
	
				return frag;
			}
	
			function _traverseCommonAncestors(startAncestor, endAncestor, how) {
				var n, frag, startOffset, endOffset, cnt, sibling, nextSibling;
	
				if (how != DELETE) {
					frag = createDocumentFragment();
				}
	
				n = _traverseLeftBoundary(startAncestor, how);
				if (frag) {
					frag.appendChild(n);
				}
	
				startOffset = nodeIndex(startAncestor);
				endOffset = nodeIndex(endAncestor);
				++startOffset;
	
				cnt = endOffset - startOffset;
				sibling = startAncestor.nextSibling;
	
				while (cnt > 0) {
					nextSibling = sibling.nextSibling;
					n = _traverseFullySelected(sibling, how);
	
					if (frag) {
						frag.appendChild(n);
					}
	
					sibling = nextSibling;
					--cnt;
				}
	
				n = _traverseRightBoundary(endAncestor, how);
	
				if (frag) {
					frag.appendChild(n);
				}
	
				if (how != CLONE) {
					self.setStartAfter(startAncestor);
					self.collapse(TRUE);
				}
	
				return frag;
			}
	
			function _traverseRightBoundary(root, how) {
				var next = _getSelectedNode(self[END_CONTAINER], self[END_OFFSET] - 1), parent, clonedParent;
				var prevSibling, clonedChild, clonedGrandParent, isFullySelected = next != self[END_CONTAINER];
	
				if (next == root) {
					return _traverseNode(next, isFullySelected, FALSE, how);
				}
	
				parent = next.parentNode;
				clonedParent = _traverseNode(parent, FALSE, FALSE, how);
	
				while (parent) {
					while (next) {
						prevSibling = next.previousSibling;
						clonedChild = _traverseNode(next, isFullySelected, FALSE, how);
	
						if (how != DELETE) {
							clonedParent.insertBefore(clonedChild, clonedParent.firstChild);
						}
	
						isFullySelected = TRUE;
						next = prevSibling;
					}
	
					if (parent == root) {
						return clonedParent;
					}
	
					next = parent.previousSibling;
					parent = parent.parentNode;
	
					clonedGrandParent = _traverseNode(parent, FALSE, FALSE, how);
	
					if (how != DELETE) {
						clonedGrandParent.appendChild(clonedParent);
					}
	
					clonedParent = clonedGrandParent;
				}
			}
	
			function _traverseLeftBoundary(root, how) {
				var next = _getSelectedNode(self[START_CONTAINER], self[START_OFFSET]), isFullySelected = next != self[START_CONTAINER];
				var parent, clonedParent, nextSibling, clonedChild, clonedGrandParent;
	
				if (next == root) {
					return _traverseNode(next, isFullySelected, TRUE, how);
				}
	
				parent = next.parentNode;
				clonedParent = _traverseNode(parent, FALSE, TRUE, how);
	
				while (parent) {
					while (next) {
						nextSibling = next.nextSibling;
						clonedChild = _traverseNode(next, isFullySelected, TRUE, how);
	
						if (how != DELETE) {
							clonedParent.appendChild(clonedChild);
						}
	
						isFullySelected = TRUE;
						next = nextSibling;
					}
	
					if (parent == root) {
						return clonedParent;
					}
	
					next = parent.nextSibling;
					parent = parent.parentNode;
	
					clonedGrandParent = _traverseNode(parent, FALSE, TRUE, how);
	
					if (how != DELETE) {
						clonedGrandParent.appendChild(clonedParent);
					}
	
					clonedParent = clonedGrandParent;
				}
			}
	
			function _traverseNode(n, isFullySelected, isLeft, how) {
				var txtValue, newNodeValue, oldNodeValue, offset, newNode;
	
				if (isFullySelected) {
					return _traverseFullySelected(n, how);
				}
	
				// TEXT_NODE
				if (n.nodeType == 3) {
					txtValue = n.nodeValue;
	
					if (isLeft) {
						offset = self[START_OFFSET];
						newNodeValue = txtValue.substring(offset);
						oldNodeValue = txtValue.substring(0, offset);
					} else {
						offset = self[END_OFFSET];
						newNodeValue = txtValue.substring(0, offset);
						oldNodeValue = txtValue.substring(offset);
					}
	
					if (how != CLONE) {
						n.nodeValue = oldNodeValue;
					}
	
					if (how == DELETE) {
						return;
					}
	
					newNode = dom.clone(n, FALSE);
					newNode.nodeValue = newNodeValue;
	
					return newNode;
				}
	
				if (how == DELETE) {
					return;
				}
	
				return dom.clone(n, FALSE);
			}
	
			function _traverseFullySelected(n, how) {
				if (how != DELETE) {
					return how == CLONE ? dom.clone(n, TRUE) : n;
				}
	
				n.parentNode.removeChild(n);
			}
	
			function toStringIE() {
				return dom.create('body', null, cloneContents()).outerText;
			}
	
			extend(self, {
				// Initial states
				startContainer: doc,
				startOffset: 0,
				endContainer: doc,
				endOffset: 0,
				collapsed: TRUE,
				commonAncestorContainer: doc,
	
				// Range constants
				START_TO_START: 0,
				START_TO_END: 1,
				END_TO_END: 2,
				END_TO_START: 3,
	
				// Public methods
				setStart: setStart,
				setEnd: setEnd,
				setStartBefore: setStartBefore,
				setStartAfter: setStartAfter,
				setEndBefore: setEndBefore,
				setEndAfter: setEndAfter,
				collapse: collapse,
				selectNode: selectNode,
				selectNodeContents: selectNodeContents,
				compareBoundaryPoints: compareBoundaryPoints,
				deleteContents: deleteContents,
				extractContents: extractContents,
				cloneContents: cloneContents,
				insertNode: insertNode,
				surroundContents: surroundContents,
				cloneRange: cloneRange,
				toStringIE: toStringIE
			});
	
			return self;
		}
	
		// Older IE versions doesn't let you override toString by it's constructor so we have to stick it in the prototype
		Range.prototype.toString = function() {
			return this.toStringIE();
		};
	
		return Range;
	});
	
	// Included from: js/tinymce/classes/html/Entities.js
	
	/**
	 * Entities.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint bitwise:false */
	/*eslint no-bitwise:0 */
	
	/**
	 * Entity encoder class.
	 *
	 * @class tinymce.html.Entities
	 * @static
	 * @version 3.4
	 */
	define("tinymce/html/Entities", [
		"tinymce/util/Tools"
	], function(Tools) {
		var makeMap = Tools.makeMap;
	
		var namedEntities, baseEntities, reverseEntities,
			attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
			textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
			rawCharsRegExp = /[<>&\"\']/g,
			entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi,
			asciiMap = {
				128: "\u20AC", 130: "\u201A", 131: "\u0192", 132: "\u201E", 133: "\u2026", 134: "\u2020",
				135: "\u2021", 136: "\u02C6", 137: "\u2030", 138: "\u0160", 139: "\u2039", 140: "\u0152",
				142: "\u017D", 145: "\u2018", 146: "\u2019", 147: "\u201C", 148: "\u201D", 149: "\u2022",
				150: "\u2013", 151: "\u2014", 152: "\u02DC", 153: "\u2122", 154: "\u0161", 155: "\u203A",
				156: "\u0153", 158: "\u017E", 159: "\u0178"
			};
	
		// Raw entities
		baseEntities = {
			'\"': '&quot;', // Needs to be escaped since the YUI compressor would otherwise break the code
			"'": '&#39;',
			'<': '&lt;',
			'>': '&gt;',
			'&': '&amp;',
			'\u0060': '&#96;'
		};
	
		// Reverse lookup table for raw entities
		reverseEntities = {
			'&lt;': '<',
			'&gt;': '>',
			'&amp;': '&',
			'&quot;': '"',
			'&apos;': "'"
		};
	
		// Decodes text by using the browser
		function nativeDecode(text) {
			var elm;
	
			elm = document.createElement("div");
			elm.innerHTML = text;
	
			return elm.textContent || elm.innerText || text;
		}
	
		// Build a two way lookup table for the entities
		function buildEntitiesLookup(items, radix) {
			var i, chr, entity, lookup = {};
	
			if (items) {
				items = items.split(',');
				radix = radix || 10;
	
				// Build entities lookup table
				for (i = 0; i < items.length; i += 2) {
					chr = String.fromCharCode(parseInt(items[i], radix));
	
					// Only add non base entities
					if (!baseEntities[chr]) {
						entity = '&' + items[i + 1] + ';';
						lookup[chr] = entity;
						lookup[entity] = chr;
					}
				}
	
				return lookup;
			}
		}
	
		// Unpack entities lookup where the numbers are in radix 32 to reduce the size
		namedEntities = buildEntitiesLookup(
			'50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' +
			'5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' +
			'5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' +
			'5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' +
			'68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' +
			'6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' +
			'6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' +
			'75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' +
			'7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' +
			'7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' +
			'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' +
			'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' +
			't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' +
			'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' +
			'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' +
			'81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' +
			'8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' +
			'8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' +
			'8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' +
			'8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' +
			'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' +
			'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' +
			'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' +
			'80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' +
			'811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	
		var Entities = {
			/**
			 * Encodes the specified string using raw entities. This means only the required XML base entities will be encoded.
			 *
			 * @method encodeRaw
			 * @param {String} text Text to encode.
			 * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
			 * @return {String} Entity encoded text.
			 */
			encodeRaw: function(text, attr) {
				return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function(chr) {
					return baseEntities[chr] || chr;
				});
			},
	
			/**
			 * Encoded the specified text with both the attributes and text entities. This function will produce larger text contents
			 * since it doesn't know if the context is within a attribute or text node. This was added for compatibility
			 * and is exposed as the DOMUtils.encode function.
			 *
			 * @method encodeAllRaw
			 * @param {String} text Text to encode.
			 * @return {String} Entity encoded text.
			 */
			encodeAllRaw: function(text) {
				return ('' + text).replace(rawCharsRegExp, function(chr) {
					return baseEntities[chr] || chr;
				});
			},
	
			/**
			 * Encodes the specified string using numeric entities. The core entities will be
			 * encoded as named ones but all non lower ascii characters will be encoded into numeric entities.
			 *
			 * @method encodeNumeric
			 * @param {String} text Text to encode.
			 * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
			 * @return {String} Entity encoded text.
			 */
			encodeNumeric: function(text, attr) {
				return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function(chr) {
					// Multi byte sequence convert it to a single entity
					if (chr.length > 1) {
						return '&#' + (((chr.charCodeAt(0) - 0xD800) * 0x400) + (chr.charCodeAt(1) - 0xDC00) + 0x10000) + ';';
					}
	
					return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
				});
			},
	
			/**
			 * Encodes the specified string using named entities. The core entities will be encoded
			 * as named ones but all non lower ascii characters will be encoded into named entities.
			 *
			 * @method encodeNamed
			 * @param {String} text Text to encode.
			 * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
			 * @param {Object} entities Optional parameter with entities to use.
			 * @return {String} Entity encoded text.
			 */
			encodeNamed: function(text, attr, entities) {
				entities = entities || namedEntities;
	
				return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function(chr) {
					return baseEntities[chr] || entities[chr] || chr;
				});
			},
	
			/**
			 * Returns an encode function based on the name(s) and it's optional entities.
			 *
			 * @method getEncodeFunc
			 * @param {String} name Comma separated list of encoders for example named,numeric.
			 * @param {String} entities Optional parameter with entities to use instead of the built in set.
			 * @return {function} Encode function to be used.
			 */
			getEncodeFunc: function(name, entities) {
				entities = buildEntitiesLookup(entities) || namedEntities;
	
				function encodeNamedAndNumeric(text, attr) {
					return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function(chr) {
						return baseEntities[chr] || entities[chr] || '&#' + chr.charCodeAt(0) + ';' || chr;
					});
				}
	
				function encodeCustomNamed(text, attr) {
					return Entities.encodeNamed(text, attr, entities);
				}
	
				// Replace + with , to be compatible with previous TinyMCE versions
				name = makeMap(name.replace(/\+/g, ','));
	
				// Named and numeric encoder
				if (name.named && name.numeric) {
					return encodeNamedAndNumeric;
				}
	
				// Named encoder
				if (name.named) {
					// Custom names
					if (entities) {
						return encodeCustomNamed;
					}
	
					return Entities.encodeNamed;
				}
	
				// Numeric
				if (name.numeric) {
					return Entities.encodeNumeric;
				}
	
				// Raw encoder
				return Entities.encodeRaw;
			},
	
			/**
			 * Decodes the specified string, this will replace entities with raw UTF characters.
			 *
			 * @method decode
			 * @param {String} text Text to entity decode.
			 * @return {String} Entity decoded string.
			 */
			decode: function(text) {
				return text.replace(entityRegExp, function(all, numeric) {
					if (numeric) {
						if (numeric.charAt(0).toLowerCase() === 'x') {
							numeric = parseInt(numeric.substr(1), 16);
						} else {
							numeric = parseInt(numeric, 10);
						}
	
						// Support upper UTF
						if (numeric > 0xFFFF) {
							numeric -= 0x10000;
	
							return String.fromCharCode(0xD800 + (numeric >> 10), 0xDC00 + (numeric & 0x3FF));
						}
	
						return asciiMap[numeric] || String.fromCharCode(numeric);
					}
	
					return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
				});
			}
		};
	
		return Entities;
	});
	
	// Included from: js/tinymce/classes/dom/StyleSheetLoader.js
	
	/**
	 * StyleSheetLoader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles loading of external stylesheets and fires events when these are loaded.
	 *
	 * @class tinymce.dom.StyleSheetLoader
	 * @private
	 */
	define("tinymce/dom/StyleSheetLoader", [
		"tinymce/util/Tools",
		"tinymce/util/Delay"
	], function(Tools, Delay) {
		"use strict";
	
		return function(document, settings) {
			var idCount = 0, loadedStates = {}, maxLoadTime;
	
			settings = settings || {};
			maxLoadTime = settings.maxLoadTime || 5000;
	
			function appendToHead(node) {
				document.getElementsByTagName('head')[0].appendChild(node);
			}
	
			/**
			 * Loads the specified css style sheet file and call the loadedCallback once it's finished loading.
			 *
			 * @method load
			 * @param {String} url Url to be loaded.
			 * @param {Function} loadedCallback Callback to be executed when loaded.
			 * @param {Function} errorCallback Callback to be executed when failed loading.
			 */
			function load(url, loadedCallback, errorCallback) {
				var link, style, startTime, state;
	
				function passed() {
					var callbacks = state.passed, i = callbacks.length;
	
					while (i--) {
						callbacks[i]();
					}
	
					state.status = 2;
					state.passed = [];
					state.failed = [];
				}
	
				function failed() {
					var callbacks = state.failed, i = callbacks.length;
	
					while (i--) {
						callbacks[i]();
					}
	
					state.status = 3;
					state.passed = [];
					state.failed = [];
				}
	
				// Sniffs for older WebKit versions that have the link.onload but a broken one
				function isOldWebKit() {
					var webKitChunks = navigator.userAgent.match(/WebKit\/(\d*)/);
					return !!(webKitChunks && webKitChunks[1] < 536);
				}
	
				// Calls the waitCallback until the test returns true or the timeout occurs
				function wait(testCallback, waitCallback) {
					if (!testCallback()) {
						// Wait for timeout
						if ((new Date().getTime()) - startTime < maxLoadTime) {
							Delay.setTimeout(waitCallback);
						} else {
							failed();
						}
					}
				}
	
				// Workaround for WebKit that doesn't properly support the onload event for link elements
				// Or WebKit that fires the onload event before the StyleSheet is added to the document
				function waitForWebKitLinkLoaded() {
					wait(function() {
						var styleSheets = document.styleSheets, styleSheet, i = styleSheets.length, owner;
	
						while (i--) {
							styleSheet = styleSheets[i];
							owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
							if (owner && owner.id === link.id) {
								passed();
								return true;
							}
						}
					}, waitForWebKitLinkLoaded);
				}
	
				// Workaround for older Geckos that doesn't have any onload event for StyleSheets
				function waitForGeckoLinkLoaded() {
					wait(function() {
						try {
							// Accessing the cssRules will throw an exception until the CSS file is loaded
							var cssRules = style.sheet.cssRules;
							passed();
							return !!cssRules;
						} catch (ex) {
							// Ignore
						}
					}, waitForGeckoLinkLoaded);
				}
	
				url = Tools._addCacheSuffix(url);
	
				if (!loadedStates[url]) {
					state = {
						passed: [],
						failed: []
					};
	
					loadedStates[url] = state;
				} else {
					state = loadedStates[url];
				}
	
				if (loadedCallback) {
					state.passed.push(loadedCallback);
				}
	
				if (errorCallback) {
					state.failed.push(errorCallback);
				}
	
				// Is loading wait for it to pass
				if (state.status == 1) {
					return;
				}
	
				// Has finished loading and was success
				if (state.status == 2) {
					passed();
					return;
				}
	
				// Has finished loading and was a failure
				if (state.status == 3) {
					failed();
					return;
				}
	
				// Start loading
				state.status = 1;
				link = document.createElement('link');
				link.rel = 'stylesheet';
				link.type = 'text/css';
				link.id = 'u' + (idCount++);
				link.async = false;
				link.defer = false;
				startTime = new Date().getTime();
	
				// Feature detect onload on link element and sniff older webkits since it has an broken onload event
				if ("onload" in link && !isOldWebKit()) {
					link.onload = waitForWebKitLinkLoaded;
					link.onerror = failed;
				} else {
					// Sniff for old Firefox that doesn't support the onload event on link elements
					// TODO: Remove this in the future when everyone uses modern browsers
					if (navigator.userAgent.indexOf("Firefox") > 0) {
						style = document.createElement('style');
						style.textContent = '@import "' + url + '"';
						waitForGeckoLinkLoaded();
						appendToHead(style);
						return;
					}
	
					// Use the id owner on older webkits
					waitForWebKitLinkLoaded();
				}
	
				appendToHead(link);
				link.href = url;
			}
	
			this.load = load;
		};
	});
	
	// Included from: js/tinymce/classes/dom/DOMUtils.js
	
	/**
	 * DOMUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for various DOM manipulation and retrieval functions.
	 *
	 * @class tinymce.dom.DOMUtils
	 * @example
	 * // Add a class to an element by id in the page
	 * tinymce.DOM.addClass('someid', 'someclass');
	 *
	 * // Add a class to an element by id inside the editor
	 * tinymce.activeEditor.dom.addClass('someid', 'someclass');
	 */
	define("tinymce/dom/DOMUtils", [
		"tinymce/dom/Sizzle",
		"tinymce/dom/DomQuery",
		"tinymce/html/Styles",
		"tinymce/dom/EventUtils",
		"tinymce/dom/TreeWalker",
		"tinymce/dom/Range",
		"tinymce/html/Entities",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/dom/StyleSheetLoader"
	], function(Sizzle, $, Styles, EventUtils, TreeWalker, Range, Entities, Env, Tools, StyleSheetLoader) {
		// Shorten names
		var each = Tools.each, is = Tools.is, grep = Tools.grep, trim = Tools.trim;
		var isIE = Env.ie;
		var simpleSelectorRe = /^([a-z0-9],?)+$/i;
		var whiteSpaceRegExp = /^[ \t\r\n]*$/;
	
		function setupAttrHooks(domUtils, settings) {
			var attrHooks = {}, keepValues = settings.keep_values, keepUrlHook;
	
			keepUrlHook = {
				set: function($elm, value, name) {
					if (settings.url_converter) {
						value = settings.url_converter.call(settings.url_converter_scope || domUtils, value, name, $elm[0]);
					}
	
					$elm.attr('data-mce-' + name, value).attr(name, value);
				},
	
				get: function($elm, name) {
					return $elm.attr('data-mce-' + name) || $elm.attr(name);
				}
			};
	
			attrHooks = {
				style: {
					set: function($elm, value) {
						if (value !== null && typeof value === 'object') {
							$elm.css(value);
							return;
						}
	
						if (keepValues) {
							$elm.attr('data-mce-style', value);
						}
	
						$elm.attr('style', value);
					},
	
					get: function($elm) {
						var value = $elm.attr('data-mce-style') || $elm.attr('style');
	
						value = domUtils.serializeStyle(domUtils.parseStyle(value), $elm[0].nodeName);
	
						return value;
					}
				}
			};
	
			if (keepValues) {
				attrHooks.href = attrHooks.src = keepUrlHook;
			}
	
			return attrHooks;
		}
	
		function updateInternalStyleAttr(domUtils, $elm) {
			var value = $elm.attr('style');
	
			value = domUtils.serializeStyle(domUtils.parseStyle(value), $elm[0].nodeName);
	
			if (!value) {
				value = null;
			}
	
			$elm.attr('data-mce-style', value);
		}
	
		function nodeIndex(node, normalized) {
			var idx = 0, lastNodeType, nodeType;
	
			if (node) {
				for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
					nodeType = node.nodeType;
	
					// Normalize text nodes
					if (normalized && nodeType == 3) {
						if (nodeType == lastNodeType || !node.nodeValue.length) {
							continue;
						}
					}
					idx++;
					lastNodeType = nodeType;
				}
			}
	
			return idx;
		}
	
		/**
		 * Constructs a new DOMUtils instance. Consult the Wiki for more details on settings etc for this class.
		 *
		 * @constructor
		 * @method DOMUtils
		 * @param {Document} doc Document reference to bind the utility class to.
		 * @param {settings} settings Optional settings collection.
		 */
		function DOMUtils(doc, settings) {
			var self = this, blockElementsMap;
	
			self.doc = doc;
			self.win = window;
			self.files = {};
			self.counter = 0;
			self.stdMode = !isIE || doc.documentMode >= 8;
			self.boxModel = !isIE || doc.compatMode == "CSS1Compat" || self.stdMode;
			self.styleSheetLoader = new StyleSheetLoader(doc);
			self.boundEvents = [];
			self.settings = settings = settings || {};
			self.schema = settings.schema;
			self.styles = new Styles({
				url_converter: settings.url_converter,
				url_converter_scope: settings.url_converter_scope
			}, settings.schema);
	
			self.fixDoc(doc);
			self.events = settings.ownEvents ? new EventUtils(settings.proxy) : EventUtils.Event;
			self.attrHooks = setupAttrHooks(self, settings);
			blockElementsMap = settings.schema ? settings.schema.getBlockElements() : {};
			self.$ = $.overrideDefaults(function() {
				return {
					context: doc,
					element: self.getRoot()
				};
			});
	
			/**
			 * Returns true/false if the specified element is a block element or not.
			 *
			 * @method isBlock
			 * @param {Node/String} node Element/Node to check.
			 * @return {Boolean} True/False state if the node is a block element or not.
			 */
			self.isBlock = function(node) {
				// Fix for #5446
				if (!node) {
					return false;
				}
	
				// This function is called in module pattern style since it might be executed with the wrong this scope
				var type = node.nodeType;
	
				// If it's a node then check the type and use the nodeName
				if (type) {
					return !!(type === 1 && blockElementsMap[node.nodeName]);
				}
	
				return !!blockElementsMap[node];
			};
		}
	
		DOMUtils.prototype = {
			$$: function(elm) {
				if (typeof elm == 'string') {
					elm = this.get(elm);
				}
	
				return this.$(elm);
			},
	
			root: null,
	
			fixDoc: function(doc) {
				var settings = this.settings, name;
	
				if (isIE && settings.schema) {
					// Add missing HTML 4/5 elements to IE
					('abbr article aside audio canvas ' +
					'details figcaption figure footer ' +
					'header hgroup mark menu meter nav ' +
					'output progress section summary ' +
					'time video').replace(/\w+/g, function(name) {
						doc.createElement(name);
					});
	
					// Create all custom elements
					for (name in settings.schema.getCustomElements()) {
						doc.createElement(name);
					}
				}
			},
	
			clone: function(node, deep) {
				var self = this, clone, doc;
	
				// TODO: Add feature detection here in the future
				if (!isIE || node.nodeType !== 1 || deep) {
					return node.cloneNode(deep);
				}
	
				doc = self.doc;
	
				// Make a HTML5 safe shallow copy
				if (!deep) {
					clone = doc.createElement(node.nodeName);
	
					// Copy attribs
					each(self.getAttribs(node), function(attr) {
						self.setAttrib(clone, attr.nodeName, self.getAttrib(node, attr.nodeName));
					});
	
					return clone;
				}
	
				return clone.firstChild;
			},
	
			/**
			 * Returns the root node of the document. This is normally the body but might be a DIV. Parents like getParent will not
			 * go above the point of this root node.
			 *
			 * @method getRoot
			 * @return {Element} Root element for the utility class.
			 */
			getRoot: function() {
				var self = this;
	
				return self.settings.root_element || self.doc.body;
			},
	
			/**
			 * Returns the viewport of the window.
			 *
			 * @method getViewPort
			 * @param {Window} win Optional window to get viewport of.
			 * @return {Object} Viewport object with fields x, y, w and h.
			 */
			getViewPort: function(win) {
				var doc, rootElm;
	
				win = !win ? this.win : win;
				doc = win.document;
				rootElm = this.boxModel ? doc.documentElement : doc.body;
	
				// Returns viewport size excluding scrollbars
				return {
					x: win.pageXOffset || rootElm.scrollLeft,
					y: win.pageYOffset || rootElm.scrollTop,
					w: win.innerWidth || rootElm.clientWidth,
					h: win.innerHeight || rootElm.clientHeight
				};
			},
	
			/**
			 * Returns the rectangle for a specific element.
			 *
			 * @method getRect
			 * @param {Element/String} elm Element object or element ID to get rectangle from.
			 * @return {object} Rectangle for specified element object with x, y, w, h fields.
			 */
			getRect: function(elm) {
				var self = this, pos, size;
	
				elm = self.get(elm);
				pos = self.getPos(elm);
				size = self.getSize(elm);
	
				return {
					x: pos.x, y: pos.y,
					w: size.w, h: size.h
				};
			},
	
			/**
			 * Returns the size dimensions of the specified element.
			 *
			 * @method getSize
			 * @param {Element/String} elm Element object or element ID to get rectangle from.
			 * @return {object} Rectangle for specified element object with w, h fields.
			 */
			getSize: function(elm) {
				var self = this, w, h;
	
				elm = self.get(elm);
				w = self.getStyle(elm, 'width');
				h = self.getStyle(elm, 'height');
	
				// Non pixel value, then force offset/clientWidth
				if (w.indexOf('px') === -1) {
					w = 0;
				}
	
				// Non pixel value, then force offset/clientWidth
				if (h.indexOf('px') === -1) {
					h = 0;
				}
	
				return {
					w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
					h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
				};
			},
	
			/**
			 * Returns a node by the specified selector function. This function will
			 * loop through all parent nodes and call the specified function for each node.
			 * If the function then returns true indicating that it has found what it was looking for, the loop execution will then end
			 * and the node it found will be returned.
			 *
			 * @method getParent
			 * @param {Node/String} node DOM node to search parents on or ID string.
			 * @param {function} selector Selection function or CSS selector to execute on each node.
			 * @param {Node} root Optional root element, never go below this point.
			 * @return {Node} DOM Node or null if it wasn't found.
			 */
			getParent: function(node, selector, root) {
				return this.getParents(node, selector, root, false);
			},
	
			/**
			 * Returns a node list of all parents matching the specified selector function or pattern.
			 * If the function then returns true indicating that it has found what it was looking for and that node will be collected.
			 *
			 * @method getParents
			 * @param {Node/String} node DOM node to search parents on or ID string.
			 * @param {function} selector Selection function to execute on each node or CSS pattern.
			 * @param {Node} root Optional root element, never go below this point.
			 * @return {Array} Array of nodes or null if it wasn't found.
			 */
			getParents: function(node, selector, root, collect) {
				var self = this, selectorVal, result = [];
	
				node = self.get(node);
				collect = collect === undefined;
	
				// Default root on inline mode
				root = root || (self.getRoot().nodeName != 'BODY' ? self.getRoot().parentNode : null);
	
				// Wrap node name as func
				if (is(selector, 'string')) {
					selectorVal = selector;
	
					if (selector === '*') {
						selector = function(node) {
							return node.nodeType == 1;
						};
					} else {
						selector = function(node) {
							return self.is(node, selectorVal);
						};
					}
				}
	
				while (node) {
					if (node == root || !node.nodeType || node.nodeType === 9) {
						break;
					}
	
					if (!selector || selector(node)) {
						if (collect) {
							result.push(node);
						} else {
							return node;
						}
					}
	
					node = node.parentNode;
				}
	
				return collect ? result : null;
			},
	
			/**
			 * Returns the specified element by ID or the input element if it isn't a string.
			 *
			 * @method get
			 * @param {String/Element} n Element id to look for or element to just pass though.
			 * @return {Element} Element matching the specified id or null if it wasn't found.
			 */
			get: function(elm) {
				var name;
	
				if (elm && this.doc && typeof elm == 'string') {
					name = elm;
					elm = this.doc.getElementById(elm);
	
					// IE and Opera returns meta elements when they match the specified input ID, but getElementsByName seems to do the trick
					if (elm && elm.id !== name) {
						return this.doc.getElementsByName(name)[1];
					}
				}
	
				return elm;
			},
	
			/**
			 * Returns the next node that matches selector or function
			 *
			 * @method getNext
			 * @param {Node} node Node to find siblings from.
			 * @param {String/function} selector Selector CSS expression or function.
			 * @return {Node} Next node item matching the selector or null if it wasn't found.
			 */
			getNext: function(node, selector) {
				return this._findSib(node, selector, 'nextSibling');
			},
	
			/**
			 * Returns the previous node that matches selector or function
			 *
			 * @method getPrev
			 * @param {Node} node Node to find siblings from.
			 * @param {String/function} selector Selector CSS expression or function.
			 * @return {Node} Previous node item matching the selector or null if it wasn't found.
			 */
			getPrev: function(node, selector) {
				return this._findSib(node, selector, 'previousSibling');
			},
	
			// #ifndef jquery
	
			/**
			 * Selects specific elements by a CSS level 3 pattern. For example "div#a1 p.test".
			 * This function is optimized for the most common patterns needed in TinyMCE but it also performs well enough
			 * on more complex patterns.
			 *
			 * @method select
			 * @param {String} selector CSS level 3 pattern to select/find elements by.
			 * @param {Object} scope Optional root element/scope element to search in.
			 * @return {Array} Array with all matched elements.
			 * @example
			 * // Adds a class to all paragraphs in the currently active editor
			 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'someclass');
			 *
			 * // Adds a class to all spans that have the test class in the currently active editor
			 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('span.test'), 'someclass')
			 */
			select: function(selector, scope) {
				var self = this;
	
				/*eslint new-cap:0 */
				return Sizzle(selector, self.get(scope) || self.settings.root_element || self.doc, []);
			},
	
			/**
			 * Returns true/false if the specified element matches the specified css pattern.
			 *
			 * @method is
			 * @param {Node/NodeList} elm DOM node to match or an array of nodes to match.
			 * @param {String} selector CSS pattern to match the element against.
			 */
			is: function(elm, selector) {
				var i;
	
				// If it isn't an array then try to do some simple selectors instead of Sizzle for to boost performance
				if (elm.length === undefined) {
					// Simple all selector
					if (selector === '*') {
						return elm.nodeType == 1;
					}
	
					// Simple selector just elements
					if (simpleSelectorRe.test(selector)) {
						selector = selector.toLowerCase().split(/,/);
						elm = elm.nodeName.toLowerCase();
	
						for (i = selector.length - 1; i >= 0; i--) {
							if (selector[i] == elm) {
								return true;
							}
						}
	
						return false;
					}
				}
	
				// Is non element
				if (elm.nodeType && elm.nodeType != 1) {
					return false;
				}
	
				var elms = elm.nodeType ? [elm] : elm;
	
				/*eslint new-cap:0 */
				return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
			},
	
			// #endif
	
			/**
			 * Adds the specified element to another element or elements.
			 *
			 * @method add
			 * @param {String/Element/Array} parentElm Element id string, DOM node element or array of ids or elements to add to.
			 * @param {String/Element} name Name of new element to add or existing element to add.
			 * @param {Object} attrs Optional object collection with arguments to add to the new element(s).
			 * @param {String} html Optional inner HTML contents to add for each element.
			 * @param {Boolean} create Optional flag if the element should be created or added.
			 * @return {Element/Array} Element that got created, or an array of created elements if multiple input elements
			 * were passed in.
			 * @example
			 * // Adds a new paragraph to the end of the active editor
			 * tinymce.activeEditor.dom.add(tinymce.activeEditor.getBody(), 'p', {title: 'my title'}, 'Some content');
			 */
			add: function(parentElm, name, attrs, html, create) {
				var self = this;
	
				return this.run(parentElm, function(parentElm) {
					var newElm;
	
					newElm = is(name, 'string') ? self.doc.createElement(name) : name;
					self.setAttribs(newElm, attrs);
	
					if (html) {
						if (html.nodeType) {
							newElm.appendChild(html);
						} else {
							self.setHTML(newElm, html);
						}
					}
	
					return !create ? parentElm.appendChild(newElm) : newElm;
				});
			},
	
			/**
			 * Creates a new element.
			 *
			 * @method create
			 * @param {String} name Name of new element.
			 * @param {Object} attrs Optional object name/value collection with element attributes.
			 * @param {String} html Optional HTML string to set as inner HTML of the element.
			 * @return {Element} HTML DOM node element that got created.
			 * @example
			 * // Adds an element where the caret/selection is in the active editor
			 * var el = tinymce.activeEditor.dom.create('div', {id: 'test', 'class': 'myclass'}, 'some content');
			 * tinymce.activeEditor.selection.setNode(el);
			 */
			create: function(name, attrs, html) {
				return this.add(this.doc.createElement(name), name, attrs, html, 1);
			},
	
			/**
			 * Creates HTML string for element. The element will be closed unless an empty inner HTML string is passed in.
			 *
			 * @method createHTML
			 * @param {String} name Name of new element.
			 * @param {Object} attrs Optional object name/value collection with element attributes.
			 * @param {String} html Optional HTML string to set as inner HTML of the element.
			 * @return {String} String with new HTML element, for example: <a href="#">test</a>.
			 * @example
			 * // Creates a html chunk and inserts it at the current selection/caret location
			 * tinymce.activeEditor.selection.setContent(tinymce.activeEditor.dom.createHTML('a', {href: 'test.html'}, 'some line'));
			 */
			createHTML: function(name, attrs, html) {
				var outHtml = '', key;
	
				outHtml += '<' + name;
	
				for (key in attrs) {
					if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] != 'undefined') {
						outHtml += ' ' + key + '="' + this.encode(attrs[key]) + '"';
					}
				}
	
				// A call to tinymce.is doesn't work for some odd reason on IE9 possible bug inside their JS runtime
				if (typeof html != "undefined") {
					return outHtml + '>' + html + '</' + name + '>';
				}
	
				return outHtml + ' />';
			},
	
			/**
			 * Creates a document fragment out of the specified HTML string.
			 *
			 * @method createFragment
			 * @param {String} html Html string to create fragment from.
			 * @return {DocumentFragment} Document fragment node.
			 */
			createFragment: function(html) {
				var frag, node, doc = this.doc, container;
	
				container = doc.createElement("div");
				frag = doc.createDocumentFragment();
	
				if (html) {
					container.innerHTML = html;
				}
	
				while ((node = container.firstChild)) {
					frag.appendChild(node);
				}
	
				return frag;
			},
	
			/**
			 * Removes/deletes the specified element(s) from the DOM.
			 *
			 * @method remove
			 * @param {String/Element/Array} node ID of element or DOM element object or array containing multiple elements/ids.
			 * @param {Boolean} keepChildren Optional state to keep children or not. If set to true all children will be
			 * placed at the location of the removed element.
			 * @return {Element/Array} HTML DOM element that got removed, or an array of removed elements if multiple input elements
			 * were passed in.
			 * @example
			 * // Removes all paragraphs in the active editor
			 * tinymce.activeEditor.dom.remove(tinymce.activeEditor.dom.select('p'));
			 *
			 * // Removes an element by id in the document
			 * tinymce.DOM.remove('mydiv');
			 */
			remove: function(node, keepChildren) {
				node = this.$$(node);
	
				if (keepChildren) {
					node.each(function() {
						var child;
	
						while ((child = this.firstChild)) {
							if (child.nodeType == 3 && child.data.length === 0) {
								this.removeChild(child);
							} else {
								this.parentNode.insertBefore(child, this);
							}
						}
					}).remove();
				} else {
					node.remove();
				}
	
				return node.length > 1 ? node.toArray() : node[0];
			},
	
			/**
			 * Sets the CSS style value on a HTML element. The name can be a camelcase string
			 * or the CSS style name like background-color.
			 *
			 * @method setStyle
			 * @param {String/Element/Array} elm HTML element/Array of elements to set CSS style value on.
			 * @param {String} name Name of the style value to set.
			 * @param {String} value Value to set on the style.
			 * @example
			 * // Sets a style value on all paragraphs in the currently active editor
			 * tinymce.activeEditor.dom.setStyle(tinymce.activeEditor.dom.select('p'), 'background-color', 'red');
			 *
			 * // Sets a style value to an element by id in the current document
			 * tinymce.DOM.setStyle('mydiv', 'background-color', 'red');
			 */
			setStyle: function(elm, name, value) {
				elm = this.$$(elm).css(name, value);
	
				if (this.settings.update_styles) {
					updateInternalStyleAttr(this, elm);
				}
			},
	
			/**
			 * Returns the current style or runtime/computed value of an element.
			 *
			 * @method getStyle
			 * @param {String/Element} elm HTML element or element id string to get style from.
			 * @param {String} name Style name to return.
			 * @param {Boolean} computed Computed style.
			 * @return {String} Current style or computed style value of an element.
			 */
			getStyle: function(elm, name, computed) {
				elm = this.$$(elm);
	
				if (computed) {
					return elm.css(name);
				}
	
				// Camelcase it, if needed
				name = name.replace(/-(\D)/g, function(a, b) {
					return b.toUpperCase();
				});
	
				if (name == 'float') {
					name = Env.ie && Env.ie < 12 ? 'styleFloat' : 'cssFloat';
				}
	
				return elm[0] && elm[0].style ? elm[0].style[name] : undefined;
			},
	
			/**
			 * Sets multiple styles on the specified element(s).
			 *
			 * @method setStyles
			 * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set styles on.
			 * @param {Object} styles Name/Value collection of style items to add to the element(s).
			 * @example
			 * // Sets styles on all paragraphs in the currently active editor
			 * tinymce.activeEditor.dom.setStyles(tinymce.activeEditor.dom.select('p'), {'background-color': 'red', 'color': 'green'});
			 *
			 * // Sets styles to an element by id in the current document
			 * tinymce.DOM.setStyles('mydiv', {'background-color': 'red', 'color': 'green'});
			 */
			setStyles: function(elm, styles) {
				elm = this.$$(elm).css(styles);
	
				if (this.settings.update_styles) {
					updateInternalStyleAttr(this, elm);
				}
			},
	
			/**
			 * Removes all attributes from an element or elements.
			 *
			 * @method removeAllAttribs
			 * @param {Element/String/Array} e DOM element, element id string or array of elements/ids to remove attributes from.
			 */
			removeAllAttribs: function(e) {
				return this.run(e, function(e) {
					var i, attrs = e.attributes;
					for (i = attrs.length - 1; i >= 0; i--) {
						e.removeAttributeNode(attrs.item(i));
					}
				});
			},
	
			/**
			 * Sets the specified attribute of an element or elements.
			 *
			 * @method setAttrib
			 * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set attribute on.
			 * @param {String} name Name of attribute to set.
			 * @param {String} value Value to set on the attribute - if this value is falsy like null, 0 or '' it will remove
			 * the attribute instead.
			 * @example
			 * // Sets class attribute on all paragraphs in the active editor
			 * tinymce.activeEditor.dom.setAttrib(tinymce.activeEditor.dom.select('p'), 'class', 'myclass');
			 *
			 * // Sets class attribute on a specific element in the current page
			 * tinymce.dom.setAttrib('mydiv', 'class', 'myclass');
			 */
			setAttrib: function(elm, name, value) {
				var self = this, originalValue, hook, settings = self.settings;
	
				if (value === '') {
					value = null;
				}
	
				elm = self.$$(elm);
				originalValue = elm.attr(name);
	
				if (!elm.length) {
					return;
				}
	
				hook = self.attrHooks[name];
				if (hook && hook.set) {
					hook.set(elm, value, name);
				} else {
					elm.attr(name, value);
				}
	
				if (originalValue != value && settings.onSetAttrib) {
					settings.onSetAttrib({
						attrElm: elm,
						attrName: name,
						attrValue: value
					});
				}
			},
	
			/**
			 * Sets two or more specified attributes of an element or elements.
			 *
			 * @method setAttribs
			 * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set attributes on.
			 * @param {Object} attrs Name/Value collection of attribute items to add to the element(s).
			 * @example
			 * // Sets class and title attributes on all paragraphs in the active editor
			 * tinymce.activeEditor.dom.setAttribs(tinymce.activeEditor.dom.select('p'), {'class': 'myclass', title: 'some title'});
			 *
			 * // Sets class and title attributes on a specific element in the current page
			 * tinymce.DOM.setAttribs('mydiv', {'class': 'myclass', title: 'some title'});
			 */
			setAttribs: function(elm, attrs) {
				var self = this;
	
				self.$$(elm).each(function(i, node) {
					each(attrs, function(value, name) {
						self.setAttrib(node, name, value);
					});
				});
			},
	
			/**
			 * Returns the specified attribute by name.
			 *
			 * @method getAttrib
			 * @param {String/Element} elm Element string id or DOM element to get attribute from.
			 * @param {String} name Name of attribute to get.
			 * @param {String} defaultVal Optional default value to return if the attribute didn't exist.
			 * @return {String} Attribute value string, default value or null if the attribute wasn't found.
			 */
			getAttrib: function(elm, name, defaultVal) {
				var self = this, hook, value;
	
				elm = self.$$(elm);
	
				if (elm.length) {
					hook = self.attrHooks[name];
	
					if (hook && hook.get) {
						value = hook.get(elm, name);
					} else {
						value = elm.attr(name);
					}
				}
	
				if (typeof value == 'undefined') {
					value = defaultVal || '';
				}
	
				return value;
			},
	
			/**
			 * Returns the absolute x, y position of a node. The position will be returned in an object with x, y fields.
			 *
			 * @method getPos
			 * @param {Element/String} elm HTML element or element id to get x, y position from.
			 * @param {Element} rootElm Optional root element to stop calculations at.
			 * @return {object} Absolute position of the specified element object with x, y fields.
			 */
			getPos: function(elm, rootElm) {
				var self = this, x = 0, y = 0, offsetParent, doc = self.doc, body = doc.body, pos;
	
				elm = self.get(elm);
				rootElm = rootElm || body;
	
				if (elm) {
					// Use getBoundingClientRect if it exists since it's faster than looping offset nodes
					// Fallback to offsetParent calculations if the body isn't static better since it stops at the body root
					if (rootElm === body && elm.getBoundingClientRect && $(body).css('position') === 'static') {
						pos = elm.getBoundingClientRect();
						rootElm = self.boxModel ? doc.documentElement : body;
	
						// Add scroll offsets from documentElement or body since IE with the wrong box model will use d.body and so do WebKit
						// Also remove the body/documentelement clientTop/clientLeft on IE 6, 7 since they offset the position
						x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - rootElm.clientLeft;
						y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - rootElm.clientTop;
	
						return {x: x, y: y};
					}
	
					offsetParent = elm;
					while (offsetParent && offsetParent != rootElm && offsetParent.nodeType) {
						x += offsetParent.offsetLeft || 0;
						y += offsetParent.offsetTop || 0;
						offsetParent = offsetParent.offsetParent;
					}
	
					offsetParent = elm.parentNode;
					while (offsetParent && offsetParent != rootElm && offsetParent.nodeType) {
						x -= offsetParent.scrollLeft || 0;
						y -= offsetParent.scrollTop || 0;
						offsetParent = offsetParent.parentNode;
					}
				}
	
				return {x: x, y: y};
			},
	
			/**
			 * Parses the specified style value into an object collection. This parser will also
			 * merge and remove any redundant items that browsers might have added. It will also convert non-hex
			 * colors to hex values. Urls inside the styles will also be converted to absolute/relative based on settings.
			 *
			 * @method parseStyle
			 * @param {String} cssText Style value to parse, for example: border:1px solid red;.
			 * @return {Object} Object representation of that style, for example: {border: '1px solid red'}
			 */
			parseStyle: function(cssText) {
				return this.styles.parse(cssText);
			},
	
			/**
			 * Serializes the specified style object into a string.
			 *
			 * @method serializeStyle
			 * @param {Object} styles Object to serialize as string, for example: {border: '1px solid red'}
			 * @param {String} name Optional element name.
			 * @return {String} String representation of the style object, for example: border: 1px solid red.
			 */
			serializeStyle: function(styles, name) {
				return this.styles.serialize(styles, name);
			},
	
			/**
			 * Adds a style element at the top of the document with the specified cssText content.
			 *
			 * @method addStyle
			 * @param {String} cssText CSS Text style to add to top of head of document.
			 */
			addStyle: function(cssText) {
				var self = this, doc = self.doc, head, styleElm;
	
				// Prevent inline from loading the same styles twice
				if (self !== DOMUtils.DOM && doc === document) {
					var addedStyles = DOMUtils.DOM.addedStyles;
	
					addedStyles = addedStyles || [];
					if (addedStyles[cssText]) {
						return;
					}
	
					addedStyles[cssText] = true;
					DOMUtils.DOM.addedStyles = addedStyles;
				}
	
				// Create style element if needed
				styleElm = doc.getElementById('mceDefaultStyles');
				if (!styleElm) {
					styleElm = doc.createElement('style');
					styleElm.id = 'mceDefaultStyles';
					styleElm.type = 'text/css';
	
					head = doc.getElementsByTagName('head')[0];
					if (head.firstChild) {
						head.insertBefore(styleElm, head.firstChild);
					} else {
						head.appendChild(styleElm);
					}
				}
	
				// Append style data to old or new style element
				if (styleElm.styleSheet) {
					styleElm.styleSheet.cssText += cssText;
				} else {
					styleElm.appendChild(doc.createTextNode(cssText));
				}
			},
	
			/**
			 * Imports/loads the specified CSS file into the document bound to the class.
			 *
			 * @method loadCSS
			 * @param {String} url URL to CSS file to load.
			 * @example
			 * // Loads a CSS file dynamically into the current document
			 * tinymce.DOM.loadCSS('somepath/some.css');
			 *
			 * // Loads a CSS file into the currently active editor instance
			 * tinymce.activeEditor.dom.loadCSS('somepath/some.css');
			 *
			 * // Loads a CSS file into an editor instance by id
			 * tinymce.get('someid').dom.loadCSS('somepath/some.css');
			 *
			 * // Loads multiple CSS files into the current document
			 * tinymce.DOM.loadCSS('somepath/some.css,somepath/someother.css');
			 */
			loadCSS: function(url) {
				var self = this, doc = self.doc, head;
	
				// Prevent inline from loading the same CSS file twice
				if (self !== DOMUtils.DOM && doc === document) {
					DOMUtils.DOM.loadCSS(url);
					return;
				}
	
				if (!url) {
					url = '';
				}
	
				head = doc.getElementsByTagName('head')[0];
	
				each(url.split(','), function(url) {
					var link;
	
					url = Tools._addCacheSuffix(url);
	
					if (self.files[url]) {
						return;
					}
	
					self.files[url] = true;
					link = self.create('link', {rel: 'stylesheet', href: url});
	
					// IE 8 has a bug where dynamically loading stylesheets would produce a 1 item remaining bug
					// This fix seems to resolve that issue by recalcing the document once a stylesheet finishes loading
					// It's ugly but it seems to work fine.
					if (isIE && doc.documentMode && doc.recalc) {
						link.onload = function() {
							if (doc.recalc) {
								doc.recalc();
							}
	
							link.onload = null;
						};
					}
	
					head.appendChild(link);
				});
			},
	
			/**
			 * Adds a class to the specified element or elements.
			 *
			 * @method addClass
			 * @param {String/Element/Array} elm Element ID string or DOM element or array with elements or IDs.
			 * @param {String} cls Class name to add to each element.
			 * @return {String/Array} String with new class value or array with new class values for all elements.
			 * @example
			 * // Adds a class to all paragraphs in the active editor
			 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'myclass');
			 *
			 * // Adds a class to a specific element in the current page
			 * tinymce.DOM.addClass('mydiv', 'myclass');
			 */
			addClass: function(elm, cls) {
				this.$$(elm).addClass(cls);
			},
	
			/**
			 * Removes a class from the specified element or elements.
			 *
			 * @method removeClass
			 * @param {String/Element/Array} elm Element ID string or DOM element or array with elements or IDs.
			 * @param {String} cls Class name to remove from each element.
			 * @return {String/Array} String of remaining class name(s), or an array of strings if multiple input elements
			 * were passed in.
			 * @example
			 * // Removes a class from all paragraphs in the active editor
			 * tinymce.activeEditor.dom.removeClass(tinymce.activeEditor.dom.select('p'), 'myclass');
			 *
			 * // Removes a class from a specific element in the current page
			 * tinymce.DOM.removeClass('mydiv', 'myclass');
			 */
			removeClass: function(elm, cls) {
				this.toggleClass(elm, cls, false);
			},
	
			/**
			 * Returns true if the specified element has the specified class.
			 *
			 * @method hasClass
			 * @param {String/Element} elm HTML element or element id string to check CSS class on.
			 * @param {String} cls CSS class to check for.
			 * @return {Boolean} true/false if the specified element has the specified class.
			 */
			hasClass: function(elm, cls) {
				return this.$$(elm).hasClass(cls);
			},
	
			/**
			 * Toggles the specified class on/off.
			 *
			 * @method toggleClass
			 * @param {Element} elm Element to toggle class on.
			 * @param {[type]} cls Class to toggle on/off.
			 * @param {[type]} state Optional state to set.
			 */
			toggleClass: function(elm, cls, state) {
				this.$$(elm).toggleClass(cls, state).each(function() {
					if (this.className === '') {
						$(this).attr('class', null);
					}
				});
			},
	
			/**
			 * Shows the specified element(s) by ID by setting the "display" style.
			 *
			 * @method show
			 * @param {String/Element/Array} elm ID of DOM element or DOM element or array with elements or IDs to show.
			 */
			show: function(elm) {
				this.$$(elm).show();
			},
	
			/**
			 * Hides the specified element(s) by ID by setting the "display" style.
			 *
			 * @method hide
			 * @param {String/Element/Array} elm ID of DOM element or DOM element or array with elements or IDs to hide.
			 * @example
			 * // Hides an element by id in the document
			 * tinymce.DOM.hide('myid');
			 */
			hide: function(elm) {
				this.$$(elm).hide();
			},
	
			/**
			 * Returns true/false if the element is hidden or not by checking the "display" style.
			 *
			 * @method isHidden
			 * @param {String/Element} elm Id or element to check display state on.
			 * @return {Boolean} true/false if the element is hidden or not.
			 */
			isHidden: function(elm) {
				return this.$$(elm).css('display') == 'none';
			},
	
			/**
			 * Returns a unique id. This can be useful when generating elements on the fly.
			 * This method will not check if the element already exists.
			 *
			 * @method uniqueId
			 * @param {String} prefix Optional prefix to add in front of all ids - defaults to "mce_".
			 * @return {String} Unique id.
			 */
			uniqueId: function(prefix) {
				return (!prefix ? 'mce_' : prefix) + (this.counter++);
			},
	
			/**
			 * Sets the specified HTML content inside the element or elements. The HTML will first be processed. This means
			 * URLs will get converted, hex color values fixed etc. Check processHTML for details.
			 *
			 * @method setHTML
			 * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set HTML inside of.
			 * @param {String} html HTML content to set as inner HTML of the element.
			 * @example
			 * // Sets the inner HTML of all paragraphs in the active editor
			 * tinymce.activeEditor.dom.setHTML(tinymce.activeEditor.dom.select('p'), 'some inner html');
			 *
			 * // Sets the inner HTML of an element by id in the document
			 * tinymce.DOM.setHTML('mydiv', 'some inner html');
			 */
			setHTML: function(elm, html) {
				elm = this.$$(elm);
	
				if (isIE) {
					elm.each(function(i, target) {
						if (target.canHaveHTML === false) {
							return;
						}
	
						// Remove all child nodes, IE keeps empty text nodes in DOM
						while (target.firstChild) {
							target.removeChild(target.firstChild);
						}
	
						try {
							// IE will remove comments from the beginning
							// unless you padd the contents with something
							target.innerHTML = '<br>' + html;
							target.removeChild(target.firstChild);
						} catch (ex) {
							// IE sometimes produces an unknown runtime error on innerHTML if it's a div inside a p
							$('<div>').html('<br>' + html).contents().slice(1).appendTo(target);
						}
	
						return html;
					});
				} else {
					elm.html(html);
				}
			},
	
			/**
			 * Returns the outer HTML of an element.
			 *
			 * @method getOuterHTML
			 * @param {String/Element} elm Element ID or element object to get outer HTML from.
			 * @return {String} Outer HTML string.
			 * @example
			 * tinymce.DOM.getOuterHTML(editorElement);
			 * tinymce.activeEditor.getOuterHTML(tinymce.activeEditor.getBody());
			 */
			getOuterHTML: function(elm) {
				elm = this.get(elm);
	
				// Older FF doesn't have outerHTML 3.6 is still used by some orgaizations
				return elm.nodeType == 1 && "outerHTML" in elm ? elm.outerHTML : $('<div>').append($(elm).clone()).html();
			},
	
			/**
			 * Sets the specified outer HTML on an element or elements.
			 *
			 * @method setOuterHTML
			 * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set outer HTML on.
			 * @param {Object} html HTML code to set as outer value for the element.
			 * @example
			 * // Sets the outer HTML of all paragraphs in the active editor
			 * tinymce.activeEditor.dom.setOuterHTML(tinymce.activeEditor.dom.select('p'), '<div>some html</div>');
			 *
			 * // Sets the outer HTML of an element by id in the document
			 * tinymce.DOM.setOuterHTML('mydiv', '<div>some html</div>');
			 */
			setOuterHTML: function(elm, html) {
				var self = this;
	
				self.$$(elm).each(function() {
					try {
						// Older FF doesn't have outerHTML 3.6 is still used by some organizations
						if ("outerHTML" in this) {
							this.outerHTML = html;
							return;
						}
					} catch (ex) {
						// Ignore
					}
	
					// OuterHTML for IE it sometimes produces an "unknown runtime error"
					self.remove($(this).html(html), true);
				});
			},
	
			/**
			 * Entity decodes a string. This method decodes any HTML entities, such as &aring;.
			 *
			 * @method decode
			 * @param {String} s String to decode entities on.
			 * @return {String} Entity decoded string.
			 */
			decode: Entities.decode,
	
			/**
			 * Entity encodes a string. This method encodes the most common entities, such as <>"&.
			 *
			 * @method encode
			 * @param {String} text String to encode with entities.
			 * @return {String} Entity encoded string.
			 */
			encode: Entities.encodeAllRaw,
	
			/**
			 * Inserts an element after the reference element.
			 *
			 * @method insertAfter
			 * @param {Element} node Element to insert after the reference.
			 * @param {Element/String/Array} referenceNode Reference element, element id or array of elements to insert after.
			 * @return {Element/Array} Element that got added or an array with elements.
			 */
			insertAfter: function(node, referenceNode) {
				referenceNode = this.get(referenceNode);
	
				return this.run(node, function(node) {
					var parent, nextSibling;
	
					parent = referenceNode.parentNode;
					nextSibling = referenceNode.nextSibling;
	
					if (nextSibling) {
						parent.insertBefore(node, nextSibling);
					} else {
						parent.appendChild(node);
					}
	
					return node;
				});
			},
	
			/**
			 * Replaces the specified element or elements with the new element specified. The new element will
			 * be cloned if multiple input elements are passed in.
			 *
			 * @method replace
			 * @param {Element} newElm New element to replace old ones with.
			 * @param {Element/String/Array} oldElm Element DOM node, element id or array of elements or ids to replace.
			 * @param {Boolean} keepChildren Optional keep children state, if set to true child nodes from the old object will be added
			 * to new ones.
			 */
			replace: function(newElm, oldElm, keepChildren) {
				var self = this;
	
				return self.run(oldElm, function(oldElm) {
					if (is(oldElm, 'array')) {
						newElm = newElm.cloneNode(true);
					}
	
					if (keepChildren) {
						each(grep(oldElm.childNodes), function(node) {
							newElm.appendChild(node);
						});
					}
	
					return oldElm.parentNode.replaceChild(newElm, oldElm);
				});
			},
	
			/**
			 * Renames the specified element and keeps its attributes and children.
			 *
			 * @method rename
			 * @param {Element} elm Element to rename.
			 * @param {String} name Name of the new element.
			 * @return {Element} New element or the old element if it needed renaming.
			 */
			rename: function(elm, name) {
				var self = this, newElm;
	
				if (elm.nodeName != name.toUpperCase()) {
					// Rename block element
					newElm = self.create(name);
	
					// Copy attribs to new block
					each(self.getAttribs(elm), function(attrNode) {
						self.setAttrib(newElm, attrNode.nodeName, self.getAttrib(elm, attrNode.nodeName));
					});
	
					// Replace block
					self.replace(newElm, elm, 1);
				}
	
				return newElm || elm;
			},
	
			/**
			 * Find the common ancestor of two elements. This is a shorter method than using the DOM Range logic.
			 *
			 * @method findCommonAncestor
			 * @param {Element} a Element to find common ancestor of.
			 * @param {Element} b Element to find common ancestor of.
			 * @return {Element} Common ancestor element of the two input elements.
			 */
			findCommonAncestor: function(a, b) {
				var ps = a, pe;
	
				while (ps) {
					pe = b;
	
					while (pe && ps != pe) {
						pe = pe.parentNode;
					}
	
					if (ps == pe) {
						break;
					}
	
					ps = ps.parentNode;
				}
	
				if (!ps && a.ownerDocument) {
					return a.ownerDocument.documentElement;
				}
	
				return ps;
			},
	
			/**
			 * Parses the specified RGB color value and returns a hex version of that color.
			 *
			 * @method toHex
			 * @param {String} rgbVal RGB string value like rgb(1,2,3)
			 * @return {String} Hex version of that RGB value like #FF00FF.
			 */
			toHex: function(rgbVal) {
				return this.styles.toHex(Tools.trim(rgbVal));
			},
	
			/**
			 * Executes the specified function on the element by id or dom element node or array of elements/id.
			 *
			 * @method run
			 * @param {String/Element/Array} elm ID or DOM element object or array with ids or elements.
			 * @param {function} func Function to execute for each item.
			 * @param {Object} scope Optional scope to execute the function in.
			 * @return {Object/Array} Single object, or an array of objects if multiple input elements were passed in.
			 */
			run: function(elm, func, scope) {
				var self = this, result;
	
				if (typeof elm === 'string') {
					elm = self.get(elm);
				}
	
				if (!elm) {
					return false;
				}
	
				scope = scope || this;
				if (!elm.nodeType && (elm.length || elm.length === 0)) {
					result = [];
	
					each(elm, function(elm, i) {
						if (elm) {
							if (typeof elm == 'string') {
								elm = self.get(elm);
							}
	
							result.push(func.call(scope, elm, i));
						}
					});
	
					return result;
				}
	
				return func.call(scope, elm);
			},
	
			/**
			 * Returns a NodeList with attributes for the element.
			 *
			 * @method getAttribs
			 * @param {HTMLElement/string} elm Element node or string id to get attributes from.
			 * @return {NodeList} NodeList with attributes.
			 */
			getAttribs: function(elm) {
				var attrs;
	
				elm = this.get(elm);
	
				if (!elm) {
					return [];
				}
	
				if (isIE) {
					attrs = [];
	
					// Object will throw exception in IE
					if (elm.nodeName == 'OBJECT') {
						return elm.attributes;
					}
	
					// IE doesn't keep the selected attribute if you clone option elements
					if (elm.nodeName === 'OPTION' && this.getAttrib(elm, 'selected')) {
						attrs.push({specified: 1, nodeName: 'selected'});
					}
	
					// It's crazy that this is faster in IE but it's because it returns all attributes all the time
					var attrRegExp = /<\/?[\w:\-]+ ?|=[\"][^\"]+\"|=\'[^\']+\'|=[\w\-]+|>/gi;
					elm.cloneNode(false).outerHTML.replace(attrRegExp, '').replace(/[\w:\-]+/gi, function(a) {
						attrs.push({specified: 1, nodeName: a});
					});
	
					return attrs;
				}
	
				return elm.attributes;
			},
	
			/**
			 * Returns true/false if the specified node is to be considered empty or not.
			 *
			 * @example
			 * tinymce.DOM.isEmpty(node, {img: true});
			 * @method isEmpty
			 * @param {Object} elements Optional name/value object with elements that are automatically treated as non-empty elements.
			 * @return {Boolean} true/false if the node is empty or not.
			 */
			isEmpty: function(node, elements) {
				var self = this, i, attributes, type, walker, name, brCount = 0;
	
				node = node.firstChild;
				if (node) {
					walker = new TreeWalker(node, node.parentNode);
					elements = elements || (self.schema ? self.schema.getNonEmptyElements() : null);
	
					do {
						type = node.nodeType;
	
						if (type === 1) {
							// Ignore bogus elements
							if (node.getAttribute('data-mce-bogus')) {
								continue;
							}
	
							// Keep empty elements like <img />
							name = node.nodeName.toLowerCase();
							if (elements && elements[name]) {
								// Ignore single BR elements in blocks like <p><br /></p> or <p><span><br /></span></p>
								if (name === 'br') {
									brCount++;
									continue;
								}
	
								return false;
							}
	
							// Keep elements with data-bookmark attributes or name attribute like <a name="1"></a>
							attributes = self.getAttribs(node);
							i = attributes.length;
							while (i--) {
								name = attributes[i].nodeName;
								if (name === "name" || name === 'data-mce-bookmark') {
									return false;
								}
							}
						}
	
						// Keep comment nodes
						if (type == 8) {
							return false;
						}
	
						// Keep non whitespace text nodes
						if ((type === 3 && !whiteSpaceRegExp.test(node.nodeValue))) {
							return false;
						}
					} while ((node = walker.next()));
				}
	
				return brCount <= 1;
			},
	
			/**
			 * Creates a new DOM Range object. This will use the native DOM Range API if it's
			 * available. If it's not, it will fall back to the custom TinyMCE implementation.
			 *
			 * @method createRng
			 * @return {DOMRange} DOM Range object.
			 * @example
			 * var rng = tinymce.DOM.createRng();
			 * alert(rng.startContainer + "," + rng.startOffset);
			 */
			createRng: function() {
				var doc = this.doc;
	
				return doc.createRange ? doc.createRange() : new Range(this);
			},
	
			/**
			 * Returns the index of the specified node within its parent.
			 *
			 * @method nodeIndex
			 * @param {Node} node Node to look for.
			 * @param {boolean} normalized Optional true/false state if the index is what it would be after a normalization.
			 * @return {Number} Index of the specified node.
			 */
			nodeIndex: nodeIndex,
	
			/**
			 * Splits an element into two new elements and places the specified split
			 * element or elements between the new ones. For example splitting the paragraph at the bold element in
			 * this example <p>abc<b>abc</b>123</p> would produce <p>abc</p><b>abc</b><p>123</p>.
			 *
			 * @method split
			 * @param {Element} parentElm Parent element to split.
			 * @param {Element} splitElm Element to split at.
			 * @param {Element} replacementElm Optional replacement element to replace the split element with.
			 * @return {Element} Returns the split element or the replacement element if that is specified.
			 */
			split: function(parentElm, splitElm, replacementElm) {
				var self = this, r = self.createRng(), bef, aft, pa;
	
				// W3C valid browsers tend to leave empty nodes to the left/right side of the contents - this makes sense
				// but we don't want that in our code since it serves no purpose for the end user
				// For example splitting this html at the bold element:
				//   <p>text 1<span><b>CHOP</b></span>text 2</p>
				// would produce:
				//   <p>text 1<span></span></p><b>CHOP</b><p><span></span>text 2</p>
				// this function will then trim off empty edges and produce:
				//   <p>text 1</p><b>CHOP</b><p>text 2</p>
				function trimNode(node) {
					var i, children = node.childNodes, type = node.nodeType;
	
					function surroundedBySpans(node) {
						var previousIsSpan = node.previousSibling && node.previousSibling.nodeName == 'SPAN';
						var nextIsSpan = node.nextSibling && node.nextSibling.nodeName == 'SPAN';
						return previousIsSpan && nextIsSpan;
					}
	
					if (type == 1 && node.getAttribute('data-mce-type') == 'bookmark') {
						return;
					}
	
					for (i = children.length - 1; i >= 0; i--) {
						trimNode(children[i]);
					}
	
					if (type != 9) {
						// Keep non whitespace text nodes
						if (type == 3 && node.nodeValue.length > 0) {
							// If parent element isn't a block or there isn't any useful contents for example "<p>   </p>"
							// Also keep text nodes with only spaces if surrounded by spans.
							// eg. "<p><span>a</span> <span>b</span></p>" should keep space between a and b
							var trimmedLength = trim(node.nodeValue).length;
							if (!self.isBlock(node.parentNode) || trimmedLength > 0 || trimmedLength === 0 && surroundedBySpans(node)) {
								return;
							}
						} else if (type == 1) {
							// If the only child is a bookmark then move it up
							children = node.childNodes;
	
							// TODO fix this complex if
							if (children.length == 1 && children[0] && children[0].nodeType == 1 &&
								children[0].getAttribute('data-mce-type') == 'bookmark') {
								node.parentNode.insertBefore(children[0], node);
							}
	
							// Keep non empty elements or img, hr etc
							if (children.length || /^(br|hr|input|img)$/i.test(node.nodeName)) {
								return;
							}
						}
	
						self.remove(node);
					}
	
					return node;
				}
	
				if (parentElm && splitElm) {
					// Get before chunk
					r.setStart(parentElm.parentNode, self.nodeIndex(parentElm));
					r.setEnd(splitElm.parentNode, self.nodeIndex(splitElm));
					bef = r.extractContents();
	
					// Get after chunk
					r = self.createRng();
					r.setStart(splitElm.parentNode, self.nodeIndex(splitElm) + 1);
					r.setEnd(parentElm.parentNode, self.nodeIndex(parentElm) + 1);
					aft = r.extractContents();
	
					// Insert before chunk
					pa = parentElm.parentNode;
					pa.insertBefore(trimNode(bef), parentElm);
	
					// Insert middle chunk
					if (replacementElm) {
						pa.insertBefore(replacementElm, parentElm);
						//pa.replaceChild(replacementElm, splitElm);
					} else {
						pa.insertBefore(splitElm, parentElm);
					}
	
					// Insert after chunk
					pa.insertBefore(trimNode(aft), parentElm);
					self.remove(parentElm);
	
					return replacementElm || splitElm;
				}
			},
	
			/**
			 * Adds an event handler to the specified object.
			 *
			 * @method bind
			 * @param {Element/Document/Window/Array} target Target element to bind events to.
			 * handler to or an array of elements/ids/documents.
			 * @param {String} name Name of event handler to add, for example: click.
			 * @param {function} func Function to execute when the event occurs.
			 * @param {Object} scope Optional scope to execute the function in.
			 * @return {function} Function callback handler the same as the one passed in.
			 */
			bind: function(target, name, func, scope) {
				var self = this;
	
				if (Tools.isArray(target)) {
					var i = target.length;
	
					while (i--) {
						target[i] = self.bind(target[i], name, func, scope);
					}
	
					return target;
				}
	
				// Collect all window/document events bound by editor instance
				if (self.settings.collect && (target === self.doc || target === self.win)) {
					self.boundEvents.push([target, name, func, scope]);
				}
	
				return self.events.bind(target, name, func, scope || self);
			},
	
			/**
			 * Removes the specified event handler by name and function from an element or collection of elements.
			 *
			 * @method unbind
			 * @param {Element/Document/Window/Array} target Target element to unbind events on.
			 * @param {String} name Event handler name, for example: "click"
			 * @param {function} func Function to remove.
			 * @return {bool/Array} Bool state of true if the handler was removed, or an array of states if multiple input elements
			 * were passed in.
			 */
			unbind: function(target, name, func) {
				var self = this, i;
	
				if (Tools.isArray(target)) {
					i = target.length;
	
					while (i--) {
						target[i] = self.unbind(target[i], name, func);
					}
	
					return target;
				}
	
				// Remove any bound events matching the input
				if (self.boundEvents && (target === self.doc || target === self.win)) {
					i = self.boundEvents.length;
	
					while (i--) {
						var item = self.boundEvents[i];
	
						if (target == item[0] && (!name || name == item[1]) && (!func || func == item[2])) {
							this.events.unbind(item[0], item[1], item[2]);
						}
					}
				}
	
				return this.events.unbind(target, name, func);
			},
	
			/**
			 * Fires the specified event name with object on target.
			 *
			 * @method fire
			 * @param {Node/Document/Window} target Target element or object to fire event on.
			 * @param {String} name Name of the event to fire.
			 * @param {Object} evt Event object to send.
			 * @return {Event} Event object.
			 */
			fire: function(target, name, evt) {
				return this.events.fire(target, name, evt);
			},
	
			// Returns the content editable state of a node
			getContentEditable: function(node) {
				var contentEditable;
	
				// Check type
				if (!node || node.nodeType != 1) {
					return null;
				}
	
				// Check for fake content editable
				contentEditable = node.getAttribute("data-mce-contenteditable");
				if (contentEditable && contentEditable !== "inherit") {
					return contentEditable;
				}
	
				// Check for real content editable
				return node.contentEditable !== "inherit" ? node.contentEditable : null;
			},
	
			getContentEditableParent: function(node) {
				var root = this.getRoot(), state = null;
	
				for (; node && node !== root; node = node.parentNode) {
					state = this.getContentEditable(node);
	
					if (state !== null) {
						break;
					}
				}
	
				return state;
			},
	
			/**
			 * Destroys all internal references to the DOM to solve IE leak issues.
			 *
			 * @method destroy
			 */
			destroy: function() {
				var self = this;
	
				// Unbind all events bound to window/document by editor instance
				if (self.boundEvents) {
					var i = self.boundEvents.length;
	
					while (i--) {
						var item = self.boundEvents[i];
						this.events.unbind(item[0], item[1], item[2]);
					}
	
					self.boundEvents = null;
				}
	
				// Restore sizzle document to window.document
				// Since the current document might be removed producing "Permission denied" on IE see #6325
				if (Sizzle.setDocument) {
					Sizzle.setDocument();
				}
	
				self.win = self.doc = self.root = self.events = self.frag = null;
			},
	
			isChildOf: function(node, parent) {
				while (node) {
					if (parent === node) {
						return true;
					}
	
					node = node.parentNode;
				}
	
				return false;
			},
	
			// #ifdef debug
	
			dumpRng: function(r) {
				return (
					'startContainer: ' + r.startContainer.nodeName +
					', startOffset: ' + r.startOffset +
					', endContainer: ' + r.endContainer.nodeName +
					', endOffset: ' + r.endOffset
				);
			},
	
			// #endif
	
			_findSib: function(node, selector, name) {
				var self = this, func = selector;
	
				if (node) {
					// If expression make a function of it using is
					if (typeof func == 'string') {
						func = function(node) {
							return self.is(node, selector);
						};
					}
	
					// Loop all siblings
					for (node = node[name]; node; node = node[name]) {
						if (func(node)) {
							return node;
						}
					}
				}
	
				return null;
			}
		};
	
		/**
		 * Instance of DOMUtils for the current document.
		 *
		 * @static
		 * @property DOM
		 * @type tinymce.dom.DOMUtils
		 * @example
		 * // Example of how to add a class to some element by id
		 * tinymce.DOM.addClass('someid', 'someclass');
		 */
		DOMUtils.DOM = new DOMUtils(document);
		DOMUtils.nodeIndex = nodeIndex;
	
		return DOMUtils;
	});
	
	// Included from: js/tinymce/classes/dom/ScriptLoader.js
	
	/**
	 * ScriptLoader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*globals console*/
	
	/**
	 * This class handles asynchronous/synchronous loading of JavaScript files it will execute callbacks
	 * when various items gets loaded. This class is useful to load external JavaScript files.
	 *
	 * @class tinymce.dom.ScriptLoader
	 * @example
	 * // Load a script from a specific URL using the global script loader
	 * tinymce.ScriptLoader.load('somescript.js');
	 *
	 * // Load a script using a unique instance of the script loader
	 * var scriptLoader = new tinymce.dom.ScriptLoader();
	 *
	 * scriptLoader.load('somescript.js');
	 *
	 * // Load multiple scripts
	 * var scriptLoader = new tinymce.dom.ScriptLoader();
	 *
	 * scriptLoader.add('somescript1.js');
	 * scriptLoader.add('somescript2.js');
	 * scriptLoader.add('somescript3.js');
	 *
	 * scriptLoader.loadQueue(function() {
	 *    alert('All scripts are now loaded.');
	 * });
	 */
	define("tinymce/dom/ScriptLoader", [
		"tinymce/dom/DOMUtils",
		"tinymce/util/Tools"
	], function(DOMUtils, Tools) {
		var DOM = DOMUtils.DOM;
		var each = Tools.each, grep = Tools.grep;
	
		function ScriptLoader() {
			var QUEUED = 0,
				LOADING = 1,
				LOADED = 2,
				states = {},
				queue = [],
				scriptLoadedCallbacks = {},
				queueLoadedCallbacks = [],
				loading = 0,
				undef;
	
			/**
			 * Loads a specific script directly without adding it to the load queue.
			 *
			 * @method load
			 * @param {String} url Absolute URL to script to add.
			 * @param {function} callback Optional callback function to execute ones this script gets loaded.
			 */
			function loadScript(url, callback) {
				var dom = DOM, elm, id;
	
				// Execute callback when script is loaded
				function done() {
					dom.remove(id);
	
					if (elm) {
						elm.onreadystatechange = elm.onload = elm = null;
					}
	
					callback();
				}
	
				function error() {
					/*eslint no-console:0 */
	
					// Report the error so it's easier for people to spot loading errors
					if (typeof console !== "undefined" && console.log) {
						console.log("Failed to load: " + url);
					}
	
					// We can't mark it as done if there is a load error since
					// A) We don't want to produce 404 errors on the server and
					// B) the onerror event won't fire on all browsers.
					// done();
				}
	
				id = dom.uniqueId();
	
				// Create new script element
				elm = document.createElement('script');
				elm.id = id;
				elm.type = 'text/javascript';
				elm.src = Tools._addCacheSuffix(url);
	
				// Seems that onreadystatechange works better on IE 10 onload seems to fire incorrectly
				if ("onreadystatechange" in elm) {
					elm.onreadystatechange = function() {
						if (/loaded|complete/.test(elm.readyState)) {
							done();
						}
					};
				} else {
					elm.onload = done;
				}
	
				// Add onerror event will get fired on some browsers but not all of them
				elm.onerror = error;
	
				// Add script to document
				(document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
			}
	
			/**
			 * Returns true/false if a script has been loaded or not.
			 *
			 * @method isDone
			 * @param {String} url URL to check for.
			 * @return {Boolean} true/false if the URL is loaded.
			 */
			this.isDone = function(url) {
				return states[url] == LOADED;
			};
	
			/**
			 * Marks a specific script to be loaded. This can be useful if a script got loaded outside
			 * the script loader or to skip it from loading some script.
			 *
			 * @method markDone
			 * @param {string} url Absolute URL to the script to mark as loaded.
			 */
			this.markDone = function(url) {
				states[url] = LOADED;
			};
	
			/**
			 * Adds a specific script to the load queue of the script loader.
			 *
			 * @method add
			 * @param {String} url Absolute URL to script to add.
			 * @param {function} callback Optional callback function to execute ones this script gets loaded.
			 * @param {Object} scope Optional scope to execute callback in.
			 */
			this.add = this.load = function(url, callback, scope) {
				var state = states[url];
	
				// Add url to load queue
				if (state == undef) {
					queue.push(url);
					states[url] = QUEUED;
				}
	
				if (callback) {
					// Store away callback for later execution
					if (!scriptLoadedCallbacks[url]) {
						scriptLoadedCallbacks[url] = [];
					}
	
					scriptLoadedCallbacks[url].push({
						func: callback,
						scope: scope || this
					});
				}
			};
	
			this.remove = function(url) {
				delete states[url];
				delete scriptLoadedCallbacks[url];
			};
	
			/**
			 * Starts the loading of the queue.
			 *
			 * @method loadQueue
			 * @param {function} callback Optional callback to execute when all queued items are loaded.
			 * @param {Object} scope Optional scope to execute the callback in.
			 */
			this.loadQueue = function(callback, scope) {
				this.loadScripts(queue, callback, scope);
			};
	
			/**
			 * Loads the specified queue of files and executes the callback ones they are loaded.
			 * This method is generally not used outside this class but it might be useful in some scenarios.
			 *
			 * @method loadScripts
			 * @param {Array} scripts Array of queue items to load.
			 * @param {function} callback Optional callback to execute ones all items are loaded.
			 * @param {Object} scope Optional scope to execute callback in.
			 */
			this.loadScripts = function(scripts, callback, scope) {
				var loadScripts;
	
				function execScriptLoadedCallbacks(url) {
					// Execute URL callback functions
					each(scriptLoadedCallbacks[url], function(callback) {
						callback.func.call(callback.scope);
					});
	
					scriptLoadedCallbacks[url] = undef;
				}
	
				queueLoadedCallbacks.push({
					func: callback,
					scope: scope || this
				});
	
				loadScripts = function() {
					var loadingScripts = grep(scripts);
	
					// Current scripts has been handled
					scripts.length = 0;
	
					// Load scripts that needs to be loaded
					each(loadingScripts, function(url) {
						// Script is already loaded then execute script callbacks directly
						if (states[url] == LOADED) {
							execScriptLoadedCallbacks(url);
							return;
						}
	
						// Is script not loading then start loading it
						if (states[url] != LOADING) {
							states[url] = LOADING;
							loading++;
	
							loadScript(url, function() {
								states[url] = LOADED;
								loading--;
	
								execScriptLoadedCallbacks(url);
	
								// Load more scripts if they where added by the recently loaded script
								loadScripts();
							});
						}
					});
	
					// No scripts are currently loading then execute all pending queue loaded callbacks
					if (!loading) {
						each(queueLoadedCallbacks, function(callback) {
							callback.func.call(callback.scope);
						});
	
						queueLoadedCallbacks.length = 0;
					}
				};
	
				loadScripts();
			};
		}
	
		ScriptLoader.ScriptLoader = new ScriptLoader();
	
		return ScriptLoader;
	});
	
	// Included from: js/tinymce/classes/AddOnManager.js
	
	/**
	 * AddOnManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the loading of themes/plugins or other add-ons and their language packs.
	 *
	 * @class tinymce.AddOnManager
	 */
	define("tinymce/AddOnManager", [
		"tinymce/dom/ScriptLoader",
		"tinymce/util/Tools"
	], function(ScriptLoader, Tools) {
		var each = Tools.each;
	
		function AddOnManager() {
			var self = this;
	
			self.items = [];
			self.urls = {};
			self.lookup = {};
		}
	
		AddOnManager.prototype = {
			/**
			 * Returns the specified add on by the short name.
			 *
			 * @method get
			 * @param {String} name Add-on to look for.
			 * @return {tinymce.Theme/tinymce.Plugin} Theme or plugin add-on instance or undefined.
			 */
			get: function(name) {
				if (this.lookup[name]) {
					return this.lookup[name].instance;
				}
	
				return undefined;
			},
	
			dependencies: function(name) {
				var result;
	
				if (this.lookup[name]) {
					result = this.lookup[name].dependencies;
				}
	
				return result || [];
			},
	
			/**
			 * Loads a language pack for the specified add-on.
			 *
			 * @method requireLangPack
			 * @param {String} name Short name of the add-on.
			 * @param {String} languages Optional comma or space separated list of languages to check if it matches the name.
			 */
			requireLangPack: function(name, languages) {
				var language = AddOnManager.language;
	
				if (language && AddOnManager.languageLoad !== false) {
					if (languages) {
						languages = ',' + languages + ',';
	
						// Load short form sv.js or long form sv_SE.js
						if (languages.indexOf(',' + language.substr(0, 2) + ',') != -1) {
							language = language.substr(0, 2);
						} else if (languages.indexOf(',' + language + ',') == -1) {
							return;
						}
					}
	
					ScriptLoader.ScriptLoader.add(this.urls[name] + '/langs/' + language + '.js');
				}
			},
	
			/**
			 * Adds a instance of the add-on by it's short name.
			 *
			 * @method add
			 * @param {String} id Short name/id for the add-on.
			 * @param {tinymce.Theme/tinymce.Plugin} addOn Theme or plugin to add.
			 * @return {tinymce.Theme/tinymce.Plugin} The same theme or plugin instance that got passed in.
			 * @example
			 * // Create a simple plugin
			 * tinymce.create('tinymce.plugins.TestPlugin', {
			 *   TestPlugin: function(ed, url) {
			 *   ed.on('click', function(e) {
			 *      ed.windowManager.alert('Hello World!');
			 *   });
			 *   }
			 * });
			 *
			 * // Register plugin using the add method
			 * tinymce.PluginManager.add('test', tinymce.plugins.TestPlugin);
			 *
			 * // Initialize TinyMCE
			 * tinymce.init({
			 *  ...
			 *  plugins: '-test' // Init the plugin but don't try to load it
			 * });
			 */
			add: function(id, addOn, dependencies) {
				this.items.push(addOn);
				this.lookup[id] = {instance: addOn, dependencies: dependencies};
	
				return addOn;
			},
	
			remove: function(name) {
				delete this.urls[name];
				delete this.lookup[name];
			},
	
			createUrl: function(baseUrl, dep) {
				if (typeof dep === "object") {
					return dep;
				}
	
				return {prefix: baseUrl.prefix, resource: dep, suffix: baseUrl.suffix};
			},
	
			/**
			 * Add a set of components that will make up the add-on. Using the url of the add-on name as the base url.
			 * This should be used in development mode.  A new compressor/javascript munger process will ensure that the
			 * components are put together into the plugin.js file and compressed correctly.
			 *
			 * @method addComponents
			 * @param {String} pluginName name of the plugin to load scripts from (will be used to get the base url for the plugins).
			 * @param {Array} scripts Array containing the names of the scripts to load.
			 */
			addComponents: function(pluginName, scripts) {
				var pluginUrl = this.urls[pluginName];
	
				each(scripts, function(script) {
					ScriptLoader.ScriptLoader.add(pluginUrl + "/" + script);
				});
			},
	
			/**
			 * Loads an add-on from a specific url.
			 *
			 * @method load
			 * @param {String} name Short name of the add-on that gets loaded.
			 * @param {String} addOnUrl URL to the add-on that will get loaded.
			 * @param {function} callback Optional callback to execute ones the add-on is loaded.
			 * @param {Object} scope Optional scope to execute the callback in.
			 * @example
			 * // Loads a plugin from an external URL
			 * tinymce.PluginManager.load('myplugin', '/some/dir/someplugin/plugin.js');
			 *
			 * // Initialize TinyMCE
			 * tinymce.init({
			 *  ...
			 *  plugins: '-myplugin' // Don't try to load it again
			 * });
			 */
			load: function(name, addOnUrl, callback, scope) {
				var self = this, url = addOnUrl;
	
				function loadDependencies() {
					var dependencies = self.dependencies(name);
	
					each(dependencies, function(dep) {
						var newUrl = self.createUrl(addOnUrl, dep);
	
						self.load(newUrl.resource, newUrl, undefined, undefined);
					});
	
					if (callback) {
						if (scope) {
							callback.call(scope);
						} else {
							callback.call(ScriptLoader);
						}
					}
				}
	
				if (self.urls[name]) {
					return;
				}
	
				if (typeof addOnUrl === "object") {
					url = addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
				}
	
				if (url.indexOf('/') !== 0 && url.indexOf('://') == -1) {
					url = AddOnManager.baseURL + '/' + url;
				}
	
				self.urls[name] = url.substring(0, url.lastIndexOf('/'));
	
				if (self.lookup[name]) {
					loadDependencies();
				} else {
					ScriptLoader.ScriptLoader.add(url, loadDependencies, scope);
				}
			}
		};
	
		AddOnManager.PluginManager = new AddOnManager();
		AddOnManager.ThemeManager = new AddOnManager();
	
		return AddOnManager;
	});
	
	/**
	 * TinyMCE theme class.
	 *
	 * @class tinymce.Theme
	 */
	
	/**
	 * This method is responsible for rendering/generating the overall user interface with toolbars, buttons, iframe containers etc.
	 *
	 * @method renderUI
	 * @param {Object} obj Object parameter containing the targetNode DOM node that will be replaced visually with an editor instance.
	 * @return {Object} an object with items like iframeContainer, editorContainer, sizeContainer, deltaWidth, deltaHeight.
	 */
	
	/**
	 * Plugin base class, this is a pseudo class that describes how a plugin is to be created for TinyMCE. The methods below are all optional.
	 *
	 * @class tinymce.Plugin
	 * @example
	 * tinymce.PluginManager.add('example', function(editor, url) {
	 *     // Add a button that opens a window
	 *     editor.addButton('example', {
	 *         text: 'My button',
	 *         icon: false,
	 *         onclick: function() {
	 *             // Open window
	 *             editor.windowManager.open({
	 *                 title: 'Example plugin',
	 *                 body: [
	 *                     {type: 'textbox', name: 'title', label: 'Title'}
	 *                 ],
	 *                 onsubmit: function(e) {
	 *                     // Insert content when the window form is submitted
	 *                     editor.insertContent('Title: ' + e.data.title);
	 *                 }
	 *             });
	 *         }
	 *     });
	 *
	 *     // Adds a menu item to the tools menu
	 *     editor.addMenuItem('example', {
	 *         text: 'Example plugin',
	 *         context: 'tools',
	 *         onclick: function() {
	 *             // Open window with a specific url
	 *             editor.windowManager.open({
	 *                 title: 'TinyMCE site',
	 *                 url: 'http://www.tinymce.com',
	 *                 width: 800,
	 *                 height: 600,
	 *                 buttons: [{
	 *                     text: 'Close',
	 *                     onclick: 'close'
	 *                 }]
	 *             });
	 *         }
	 *     });
	 * });
	 */
	
	// Included from: js/tinymce/classes/dom/NodeType.js
	
	/**
	 * NodeType.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains various node validation functions.
	 *
	 * @private
	 * @class tinymce.dom.NodeType
	 */
	define("tinymce/dom/NodeType", [], function() {
		function isNodeType(type) {
			return function(node) {
				return !!node && node.nodeType == type;
			};
		}
	
		var isElement = isNodeType(1);
	
		function matchNodeNames(names) {
			names = names.toLowerCase().split(' ');
	
			return function(node) {
				var i, name;
	
				if (node && node.nodeType) {
					name = node.nodeName.toLowerCase();
	
					for (i = 0; i < names.length; i++) {
						if (name === names[i]) {
							return true;
						}
					}
				}
	
				return false;
			};
		}
	
		function matchStyleValues(name, values) {
			values = values.toLowerCase().split(' ');
	
			return function(node) {
				var i, cssValue;
	
				if (isElement(node)) {
					for (i = 0; i < values.length; i++) {
						cssValue = getComputedStyle(node, null).getPropertyValue(name);
						if (cssValue === values[i]) {
							return true;
						}
					}
				}
	
				return false;
			};
		}
	
		function hasPropValue(propName, propValue) {
			return function(node) {
				return isElement(node) && node[propName] === propValue;
			};
		}
	
		function hasAttributeValue(attrName, attrValue) {
			return function(node) {
				return isElement(node) && node.getAttribute(attrName) === attrValue;
			};
		}
	
		function isBogus(node) {
			return isElement(node) && node.hasAttribute('data-mce-bogus');
		}
	
		function hasContentEditableState(value) {
			return function(node) {
				if (isElement(node)) {
					if (node.contentEditable === value) {
						return true;
					}
	
					if (node.getAttribute('data-mce-contenteditable') === value) {
						return true;
					}
				}
	
				return false;
			};
		}
	
		return {
			isText: isNodeType(3),
			isElement: isElement,
			isComment: isNodeType(8),
			isBr: matchNodeNames('br'),
			isContentEditableTrue: hasContentEditableState('true'),
			isContentEditableFalse: hasContentEditableState('false'),
			matchNodeNames: matchNodeNames,
			hasPropValue: hasPropValue,
			hasAttributeValue: hasAttributeValue,
			matchStyleValues: matchStyleValues,
			isBogus: isBogus
		};
	});
	
	// Included from: js/tinymce/classes/text/Zwsp.js
	
	/**
	 * Zwsp.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with zero width space
	 * characters used as character containers etc.
	 *
	 * @private
	 * @class tinymce.text.Zwsp
	 * @example
	 * var isZwsp = Zwsp.isZwsp('\uFEFF');
	 * var abc = Zwsp.trim('a\uFEFFc');
	 */
	define("tinymce/text/Zwsp", [], function() {
		var ZWSP = '\uFEFF';
	
		function isZwsp(chr) {
			return chr == ZWSP;
		}
	
		function trim(str) {
			return str.replace(new RegExp(ZWSP, 'g'), '');
		}
	
		return {
			isZwsp: isZwsp,
			ZWSP: ZWSP,
			trim: trim
		};
	});
	
	// Included from: js/tinymce/classes/caret/CaretContainer.js
	
	/**
	 * CaretContainer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module handles caret containers. A caret container is a node that
	 * holds the caret for positional purposes.
	 *
	 * @private
	 * @class tinymce.caret.CaretContainer
	 */
	define("tinymce/caret/CaretContainer", [
		"tinymce/dom/NodeType",
		"tinymce/text/Zwsp"
	], function(NodeType, Zwsp) {
		var isElement = NodeType.isElement,
			isText = NodeType.isText;
	
		function isCaretContainerBlock(node) {
			if (isText(node)) {
				node = node.parentNode;
			}
	
			return isElement(node) && node.hasAttribute('data-mce-caret');
		}
	
		function isCaretContainerInline(node) {
			return isText(node) && Zwsp.isZwsp(node.data);
		}
	
		function isCaretContainer(node) {
			return isCaretContainerBlock(node) || isCaretContainerInline(node);
		}
	
		function removeNode(node) {
			var parentNode = node.parentNode;
			if (parentNode) {
				parentNode.removeChild(node);
			}
		}
	
		function getNodeValue(node) {
			try {
				return node.nodeValue;
			} catch (ex) {
				// IE sometimes produces "Invalid argument" on nodes
				return "";
			}
		}
	
		function setNodeValue(node, text) {
			if (text.length === 0) {
				removeNode(node);
			} else {
				node.nodeValue = text;
			}
		}
	
		function insertInline(node, before) {
			var doc, sibling, textNode, parentNode;
	
			doc = node.ownerDocument;
			textNode = doc.createTextNode(Zwsp.ZWSP);
			parentNode = node.parentNode;
	
			if (!before) {
				sibling = node.nextSibling;
				if (isText(sibling)) {
					if (isCaretContainer(sibling)) {
						return sibling;
					}
	
					if (startsWithCaretContainer(sibling)) {
						sibling.splitText(1);
						return sibling;
					}
				}
	
				if (node.nextSibling) {
					parentNode.insertBefore(textNode, node.nextSibling);
				} else {
					parentNode.appendChild(textNode);
				}
			} else {
				sibling = node.previousSibling;
				if (isText(sibling)) {
					if (isCaretContainer(sibling)) {
						return sibling;
					}
	
					if (endsWithCaretContainer(sibling)) {
						return sibling.splitText(sibling.data.length - 1);
					}
				}
	
				parentNode.insertBefore(textNode, node);
			}
	
			return textNode;
		}
	
		function insertBlock(blockName, node, before) {
			var doc, blockNode, parentNode;
	
			doc = node.ownerDocument;
			blockNode = doc.createElement(blockName);
			blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
			blockNode.setAttribute('data-mce-bogus', 'all');
			blockNode.appendChild(doc.createTextNode('\u00a0'));
			parentNode = node.parentNode;
	
			if (!before) {
				if (node.nextSibling) {
					parentNode.insertBefore(blockNode, node.nextSibling);
				} else {
					parentNode.appendChild(blockNode);
				}
			} else {
				parentNode.insertBefore(blockNode, node);
			}
	
			return blockNode;
		}
	
		function remove(caretContainerNode) {
			if (isElement(caretContainerNode) && isCaretContainer(caretContainerNode)) {
				if (caretContainerNode.innerHTML != '&nbsp;') {
					caretContainerNode.removeAttribute('data-mce-caret');
				} else {
					removeNode(caretContainerNode);
				}
			}
	
			if (isText(caretContainerNode)) {
				var text = Zwsp.trim(getNodeValue(caretContainerNode));
				setNodeValue(caretContainerNode, text);
			}
		}
	
		function startsWithCaretContainer(node) {
			return isText(node) && node.data[0] == Zwsp.ZWSP;
		}
	
		function endsWithCaretContainer(node) {
			return isText(node) && node.data[node.data.length - 1] == Zwsp.ZWSP;
		}
	
		return {
			isCaretContainer: isCaretContainer,
			isCaretContainerBlock: isCaretContainerBlock,
			isCaretContainerInline: isCaretContainerInline,
			insertInline: insertInline,
			insertBlock: insertBlock,
			remove: remove,
			startsWithCaretContainer: startsWithCaretContainer,
			endsWithCaretContainer: endsWithCaretContainer
		};
	});
	
	// Included from: js/tinymce/classes/dom/RangeUtils.js
	
	/**
	 * RangeUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains a few utility methods for ranges.
	 *
	 * @class tinymce.dom.RangeUtils
	 */
	define("tinymce/dom/RangeUtils", [
		"tinymce/util/Tools",
		"tinymce/dom/TreeWalker",
		"tinymce/dom/NodeType",
		"tinymce/dom/Range",
		"tinymce/caret/CaretContainer"
	], function(Tools, TreeWalker, NodeType, Range, CaretContainer) {
		var each = Tools.each,
			isContentEditableFalse = NodeType.isContentEditableFalse,
			isCaretContainer = CaretContainer.isCaretContainer;
	
		function getEndChild(container, index) {
			var childNodes = container.childNodes;
	
			index--;
	
			if (index > childNodes.length - 1) {
				index = childNodes.length - 1;
			} else if (index < 0) {
				index = 0;
			}
	
			return childNodes[index] || container;
		}
	
		function RangeUtils(dom) {
			/**
			 * Walks the specified range like object and executes the callback for each sibling collection it finds.
			 *
			 * @private
			 * @method walk
			 * @param {Object} rng Range like object.
			 * @param {function} callback Callback function to execute for each sibling collection.
			 */
			this.walk = function(rng, callback) {
				var startContainer = rng.startContainer,
					startOffset = rng.startOffset,
					endContainer = rng.endContainer,
					endOffset = rng.endOffset,
					ancestor, startPoint,
					endPoint, node, parent, siblings, nodes;
	
				// Handle table cell selection the table plugin enables
				// you to fake select table cells and perform formatting actions on them
				nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
				if (nodes.length > 0) {
					each(nodes, function(node) {
						callback([node]);
					});
	
					return;
				}
	
				/**
				 * Excludes start/end text node if they are out side the range
				 *
				 * @private
				 * @param {Array} nodes Nodes to exclude items from.
				 * @return {Array} Array with nodes excluding the start/end container if needed.
				 */
				function exclude(nodes) {
					var node;
	
					// First node is excluded
					node = nodes[0];
					if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
						nodes.splice(0, 1);
					}
	
					// Last node is excluded
					node = nodes[nodes.length - 1];
					if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
						nodes.splice(nodes.length - 1, 1);
					}
	
					return nodes;
				}
	
				/**
				 * Collects siblings
				 *
				 * @private
				 * @param {Node} node Node to collect siblings from.
				 * @param {String} name Name of the sibling to check for.
				 * @param {Node} end_node
				 * @return {Array} Array of collected siblings.
				 */
				function collectSiblings(node, name, end_node) {
					var siblings = [];
	
					for (; node && node != end_node; node = node[name]) {
						siblings.push(node);
					}
	
					return siblings;
				}
	
				/**
				 * Find an end point this is the node just before the common ancestor root.
				 *
				 * @private
				 * @param {Node} node Node to start at.
				 * @param {Node} root Root/ancestor element to stop just before.
				 * @return {Node} Node just before the root element.
				 */
				function findEndPoint(node, root) {
					do {
						if (node.parentNode == root) {
							return node;
						}
	
						node = node.parentNode;
					} while (node);
				}
	
				function walkBoundary(start_node, end_node, next) {
					var siblingName = next ? 'nextSibling' : 'previousSibling';
	
					for (node = start_node, parent = node.parentNode; node && node != end_node; node = parent) {
						parent = node.parentNode;
						siblings = collectSiblings(node == start_node ? node : node[siblingName], siblingName);
	
						if (siblings.length) {
							if (!next) {
								siblings.reverse();
							}
	
							callback(exclude(siblings));
						}
					}
				}
	
				// If index based start position then resolve it
				if (startContainer.nodeType == 1 && startContainer.hasChildNodes()) {
					startContainer = startContainer.childNodes[startOffset];
				}
	
				// If index based end position then resolve it
				if (endContainer.nodeType == 1 && endContainer.hasChildNodes()) {
					endContainer = getEndChild(endContainer, endOffset);
				}
	
				// Same container
				if (startContainer == endContainer) {
					return callback(exclude([startContainer]));
				}
	
				// Find common ancestor and end points
				ancestor = dom.findCommonAncestor(startContainer, endContainer);
	
				// Process left side
				for (node = startContainer; node; node = node.parentNode) {
					if (node === endContainer) {
						return walkBoundary(startContainer, ancestor, true);
					}
	
					if (node === ancestor) {
						break;
					}
				}
	
				// Process right side
				for (node = endContainer; node; node = node.parentNode) {
					if (node === startContainer) {
						return walkBoundary(endContainer, ancestor);
					}
	
					if (node === ancestor) {
						break;
					}
				}
	
				// Find start/end point
				startPoint = findEndPoint(startContainer, ancestor) || startContainer;
				endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	
				// Walk left leaf
				walkBoundary(startContainer, startPoint, true);
	
				// Walk the middle from start to end point
				siblings = collectSiblings(
					startPoint == startContainer ? startPoint : startPoint.nextSibling,
					'nextSibling',
					endPoint == endContainer ? endPoint.nextSibling : endPoint
				);
	
				if (siblings.length) {
					callback(exclude(siblings));
				}
	
				// Walk right leaf
				walkBoundary(endContainer, endPoint);
			};
	
			/**
			 * Splits the specified range at it's start/end points.
			 *
			 * @private
			 * @param {Range/RangeObject} rng Range to split.
			 * @return {Object} Range position object.
			 */
			this.split = function(rng) {
				var startContainer = rng.startContainer,
					startOffset = rng.startOffset,
					endContainer = rng.endContainer,
					endOffset = rng.endOffset;
	
				function splitText(node, offset) {
					return node.splitText(offset);
				}
	
				// Handle single text node
				if (startContainer == endContainer && startContainer.nodeType == 3) {
					if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
						endContainer = splitText(startContainer, startOffset);
						startContainer = endContainer.previousSibling;
	
						if (endOffset > startOffset) {
							endOffset = endOffset - startOffset;
							startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
							endOffset = endContainer.nodeValue.length;
							startOffset = 0;
						} else {
							endOffset = 0;
						}
					}
				} else {
					// Split startContainer text node if needed
					if (startContainer.nodeType == 3 && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
						startContainer = splitText(startContainer, startOffset);
						startOffset = 0;
					}
	
					// Split endContainer text node if needed
					if (endContainer.nodeType == 3 && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
						endContainer = splitText(endContainer, endOffset).previousSibling;
						endOffset = endContainer.nodeValue.length;
					}
				}
	
				return {
					startContainer: startContainer,
					startOffset: startOffset,
					endContainer: endContainer,
					endOffset: endOffset
				};
			};
	
			/**
			 * Normalizes the specified range by finding the closest best suitable caret location.
			 *
			 * @private
			 * @param {Range} rng Range to normalize.
			 * @return {Boolean} True/false if the specified range was normalized or not.
			 */
			this.normalize = function(rng) {
				var normalized, collapsed;
	
				function normalizeEndPoint(start) {
					var container, offset, walker, body = dom.getRoot(), node, nonEmptyElementsMap;
					var directionLeft, isAfterNode;
	
					function isTableCell(node) {
						return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
					}
	
					function hasBrBeforeAfter(node, left) {
						var walker = new TreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || body);
	
						while ((node = walker[left ? 'prev' : 'next']())) {
							if (node.nodeName === "BR") {
								return true;
							}
						}
					}
	
					function hasContentEditableFalseParent(node) {
						while (node && node != body) {
							if (isContentEditableFalse(node)) {
								return true;
							}
	
							node = node.parentNode;
						}
	
						return false;
					}
	
					function isPrevNode(node, name) {
						return node.previousSibling && node.previousSibling.nodeName == name;
					}
	
					// Walks the dom left/right to find a suitable text node to move the endpoint into
					// It will only walk within the current parent block or body and will stop if it hits a block or a BR/IMG
					function findTextNodeRelative(left, startNode) {
						var walker, lastInlineElement, parentBlockContainer;
	
						startNode = startNode || container;
						parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	
						// Lean left before the BR element if it's the only BR within a block element. Gecko bug: #6680
						// This: <p><br>|</p> becomes <p>|<br></p>
						if (left && startNode.nodeName == 'BR' && isAfterNode && dom.isEmpty(parentBlockContainer)) {
							container = startNode.parentNode;
							offset = dom.nodeIndex(startNode);
							normalized = true;
							return;
						}
	
						// Walk left until we hit a text node we can move to or a block/br/img
						walker = new TreeWalker(startNode, parentBlockContainer);
						while ((node = walker[left ? 'prev' : 'next']())) {
							// Break if we hit a non content editable node
							if (dom.getContentEditableParent(node) === "false" || isCaretContainer(node)) {
								return;
							}
	
							// Found text node that has a length
							if (node.nodeType === 3 && node.nodeValue.length > 0) {
								container = node;
								offset = left ? node.nodeValue.length : 0;
								normalized = true;
								return;
							}
	
							// Break if we find a block or a BR/IMG/INPUT etc
							if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
								return;
							}
	
							lastInlineElement = node;
						}
	
						// Only fetch the last inline element when in caret mode for now
						if (collapsed && lastInlineElement) {
							container = lastInlineElement;
							normalized = true;
							offset = 0;
						}
					}
	
					container = rng[(start ? 'start' : 'end') + 'Container'];
					offset = rng[(start ? 'start' : 'end') + 'Offset'];
					isAfterNode = container.nodeType == 1 && offset === container.childNodes.length;
					nonEmptyElementsMap = dom.schema.getNonEmptyElements();
					directionLeft = start;
	
					if (isCaretContainer(container)) {
						return;
					}
	
					if (container.nodeType == 1 && offset > container.childNodes.length - 1) {
						directionLeft = false;
					}
	
					// If the container is a document move it to the body element
					if (container.nodeType === 9) {
						container = dom.getRoot();
						offset = 0;
					}
	
					// If the container is body try move it into the closest text node or position
					if (container === body) {
						// If start is before/after a image, table etc
						if (directionLeft) {
							node = container.childNodes[offset > 0 ? offset - 1 : 0];
							if (node) {
								if (isCaretContainer(node)) {
									return;
								}
	
								if (nonEmptyElementsMap[node.nodeName] || node.nodeName == "TABLE") {
									return;
								}
							}
						}
	
						// Resolve the index
						if (container.hasChildNodes()) {
							offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
							container = container.childNodes[offset];
							offset = 0;
	
							// Don't normalize non collapsed selections like <p>[a</p><table></table>]
							if (!collapsed && container === body.lastChild && container.nodeName === 'TABLE') {
								return;
							}
	
							if (hasContentEditableFalseParent(container) || isCaretContainer(container)) {
								return;
							}
	
							// Don't walk into elements that doesn't have any child nodes like a IMG
							if (container.hasChildNodes() && !/TABLE/.test(container.nodeName)) {
								// Walk the DOM to find a text node to place the caret at or a BR
								node = container;
								walker = new TreeWalker(container, body);
	
								do {
									if (isContentEditableFalse(node) || isCaretContainer(node)) {
										normalized = false;
										break;
									}
	
									// Found a text node use that position
									if (node.nodeType === 3 && node.nodeValue.length > 0) {
										offset = directionLeft ? 0 : node.nodeValue.length;
										container = node;
										normalized = true;
										break;
									}
	
									// Found a BR/IMG element that we can place the caret before
									if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell(node)) {
										offset = dom.nodeIndex(node);
										container = node.parentNode;
	
										// Put caret after image when moving the end point
										if (node.nodeName == "IMG" && !directionLeft) {
											offset++;
										}
	
										normalized = true;
										break;
									}
								} while ((node = (directionLeft ? walker.next() : walker.prev())));
							}
						}
					}
	
					// Lean the caret to the left if possible
					if (collapsed) {
						// So this: <b>x</b><i>|x</i>
						// Becomes: <b>x|</b><i>x</i>
						// Seems that only gecko has issues with this
						if (container.nodeType === 3 && offset === 0) {
							findTextNodeRelative(true);
						}
	
						// Lean left into empty inline elements when the caret is before a BR
						// So this: <i><b></b><i>|<br></i>
						// Becomes: <i><b>|</b><i><br></i>
						// Seems that only gecko has issues with this.
						// Special edge case for <p><a>x</a>|<br></p> since we don't want <p><a>x|</a><br></p>
						if (container.nodeType === 1) {
							node = container.childNodes[offset];
	
							// Offset is after the containers last child
							// then use the previous child for normalization
							if (!node) {
								node = container.childNodes[offset - 1];
							}
	
							if (node && node.nodeName === 'BR' && !isPrevNode(node, 'A') &&
								!hasBrBeforeAfter(node) && !hasBrBeforeAfter(node, true)) {
								findTextNodeRelative(true, node);
							}
						}
					}
	
					// Lean the start of the selection right if possible
					// So this: x[<b>x]</b>
					// Becomes: x<b>[x]</b>
					if (directionLeft && !collapsed && container.nodeType === 3 && offset === container.nodeValue.length) {
						findTextNodeRelative(false);
					}
	
					// Set endpoint if it was normalized
					if (normalized) {
						rng['set' + (start ? 'Start' : 'End')](container, offset);
					}
				}
	
				collapsed = rng.collapsed;
	
				normalizeEndPoint(true);
	
				if (!collapsed) {
					normalizeEndPoint();
				}
	
				// If it was collapsed then make sure it still is
				if (normalized && collapsed) {
					rng.collapse(true);
				}
	
				return normalized;
			};
		}
	
		/**
		 * Compares two ranges and checks if they are equal.
		 *
		 * @static
		 * @method compareRanges
		 * @param {DOMRange} rng1 First range to compare.
		 * @param {DOMRange} rng2 First range to compare.
		 * @return {Boolean} true/false if the ranges are equal.
		 */
		RangeUtils.compareRanges = function(rng1, rng2) {
			if (rng1 && rng2) {
				// Compare native IE ranges
				if (rng1.item || rng1.duplicate) {
					// Both are control ranges and the selected element matches
					if (rng1.item && rng2.item && rng1.item(0) === rng2.item(0)) {
						return true;
					}
	
					// Both are text ranges and the range matches
					if (rng1.isEqual && rng2.isEqual && rng2.isEqual(rng1)) {
						return true;
					}
				} else {
					// Compare w3c ranges
					return rng1.startContainer == rng2.startContainer && rng1.startOffset == rng2.startOffset;
				}
			}
	
			return false;
		};
	
		/**
		 * Finds the closest selection rect tries to get the range from that.
		 */
		function findClosestIeRange(clientX, clientY, doc) {
			var element, rng, rects;
	
			element = doc.elementFromPoint(clientX, clientY);
			rng = doc.body.createTextRange();
	
			if (!element || element.tagName == 'HTML') {
				element = doc.body;
			}
	
			rng.moveToElementText(element);
			rects = Tools.toArray(rng.getClientRects());
	
			rects = rects.sort(function(a, b) {
				a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
				b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	
				return a - b;
			});
	
			if (rects.length > 0) {
				clientY = (rects[0].bottom + rects[0].top) / 2;
	
				try {
					rng.moveToPoint(clientX, clientY);
					rng.collapse(true);
	
					return rng;
				} catch (ex) {
					// At least we tried
				}
			}
	
			return null;
		}
	
		/**
		 * Gets the caret range for the given x/y location.
		 *
		 * @static
		 * @method getCaretRangeFromPoint
		 * @param {Number} clientX X coordinate for range
		 * @param {Number} clientY Y coordinate for range
		 * @param {Document} doc Document that x/y are relative to
		 * @returns {Range} caret range
		 */
		RangeUtils.getCaretRangeFromPoint = function(clientX, clientY, doc) {
			var rng, point;
	
			if (doc.caretPositionFromPoint) {
				point = doc.caretPositionFromPoint(clientX, clientY);
				rng = doc.createRange();
				rng.setStart(point.offsetNode, point.offset);
				rng.collapse(true);
			} else if (doc.caretRangeFromPoint) {
				rng = doc.caretRangeFromPoint(clientX, clientY);
			} else if (doc.body.createTextRange) {
				rng = doc.body.createTextRange();
	
				try {
					rng.moveToPoint(clientX, clientY);
					rng.collapse(true);
				} catch (ex) {
					rng = findClosestIeRange(clientX, clientY, doc);
				}
			}
	
			return rng;
		};
	
		RangeUtils.getSelectedNode = function(range) {
			var startContainer = range.startContainer,
				startOffset = range.startOffset;
	
			if (startContainer.hasChildNodes() && range.endOffset == startOffset + 1) {
				return startContainer.childNodes[startOffset];
			}
	
			return null;
		};
	
		RangeUtils.getNode = function(container, offset) {
			if (container.nodeType == 1 && container.hasChildNodes()) {
				if (offset >= container.childNodes.length) {
					offset = container.childNodes.length - 1;
				}
	
				container = container.childNodes[offset];
			}
	
			return container;
		};
	
		return RangeUtils;
	});
	
	// Included from: js/tinymce/classes/NodeChange.js
	
	/**
	 * NodeChange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the nodechange event dispatching both manual and through selection change events.
	 *
	 * @class tinymce.NodeChange
	 * @private
	 */
	define("tinymce/NodeChange", [
		"tinymce/dom/RangeUtils",
		"tinymce/Env",
		"tinymce/util/Delay"
	], function(RangeUtils, Env, Delay) {
		return function(editor) {
			var lastRng, lastPath = [];
	
			/**
			 * Returns true/false if the current element path has been changed or not.
			 *
			 * @private
			 * @return {Boolean} True if the element path is the same false if it's not.
			 */
			function isSameElementPath(startElm) {
				var i, currentPath;
	
				currentPath = editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);
				if (currentPath.length === lastPath.length) {
					for (i = currentPath.length; i >= 0; i--) {
						if (currentPath[i] !== lastPath[i]) {
							break;
						}
					}
	
					if (i === -1) {
						lastPath = currentPath;
						return true;
					}
				}
	
				lastPath = currentPath;
	
				return false;
			}
	
			// Gecko doesn't support the "selectionchange" event
			if (!('onselectionchange' in editor.getDoc())) {
				editor.on('NodeChange Click MouseUp KeyUp Focus', function(e) {
					var nativeRng, fakeRng;
	
					// Since DOM Ranges mutate on modification
					// of the DOM we need to clone it's contents
					nativeRng = editor.selection.getRng();
					fakeRng = {
						startContainer: nativeRng.startContainer,
						startOffset: nativeRng.startOffset,
						endContainer: nativeRng.endContainer,
						endOffset: nativeRng.endOffset
					};
	
					// Always treat nodechange as a selectionchange since applying
					// formatting to the current range wouldn't update the range but it's parent
					if (e.type == 'nodechange' || !RangeUtils.compareRanges(fakeRng, lastRng)) {
						editor.fire('SelectionChange');
					}
	
					lastRng = fakeRng;
				});
			}
	
			// IE has a bug where it fires a selectionchange on right click that has a range at the start of the body
			// When the contextmenu event fires the selection is located at the right location
			editor.on('contextmenu', function() {
				editor.fire('SelectionChange');
			});
	
			// Selection change is delayed ~200ms on IE when you click inside the current range
			editor.on('SelectionChange', function() {
				var startElm = editor.selection.getStart(true);
	
				// IE 8 will fire a selectionchange event with an incorrect selection
				// when focusing out of table cells. Click inside cell -> toolbar = Invalid SelectionChange event
				if (!Env.range && editor.selection.isCollapsed()) {
					return;
				}
	
				if (!isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
					editor.nodeChanged({selectionChange: true});
				}
			});
	
			// Fire an extra nodeChange on mouseup for compatibility reasons
			editor.on('MouseUp', function(e) {
				if (!e.isDefaultPrevented()) {
					// Delay nodeChanged call for WebKit edge case issue where the range
					// isn't updated until after you click outside a selected image
					if (editor.selection.getNode().nodeName == 'IMG') {
						Delay.setEditorTimeout(editor, function() {
							editor.nodeChanged();
						});
					} else {
						editor.nodeChanged();
					}
				}
			});
	
			/**
			 * Dispatches out a onNodeChange event to all observers. This method should be called when you
			 * need to update the UI states or element path etc.
			 *
			 * @method nodeChanged
			 * @param {Object} args Optional args to pass to NodeChange event handlers.
			 */
			this.nodeChanged = function(args) {
				var selection = editor.selection, node, parents, root;
	
				// Fix for bug #1896577 it seems that this can not be fired while the editor is loading
				if (editor.initialized && selection && !editor.settings.disable_nodechange && !editor.readonly) {
					// Get start node
					root = editor.getBody();
					node = selection.getStart() || root;
	
					// Make sure the node is within the editor root or is the editor root
					if (node.ownerDocument != editor.getDoc() || !editor.dom.isChildOf(node, root)) {
						node = root;
					}
	
					// Edge case for <p>|<img></p>
					if (node.nodeName == 'IMG' && selection.isCollapsed()) {
						node = node.parentNode;
					}
	
					// Get parents and add them to object
					parents = [];
					editor.dom.getParent(node, function(node) {
						if (node === root) {
							return true;
						}
	
						parents.push(node);
					});
	
					args = args || {};
					args.element = node;
					args.parents = parents;
	
					editor.fire('NodeChange', args);
				}
			};
		};
	});
	
	// Included from: js/tinymce/classes/html/Node.js
	
	/**
	 * Node.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a minimalistic implementation of a DOM like node used by the DomParser class.
	 *
	 * @example
	 * var node = new tinymce.html.Node('strong', 1);
	 * someRoot.append(node);
	 *
	 * @class tinymce.html.Node
	 * @version 3.4
	 */
	define("tinymce/html/Node", [], function() {
		var whiteSpaceRegExp = /^[ \t\r\n]*$/, typeLookup = {
			'#text': 3,
			'#comment': 8,
			'#cdata': 4,
			'#pi': 7,
			'#doctype': 10,
			'#document-fragment': 11
		};
	
		// Walks the tree left/right
		function walk(node, root_node, prev) {
			var sibling, parent, startName = prev ? 'lastChild' : 'firstChild', siblingName = prev ? 'prev' : 'next';
	
			// Walk into nodes if it has a start
			if (node[startName]) {
				return node[startName];
			}
	
			// Return the sibling if it has one
			if (node !== root_node) {
				sibling = node[siblingName];
	
				if (sibling) {
					return sibling;
				}
	
				// Walk up the parents to look for siblings
				for (parent = node.parent; parent && parent !== root_node; parent = parent.parent) {
					sibling = parent[siblingName];
	
					if (sibling) {
						return sibling;
					}
				}
			}
		}
	
		/**
		 * Constructs a new Node instance.
		 *
		 * @constructor
		 * @method Node
		 * @param {String} name Name of the node type.
		 * @param {Number} type Numeric type representing the node.
		 */
		function Node(name, type) {
			this.name = name;
			this.type = type;
	
			if (type === 1) {
				this.attributes = [];
				this.attributes.map = {};
			}
		}
	
		Node.prototype = {
			/**
			 * Replaces the current node with the specified one.
			 *
			 * @example
			 * someNode.replace(someNewNode);
			 *
			 * @method replace
			 * @param {tinymce.html.Node} node Node to replace the current node with.
			 * @return {tinymce.html.Node} The old node that got replaced.
			 */
			replace: function(node) {
				var self = this;
	
				if (node.parent) {
					node.remove();
				}
	
				self.insert(node, self);
				self.remove();
	
				return self;
			},
	
			/**
			 * Gets/sets or removes an attribute by name.
			 *
			 * @example
			 * someNode.attr("name", "value"); // Sets an attribute
			 * console.log(someNode.attr("name")); // Gets an attribute
			 * someNode.attr("name", null); // Removes an attribute
			 *
			 * @method attr
			 * @param {String} name Attribute name to set or get.
			 * @param {String} value Optional value to set.
			 * @return {String/tinymce.html.Node} String or undefined on a get operation or the current node on a set operation.
			 */
			attr: function(name, value) {
				var self = this, attrs, i, undef;
	
				if (typeof name !== "string") {
					for (i in name) {
						self.attr(i, name[i]);
					}
	
					return self;
				}
	
				if ((attrs = self.attributes)) {
					if (value !== undef) {
						// Remove attribute
						if (value === null) {
							if (name in attrs.map) {
								delete attrs.map[name];
	
								i = attrs.length;
								while (i--) {
									if (attrs[i].name === name) {
										attrs = attrs.splice(i, 1);
										return self;
									}
								}
							}
	
							return self;
						}
	
						// Set attribute
						if (name in attrs.map) {
							// Set attribute
							i = attrs.length;
							while (i--) {
								if (attrs[i].name === name) {
									attrs[i].value = value;
									break;
								}
							}
						} else {
							attrs.push({name: name, value: value});
						}
	
						attrs.map[name] = value;
	
						return self;
					}
	
					return attrs.map[name];
				}
			},
	
			/**
			 * Does a shallow clones the node into a new node. It will also exclude id attributes since
			 * there should only be one id per document.
			 *
			 * @example
			 * var clonedNode = node.clone();
			 *
			 * @method clone
			 * @return {tinymce.html.Node} New copy of the original node.
			 */
			clone: function() {
				var self = this, clone = new Node(self.name, self.type), i, l, selfAttrs, selfAttr, cloneAttrs;
	
				// Clone element attributes
				if ((selfAttrs = self.attributes)) {
					cloneAttrs = [];
					cloneAttrs.map = {};
	
					for (i = 0, l = selfAttrs.length; i < l; i++) {
						selfAttr = selfAttrs[i];
	
						// Clone everything except id
						if (selfAttr.name !== 'id') {
							cloneAttrs[cloneAttrs.length] = {name: selfAttr.name, value: selfAttr.value};
							cloneAttrs.map[selfAttr.name] = selfAttr.value;
						}
					}
	
					clone.attributes = cloneAttrs;
				}
	
				clone.value = self.value;
				clone.shortEnded = self.shortEnded;
	
				return clone;
			},
	
			/**
			 * Wraps the node in in another node.
			 *
			 * @example
			 * node.wrap(wrapperNode);
			 *
			 * @method wrap
			 */
			wrap: function(wrapper) {
				var self = this;
	
				self.parent.insert(wrapper, self);
				wrapper.append(self);
	
				return self;
			},
	
			/**
			 * Unwraps the node in other words it removes the node but keeps the children.
			 *
			 * @example
			 * node.unwrap();
			 *
			 * @method unwrap
			 */
			unwrap: function() {
				var self = this, node, next;
	
				for (node = self.firstChild; node;) {
					next = node.next;
					self.insert(node, self, true);
					node = next;
				}
	
				self.remove();
			},
	
			/**
			 * Removes the node from it's parent.
			 *
			 * @example
			 * node.remove();
			 *
			 * @method remove
			 * @return {tinymce.html.Node} Current node that got removed.
			 */
			remove: function() {
				var self = this, parent = self.parent, next = self.next, prev = self.prev;
	
				if (parent) {
					if (parent.firstChild === self) {
						parent.firstChild = next;
	
						if (next) {
							next.prev = null;
						}
					} else {
						prev.next = next;
					}
	
					if (parent.lastChild === self) {
						parent.lastChild = prev;
	
						if (prev) {
							prev.next = null;
						}
					} else {
						next.prev = prev;
					}
	
					self.parent = self.next = self.prev = null;
				}
	
				return self;
			},
	
			/**
			 * Appends a new node as a child of the current node.
			 *
			 * @example
			 * node.append(someNode);
			 *
			 * @method append
			 * @param {tinymce.html.Node} node Node to append as a child of the current one.
			 * @return {tinymce.html.Node} The node that got appended.
			 */
			append: function(node) {
				var self = this, last;
	
				if (node.parent) {
					node.remove();
				}
	
				last = self.lastChild;
				if (last) {
					last.next = node;
					node.prev = last;
					self.lastChild = node;
				} else {
					self.lastChild = self.firstChild = node;
				}
	
				node.parent = self;
	
				return node;
			},
	
			/**
			 * Inserts a node at a specific position as a child of the current node.
			 *
			 * @example
			 * parentNode.insert(newChildNode, oldChildNode);
			 *
			 * @method insert
			 * @param {tinymce.html.Node} node Node to insert as a child of the current node.
			 * @param {tinymce.html.Node} ref_node Reference node to set node before/after.
			 * @param {Boolean} before Optional state to insert the node before the reference node.
			 * @return {tinymce.html.Node} The node that got inserted.
			 */
			insert: function(node, ref_node, before) {
				var parent;
	
				if (node.parent) {
					node.remove();
				}
	
				parent = ref_node.parent || this;
	
				if (before) {
					if (ref_node === parent.firstChild) {
						parent.firstChild = node;
					} else {
						ref_node.prev.next = node;
					}
	
					node.prev = ref_node.prev;
					node.next = ref_node;
					ref_node.prev = node;
				} else {
					if (ref_node === parent.lastChild) {
						parent.lastChild = node;
					} else {
						ref_node.next.prev = node;
					}
	
					node.next = ref_node.next;
					node.prev = ref_node;
					ref_node.next = node;
				}
	
				node.parent = parent;
	
				return node;
			},
	
			/**
			 * Get all children by name.
			 *
			 * @method getAll
			 * @param {String} name Name of the child nodes to collect.
			 * @return {Array} Array with child nodes matchin the specified name.
			 */
			getAll: function(name) {
				var self = this, node, collection = [];
	
				for (node = self.firstChild; node; node = walk(node, self)) {
					if (node.name === name) {
						collection.push(node);
					}
				}
	
				return collection;
			},
	
			/**
			 * Removes all children of the current node.
			 *
			 * @method empty
			 * @return {tinymce.html.Node} The current node that got cleared.
			 */
			empty: function() {
				var self = this, nodes, i, node;
	
				// Remove all children
				if (self.firstChild) {
					nodes = [];
	
					// Collect the children
					for (node = self.firstChild; node; node = walk(node, self)) {
						nodes.push(node);
					}
	
					// Remove the children
					i = nodes.length;
					while (i--) {
						node = nodes[i];
						node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
					}
				}
	
				self.firstChild = self.lastChild = null;
	
				return self;
			},
	
			/**
			 * Returns true/false if the node is to be considered empty or not.
			 *
			 * @example
			 * node.isEmpty({img: true});
			 * @method isEmpty
			 * @param {Object} elements Name/value object with elements that are automatically treated as non empty elements.
			 * @return {Boolean} true/false if the node is empty or not.
			 */
			isEmpty: function(elements) {
				var self = this, node = self.firstChild, i, name;
	
				if (node) {
					do {
						if (node.type === 1) {
							// Ignore bogus elements
							if (node.attributes.map['data-mce-bogus']) {
								continue;
							}
	
							// Keep empty elements like <img />
							if (elements[node.name]) {
								return false;
							}
	
							// Keep bookmark nodes and name attribute like <a name="1"></a>
							i = node.attributes.length;
							while (i--) {
								name = node.attributes[i].name;
								if (name === "name" || name.indexOf('data-mce-bookmark') === 0) {
									return false;
								}
							}
						}
	
						// Keep comments
						if (node.type === 8) {
							return false;
						}
	
						// Keep non whitespace text nodes
						if ((node.type === 3 && !whiteSpaceRegExp.test(node.value))) {
							return false;
						}
					} while ((node = walk(node, self)));
				}
	
				return true;
			},
	
			/**
			 * Walks to the next or previous node and returns that node or null if it wasn't found.
			 *
			 * @method walk
			 * @param {Boolean} prev Optional previous node state defaults to false.
			 * @return {tinymce.html.Node} Node that is next to or previous of the current node.
			 */
			walk: function(prev) {
				return walk(this, null, prev);
			}
		};
	
		/**
		 * Creates a node of a specific type.
		 *
		 * @static
		 * @method create
		 * @param {String} name Name of the node type to create for example "b" or "#text".
		 * @param {Object} attrs Name/value collection of attributes that will be applied to elements.
		 */
		Node.create = function(name, attrs) {
			var node, attrName;
	
			// Create node
			node = new Node(name, typeLookup[name] || 1);
	
			// Add attributes if needed
			if (attrs) {
				for (attrName in attrs) {
					node.attr(attrName, attrs[attrName]);
				}
			}
	
			return node;
		};
	
		return Node;
	});
	
	// Included from: js/tinymce/classes/html/Schema.js
	
	/**
	 * Schema.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Schema validator class.
	 *
	 * @class tinymce.html.Schema
	 * @example
	 *  if (tinymce.activeEditor.schema.isValidChild('p', 'span'))
	 *    alert('span is valid child of p.');
	 *
	 *  if (tinymce.activeEditor.schema.getElementRule('p'))
	 *    alert('P is a valid element.');
	 *
	 * @class tinymce.html.Schema
	 * @version 3.4
	 */
	define("tinymce/html/Schema", [
		"tinymce/util/Tools"
	], function(Tools) {
		var mapCache = {}, dummyObj = {};
		var makeMap = Tools.makeMap, each = Tools.each, extend = Tools.extend, explode = Tools.explode, inArray = Tools.inArray;
	
		function split(items, delim) {
			return items ? items.split(delim || ' ') : [];
		}
	
		/**
		 * Builds a schema lookup table
		 *
		 * @private
		 * @param {String} type html4, html5 or html5-strict schema type.
		 * @return {Object} Schema lookup table.
		 */
		function compileSchema(type) {
			var schema = {}, globalAttributes, blockContent;
			var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	
			function add(name, attributes, children) {
				var ni, i, attributesOrder, args = arguments;
	
				function arrayToMap(array, obj) {
					var map = {}, i, l;
	
					for (i = 0, l = array.length; i < l; i++) {
						map[array[i]] = obj || {};
					}
	
					return map;
				}
	
				children = children || [];
				attributes = attributes || "";
	
				if (typeof children === "string") {
					children = split(children);
				}
	
				// Split string children
				for (i = 3; i < args.length; i++) {
					if (typeof args[i] === "string") {
						args[i] = split(args[i]);
					}
	
					children.push.apply(children, args[i]);
				}
	
				name = split(name);
				ni = name.length;
				while (ni--) {
					attributesOrder = [].concat(globalAttributes, split(attributes));
					schema[name[ni]] = {
						attributes: arrayToMap(attributesOrder),
						attributesOrder: attributesOrder,
						children: arrayToMap(children, dummyObj)
					};
				}
			}
	
			function addAttrs(name, attributes) {
				var ni, schemaItem, i, l;
	
				name = split(name);
				ni = name.length;
				attributes = split(attributes);
				while (ni--) {
					schemaItem = schema[name[ni]];
					for (i = 0, l = attributes.length; i < l; i++) {
						schemaItem.attributes[attributes[i]] = {};
						schemaItem.attributesOrder.push(attributes[i]);
					}
				}
			}
	
			// Use cached schema
			if (mapCache[type]) {
				return mapCache[type];
			}
	
			// Attributes present on all elements
			globalAttributes = split("id accesskey class dir lang style tabindex title");
	
			// Event attributes can be opt-in/opt-out
			/*eventAttributes = split("onabort onblur oncancel oncanplay oncanplaythrough onchange onclick onclose oncontextmenu oncuechange " +
					"ondblclick ondrag ondragend ondragenter ondragleave ondragover ondragstart ondrop ondurationchange onemptied onended " +
					"onerror onfocus oninput oninvalid onkeydown onkeypress onkeyup onload onloadeddata onloadedmetadata onloadstart " +
					"onmousedown onmousemove onmouseout onmouseover onmouseup onmousewheel onpause onplay onplaying onprogress onratechange " +
					"onreset onscroll onseeked onseeking onseeking onselect onshow onstalled onsubmit onsuspend ontimeupdate onvolumechange " +
					"onwaiting"
			);*/
	
			// Block content elements
			blockContent = split(
				"address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul"
			);
	
			// Phrasing content elements from the HTML5 spec (inline)
			phrasingContent = split(
				"a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd " +
				"label map noscript object q s samp script select small span strong sub sup " +
				"textarea u var #text #comment"
			);
	
			// Add HTML5 items to globalAttributes, blockContent, phrasingContent
			if (type != "html4") {
				globalAttributes.push.apply(globalAttributes, split("contenteditable contextmenu draggable dropzone " +
					"hidden spellcheck translate"));
				blockContent.push.apply(blockContent, split("article aside details dialog figure header footer hgroup section nav"));
				phrasingContent.push.apply(phrasingContent, split("audio canvas command datalist mark meter output picture " +
					"progress time wbr video ruby bdi keygen"));
			}
	
			// Add HTML4 elements unless it's html5-strict
			if (type != "html5-strict") {
				globalAttributes.push("xml:lang");
	
				html4PhrasingContent = split("acronym applet basefont big font strike tt");
				phrasingContent.push.apply(phrasingContent, html4PhrasingContent);
	
				each(html4PhrasingContent, function(name) {
					add(name, "", phrasingContent);
				});
	
				html4BlockContent = split("center dir isindex noframes");
				blockContent.push.apply(blockContent, html4BlockContent);
	
				// Flow content elements from the HTML5 spec (block+inline)
				flowContent = [].concat(blockContent, phrasingContent);
	
				each(html4BlockContent, function(name) {
					add(name, "", flowContent);
				});
			}
	
			// Flow content elements from the HTML5 spec (block+inline)
			flowContent = flowContent || [].concat(blockContent, phrasingContent);
	
			// HTML4 base schema TODO: Move HTML5 specific attributes to HTML5 specific if statement
			// Schema items <element name>, <specific attributes>, <children ..>
			add("html", "manifest", "head body");
			add("head", "", "base command link meta noscript script style title");
			add("title hr noscript br");
			add("base", "href target");
			add("link", "href rel media hreflang type sizes hreflang");
			add("meta", "name http-equiv content charset");
			add("style", "media type scoped");
			add("script", "src async defer type charset");
			add("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus " +
					"onhashchange onload onmessage onoffline ononline onpagehide onpageshow " +
					"onpopstate onresize onscroll onstorage onunload", flowContent);
			add("address dt dd div caption", "", flowContent);
			add("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", phrasingContent);
			add("blockquote", "cite", flowContent);
			add("ol", "reversed start type", "li");
			add("ul", "", "li");
			add("li", "value", flowContent);
			add("dl", "", "dt dd");
			add("a", "href target rel media hreflang type", phrasingContent);
			add("q", "cite", phrasingContent);
			add("ins del", "cite datetime", flowContent);
			add("img", "src sizes srcset alt usemap ismap width height");
			add("iframe", "src name width height", flowContent);
			add("embed", "src type width height");
			add("object", "data type typemustmatch name usemap form width height", flowContent, "param");
			add("param", "name value");
			add("map", "name", flowContent, "area");
			add("area", "alt coords shape href target rel media hreflang type");
			add("table", "border", "caption colgroup thead tfoot tbody tr" + (type == "html4" ? " col" : ""));
			add("colgroup", "span", "col");
			add("col", "span");
			add("tbody thead tfoot", "", "tr");
			add("tr", "", "td th");
			add("td", "colspan rowspan headers", flowContent);
			add("th", "colspan rowspan headers scope abbr", flowContent);
			add("form", "accept-charset action autocomplete enctype method name novalidate target", flowContent);
			add("fieldset", "disabled form name", flowContent, "legend");
			add("label", "form for", phrasingContent);
			add("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate " +
					"formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"
			);
			add("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value",
				type == "html4" ? flowContent : phrasingContent);
			add("select", "disabled form multiple name required size", "option optgroup");
			add("optgroup", "disabled label", "option");
			add("option", "disabled label selected value");
			add("textarea", "cols dirname disabled form maxlength name readonly required rows wrap");
			add("menu", "type label", flowContent, "li");
			add("noscript", "", flowContent);
	
			// Extend with HTML5 elements
			if (type != "html4") {
				add("wbr");
				add("ruby", "", phrasingContent, "rt rp");
				add("figcaption", "", flowContent);
				add("mark rt rp summary bdi", "", phrasingContent);
				add("canvas", "width height", flowContent);
				add("video", "src crossorigin poster preload autoplay mediagroup loop " +
					"muted controls width height buffered", flowContent, "track source");
				add("audio", "src crossorigin preload autoplay mediagroup loop muted controls buffered volume", flowContent, "track source");
				add("picture", "", "img source");
				add("source", "src srcset type media sizes");
				add("track", "kind src srclang label default");
				add("datalist", "", phrasingContent, "option");
				add("article section nav aside header footer", "", flowContent);
				add("hgroup", "", "h1 h2 h3 h4 h5 h6");
				add("figure", "", flowContent, "figcaption");
				add("time", "datetime", phrasingContent);
				add("dialog", "open", flowContent);
				add("command", "type label icon disabled checked radiogroup command");
				add("output", "for form name", phrasingContent);
				add("progress", "value max", phrasingContent);
				add("meter", "value min max low high optimum", phrasingContent);
				add("details", "open", flowContent, "summary");
				add("keygen", "autofocus challenge disabled form keytype name");
			}
	
			// Extend with HTML4 attributes unless it's html5-strict
			if (type != "html5-strict") {
				addAttrs("script", "language xml:space");
				addAttrs("style", "xml:space");
				addAttrs("object", "declare classid code codebase codetype archive standby align border hspace vspace");
				addAttrs("embed", "align name hspace vspace");
				addAttrs("param", "valuetype type");
				addAttrs("a", "charset name rev shape coords");
				addAttrs("br", "clear");
				addAttrs("applet", "codebase archive code object alt name width height align hspace vspace");
				addAttrs("img", "name longdesc align border hspace vspace");
				addAttrs("iframe", "longdesc frameborder marginwidth marginheight scrolling align");
				addAttrs("font basefont", "size color face");
				addAttrs("input", "usemap align");
				addAttrs("select", "onchange");
				addAttrs("textarea");
				addAttrs("h1 h2 h3 h4 h5 h6 div p legend caption", "align");
				addAttrs("ul", "type compact");
				addAttrs("li", "type");
				addAttrs("ol dl menu dir", "compact");
				addAttrs("pre", "width xml:space");
				addAttrs("hr", "align noshade size width");
				addAttrs("isindex", "prompt");
				addAttrs("table", "summary width frame rules cellspacing cellpadding align bgcolor");
				addAttrs("col", "width align char charoff valign");
				addAttrs("colgroup", "width align char charoff valign");
				addAttrs("thead", "align char charoff valign");
				addAttrs("tr", "align char charoff valign bgcolor");
				addAttrs("th", "axis align char charoff valign nowrap bgcolor width height");
				addAttrs("form", "accept");
				addAttrs("td", "abbr axis scope align char charoff valign nowrap bgcolor width height");
				addAttrs("tfoot", "align char charoff valign");
				addAttrs("tbody", "align char charoff valign");
				addAttrs("area", "nohref");
				addAttrs("body", "background bgcolor text link vlink alink");
			}
	
			// Extend with HTML5 attributes unless it's html4
			if (type != "html4") {
				addAttrs("input button select textarea", "autofocus");
				addAttrs("input textarea", "placeholder");
				addAttrs("a", "download");
				addAttrs("link script img", "crossorigin");
				addAttrs("iframe", "sandbox seamless allowfullscreen"); // Excluded: srcdoc
			}
	
			// Special: iframe, ruby, video, audio, label
	
			// Delete children of the same name from it's parent
			// For example: form can't have a child of the name form
			each(split('a form meter progress dfn'), function(name) {
				if (schema[name]) {
					delete schema[name].children[name];
				}
			});
	
			// Delete header, footer, sectioning and heading content descendants
			/*each('dt th address', function(name) {
				delete schema[name].children[name];
			});*/
	
			// Caption can't have tables
			delete schema.caption.children.table;
	
			// Delete scripts by default due to possible XSS
			delete schema.script;
	
			// TODO: LI:s can only have value if parent is OL
	
			// TODO: Handle transparent elements
			// a ins del canvas map
	
			mapCache[type] = schema;
	
			return schema;
		}
	
		function compileElementMap(value, mode) {
			var styles;
	
			if (value) {
				styles = {};
	
				if (typeof value == 'string') {
					value = {
						'*': value
					};
				}
	
				// Convert styles into a rule list
				each(value, function(value, key) {
					styles[key] = styles[key.toUpperCase()] = mode == 'map' ? makeMap(value, /[, ]/) : explode(value, /[, ]/);
				});
			}
	
			return styles;
		}
	
		/**
		 * Constructs a new Schema instance.
		 *
		 * @constructor
		 * @method Schema
		 * @param {Object} settings Name/value settings object.
		 */
		return function(settings) {
			var self = this, elements = {}, children = {}, patternElements = [], validStyles, invalidStyles, schemaItems;
			var whiteSpaceElementsMap, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
			var blockElementsMap, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
			var customElementsMap = {}, specialElements = {};
	
			// Creates an lookup table map object for the specified option or the default value
			function createLookupTable(option, default_value, extendWith) {
				var value = settings[option];
	
				if (!value) {
					// Get cached default map or make it if needed
					value = mapCache[option];
	
					if (!value) {
						value = makeMap(default_value, ' ', makeMap(default_value.toUpperCase(), ' '));
						value = extend(value, extendWith);
	
						mapCache[option] = value;
					}
				} else {
					// Create custom map
					value = makeMap(value, /[, ]/, makeMap(value.toUpperCase(), /[, ]/));
				}
	
				return value;
			}
	
			settings = settings || {};
			schemaItems = compileSchema(settings.schema);
	
			// Allow all elements and attributes if verify_html is set to false
			if (settings.verify_html === false) {
				settings.valid_elements = '*[*]';
			}
	
			validStyles = compileElementMap(settings.valid_styles);
			invalidStyles = compileElementMap(settings.invalid_styles, 'map');
			validClasses = compileElementMap(settings.valid_classes, 'map');
	
			// Setup map objects
			whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object');
			selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
			shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' +
				'meta param embed source wbr track');
			boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' +
				'noshade nowrap readonly selected autoplay loop controls');
			nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object script', shortEndedElementsMap);
			moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
			textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' +
							'blockquote center dir fieldset header footer article section hgroup aside nav figure');
			blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' +
							'th tr td li ol ul caption dl dt dd noscript menu isindex option ' +
							'datalist select optgroup figcaption', textBlockElementsMap);
			textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' +
											'dfn code mark q sup sub samp');
	
			each((settings.special || 'script noscript style textarea').split(' '), function(name) {
				specialElements[name] = new RegExp('<\/' + name + '[^>]*>', 'gi');
			});
	
			// Converts a wildcard expression string to a regexp for example *a will become /.*a/.
			function patternToRegExp(str) {
				return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
			}
	
			// Parses the specified valid_elements string and adds to the current rules
			// This function is a bit hard to read since it's heavily optimized for speed
			function addValidElements(validElements) {
				var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder,
					prefix, outputName, globalAttributes, globalAttributesOrder, key, value,
					elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/,
					attrRuleRegExp = /^([!\-])?(\w+::\w+|[^=:<]+)?(?:([=:<])(.*))?$/,
					hasPatternsRegExp = /[*?+]/;
	
				if (validElements) {
					// Split valid elements into an array with rules
					validElements = split(validElements, ',');
	
					if (elements['@']) {
						globalAttributes = elements['@'].attributes;
						globalAttributesOrder = elements['@'].attributesOrder;
					}
	
					// Loop all rules
					for (ei = 0, el = validElements.length; ei < el; ei++) {
						// Parse element rule
						matches = elementRuleRegExp.exec(validElements[ei]);
						if (matches) {
							// Setup local names for matches
							prefix = matches[1];
							elementName = matches[2];
							outputName = matches[3];
							attrData = matches[5];
	
							// Create new attributes and attributesOrder
							attributes = {};
							attributesOrder = [];
	
							// Create the new element
							element = {
								attributes: attributes,
								attributesOrder: attributesOrder
							};
	
							// Padd empty elements prefix
							if (prefix === '#') {
								element.paddEmpty = true;
							}
	
							// Remove empty elements prefix
							if (prefix === '-') {
								element.removeEmpty = true;
							}
	
							if (matches[4] === '!') {
								element.removeEmptyAttrs = true;
							}
	
							// Copy attributes from global rule into current rule
							if (globalAttributes) {
								for (key in globalAttributes) {
									attributes[key] = globalAttributes[key];
								}
	
								attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
							}
	
							// Attributes defined
							if (attrData) {
								attrData = split(attrData, '|');
								for (ai = 0, al = attrData.length; ai < al; ai++) {
									matches = attrRuleRegExp.exec(attrData[ai]);
									if (matches) {
										attr = {};
										attrType = matches[1];
										attrName = matches[2].replace(/::/g, ':');
										prefix = matches[3];
										value = matches[4];
	
										// Required
										if (attrType === '!') {
											element.attributesRequired = element.attributesRequired || [];
											element.attributesRequired.push(attrName);
											attr.required = true;
										}
	
										// Denied from global
										if (attrType === '-') {
											delete attributes[attrName];
											attributesOrder.splice(inArray(attributesOrder, attrName), 1);
											continue;
										}
	
										// Default value
										if (prefix) {
											// Default value
											if (prefix === '=') {
												element.attributesDefault = element.attributesDefault || [];
												element.attributesDefault.push({name: attrName, value: value});
												attr.defaultValue = value;
											}
	
											// Forced value
											if (prefix === ':') {
												element.attributesForced = element.attributesForced || [];
												element.attributesForced.push({name: attrName, value: value});
												attr.forcedValue = value;
											}
	
											// Required values
											if (prefix === '<') {
												attr.validValues = makeMap(value, '?');
											}
										}
	
										// Check for attribute patterns
										if (hasPatternsRegExp.test(attrName)) {
											element.attributePatterns = element.attributePatterns || [];
											attr.pattern = patternToRegExp(attrName);
											element.attributePatterns.push(attr);
										} else {
											// Add attribute to order list if it doesn't already exist
											if (!attributes[attrName]) {
												attributesOrder.push(attrName);
											}
	
											attributes[attrName] = attr;
										}
									}
								}
							}
	
							// Global rule, store away these for later usage
							if (!globalAttributes && elementName == '@') {
								globalAttributes = attributes;
								globalAttributesOrder = attributesOrder;
							}
	
							// Handle substitute elements such as b/strong
							if (outputName) {
								element.outputName = elementName;
								elements[outputName] = element;
							}
	
							// Add pattern or exact element
							if (hasPatternsRegExp.test(elementName)) {
								element.pattern = patternToRegExp(elementName);
								patternElements.push(element);
							} else {
								elements[elementName] = element;
							}
						}
					}
				}
			}
	
			function setValidElements(validElements) {
				elements = {};
				patternElements = [];
	
				addValidElements(validElements);
	
				each(schemaItems, function(element, name) {
					children[name] = element.children;
				});
			}
	
			// Adds custom non HTML elements to the schema
			function addCustomElements(customElements) {
				var customElementRegExp = /^(~)?(.+)$/;
	
				if (customElements) {
					// Flush cached items since we are altering the default maps
					mapCache.text_block_elements = mapCache.block_elements = null;
	
					each(split(customElements, ','), function(rule) {
						var matches = customElementRegExp.exec(rule),
							inline = matches[1] === '~',
							cloneName = inline ? 'span' : 'div',
							name = matches[2];
	
						children[name] = children[cloneName];
						customElementsMap[name] = cloneName;
	
						// If it's not marked as inline then add it to valid block elements
						if (!inline) {
							blockElementsMap[name.toUpperCase()] = {};
							blockElementsMap[name] = {};
						}
	
						// Add elements clone if needed
						if (!elements[name]) {
							var customRule = elements[cloneName];
	
							customRule = extend({}, customRule);
							delete customRule.removeEmptyAttrs;
							delete customRule.removeEmpty;
	
							elements[name] = customRule;
						}
	
						// Add custom elements at span/div positions
						each(children, function(element, elmName) {
							if (element[cloneName]) {
								children[elmName] = element = extend({}, children[elmName]);
								element[name] = element[cloneName];
							}
						});
					});
				}
			}
	
			// Adds valid children to the schema object
			function addValidChildren(validChildren) {
				var childRuleRegExp = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
	
				// Invalidate the schema cache if the schema is mutated
				mapCache[settings.schema] = null;
	
				if (validChildren) {
					each(split(validChildren, ','), function(rule) {
						var matches = childRuleRegExp.exec(rule), parent, prefix;
	
						if (matches) {
							prefix = matches[1];
	
							// Add/remove items from default
							if (prefix) {
								parent = children[matches[2]];
							} else {
								parent = children[matches[2]] = {'#comment': {}};
							}
	
							parent = children[matches[2]];
	
							each(split(matches[3], '|'), function(child) {
								if (prefix === '-') {
									delete parent[child];
								} else {
									parent[child] = {};
								}
							});
						}
					});
				}
			}
	
			function getElementRule(name) {
				var element = elements[name], i;
	
				// Exact match found
				if (element) {
					return element;
				}
	
				// No exact match then try the patterns
				i = patternElements.length;
				while (i--) {
					element = patternElements[i];
	
					if (element.pattern.test(name)) {
						return element;
					}
				}
			}
	
			if (!settings.valid_elements) {
				// No valid elements defined then clone the elements from the schema spec
				each(schemaItems, function(element, name) {
					elements[name] = {
						attributes: element.attributes,
						attributesOrder: element.attributesOrder
					};
	
					children[name] = element.children;
				});
	
				// Switch these on HTML4
				if (settings.schema != "html5") {
					each(split('strong/b em/i'), function(item) {
						item = split(item, '/');
						elements[item[1]].outputName = item[0];
					});
				}
	
				// Add default alt attribute for images, removed since alt="" is treated as presentational.
				// elements.img.attributesDefault = [{name: 'alt', value: ''}];
	
				// Remove these if they are empty by default
				each(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function(name) {
					if (elements[name]) {
						elements[name].removeEmpty = true;
					}
				});
	
				// Padd these by default
				each(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption'), function(name) {
					elements[name].paddEmpty = true;
				});
	
				// Remove these if they have no attributes
				each(split('span'), function(name) {
					elements[name].removeEmptyAttrs = true;
				});
	
				// Remove these by default
				// TODO: Reenable in 4.1
				/*each(split('script style'), function(name) {
					delete elements[name];
				});*/
			} else {
				setValidElements(settings.valid_elements);
			}
	
			addCustomElements(settings.custom_elements);
			addValidChildren(settings.valid_children);
			addValidElements(settings.extended_valid_elements);
	
			// Todo: Remove this when we fix list handling to be valid
			addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	
			// Delete invalid elements
			if (settings.invalid_elements) {
				each(explode(settings.invalid_elements), function(item) {
					if (elements[item]) {
						delete elements[item];
					}
				});
			}
	
			// If the user didn't allow span only allow internal spans
			if (!getElementRule('span')) {
				addValidElements('span[!data-mce-type|*]');
			}
	
			/**
			 * Name/value map object with valid parents and children to those parents.
			 *
			 * @example
			 * children = {
			 *    div:{p:{}, h1:{}}
			 * };
			 * @field children
			 * @type Object
			 */
			self.children = children;
	
			/**
			 * Name/value map object with valid styles for each element.
			 *
			 * @method getValidStyles
			 * @type Object
			 */
			self.getValidStyles = function() {
				return validStyles;
			};
	
			/**
			 * Name/value map object with valid styles for each element.
			 *
			 * @method getInvalidStyles
			 * @type Object
			 */
			self.getInvalidStyles = function() {
				return invalidStyles;
			};
	
			/**
			 * Name/value map object with valid classes for each element.
			 *
			 * @method getValidClasses
			 * @type Object
			 */
			self.getValidClasses = function() {
				return validClasses;
			};
	
			/**
			 * Returns a map with boolean attributes.
			 *
			 * @method getBoolAttrs
			 * @return {Object} Name/value lookup map for boolean attributes.
			 */
			self.getBoolAttrs = function() {
				return boolAttrMap;
			};
	
			/**
			 * Returns a map with block elements.
			 *
			 * @method getBlockElements
			 * @return {Object} Name/value lookup map for block elements.
			 */
			self.getBlockElements = function() {
				return blockElementsMap;
			};
	
			/**
			 * Returns a map with text block elements. Such as: p,h1-h6,div,address
			 *
			 * @method getTextBlockElements
			 * @return {Object} Name/value lookup map for block elements.
			 */
			self.getTextBlockElements = function() {
				return textBlockElementsMap;
			};
	
			/**
			 * Returns a map of inline text format nodes for example strong/span or ins.
			 *
			 * @method getTextInlineElements
			 * @return {Object} Name/value lookup map for text format elements.
			 */
			self.getTextInlineElements = function() {
				return textInlineElementsMap;
			};
	
			/**
			 * Returns a map with short ended elements such as BR or IMG.
			 *
			 * @method getShortEndedElements
			 * @return {Object} Name/value lookup map for short ended elements.
			 */
			self.getShortEndedElements = function() {
				return shortEndedElementsMap;
			};
	
			/**
			 * Returns a map with self closing tags such as <li>.
			 *
			 * @method getSelfClosingElements
			 * @return {Object} Name/value lookup map for self closing tags elements.
			 */
			self.getSelfClosingElements = function() {
				return selfClosingElementsMap;
			};
	
			/**
			 * Returns a map with elements that should be treated as contents regardless if it has text
			 * content in them or not such as TD, VIDEO or IMG.
			 *
			 * @method getNonEmptyElements
			 * @return {Object} Name/value lookup map for non empty elements.
			 */
			self.getNonEmptyElements = function() {
				return nonEmptyElementsMap;
			};
	
			/**
			 * Returns a map with elements that the caret should be moved in front of after enter is
			 * pressed
			 *
			 * @method getMoveCaretBeforeOnEnterElements
			 * @return {Object} Name/value lookup map for elements to place the caret in front of.
			 */
			self.getMoveCaretBeforeOnEnterElements = function() {
				return moveCaretBeforeOnEnterElementsMap;
			};
	
			/**
			 * Returns a map with elements where white space is to be preserved like PRE or SCRIPT.
			 *
			 * @method getWhiteSpaceElements
			 * @return {Object} Name/value lookup map for white space elements.
			 */
			self.getWhiteSpaceElements = function() {
				return whiteSpaceElementsMap;
			};
	
			/**
			 * Returns a map with special elements. These are elements that needs to be parsed
			 * in a special way such as script, style, textarea etc. The map object values
			 * are regexps used to find the end of the element.
			 *
			 * @method getSpecialElements
			 * @return {Object} Name/value lookup map for special elements.
			 */
			self.getSpecialElements = function() {
				return specialElements;
			};
	
			/**
			 * Returns true/false if the specified element and it's child is valid or not
			 * according to the schema.
			 *
			 * @method isValidChild
			 * @param {String} name Element name to check for.
			 * @param {String} child Element child to verify.
			 * @return {Boolean} True/false if the element is a valid child of the specified parent.
			 */
			self.isValidChild = function(name, child) {
				var parent = children[name];
	
				return !!(parent && parent[child]);
			};
	
			/**
			 * Returns true/false if the specified element name and optional attribute is
			 * valid according to the schema.
			 *
			 * @method isValid
			 * @param {String} name Name of element to check.
			 * @param {String} attr Optional attribute name to check for.
			 * @return {Boolean} True/false if the element and attribute is valid.
			 */
			self.isValid = function(name, attr) {
				var attrPatterns, i, rule = getElementRule(name);
	
				// Check if it's a valid element
				if (rule) {
					if (attr) {
						// Check if attribute name exists
						if (rule.attributes[attr]) {
							return true;
						}
	
						// Check if attribute matches a regexp pattern
						attrPatterns = rule.attributePatterns;
						if (attrPatterns) {
							i = attrPatterns.length;
							while (i--) {
								if (attrPatterns[i].pattern.test(name)) {
									return true;
								}
							}
						}
					} else {
						return true;
					}
				}
	
				// No match
				return false;
			};
	
			/**
			 * Returns true/false if the specified element is valid or not
			 * according to the schema.
			 *
			 * @method getElementRule
			 * @param {String} name Element name to check for.
			 * @return {Object} Element object or undefined if the element isn't valid.
			 */
			self.getElementRule = getElementRule;
	
			/**
			 * Returns an map object of all custom elements.
			 *
			 * @method getCustomElements
			 * @return {Object} Name/value map object of all custom elements.
			 */
			self.getCustomElements = function() {
				return customElementsMap;
			};
	
			/**
			 * Parses a valid elements string and adds it to the schema. The valid elements
			 * format is for example "element[attr=default|otherattr]".
			 * Existing rules will be replaced with the ones specified, so this extends the schema.
			 *
			 * @method addValidElements
			 * @param {String} valid_elements String in the valid elements format to be parsed.
			 */
			self.addValidElements = addValidElements;
	
			/**
			 * Parses a valid elements string and sets it to the schema. The valid elements
			 * format is for example "element[attr=default|otherattr]".
			 * Existing rules will be replaced with the ones specified, so this extends the schema.
			 *
			 * @method setValidElements
			 * @param {String} valid_elements String in the valid elements format to be parsed.
			 */
			self.setValidElements = setValidElements;
	
			/**
			 * Adds custom non HTML elements to the schema.
			 *
			 * @method addCustomElements
			 * @param {String} custom_elements Comma separated list of custom elements to add.
			 */
			self.addCustomElements = addCustomElements;
	
			/**
			 * Parses a valid children string and adds them to the schema structure. The valid children
			 * format is for example: "element[child1|child2]".
			 *
			 * @method addValidChildren
			 * @param {String} valid_children Valid children elements string to parse
			 */
			self.addValidChildren = addValidChildren;
	
			self.elements = elements;
		};
	});
	
	// Included from: js/tinymce/classes/html/SaxParser.js
	
	/**
	 * SaxParser.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint max-depth:[2, 9] */
	
	/**
	 * This class parses HTML code using pure JavaScript and executes various events for each item it finds. It will
	 * always execute the events in the right order for tag soup code like <b><p></b></p>. It will also remove elements
	 * and attributes that doesn't fit the schema if the validate setting is enabled.
	 *
	 * @example
	 * var parser = new tinymce.html.SaxParser({
	 *     validate: true,
	 *
	 *     comment: function(text) {
	 *         console.log('Comment:', text);
	 *     },
	 *
	 *     cdata: function(text) {
	 *         console.log('CDATA:', text);
	 *     },
	 *
	 *     text: function(text, raw) {
	 *         console.log('Text:', text, 'Raw:', raw);
	 *     },
	 *
	 *     start: function(name, attrs, empty) {
	 *         console.log('Start:', name, attrs, empty);
	 *     },
	 *
	 *     end: function(name) {
	 *         console.log('End:', name);
	 *     },
	 *
	 *     pi: function(name, text) {
	 *         console.log('PI:', name, text);
	 *     },
	 *
	 *     doctype: function(text) {
	 *         console.log('DocType:', text);
	 *     }
	 * }, schema);
	 * @class tinymce.html.SaxParser
	 * @version 3.4
	 */
	define("tinymce/html/SaxParser", [
		"tinymce/html/Schema",
		"tinymce/html/Entities",
		"tinymce/util/Tools"
	], function(Schema, Entities, Tools) {
		var each = Tools.each;
	
		/**
		 * Returns the index of the end tag for a specific start tag. This can be
		 * used to skip all children of a parent element from being processed.
		 *
		 * @private
		 * @method findEndTag
		 * @param {tinymce.html.Schema} schema Schema instance to use to match short ended elements.
		 * @param {String} html HTML string to find the end tag in.
		 * @param {Number} startIndex Indext to start searching at should be after the start tag.
		 * @return {Number} Index of the end tag.
		 */
		function findEndTag(schema, html, startIndex) {
			var count = 1, index, matches, tokenRegExp, shortEndedElements;
	
			shortEndedElements = schema.getShortEndedElements();
			tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
			tokenRegExp.lastIndex = index = startIndex;
	
			while ((matches = tokenRegExp.exec(html))) {
				index = tokenRegExp.lastIndex;
	
				if (matches[1] === '/') { // End element
					count--;
				} else if (!matches[1]) { // Start element
					if (matches[2] in shortEndedElements) {
						continue;
					}
	
					count++;
				}
	
				if (count === 0) {
					break;
				}
			}
	
			return index;
		}
	
		/**
		 * Constructs a new SaxParser instance.
		 *
		 * @constructor
		 * @method SaxParser
		 * @param {Object} settings Name/value collection of settings. comment, cdata, text, start and end are callbacks.
		 * @param {tinymce.html.Schema} schema HTML Schema class to use when parsing.
		 */
		function SaxParser(settings, schema) {
			var self = this;
	
			function noop() {}
	
			settings = settings || {};
			self.schema = schema = schema || new Schema();
	
			if (settings.fix_self_closing !== false) {
				settings.fix_self_closing = true;
			}
	
			// Add handler functions from settings and setup default handlers
			each('comment cdata text start end pi doctype'.split(' '), function(name) {
				if (name) {
					self[name] = settings[name] || noop;
				}
			});
	
			/**
			 * Parses the specified HTML string and executes the callbacks for each item it finds.
			 *
			 * @example
			 * new SaxParser({...}).parse('<b>text</b>');
			 * @method parse
			 * @param {String} html Html string to sax parse.
			 */
			self.parse = function(html) {
				var self = this, matches, index = 0, value, endRegExp, stack = [], attrList, i, text, name;
				var isInternalElement, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
				var validate, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
				var attributesRequired, attributesDefault, attributesForced;
				var anyAttributesRequired, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
				var decode = Entities.decode, fixSelfClosing, filteredUrlAttrs = Tools.makeMap('src,href,data,background,formaction,poster');
				var scriptUriRegExp = /((java|vb)script|mhtml):/i, dataUriRegExp = /^data:/i;
	
				function processEndTag(name) {
					var pos, i;
	
					// Find position of parent of the same type
					pos = stack.length;
					while (pos--) {
						if (stack[pos].name === name) {
							break;
						}
					}
	
					// Found parent
					if (pos >= 0) {
						// Close all the open elements
						for (i = stack.length - 1; i >= pos; i--) {
							name = stack[i];
	
							if (name.valid) {
								self.end(name.name);
							}
						}
	
						// Remove the open elements from the stack
						stack.length = pos;
					}
				}
	
				function parseAttribute(match, name, value, val2, val3) {
					var attrRule, i, trimRegExp = /[\s\u0000-\u001F]+/g;
	
					name = name.toLowerCase();
					value = name in fillAttrsMap ? name : decode(value || val2 || val3 || ''); // Handle boolean attribute than value attribute
	
					// Validate name and value pass through all data- attributes
					if (validate && !isInternalElement && name.indexOf('data-') !== 0) {
						attrRule = validAttributesMap[name];
	
						// Find rule by pattern matching
						if (!attrRule && validAttributePatterns) {
							i = validAttributePatterns.length;
							while (i--) {
								attrRule = validAttributePatterns[i];
								if (attrRule.pattern.test(name)) {
									break;
								}
							}
	
							// No rule matched
							if (i === -1) {
								attrRule = null;
							}
						}
	
						// No attribute rule found
						if (!attrRule) {
							return;
						}
	
						// Validate value
						if (attrRule.validValues && !(value in attrRule.validValues)) {
							return;
						}
					}
	
					// Block any javascript: urls or non image data uris
					if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
						var uri = value.replace(trimRegExp, '');
	
						try {
							// Might throw malformed URI sequence
							uri = decodeURIComponent(uri);
						} catch (ex) {
							// Fallback to non UTF-8 decoder
							uri = unescape(uri);
						}
	
						if (scriptUriRegExp.test(uri)) {
							return;
						}
	
						if (!settings.allow_html_data_urls && dataUriRegExp.test(uri) && !/^data:image\//i.test(uri)) {
							return;
						}
					}
	
					// Add attribute to list and map
					attrList.map[name] = value;
					attrList.push({
						name: name,
						value: value
					});
				}
	
				// Precompile RegExps and map objects
				tokenRegExp = new RegExp('<(?:' +
					'(?:!--([\\w\\W]*?)-->)|' + // Comment
					'(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + // CDATA
					'(?:!DOCTYPE([\\w\\W]*?)>)|' + // DOCTYPE
					'(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + // PI
					'(?:\\/([^>]+)>)|' + // End element
					'(?:([A-Za-z0-9\\-_\\:\\.]+)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + // Start element
				')', 'g');
	
				attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	
				// Setup lookup tables for empty elements and boolean attributes
				shortEndedElements = schema.getShortEndedElements();
				selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
				fillAttrsMap = schema.getBoolAttrs();
				validate = settings.validate;
				removeInternalElements = settings.remove_internals;
				fixSelfClosing = settings.fix_self_closing;
				specialElements = schema.getSpecialElements();
	
				while ((matches = tokenRegExp.exec(html))) {
					// Text
					if (index < matches.index) {
						self.text(decode(html.substr(index, matches.index - index)));
					}
	
					if ((value = matches[6])) { // End element
						value = value.toLowerCase();
	
						// IE will add a ":" in front of elements it doesn't understand like custom elements or HTML5 elements
						if (value.charAt(0) === ':') {
							value = value.substr(1);
						}
	
						processEndTag(value);
					} else if ((value = matches[7])) { // Start element
						value = value.toLowerCase();
	
						// IE will add a ":" in front of elements it doesn't understand like custom elements or HTML5 elements
						if (value.charAt(0) === ':') {
							value = value.substr(1);
						}
	
						isShortEnded = value in shortEndedElements;
	
						// Is self closing tag for example an <li> after an open <li>
						if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
							processEndTag(value);
						}
	
						// Validate element
						if (!validate || (elementRule = schema.getElementRule(value))) {
							isValidElement = true;
	
							// Grab attributes map and patters when validation is enabled
							if (validate) {
								validAttributesMap = elementRule.attributes;
								validAttributePatterns = elementRule.attributePatterns;
							}
	
							// Parse attributes
							if ((attribsValue = matches[8])) {
								isInternalElement = attribsValue.indexOf('data-mce-type') !== -1; // Check if the element is an internal element
	
								// If the element has internal attributes then remove it if we are told to do so
								if (isInternalElement && removeInternalElements) {
									isValidElement = false;
								}
	
								attrList = [];
								attrList.map = {};
	
								attribsValue.replace(attrRegExp, parseAttribute);
							} else {
								attrList = [];
								attrList.map = {};
							}
	
							// Process attributes if validation is enabled
							if (validate && !isInternalElement) {
								attributesRequired = elementRule.attributesRequired;
								attributesDefault = elementRule.attributesDefault;
								attributesForced = elementRule.attributesForced;
								anyAttributesRequired = elementRule.removeEmptyAttrs;
	
								// Check if any attribute exists
								if (anyAttributesRequired && !attrList.length) {
									isValidElement = false;
								}
	
								// Handle forced attributes
								if (attributesForced) {
									i = attributesForced.length;
									while (i--) {
										attr = attributesForced[i];
										name = attr.name;
										attrValue = attr.value;
	
										if (attrValue === '{$uid}') {
											attrValue = 'mce_' + idCount++;
										}
	
										attrList.map[name] = attrValue;
										attrList.push({name: name, value: attrValue});
									}
								}
	
								// Handle default attributes
								if (attributesDefault) {
									i = attributesDefault.length;
									while (i--) {
										attr = attributesDefault[i];
										name = attr.name;
	
										if (!(name in attrList.map)) {
											attrValue = attr.value;
	
											if (attrValue === '{$uid}') {
												attrValue = 'mce_' + idCount++;
											}
	
											attrList.map[name] = attrValue;
											attrList.push({name: name, value: attrValue});
										}
									}
								}
	
								// Handle required attributes
								if (attributesRequired) {
									i = attributesRequired.length;
									while (i--) {
										if (attributesRequired[i] in attrList.map) {
											break;
										}
									}
	
									// None of the required attributes where found
									if (i === -1) {
										isValidElement = false;
									}
								}
	
								// Invalidate element if it's marked as bogus
								if ((attr = attrList.map['data-mce-bogus'])) {
									if (attr === 'all') {
										index = findEndTag(schema, html, tokenRegExp.lastIndex);
										tokenRegExp.lastIndex = index;
										continue;
									}
	
									isValidElement = false;
								}
							}
	
							if (isValidElement) {
								self.start(value, attrList, isShortEnded);
							}
						} else {
							isValidElement = false;
						}
	
						// Treat script, noscript and style a bit different since they may include code that looks like elements
						if ((endRegExp = specialElements[value])) {
							endRegExp.lastIndex = index = matches.index + matches[0].length;
	
							if ((matches = endRegExp.exec(html))) {
								if (isValidElement) {
									text = html.substr(index, matches.index - index);
								}
	
								index = matches.index + matches[0].length;
							} else {
								text = html.substr(index);
								index = html.length;
							}
	
							if (isValidElement) {
								if (text.length > 0) {
									self.text(text, true);
								}
	
								self.end(value);
							}
	
							tokenRegExp.lastIndex = index;
							continue;
						}
	
						// Push value on to stack
						if (!isShortEnded) {
							if (!attribsValue || attribsValue.indexOf('/') != attribsValue.length - 1) {
								stack.push({name: value, valid: isValidElement});
							} else if (isValidElement) {
								self.end(value);
							}
						}
					} else if ((value = matches[1])) { // Comment
						// Padd comment value to avoid browsers from parsing invalid comments as HTML
						if (value.charAt(0) === '>') {
							value = ' ' + value;
						}
	
						if (!settings.allow_conditional_comments && value.substr(0, 3) === '[if') {
							value = ' ' + value;
						}
	
						self.comment(value);
					} else if ((value = matches[2])) { // CDATA
						self.cdata(value);
					} else if ((value = matches[3])) { // DOCTYPE
						self.doctype(value);
					} else if ((value = matches[4])) { // PI
						self.pi(value, matches[5]);
					}
	
					index = matches.index + matches[0].length;
				}
	
				// Text
				if (index < html.length) {
					self.text(decode(html.substr(index)));
				}
	
				// Close any open elements
				for (i = stack.length - 1; i >= 0; i--) {
					value = stack[i];
	
					if (value.valid) {
						self.end(value.name);
					}
				}
			};
		}
	
		SaxParser.findEndTag = findEndTag;
	
		return SaxParser;
	});
	
	// Included from: js/tinymce/classes/html/DomParser.js
	
	/**
	 * DomParser.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class parses HTML code into a DOM like structure of nodes it will remove redundant whitespace and make
	 * sure that the node tree is valid according to the specified schema.
	 * So for example: <p>a<p>b</p>c</p> will become <p>a</p><p>b</p><p>c</p>
	 *
	 * @example
	 * var parser = new tinymce.html.DomParser({validate: true}, schema);
	 * var rootNode = parser.parse('<h1>content</h1>');
	 *
	 * @class tinymce.html.DomParser
	 * @version 3.4
	 */
	define("tinymce/html/DomParser", [
		"tinymce/html/Node",
		"tinymce/html/Schema",
		"tinymce/html/SaxParser",
		"tinymce/util/Tools"
	], function(Node, Schema, SaxParser, Tools) {
		var makeMap = Tools.makeMap, each = Tools.each, explode = Tools.explode, extend = Tools.extend;
	
		/**
		 * Constructs a new DomParser instance.
		 *
		 * @constructor
		 * @method DomParser
		 * @param {Object} settings Name/value collection of settings. comment, cdata, text, start and end are callbacks.
		 * @param {tinymce.html.Schema} schema HTML Schema class to use when parsing.
		 */
		return function(settings, schema) {
			var self = this, nodeFilters = {}, attributeFilters = [], matchedNodes = {}, matchedAttributes = {};
	
			settings = settings || {};
			settings.validate = "validate" in settings ? settings.validate : true;
			settings.root_name = settings.root_name || 'body';
			self.schema = schema = schema || new Schema();
	
			function fixInvalidChildren(nodes) {
				var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
				var nonEmptyElements, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
	
				nonSplitableElements = makeMap('tr,td,th,tbody,thead,tfoot,table');
				nonEmptyElements = schema.getNonEmptyElements();
				textBlockElements = schema.getTextBlockElements();
				specialElements = schema.getSpecialElements();
	
				for (ni = 0; ni < nodes.length; ni++) {
					node = nodes[ni];
	
					// Already removed or fixed
					if (!node.parent || node.fixed) {
						continue;
					}
	
					// If the invalid element is a text block and the text block is within a parent LI element
					// Then unwrap the first text block and convert other sibling text blocks to LI elements similar to Word/Open Office
					if (textBlockElements[node.name] && node.parent.name == 'li') {
						// Move sibling text blocks after LI element
						sibling = node.next;
						while (sibling) {
							if (textBlockElements[sibling.name]) {
								sibling.name = 'li';
								sibling.fixed = true;
								node.parent.insert(sibling, node.parent);
							} else {
								break;
							}
	
							sibling = sibling.next;
						}
	
						// Unwrap current text block
						node.unwrap(node);
						continue;
					}
	
					// Get list of all parent nodes until we find a valid parent to stick the child into
					parents = [node];
					for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) &&
						!nonSplitableElements[parent.name]; parent = parent.parent) {
						parents.push(parent);
					}
	
					// Found a suitable parent
					if (parent && parents.length > 1) {
						// Reverse the array since it makes looping easier
						parents.reverse();
	
						// Clone the related parent and insert that after the moved node
						newParent = currentNode = self.filterNode(parents[0].clone());
	
						// Start cloning and moving children on the left side of the target node
						for (i = 0; i < parents.length - 1; i++) {
							if (schema.isValidChild(currentNode.name, parents[i].name)) {
								tempNode = self.filterNode(parents[i].clone());
								currentNode.append(tempNode);
							} else {
								tempNode = currentNode;
							}
	
							for (childNode = parents[i].firstChild; childNode && childNode != parents[i + 1];) {
								nextNode = childNode.next;
								tempNode.append(childNode);
								childNode = nextNode;
							}
	
							currentNode = tempNode;
						}
	
						if (!newParent.isEmpty(nonEmptyElements)) {
							parent.insert(newParent, parents[0], true);
							parent.insert(node, newParent);
						} else {
							parent.insert(node, parents[0], true);
						}
	
						// Check if the element is empty by looking through it's contents and special treatment for <p><br /></p>
						parent = parents[0];
						if (parent.isEmpty(nonEmptyElements) || parent.firstChild === parent.lastChild && parent.firstChild.name === 'br') {
							parent.empty().remove();
						}
					} else if (node.parent) {
						// If it's an LI try to find a UL/OL for it or wrap it
						if (node.name === 'li') {
							sibling = node.prev;
							if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
								sibling.append(node);
								continue;
							}
	
							sibling = node.next;
							if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
								sibling.insert(node, sibling.firstChild, true);
								continue;
							}
	
							node.wrap(self.filterNode(new Node('ul', 1)));
							continue;
						}
	
						// Try wrapping the element in a DIV
						if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
							node.wrap(self.filterNode(new Node('div', 1)));
						} else {
							// We failed wrapping it, then remove or unwrap it
							if (specialElements[node.name]) {
								node.empty().remove();
							} else {
								node.unwrap();
							}
						}
					}
				}
			}
	
			/**
			 * Runs the specified node though the element and attributes filters.
			 *
			 * @method filterNode
			 * @param {tinymce.html.Node} Node the node to run filters on.
			 * @return {tinymce.html.Node} The passed in node.
			 */
			self.filterNode = function(node) {
				var i, name, list;
	
				// Run element filters
				if (name in nodeFilters) {
					list = matchedNodes[name];
	
					if (list) {
						list.push(node);
					} else {
						matchedNodes[name] = [node];
					}
				}
	
				// Run attribute filters
				i = attributeFilters.length;
				while (i--) {
					name = attributeFilters[i].name;
	
					if (name in node.attributes.map) {
						list = matchedAttributes[name];
	
						if (list) {
							list.push(node);
						} else {
							matchedAttributes[name] = [node];
						}
					}
				}
	
				return node;
			};
	
			/**
			 * Adds a node filter function to the parser, the parser will collect the specified nodes by name
			 * and then execute the callback ones it has finished parsing the document.
			 *
			 * @example
			 * parser.addNodeFilter('p,h1', function(nodes, name) {
			 *		for (var i = 0; i < nodes.length; i++) {
			 *			console.log(nodes[i].name);
			 *		}
			 * });
			 * @method addNodeFilter
			 * @method {String} name Comma separated list of nodes to collect.
			 * @param {function} callback Callback function to execute once it has collected nodes.
			 */
			self.addNodeFilter = function(name, callback) {
				each(explode(name), function(name) {
					var list = nodeFilters[name];
	
					if (!list) {
						nodeFilters[name] = list = [];
					}
	
					list.push(callback);
				});
			};
	
			/**
			 * Adds a attribute filter function to the parser, the parser will collect nodes that has the specified attributes
			 * and then execute the callback ones it has finished parsing the document.
			 *
			 * @example
			 * parser.addAttributeFilter('src,href', function(nodes, name) {
			 *		for (var i = 0; i < nodes.length; i++) {
			 *			console.log(nodes[i].name);
			 *		}
			 * });
			 * @method addAttributeFilter
			 * @method {String} name Comma separated list of nodes to collect.
			 * @param {function} callback Callback function to execute once it has collected nodes.
			 */
			self.addAttributeFilter = function(name, callback) {
				each(explode(name), function(name) {
					var i;
	
					for (i = 0; i < attributeFilters.length; i++) {
						if (attributeFilters[i].name === name) {
							attributeFilters[i].callbacks.push(callback);
							return;
						}
					}
	
					attributeFilters.push({name: name, callbacks: [callback]});
				});
			};
	
			/**
			 * Parses the specified HTML string into a DOM like node tree and returns the result.
			 *
			 * @example
			 * var rootNode = new DomParser({...}).parse('<b>text</b>');
			 * @method parse
			 * @param {String} html Html string to sax parse.
			 * @param {Object} args Optional args object that gets passed to all filter functions.
			 * @return {tinymce.html.Node} Root node containing the tree.
			 */
			self.parse = function(html, args) {
				var parser, rootNode, node, nodes, i, l, fi, fl, list, name, validate;
				var blockElements, startWhiteSpaceRegExp, invalidChildren = [], isInWhiteSpacePreservedElement;
				var endWhiteSpaceRegExp, allWhiteSpaceRegExp, isAllWhiteSpaceRegExp, whiteSpaceElements;
				var children, nonEmptyElements, rootBlockName;
	
				args = args || {};
				matchedNodes = {};
				matchedAttributes = {};
				blockElements = extend(makeMap('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
				nonEmptyElements = schema.getNonEmptyElements();
				children = schema.children;
				validate = settings.validate;
				rootBlockName = "forced_root_block" in args ? args.forced_root_block : settings.forced_root_block;
	
				whiteSpaceElements = schema.getWhiteSpaceElements();
				startWhiteSpaceRegExp = /^[ \t\r\n]+/;
				endWhiteSpaceRegExp = /[ \t\r\n]+$/;
				allWhiteSpaceRegExp = /[ \t\r\n]+/g;
				isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	
				function addRootBlocks() {
					var node = rootNode.firstChild, next, rootBlockNode;
	
					// Removes whitespace at beginning and end of block so:
					// <p> x </p> -> <p>x</p>
					function trim(rootBlockNode) {
						if (rootBlockNode) {
							node = rootBlockNode.firstChild;
							if (node && node.type == 3) {
								node.value = node.value.replace(startWhiteSpaceRegExp, '');
							}
	
							node = rootBlockNode.lastChild;
							if (node && node.type == 3) {
								node.value = node.value.replace(endWhiteSpaceRegExp, '');
							}
						}
					}
	
					// Check if rootBlock is valid within rootNode for example if P is valid in H1 if H1 is the contentEditabe root
					if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
						return;
					}
	
					while (node) {
						next = node.next;
	
						if (node.type == 3 || (node.type == 1 && node.name !== 'p' &&
							!blockElements[node.name] && !node.attr('data-mce-type'))) {
							if (!rootBlockNode) {
								// Create a new root block element
								rootBlockNode = createNode(rootBlockName, 1);
								rootBlockNode.attr(settings.forced_root_block_attrs);
								rootNode.insert(rootBlockNode, node);
								rootBlockNode.append(node);
							} else {
								rootBlockNode.append(node);
							}
						} else {
							trim(rootBlockNode);
							rootBlockNode = null;
						}
	
						node = next;
					}
	
					trim(rootBlockNode);
				}
	
				function createNode(name, type) {
					var node = new Node(name, type), list;
	
					if (name in nodeFilters) {
						list = matchedNodes[name];
	
						if (list) {
							list.push(node);
						} else {
							matchedNodes[name] = [node];
						}
					}
	
					return node;
				}
	
				function removeWhitespaceBefore(node) {
					var textNode, textNodeNext, textVal, sibling, blockElements = schema.getBlockElements();
	
					for (textNode = node.prev; textNode && textNode.type === 3;) {
						textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	
						// Found a text node with non whitespace then trim that and break
						if (textVal.length > 0) {
							textNode.value = textVal;
							return;
						}
	
						textNodeNext = textNode.next;
	
						// Fix for bug #7543 where bogus nodes would produce empty
						// text nodes and these would be removed if a nested list was before it
						if (textNodeNext) {
							if (textNodeNext.type == 3 && textNodeNext.value.length) {
								textNode = textNode.prev;
								continue;
							}
	
							if (!blockElements[textNodeNext.name] && textNodeNext.name != 'script' && textNodeNext.name != 'style') {
								textNode = textNode.prev;
								continue;
							}
						}
	
						sibling = textNode.prev;
						textNode.remove();
						textNode = sibling;
					}
				}
	
				function cloneAndExcludeBlocks(input) {
					var name, output = {};
	
					for (name in input) {
						if (name !== 'li' && name != 'p') {
							output[name] = input[name];
						}
					}
	
					return output;
				}
	
				parser = new SaxParser({
					validate: validate,
					allow_script_urls: settings.allow_script_urls,
					allow_conditional_comments: settings.allow_conditional_comments,
	
					// Exclude P and LI from DOM parsing since it's treated better by the DOM parser
					self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	
					cdata: function(text) {
						node.append(createNode('#cdata', 4)).value = text;
					},
	
					text: function(text, raw) {
						var textNode;
	
						// Trim all redundant whitespace on non white space elements
						if (!isInWhiteSpacePreservedElement) {
							text = text.replace(allWhiteSpaceRegExp, ' ');
	
							if (node.lastChild && blockElements[node.lastChild.name]) {
								text = text.replace(startWhiteSpaceRegExp, '');
							}
						}
	
						// Do we need to create the node
						if (text.length !== 0) {
							textNode = createNode('#text', 3);
							textNode.raw = !!raw;
							node.append(textNode).value = text;
						}
					},
	
					comment: function(text) {
						node.append(createNode('#comment', 8)).value = text;
					},
	
					pi: function(name, text) {
						node.append(createNode(name, 7)).value = text;
						removeWhitespaceBefore(node);
					},
	
					doctype: function(text) {
						var newNode;
	
						newNode = node.append(createNode('#doctype', 10));
						newNode.value = text;
						removeWhitespaceBefore(node);
					},
	
					start: function(name, attrs, empty) {
						var newNode, attrFiltersLen, elementRule, attrName, parent;
	
						elementRule = validate ? schema.getElementRule(name) : {};
						if (elementRule) {
							newNode = createNode(elementRule.outputName || name, 1);
							newNode.attributes = attrs;
							newNode.shortEnded = empty;
	
							node.append(newNode);
	
							// Check if node is valid child of the parent node is the child is
							// unknown we don't collect it since it's probably a custom element
							parent = children[node.name];
							if (parent && children[newNode.name] && !parent[newNode.name]) {
								invalidChildren.push(newNode);
							}
	
							attrFiltersLen = attributeFilters.length;
							while (attrFiltersLen--) {
								attrName = attributeFilters[attrFiltersLen].name;
	
								if (attrName in attrs.map) {
									list = matchedAttributes[attrName];
	
									if (list) {
										list.push(newNode);
									} else {
										matchedAttributes[attrName] = [newNode];
									}
								}
							}
	
							// Trim whitespace before block
							if (blockElements[name]) {
								removeWhitespaceBefore(newNode);
							}
	
							// Change current node if the element wasn't empty i.e not <br /> or <img />
							if (!empty) {
								node = newNode;
							}
	
							// Check if we are inside a whitespace preserved element
							if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
								isInWhiteSpacePreservedElement = true;
							}
						}
					},
	
					end: function(name) {
						var textNode, elementRule, text, sibling, tempNode;
	
						elementRule = validate ? schema.getElementRule(name) : {};
						if (elementRule) {
							if (blockElements[name]) {
								if (!isInWhiteSpacePreservedElement) {
									// Trim whitespace of the first node in a block
									textNode = node.firstChild;
									if (textNode && textNode.type === 3) {
										text = textNode.value.replace(startWhiteSpaceRegExp, '');
	
										// Any characters left after trim or should we remove it
										if (text.length > 0) {
											textNode.value = text;
											textNode = textNode.next;
										} else {
											sibling = textNode.next;
											textNode.remove();
											textNode = sibling;
	
											// Remove any pure whitespace siblings
											while (textNode && textNode.type === 3) {
												text = textNode.value;
												sibling = textNode.next;
	
												if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
													textNode.remove();
													textNode = sibling;
												}
	
												textNode = sibling;
											}
										}
									}
	
									// Trim whitespace of the last node in a block
									textNode = node.lastChild;
									if (textNode && textNode.type === 3) {
										text = textNode.value.replace(endWhiteSpaceRegExp, '');
	
										// Any characters left after trim or should we remove it
										if (text.length > 0) {
											textNode.value = text;
											textNode = textNode.prev;
										} else {
											sibling = textNode.prev;
											textNode.remove();
											textNode = sibling;
	
											// Remove any pure whitespace siblings
											while (textNode && textNode.type === 3) {
												text = textNode.value;
												sibling = textNode.prev;
	
												if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
													textNode.remove();
													textNode = sibling;
												}
	
												textNode = sibling;
											}
										}
									}
								}
	
								// Trim start white space
								// Removed due to: #5424
								/*textNode = node.prev;
								if (textNode && textNode.type === 3) {
									text = textNode.value.replace(startWhiteSpaceRegExp, '');
	
									if (text.length > 0)
										textNode.value = text;
									else
										textNode.remove();
								}*/
							}
	
							// Check if we exited a whitespace preserved element
							if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
								isInWhiteSpacePreservedElement = false;
							}
	
							// Handle empty nodes
							if (elementRule.removeEmpty || elementRule.paddEmpty) {
								if (node.isEmpty(nonEmptyElements)) {
									if (elementRule.paddEmpty) {
										node.empty().append(new Node('#text', '3')).value = '\u00a0';
									} else {
										// Leave nodes that have a name like <a name="name">
										if (!node.attributes.map.name && !node.attributes.map.id) {
											tempNode = node.parent;
	
											if (blockElements[node.name]) {
												node.empty().remove();
											} else {
												node.unwrap();
											}
	
											node = tempNode;
											return;
										}
									}
								}
							}
	
							node = node.parent;
						}
					}
				}, schema);
	
				rootNode = node = new Node(args.context || settings.root_name, 11);
	
				parser.parse(html);
	
				// Fix invalid children or report invalid children in a contextual parsing
				if (validate && invalidChildren.length) {
					if (!args.context) {
						fixInvalidChildren(invalidChildren);
					} else {
						args.invalid = true;
					}
				}
	
				// Wrap nodes in the root into block elements if the root is body
				if (rootBlockName && (rootNode.name == 'body' || args.isRootContent)) {
					addRootBlocks();
				}
	
				// Run filters only when the contents is valid
				if (!args.invalid) {
					// Run node filters
					for (name in matchedNodes) {
						list = nodeFilters[name];
						nodes = matchedNodes[name];
	
						// Remove already removed children
						fi = nodes.length;
						while (fi--) {
							if (!nodes[fi].parent) {
								nodes.splice(fi, 1);
							}
						}
	
						for (i = 0, l = list.length; i < l; i++) {
							list[i](nodes, name, args);
						}
					}
	
					// Run attribute filters
					for (i = 0, l = attributeFilters.length; i < l; i++) {
						list = attributeFilters[i];
	
						if (list.name in matchedAttributes) {
							nodes = matchedAttributes[list.name];
	
							// Remove already removed children
							fi = nodes.length;
							while (fi--) {
								if (!nodes[fi].parent) {
									nodes.splice(fi, 1);
								}
							}
	
							for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
								list.callbacks[fi](nodes, list.name, args);
							}
						}
					}
				}
	
				return rootNode;
			};
	
			// Remove <br> at end of block elements Gecko and WebKit injects BR elements to
			// make it possible to place the caret inside empty blocks. This logic tries to remove
			// these elements and keep br elements that where intended to be there intact
			if (settings.remove_trailing_brs) {
				self.addNodeFilter('br', function(nodes) {
					var i, l = nodes.length, node, blockElements = extend({}, schema.getBlockElements());
					var nonEmptyElements = schema.getNonEmptyElements(), parent, lastParent, prev, prevName;
					var elementRule, textNode;
	
					// Remove brs from body element as well
					blockElements.body = 1;
	
					// Must loop forwards since it will otherwise remove all brs in <p>a<br><br><br></p>
					for (i = 0; i < l; i++) {
						node = nodes[i];
						parent = node.parent;
	
						if (blockElements[node.parent.name] && node === parent.lastChild) {
							// Loop all nodes to the left of the current node and check for other BR elements
							// excluding bookmarks since they are invisible
							prev = node.prev;
							while (prev) {
								prevName = prev.name;
	
								// Ignore bookmarks
								if (prevName !== "span" || prev.attr('data-mce-type') !== 'bookmark') {
									// Found a non BR element
									if (prevName !== "br") {
										break;
									}
	
									// Found another br it's a <br><br> structure then don't remove anything
									if (prevName === 'br') {
										node = null;
										break;
									}
								}
	
								prev = prev.prev;
							}
	
							if (node) {
								node.remove();
	
								// Is the parent to be considered empty after we removed the BR
								if (parent.isEmpty(nonEmptyElements)) {
									elementRule = schema.getElementRule(parent.name);
	
									// Remove or padd the element depending on schema rule
									if (elementRule) {
										if (elementRule.removeEmpty) {
											parent.remove();
										} else if (elementRule.paddEmpty) {
											parent.empty().append(new Node('#text', 3)).value = '\u00a0';
										}
									}
								}
							}
						} else {
							// Replaces BR elements inside inline elements like <p><b><i><br></i></b></p>
							// so they become <p><b><i>&nbsp;</i></b></p>
							lastParent = node;
							while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
								lastParent = parent;
	
								if (blockElements[parent.name]) {
									break;
								}
	
								parent = parent.parent;
							}
	
							if (lastParent === parent) {
								textNode = new Node('#text', 3);
								textNode.value = '\u00a0';
								node.replace(textNode);
							}
						}
					}
				});
			}
	
			// Force anchor names closed, unless the setting "allow_html_in_named_anchor" is explicitly included.
			if (!settings.allow_html_in_named_anchor) {
				self.addAttributeFilter('id,name', function(nodes) {
					var i = nodes.length, sibling, prevSibling, parent, node;
	
					while (i--) {
						node = nodes[i];
						if (node.name === 'a' && node.firstChild && !node.attr('href')) {
							parent = node.parent;
	
							// Move children after current node
							sibling = node.lastChild;
							do {
								prevSibling = sibling.prev;
								parent.insert(sibling, node);
								sibling = prevSibling;
							} while (sibling);
						}
					}
				});
			}
	
			if (settings.validate && schema.getValidClasses()) {
				self.addAttributeFilter('class', function(nodes) {
					var i = nodes.length, node, classList, ci, className, classValue;
					var validClasses = schema.getValidClasses(), validClassesMap, valid;
	
					while (i--) {
						node = nodes[i];
						classList = node.attr('class').split(' ');
						classValue = '';
	
						for (ci = 0; ci < classList.length; ci++) {
							className = classList[ci];
							valid = false;
	
							validClassesMap = validClasses['*'];
							if (validClassesMap && validClassesMap[className]) {
								valid = true;
							}
	
							validClassesMap = validClasses[node.name];
							if (!valid && validClassesMap && validClassesMap[className]) {
								valid = true;
							}
	
							if (valid) {
								if (classValue) {
									classValue += ' ';
								}
	
								classValue += className;
							}
						}
	
						if (!classValue.length) {
							classValue = null;
						}
	
						node.attr('class', classValue);
					}
				});
			}
		};
	});
	
	// Included from: js/tinymce/classes/html/Writer.js
	
	/**
	 * Writer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to write HTML tags out it can be used with the Serializer or the SaxParser.
	 *
	 * @class tinymce.html.Writer
	 * @example
	 * var writer = new tinymce.html.Writer({indent: true});
	 * var parser = new tinymce.html.SaxParser(writer).parse('<p><br></p>');
	 * console.log(writer.getContent());
	 *
	 * @class tinymce.html.Writer
	 * @version 3.4
	 */
	define("tinymce/html/Writer", [
		"tinymce/html/Entities",
		"tinymce/util/Tools"
	], function(Entities, Tools) {
		var makeMap = Tools.makeMap;
	
		/**
		 * Constructs a new Writer instance.
		 *
		 * @constructor
		 * @method Writer
		 * @param {Object} settings Name/value settings object.
		 */
		return function(settings) {
			var html = [], indent, indentBefore, indentAfter, encode, htmlOutput;
	
			settings = settings || {};
			indent = settings.indent;
			indentBefore = makeMap(settings.indent_before || '');
			indentAfter = makeMap(settings.indent_after || '');
			encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
			htmlOutput = settings.element_format == "html";
	
			return {
				/**
				 * Writes the a start element such as <p id="a">.
				 *
				 * @method start
				 * @param {String} name Name of the element.
				 * @param {Array} attrs Optional attribute array or undefined if it hasn't any.
				 * @param {Boolean} empty Optional empty state if the tag should end like <br />.
				 */
				start: function(name, attrs, empty) {
					var i, l, attr, value;
	
					if (indent && indentBefore[name] && html.length > 0) {
						value = html[html.length - 1];
	
						if (value.length > 0 && value !== '\n') {
							html.push('\n');
						}
					}
	
					html.push('<', name);
	
					if (attrs) {
						for (i = 0, l = attrs.length; i < l; i++) {
							attr = attrs[i];
							html.push(' ', attr.name, '="', encode(attr.value, true), '"');
						}
					}
	
					if (!empty || htmlOutput) {
						html[html.length] = '>';
					} else {
						html[html.length] = ' />';
					}
	
					if (empty && indent && indentAfter[name] && html.length > 0) {
						value = html[html.length - 1];
	
						if (value.length > 0 && value !== '\n') {
							html.push('\n');
						}
					}
				},
	
				/**
				 * Writes the a end element such as </p>.
				 *
				 * @method end
				 * @param {String} name Name of the element.
				 */
				end: function(name) {
					var value;
	
					/*if (indent && indentBefore[name] && html.length > 0) {
						value = html[html.length - 1];
	
						if (value.length > 0 && value !== '\n')
							html.push('\n');
					}*/
	
					html.push('</', name, '>');
	
					if (indent && indentAfter[name] && html.length > 0) {
						value = html[html.length - 1];
	
						if (value.length > 0 && value !== '\n') {
							html.push('\n');
						}
					}
				},
	
				/**
				 * Writes a text node.
				 *
				 * @method text
				 * @param {String} text String to write out.
				 * @param {Boolean} raw Optional raw state if true the contents wont get encoded.
				 */
				text: function(text, raw) {
					if (text.length > 0) {
						html[html.length] = raw ? text : encode(text);
					}
				},
	
				/**
				 * Writes a cdata node such as <![CDATA[data]]>.
				 *
				 * @method cdata
				 * @param {String} text String to write out inside the cdata.
				 */
				cdata: function(text) {
					html.push('<![CDATA[', text, ']]>');
				},
	
				/**
				 * Writes a comment node such as <!-- Comment -->.
				 *
				 * @method cdata
				 * @param {String} text String to write out inside the comment.
				 */
				comment: function(text) {
					html.push('<!--', text, '-->');
				},
	
				/**
				 * Writes a PI node such as <?xml attr="value" ?>.
				 *
				 * @method pi
				 * @param {String} name Name of the pi.
				 * @param {String} text String to write out inside the pi.
				 */
				pi: function(name, text) {
					if (text) {
						html.push('<?', name, ' ', encode(text), '?>');
					} else {
						html.push('<?', name, '?>');
					}
	
					if (indent) {
						html.push('\n');
					}
				},
	
				/**
				 * Writes a doctype node such as <!DOCTYPE data>.
				 *
				 * @method doctype
				 * @param {String} text String to write out inside the doctype.
				 */
				doctype: function(text) {
					html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
				},
	
				/**
				 * Resets the internal buffer if one wants to reuse the writer.
				 *
				 * @method reset
				 */
				reset: function() {
					html.length = 0;
				},
	
				/**
				 * Returns the contents that got serialized.
				 *
				 * @method getContent
				 * @return {String} HTML contents that got written down.
				 */
				getContent: function() {
					return html.join('').replace(/\n$/, '');
				}
			};
		};
	});
	
	// Included from: js/tinymce/classes/html/Serializer.js
	
	/**
	 * Serializer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to serialize down the DOM tree into a string using a Writer instance.
	 *
	 *
	 * @example
	 * new tinymce.html.Serializer().serialize(new tinymce.html.DomParser().parse('<p>text</p>'));
	 * @class tinymce.html.Serializer
	 * @version 3.4
	 */
	define("tinymce/html/Serializer", [
		"tinymce/html/Writer",
		"tinymce/html/Schema"
	], function(Writer, Schema) {
		/**
		 * Constructs a new Serializer instance.
		 *
		 * @constructor
		 * @method Serializer
		 * @param {Object} settings Name/value settings object.
		 * @param {tinymce.html.Schema} schema Schema instance to use.
		 */
		return function(settings, schema) {
			var self = this, writer = new Writer(settings);
	
			settings = settings || {};
			settings.validate = "validate" in settings ? settings.validate : true;
	
			self.schema = schema = schema || new Schema();
			self.writer = writer;
	
			/**
			 * Serializes the specified node into a string.
			 *
			 * @example
			 * new tinymce.html.Serializer().serialize(new tinymce.html.DomParser().parse('<p>text</p>'));
			 * @method serialize
			 * @param {tinymce.html.Node} node Node instance to serialize.
			 * @return {String} String with HTML based on DOM tree.
			 */
			self.serialize = function(node) {
				var handlers, validate;
	
				validate = settings.validate;
	
				handlers = {
					// #text
					3: function(node) {
						writer.text(node.value, node.raw);
					},
	
					// #comment
					8: function(node) {
						writer.comment(node.value);
					},
	
					// Processing instruction
					7: function(node) {
						writer.pi(node.name, node.value);
					},
	
					// Doctype
					10: function(node) {
						writer.doctype(node.value);
					},
	
					// CDATA
					4: function(node) {
						writer.cdata(node.value);
					},
	
					// Document fragment
					11: function(node) {
						if ((node = node.firstChild)) {
							do {
								walk(node);
							} while ((node = node.next));
						}
					}
				};
	
				writer.reset();
	
				function walk(node) {
					var handler = handlers[node.type], name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
	
					if (!handler) {
						name = node.name;
						isEmpty = node.shortEnded;
						attrs = node.attributes;
	
						// Sort attributes
						if (validate && attrs && attrs.length > 1) {
							sortedAttrs = [];
							sortedAttrs.map = {};
	
							elementRule = schema.getElementRule(node.name);
							if (elementRule) {
								for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
									attrName = elementRule.attributesOrder[i];
	
									if (attrName in attrs.map) {
										attrValue = attrs.map[attrName];
										sortedAttrs.map[attrName] = attrValue;
										sortedAttrs.push({name: attrName, value: attrValue});
									}
								}
	
								for (i = 0, l = attrs.length; i < l; i++) {
									attrName = attrs[i].name;
	
									if (!(attrName in sortedAttrs.map)) {
										attrValue = attrs.map[attrName];
										sortedAttrs.map[attrName] = attrValue;
										sortedAttrs.push({name: attrName, value: attrValue});
									}
								}
	
								attrs = sortedAttrs;
							}
						}
	
						writer.start(node.name, attrs, isEmpty);
	
						if (!isEmpty) {
							if ((node = node.firstChild)) {
								do {
									walk(node);
								} while ((node = node.next));
							}
	
							writer.end(name);
						}
					} else {
						handler(node);
					}
				}
	
				// Serialize element and treat all non elements as fragments
				if (node.type == 1 && !settings.inner) {
					walk(node);
				} else {
					handlers[11](node);
				}
	
				return writer.getContent();
			};
		};
	});
	
	// Included from: js/tinymce/classes/dom/Serializer.js
	
	/**
	 * Serializer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to serialize DOM trees into a string. Consult the TinyMCE Wiki API for
	 * more details and examples on how to use this class.
	 *
	 * @class tinymce.dom.Serializer
	 */
	define("tinymce/dom/Serializer", [
		"tinymce/dom/DOMUtils",
		"tinymce/html/DomParser",
		"tinymce/html/SaxParser",
		"tinymce/html/Entities",
		"tinymce/html/Serializer",
		"tinymce/html/Node",
		"tinymce/html/Schema",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/text/Zwsp"
	], function(DOMUtils, DomParser, SaxParser, Entities, Serializer, Node, Schema, Env, Tools, Zwsp) {
		var each = Tools.each, trim = Tools.trim;
		var DOM = DOMUtils.DOM, tempAttrs = ["data-mce-selected"];
	
		/**
		 * IE 11 has a fantastic bug where it will produce two trailing BR elements to iframe bodies when
		 * the iframe is hidden by display: none on a parent container. The DOM is actually out of sync
		 * with innerHTML in this case. It's like IE adds shadow DOM BR elements that appears on innerHTML
		 * but not as the lastChild of the body. So this fix simply removes the last two
		 * BR elements at the end of the document.
		 *
		 * Example of what happens: <body>text</body> becomes <body>text<br><br></body>
		 */
		function trimTrailingBr(rootNode) {
			var brNode1, brNode2;
	
			function isBr(node) {
				return node && node.name === 'br';
			}
	
			brNode1 = rootNode.lastChild;
			if (isBr(brNode1)) {
				brNode2 = brNode1.prev;
	
				if (isBr(brNode2)) {
					brNode1.remove();
					brNode2.remove();
				}
			}
		}
	
		/**
		 * Constructs a new DOM serializer class.
		 *
		 * @constructor
		 * @method Serializer
		 * @param {Object} settings Serializer settings object.
		 * @param {tinymce.Editor} editor Optional editor to bind events to and get schema/dom from.
		 */
		return function(settings, editor) {
			var dom, schema, htmlParser;
	
			if (editor) {
				dom = editor.dom;
				schema = editor.schema;
			}
	
			function trimHtml(html) {
				var trimContentRegExp = new RegExp([
					'<span[^>]+data-mce-bogus[^>]+>[\u200B\uFEFF]+<\\/span>', // Trim bogus spans like caret containers
					'\\s?(' + tempAttrs.join('|') + ')="[^"]+"' // Trim temporaty data-mce prefixed attributes like data-mce-selected
				].join('|'), 'gi');
	
				html = Zwsp.trim(html.replace(trimContentRegExp, ''));
	
				return html;
			}
	
			/**
			 * Returns a trimmed version of the editor contents to be used for the undo level. This
			 * will remove any data-mce-bogus="all" marked elements since these are used for UI it will also
			 * remove the data-mce-selected attributes used for selection of objects and caret containers.
			 * It will keep all data-mce-bogus="1" elements since these can be used to place the caret etc and will
			 * be removed by the serialization logic when you save.
			 *
			 * @private
			 * @return {String} HTML contents of the editor excluding some internal bogus elements.
			 */
			function getTrimmedContent() {
				var content = editor.getBody().innerHTML;
				var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
				var endTagIndex, index, matchLength, matches, shortEndedElements, schema = editor.schema;
	
				content = trimHtml(content);
				shortEndedElements = schema.getShortEndedElements();
	
				// Remove all bogus elements marked with "all"
				while ((matches = bogusAllRegExp.exec(content))) {
					index = bogusAllRegExp.lastIndex;
					matchLength = matches[0].length;
	
					if (shortEndedElements[matches[1]]) {
						endTagIndex = index;
					} else {
						endTagIndex = SaxParser.findEndTag(schema, content, index);
					}
	
					content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
					bogusAllRegExp.lastIndex = index - matchLength;
				}
	
				return trim(content);
			}
	
			function addTempAttr(name) {
				if (Tools.inArray(tempAttrs, name) === -1) {
					htmlParser.addAttributeFilter(name, function(nodes, name) {
						var i = nodes.length;
	
						while (i--) {
							nodes[i].attr(name, null);
						}
					});
	
					tempAttrs.push(name);
				}
			}
	
			// Default DOM and Schema if they are undefined
			dom = dom || DOM;
			schema = schema || new Schema(settings);
			settings.entity_encoding = settings.entity_encoding || 'named';
			settings.remove_trailing_brs = "remove_trailing_brs" in settings ? settings.remove_trailing_brs : true;
	
			htmlParser = new DomParser(settings, schema);
	
			// Convert tabindex back to elements when serializing contents
			htmlParser.addAttributeFilter('data-mce-tabindex', function(nodes, name) {
				var i = nodes.length, node;
	
				while (i--) {
					node = nodes[i];
					node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
					node.attr(name, null);
				}
			});
	
			// Convert move data-mce-src, data-mce-href and data-mce-style into nodes or process them if needed
			htmlParser.addAttributeFilter('src,href,style', function(nodes, name) {
				var i = nodes.length, node, value, internalName = 'data-mce-' + name;
				var urlConverter = settings.url_converter, urlConverterScope = settings.url_converter_scope, undef;
	
				while (i--) {
					node = nodes[i];
	
					value = node.attributes.map[internalName];
					if (value !== undef) {
						// Set external name to internal value and remove internal
						node.attr(name, value.length > 0 ? value : null);
						node.attr(internalName, null);
					} else {
						// No internal attribute found then convert the value we have in the DOM
						value = node.attributes.map[name];
	
						if (name === "style") {
							value = dom.serializeStyle(dom.parseStyle(value), node.name);
						} else if (urlConverter) {
							value = urlConverter.call(urlConverterScope, value, name, node.name);
						}
	
						node.attr(name, value.length > 0 ? value : null);
					}
				}
			});
	
			// Remove internal classes mceItem<..> or mceSelected
			htmlParser.addAttributeFilter('class', function(nodes) {
				var i = nodes.length, node, value;
	
				while (i--) {
					node = nodes[i];
					value = node.attr('class');
	
					if (value) {
						value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
						node.attr('class', value.length > 0 ? value : null);
					}
				}
			});
	
			// Remove bookmark elements
			htmlParser.addAttributeFilter('data-mce-type', function(nodes, name, args) {
				var i = nodes.length, node;
	
				while (i--) {
					node = nodes[i];
	
					if (node.attributes.map['data-mce-type'] === 'bookmark' && !args.cleanup) {
						node.remove();
					}
				}
			});
	
			htmlParser.addNodeFilter('noscript', function(nodes) {
				var i = nodes.length, node;
	
				while (i--) {
					node = nodes[i].firstChild;
	
					if (node) {
						node.value = Entities.decode(node.value);
					}
				}
			});
	
			// Force script into CDATA sections and remove the mce- prefix also add comments around styles
			htmlParser.addNodeFilter('script,style', function(nodes, name) {
				var i = nodes.length, node, value, type;
	
				function trim(value) {
					/*jshint maxlen:255 */
					/*eslint max-len:0 */
					return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
							.replace(/^[\r\n]*|[\r\n]*$/g, '')
							.replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
							.replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
				}
	
				while (i--) {
					node = nodes[i];
					value = node.firstChild ? node.firstChild.value : '';
	
					if (name === "script") {
						// Remove mce- prefix from script elements and remove default type since the user specified
						// a script element without type attribute
						type = node.attr('type');
						if (type) {
							node.attr('type', type == 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
						}
	
						if (value.length > 0) {
							node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
						}
					} else {
						if (value.length > 0) {
							node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
						}
					}
				}
			});
	
			// Convert comments to cdata and handle protected comments
			htmlParser.addNodeFilter('#comment', function(nodes) {
				var i = nodes.length, node;
	
				while (i--) {
					node = nodes[i];
	
					if (node.value.indexOf('[CDATA[') === 0) {
						node.name = '#cdata';
						node.type = 4;
						node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '');
					} else if (node.value.indexOf('mce:protected ') === 0) {
						node.name = "#text";
						node.type = 3;
						node.raw = true;
						node.value = unescape(node.value).substr(14);
					}
				}
			});
	
			htmlParser.addNodeFilter('xml:namespace,input', function(nodes, name) {
				var i = nodes.length, node;
	
				while (i--) {
					node = nodes[i];
					if (node.type === 7) {
						node.remove();
					} else if (node.type === 1) {
						if (name === "input" && !("type" in node.attributes.map)) {
							node.attr('type', 'text');
						}
					}
				}
			});
	
			// Fix list elements, TODO: Replace this later
			if (settings.fix_list_elements) {
				htmlParser.addNodeFilter('ul,ol', function(nodes) {
					var i = nodes.length, node, parentNode;
	
					while (i--) {
						node = nodes[i];
						parentNode = node.parent;
	
						if (parentNode.name === 'ul' || parentNode.name === 'ol') {
							if (node.prev && node.prev.name === 'li') {
								node.prev.append(node);
							}
						}
					}
				});
			}
	
			// Remove internal data attributes
			htmlParser.addAttributeFilter(
				'data-mce-src,data-mce-href,data-mce-style,' +
				'data-mce-selected,data-mce-expando,' +
				'data-mce-type,data-mce-resize',
	
				function(nodes, name) {
					var i = nodes.length;
	
					while (i--) {
						nodes[i].attr(name, null);
					}
				}
			);
	
			// Return public methods
			return {
				/**
				 * Schema instance that was used to when the Serializer was constructed.
				 *
				 * @field {tinymce.html.Schema} schema
				 */
				schema: schema,
	
				/**
				 * Adds a node filter function to the parser used by the serializer, the parser will collect the specified nodes by name
				 * and then execute the callback ones it has finished parsing the document.
				 *
				 * @example
				 * parser.addNodeFilter('p,h1', function(nodes, name) {
				 *		for (var i = 0; i < nodes.length; i++) {
				 *			console.log(nodes[i].name);
				 *		}
				 * });
				 * @method addNodeFilter
				 * @method {String} name Comma separated list of nodes to collect.
				 * @param {function} callback Callback function to execute once it has collected nodes.
				 */
				addNodeFilter: htmlParser.addNodeFilter,
	
				/**
				 * Adds a attribute filter function to the parser used by the serializer, the parser will
				 * collect nodes that has the specified attributes
				 * and then execute the callback ones it has finished parsing the document.
				 *
				 * @example
				 * parser.addAttributeFilter('src,href', function(nodes, name) {
				 *		for (var i = 0; i < nodes.length; i++) {
				 *			console.log(nodes[i].name);
				 *		}
				 * });
				 * @method addAttributeFilter
				 * @method {String} name Comma separated list of nodes to collect.
				 * @param {function} callback Callback function to execute once it has collected nodes.
				 */
				addAttributeFilter: htmlParser.addAttributeFilter,
	
				/**
				 * Serializes the specified browser DOM node into a HTML string.
				 *
				 * @method serialize
				 * @param {DOMNode} node DOM node to serialize.
				 * @param {Object} args Arguments option that gets passed to event handlers.
				 */
				serialize: function(node, args) {
					var self = this, impl, doc, oldDoc, htmlSerializer, content, rootNode;
	
					// Explorer won't clone contents of script and style and the
					// selected index of select elements are cleared on a clone operation.
					if (Env.ie && dom.select('script,style,select,map').length > 0) {
						content = node.innerHTML;
						node = node.cloneNode(false);
						dom.setHTML(node, content);
					} else {
						node = node.cloneNode(true);
					}
	
					// Nodes needs to be attached to something in WebKit/Opera
					// This fix will make DOM ranges and make Sizzle happy!
					impl = document.implementation;
					if (impl.createHTMLDocument) {
						// Create an empty HTML document
						doc = impl.createHTMLDocument("");
	
						// Add the element or it's children if it's a body element to the new document
						each(node.nodeName == 'BODY' ? node.childNodes : [node], function(node) {
							doc.body.appendChild(doc.importNode(node, true));
						});
	
						// Grab first child or body element for serialization
						if (node.nodeName != 'BODY') {
							node = doc.body.firstChild;
						} else {
							node = doc.body;
						}
	
						// set the new document in DOMUtils so createElement etc works
						oldDoc = dom.doc;
						dom.doc = doc;
					}
	
					args = args || {};
					args.format = args.format || 'html';
	
					// Don't wrap content if we want selected html
					if (args.selection) {
						args.forced_root_block = '';
					}
	
					// Pre process
					if (!args.no_events) {
						args.node = node;
						self.onPreProcess(args);
					}
	
					// Parse HTML
					rootNode = htmlParser.parse(trim(args.getInner ? node.innerHTML : dom.getOuterHTML(node)), args);
					trimTrailingBr(rootNode);
	
					// Serialize HTML
					htmlSerializer = new Serializer(settings, schema);
					args.content = htmlSerializer.serialize(rootNode);
	
					// Replace all BOM characters for now until we can find a better solution
					if (!args.cleanup) {
						args.content = Zwsp.trim(args.content);
						args.content = args.content.replace(/\uFEFF/g, '');
					}
	
					// Post process
					if (!args.no_events) {
						self.onPostProcess(args);
					}
	
					// Restore the old document if it was changed
					if (oldDoc) {
						dom.doc = oldDoc;
					}
	
					args.node = null;
	
					return args.content;
				},
	
				/**
				 * Adds valid elements rules to the serializers schema instance this enables you to specify things
				 * like what elements should be outputted and what attributes specific elements might have.
				 * Consult the Wiki for more details on this format.
				 *
				 * @method addRules
				 * @param {String} rules Valid elements rules string to add to schema.
				 */
				addRules: function(rules) {
					schema.addValidElements(rules);
				},
	
				/**
				 * Sets the valid elements rules to the serializers schema instance this enables you to specify things
				 * like what elements should be outputted and what attributes specific elements might have.
				 * Consult the Wiki for more details on this format.
				 *
				 * @method setRules
				 * @param {String} rules Valid elements rules string.
				 */
				setRules: function(rules) {
					schema.setValidElements(rules);
				},
	
				onPreProcess: function(args) {
					if (editor) {
						editor.fire('PreProcess', args);
					}
				},
	
				onPostProcess: function(args) {
					if (editor) {
						editor.fire('PostProcess', args);
					}
				},
	
				/**
				 * Adds a temporary internal attribute these attributes will get removed on undo and
				 * when getting contents out of the editor.
				 *
				 * @method addTempAttr
				 * @param {String} name string
				 */
				addTempAttr: addTempAttr,
	
				// Internal
				trimHtml: trimHtml,
				getTrimmedContent: getTrimmedContent
			};
		};
	});
	
	// Included from: js/tinymce/classes/dom/TridentSelection.js
	
	/**
	 * TridentSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Selection class for old explorer versions. This one fakes the
	 * native selection object available on modern browsers.
	 *
	 * @private
	 * @class tinymce.dom.TridentSelection
	 */
	define("tinymce/dom/TridentSelection", [], function() {
		function Selection(selection) {
			var self = this, dom = selection.dom, FALSE = false;
	
			function getPosition(rng, start) {
				var checkRng, startIndex = 0, endIndex, inside,
					children, child, offset, index, position = -1, parent;
	
				// Setup test range, collapse it and get the parent
				checkRng = rng.duplicate();
				checkRng.collapse(start);
				parent = checkRng.parentElement();
	
				// Check if the selection is within the right document
				if (parent.ownerDocument !== selection.dom.doc) {
					return;
				}
	
				// IE will report non editable elements as it's parent so look for an editable one
				while (parent.contentEditable === "false") {
					parent = parent.parentNode;
				}
	
				// If parent doesn't have any children then return that we are inside the element
				if (!parent.hasChildNodes()) {
					return {node: parent, inside: 1};
				}
	
				// Setup node list and endIndex
				children = parent.children;
				endIndex = children.length - 1;
	
				// Perform a binary search for the position
				while (startIndex <= endIndex) {
					index = Math.floor((startIndex + endIndex) / 2);
	
					// Move selection to node and compare the ranges
					child = children[index];
					checkRng.moveToElementText(child);
					position = checkRng.compareEndPoints(start ? 'StartToStart' : 'EndToEnd', rng);
	
					// Before/after or an exact match
					if (position > 0) {
						endIndex = index - 1;
					} else if (position < 0) {
						startIndex = index + 1;
					} else {
						return {node: child};
					}
				}
	
				// Check if child position is before or we didn't find a position
				if (position < 0) {
					// No element child was found use the parent element and the offset inside that
					if (!child) {
						checkRng.moveToElementText(parent);
						checkRng.collapse(true);
						child = parent;
						inside = true;
					} else {
						checkRng.collapse(false);
					}
	
					// Walk character by character in text node until we hit the selected range endpoint,
					// hit the end of document or parent isn't the right one
					// We need to walk char by char since rng.text or rng.htmlText will trim line endings
					offset = 0;
					while (checkRng.compareEndPoints(start ? 'StartToStart' : 'StartToEnd', rng) !== 0) {
						if (checkRng.move('character', 1) === 0 || parent != checkRng.parentElement()) {
							break;
						}
	
						offset++;
					}
				} else {
					// Child position is after the selection endpoint
					checkRng.collapse(true);
	
					// Walk character by character in text node until we hit the selected range endpoint, hit
					// the end of document or parent isn't the right one
					offset = 0;
					while (checkRng.compareEndPoints(start ? 'StartToStart' : 'StartToEnd', rng) !== 0) {
						if (checkRng.move('character', -1) === 0 || parent != checkRng.parentElement()) {
							break;
						}
	
						offset++;
					}
				}
	
				return {node: child, position: position, offset: offset, inside: inside};
			}
	
			// Returns a W3C DOM compatible range object by using the IE Range API
			function getRange() {
				var ieRange = selection.getRng(), domRange = dom.createRng(), element, collapsed, tmpRange, element2, bookmark;
	
				// If selection is outside the current document just return an empty range
				element = ieRange.item ? ieRange.item(0) : ieRange.parentElement();
				if (element.ownerDocument != dom.doc) {
					return domRange;
				}
	
				collapsed = selection.isCollapsed();
	
				// Handle control selection
				if (ieRange.item) {
					domRange.setStart(element.parentNode, dom.nodeIndex(element));
					domRange.setEnd(domRange.startContainer, domRange.startOffset + 1);
	
					return domRange;
				}
	
				function findEndPoint(start) {
					var endPoint = getPosition(ieRange, start), container, offset, textNodeOffset = 0, sibling, undef, nodeValue;
	
					container = endPoint.node;
					offset = endPoint.offset;
	
					if (endPoint.inside && !container.hasChildNodes()) {
						domRange[start ? 'setStart' : 'setEnd'](container, 0);
						return;
					}
	
					if (offset === undef) {
						domRange[start ? 'setStartBefore' : 'setEndAfter'](container);
						return;
					}
	
					if (endPoint.position < 0) {
						sibling = endPoint.inside ? container.firstChild : container.nextSibling;
	
						if (!sibling) {
							domRange[start ? 'setStartAfter' : 'setEndAfter'](container);
							return;
						}
	
						if (!offset) {
							if (sibling.nodeType == 3) {
								domRange[start ? 'setStart' : 'setEnd'](sibling, 0);
							} else {
								domRange[start ? 'setStartBefore' : 'setEndBefore'](sibling);
							}
	
							return;
						}
	
						// Find the text node and offset
						while (sibling) {
							if (sibling.nodeType == 3) {
								nodeValue = sibling.nodeValue;
								textNodeOffset += nodeValue.length;
	
								// We are at or passed the position we where looking for
								if (textNodeOffset >= offset) {
									container = sibling;
									textNodeOffset -= offset;
									textNodeOffset = nodeValue.length - textNodeOffset;
									break;
								}
							}
	
							sibling = sibling.nextSibling;
						}
					} else {
						// Find the text node and offset
						sibling = container.previousSibling;
	
						if (!sibling) {
							return domRange[start ? 'setStartBefore' : 'setEndBefore'](container);
						}
	
						// If there isn't any text to loop then use the first position
						if (!offset) {
							if (container.nodeType == 3) {
								domRange[start ? 'setStart' : 'setEnd'](sibling, container.nodeValue.length);
							} else {
								domRange[start ? 'setStartAfter' : 'setEndAfter'](sibling);
							}
	
							return;
						}
	
						while (sibling) {
							if (sibling.nodeType == 3) {
								textNodeOffset += sibling.nodeValue.length;
	
								// We are at or passed the position we where looking for
								if (textNodeOffset >= offset) {
									container = sibling;
									textNodeOffset -= offset;
									break;
								}
							}
	
							sibling = sibling.previousSibling;
						}
					}
	
					domRange[start ? 'setStart' : 'setEnd'](container, textNodeOffset);
				}
	
				try {
					// Find start point
					findEndPoint(true);
	
					// Find end point if needed
					if (!collapsed) {
						findEndPoint();
					}
				} catch (ex) {
					// IE has a nasty bug where text nodes might throw "invalid argument" when you
					// access the nodeValue or other properties of text nodes. This seems to happen when
					// text nodes are split into two nodes by a delete/backspace call.
					// So let us detect and try to fix it.
					if (ex.number == -2147024809) {
						// Get the current selection
						bookmark = self.getBookmark(2);
	
						// Get start element
						tmpRange = ieRange.duplicate();
						tmpRange.collapse(true);
						element = tmpRange.parentElement();
	
						// Get end element
						if (!collapsed) {
							tmpRange = ieRange.duplicate();
							tmpRange.collapse(false);
							element2 = tmpRange.parentElement();
							element2.innerHTML = element2.innerHTML;
						}
	
						// Remove the broken elements
						element.innerHTML = element.innerHTML;
	
						// Restore the selection
						self.moveToBookmark(bookmark);
	
						// Since the range has moved we need to re-get it
						ieRange = selection.getRng();
	
						// Find start point
						findEndPoint(true);
	
						// Find end point if needed
						if (!collapsed) {
							findEndPoint();
						}
					} else {
						throw ex; // Throw other errors
					}
				}
	
				return domRange;
			}
	
			this.getBookmark = function(type) {
				var rng = selection.getRng(), bookmark = {};
	
				function getIndexes(node) {
					var parent, root, children, i, indexes = [];
	
					parent = node.parentNode;
					root = dom.getRoot().parentNode;
	
					while (parent != root && parent.nodeType !== 9) {
						children = parent.children;
	
						i = children.length;
						while (i--) {
							if (node === children[i]) {
								indexes.push(i);
								break;
							}
						}
	
						node = parent;
						parent = parent.parentNode;
					}
	
					return indexes;
				}
	
				function getBookmarkEndPoint(start) {
					var position;
	
					position = getPosition(rng, start);
					if (position) {
						return {
							position: position.position,
							offset: position.offset,
							indexes: getIndexes(position.node),
							inside: position.inside
						};
					}
				}
	
				// Non ubstructive bookmark
				if (type === 2) {
					// Handle text selection
					if (!rng.item) {
						bookmark.start = getBookmarkEndPoint(true);
	
						if (!selection.isCollapsed()) {
							bookmark.end = getBookmarkEndPoint();
						}
					} else {
						bookmark.start = {ctrl: true, indexes: getIndexes(rng.item(0))};
					}
				}
	
				return bookmark;
			};
	
			this.moveToBookmark = function(bookmark) {
				var rng, body = dom.doc.body;
	
				function resolveIndexes(indexes) {
					var node, i, idx, children;
	
					node = dom.getRoot();
					for (i = indexes.length - 1; i >= 0; i--) {
						children = node.children;
						idx = indexes[i];
	
						if (idx <= children.length - 1) {
							node = children[idx];
						}
					}
	
					return node;
				}
	
				function setBookmarkEndPoint(start) {
					var endPoint = bookmark[start ? 'start' : 'end'], moveLeft, moveRng, undef, offset;
	
					if (endPoint) {
						moveLeft = endPoint.position > 0;
	
						moveRng = body.createTextRange();
						moveRng.moveToElementText(resolveIndexes(endPoint.indexes));
	
						offset = endPoint.offset;
						if (offset !== undef) {
							moveRng.collapse(endPoint.inside || moveLeft);
							moveRng.moveStart('character', moveLeft ? -offset : offset);
						} else {
							moveRng.collapse(start);
						}
	
						rng.setEndPoint(start ? 'StartToStart' : 'EndToStart', moveRng);
	
						if (start) {
							rng.collapse(true);
						}
					}
				}
	
				if (bookmark.start) {
					if (bookmark.start.ctrl) {
						rng = body.createControlRange();
						rng.addElement(resolveIndexes(bookmark.start.indexes));
						rng.select();
					} else {
						rng = body.createTextRange();
						setBookmarkEndPoint(true);
						setBookmarkEndPoint();
						rng.select();
					}
				}
			};
	
			this.addRange = function(rng) {
				var ieRng, ctrlRng, startContainer, startOffset, endContainer, endOffset, sibling,
					doc = selection.dom.doc, body = doc.body, nativeRng, ctrlElm;
	
				function setEndPoint(start) {
					var container, offset, marker, tmpRng, nodes;
	
					marker = dom.create('a');
					container = start ? startContainer : endContainer;
					offset = start ? startOffset : endOffset;
					tmpRng = ieRng.duplicate();
	
					if (container == doc || container == doc.documentElement) {
						container = body;
						offset = 0;
					}
	
					if (container.nodeType == 3) {
						container.parentNode.insertBefore(marker, container);
						tmpRng.moveToElementText(marker);
						tmpRng.moveStart('character', offset);
						dom.remove(marker);
						ieRng.setEndPoint(start ? 'StartToStart' : 'EndToEnd', tmpRng);
					} else {
						nodes = container.childNodes;
	
						if (nodes.length) {
							if (offset >= nodes.length) {
								dom.insertAfter(marker, nodes[nodes.length - 1]);
							} else {
								container.insertBefore(marker, nodes[offset]);
							}
	
							tmpRng.moveToElementText(marker);
						} else if (container.canHaveHTML) {
							// Empty node selection for example <div>|</div>
							// Setting innerHTML with a span marker then remove that marker seems to keep empty block elements open
							container.innerHTML = '<span>&#xFEFF;</span>';
							marker = container.firstChild;
							tmpRng.moveToElementText(marker);
							tmpRng.collapse(FALSE); // Collapse false works better than true for some odd reason
						}
	
						ieRng.setEndPoint(start ? 'StartToStart' : 'EndToEnd', tmpRng);
						dom.remove(marker);
					}
				}
	
				// Setup some shorter versions
				startContainer = rng.startContainer;
				startOffset = rng.startOffset;
				endContainer = rng.endContainer;
				endOffset = rng.endOffset;
				ieRng = body.createTextRange();
	
				// If single element selection then try making a control selection out of it
				if (startContainer == endContainer && startContainer.nodeType == 1) {
					// Trick to place the caret inside an empty block element like <p></p>
					if (startOffset == endOffset && !startContainer.hasChildNodes()) {
						if (startContainer.canHaveHTML) {
							// Check if previous sibling is an empty block if it is then we need to render it
							// IE would otherwise move the caret into the sibling instead of the empty startContainer see: #5236
							// Example this: <p></p><p>|</p> would become this: <p>|</p><p></p>
							sibling = startContainer.previousSibling;
							if (sibling && !sibling.hasChildNodes() && dom.isBlock(sibling)) {
								sibling.innerHTML = '&#xFEFF;';
							} else {
								sibling = null;
							}
	
							startContainer.innerHTML = '<span>&#xFEFF;</span><span>&#xFEFF;</span>';
							ieRng.moveToElementText(startContainer.lastChild);
							ieRng.select();
							dom.doc.selection.clear();
							startContainer.innerHTML = '';
	
							if (sibling) {
								sibling.innerHTML = '';
							}
							return;
						}
	
						startOffset = dom.nodeIndex(startContainer);
						startContainer = startContainer.parentNode;
					}
	
					if (startOffset == endOffset - 1) {
						try {
							ctrlElm = startContainer.childNodes[startOffset];
							ctrlRng = body.createControlRange();
							ctrlRng.addElement(ctrlElm);
							ctrlRng.select();
	
							// Check if the range produced is on the correct element and is a control range
							// On IE 8 it will select the parent contentEditable container if you select an inner element see: #5398
							nativeRng = selection.getRng();
							if (nativeRng.item && ctrlElm === nativeRng.item(0)) {
								return;
							}
						} catch (ex) {
							// Ignore
						}
					}
				}
	
				// Set start/end point of selection
				setEndPoint(true);
				setEndPoint();
	
				// Select the new range and scroll it into view
				ieRng.select();
			};
	
			// Expose range method
			this.getRangeAt = getRange;
		}
	
		return Selection;
	});
	
	// Included from: js/tinymce/classes/util/VK.js
	
	/**
	 * VK.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This file exposes a set of the common KeyCodes for use. Please grow it as needed.
	 */
	define("tinymce/util/VK", [
		"tinymce/Env"
	], function(Env) {
		return {
			BACKSPACE: 8,
			DELETE: 46,
			DOWN: 40,
			ENTER: 13,
			LEFT: 37,
			RIGHT: 39,
			SPACEBAR: 32,
			TAB: 9,
			UP: 38,
	
			modifierPressed: function(e) {
				return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e);
			},
	
			metaKeyPressed: function(e) {
				// Check if ctrl or meta key is pressed. Edge case for AltGr on Windows where it produces ctrlKey+altKey states
				return (Env.mac ? e.metaKey : e.ctrlKey && !e.altKey);
			}
		};
	});
	
	// Included from: js/tinymce/classes/dom/ControlSelection.js
	
	/**
	 * ControlSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles control selection of elements. Controls are elements
	 * that can be resized and needs to be selected as a whole. It adds custom resize handles
	 * to all browser engines that support properly disabling the built in resize logic.
	 *
	 * @class tinymce.dom.ControlSelection
	 */
	define("tinymce/dom/ControlSelection", [
		"tinymce/util/VK",
		"tinymce/util/Tools",
		"tinymce/util/Delay",
		"tinymce/Env",
		"tinymce/dom/NodeType"
	], function(VK, Tools, Delay, Env, NodeType) {
		var isContentEditableFalse = NodeType.isContentEditableFalse;
		var isContentEditableTrue = NodeType.isContentEditableTrue;
	
		function getContentEditableRoot(root, node) {
			while (node && node != root) {
				if (isContentEditableTrue(node) || isContentEditableFalse(node)) {
					return node;
				}
	
				node = node.parentNode;
			}
	
			return null;
		}
	
		return function(selection, editor) {
			var dom = editor.dom, each = Tools.each;
			var selectedElm, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle, lastMouseDownEvent;
			var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
			var width, height, editableDoc = editor.getDoc(), rootDocument = document, isIE = Env.ie && Env.ie < 11;
			var abs = Math.abs, round = Math.round, rootElement = editor.getBody(), startScrollWidth, startScrollHeight;
	
			// Details about each resize handle how to scale etc
			resizeHandles = {
				// Name: x multiplier, y multiplier, delta size x, delta size y
				/*n: [0.5, 0, 0, -1],
				e: [1, 0.5, 1, 0],
				s: [0.5, 1, 0, 1],
				w: [0, 0.5, -1, 0],*/
				nw: [0, 0, -1, -1],
				ne: [1, 0, 1, -1],
				se: [1, 1, 1, 1],
				sw: [0, 1, -1, 1]
			};
	
			// Add CSS for resize handles, cloned element and selected
			var rootClass = '.mce-content-body';
			editor.contentStyles.push(
				rootClass + ' div.mce-resizehandle {' +
					'position: absolute;' +
					'border: 1px solid black;' +
					'box-sizing: box-sizing;' +
					'background: #FFF;' +
					'width: 7px;' +
					'height: 7px;' +
					'z-index: 10000' +
				'}' +
				rootClass + ' .mce-resizehandle:hover {' +
					'background: #000' +
				'}' +
				rootClass + ' img[data-mce-selected],' + rootClass + ' hr[data-mce-selected] {' +
					'outline: 1px solid black;' +
					'resize: none' + // Have been talks about implementing this in browsers
				'}' +
				rootClass + ' .mce-clonedresizable {' +
					'position: absolute;' +
					(Env.gecko ? '' : 'outline: 1px dashed black;') + // Gecko produces trails while resizing
					'opacity: .5;' +
					'filter: alpha(opacity=50);' +
					'z-index: 10000' +
				'}' +
				rootClass + ' .mce-resize-helper {' +
					'background: #555;' +
					'background: rgba(0,0,0,0.75);' +
					'border-radius: 3px;' +
					'border: 1px;' +
					'color: white;' +
					'display: none;' +
					'font-family: sans-serif;' +
					'font-size: 12px;' +
					'white-space: nowrap;' +
					'line-height: 14px;' +
					'margin: 5px 10px;' +
					'padding: 5px;' +
					'position: absolute;' +
					'z-index: 10001' +
				'}'
			);
	
			function isResizable(elm) {
				var selector = editor.settings.object_resizing;
	
				if (selector === false || Env.iOS) {
					return false;
				}
	
				if (typeof selector != 'string') {
					selector = 'table,img,div';
				}
	
				if (elm.getAttribute('data-mce-resize') === 'false') {
					return false;
				}
	
				if (elm == editor.getBody()) {
					return false;
				}
	
				return editor.dom.is(elm, selector);
			}
	
			function resizeGhostElement(e) {
				var deltaX, deltaY, proportional;
				var resizeHelperX, resizeHelperY;
	
				// Calc new width/height
				deltaX = e.screenX - startX;
				deltaY = e.screenY - startY;
	
				// Calc new size
				width = deltaX * selectedHandle[2] + startW;
				height = deltaY * selectedHandle[3] + startH;
	
				// Never scale down lower than 5 pixels
				width = width < 5 ? 5 : width;
				height = height < 5 ? 5 : height;
	
				if (selectedElm.nodeName == "IMG" && editor.settings.resize_img_proportional !== false) {
					proportional = !VK.modifierPressed(e);
				} else {
					proportional = VK.modifierPressed(e) || (selectedElm.nodeName == "IMG" && selectedHandle[2] * selectedHandle[3] !== 0);
				}
	
				// Constrain proportions
				if (proportional) {
					if (abs(deltaX) > abs(deltaY)) {
						height = round(width * ratio);
						width = round(height / ratio);
					} else {
						width = round(height / ratio);
						height = round(width * ratio);
					}
				}
	
				// Update ghost size
				dom.setStyles(selectedElmGhost, {
					width: width,
					height: height
				});
	
				// Update resize helper position
				resizeHelperX = selectedHandle.startPos.x + deltaX;
				resizeHelperY = selectedHandle.startPos.y + deltaY;
				resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
				resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	
				dom.setStyles(resizeHelper, {
					left: resizeHelperX,
					top: resizeHelperY,
					display: 'block'
				});
	
				resizeHelper.innerHTML = width + ' &times; ' + height;
	
				// Update ghost X position if needed
				if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
					dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
				}
	
				// Update ghost Y position if needed
				if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
					dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
				}
	
				// Calculate how must overflow we got
				deltaX = rootElement.scrollWidth - startScrollWidth;
				deltaY = rootElement.scrollHeight - startScrollHeight;
	
				// Re-position the resize helper based on the overflow
				if (deltaX + deltaY !== 0) {
					dom.setStyles(resizeHelper, {
						left: resizeHelperX - deltaX,
						top: resizeHelperY - deltaY
					});
				}
	
				if (!resizeStarted) {
					editor.fire('ObjectResizeStart', {target: selectedElm, width: startW, height: startH});
					resizeStarted = true;
				}
			}
	
			function endGhostResize() {
				resizeStarted = false;
	
				function setSizeProp(name, value) {
					if (value) {
						// Resize by using style or attribute
						if (selectedElm.style[name] || !editor.schema.isValid(selectedElm.nodeName.toLowerCase(), name)) {
							dom.setStyle(selectedElm, name, value);
						} else {
							dom.setAttrib(selectedElm, name, value);
						}
					}
				}
	
				// Set width/height properties
				setSizeProp('width', width);
				setSizeProp('height', height);
	
				dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
				dom.unbind(editableDoc, 'mouseup', endGhostResize);
	
				if (rootDocument != editableDoc) {
					dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
					dom.unbind(rootDocument, 'mouseup', endGhostResize);
				}
	
				// Remove ghost/helper and update resize handle positions
				dom.remove(selectedElmGhost);
				dom.remove(resizeHelper);
	
				if (!isIE || selectedElm.nodeName == "TABLE") {
					showResizeRect(selectedElm);
				}
	
				editor.fire('ObjectResized', {target: selectedElm, width: width, height: height});
				dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
				editor.nodeChanged();
			}
	
			function showResizeRect(targetElm, mouseDownHandleName, mouseDownEvent) {
				var position, targetWidth, targetHeight, e, rect;
	
				hideResizeRect();
				unbindResizeHandleEvents();
	
				// Get position and size of target
				position = dom.getPos(targetElm, rootElement);
				selectedElmX = position.x;
				selectedElmY = position.y;
				rect = targetElm.getBoundingClientRect(); // Fix for Gecko offsetHeight for table with caption
				targetWidth = rect.width || (rect.right - rect.left);
				targetHeight = rect.height || (rect.bottom - rect.top);
	
				// Reset width/height if user selects a new image/table
				if (selectedElm != targetElm) {
					detachResizeStartListener();
					selectedElm = targetElm;
					width = height = 0;
				}
	
				// Makes it possible to disable resizing
				e = editor.fire('ObjectSelected', {target: targetElm});
	
				if (isResizable(targetElm) && !e.isDefaultPrevented()) {
					each(resizeHandles, function(handle, name) {
						var handleElm;
	
						function startDrag(e) {
							startX = e.screenX;
							startY = e.screenY;
							startW = selectedElm.clientWidth;
							startH = selectedElm.clientHeight;
							ratio = startH / startW;
							selectedHandle = handle;
	
							handle.startPos = {
								x: targetWidth * handle[0] + selectedElmX,
								y: targetHeight * handle[1] + selectedElmY
							};
	
							startScrollWidth = rootElement.scrollWidth;
							startScrollHeight = rootElement.scrollHeight;
	
							selectedElmGhost = selectedElm.cloneNode(true);
							dom.addClass(selectedElmGhost, 'mce-clonedresizable');
							dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
							selectedElmGhost.contentEditable = false; // Hides IE move layer cursor
							selectedElmGhost.unSelectabe = true;
							dom.setStyles(selectedElmGhost, {
								left: selectedElmX,
								top: selectedElmY,
								margin: 0
							});
	
							selectedElmGhost.removeAttribute('data-mce-selected');
							rootElement.appendChild(selectedElmGhost);
	
							dom.bind(editableDoc, 'mousemove', resizeGhostElement);
							dom.bind(editableDoc, 'mouseup', endGhostResize);
	
							if (rootDocument != editableDoc) {
								dom.bind(rootDocument, 'mousemove', resizeGhostElement);
								dom.bind(rootDocument, 'mouseup', endGhostResize);
							}
	
							resizeHelper = dom.add(rootElement, 'div', {
								'class': 'mce-resize-helper',
								'data-mce-bogus': 'all'
							}, startW + ' &times; ' + startH);
						}
	
						if (mouseDownHandleName) {
							// Drag started by IE native resizestart
							if (name == mouseDownHandleName) {
								startDrag(mouseDownEvent);
							}
	
							return;
						}
	
						// Get existing or render resize handle
						handleElm = dom.get('mceResizeHandle' + name);
						if (handleElm) {
							dom.remove(handleElm);
						}
	
						handleElm = dom.add(rootElement, 'div', {
							id: 'mceResizeHandle' + name,
							'data-mce-bogus': 'all',
							'class': 'mce-resizehandle',
							unselectable: true,
							style: 'cursor:' + name + '-resize; margin:0; padding:0'
						});
	
						// Hides IE move layer cursor
						// If we set it on Chrome we get this wounderful bug: #6725
						if (Env.ie) {
							handleElm.contentEditable = false;
						}
	
						dom.bind(handleElm, 'mousedown', function(e) {
							e.stopImmediatePropagation();
							e.preventDefault();
							startDrag(e);
						});
	
						handle.elm = handleElm;
	
						// Position element
						dom.setStyles(handleElm, {
							left: (targetWidth * handle[0] + selectedElmX) - (handleElm.offsetWidth / 2),
							top: (targetHeight * handle[1] + selectedElmY) - (handleElm.offsetHeight / 2)
						});
					});
				} else {
					hideResizeRect();
				}
	
				selectedElm.setAttribute('data-mce-selected', '1');
			}
	
			function hideResizeRect() {
				var name, handleElm;
	
				unbindResizeHandleEvents();
	
				if (selectedElm) {
					selectedElm.removeAttribute('data-mce-selected');
				}
	
				for (name in resizeHandles) {
					handleElm = dom.get('mceResizeHandle' + name);
					if (handleElm) {
						dom.unbind(handleElm);
						dom.remove(handleElm);
					}
				}
			}
	
			function updateResizeRect(e) {
				var startElm, controlElm;
	
				function isChildOrEqual(node, parent) {
					if (node) {
						do {
							if (node === parent) {
								return true;
							}
						} while ((node = node.parentNode));
					}
				}
	
				// Ignore all events while resizing or if the editor instance was removed
				if (resizeStarted || editor.removed) {
					return;
				}
	
				// Remove data-mce-selected from all elements since they might have been copied using Ctrl+c/v
				each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function(img) {
					img.removeAttribute('data-mce-selected');
				});
	
				controlElm = e.type == 'mousedown' ? e.target : selection.getNode();
				controlElm = dom.$(controlElm).closest(isIE ? 'table' : 'table,img,hr')[0];
	
				if (isChildOrEqual(controlElm, rootElement)) {
					disableGeckoResize();
					startElm = selection.getStart(true);
	
					if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
						if (!isIE || (controlElm != startElm && startElm.nodeName !== 'IMG')) {
							showResizeRect(controlElm);
							return;
						}
					}
				}
	
				hideResizeRect();
			}
	
			function attachEvent(elm, name, func) {
				if (elm && elm.attachEvent) {
					elm.attachEvent('on' + name, func);
				}
			}
	
			function detachEvent(elm, name, func) {
				if (elm && elm.detachEvent) {
					elm.detachEvent('on' + name, func);
				}
			}
	
			function resizeNativeStart(e) {
				var target = e.srcElement, pos, name, corner, cornerX, cornerY, relativeX, relativeY;
	
				pos = target.getBoundingClientRect();
				relativeX = lastMouseDownEvent.clientX - pos.left;
				relativeY = lastMouseDownEvent.clientY - pos.top;
	
				// Figure out what corner we are draging on
				for (name in resizeHandles) {
					corner = resizeHandles[name];
	
					cornerX = target.offsetWidth * corner[0];
					cornerY = target.offsetHeight * corner[1];
	
					if (abs(cornerX - relativeX) < 8 && abs(cornerY - relativeY) < 8) {
						selectedHandle = corner;
						break;
					}
				}
	
				// Remove native selection and let the magic begin
				resizeStarted = true;
				editor.fire('ObjectResizeStart', {
					target: selectedElm,
					width: selectedElm.clientWidth,
					height: selectedElm.clientHeight
				});
				editor.getDoc().selection.empty();
				showResizeRect(target, name, lastMouseDownEvent);
			}
	
			function preventDefault(e) {
				if (e.preventDefault) {
					e.preventDefault();
				} else {
					e.returnValue = false; // IE
				}
			}
	
			function isWithinContentEditableFalse(elm) {
				return isContentEditableFalse(getContentEditableRoot(editor.getBody(), elm));
			}
	
			function nativeControlSelect(e) {
				var target = e.srcElement;
	
				if (isWithinContentEditableFalse(target)) {
					preventDefault(e);
					return;
				}
	
				if (target != selectedElm) {
					editor.fire('ObjectSelected', {target: target});
					detachResizeStartListener();
	
					if (target.id.indexOf('mceResizeHandle') === 0) {
						e.returnValue = false;
						return;
					}
	
					if (target.nodeName == 'IMG' || target.nodeName == 'TABLE') {
						hideResizeRect();
						selectedElm = target;
						attachEvent(target, 'resizestart', resizeNativeStart);
					}
				}
			}
	
			function detachResizeStartListener() {
				detachEvent(selectedElm, 'resizestart', resizeNativeStart);
			}
	
			function unbindResizeHandleEvents() {
				for (var name in resizeHandles) {
					var handle = resizeHandles[name];
	
					if (handle.elm) {
						dom.unbind(handle.elm);
						delete handle.elm;
					}
				}
			}
	
			function disableGeckoResize() {
				try {
					// Disable object resizing on Gecko
					editor.getDoc().execCommand('enableObjectResizing', false, false);
				} catch (ex) {
					// Ignore
				}
			}
	
			function controlSelect(elm) {
				var ctrlRng;
	
				if (!isIE) {
					return;
				}
	
				ctrlRng = editableDoc.body.createControlRange();
	
				try {
					ctrlRng.addElement(elm);
					ctrlRng.select();
					return true;
				} catch (ex) {
					// Ignore since the element can't be control selected for example a P tag
				}
			}
	
			editor.on('init', function() {
				if (isIE) {
					// Hide the resize rect on resize and reselect the image
					editor.on('ObjectResized', function(e) {
						if (e.target.nodeName != 'TABLE') {
							hideResizeRect();
							controlSelect(e.target);
						}
					});
	
					attachEvent(rootElement, 'controlselect', nativeControlSelect);
	
					editor.on('mousedown', function(e) {
						lastMouseDownEvent = e;
					});
				} else {
					disableGeckoResize();
	
					// Sniff sniff, hard to feature detect this stuff
					if (Env.ie >= 11) {
						// Needs to be mousedown for drag/drop to work on IE 11
						// Needs to be click on Edge to properly select images
						editor.on('mousedown click', function(e) {
							var target = e.target, nodeName = target.nodeName;
	
							if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
								editor.selection.select(target, nodeName == 'TABLE');
	
								// Only fire once since nodeChange is expensive
								if (e.type == 'mousedown') {
									editor.nodeChanged();
								}
							}
						});
	
						editor.dom.bind(rootElement, 'mscontrolselect', function(e) {
							function delayedSelect(node) {
								Delay.setEditorTimeout(editor, function() {
									editor.selection.select(node);
								});
							}
	
							if (isWithinContentEditableFalse(e.target)) {
								e.preventDefault();
								delayedSelect(e.target);
								return;
							}
	
							if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
								e.preventDefault();
	
								// This moves the selection from being a control selection to a text like selection like in WebKit #6753
								// TODO: Fix this the day IE works like other browsers without this nasty native ugly control selections.
								if (e.target.tagName == 'IMG') {
									delayedSelect(e.target);
								}
							}
						});
					}
				}
	
				var throttledUpdateResizeRect = Delay.throttle(function(e) {
					if (!editor.composing) {
						updateResizeRect(e);
					}
				});
	
				editor.on('nodechange ResizeEditor ResizeWindow drop', throttledUpdateResizeRect);
	
				// Update resize rect while typing in a table
				editor.on('keyup compositionend', function(e) {
					// Don't update the resize rect while composing since it blows away the IME see: #2710
					if (selectedElm && selectedElm.nodeName == "TABLE") {
						throttledUpdateResizeRect(e);
					}
				});
	
				editor.on('hide blur', hideResizeRect);
	
				// Hide rect on focusout since it would float on top of windows otherwise
				//editor.on('focusout', hideResizeRect);
			});
	
			editor.on('remove', unbindResizeHandleEvents);
	
			function destroy() {
				selectedElm = selectedElmGhost = null;
	
				if (isIE) {
					detachResizeStartListener();
					detachEvent(rootElement, 'controlselect', nativeControlSelect);
				}
			}
	
			return {
				isResizable: isResizable,
				showResizeRect: showResizeRect,
				hideResizeRect: hideResizeRect,
				updateResizeRect: updateResizeRect,
				controlSelect: controlSelect,
				destroy: destroy
			};
		};
	});
	
	// Included from: js/tinymce/classes/util/Fun.js
	
	/**
	 * Fun.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Functional utility class.
	 *
	 * @private
	 * @class tinymce.util.Fun
	 */
	define("tinymce/util/Fun", [], function() {
		var slice = [].slice;
	
		function constant(value) {
			return function() {
				return value;
			};
		}
	
		function negate(predicate) {
			return function(x) {
				return !predicate(x);
			};
		}
	
		function compose(f, g) {
			return function(x) {
				return f(g(x));
			};
		}
	
		function or() {
			var args = slice.call(arguments);
	
			return function(x) {
				for (var i = 0; i < args.length; i++) {
					if (args[i](x)) {
						return true;
					}
				}
	
				return false;
			};
		}
	
		function and() {
			var args = slice.call(arguments);
	
			return function(x) {
				for (var i = 0; i < args.length; i++) {
					if (!args[i](x)) {
						return false;
					}
				}
	
				return true;
			};
		}
	
		function curry(fn) {
			var args = slice.call(arguments);
	
			if (args.length - 1 >= fn.length) {
				return fn.apply(this, args.slice(1));
			}
	
			return function() {
				var tempArgs = args.concat([].slice.call(arguments));
				return curry.apply(this, tempArgs);
			};
		}
	
		return {
			constant: constant,
			negate: negate,
			and: and,
			or: or,
			curry: curry,
			compose: compose
		};
	});
	
	// Included from: js/tinymce/classes/caret/CaretCandidate.js
	
	/**
	 * CaretCandidate.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for handling caret candidates. A caret candidate is
	 * for example text nodes, images, input elements, cE=false elements etc.
	 *
	 * @private
	 * @class tinymce.caret.CaretCandidate
	 */
	define("tinymce/caret/CaretCandidate", [
		"tinymce/dom/NodeType",
		"tinymce/util/Arr",
		"tinymce/caret/CaretContainer"
	], function(NodeType, Arr, CaretContainer) {
		var isContentEditableTrue = NodeType.isContentEditableTrue,
			isContentEditableFalse = NodeType.isContentEditableFalse,
			isBr = NodeType.isBr,
			isText = NodeType.isText,
			isInvalidTextElement = NodeType.matchNodeNames('script style textarea'),
			isAtomicInline = NodeType.matchNodeNames('img input textarea hr iframe video audio object'),
			isTable = NodeType.matchNodeNames('table'),
			isCaretContainer = CaretContainer.isCaretContainer;
	
		function isCaretCandidate(node) {
			if (isCaretContainer(node)) {
				return false;
			}
	
			if (isText(node)) {
				if (isInvalidTextElement(node.parentNode)) {
					return false;
				}
	
				return true;
			}
	
			return isAtomicInline(node) || isBr(node) || isTable(node) || isContentEditableFalse(node);
		}
	
		function isInEditable(node, rootNode) {
			for (node = node.parentNode; node && node != rootNode; node = node.parentNode) {
				if (isContentEditableFalse(node)) {
					return false;
				}
	
				if (isContentEditableTrue(node)) {
					return true;
				}
			}
	
			return true;
		}
	
		function isAtomicContentEditableFalse(node) {
			if (!isContentEditableFalse(node)) {
				return false;
			}
	
			return Arr.reduce(node.getElementsByTagName('*'), function(result, elm) {
				return result || isContentEditableTrue(elm);
			}, false) !== true;
		}
	
		function isAtomic(node) {
			return isAtomicInline(node) || isAtomicContentEditableFalse(node);
		}
	
		function isEditableCaretCandidate(node, rootNode) {
			return isCaretCandidate(node) && isInEditable(node, rootNode);
		}
	
		return {
			isCaretCandidate: isCaretCandidate,
			isInEditable: isInEditable,
			isAtomic: isAtomic,
			isEditableCaretCandidate: isEditableCaretCandidate
		};
	});
	
	// Included from: js/tinymce/classes/geom/ClientRect.js
	
	/**
	 * ClientRect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with client rects.
	 *
	 * @private
	 * @class tinymce.geom.ClientRect
	 */
	define("tinymce/geom/ClientRect", [], function() {
		var round = Math.round;
	
		function clone(rect) {
			if (!rect) {
				return {left: 0, top: 0, bottom: 0, right: 0, width: 0, height: 0};
			}
	
			return {
				left: round(rect.left),
				top: round(rect.top),
				bottom: round(rect.bottom),
				right: round(rect.right),
				width: round(rect.width),
				height: round(rect.height)
			};
		}
	
		function collapse(clientRect, toStart) {
			clientRect = clone(clientRect);
	
			if (toStart) {
				clientRect.right = clientRect.left;
			} else {
				clientRect.left = clientRect.left + clientRect.width;
				clientRect.right = clientRect.left;
			}
	
			clientRect.width = 0;
	
			return clientRect;
		}
	
		function isEqual(rect1, rect2) {
			return (
				rect1.left === rect2.left &&
				rect1.top === rect2.top &&
				rect1.bottom === rect2.bottom &&
				rect1.right === rect2.right
			);
		}
	
		function isValidOverflow(overflowY, clientRect1, clientRect2) {
			return overflowY >= 0 && overflowY <= Math.min(clientRect1.height, clientRect2.height) / 2;
	
		}
	
		function isAbove(clientRect1, clientRect2) {
			if (clientRect1.bottom < clientRect2.top) {
				return true;
			}
	
			if (clientRect1.top > clientRect2.bottom) {
				return false;
			}
	
			return isValidOverflow(clientRect2.top - clientRect1.bottom, clientRect1, clientRect2);
		}
	
		function isBelow(clientRect1, clientRect2) {
			if (clientRect1.top > clientRect2.bottom) {
				return true;
			}
	
			if (clientRect1.bottom < clientRect2.top) {
				return false;
			}
	
			return isValidOverflow(clientRect2.bottom - clientRect1.top, clientRect1, clientRect2);
		}
	
		function isLeft(clientRect1, clientRect2) {
			return clientRect1.left < clientRect2.left;
		}
	
		function isRight(clientRect1, clientRect2) {
			return clientRect1.right > clientRect2.right;
		}
	
		function compare(clientRect1, clientRect2) {
			if (isAbove(clientRect1, clientRect2)) {
				return -1;
			}
	
			if (isBelow(clientRect1, clientRect2)) {
				return 1;
			}
	
			if (isLeft(clientRect1, clientRect2)) {
				return -1;
			}
	
			if (isRight(clientRect1, clientRect2)) {
				return 1;
			}
	
			return 0;
		}
	
		function containsXY(clientRect, clientX, clientY) {
			return (
				clientX >= clientRect.left &&
				clientX <= clientRect.right &&
				clientY >= clientRect.top &&
				clientY <= clientRect.bottom
			);
		}
	
		return {
			clone: clone,
			collapse: collapse,
			isEqual: isEqual,
			isAbove: isAbove,
			isBelow: isBelow,
			isLeft: isLeft,
			isRight: isRight,
			compare: compare,
			containsXY: containsXY
		};
	});
	
	// Included from: js/tinymce/classes/text/ExtendingChar.js
	
	/**
	 * ExtendingChar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains logic for detecting extending characters.
	 *
	 * @private
	 * @class tinymce.text.ExtendingChar
	 * @example
	 * var isExtending = ExtendingChar.isExtendingChar('a');
	 */
	define("tinymce/text/ExtendingChar", [], function() {
		// Generated from: http://www.unicode.org/Public/UNIDATA/DerivedCoreProperties.txt
		// Only includes the characters in that fit into UCS-2 16 bit
		var extendingChars = new RegExp(
			"[\u0300-\u036F\u0483-\u0487\u0488-\u0489\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A" +
			"\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0" +
			"\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C" +
			"\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2-\u09E3" +
			"\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC" +
			"\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B57" +
			"\u0B62-\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56" +
			"\u0C62-\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC-\u0CCD\u0CD5-\u0CD6\u0CE2-\u0CE3\u0D01\u0D3E\u0D41-\u0D44" +
			"\u0D4D\u0D57\u0D62-\u0D63\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9" +
			"\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97" +
			"\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074" +
			"\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5" +
			"\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18" +
			"\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABE\u1B00-\u1B03\u1B34" +
			"\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8-\u1BE9" +
			"\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8-\u1CF9" +
			"\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C-\u200D\u20D0-\u20DC\u20DD-\u20E0\u20E1\u20E2-\u20E4\u20E5-\u20F0\u2CEF-\u2CF1" +
			"\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u302E-\u302F\u3099-\u309A\uA66F\uA670-\uA672\uA674-\uA67D\uA69E-\uA69F\uA6F0-\uA6F1" +
			"\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC" +
			"\uA9E5\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1" +
			"\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E-\uFF9F]"
		);
	
		function isExtendingChar(ch) {
			return typeof ch == "string" && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
		}
	
		return {
			isExtendingChar: isExtendingChar
		};
	});
	
	// Included from: js/tinymce/classes/caret/CaretPosition.js
	
	/**
	 * CaretPosition.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for creating caret positions within a document a caretposition
	 * is similar to a DOMRange object but it doesn't have two endpoints and is also more lightweight
	 * since it's now updated live when the DOM changes.
	 *
	 * @private
	 * @class tinymce.caret.CaretPosition
	 * @example
	 * var caretPos1 = new CaretPosition(container, offset);
	 * var caretPos2 = CaretPosition.fromRangeStart(someRange);
	 */
	define("tinymce/caret/CaretPosition", [
		"tinymce/util/Fun",
		"tinymce/dom/NodeType",
		"tinymce/dom/DOMUtils",
		"tinymce/dom/RangeUtils",
		"tinymce/caret/CaretCandidate",
		"tinymce/geom/ClientRect",
		"tinymce/text/ExtendingChar"
	], function(Fun, NodeType, DOMUtils, RangeUtils, CaretCandidate, ClientRect, ExtendingChar) {
		var isElement = NodeType.isElement,
			isCaretCandidate = CaretCandidate.isCaretCandidate,
			isBlock = NodeType.matchStyleValues('display', 'block table'),
			isFloated = NodeType.matchStyleValues('float', 'left right'),
			isValidElementCaretCandidate = Fun.and(isElement, isCaretCandidate, Fun.negate(isFloated)),
			isNotPre = Fun.negate(NodeType.matchStyleValues('white-space', 'pre pre-line pre-wrap')),
			isText = NodeType.isText,
			isBr = NodeType.isBr,
			nodeIndex = DOMUtils.nodeIndex,
			resolveIndex = RangeUtils.getNode;
	
		function createRange(doc) {
			return "createRange" in doc ? doc.createRange() : DOMUtils.DOM.createRng();
		}
	
		function isWhiteSpace(chr) {
			return chr && /[\r\n\t ]/.test(chr);
		}
	
		function isHiddenWhiteSpaceRange(range) {
			var container = range.startContainer,
				offset = range.startOffset,
				text;
	
			if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode)) {
				text = container.data;
	
				if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
					return true;
				}
			}
	
			return false;
		}
	
		function getCaretPositionClientRects(caretPosition) {
			var clientRects = [], beforeNode, node;
	
			// Hack for older WebKit versions that doesn't
			// support getBoundingClientRect on BR elements
			function getBrClientRect(brNode) {
				var doc = brNode.ownerDocument,
					rng = createRange(doc),
					nbsp = doc.createTextNode('\u00a0'),
					parentNode = brNode.parentNode,
					clientRect;
	
				parentNode.insertBefore(nbsp, brNode);
				rng.setStart(nbsp, 0);
				rng.setEnd(nbsp, 1);
				clientRect = ClientRect.clone(rng.getBoundingClientRect());
				parentNode.removeChild(nbsp);
	
				return clientRect;
			}
	
			function getBoundingClientRect(item) {
				var clientRect, clientRects;
	
				clientRects = item.getClientRects();
				if (clientRects.length > 0) {
					clientRect = ClientRect.clone(clientRects[0]);
				} else {
					clientRect = ClientRect.clone(item.getBoundingClientRect());
				}
	
				if (isBr(item) && clientRect.left === 0) {
					return getBrClientRect(item);
				}
	
				return clientRect;
			}
	
			function collapseAndInflateWidth(clientRect, toStart) {
				clientRect = ClientRect.collapse(clientRect, toStart);
				clientRect.width = 1;
				clientRect.right = clientRect.left + 1;
	
				return clientRect;
			}
	
			function addUniqueAndValidRect(clientRect) {
				if (clientRect.height === 0) {
					return;
				}
	
				if (clientRects.length > 0) {
					if (ClientRect.isEqual(clientRect, clientRects[clientRects.length - 1])) {
						return;
					}
				}
	
				clientRects.push(clientRect);
			}
	
			function addCharacterOffset(container, offset) {
				var range = createRange(container.ownerDocument);
	
				if (offset < container.data.length) {
					if (ExtendingChar.isExtendingChar(container.data[offset])) {
						return clientRects;
					}
	
					// WebKit returns two client rects for a position after an extending
					// character a\uxxx|b so expand on "b" and collapse to start of "b" box
					if (ExtendingChar.isExtendingChar(container.data[offset - 1])) {
						range.setStart(container, offset);
						range.setEnd(container, offset + 1);
	
						if (!isHiddenWhiteSpaceRange(range)) {
							addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
							return clientRects;
						}
					}
				}
	
				if (offset > 0) {
					range.setStart(container, offset - 1);
					range.setEnd(container, offset);
	
					if (!isHiddenWhiteSpaceRange(range)) {
						addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
					}
				}
	
				if (offset < container.data.length) {
					range.setStart(container, offset);
					range.setEnd(container, offset + 1);
	
					if (!isHiddenWhiteSpaceRange(range)) {
						addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
					}
				}
			}
	
			if (isText(caretPosition.container())) {
				addCharacterOffset(caretPosition.container(), caretPosition.offset());
				return clientRects;
			}
	
			if (isElement(caretPosition.container())) {
				if (caretPosition.isAtEnd()) {
					node = resolveIndex(caretPosition.container(), caretPosition.offset());
					if (isText(node)) {
						addCharacterOffset(node, node.data.length);
					}
	
					if (isValidElementCaretCandidate(node) && !isBr(node)) {
						addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
					}
				} else {
					node = resolveIndex(caretPosition.container(), caretPosition.offset());
					if (isText(node)) {
						addCharacterOffset(node, 0);
					}
	
					if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
						addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
						return clientRects;
					}
	
					beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
					if (isValidElementCaretCandidate(beforeNode) && !isBr(beforeNode)) {
						if (isBlock(beforeNode) || isBlock(node) || !isValidElementCaretCandidate(node)) {
							addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
						}
					}
	
					if (isValidElementCaretCandidate(node)) {
						addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
					}
				}
			}
	
			return clientRects;
		}
	
		/**
		 * Represents a location within the document by a container and an offset.
		 *
		 * @constructor
		 * @param {Node} container Container node.
		 * @param {Number} offset Offset within that container node.
		 * @param {Array} clientRects Optional client rects array for the position.
		 */
		function CaretPosition(container, offset, clientRects) {
			function isAtStart() {
				if (isText(container)) {
					return offset === 0;
				}
	
				return offset === 0;
			}
	
			function isAtEnd() {
				if (isText(container)) {
					return offset >= container.data.length;
				}
	
				return offset >= container.childNodes.length;
			}
	
			function toRange() {
				var range;
	
				range = createRange(container.ownerDocument);
				range.setStart(container, offset);
				range.setEnd(container, offset);
	
				return range;
			}
	
			function getClientRects() {
				if (!clientRects) {
					clientRects = getCaretPositionClientRects(new CaretPosition(container, offset));
				}
	
				return clientRects;
			}
	
			function isVisible() {
				return getClientRects().length > 0;
			}
	
			function isEqual(caretPosition) {
				return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
			}
	
			function getNode(before) {
				return resolveIndex(container, before ? offset - 1 : offset);
			}
	
			return {
				/**
				 * Returns the container node.
				 *
				 * @method container
				 * @return {Node} Container node.
				 */
				container: Fun.constant(container),
	
				/**
				 * Returns the offset within the container node.
				 *
				 * @method offset
				 * @return {Number} Offset within the container node.
				 */
				offset: Fun.constant(offset),
	
				/**
				 * Returns a range out of a the caret position.
				 *
				 * @method toRange
				 * @return {DOMRange} range for the caret position.
				 */
				toRange: toRange,
	
				/**
				 * Returns the client rects for the caret position. Might be multiple rects between
				 * block elements.
				 *
				 * @method getClientRects
				 * @return {Array} Array of client rects.
				 */
				getClientRects: getClientRects,
	
				/**
				 * Returns true if the caret location is visible/displayed on screen.
				 *
				 * @method isVisible
				 * @return {Boolean} true/false if the position is visible or not.
				 */
				isVisible: isVisible,
	
				/**
				 * Returns true if the caret location is at the beginning of text node or container.
				 *
				 * @method isVisible
				 * @return {Boolean} true/false if the position is at the beginning.
				 */
				isAtStart: isAtStart,
	
				/**
				 * Returns true if the caret location is at the end of text node or container.
				 *
				 * @method isVisible
				 * @return {Boolean} true/false if the position is at the end.
				 */
				isAtEnd: isAtEnd,
	
				/**
				 * Compares the caret position to another caret position. This will only compare the
				 * container and offset not it's visual position.
				 *
				 * @method isEqual
				 * @param {tinymce.caret.CaretPosition} caretPosition Caret position to compare with.
				 * @return {Boolean} true if the caret positions are equal.
				 */
				isEqual: isEqual,
	
				/**
				 * Returns the closest resolved node from a node index. That means if you have an offset after the
				 * last node in a container it will return that last node.
				 *
				 * @method getNode
				 * @return {Node} Node that is closest to the index.
				 */
				getNode: getNode
			};
		}
	
		/**
		 * Creates a caret position from the start of a range.
		 *
		 * @method fromRangeStart
		 * @param {DOMRange} range DOM Range to create caret position from.
		 * @return {tinymce.caret.CaretPosition} Caret position from the start of DOM range.
		 */
		CaretPosition.fromRangeStart = function(range) {
			return new CaretPosition(range.startContainer, range.startOffset);
		};
	
		/**
		 * Creates a caret position from the end of a range.
		 *
		 * @method fromRangeEnd
		 * @param {DOMRange} range DOM Range to create caret position from.
		 * @return {tinymce.caret.CaretPosition} Caret position from the end of DOM range.
		 */
		CaretPosition.fromRangeEnd = function(range) {
			return new CaretPosition(range.endContainer, range.endOffset);
		};
	
		/**
		 * Creates a caret position from a node and places the offset after it.
		 *
		 * @method after
		 * @param {Node} node Node to get caret position from.
		 * @return {tinymce.caret.CaretPosition} Caret position from the node.
		 */
		CaretPosition.after = function(node) {
			return new CaretPosition(node.parentNode, nodeIndex(node) + 1);
		};
	
		/**
		 * Creates a caret position from a node and places the offset before it.
		 *
		 * @method before
		 * @param {Node} node Node to get caret position from.
		 * @return {tinymce.caret.CaretPosition} Caret position from the node.
		 */
		CaretPosition.before = function(node) {
			return new CaretPosition(node.parentNode, nodeIndex(node));
		};
	
		return CaretPosition;
	});
	
	// Included from: js/tinymce/classes/caret/CaretBookmark.js
	
	/**
	 * CaretBookmark.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module creates or resolves xpath like string representation of a CaretPositions.
	 *
	 * The format is a / separated list of chunks with:
	 * <element|text()>[index|after|before]
	 *
	 * For example:
	 *  p[0]/b[0]/text()[0],1 = <p><b>a|c</b></p>
	 *  p[0]/img[0],before = <p>|<img></p>
	 *  p[0]/img[0],after = <p><img>|</p>
	 *
	 * @private
	 * @static
	 * @class tinymce.caret.CaretBookmark
	 * @example
	 * var bookmark = CaretBookmark.create(rootElm, CaretPosition.before(rootElm.firstChild));
	 * var caretPosition = CaretBookmark.resolve(bookmark);
	 */
	define('tinymce/caret/CaretBookmark', [
		'tinymce/dom/NodeType',
		'tinymce/dom/DOMUtils',
		'tinymce/util/Fun',
		'tinymce/util/Arr',
		'tinymce/caret/CaretPosition'
	], function(NodeType, DomUtils, Fun, Arr, CaretPosition) {
		var isText = NodeType.isText,
			isBogus = NodeType.isBogus,
			nodeIndex = DomUtils.nodeIndex;
	
		function normalizedParent(node) {
			var parentNode = node.parentNode;
	
			if (isBogus(parentNode)) {
				return normalizedParent(parentNode);
			}
	
			return parentNode;
		}
	
		function getChildNodes(node) {
			if (!node) {
				return [];
			}
	
			return Arr.reduce(node.childNodes, function(result, node) {
				if (isBogus(node) && node.nodeName != 'BR') {
					result = result.concat(getChildNodes(node));
				} else {
					result.push(node);
				}
	
				return result;
			}, []);
		}
	
		function normalizedTextOffset(textNode, offset) {
			while ((textNode = textNode.previousSibling)) {
				if (!isText(textNode)) {
					break;
				}
	
				offset += textNode.data.length;
			}
	
			return offset;
		}
	
		function equal(targetValue) {
			return function(value) {
				return targetValue === value;
			};
		}
	
		function normalizedNodeIndex(node) {
			var nodes, index, numTextFragments;
	
			nodes = getChildNodes(normalizedParent(node));
			index = Arr.findIndex(nodes, equal(node), node);
			nodes = nodes.slice(0, index + 1);
			numTextFragments = Arr.reduce(nodes, function(result, node, i) {
				if (isText(node) && isText(nodes[i - 1])) {
					result++;
				}
	
				return result;
			}, 0);
	
			nodes = Arr.filter(nodes, NodeType.matchNodeNames(node.nodeName));
			index = Arr.findIndex(nodes, equal(node), node);
	
			return index - numTextFragments;
		}
	
		function createPathItem(node) {
			var name;
	
			if (isText(node)) {
				name = 'text()';
			} else {
				name = node.nodeName.toLowerCase();
			}
	
			return name + '[' + normalizedNodeIndex(node) + ']';
		}
	
		function parentsUntil(rootNode, node, predicate) {
			var parents = [];
	
			for (node = node.parentNode; node != rootNode; node = node.parentNode) {
				if (predicate && predicate(node)) {
					break;
				}
	
				parents.push(node);
			}
	
			return parents;
		}
	
		function create(rootNode, caretPosition) {
			var container, offset, path = [],
				outputOffset, childNodes, parents;
	
			container = caretPosition.container();
			offset = caretPosition.offset();
	
			if (isText(container)) {
				outputOffset = normalizedTextOffset(container, offset);
			} else {
				childNodes = container.childNodes;
				if (offset >= childNodes.length) {
					outputOffset = 'after';
					offset = childNodes.length - 1;
				} else {
					outputOffset = 'before';
				}
	
				container = childNodes[offset];
			}
	
			path.push(createPathItem(container));
			parents = parentsUntil(rootNode, container);
			parents = Arr.filter(parents, Fun.negate(NodeType.isBogus));
			path = path.concat(Arr.map(parents, function(node) {
				return createPathItem(node);
			}));
	
			return path.reverse().join('/') + ',' + outputOffset;
		}
	
		function resolvePathItem(node, name, index) {
			var nodes = getChildNodes(node);
	
			nodes = Arr.filter(nodes, function(node, index) {
				return !isText(node) || !isText(nodes[index - 1]);
			});
	
			nodes = Arr.filter(nodes, NodeType.matchNodeNames(name));
			return nodes[index];
		}
	
		function findTextPosition(container, offset) {
			var node = container, targetOffset = 0, dataLen;
	
			while (isText(node)) {
				dataLen = node.data.length;
	
				if (offset >= targetOffset && offset <= targetOffset + dataLen) {
					container = node;
					offset = offset - targetOffset;
					break;
				}
	
				if (!isText(node.nextSibling)) {
					container = node;
					offset = dataLen;
					break;
				}
	
				targetOffset += dataLen;
				node = node.nextSibling;
			}
	
			if (offset > container.data.length) {
				offset = container.data.length;
			}
	
			return new CaretPosition(container, offset);
		}
	
		function resolve(rootNode, path) {
			var parts, container, offset;
	
			if (!path) {
				return null;
			}
	
			parts = path.split(',');
			path = parts[0].split('/');
			offset = parts.length > 1 ? parts[1] : 'before';
	
			container = Arr.reduce(path, function(result, value) {
				value = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
				if (!value) {
					return null;
				}
	
				if (value[1] === 'text()') {
					value[1] = '#text';
				}
	
				return resolvePathItem(result, value[1], parseInt(value[2], 10));
			}, rootNode);
	
			if (!container) {
				return null;
			}
	
			if (!isText(container)) {
				if (offset === 'after') {
					offset = nodeIndex(container) + 1;
				} else {
					offset = nodeIndex(container);
				}
	
				return new CaretPosition(container.parentNode, offset);
			}
	
			return findTextPosition(container, parseInt(offset, 10));
		}
	
		return {
			/**
			 * Create a xpath bookmark location for the specified caret position.
			 *
			 * @method create
			 * @param {Node} rootNode Root node to create bookmark within.
			 * @param {tinymce.caret.CaretPosition} caretPosition Caret position within the root node.
			 * @return {String} String xpath like location of caret position.
			 */
			create: create,
	
			/**
			 * Resolves a xpath like bookmark location to the a caret position.
			 *
			 * @method resolve
			 * @param {Node} rootNode Root node to resolve xpath bookmark within.
			 * @param {String} bookmark Bookmark string to resolve.
			 * @return {tinymce.caret.CaretPosition} Caret position resolved from xpath like bookmark.
			 */
			resolve: resolve
		};
	});
	
	// Included from: js/tinymce/classes/dom/BookmarkManager.js
	
	/**
	 * BookmarkManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles selection bookmarks.
	 *
	 * @class tinymce.dom.BookmarkManager
	 */
	define("tinymce/dom/BookmarkManager", [
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/caret/CaretContainer",
		"tinymce/caret/CaretBookmark",
		"tinymce/caret/CaretPosition",
		"tinymce/dom/NodeType"
	], function(Env, Tools, CaretContainer, CaretBookmark, CaretPosition, NodeType) {
		var isContentEditableFalse = NodeType.isContentEditableFalse;
	
		/**
		 * Constructs a new BookmarkManager instance for a specific selection instance.
		 *
		 * @constructor
		 * @method BookmarkManager
		 * @param {tinymce.dom.Selection} selection Selection instance to handle bookmarks for.
		 */
		function BookmarkManager(selection) {
			var dom = selection.dom;
	
			/**
			 * Returns a bookmark location for the current selection. This bookmark object
			 * can then be used to restore the selection after some content modification to the document.
			 *
			 * @method getBookmark
			 * @param {Number} type Optional state if the bookmark should be simple or not. Default is complex.
			 * @param {Boolean} normalized Optional state that enables you to get a position that it would be after normalization.
			 * @return {Object} Bookmark object, use moveToBookmark with this object to restore the selection.
			 * @example
			 * // Stores a bookmark of the current selection
			 * var bm = tinymce.activeEditor.selection.getBookmark();
			 *
			 * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
			 *
			 * // Restore the selection bookmark
			 * tinymce.activeEditor.selection.moveToBookmark(bm);
			 */
			this.getBookmark = function(type, normalized) {
				var rng, rng2, id, collapsed, name, element, chr = '&#xFEFF;', styles;
	
				function findIndex(name, element) {
					var count = 0;
	
					Tools.each(dom.select(name), function(node) {
						if (node.getAttribute('data-mce-bogus') === 'all') {
							return;
						}
	
						if (node == element) {
							return false;
						}
	
						count++;
					});
	
					return count;
				}
	
				function normalizeTableCellSelection(rng) {
					function moveEndPoint(start) {
						var container, offset, childNodes, prefix = start ? 'start' : 'end';
	
						container = rng[prefix + 'Container'];
						offset = rng[prefix + 'Offset'];
	
						if (container.nodeType == 1 && container.nodeName == "TR") {
							childNodes = container.childNodes;
							container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
							if (container) {
								offset = start ? 0 : container.childNodes.length;
								rng['set' + (start ? 'Start' : 'End')](container, offset);
							}
						}
					}
	
					moveEndPoint(true);
					moveEndPoint();
	
					return rng;
				}
	
				function getLocation(rng) {
					var root = dom.getRoot(), bookmark = {};
	
					function getPoint(rng, start) {
						var container = rng[start ? 'startContainer' : 'endContainer'],
							offset = rng[start ? 'startOffset' : 'endOffset'], point = [], node, childNodes, after = 0;
	
						if (container.nodeType == 3) {
							if (normalized) {
								for (node = container.previousSibling; node && node.nodeType == 3; node = node.previousSibling) {
									offset += node.nodeValue.length;
								}
							}
	
							point.push(offset);
						} else {
							childNodes = container.childNodes;
	
							if (offset >= childNodes.length && childNodes.length) {
								after = 1;
								offset = Math.max(0, childNodes.length - 1);
							}
	
							point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
						}
	
						for (; container && container != root; container = container.parentNode) {
							point.push(dom.nodeIndex(container, normalized));
						}
	
						return point;
					}
	
					bookmark.start = getPoint(rng, true);
	
					if (!selection.isCollapsed()) {
						bookmark.end = getPoint(rng);
					}
	
					return bookmark;
				}
	
				function findAdjacentContentEditableFalseElm(rng) {
					function findSibling(node) {
						var sibling;
	
						if (CaretContainer.isCaretContainer(node)) {
							if (NodeType.isText(node) && CaretContainer.isCaretContainerBlock(node)) {
								node = node.parentNode;
							}
	
							sibling = node.previousSibling;
							if (isContentEditableFalse(sibling)) {
								return sibling;
							}
	
							sibling = node.nextSibling;
							if (isContentEditableFalse(sibling)) {
								return sibling;
							}
						}
					}
	
					return findSibling(rng.startContainer) || findSibling(rng.endContainer);
				}
	
				if (type == 2) {
					element = selection.getNode();
					name = element ? element.nodeName : null;
					rng = selection.getRng();
	
					if (isContentEditableFalse(element) || name == 'IMG') {
						return {name: name, index: findIndex(name, element)};
					}
	
					if (selection.tridentSel) {
						return selection.tridentSel.getBookmark(type);
					}
	
					element = findAdjacentContentEditableFalseElm(rng);
					if (element) {
						name = element.tagName;
						return {name: name, index: findIndex(name, element)};
					}
	
					return getLocation(rng);
				}
	
				if (type == 3) {
					rng = selection.getRng();
	
					return {
						start: CaretBookmark.create(dom.getRoot(), CaretPosition.fromRangeStart(rng)),
						end: CaretBookmark.create(dom.getRoot(), CaretPosition.fromRangeEnd(rng))
					};
				}
	
				// Handle simple range
				if (type) {
					return {rng: selection.getRng()};
				}
	
				rng = selection.getRng();
				id = dom.uniqueId();
				collapsed = selection.isCollapsed();
				styles = 'overflow:hidden;line-height:0px';
	
				// Explorer method
				if (rng.duplicate || rng.item) {
					// Text selection
					if (!rng.item) {
						rng2 = rng.duplicate();
	
						try {
							// Insert start marker
							rng.collapse();
							rng.pasteHTML('<span data-mce-type="bookmark" id="' + id + '_start" style="' + styles + '">' + chr + '</span>');
	
							// Insert end marker
							if (!collapsed) {
								rng2.collapse(false);
	
								// Detect the empty space after block elements in IE and move the
								// end back one character <p></p>] becomes <p>]</p>
								rng.moveToElementText(rng2.parentElement());
								if (rng.compareEndPoints('StartToEnd', rng2) === 0) {
									rng2.move('character', -1);
								}
	
								rng2.pasteHTML('<span data-mce-type="bookmark" id="' + id + '_end" style="' + styles + '">' + chr + '</span>');
							}
						} catch (ex) {
							// IE might throw unspecified error so lets ignore it
							return null;
						}
					} else {
						// Control selection
						element = rng.item(0);
						name = element.nodeName;
	
						return {name: name, index: findIndex(name, element)};
					}
				} else {
					element = selection.getNode();
					name = element.nodeName;
					if (name == 'IMG') {
						return {name: name, index: findIndex(name, element)};
					}
	
					// W3C method
					rng2 = normalizeTableCellSelection(rng.cloneRange());
	
					// Insert end marker
					if (!collapsed) {
						rng2.collapse(false);
						rng2.insertNode(dom.create('span', {'data-mce-type': "bookmark", id: id + '_end', style: styles}, chr));
					}
	
					rng = normalizeTableCellSelection(rng);
					rng.collapse(true);
					rng.insertNode(dom.create('span', {'data-mce-type': "bookmark", id: id + '_start', style: styles}, chr));
				}
	
				selection.moveToBookmark({id: id, keep: 1});
	
				return {id: id};
			};
	
			/**
			 * Restores the selection to the specified bookmark.
			 *
			 * @method moveToBookmark
			 * @param {Object} bookmark Bookmark to restore selection from.
			 * @return {Boolean} true/false if it was successful or not.
			 * @example
			 * // Stores a bookmark of the current selection
			 * var bm = tinymce.activeEditor.selection.getBookmark();
			 *
			 * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
			 *
			 * // Restore the selection bookmark
			 * tinymce.activeEditor.selection.moveToBookmark(bm);
			 */
			this.moveToBookmark = function(bookmark) {
				var rng, root, startContainer, endContainer, startOffset, endOffset;
	
				function setEndPoint(start) {
					var point = bookmark[start ? 'start' : 'end'], i, node, offset, children;
	
					if (point) {
						offset = point[0];
	
						// Find container node
						for (node = root, i = point.length - 1; i >= 1; i--) {
							children = node.childNodes;
	
							if (point[i] > children.length - 1) {
								return;
							}
	
							node = children[point[i]];
						}
	
						// Move text offset to best suitable location
						if (node.nodeType === 3) {
							offset = Math.min(point[0], node.nodeValue.length);
						}
	
						// Move element offset to best suitable location
						if (node.nodeType === 1) {
							offset = Math.min(point[0], node.childNodes.length);
						}
	
						// Set offset within container node
						if (start) {
							rng.setStart(node, offset);
						} else {
							rng.setEnd(node, offset);
						}
					}
	
					return true;
				}
	
				function restoreEndPoint(suffix) {
					var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev, keep = bookmark.keep;
	
					if (marker) {
						node = marker.parentNode;
	
						if (suffix == 'start') {
							if (!keep) {
								idx = dom.nodeIndex(marker);
							} else {
								node = marker.firstChild;
								idx = 1;
							}
	
							startContainer = endContainer = node;
							startOffset = endOffset = idx;
						} else {
							if (!keep) {
								idx = dom.nodeIndex(marker);
							} else {
								node = marker.firstChild;
								idx = 1;
							}
	
							endContainer = node;
							endOffset = idx;
						}
	
						if (!keep) {
							prev = marker.previousSibling;
							next = marker.nextSibling;
	
							// Remove all marker text nodes
							Tools.each(Tools.grep(marker.childNodes), function(node) {
								if (node.nodeType == 3) {
									node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
								}
							});
	
							// Remove marker but keep children if for example contents where inserted into the marker
							// Also remove duplicated instances of the marker for example by a
							// split operation or by WebKit auto split on paste feature
							while ((marker = dom.get(bookmark.id + '_' + suffix))) {
								dom.remove(marker, 1);
							}
	
							// If siblings are text nodes then merge them unless it's Opera since it some how removes the node
							// and we are sniffing since adding a lot of detection code for a browser with 3% of the market
							// isn't worth the effort. Sorry, Opera but it's just a fact
							if (prev && next && prev.nodeType == next.nodeType && prev.nodeType == 3 && !Env.opera) {
								idx = prev.nodeValue.length;
								prev.appendData(next.nodeValue);
								dom.remove(next);
	
								if (suffix == 'start') {
									startContainer = endContainer = prev;
									startOffset = endOffset = idx;
								} else {
									endContainer = prev;
									endOffset = idx;
								}
							}
						}
					}
				}
	
				function addBogus(node) {
					// Adds a bogus BR element for empty block elements
					if (dom.isBlock(node) && !node.innerHTML && !Env.ie) {
						node.innerHTML = '<br data-mce-bogus="1" />';
					}
	
					return node;
				}
	
				function resolveCaretPositionBookmark() {
					var rng, pos;
	
					rng = dom.createRng();
					pos = CaretBookmark.resolve(dom.getRoot(), bookmark.start);
					rng.setStart(pos.container(), pos.offset());
	
					pos = CaretBookmark.resolve(dom.getRoot(), bookmark.end);
					rng.setEnd(pos.container(), pos.offset());
	
					return rng;
				}
	
				if (bookmark) {
					if (Tools.isArray(bookmark.start)) {
						rng = dom.createRng();
						root = dom.getRoot();
	
						if (selection.tridentSel) {
							return selection.tridentSel.moveToBookmark(bookmark);
						}
	
						if (setEndPoint(true) && setEndPoint()) {
							selection.setRng(rng);
						}
					} else if (typeof bookmark.start == 'string') {
						selection.setRng(resolveCaretPositionBookmark(bookmark));
					} else if (bookmark.id) {
						// Restore start/end points
						restoreEndPoint('start');
						restoreEndPoint('end');
	
						if (startContainer) {
							rng = dom.createRng();
							rng.setStart(addBogus(startContainer), startOffset);
							rng.setEnd(addBogus(endContainer), endOffset);
							selection.setRng(rng);
						}
					} else if (bookmark.name) {
						selection.select(dom.select(bookmark.name)[bookmark.index]);
					} else if (bookmark.rng) {
						selection.setRng(bookmark.rng);
					}
				}
			};
		}
	
		/**
		 * Returns true/false if the specified node is a bookmark node or not.
		 *
		 * @static
		 * @method isBookmarkNode
		 * @param {DOMNode} node DOM Node to check if it's a bookmark node or not.
		 * @return {Boolean} true/false if the node is a bookmark node or not.
		 */
		BookmarkManager.isBookmarkNode = function(node) {
			return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
		};
	
		return BookmarkManager;
	});
	
	// Included from: js/tinymce/classes/dom/Selection.js
	
	/**
	 * Selection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles text and control selection it's an crossbrowser utility class.
	 * Consult the TinyMCE Wiki API for more details and examples on how to use this class.
	 *
	 * @class tinymce.dom.Selection
	 * @example
	 * // Getting the currently selected node for the active editor
	 * alert(tinymce.activeEditor.selection.getNode().nodeName);
	 */
	define("tinymce/dom/Selection", [
		"tinymce/dom/TreeWalker",
		"tinymce/dom/TridentSelection",
		"tinymce/dom/ControlSelection",
		"tinymce/dom/RangeUtils",
		"tinymce/dom/BookmarkManager",
		"tinymce/dom/NodeType",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/caret/CaretPosition"
	], function(TreeWalker, TridentSelection, ControlSelection, RangeUtils, BookmarkManager, NodeType, Env, Tools, CaretPosition) {
		var each = Tools.each, trim = Tools.trim;
		var isIE = Env.ie;
	
		/**
		 * Constructs a new selection instance.
		 *
		 * @constructor
		 * @method Selection
		 * @param {tinymce.dom.DOMUtils} dom DOMUtils object reference.
		 * @param {Window} win Window to bind the selection object to.
		 * @param {tinymce.Editor} editor Editor instance of the selection.
		 * @param {tinymce.dom.Serializer} serializer DOM serialization class to use for getContent.
		 */
		function Selection(dom, win, serializer, editor) {
			var self = this;
	
			self.dom = dom;
			self.win = win;
			self.serializer = serializer;
			self.editor = editor;
			self.bookmarkManager = new BookmarkManager(self);
			self.controlSelection = new ControlSelection(self, editor);
	
			// No W3C Range support
			if (!self.win.getSelection) {
				self.tridentSel = new TridentSelection(self);
			}
		}
	
		Selection.prototype = {
			/**
			 * Move the selection cursor range to the specified node and offset.
			 * If there is no node specified it will move it to the first suitable location within the body.
			 *
			 * @method setCursorLocation
			 * @param {Node} node Optional node to put the cursor in.
			 * @param {Number} offset Optional offset from the start of the node to put the cursor at.
			 */
			setCursorLocation: function(node, offset) {
				var self = this, rng = self.dom.createRng();
	
				if (!node) {
					self._moveEndPoint(rng, self.editor.getBody(), true);
					self.setRng(rng);
				} else {
					rng.setStart(node, offset);
					rng.setEnd(node, offset);
					self.setRng(rng);
					self.collapse(false);
				}
			},
	
			/**
			 * Returns the selected contents using the DOM serializer passed in to this class.
			 *
			 * @method getContent
			 * @param {Object} args Optional settings class with for example output format text or html.
			 * @return {String} Selected contents in for example HTML format.
			 * @example
			 * // Alerts the currently selected contents
			 * alert(tinymce.activeEditor.selection.getContent());
			 *
			 * // Alerts the currently selected contents as plain text
			 * alert(tinymce.activeEditor.selection.getContent({format: 'text'}));
			 */
			getContent: function(args) {
				var self = this, rng = self.getRng(), tmpElm = self.dom.create("body");
				var se = self.getSel(), whiteSpaceBefore, whiteSpaceAfter, fragment;
	
				args = args || {};
				whiteSpaceBefore = whiteSpaceAfter = '';
				args.get = true;
				args.format = args.format || 'html';
				args.selection = true;
				self.editor.fire('BeforeGetContent', args);
	
				if (args.format == 'text') {
					return self.isCollapsed() ? '' : (rng.text || (se.toString ? se.toString() : ''));
				}
	
				if (rng.cloneContents) {
					fragment = rng.cloneContents();
	
					if (fragment) {
						tmpElm.appendChild(fragment);
					}
				} else if (rng.item !== undefined || rng.htmlText !== undefined) {
					// IE will produce invalid markup if elements are present that
					// it doesn't understand like custom elements or HTML5 elements.
					// Adding a BR in front of the contents and then remoiving it seems to fix it though.
					tmpElm.innerHTML = '<br>' + (rng.item ? rng.item(0).outerHTML : rng.htmlText);
					tmpElm.removeChild(tmpElm.firstChild);
				} else {
					tmpElm.innerHTML = rng.toString();
				}
	
				// Keep whitespace before and after
				if (/^\s/.test(tmpElm.innerHTML)) {
					whiteSpaceBefore = ' ';
				}
	
				if (/\s+$/.test(tmpElm.innerHTML)) {
					whiteSpaceAfter = ' ';
				}
	
				args.getInner = true;
	
				args.content = self.isCollapsed() ? '' : whiteSpaceBefore + self.serializer.serialize(tmpElm, args) + whiteSpaceAfter;
				self.editor.fire('GetContent', args);
	
				return args.content;
			},
	
			/**
			 * Sets the current selection to the specified content. If any contents is selected it will be replaced
			 * with the contents passed in to this function. If there is no selection the contents will be inserted
			 * where the caret is placed in the editor/page.
			 *
			 * @method setContent
			 * @param {String} content HTML contents to set could also be other formats depending on settings.
			 * @param {Object} args Optional settings object with for example data format.
			 * @example
			 * // Inserts some HTML contents at the current selection
			 * tinymce.activeEditor.selection.setContent('<strong>Some contents</strong>');
			 */
			setContent: function(content, args) {
				var self = this, rng = self.getRng(), caretNode, doc = self.win.document, frag, temp;
	
				args = args || {format: 'html'};
				args.set = true;
				args.selection = true;
				args.content = content;
	
				// Dispatch before set content event
				if (!args.no_events) {
					self.editor.fire('BeforeSetContent', args);
				}
	
				content = args.content;
	
				if (rng.insertNode) {
					// Make caret marker since insertNode places the caret in the beginning of text after insert
					content += '<span id="__caret">_</span>';
	
					// Delete and insert new node
					if (rng.startContainer == doc && rng.endContainer == doc) {
						// WebKit will fail if the body is empty since the range is then invalid and it can't insert contents
						doc.body.innerHTML = content;
					} else {
						rng.deleteContents();
	
						if (doc.body.childNodes.length === 0) {
							doc.body.innerHTML = content;
						} else {
							// createContextualFragment doesn't exists in IE 9 DOMRanges
							if (rng.createContextualFragment) {
								rng.insertNode(rng.createContextualFragment(content));
							} else {
								// Fake createContextualFragment call in IE 9
								frag = doc.createDocumentFragment();
								temp = doc.createElement('div');
	
								frag.appendChild(temp);
								temp.outerHTML = content;
	
								rng.insertNode(frag);
							}
						}
					}
	
					// Move to caret marker
					caretNode = self.dom.get('__caret');
	
					// Make sure we wrap it compleatly, Opera fails with a simple select call
					rng = doc.createRange();
					rng.setStartBefore(caretNode);
					rng.setEndBefore(caretNode);
					self.setRng(rng);
	
					// Remove the caret position
					self.dom.remove('__caret');
	
					try {
						self.setRng(rng);
					} catch (ex) {
						// Might fail on Opera for some odd reason
					}
				} else {
					if (rng.item) {
						// Delete content and get caret text selection
						doc.execCommand('Delete', false, null);
						rng = self.getRng();
					}
	
					// Explorer removes spaces from the beginning of pasted contents
					if (/^\s+/.test(content)) {
						rng.pasteHTML('<span id="__mce_tmp">_</span>' + content);
						self.dom.remove('__mce_tmp');
					} else {
						rng.pasteHTML(content);
					}
				}
	
				// Dispatch set content event
				if (!args.no_events) {
					self.editor.fire('SetContent', args);
				}
			},
	
			/**
			 * Returns the start element of a selection range. If the start is in a text
			 * node the parent element will be returned.
			 *
			 * @method getStart
			 * @param {Boolean} real Optional state to get the real parent when the selection is collapsed not the closest element.
			 * @return {Element} Start element of selection range.
			 */
			getStart: function(real) {
				var self = this, rng = self.getRng(), startElement, parentElement, checkRng, node;
	
				if (rng.duplicate || rng.item) {
					// Control selection, return first item
					if (rng.item) {
						return rng.item(0);
					}
	
					// Get start element
					checkRng = rng.duplicate();
					checkRng.collapse(1);
					startElement = checkRng.parentElement();
					if (startElement.ownerDocument !== self.dom.doc) {
						startElement = self.dom.getRoot();
					}
	
					// Check if range parent is inside the start element, then return the inner parent element
					// This will fix issues when a single element is selected, IE would otherwise return the wrong start element
					parentElement = node = rng.parentElement();
					while ((node = node.parentNode)) {
						if (node == startElement) {
							startElement = parentElement;
							break;
						}
					}
	
					return startElement;
				}
	
				startElement = rng.startContainer;
	
				if (startElement.nodeType == 1 && startElement.hasChildNodes()) {
					if (!real || !rng.collapsed) {
						startElement = startElement.childNodes[Math.min(startElement.childNodes.length - 1, rng.startOffset)];
					}
				}
	
				if (startElement && startElement.nodeType == 3) {
					return startElement.parentNode;
				}
	
				return startElement;
			},
	
			/**
			 * Returns the end element of a selection range. If the end is in a text
			 * node the parent element will be returned.
			 *
			 * @method getEnd
			 * @param {Boolean} real Optional state to get the real parent when the selection is collapsed not the closest element.
			 * @return {Element} End element of selection range.
			 */
			getEnd: function(real) {
				var self = this, rng = self.getRng(), endElement, endOffset;
	
				if (rng.duplicate || rng.item) {
					if (rng.item) {
						return rng.item(0);
					}
	
					rng = rng.duplicate();
					rng.collapse(0);
					endElement = rng.parentElement();
					if (endElement.ownerDocument !== self.dom.doc) {
						endElement = self.dom.getRoot();
					}
	
					if (endElement && endElement.nodeName == 'BODY') {
						return endElement.lastChild || endElement;
					}
	
					return endElement;
				}
	
				endElement = rng.endContainer;
				endOffset = rng.endOffset;
	
				if (endElement.nodeType == 1 && endElement.hasChildNodes()) {
					if (!real || !rng.collapsed) {
						endElement = endElement.childNodes[endOffset > 0 ? endOffset - 1 : endOffset];
					}
				}
	
				if (endElement && endElement.nodeType == 3) {
					return endElement.parentNode;
				}
	
				return endElement;
			},
	
			/**
			 * Returns a bookmark location for the current selection. This bookmark object
			 * can then be used to restore the selection after some content modification to the document.
			 *
			 * @method getBookmark
			 * @param {Number} type Optional state if the bookmark should be simple or not. Default is complex.
			 * @param {Boolean} normalized Optional state that enables you to get a position that it would be after normalization.
			 * @return {Object} Bookmark object, use moveToBookmark with this object to restore the selection.
			 * @example
			 * // Stores a bookmark of the current selection
			 * var bm = tinymce.activeEditor.selection.getBookmark();
			 *
			 * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
			 *
			 * // Restore the selection bookmark
			 * tinymce.activeEditor.selection.moveToBookmark(bm);
			 */
			getBookmark: function(type, normalized) {
				return this.bookmarkManager.getBookmark(type, normalized);
			},
	
			/**
			 * Restores the selection to the specified bookmark.
			 *
			 * @method moveToBookmark
			 * @param {Object} bookmark Bookmark to restore selection from.
			 * @return {Boolean} true/false if it was successful or not.
			 * @example
			 * // Stores a bookmark of the current selection
			 * var bm = tinymce.activeEditor.selection.getBookmark();
			 *
			 * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
			 *
			 * // Restore the selection bookmark
			 * tinymce.activeEditor.selection.moveToBookmark(bm);
			 */
			moveToBookmark: function(bookmark) {
				return this.bookmarkManager.moveToBookmark(bookmark);
			},
	
			/**
			 * Selects the specified element. This will place the start and end of the selection range around the element.
			 *
			 * @method select
			 * @param {Element} node HTML DOM element to select.
			 * @param {Boolean} content Optional bool state if the contents should be selected or not on non IE browser.
			 * @return {Element} Selected element the same element as the one that got passed in.
			 * @example
			 * // Select the first paragraph in the active editor
			 * tinymce.activeEditor.selection.select(tinymce.activeEditor.dom.select('p')[0]);
			 */
			select: function(node, content) {
				var self = this, dom = self.dom, rng = dom.createRng(), idx;
	
				// Clear stored range set by FocusManager
				self.lastFocusBookmark = null;
	
				if (node) {
					if (!content && self.controlSelection.controlSelect(node)) {
						return;
					}
	
					idx = dom.nodeIndex(node);
					rng.setStart(node.parentNode, idx);
					rng.setEnd(node.parentNode, idx + 1);
	
					// Find first/last text node or BR element
					if (content) {
						self._moveEndPoint(rng, node, true);
						self._moveEndPoint(rng, node);
					}
	
					self.setRng(rng);
				}
	
				return node;
			},
	
			/**
			 * Returns true/false if the selection range is collapsed or not. Collapsed means if it's a caret or a larger selection.
			 *
			 * @method isCollapsed
			 * @return {Boolean} true/false state if the selection range is collapsed or not.
			 * Collapsed means if it's a caret or a larger selection.
			 */
			isCollapsed: function() {
				var self = this, rng = self.getRng(), sel = self.getSel();
	
				if (!rng || rng.item) {
					return false;
				}
	
				if (rng.compareEndPoints) {
					return rng.compareEndPoints('StartToEnd', rng) === 0;
				}
	
				return !sel || rng.collapsed;
			},
	
			/**
			 * Collapse the selection to start or end of range.
			 *
			 * @method collapse
			 * @param {Boolean} toStart Optional boolean state if to collapse to end or not. Defaults to false.
			 */
			collapse: function(toStart) {
				var self = this, rng = self.getRng(), node;
	
				// Control range on IE
				if (rng.item) {
					node = rng.item(0);
					rng = self.win.document.body.createTextRange();
					rng.moveToElementText(node);
				}
	
				rng.collapse(!!toStart);
				self.setRng(rng);
			},
	
			/**
			 * Returns the browsers internal selection object.
			 *
			 * @method getSel
			 * @return {Selection} Internal browser selection object.
			 */
			getSel: function() {
				var win = this.win;
	
				return win.getSelection ? win.getSelection() : win.document.selection;
			},
	
			/**
			 * Returns the browsers internal range object.
			 *
			 * @method getRng
			 * @param {Boolean} w3c Forces a compatible W3C range on IE.
			 * @return {Range} Internal browser range object.
			 * @see http://www.quirksmode.org/dom/range_intro.html
			 * @see http://www.dotvoid.com/2001/03/using-the-range-object-in-mozilla/
			 */
			getRng: function(w3c) {
				var self = this, selection, rng, elm, doc, ieRng, evt;
	
				function tryCompareBoundaryPoints(how, sourceRange, destinationRange) {
					try {
						return sourceRange.compareBoundaryPoints(how, destinationRange);
					} catch (ex) {
						// Gecko throws wrong document exception if the range points
						// to nodes that where removed from the dom #6690
						// Browsers should mutate existing DOMRange instances so that they always point
						// to something in the document this is not the case in Gecko works fine in IE/WebKit/Blink
						// For performance reasons just return -1
						return -1;
					}
				}
	
				if (!self.win) {
					return null;
				}
	
				doc = self.win.document;
	
				// Use last rng passed from FocusManager if it's available this enables
				// calls to editor.selection.getStart() to work when caret focus is lost on IE
				if (!w3c && self.lastFocusBookmark) {
					var bookmark = self.lastFocusBookmark;
	
					// Convert bookmark to range IE 11 fix
					if (bookmark.startContainer) {
						rng = doc.createRange();
						rng.setStart(bookmark.startContainer, bookmark.startOffset);
						rng.setEnd(bookmark.endContainer, bookmark.endOffset);
					} else {
						rng = bookmark;
					}
	
					return rng;
				}
	
				// Found tridentSel object then we need to use that one
				if (w3c && self.tridentSel) {
					return self.tridentSel.getRangeAt(0);
				}
	
				try {
					if ((selection = self.getSel())) {
						if (selection.rangeCount > 0) {
							rng = selection.getRangeAt(0);
						} else {
							rng = selection.createRange ? selection.createRange() : doc.createRange();
						}
					}
				} catch (ex) {
					// IE throws unspecified error here if TinyMCE is placed in a frame/iframe
				}
	
				evt = self.editor.fire('GetSelectionRange', {range: rng});
				if (evt.range !== rng) {
					return evt.range;
				}
	
				// We have W3C ranges and it's IE then fake control selection since IE9 doesn't handle that correctly yet
				// IE 11 doesn't support the selection object so we check for that as well
				if (isIE && rng && rng.setStart && doc.selection) {
					try {
						// IE will sometimes throw an exception here
						ieRng = doc.selection.createRange();
					} catch (ex) {
						// Ignore
					}
	
					if (ieRng && ieRng.item) {
						elm = ieRng.item(0);
						rng = doc.createRange();
						rng.setStartBefore(elm);
						rng.setEndAfter(elm);
					}
				}
	
				// No range found then create an empty one
				// This can occur when the editor is placed in a hidden container element on Gecko
				// Or on IE when there was an exception
				if (!rng) {
					rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
				}
	
				// If range is at start of document then move it to start of body
				if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
					elm = self.dom.getRoot();
					rng.setStart(elm, 0);
					rng.setEnd(elm, 0);
				}
	
				if (self.selectedRange && self.explicitRange) {
					if (tryCompareBoundaryPoints(rng.START_TO_START, rng, self.selectedRange) === 0 &&
						tryCompareBoundaryPoints(rng.END_TO_END, rng, self.selectedRange) === 0) {
						// Safari, Opera and Chrome only ever select text which causes the range to change.
						// This lets us use the originally set range if the selection hasn't been changed by the user.
						rng = self.explicitRange;
					} else {
						self.selectedRange = null;
						self.explicitRange = null;
					}
				}
	
				return rng;
			},
	
			/**
			 * Changes the selection to the specified DOM range.
			 *
			 * @method setRng
			 * @param {Range} rng Range to select.
			 * @param {Boolean} forward Optional boolean if the selection is forwards or backwards.
			 */
			setRng: function(rng, forward) {
				var self = this, sel, node, evt;
	
				if (!rng) {
					return;
				}
	
				// Is IE specific range
				if (rng.select) {
					self.explicitRange = null;
	
					try {
						rng.select();
					} catch (ex) {
						// Needed for some odd IE bug #1843306
					}
	
					return;
				}
	
				if (!self.tridentSel) {
					sel = self.getSel();
	
					evt = self.editor.fire('SetSelectionRange', {range: rng});
					rng = evt.range;
	
					if (sel) {
						self.explicitRange = rng;
	
						try {
							sel.removeAllRanges();
							sel.addRange(rng);
						} catch (ex) {
							// IE might throw errors here if the editor is within a hidden container and selection is changed
						}
	
						// Forward is set to false and we have an extend function
						if (forward === false && sel.extend) {
							sel.collapse(rng.endContainer, rng.endOffset);
							sel.extend(rng.startContainer, rng.startOffset);
						}
	
						// adding range isn't always successful so we need to check range count otherwise an exception can occur
						self.selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
					}
	
					// WebKit egde case selecting images works better using setBaseAndExtent
					if (!rng.collapsed && rng.startContainer == rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
						if (rng.endOffset - rng.startOffset < 2) {
							if (rng.startContainer.hasChildNodes()) {
								node = rng.startContainer.childNodes[rng.startOffset];
								if (node && node.tagName == 'IMG') {
									self.getSel().setBaseAndExtent(node, 0, node, 1);
								}
							}
						}
					}
				} else {
					// Is W3C Range fake range on IE
					if (rng.cloneRange) {
						try {
							self.tridentSel.addRange(rng);
						} catch (ex) {
							//IE9 throws an error here if called before selection is placed in the editor
						}
					}
				}
			},
	
			/**
			 * Sets the current selection to the specified DOM element.
			 *
			 * @method setNode
			 * @param {Element} elm Element to set as the contents of the selection.
			 * @return {Element} Returns the element that got passed in.
			 * @example
			 * // Inserts a DOM node at current selection/caret location
			 * tinymce.activeEditor.selection.setNode(tinymce.activeEditor.dom.create('img', {src: 'some.gif', title: 'some title'}));
			 */
			setNode: function(elm) {
				var self = this;
	
				self.setContent(self.dom.getOuterHTML(elm));
	
				return elm;
			},
	
			/**
			 * Returns the currently selected element or the common ancestor element for both start and end of the selection.
			 *
			 * @method getNode
			 * @return {Element} Currently selected element or common ancestor element.
			 * @example
			 * // Alerts the currently selected elements node name
			 * alert(tinymce.activeEditor.selection.getNode().nodeName);
			 */
			getNode: function() {
				var self = this, rng = self.getRng(), elm;
				var startContainer, endContainer, startOffset, endOffset, root = self.dom.getRoot();
	
				function skipEmptyTextNodes(node, forwards) {
					var orig = node;
	
					while (node && node.nodeType === 3 && node.length === 0) {
						node = forwards ? node.nextSibling : node.previousSibling;
					}
	
					return node || orig;
				}
	
				// Range maybe lost after the editor is made visible again
				if (!rng) {
					return root;
				}
	
				startContainer = rng.startContainer;
				endContainer = rng.endContainer;
				startOffset = rng.startOffset;
				endOffset = rng.endOffset;
	
				if (rng.setStart) {
					elm = rng.commonAncestorContainer;
	
					// Handle selection a image or other control like element such as anchors
					if (!rng.collapsed) {
						if (startContainer == endContainer) {
							if (endOffset - startOffset < 2) {
								if (startContainer.hasChildNodes()) {
									elm = startContainer.childNodes[startOffset];
								}
							}
						}
	
						// If the anchor node is a element instead of a text node then return this element
						//if (tinymce.isWebKit && sel.anchorNode && sel.anchorNode.nodeType == 1)
						//	return sel.anchorNode.childNodes[sel.anchorOffset];
	
						// Handle cases where the selection is immediately wrapped around a node and return that node instead of it's parent.
						// This happens when you double click an underlined word in FireFox.
						if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
							if (startContainer.length === startOffset) {
								startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
							} else {
								startContainer = startContainer.parentNode;
							}
	
							if (endOffset === 0) {
								endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
							} else {
								endContainer = endContainer.parentNode;
							}
	
							if (startContainer && startContainer === endContainer) {
								return startContainer;
							}
						}
					}
	
					if (elm && elm.nodeType == 3) {
						return elm.parentNode;
					}
	
					return elm;
				}
	
				elm = rng.item ? rng.item(0) : rng.parentElement();
	
				// IE 7 might return elements outside the iframe
				if (elm.ownerDocument !== self.win.document) {
					elm = root;
				}
	
				return elm;
			},
	
			getSelectedBlocks: function(startElm, endElm) {
				var self = this, dom = self.dom, node, root, selectedBlocks = [];
	
				root = dom.getRoot();
				startElm = dom.getParent(startElm || self.getStart(), dom.isBlock);
				endElm = dom.getParent(endElm || self.getEnd(), dom.isBlock);
	
				if (startElm && startElm != root) {
					selectedBlocks.push(startElm);
				}
	
				if (startElm && endElm && startElm != endElm) {
					node = startElm;
	
					var walker = new TreeWalker(startElm, root);
					while ((node = walker.next()) && node != endElm) {
						if (dom.isBlock(node)) {
							selectedBlocks.push(node);
						}
					}
				}
	
				if (endElm && startElm != endElm && endElm != root) {
					selectedBlocks.push(endElm);
				}
	
				return selectedBlocks;
			},
	
			isForward: function() {
				var dom = this.dom, sel = this.getSel(), anchorRange, focusRange;
	
				// No support for selection direction then always return true
				if (!sel || !sel.anchorNode || !sel.focusNode) {
					return true;
				}
	
				anchorRange = dom.createRng();
				anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
				anchorRange.collapse(true);
	
				focusRange = dom.createRng();
				focusRange.setStart(sel.focusNode, sel.focusOffset);
				focusRange.collapse(true);
	
				return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
			},
	
			normalize: function() {
				var self = this, rng = self.getRng();
	
				if (Env.range && new RangeUtils(self.dom).normalize(rng)) {
					self.setRng(rng, self.isForward());
				}
	
				return rng;
			},
	
			/**
			 * Executes callback when the current selection starts/stops matching the specified selector. The current
			 * state will be passed to the callback as it's first argument.
			 *
			 * @method selectorChanged
			 * @param {String} selector CSS selector to check for.
			 * @param {function} callback Callback with state and args when the selector is matches or not.
			 */
			selectorChanged: function(selector, callback) {
				var self = this, currentSelectors;
	
				if (!self.selectorChangedData) {
					self.selectorChangedData = {};
					currentSelectors = {};
	
					self.editor.on('NodeChange', function(e) {
						var node = e.element, dom = self.dom, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
	
						// Check for new matching selectors
						each(self.selectorChangedData, function(callbacks, selector) {
							each(parents, function(node) {
								if (dom.is(node, selector)) {
									if (!currentSelectors[selector]) {
										// Execute callbacks
										each(callbacks, function(callback) {
											callback(true, {node: node, selector: selector, parents: parents});
										});
	
										currentSelectors[selector] = callbacks;
									}
	
									matchedSelectors[selector] = callbacks;
									return false;
								}
							});
						});
	
						// Check if current selectors still match
						each(currentSelectors, function(callbacks, selector) {
							if (!matchedSelectors[selector]) {
								delete currentSelectors[selector];
	
								each(callbacks, function(callback) {
									callback(false, {node: node, selector: selector, parents: parents});
								});
							}
						});
					});
				}
	
				// Add selector listeners
				if (!self.selectorChangedData[selector]) {
					self.selectorChangedData[selector] = [];
				}
	
				self.selectorChangedData[selector].push(callback);
	
				return self;
			},
	
			getScrollContainer: function() {
				var scrollContainer, node = this.dom.getRoot();
	
				while (node && node.nodeName != 'BODY') {
					if (node.scrollHeight > node.clientHeight) {
						scrollContainer = node;
						break;
					}
	
					node = node.parentNode;
				}
	
				return scrollContainer;
			},
	
			scrollIntoView: function(elm, alignToTop) {
				var y, viewPort, self = this, dom = self.dom, root = dom.getRoot(), viewPortY, viewPortH, offsetY = 0;
	
				function getPos(elm) {
					var x = 0, y = 0;
	
					var offsetParent = elm;
					while (offsetParent && offsetParent.nodeType) {
						x += offsetParent.offsetLeft || 0;
						y += offsetParent.offsetTop || 0;
						offsetParent = offsetParent.offsetParent;
					}
	
					return {x: x, y: y};
				}
	
				if (!NodeType.isElement(elm)) {
					return;
				}
	
				if (alignToTop === false) {
					offsetY = elm.offsetHeight;
				}
	
				if (root.nodeName != 'BODY') {
					var scrollContainer = self.getScrollContainer();
					if (scrollContainer) {
						y = getPos(elm).y - getPos(scrollContainer).y + offsetY;
						viewPortH = scrollContainer.clientHeight;
						viewPortY = scrollContainer.scrollTop;
						if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
							scrollContainer.scrollTop = y < viewPortY ? y : y - viewPortH + 25;
						}
	
						return;
					}
				}
	
				viewPort = dom.getViewPort(self.editor.getWin());
				y = dom.getPos(elm).y + offsetY;
				viewPortY = viewPort.y;
				viewPortH = viewPort.h;
				if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
					self.editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25);
				}
			},
	
			placeCaretAt: function(clientX, clientY) {
				this.setRng(RangeUtils.getCaretRangeFromPoint(clientX, clientY, this.editor.getDoc()));
			},
	
			_moveEndPoint: function(rng, node, start) {
				var root = node, walker = new TreeWalker(node, root);
				var nonEmptyElementsMap = this.dom.schema.getNonEmptyElements();
	
				do {
					// Text node
					if (node.nodeType == 3 && trim(node.nodeValue).length !== 0) {
						if (start) {
							rng.setStart(node, 0);
						} else {
							rng.setEnd(node, node.nodeValue.length);
						}
	
						return;
					}
	
					// BR/IMG/INPUT elements but not table cells
					if (nonEmptyElementsMap[node.nodeName] && !/^(TD|TH)$/.test(node.nodeName)) {
						if (start) {
							rng.setStartBefore(node);
						} else {
							if (node.nodeName == 'BR') {
								rng.setEndBefore(node);
							} else {
								rng.setEndAfter(node);
							}
						}
	
						return;
					}
	
					// Found empty text block old IE can place the selection inside those
					if (Env.ie && Env.ie < 11 && this.dom.isBlock(node) && this.dom.isEmpty(node)) {
						if (start) {
							rng.setStart(node, 0);
						} else {
							rng.setEnd(node, 0);
						}
	
						return;
					}
				} while ((node = (start ? walker.next() : walker.prev())));
	
				// Failed to find any text node or other suitable location then move to the root of body
				if (root.nodeName == 'BODY') {
					if (start) {
						rng.setStart(root, 0);
					} else {
						rng.setEnd(root, root.childNodes.length);
					}
				}
			},
	
			getBoundingClientRect:  function() {
				var rng = this.getRng();
				return rng.collapsed ? CaretPosition.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
			},
	
			destroy: function() {
				this.win = null;
				this.controlSelection.destroy();
			}
		};
	
		return Selection;
	});
	
	// Included from: js/tinymce/classes/dom/ElementUtils.js
	
	/**
	 * ElementUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for various element specific functions.
	 *
	 * @private
	 * @class tinymce.dom.ElementUtils
	 */
	define("tinymce/dom/ElementUtils", [
		"tinymce/dom/BookmarkManager",
		"tinymce/util/Tools"
	], function(BookmarkManager, Tools) {
		var each = Tools.each;
	
		function ElementUtils(dom) {
			/**
			 * Compares two nodes and checks if it's attributes and styles matches.
			 * This doesn't compare classes as items since their order is significant.
			 *
			 * @method compare
			 * @param {Node} node1 First node to compare with.
			 * @param {Node} node2 Second node to compare with.
			 * @return {boolean} True/false if the nodes are the same or not.
			 */
			this.compare = function(node1, node2) {
				// Not the same name
				if (node1.nodeName != node2.nodeName) {
					return false;
				}
	
				/**
				 * Returns all the nodes attributes excluding internal ones, styles and classes.
				 *
				 * @private
				 * @param {Node} node Node to get attributes from.
				 * @return {Object} Name/value object with attributes and attribute values.
				 */
				function getAttribs(node) {
					var attribs = {};
	
					each(dom.getAttribs(node), function(attr) {
						var name = attr.nodeName.toLowerCase();
	
						// Don't compare internal attributes or style
						if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
							attribs[name] = dom.getAttrib(node, name);
						}
					});
	
					return attribs;
				}
	
				/**
				 * Compares two objects checks if it's key + value exists in the other one.
				 *
				 * @private
				 * @param {Object} obj1 First object to compare.
				 * @param {Object} obj2 Second object to compare.
				 * @return {boolean} True/false if the objects matches or not.
				 */
				function compareObjects(obj1, obj2) {
					var value, name;
	
					for (name in obj1) {
						// Obj1 has item obj2 doesn't have
						if (obj1.hasOwnProperty(name)) {
							value = obj2[name];
	
							// Obj2 doesn't have obj1 item
							if (typeof value == "undefined") {
								return false;
							}
	
							// Obj2 item has a different value
							if (obj1[name] != value) {
								return false;
							}
	
							// Delete similar value
							delete obj2[name];
						}
					}
	
					// Check if obj 2 has something obj 1 doesn't have
					for (name in obj2) {
						// Obj2 has item obj1 doesn't have
						if (obj2.hasOwnProperty(name)) {
							return false;
						}
					}
	
					return true;
				}
	
				// Attribs are not the same
				if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
					return false;
				}
	
				// Styles are not the same
				if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
					return false;
				}
	
				return !BookmarkManager.isBookmarkNode(node1) && !BookmarkManager.isBookmarkNode(node2);
			};
		}
	
		return ElementUtils;
	});
	
	// Included from: js/tinymce/classes/fmt/Preview.js
	
	/**
	 * Preview.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class for generating previews styles for formats.
	 *
	 * Example:
	 *  Preview.getCssText(editor, 'bold');
	 *
	 * @private
	 * @class tinymce.fmt.Preview
	 */
	define("tinymce/fmt/Preview", [
		"tinymce/util/Tools"
	], function(Tools) {
		var each = Tools.each;
	
		function getCssText(editor, format) {
			var name, previewElm, dom = editor.dom;
			var previewCss = '', parentFontSize, previewStyles;
	
			previewStyles = editor.settings.preview_styles;
	
			// No preview forced
			if (previewStyles === false) {
				return '';
			}
	
			// Default preview
			if (!previewStyles) {
				previewStyles = 'font-family font-size font-weight font-style text-decoration ' +
					'text-transform color background-color border border-radius outline text-shadow';
			}
	
			// Removes any variables since these can't be previewed
			function removeVars(val) {
				return val.replace(/%(\w+)/g, '');
			}
	
			// Create block/inline element to use for preview
			if (typeof format == "string") {
				format = editor.formatter.get(format);
				if (!format) {
					return;
				}
	
				format = format[0];
			}
	
			name = format.block || format.inline || 'span';
			previewElm = dom.create(name);
	
			// Add format styles to preview element
			each(format.styles, function(value, name) {
				value = removeVars(value);
	
				if (value) {
					dom.setStyle(previewElm, name, value);
				}
			});
	
			// Add attributes to preview element
			each(format.attributes, function(value, name) {
				value = removeVars(value);
	
				if (value) {
					dom.setAttrib(previewElm, name, value);
				}
			});
	
			// Add classes to preview element
			each(format.classes, function(value) {
				value = removeVars(value);
	
				if (!dom.hasClass(previewElm, value)) {
					dom.addClass(previewElm, value);
				}
			});
	
			editor.fire('PreviewFormats');
	
			// Add the previewElm outside the visual area
			dom.setStyles(previewElm, {position: 'absolute', left: -0xFFFF});
			editor.getBody().appendChild(previewElm);
	
			// Get parent container font size so we can compute px values out of em/% for older IE:s
			parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
			parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	
			each(previewStyles.split(' '), function(name) {
				var value = dom.getStyle(previewElm, name, true);
	
				// If background is transparent then check if the body has a background color we can use
				if (name == 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
					value = dom.getStyle(editor.getBody(), name, true);
	
					// Ignore white since it's the default color, not the nicest fix
					// TODO: Fix this by detecting runtime style
					if (dom.toHex(value).toLowerCase() == '#ffffff') {
						return;
					}
				}
	
				if (name == 'color') {
					// Ignore black since it's the default color, not the nicest fix
					// TODO: Fix this by detecting runtime style
					if (dom.toHex(value).toLowerCase() == '#000000') {
						return;
					}
				}
	
				// Old IE won't calculate the font size so we need to do that manually
				if (name == 'font-size') {
					if (/em|%$/.test(value)) {
						if (parentFontSize === 0) {
							return;
						}
	
						// Convert font size from em/% to px
						value = parseFloat(value, 10) / (/%$/.test(value) ? 100 : 1);
						value = (value * parentFontSize) + 'px';
					}
				}
	
				if (name == "border" && value) {
					previewCss += 'padding:0 2px;';
				}
	
				previewCss += name + ':' + value + ';';
			});
	
			editor.fire('AfterPreviewFormats');
	
			//previewCss += 'line-height:normal';
	
			dom.remove(previewElm);
	
			return previewCss;
		}
	
		return {
			getCssText: getCssText
		};
	});
	
	// Included from: js/tinymce/classes/fmt/Hooks.js
	
	/**
	 * Hooks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class for overriding formatting.
	 *
	 * @private
	 * @class tinymce.fmt.Hooks
	 */
	define("tinymce/fmt/Hooks", [
		"tinymce/util/Arr",
		"tinymce/dom/NodeType",
		"tinymce/dom/DomQuery"
	], function(Arr, NodeType, $) {
		var postProcessHooks = [], filter = Arr.filter, each = Arr.each;
	
		function addPostProcessHook(name, hook) {
			var hooks = postProcessHooks[name];
	
			if (!hooks) {
				postProcessHooks[name] = hooks = [];
			}
	
			postProcessHooks[name].push(hook);
		}
	
		function postProcess(name, editor) {
			each(postProcessHooks[name], function(hook) {
				hook(editor);
			});
		}
	
		addPostProcessHook("pre", function(editor) {
			var rng = editor.selection.getRng(), isPre, blocks;
	
			function hasPreSibling(pre) {
				return isPre(pre.previousSibling) && Arr.indexOf(blocks, pre.previousSibling) != -1;
			}
	
			function joinPre(pre1, pre2) {
				$(pre2).remove();
				$(pre1).append('<br><br>').append(pre2.childNodes);
			}
	
			isPre = NodeType.matchNodeNames('pre');
	
			if (!rng.collapsed) {
				blocks = editor.selection.getSelectedBlocks();
	
				each(filter(filter(blocks, isPre), hasPreSibling), function(pre) {
					joinPre(pre.previousSibling, pre);
				});
			}
		});
	
		return {
			postProcess: postProcess
		};
	});
	
	// Included from: js/tinymce/classes/Formatter.js
	
	/**
	 * Formatter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Text formatter engine class. This class is used to apply formats like bold, italic, font size
	 * etc to the current selection or specific nodes. This engine was built to replace the browser's
	 * default formatting logic for execCommand due to its inconsistent and buggy behavior.
	 *
	 * @class tinymce.Formatter
	 * @example
	 *  tinymce.activeEditor.formatter.register('mycustomformat', {
	 *    inline: 'span',
	 *    styles: {color: '#ff0000'}
	 *  });
	 *
	 *  tinymce.activeEditor.formatter.apply('mycustomformat');
	 */
	define("tinymce/Formatter", [
		"tinymce/dom/TreeWalker",
		"tinymce/dom/RangeUtils",
		"tinymce/dom/BookmarkManager",
		"tinymce/dom/ElementUtils",
		"tinymce/util/Tools",
		"tinymce/fmt/Preview",
		"tinymce/fmt/Hooks"
	], function(TreeWalker, RangeUtils, BookmarkManager, ElementUtils, Tools, Preview, Hooks) {
		/**
		 * Constructs a new formatter instance.
		 *
		 * @constructor Formatter
		 * @param {tinymce.Editor} ed Editor instance to construct the formatter engine to.
		 */
		return function(ed) {
			var formats = {},
				dom = ed.dom,
				selection = ed.selection,
				rangeUtils = new RangeUtils(dom),
				isValid = ed.schema.isValidChild,
				isBlock = dom.isBlock,
				forcedRootBlock = ed.settings.forced_root_block,
				nodeIndex = dom.nodeIndex,
				INVISIBLE_CHAR = '\uFEFF',
				MCE_ATTR_RE = /^(src|href|style)$/,
				FALSE = false,
				TRUE = true,
				formatChangeData,
				undef,
				getContentEditable = dom.getContentEditable,
				disableCaretContainer,
				markCaretContainersBogus,
				isBookmarkNode = BookmarkManager.isBookmarkNode;
	
			var each = Tools.each,
				grep = Tools.grep,
				walk = Tools.walk,
				extend = Tools.extend;
	
			function isTextBlock(name) {
				if (name.nodeType) {
					name = name.nodeName;
				}
	
				return !!ed.schema.getTextBlockElements()[name.toLowerCase()];
			}
	
			function isTableCell(node) {
				return /^(TH|TD)$/.test(node.nodeName);
			}
	
			function isInlineBlock(node) {
				return node && /^(IMG)$/.test(node.nodeName);
			}
	
			function getParents(node, selector) {
				return dom.getParents(node, selector, dom.getRoot());
			}
	
			function isCaretNode(node) {
				return node.nodeType === 1 && node.id === '_mce_caret';
			}
	
			function defaultFormats() {
				register({
					valigntop: [
						{selector: 'td,th', styles: {'verticalAlign': 'top'}}
					],
	
					valignmiddle: [
						{selector: 'td,th', styles: {'verticalAlign': 'middle'}}
					],
	
					valignbottom: [
						{selector: 'td,th', styles: {'verticalAlign': 'bottom'}}
					],
	
					alignleft: [
						{selector: 'figure.image', collapsed: false, classes: 'align-left', ceFalseOverride: true},
						{
							selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
							styles: {
								textAlign: 'left'
							},
							inherit: false,
							defaultBlock: 'div'
						},
						{selector: 'img,table', collapsed: false, styles: {'float': 'left'}}
					],
	
					aligncenter: [
						{
							selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
							styles: {
								textAlign: 'center'
							},
							inherit: false,
							defaultBlock: 'div'
						},
						{selector: 'figure.image', collapsed: false, classes: 'align-center', ceFalseOverride: true},
						{selector: 'img', collapsed: false, styles: {display: 'block', marginLeft: 'auto', marginRight: 'auto'}},
						{selector: 'table', collapsed: false, styles: {marginLeft: 'auto', marginRight: 'auto'}}
					],
	
					alignright: [
						{selector: 'figure.image', collapsed: false, classes: 'align-right', ceFalseOverride: true},
						{
							selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
							styles: {
								textAlign: 'right'
							},
							inherit: false,
							defaultBlock: 'div'
						},
						{selector: 'img,table', collapsed: false, styles: {'float': 'right'}}
					],
	
					alignjustify: [
						{
							selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
							styles: {
								textAlign: 'justify'
							},
							inherit: false,
							defaultBlock: 'div'
						}
					],
	
					bold: [
						{inline: 'strong', remove: 'all'},
						{inline: 'span', styles: {fontWeight: 'bold'}},
						{inline: 'b', remove: 'all'}
					],
	
					italic: [
						{inline: 'em', remove: 'all'},
						{inline: 'span', styles: {fontStyle: 'italic'}},
						{inline: 'i', remove: 'all'}
					],
	
					underline: [
						{inline: 'span', styles: {textDecoration: 'underline'}, exact: true},
						{inline: 'u', remove: 'all'}
					],
	
					strikethrough: [
						{inline: 'span', styles: {textDecoration: 'line-through'}, exact: true},
						{inline: 'strike', remove: 'all'}
					],
	
					forecolor: {inline: 'span', styles: {color: '%value'}, links: true, remove_similar: true},
					hilitecolor: {inline: 'span', styles: {backgroundColor: '%value'}, links: true, remove_similar: true},
					fontname: {inline: 'span', styles: {fontFamily: '%value'}},
					fontsize: {inline: 'span', styles: {fontSize: '%value'}},
					fontsize_class: {inline: 'span', attributes: {'class': '%value'}},
					blockquote: {block: 'blockquote', wrapper: 1, remove: 'all'},
					subscript: {inline: 'sub'},
					superscript: {inline: 'sup'},
					code: {inline: 'code'},
	
					link: {inline: 'a', selector: 'a', remove: 'all', split: true, deep: true,
						onmatch: function() {
							return true;
						},
	
						onformat: function(elm, fmt, vars) {
							each(vars, function(value, key) {
								dom.setAttrib(elm, key, value);
							});
						}
					},
	
					removeformat: [
						{
							selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
							remove: 'all',
							split: true,
							expand: false,
							block_expand: true,
							deep: true
						},
						{selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true},
						{selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true}
					]
				});
	
				// Register default block formats
				each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function(name) {
					register(name, {block: name, remove: 'all'});
				});
	
				// Register user defined formats
				register(ed.settings.formats);
			}
	
			function addKeyboardShortcuts() {
				// Add some inline shortcuts
				ed.addShortcut('meta+b', 'bold_desc', 'Bold');
				ed.addShortcut('meta+i', 'italic_desc', 'Italic');
				ed.addShortcut('meta+u', 'underline_desc', 'Underline');
	
				// BlockFormat shortcuts keys
				for (var i = 1; i <= 6; i++) {
					ed.addShortcut('access+' + i, '', ['FormatBlock', false, 'h' + i]);
				}
	
				ed.addShortcut('access+7', '', ['FormatBlock', false, 'p']);
				ed.addShortcut('access+8', '', ['FormatBlock', false, 'div']);
				ed.addShortcut('access+9', '', ['FormatBlock', false, 'address']);
			}
	
			// Public functions
	
			/**
			 * Returns the format by name or all formats if no name is specified.
			 *
			 * @method get
			 * @param {String} name Optional name to retrieve by.
			 * @return {Array/Object} Array/Object with all registered formats or a specific format.
			 */
			function get(name) {
				return name ? formats[name] : formats;
			}
	
			/**
			 * Registers a specific format by name.
			 *
			 * @method register
			 * @param {Object/String} name Name of the format for example "bold".
			 * @param {Object/Array} format Optional format object or array of format variants
			 * can only be omitted if the first arg is an object.
			 */
			function register(name, format) {
				if (name) {
					if (typeof name !== 'string') {
						each(name, function(format, name) {
							register(name, format);
						});
					} else {
						// Force format into array and add it to internal collection
						format = format.length ? format : [format];
	
						each(format, function(format) {
							// Set deep to false by default on selector formats this to avoid removing
							// alignment on images inside paragraphs when alignment is changed on paragraphs
							if (format.deep === undef) {
								format.deep = !format.selector;
							}
	
							// Default to true
							if (format.split === undef) {
								format.split = !format.selector || format.inline;
							}
	
							// Default to true
							if (format.remove === undef && format.selector && !format.inline) {
								format.remove = 'none';
							}
	
							// Mark format as a mixed format inline + block level
							if (format.selector && format.inline) {
								format.mixed = true;
								format.block_expand = true;
							}
	
							// Split classes if needed
							if (typeof format.classes === 'string') {
								format.classes = format.classes.split(/\s+/);
							}
						});
	
						formats[name] = format;
					}
				}
			}
	
			/**
			 * Unregister a specific format by name.
			 *
			 * @method unregister
			 * @param {String} name Name of the format for example "bold".
			 */
			function unregister(name) {
				if (name && formats[name]) {
					delete formats[name];
				}
	
				return formats;
			}
	
			function matchesUnInheritedFormatSelector(node, name) {
				var formatList = get(name);
	
				if (formatList) {
					for (var i = 0; i < formatList.length; i++) {
						if (formatList[i].inherit === false && dom.is(node, formatList[i].selector)) {
							return true;
						}
					}
				}
	
				return false;
			}
	
			function getTextDecoration(node) {
				var decoration;
	
				ed.dom.getParent(node, function(n) {
					decoration = ed.dom.getStyle(n, 'text-decoration');
					return decoration && decoration !== 'none';
				});
	
				return decoration;
			}
	
			function processUnderlineAndColor(node) {
				var textDecoration;
				if (node.nodeType === 1 && node.parentNode && node.parentNode.nodeType === 1) {
					textDecoration = getTextDecoration(node.parentNode);
					if (ed.dom.getStyle(node, 'color') && textDecoration) {
						ed.dom.setStyle(node, 'text-decoration', textDecoration);
					} else if (ed.dom.getStyle(node, 'text-decoration') === textDecoration) {
						ed.dom.setStyle(node, 'text-decoration', null);
					}
				}
			}
	
			/**
			 * Applies the specified format to the current selection or specified node.
			 *
			 * @method apply
			 * @param {String} name Name of format to apply.
			 * @param {Object} vars Optional list of variables to replace within format before applying it.
			 * @param {Node} node Optional node to apply the format to defaults to current selection.
			 */
			function apply(name, vars, node) {
				var formatList = get(name), format = formatList[0], bookmark, rng, isCollapsed = !node && selection.isCollapsed();
	
				function setElementFormat(elm, fmt) {
					fmt = fmt || format;
	
					if (elm) {
						if (fmt.onformat) {
							fmt.onformat(elm, fmt, vars, node);
						}
	
						each(fmt.styles, function(value, name) {
							dom.setStyle(elm, name, replaceVars(value, vars));
						});
	
						// Needed for the WebKit span spam bug
						// TODO: Remove this once WebKit/Blink fixes this
						if (fmt.styles) {
							var styleVal = dom.getAttrib(elm, 'style');
	
							if (styleVal) {
								elm.setAttribute('data-mce-style', styleVal);
							}
						}
	
						each(fmt.attributes, function(value, name) {
							dom.setAttrib(elm, name, replaceVars(value, vars));
						});
	
						each(fmt.classes, function(value) {
							value = replaceVars(value, vars);
	
							if (!dom.hasClass(elm, value)) {
								dom.addClass(elm, value);
							}
						});
					}
				}
	
				// This converts: <p>[a</p><p>]b</p> -> <p>[a]</p><p>b</p>
				function adjustSelectionToVisibleSelection() {
					function findSelectionEnd(start, end) {
						var walker = new TreeWalker(end);
						for (node = walker.prev2(); node; node = walker.prev2()) {
							if (node.nodeType == 3 && node.data.length > 0) {
								return node;
							}
	
							if (node.childNodes.length > 1 || node == start || node.tagName == 'BR') {
								return node;
							}
						}
					}
	
					// Adjust selection so that a end container with a end offset of zero is not included in the selection
					// as this isn't visible to the user.
					var rng = ed.selection.getRng();
					var start = rng.startContainer;
					var end = rng.endContainer;
	
					if (start != end && rng.endOffset === 0) {
						var newEnd = findSelectionEnd(start, end);
						var endOffset = newEnd.nodeType == 3 ? newEnd.data.length : newEnd.childNodes.length;
	
						rng.setEnd(newEnd, endOffset);
					}
	
					return rng;
				}
	
				function applyRngStyle(rng, bookmark, node_specific) {
					var newWrappers = [], wrapName, wrapElm, contentEditable = true;
	
					// Setup wrapper element
					wrapName = format.inline || format.block;
					wrapElm = dom.create(wrapName);
					setElementFormat(wrapElm);
	
					rangeUtils.walk(rng, function(nodes) {
						var currentWrapElm;
	
						/**
						 * Process a list of nodes wrap them.
						 */
						function process(node) {
							var nodeName, parentName, found, hasContentEditableState, lastContentEditable;
	
							lastContentEditable = contentEditable;
							nodeName = node.nodeName.toLowerCase();
							parentName = node.parentNode.nodeName.toLowerCase();
	
							// Node has a contentEditable value
							if (node.nodeType === 1 && getContentEditable(node)) {
								lastContentEditable = contentEditable;
								contentEditable = getContentEditable(node) === "true";
								hasContentEditableState = true; // We don't want to wrap the container only it's children
							}
	
							// Stop wrapping on br elements
							if (isEq(nodeName, 'br')) {
								currentWrapElm = 0;
	
								// Remove any br elements when we wrap things
								if (format.block) {
									dom.remove(node);
								}
	
								return;
							}
	
							// If node is wrapper type
							if (format.wrapper && matchNode(node, name, vars)) {
								currentWrapElm = 0;
								return;
							}
	
							// Can we rename the block
							// TODO: Break this if up, too complex
							if (contentEditable && !hasContentEditableState && format.block &&
								!format.wrapper && isTextBlock(nodeName) && isValid(parentName, wrapName)) {
								node = dom.rename(node, wrapName);
								setElementFormat(node);
								newWrappers.push(node);
								currentWrapElm = 0;
								return;
							}
	
							// Handle selector patterns
							if (format.selector) {
								// Look for matching formats
								each(formatList, function(format) {
									// Check collapsed state if it exists
									if ('collapsed' in format && format.collapsed !== isCollapsed) {
										return;
									}
	
									if (dom.is(node, format.selector) && !isCaretNode(node)) {
										setElementFormat(node, format);
										found = true;
										return false;
									}
								});
	
								// Continue processing if a selector match wasn't found and a inline element is defined
								if (!format.inline || found) {
									currentWrapElm = 0;
									return;
								}
							}
	
							// Is it valid to wrap this item
							// TODO: Break this if up, too complex
							if (contentEditable && !hasContentEditableState && isValid(wrapName, nodeName) && isValid(parentName, wrapName) &&
									!(!node_specific && node.nodeType === 3 &&
									node.nodeValue.length === 1 &&
									node.nodeValue.charCodeAt(0) === 65279) &&
									!isCaretNode(node) &&
									(!format.inline || !isBlock(node))) {
								// Start wrapping
								if (!currentWrapElm) {
									// Wrap the node
									currentWrapElm = dom.clone(wrapElm, FALSE);
									node.parentNode.insertBefore(currentWrapElm, node);
									newWrappers.push(currentWrapElm);
								}
	
								currentWrapElm.appendChild(node);
							} else {
								// Start a new wrapper for possible children
								currentWrapElm = 0;
	
								each(grep(node.childNodes), process);
	
								if (hasContentEditableState) {
									contentEditable = lastContentEditable; // Restore last contentEditable state from stack
								}
	
								// End the last wrapper
								currentWrapElm = 0;
							}
						}
	
						// Process siblings from range
						each(nodes, process);
					});
	
					// Apply formats to links as well to get the color of the underline to change as well
					if (format.links === true) {
						each(newWrappers, function(node) {
							function process(node) {
								if (node.nodeName === 'A') {
									setElementFormat(node, format);
								}
	
								each(grep(node.childNodes), process);
							}
	
							process(node);
						});
					}
	
					// Cleanup
					each(newWrappers, function(node) {
						var childCount;
	
						function getChildCount(node) {
							var count = 0;
	
							each(node.childNodes, function(node) {
								if (!isWhiteSpaceNode(node) && !isBookmarkNode(node)) {
									count++;
								}
							});
	
							return count;
						}
	
						function mergeStyles(node) {
							var child, clone;
	
							each(node.childNodes, function(node) {
								if (node.nodeType == 1 && !isBookmarkNode(node) && !isCaretNode(node)) {
									child = node;
									return FALSE; // break loop
								}
							});
	
							// If child was found and of the same type as the current node
							if (child && !isBookmarkNode(child) && matchName(child, format)) {
								clone = dom.clone(child, FALSE);
								setElementFormat(clone);
	
								dom.replace(clone, node, TRUE);
								dom.remove(child, 1);
							}
	
							return clone || node;
						}
	
						childCount = getChildCount(node);
	
						// Remove empty nodes but only if there is multiple wrappers and they are not block
						// elements so never remove single <h1></h1> since that would remove the
						// current empty block element where the caret is at
						if ((newWrappers.length > 1 || !isBlock(node)) && childCount === 0) {
							dom.remove(node, 1);
							return;
						}
	
						if (format.inline || format.wrapper) {
							// Merges the current node with it's children of similar type to reduce the number of elements
							if (!format.exact && childCount === 1) {
								node = mergeStyles(node);
							}
	
							// Remove/merge children
							each(formatList, function(format) {
								// Merge all children of similar type will move styles from child to parent
								// this: <span style="color:red"><b><span style="color:red; font-size:10px">text</span></b></span>
								// will become: <span style="color:red"><b><span style="font-size:10px">text</span></b></span>
								each(dom.select(format.inline, node), function(child) {
									if (isBookmarkNode(child)) {
										return;
									}
	
									removeFormat(format, vars, child, format.exact ? child : null);
								});
							});
	
							// Remove child if direct parent is of same type
							if (matchNode(node.parentNode, name, vars)) {
								dom.remove(node, 1);
								node = 0;
								return TRUE;
							}
	
							// Look for parent with similar style format
							if (format.merge_with_parents) {
								dom.getParent(node.parentNode, function(parent) {
									if (matchNode(parent, name, vars)) {
										dom.remove(node, 1);
										node = 0;
										return TRUE;
									}
								});
							}
	
							// Merge next and previous siblings if they are similar <b>text</b><b>text</b> becomes <b>texttext</b>
							if (node && format.merge_siblings !== false) {
								node = mergeSiblings(getNonWhiteSpaceSibling(node), node);
								node = mergeSiblings(node, getNonWhiteSpaceSibling(node, TRUE));
							}
						}
					});
				}
	
				if (getContentEditable(selection.getNode()) === "false") {
					node = selection.getNode();
					for (var i = 0, l = formatList.length; i < l; i++) {
						if (formatList[i].ceFalseOverride && dom.is(node, formatList[i].selector)) {
							setElementFormat(node, formatList[i]);
							return;
						}
					}
	
					return;
				}
	
				if (format) {
					if (node) {
						if (node.nodeType) {
							rng = dom.createRng();
							rng.setStartBefore(node);
							rng.setEndAfter(node);
							applyRngStyle(expandRng(rng, formatList), null, true);
						} else {
							applyRngStyle(node, null, true);
						}
					} else {
						if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
							// Obtain selection node before selection is unselected by applyRngStyle()
							var curSelNode = ed.selection.getNode();
	
							// If the formats have a default block and we can't find a parent block then
							// start wrapping it with a DIV this is for forced_root_blocks: false
							// It's kind of a hack but people should be using the default block type P since all desktop editors work that way
							if (!forcedRootBlock && formatList[0].defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
								apply(formatList[0].defaultBlock);
							}
	
							// Apply formatting to selection
							ed.selection.setRng(adjustSelectionToVisibleSelection());
							bookmark = selection.getBookmark();
							applyRngStyle(expandRng(selection.getRng(TRUE), formatList), bookmark);
	
							// Colored nodes should be underlined so that the color of the underline matches the text color.
							if (format.styles && (format.styles.color || format.styles.textDecoration)) {
								walk(curSelNode, processUnderlineAndColor, 'childNodes');
								processUnderlineAndColor(curSelNode);
							}
	
							selection.moveToBookmark(bookmark);
							moveStart(selection.getRng(TRUE));
							ed.nodeChanged();
						} else {
							performCaretAction('apply', name, vars);
						}
					}
	
					Hooks.postProcess(name, ed);
				}
			}
	
			/**
			 * Removes the specified format from the current selection or specified node.
			 *
			 * @method remove
			 * @param {String} name Name of format to remove.
			 * @param {Object} vars Optional list of variables to replace within format before removing it.
			 * @param {Node/Range} node Optional node or DOM range to remove the format from defaults to current selection.
			 */
			function remove(name, vars, node, similar) {
				var formatList = get(name), format = formatList[0], bookmark, rng, contentEditable = true;
	
				// Merges the styles for each node
				function process(node) {
					var children, i, l, lastContentEditable, hasContentEditableState;
	
					// Node has a contentEditable value
					if (node.nodeType === 1 && getContentEditable(node)) {
						lastContentEditable = contentEditable;
						contentEditable = getContentEditable(node) === "true";
						hasContentEditableState = true; // We don't want to wrap the container only it's children
					}
	
					// Grab the children first since the nodelist might be changed
					children = grep(node.childNodes);
	
					// Process current node
					if (contentEditable && !hasContentEditableState) {
						for (i = 0, l = formatList.length; i < l; i++) {
							if (removeFormat(formatList[i], vars, node, node)) {
								break;
							}
						}
					}
	
					// Process the children
					if (format.deep) {
						if (children.length) {
							for (i = 0, l = children.length; i < l; i++) {
								process(children[i]);
							}
	
							if (hasContentEditableState) {
								contentEditable = lastContentEditable; // Restore last contentEditable state from stack
							}
						}
					}
				}
	
				function findFormatRoot(container) {
					var formatRoot;
	
					// Find format root
					each(getParents(container.parentNode).reverse(), function(parent) {
						var format;
	
						// Find format root element
						if (!formatRoot && parent.id != '_start' && parent.id != '_end') {
							// Is the node matching the format we are looking for
							format = matchNode(parent, name, vars, similar);
							if (format && format.split !== false) {
								formatRoot = parent;
							}
						}
					});
	
					return formatRoot;
				}
	
				function wrapAndSplit(formatRoot, container, target, split) {
					var parent, clone, lastClone, firstClone, i, formatRootParent;
	
					// Format root found then clone formats and split it
					if (formatRoot) {
						formatRootParent = formatRoot.parentNode;
	
						for (parent = container.parentNode; parent && parent != formatRootParent; parent = parent.parentNode) {
							clone = dom.clone(parent, FALSE);
	
							for (i = 0; i < formatList.length; i++) {
								if (removeFormat(formatList[i], vars, clone, clone)) {
									clone = 0;
									break;
								}
							}
	
							// Build wrapper node
							if (clone) {
								if (lastClone) {
									clone.appendChild(lastClone);
								}
	
								if (!firstClone) {
									firstClone = clone;
								}
	
								lastClone = clone;
							}
						}
	
						// Never split block elements if the format is mixed
						if (split && (!format.mixed || !isBlock(formatRoot))) {
							container = dom.split(formatRoot, container);
						}
	
						// Wrap container in cloned formats
						if (lastClone) {
							target.parentNode.insertBefore(lastClone, target);
							firstClone.appendChild(target);
						}
					}
	
					return container;
				}
	
				function splitToFormatRoot(container) {
					return wrapAndSplit(findFormatRoot(container), container, container, true);
				}
	
				function unwrap(start) {
					var node = dom.get(start ? '_start' : '_end'),
						out = node[start ? 'firstChild' : 'lastChild'];
	
					// If the end is placed within the start the result will be removed
					// So this checks if the out node is a bookmark node if it is it
					// checks for another more suitable node
					if (isBookmarkNode(out)) {
						out = out[start ? 'firstChild' : 'lastChild'];
					}
	
					// Since dom.remove removes empty text nodes then we need to try to find a better node
					if (out.nodeType == 3 && out.data.length === 0) {
						out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
					}
	
					dom.remove(node, true);
	
					return out;
				}
	
				function removeRngStyle(rng) {
					var startContainer, endContainer;
					var commonAncestorContainer = rng.commonAncestorContainer;
	
					rng = expandRng(rng, formatList, TRUE);
	
					if (format.split) {
						startContainer = getContainer(rng, TRUE);
						endContainer = getContainer(rng);
	
						if (startContainer != endContainer) {
							// WebKit will render the table incorrectly if we wrap a TH or TD in a SPAN
							// so let's see if we can use the first child instead
							// This will happen if you triple click a table cell and use remove formatting
							if (/^(TR|TH|TD)$/.test(startContainer.nodeName) && startContainer.firstChild) {
								if (startContainer.nodeName == "TR") {
									startContainer = startContainer.firstChild.firstChild || startContainer;
								} else {
									startContainer = startContainer.firstChild || startContainer;
								}
							}
	
							// Try to adjust endContainer as well if cells on the same row were selected - bug #6410
							if (commonAncestorContainer &&
								/^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName) &&
								isTableCell(endContainer) && endContainer.firstChild) {
								endContainer = endContainer.firstChild || endContainer;
							}
	
							if (dom.isChildOf(startContainer, endContainer) && !isBlock(endContainer) &&
								!isTableCell(startContainer) && !isTableCell(endContainer)) {
								startContainer = wrap(startContainer, 'span', {id: '_start', 'data-mce-type': 'bookmark'});
								splitToFormatRoot(startContainer);
								startContainer = unwrap(TRUE);
								return;
							}
	
							// Wrap start/end nodes in span element since these might be cloned/moved
							startContainer = wrap(startContainer, 'span', {id: '_start', 'data-mce-type': 'bookmark'});
							endContainer = wrap(endContainer, 'span', {id: '_end', 'data-mce-type': 'bookmark'});
	
							// Split start/end
							splitToFormatRoot(startContainer);
							splitToFormatRoot(endContainer);
	
							// Unwrap start/end to get real elements again
							startContainer = unwrap(TRUE);
							endContainer = unwrap();
						} else {
							startContainer = endContainer = splitToFormatRoot(startContainer);
						}
	
						// Update range positions since they might have changed after the split operations
						rng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
						rng.startOffset = nodeIndex(startContainer);
						rng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
						rng.endOffset = nodeIndex(endContainer) + 1;
					}
	
					// Remove items between start/end
					rangeUtils.walk(rng, function(nodes) {
						each(nodes, function(node) {
							process(node);
	
							// Remove parent span if it only contains text-decoration: underline, yet a parent node is also underlined.
							if (node.nodeType === 1 && ed.dom.getStyle(node, 'text-decoration') === 'underline' &&
								node.parentNode && getTextDecoration(node.parentNode) === 'underline') {
								removeFormat({
									'deep': false,
									'exact': true,
									'inline': 'span',
									'styles': {
										'textDecoration': 'underline'
									}
								}, null, node);
							}
						});
					});
				}
	
				// Handle node
				if (node) {
					if (node.nodeType) {
						rng = dom.createRng();
						rng.setStartBefore(node);
						rng.setEndAfter(node);
						removeRngStyle(rng);
					} else {
						removeRngStyle(node);
					}
	
					return;
				}
	
				if (getContentEditable(selection.getNode()) === "false") {
					node = selection.getNode();
					for (var i = 0, l = formatList.length; i < l; i++) {
						if (formatList[i].ceFalseOverride) {
							if (removeFormat(formatList[i], vars, node, node)) {
								break;
							}
						}
					}
	
					return;
				}
	
				if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
					bookmark = selection.getBookmark();
					removeRngStyle(selection.getRng(TRUE));
					selection.moveToBookmark(bookmark);
	
					// Check if start element still has formatting then we are at: "<b>text|</b>text"
					// and need to move the start into the next text node
					if (format.inline && match(name, vars, selection.getStart())) {
						moveStart(selection.getRng(true));
					}
	
					ed.nodeChanged();
				} else {
					performCaretAction('remove', name, vars, similar);
				}
			}
	
			/**
			 * Toggles the specified format on/off.
			 *
			 * @method toggle
			 * @param {String} name Name of format to apply/remove.
			 * @param {Object} vars Optional list of variables to replace within format before applying/removing it.
			 * @param {Node} node Optional node to apply the format to or remove from. Defaults to current selection.
			 */
			function toggle(name, vars, node) {
				var fmt = get(name);
	
				if (match(name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
					remove(name, vars, node);
				} else {
					apply(name, vars, node);
				}
			}
	
			/**
			 * Return true/false if the specified node has the specified format.
			 *
			 * @method matchNode
			 * @param {Node} node Node to check the format on.
			 * @param {String} name Format name to check.
			 * @param {Object} vars Optional list of variables to replace before checking it.
			 * @param {Boolean} similar Match format that has similar properties.
			 * @return {Object} Returns the format object it matches or undefined if it doesn't match.
			 */
			function matchNode(node, name, vars, similar) {
				var formatList = get(name), format, i, classes;
	
				function matchItems(node, format, item_name) {
					var key, value, items = format[item_name], i;
	
					// Custom match
					if (format.onmatch) {
						return format.onmatch(node, format, item_name);
					}
	
					// Check all items
					if (items) {
						// Non indexed object
						if (items.length === undef) {
							for (key in items) {
								if (items.hasOwnProperty(key)) {
									if (item_name === 'attributes') {
										value = dom.getAttrib(node, key);
									} else {
										value = getStyle(node, key);
									}
	
									if (similar && !value && !format.exact) {
										return;
									}
	
									if ((!similar || format.exact) && !isEq(value, normalizeStyleValue(replaceVars(items[key], vars), key))) {
										return;
									}
								}
							}
						} else {
							// Only one match needed for indexed arrays
							for (i = 0; i < items.length; i++) {
								if (item_name === 'attributes' ? dom.getAttrib(node, items[i]) : getStyle(node, items[i])) {
									return format;
								}
							}
						}
					}
	
					return format;
				}
	
				if (formatList && node) {
					// Check each format in list
					for (i = 0; i < formatList.length; i++) {
						format = formatList[i];
	
						// Name name, attributes, styles and classes
						if (matchName(node, format) && matchItems(node, format, 'attributes') && matchItems(node, format, 'styles')) {
							// Match classes
							if ((classes = format.classes)) {
								for (i = 0; i < classes.length; i++) {
									if (!dom.hasClass(node, classes[i])) {
										return;
									}
								}
							}
	
							return format;
						}
					}
				}
			}
	
			/**
			 * Matches the current selection or specified node against the specified format name.
			 *
			 * @method match
			 * @param {String} name Name of format to match.
			 * @param {Object} vars Optional list of variables to replace before checking it.
			 * @param {Node} node Optional node to check.
			 * @return {boolean} true/false if the specified selection/node matches the format.
			 */
			function match(name, vars, node) {
				var startNode;
	
				function matchParents(node) {
					var root = dom.getRoot();
	
					if (node === root) {
						return false;
					}
	
					// Find first node with similar format settings
					node = dom.getParent(node, function(node) {
						if (matchesUnInheritedFormatSelector(node, name)) {
							return true;
						}
	
						return node.parentNode === root || !!matchNode(node, name, vars, true);
					});
	
					// Do an exact check on the similar format element
					return matchNode(node, name, vars);
				}
	
				// Check specified node
				if (node) {
					return matchParents(node);
				}
	
				// Check selected node
				node = selection.getNode();
				if (matchParents(node)) {
					return TRUE;
				}
	
				// Check start node if it's different
				startNode = selection.getStart();
				if (startNode != node) {
					if (matchParents(startNode)) {
						return TRUE;
					}
				}
	
				return FALSE;
			}
	
			/**
			 * Matches the current selection against the array of formats and returns a new array with matching formats.
			 *
			 * @method matchAll
			 * @param {Array} names Name of format to match.
			 * @param {Object} vars Optional list of variables to replace before checking it.
			 * @return {Array} Array with matched formats.
			 */
			function matchAll(names, vars) {
				var startElement, matchedFormatNames = [], checkedMap = {};
	
				// Check start of selection for formats
				startElement = selection.getStart();
				dom.getParent(startElement, function(node) {
					var i, name;
	
					for (i = 0; i < names.length; i++) {
						name = names[i];
	
						if (!checkedMap[name] && matchNode(node, name, vars)) {
							checkedMap[name] = true;
							matchedFormatNames.push(name);
						}
					}
				}, dom.getRoot());
	
				return matchedFormatNames;
			}
	
			/**
			 * Returns true/false if the specified format can be applied to the current selection or not. It
			 * will currently only check the state for selector formats, it returns true on all other format types.
			 *
			 * @method canApply
			 * @param {String} name Name of format to check.
			 * @return {boolean} true/false if the specified format can be applied to the current selection/node.
			 */
			function canApply(name) {
				var formatList = get(name), startNode, parents, i, x, selector;
	
				if (formatList) {
					startNode = selection.getStart();
					parents = getParents(startNode);
	
					for (x = formatList.length - 1; x >= 0; x--) {
						selector = formatList[x].selector;
	
						// Format is not selector based then always return TRUE
						// Is it has a defaultBlock then it's likely it can be applied for example align on a non block element line
						if (!selector || formatList[x].defaultBlock) {
							return TRUE;
						}
	
						for (i = parents.length - 1; i >= 0; i--) {
							if (dom.is(parents[i], selector)) {
								return TRUE;
							}
						}
					}
				}
	
				return FALSE;
			}
	
			/**
			 * Executes the specified callback when the current selection matches the formats or not.
			 *
			 * @method formatChanged
			 * @param {String} formats Comma separated list of formats to check for.
			 * @param {function} callback Callback with state and args when the format is changed/toggled on/off.
			 * @param {Boolean} similar True/false state if the match should handle similar or exact formats.
			 */
			function formatChanged(formats, callback, similar) {
				var currentFormats;
	
				// Setup format node change logic
				if (!formatChangeData) {
					formatChangeData = {};
					currentFormats = {};
	
					ed.on('NodeChange', function(e) {
						var parents = getParents(e.element), matchedFormats = {};
	
						// Ignore bogus nodes like the <a> tag created by moveStart()
						parents = Tools.grep(parents, function(node) {
							return node.nodeType == 1 && !node.getAttribute('data-mce-bogus');
						});
	
						// Check for new formats
						each(formatChangeData, function(callbacks, format) {
							each(parents, function(node) {
								if (matchNode(node, format, {}, callbacks.similar)) {
									if (!currentFormats[format]) {
										// Execute callbacks
										each(callbacks, function(callback) {
											callback(true, {node: node, format: format, parents: parents});
										});
	
										currentFormats[format] = callbacks;
									}
	
									matchedFormats[format] = callbacks;
									return false;
								}
	
								if (matchesUnInheritedFormatSelector(node, format)) {
									return false;
								}
							});
						});
	
						// Check if current formats still match
						each(currentFormats, function(callbacks, format) {
							if (!matchedFormats[format]) {
								delete currentFormats[format];
	
								each(callbacks, function(callback) {
									callback(false, {node: e.element, format: format, parents: parents});
								});
							}
						});
					});
				}
	
				// Add format listeners
				each(formats.split(','), function(format) {
					if (!formatChangeData[format]) {
						formatChangeData[format] = [];
						formatChangeData[format].similar = similar;
					}
	
					formatChangeData[format].push(callback);
				});
	
				return this;
			}
	
			/**
			 * Returns a preview css text for the specified format.
			 *
			 * @method getCssText
			 * @param {String/Object} format Format to generate preview css text for.
			 * @return {String} Css text for the specified format.
			 * @example
			 * var cssText1 = editor.formatter.getCssText('bold');
			 * var cssText2 = editor.formatter.getCssText({inline: 'b'});
			 */
			function getCssText(format) {
				return Preview.getCssText(ed, format);
			}
	
			// Expose to public
			extend(this, {
				get: get,
				register: register,
				unregister: unregister,
				apply: apply,
				remove: remove,
				toggle: toggle,
				match: match,
				matchAll: matchAll,
				matchNode: matchNode,
				canApply: canApply,
				formatChanged: formatChanged,
				getCssText: getCssText
			});
	
			// Initialize
			defaultFormats();
			addKeyboardShortcuts();
			ed.on('BeforeGetContent', function(e) {
				if (markCaretContainersBogus && e.format != 'raw') {
					markCaretContainersBogus();
				}
			});
			ed.on('mouseup keydown', function(e) {
				if (disableCaretContainer) {
					disableCaretContainer(e);
				}
			});
	
			// Private functions
	
			/**
			 * Checks if the specified nodes name matches the format inline/block or selector.
			 *
			 * @private
			 * @param {Node} node Node to match against the specified format.
			 * @param {Object} format Format object o match with.
			 * @return {boolean} true/false if the format matches.
			 */
			function matchName(node, format) {
				// Check for inline match
				if (isEq(node, format.inline)) {
					return TRUE;
				}
	
				// Check for block match
				if (isEq(node, format.block)) {
					return TRUE;
				}
	
				// Check for selector match
				if (format.selector) {
					return node.nodeType == 1 && dom.is(node, format.selector);
				}
			}
	
			/**
			 * Compares two string/nodes regardless of their case.
			 *
			 * @private
			 * @param {String/Node} str1 Node or string to compare.
			 * @param {String/Node} str2 Node or string to compare.
			 * @return {boolean} True/false if they match.
			 */
			function isEq(str1, str2) {
				str1 = str1 || '';
				str2 = str2 || '';
	
				str1 = '' + (str1.nodeName || str1);
				str2 = '' + (str2.nodeName || str2);
	
				return str1.toLowerCase() == str2.toLowerCase();
			}
	
			/**
			 * Returns the style by name on the specified node. This method modifies the style
			 * contents to make it more easy to match. This will resolve a few browser issues.
			 *
			 * @private
			 * @param {Node} node to get style from.
			 * @param {String} name Style name to get.
			 * @return {String} Style item value.
			 */
			function getStyle(node, name) {
				return normalizeStyleValue(dom.getStyle(node, name), name);
			}
	
			/**
			 * Normalize style value by name. This method modifies the style contents
			 * to make it more easy to match. This will resolve a few browser issues.
			 *
			 * @private
			 * @param {String} value Value to get style from.
			 * @param {String} name Style name to get.
			 * @return {String} Style item value.
			 */
			function normalizeStyleValue(value, name) {
				// Force the format to hex
				if (name == 'color' || name == 'backgroundColor') {
					value = dom.toHex(value);
				}
	
				// Opera will return bold as 700
				if (name == 'fontWeight' && value == 700) {
					value = 'bold';
				}
	
				// Normalize fontFamily so "'Font name', Font" becomes: "Font name,Font"
				if (name == 'fontFamily') {
					value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
				}
	
				return '' + value;
			}
	
			/**
			 * Replaces variables in the value. The variable format is %var.
			 *
			 * @private
			 * @param {String} value Value to replace variables in.
			 * @param {Object} vars Name/value array with variables to replace.
			 * @return {String} New value with replaced variables.
			 */
			function replaceVars(value, vars) {
				if (typeof value != "string") {
					value = value(vars);
				} else if (vars) {
					value = value.replace(/%(\w+)/g, function(str, name) {
						return vars[name] || str;
					});
				}
	
				return value;
			}
	
			function isWhiteSpaceNode(node) {
				return node && node.nodeType === 3 && /^([\t \r\n]+|)$/.test(node.nodeValue);
			}
	
			function wrap(node, name, attrs) {
				var wrapper = dom.create(name, attrs);
	
				node.parentNode.insertBefore(wrapper, node);
				wrapper.appendChild(node);
	
				return wrapper;
			}
	
			/**
			 * Expands the specified range like object to depending on format.
			 *
			 * For example on block formats it will move the start/end position
			 * to the beginning of the current block.
			 *
			 * @private
			 * @param {Object} rng Range like object.
			 * @param {Array} format Array with formats to expand by.
			 * @param {Boolean} remove
			 * @return {Object} Expanded range like object.
			 */
			function expandRng(rng, format, remove) {
				var lastIdx, leaf, endPoint,
					startContainer = rng.startContainer,
					startOffset = rng.startOffset,
					endContainer = rng.endContainer,
					endOffset = rng.endOffset;
	
				// This function walks up the tree if there is no siblings before/after the node
				function findParentContainer(start) {
					var container, parent, sibling, siblingName, root;
	
					container = parent = start ? startContainer : endContainer;
					siblingName = start ? 'previousSibling' : 'nextSibling';
					root = dom.getRoot();
	
					function isBogusBr(node) {
						return node.nodeName == "BR" && node.getAttribute('data-mce-bogus') && !node.nextSibling;
					}
	
					// If it's a text node and the offset is inside the text
					if (container.nodeType == 3 && !isWhiteSpaceNode(container)) {
						if (start ? startOffset > 0 : endOffset < container.nodeValue.length) {
							return container;
						}
					}
	
					/*eslint no-constant-condition:0 */
					while (true) {
						// Stop expanding on block elements
						if (!format[0].block_expand && isBlock(parent)) {
							return parent;
						}
	
						// Walk left/right
						for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
							if (!isBookmarkNode(sibling) && !isWhiteSpaceNode(sibling) && !isBogusBr(sibling)) {
								return parent;
							}
						}
	
						// Check if we can move up are we at root level or body level
						if (parent == root || parent.parentNode == root) {
							container = parent;
							break;
						}
	
						parent = parent.parentNode;
					}
	
					return container;
				}
	
				// This function walks down the tree to find the leaf at the selection.
				// The offset is also returned as if node initially a leaf, the offset may be in the middle of the text node.
				function findLeaf(node, offset) {
					if (offset === undef) {
						offset = node.nodeType === 3 ? node.length : node.childNodes.length;
					}
	
					while (node && node.hasChildNodes()) {
						node = node.childNodes[offset];
						if (node) {
							offset = node.nodeType === 3 ? node.length : node.childNodes.length;
						}
					}
					return {node: node, offset: offset};
				}
	
				// If index based start position then resolve it
				if (startContainer.nodeType == 1 && startContainer.hasChildNodes()) {
					lastIdx = startContainer.childNodes.length - 1;
					startContainer = startContainer.childNodes[startOffset > lastIdx ? lastIdx : startOffset];
	
					if (startContainer.nodeType == 3) {
						startOffset = 0;
					}
				}
	
				// If index based end position then resolve it
				if (endContainer.nodeType == 1 && endContainer.hasChildNodes()) {
					lastIdx = endContainer.childNodes.length - 1;
					endContainer = endContainer.childNodes[endOffset > lastIdx ? lastIdx : endOffset - 1];
	
					if (endContainer.nodeType == 3) {
						endOffset = endContainer.nodeValue.length;
					}
				}
	
				// Expands the node to the closes contentEditable false element if it exists
				function findParentContentEditable(node) {
					var parent = node;
	
					while (parent) {
						if (parent.nodeType === 1 && getContentEditable(parent)) {
							return getContentEditable(parent) === "false" ? parent : node;
						}
	
						parent = parent.parentNode;
					}
	
					return node;
				}
	
				function findWordEndPoint(container, offset, start) {
					var walker, node, pos, lastTextNode;
	
					function findSpace(node, offset) {
						var pos, pos2, str = node.nodeValue;
	
						if (typeof offset == "undefined") {
							offset = start ? str.length : 0;
						}
	
						if (start) {
							pos = str.lastIndexOf(' ', offset);
							pos2 = str.lastIndexOf('\u00a0', offset);
							pos = pos > pos2 ? pos : pos2;
	
							// Include the space on remove to avoid tag soup
							if (pos !== -1 && !remove) {
								pos++;
							}
						} else {
							pos = str.indexOf(' ', offset);
							pos2 = str.indexOf('\u00a0', offset);
							pos = pos !== -1 && (pos2 === -1 || pos < pos2) ? pos : pos2;
						}
	
						return pos;
					}
	
					if (container.nodeType === 3) {
						pos = findSpace(container, offset);
	
						if (pos !== -1) {
							return {container: container, offset: pos};
						}
	
						lastTextNode = container;
					}
	
					// Walk the nodes inside the block
					walker = new TreeWalker(container, dom.getParent(container, isBlock) || ed.getBody());
					while ((node = walker[start ? 'prev' : 'next']())) {
						if (node.nodeType === 3) {
							lastTextNode = node;
							pos = findSpace(node);
	
							if (pos !== -1) {
								return {container: node, offset: pos};
							}
						} else if (isBlock(node)) {
							break;
						}
					}
	
					if (lastTextNode) {
						if (start) {
							offset = 0;
						} else {
							offset = lastTextNode.length;
						}
	
						return {container: lastTextNode, offset: offset};
					}
				}
	
				function findSelectorEndPoint(container, sibling_name) {
					var parents, i, y, curFormat;
	
					if (container.nodeType == 3 && container.nodeValue.length === 0 && container[sibling_name]) {
						container = container[sibling_name];
					}
	
					parents = getParents(container);
					for (i = 0; i < parents.length; i++) {
						for (y = 0; y < format.length; y++) {
							curFormat = format[y];
	
							// If collapsed state is set then skip formats that doesn't match that
							if ("collapsed" in curFormat && curFormat.collapsed !== rng.collapsed) {
								continue;
							}
	
							if (dom.is(parents[i], curFormat.selector)) {
								return parents[i];
							}
						}
					}
	
					return container;
				}
	
				function findBlockEndPoint(container, sibling_name) {
					var node, root = dom.getRoot();
	
					// Expand to block of similar type
					if (!format[0].wrapper) {
						node = dom.getParent(container, format[0].block, root);
					}
	
					// Expand to first wrappable block element or any block element
					if (!node) {
						node = dom.getParent(container.nodeType == 3 ? container.parentNode : container, function(node) {
							// Fixes #6183 where it would expand to editable parent element in inline mode
							return node != root && isTextBlock(node);
						});
					}
	
					// Exclude inner lists from wrapping
					if (node && format[0].wrapper) {
						node = getParents(node, 'ul,ol').reverse()[0] || node;
					}
	
					// Didn't find a block element look for first/last wrappable element
					if (!node) {
						node = container;
	
						while (node[sibling_name] && !isBlock(node[sibling_name])) {
							node = node[sibling_name];
	
							// Break on BR but include it will be removed later on
							// we can't remove it now since we need to check if it can be wrapped
							if (isEq(node, 'br')) {
								break;
							}
						}
					}
	
					return node || container;
				}
	
				// Expand to closest contentEditable element
				startContainer = findParentContentEditable(startContainer);
				endContainer = findParentContentEditable(endContainer);
	
				// Exclude bookmark nodes if possible
				if (isBookmarkNode(startContainer.parentNode) || isBookmarkNode(startContainer)) {
					startContainer = isBookmarkNode(startContainer) ? startContainer : startContainer.parentNode;
					startContainer = startContainer.nextSibling || startContainer;
	
					if (startContainer.nodeType == 3) {
						startOffset = 0;
					}
				}
	
				if (isBookmarkNode(endContainer.parentNode) || isBookmarkNode(endContainer)) {
					endContainer = isBookmarkNode(endContainer) ? endContainer : endContainer.parentNode;
					endContainer = endContainer.previousSibling || endContainer;
	
					if (endContainer.nodeType == 3) {
						endOffset = endContainer.length;
					}
				}
	
				if (format[0].inline) {
					if (rng.collapsed) {
						// Expand left to closest word boundary
						endPoint = findWordEndPoint(startContainer, startOffset, true);
						if (endPoint) {
							startContainer = endPoint.container;
							startOffset = endPoint.offset;
						}
	
						// Expand right to closest word boundary
						endPoint = findWordEndPoint(endContainer, endOffset);
						if (endPoint) {
							endContainer = endPoint.container;
							endOffset = endPoint.offset;
						}
					}
	
					// Avoid applying formatting to a trailing space.
					leaf = findLeaf(endContainer, endOffset);
					if (leaf.node) {
						while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
							leaf = findLeaf(leaf.node.previousSibling);
						}
	
						if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 &&
								leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
	
							if (leaf.offset > 1) {
								endContainer = leaf.node;
								endContainer.splitText(leaf.offset - 1);
							}
						}
					}
				}
	
				// Move start/end point up the tree if the leaves are sharp and if we are in different containers
				// Example * becomes !: !<p><b><i>*text</i><i>text*</i></b></p>!
				// This will reduce the number of wrapper elements that needs to be created
				// Move start point up the tree
				if (format[0].inline || format[0].block_expand) {
					if (!format[0].inline || (startContainer.nodeType != 3 || startOffset === 0)) {
						startContainer = findParentContainer(true);
					}
	
					if (!format[0].inline || (endContainer.nodeType != 3 || endOffset === endContainer.nodeValue.length)) {
						endContainer = findParentContainer();
					}
				}
	
				// Expand start/end container to matching selector
				if (format[0].selector && format[0].expand !== FALSE && !format[0].inline) {
					// Find new startContainer/endContainer if there is better one
					startContainer = findSelectorEndPoint(startContainer, 'previousSibling');
					endContainer = findSelectorEndPoint(endContainer, 'nextSibling');
				}
	
				// Expand start/end container to matching block element or text node
				if (format[0].block || format[0].selector) {
					// Find new startContainer/endContainer if there is better one
					startContainer = findBlockEndPoint(startContainer, 'previousSibling');
					endContainer = findBlockEndPoint(endContainer, 'nextSibling');
	
					// Non block element then try to expand up the leaf
					if (format[0].block) {
						if (!isBlock(startContainer)) {
							startContainer = findParentContainer(true);
						}
	
						if (!isBlock(endContainer)) {
							endContainer = findParentContainer();
						}
					}
				}
	
				// Setup index for startContainer
				if (startContainer.nodeType == 1) {
					startOffset = nodeIndex(startContainer);
					startContainer = startContainer.parentNode;
				}
	
				// Setup index for endContainer
				if (endContainer.nodeType == 1) {
					endOffset = nodeIndex(endContainer) + 1;
					endContainer = endContainer.parentNode;
				}
	
				// Return new range like object
				return {
					startContainer: startContainer,
					startOffset: startOffset,
					endContainer: endContainer,
					endOffset: endOffset
				};
			}
	
			function isColorFormatAndAnchor(node, format) {
				return format.links && node.tagName == 'A';
			}
	
			/**
			 * Removes the specified format for the specified node. It will also remove the node if it doesn't have
			 * any attributes if the format specifies it to do so.
			 *
			 * @private
			 * @param {Object} format Format object with items to remove from node.
			 * @param {Object} vars Name/value object with variables to apply to format.
			 * @param {Node} node Node to remove the format styles on.
			 * @param {Node} compare_node Optional compare node, if specified the styles will be compared to that node.
			 * @return {Boolean} True/false if the node was removed or not.
			 */
			function removeFormat(format, vars, node, compare_node) {
				var i, attrs, stylesModified;
	
				// Check if node matches format
				if (!matchName(node, format) && !isColorFormatAndAnchor(node, format)) {
					return FALSE;
				}
	
				// Should we compare with format attribs and styles
				if (format.remove != 'all') {
					// Remove styles
					each(format.styles, function(value, name) {
						value = normalizeStyleValue(replaceVars(value, vars), name);
	
						// Indexed array
						if (typeof name === 'number') {
							name = value;
							compare_node = 0;
						}
	
						if (format.remove_similar || (!compare_node || isEq(getStyle(compare_node, name), value))) {
							dom.setStyle(node, name, '');
						}
	
						stylesModified = 1;
					});
	
					// Remove style attribute if it's empty
					if (stylesModified && dom.getAttrib(node, 'style') === '') {
						node.removeAttribute('style');
						node.removeAttribute('data-mce-style');
					}
	
					// Remove attributes
					each(format.attributes, function(value, name) {
						var valueOut;
	
						value = replaceVars(value, vars);
	
						// Indexed array
						if (typeof name === 'number') {
							name = value;
							compare_node = 0;
						}
	
						if (!compare_node || isEq(dom.getAttrib(compare_node, name), value)) {
							// Keep internal classes
							if (name == 'class') {
								value = dom.getAttrib(node, name);
								if (value) {
									// Build new class value where everything is removed except the internal prefixed classes
									valueOut = '';
									each(value.split(/\s+/), function(cls) {
										if (/mce\-\w+/.test(cls)) {
											valueOut += (valueOut ? ' ' : '') + cls;
										}
									});
	
									// We got some internal classes left
									if (valueOut) {
										dom.setAttrib(node, name, valueOut);
										return;
									}
								}
							}
	
							// IE6 has a bug where the attribute doesn't get removed correctly
							if (name == "class") {
								node.removeAttribute('className');
							}
	
							// Remove mce prefixed attributes
							if (MCE_ATTR_RE.test(name)) {
								node.removeAttribute('data-mce-' + name);
							}
	
							node.removeAttribute(name);
						}
					});
	
					// Remove classes
					each(format.classes, function(value) {
						value = replaceVars(value, vars);
	
						if (!compare_node || dom.hasClass(compare_node, value)) {
							dom.removeClass(node, value);
						}
					});
	
					// Check for non internal attributes
					attrs = dom.getAttribs(node);
					for (i = 0; i < attrs.length; i++) {
						var attrName = attrs[i].nodeName;
						if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
							return FALSE;
						}
					}
				}
	
				// Remove the inline child if it's empty for example <b> or <span>
				if (format.remove != 'none') {
					removeNode(node, format);
					return TRUE;
				}
			}
	
			/**
			 * Removes the node and wrap it's children in paragraphs before doing so or
			 * appends BR elements to the beginning/end of the block element if forcedRootBlocks is disabled.
			 *
			 * If the div in the node below gets removed:
			 *  text<div>text</div>text
			 *
			 * Output becomes:
			 *  text<div><br />text<br /></div>text
			 *
			 * So when the div is removed the result is:
			 *  text<br />text<br />text
			 *
			 * @private
			 * @param {Node} node Node to remove + apply BR/P elements to.
			 * @param {Object} format Format rule.
			 * @return {Node} Input node.
			 */
			function removeNode(node, format) {
				var parentNode = node.parentNode, rootBlockElm;
	
				function find(node, next, inc) {
					node = getNonWhiteSpaceSibling(node, next, inc);
	
					return !node || (node.nodeName == 'BR' || isBlock(node));
				}
	
				if (format.block) {
					if (!forcedRootBlock) {
						// Append BR elements if needed before we remove the block
						if (isBlock(node) && !isBlock(parentNode)) {
							if (!find(node, FALSE) && !find(node.firstChild, TRUE, 1)) {
								node.insertBefore(dom.create('br'), node.firstChild);
							}
	
							if (!find(node, TRUE) && !find(node.lastChild, FALSE, 1)) {
								node.appendChild(dom.create('br'));
							}
						}
					} else {
						// Wrap the block in a forcedRootBlock if we are at the root of document
						if (parentNode == dom.getRoot()) {
							if (!format.list_block || !isEq(node, format.list_block)) {
								each(grep(node.childNodes), function(node) {
									if (isValid(forcedRootBlock, node.nodeName.toLowerCase())) {
										if (!rootBlockElm) {
											rootBlockElm = wrap(node, forcedRootBlock);
											dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
										} else {
											rootBlockElm.appendChild(node);
										}
									} else {
										rootBlockElm = 0;
									}
								});
							}
						}
					}
				}
	
				// Never remove nodes that isn't the specified inline element if a selector is specified too
				if (format.selector && format.inline && !isEq(format.inline, node)) {
					return;
				}
	
				dom.remove(node, 1);
			}
	
			/**
			 * Returns the next/previous non whitespace node.
			 *
			 * @private
			 * @param {Node} node Node to start at.
			 * @param {boolean} next (Optional) Include next or previous node defaults to previous.
			 * @param {boolean} inc (Optional) Include the current node in checking. Defaults to false.
			 * @return {Node} Next or previous node or undefined if it wasn't found.
			 */
			function getNonWhiteSpaceSibling(node, next, inc) {
				if (node) {
					next = next ? 'nextSibling' : 'previousSibling';
	
					for (node = inc ? node : node[next]; node; node = node[next]) {
						if (node.nodeType == 1 || !isWhiteSpaceNode(node)) {
							return node;
						}
					}
				}
			}
	
			/**
			 * Merges the next/previous sibling element if they match.
			 *
			 * @private
			 * @param {Node} prev Previous node to compare/merge.
			 * @param {Node} next Next node to compare/merge.
			 * @return {Node} Next node if we didn't merge and prev node if we did.
			 */
			function mergeSiblings(prev, next) {
				var sibling, tmpSibling, elementUtils = new ElementUtils(dom);
	
				function findElementSibling(node, sibling_name) {
					for (sibling = node; sibling; sibling = sibling[sibling_name]) {
						if (sibling.nodeType == 3 && sibling.nodeValue.length !== 0) {
							return node;
						}
	
						if (sibling.nodeType == 1 && !isBookmarkNode(sibling)) {
							return sibling;
						}
					}
	
					return node;
				}
	
				// Check if next/prev exists and that they are elements
				if (prev && next) {
					// If previous sibling is empty then jump over it
					prev = findElementSibling(prev, 'previousSibling');
					next = findElementSibling(next, 'nextSibling');
	
					// Compare next and previous nodes
					if (elementUtils.compare(prev, next)) {
						// Append nodes between
						for (sibling = prev.nextSibling; sibling && sibling != next;) {
							tmpSibling = sibling;
							sibling = sibling.nextSibling;
							prev.appendChild(tmpSibling);
						}
	
						// Remove next node
						dom.remove(next);
	
						// Move children into prev node
						each(grep(next.childNodes), function(node) {
							prev.appendChild(node);
						});
	
						return prev;
					}
				}
	
				return next;
			}
	
			function getContainer(rng, start) {
				var container, offset, lastIdx;
	
				container = rng[start ? 'startContainer' : 'endContainer'];
				offset = rng[start ? 'startOffset' : 'endOffset'];
	
				if (container.nodeType == 1) {
					lastIdx = container.childNodes.length - 1;
	
					if (!start && offset) {
						offset--;
					}
	
					container = container.childNodes[offset > lastIdx ? lastIdx : offset];
				}
	
				// If start text node is excluded then walk to the next node
				if (container.nodeType === 3 && start && offset >= container.nodeValue.length) {
					container = new TreeWalker(container, ed.getBody()).next() || container;
				}
	
				// If end text node is excluded then walk to the previous node
				if (container.nodeType === 3 && !start && offset === 0) {
					container = new TreeWalker(container, ed.getBody()).prev() || container;
				}
	
				return container;
			}
	
			function performCaretAction(type, name, vars, similar) {
				var caretContainerId = '_mce_caret', debug = ed.settings.caret_debug;
	
				// Creates a caret container bogus element
				function createCaretContainer(fill) {
					var caretContainer = dom.create('span', {id: caretContainerId, 'data-mce-bogus': true, style: debug ? 'color:red' : ''});
	
					if (fill) {
						caretContainer.appendChild(ed.getDoc().createTextNode(INVISIBLE_CHAR));
					}
	
					return caretContainer;
				}
	
				function isCaretContainerEmpty(node, nodes) {
					while (node) {
						if ((node.nodeType === 3 && node.nodeValue !== INVISIBLE_CHAR) || node.childNodes.length > 1) {
							return false;
						}
	
						// Collect nodes
						if (nodes && node.nodeType === 1) {
							nodes.push(node);
						}
	
						node = node.firstChild;
					}
	
					return true;
				}
	
				// Returns any parent caret container element
				function getParentCaretContainer(node) {
					while (node) {
						if (node.id === caretContainerId) {
							return node;
						}
	
						node = node.parentNode;
					}
				}
	
				// Finds the first text node in the specified node
				function findFirstTextNode(node) {
					var walker;
	
					if (node) {
						walker = new TreeWalker(node, node);
	
						for (node = walker.current(); node; node = walker.next()) {
							if (node.nodeType === 3) {
								return node;
							}
						}
					}
				}
	
				// Removes the caret container for the specified node or all on the current document
				function removeCaretContainer(node, move_caret) {
					var child, rng;
	
					if (!node) {
						node = getParentCaretContainer(selection.getStart());
	
						if (!node) {
							while ((node = dom.get(caretContainerId))) {
								removeCaretContainer(node, false);
							}
						}
					} else {
						rng = selection.getRng(true);
	
						if (isCaretContainerEmpty(node)) {
							if (move_caret !== false) {
								rng.setStartBefore(node);
								rng.setEndBefore(node);
							}
	
							dom.remove(node);
						} else {
							child = findFirstTextNode(node);
	
							if (child.nodeValue.charAt(0) === INVISIBLE_CHAR) {
								child.deleteData(0, 1);
	
								// Fix for bug #6976
								if (rng.startContainer == child && rng.startOffset > 0) {
									rng.setStart(child, rng.startOffset - 1);
								}
	
								if (rng.endContainer == child && rng.endOffset > 0) {
									rng.setEnd(child, rng.endOffset - 1);
								}
							}
	
							dom.remove(node, 1);
						}
	
						selection.setRng(rng);
					}
				}
	
				// Applies formatting to the caret position
				function applyCaretFormat() {
					var rng, caretContainer, textNode, offset, bookmark, container, text;
	
					rng = selection.getRng(true);
					offset = rng.startOffset;
					container = rng.startContainer;
					text = container.nodeValue;
	
					caretContainer = getParentCaretContainer(selection.getStart());
					if (caretContainer) {
						textNode = findFirstTextNode(caretContainer);
					}
	
					// Expand to word is caret is in the middle of a text node and the char before/after is a alpha numeric character
					if (text && offset > 0 && offset < text.length && /\w/.test(text.charAt(offset)) && /\w/.test(text.charAt(offset - 1))) {
						// Get bookmark of caret position
						bookmark = selection.getBookmark();
	
						// Collapse bookmark range (WebKit)
						rng.collapse(true);
	
						// Expand the range to the closest word and split it at those points
						rng = expandRng(rng, get(name));
						rng = rangeUtils.split(rng);
	
						// Apply the format to the range
						apply(name, vars, rng);
	
						// Move selection back to caret position
						selection.moveToBookmark(bookmark);
					} else {
						if (!caretContainer || textNode.nodeValue !== INVISIBLE_CHAR) {
							caretContainer = createCaretContainer(true);
							textNode = caretContainer.firstChild;
	
							rng.insertNode(caretContainer);
							offset = 1;
	
							apply(name, vars, caretContainer);
						} else {
							apply(name, vars, caretContainer);
						}
	
						// Move selection to text node
						selection.setCursorLocation(textNode, offset);
					}
				}
	
				function removeCaretFormat() {
					var rng = selection.getRng(true), container, offset, bookmark,
						hasContentAfter, node, formatNode, parents = [], i, caretContainer;
	
					container = rng.startContainer;
					offset = rng.startOffset;
					node = container;
	
					if (container.nodeType == 3) {
						if (offset != container.nodeValue.length) {
							hasContentAfter = true;
						}
	
						node = node.parentNode;
					}
	
					while (node) {
						if (matchNode(node, name, vars, similar)) {
							formatNode = node;
							break;
						}
	
						if (node.nextSibling) {
							hasContentAfter = true;
						}
	
						parents.push(node);
						node = node.parentNode;
					}
	
					// Node doesn't have the specified format
					if (!formatNode) {
						return;
					}
	
					// Is there contents after the caret then remove the format on the element
					if (hasContentAfter) {
						// Get bookmark of caret position
						bookmark = selection.getBookmark();
	
						// Collapse bookmark range (WebKit)
						rng.collapse(true);
	
						// Expand the range to the closest word and split it at those points
						rng = expandRng(rng, get(name), true);
						rng = rangeUtils.split(rng);
	
						// Remove the format from the range
						remove(name, vars, rng);
	
						// Move selection back to caret position
						selection.moveToBookmark(bookmark);
					} else {
						caretContainer = createCaretContainer();
	
						node = caretContainer;
						for (i = parents.length - 1; i >= 0; i--) {
							node.appendChild(dom.clone(parents[i], false));
							node = node.firstChild;
						}
	
						// Insert invisible character into inner most format element
						node.appendChild(dom.doc.createTextNode(INVISIBLE_CHAR));
						node = node.firstChild;
	
						var block = dom.getParent(formatNode, isTextBlock);
	
						if (block && dom.isEmpty(block)) {
							// Replace formatNode with caretContainer when removing format from empty block like <p><b>|</b></p>
							formatNode.parentNode.replaceChild(caretContainer, formatNode);
						} else {
							// Insert caret container after the formatted node
							dom.insertAfter(caretContainer, formatNode);
						}
	
						// Move selection to text node
						selection.setCursorLocation(node, 1);
	
						// If the formatNode is empty, we can remove it safely.
						if (dom.isEmpty(formatNode)) {
							dom.remove(formatNode);
						}
					}
				}
	
				// Checks if the parent caret container node isn't empty if that is the case it
				// will remove the bogus state on all children that isn't empty
				function unmarkBogusCaretParents() {
					var caretContainer;
	
					caretContainer = getParentCaretContainer(selection.getStart());
					if (caretContainer && !dom.isEmpty(caretContainer)) {
						walk(caretContainer, function(node) {
							if (node.nodeType == 1 && node.id !== caretContainerId && !dom.isEmpty(node)) {
								dom.setAttrib(node, 'data-mce-bogus', null);
							}
						}, 'childNodes');
					}
				}
	
				// Only bind the caret events once
				if (!ed._hasCaretEvents) {
					// Mark current caret container elements as bogus when getting the contents so we don't end up with empty elements
					markCaretContainersBogus = function() {
						var nodes = [], i;
	
						if (isCaretContainerEmpty(getParentCaretContainer(selection.getStart()), nodes)) {
							// Mark children
							i = nodes.length;
							while (i--) {
								dom.setAttrib(nodes[i], 'data-mce-bogus', '1');
							}
						}
					};
	
					disableCaretContainer = function(e) {
						var keyCode = e.keyCode;
	
						removeCaretContainer();
	
						// Remove caret container if it's empty
						if (keyCode == 8 && selection.isCollapsed() && selection.getStart().innerHTML == INVISIBLE_CHAR) {
							removeCaretContainer(getParentCaretContainer(selection.getStart()));
						}
	
						// Remove caret container on keydown and it's left/right arrow keys
						if (keyCode == 37 || keyCode == 39) {
							removeCaretContainer(getParentCaretContainer(selection.getStart()));
						}
	
						unmarkBogusCaretParents();
					};
	
					// Remove bogus state if they got filled by contents using editor.selection.setContent
					ed.on('SetContent', function(e) {
						if (e.selection) {
							unmarkBogusCaretParents();
						}
					});
					ed._hasCaretEvents = true;
				}
	
				// Do apply or remove caret format
				if (type == "apply") {
					applyCaretFormat();
				} else {
					removeCaretFormat();
				}
			}
	
			/**
			 * Moves the start to the first suitable text node.
			 */
			function moveStart(rng) {
				var container = rng.startContainer,
						offset = rng.startOffset, isAtEndOfText,
						walker, node, nodes, tmpNode;
	
				if (rng.startContainer == rng.endContainer) {
					if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
						return;
					}
				}
	
				// Convert text node into index if possible
				if (container.nodeType == 3 && offset >= container.nodeValue.length) {
					// Get the parent container location and walk from there
					offset = nodeIndex(container);
					container = container.parentNode;
					isAtEndOfText = true;
				}
	
				// Move startContainer/startOffset in to a suitable node
				if (container.nodeType == 1) {
					nodes = container.childNodes;
					container = nodes[Math.min(offset, nodes.length - 1)];
					walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	
					// If offset is at end of the parent node walk to the next one
					if (offset > nodes.length - 1 || isAtEndOfText) {
						walker.next();
					}
	
					for (node = walker.current(); node; node = walker.next()) {
						if (node.nodeType == 3 && !isWhiteSpaceNode(node)) {
							// IE has a "neat" feature where it moves the start node into the closest element
							// we can avoid this by inserting an element before it and then remove it after we set the selection
							tmpNode = dom.create('a', {'data-mce-bogus': 'all'}, INVISIBLE_CHAR);
							node.parentNode.insertBefore(tmpNode, node);
	
							// Set selection and remove tmpNode
							rng.setStart(node, 0);
							selection.setRng(rng);
							dom.remove(tmpNode);
	
							return;
						}
					}
				}
			}
		};
	});
	
	// Included from: js/tinymce/classes/UndoManager.js
	
	/**
	 * UndoManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the undo/redo history levels for the editor. Since the built-in undo/redo has major drawbacks a custom one was needed.
	 *
	 * @class tinymce.UndoManager
	 */
	define("tinymce/UndoManager", [
		"tinymce/util/VK",
		"tinymce/Env"
	], function(VK, Env) {
		return function(editor) {
			var self = this, index = 0, data = [], beforeBookmark, isFirstTypedCharacter, locks = 0;
	
			function getContent() {
				return editor.serializer.getTrimmedContent();
			}
	
			function setDirty(state) {
				editor.setDirty(state);
			}
	
			function addNonTypingUndoLevel(e) {
				self.typing = false;
				self.add({}, e);
			}
	
			// Add initial undo level when the editor is initialized
			editor.on('init', function() {
				self.add();
			});
	
			// Get position before an execCommand is processed
			editor.on('BeforeExecCommand', function(e) {
				var cmd = e.command;
	
				if (cmd != 'Undo' && cmd != 'Redo' && cmd != 'mceRepaint') {
					self.beforeChange();
				}
			});
	
			// Add undo level after an execCommand call was made
			editor.on('ExecCommand', function(e) {
				var cmd = e.command;
	
				if (cmd != 'Undo' && cmd != 'Redo' && cmd != 'mceRepaint') {
					addNonTypingUndoLevel(e);
				}
			});
	
			editor.on('ObjectResizeStart Cut', function() {
				self.beforeChange();
			});
	
			editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
			editor.on('DragEnd', addNonTypingUndoLevel);
	
			editor.on('KeyUp', function(e) {
				var keyCode = e.keyCode;
	
				// If key is prevented then don't add undo level
				// This would happen on keyboard shortcuts for example
				if (e.isDefaultPrevented()) {
					return;
				}
	
				if ((keyCode >= 33 && keyCode <= 36) || (keyCode >= 37 && keyCode <= 40) || keyCode == 45 || keyCode == 13 || e.ctrlKey) {
					addNonTypingUndoLevel();
					editor.nodeChanged();
				}
	
				if (keyCode == 46 || keyCode == 8 || (Env.mac && (keyCode == 91 || keyCode == 93))) {
					editor.nodeChanged();
				}
	
				// Fire a TypingUndo event on the first character entered
				if (isFirstTypedCharacter && self.typing) {
					// Make it dirty if the content was changed after typing the first character
					if (!editor.isDirty()) {
						setDirty(data[0] && getContent() != data[0].content);
	
						// Fire initial change event
						if (editor.isDirty()) {
							editor.fire('change', {level: data[0], lastLevel: null});
						}
					}
	
					editor.fire('TypingUndo');
					isFirstTypedCharacter = false;
					editor.nodeChanged();
				}
			});
	
			editor.on('KeyDown', function(e) {
				var keyCode = e.keyCode;
	
				// If key is prevented then don't add undo level
				// This would happen on keyboard shortcuts for example
				if (e.isDefaultPrevented()) {
					return;
				}
	
				// Is character position keys left,right,up,down,home,end,pgdown,pgup,enter
				if ((keyCode >= 33 && keyCode <= 36) || (keyCode >= 37 && keyCode <= 40) || keyCode == 45) {
					if (self.typing) {
						addNonTypingUndoLevel(e);
					}
	
					return;
				}
	
				// If key isn't Ctrl+Alt/AltGr
				var modKey = (e.ctrlKey && !e.altKey) || e.metaKey;
				if ((keyCode < 16 || keyCode > 20) && keyCode != 224 && keyCode != 91 && !self.typing && !modKey) {
					self.beforeChange();
					self.typing = true;
					self.add({}, e);
					isFirstTypedCharacter = true;
				}
			});
	
			editor.on('MouseDown', function(e) {
				if (self.typing) {
					addNonTypingUndoLevel(e);
				}
			});
	
			// Add keyboard shortcuts for undo/redo keys
			editor.addShortcut('meta+z', '', 'Undo');
			editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	
			editor.on('AddUndo Undo Redo ClearUndos', function(e) {
				if (!e.isDefaultPrevented()) {
					editor.nodeChanged();
				}
			});
	
			/*eslint consistent-this:0 */
			self = {
				// Explode for debugging reasons
				data: data,
	
				/**
				 * State if the user is currently typing or not. This will add a typing operation into one undo
				 * level instead of one new level for each keystroke.
				 *
				 * @field {Boolean} typing
				 */
				typing: false,
	
				/**
				 * Stores away a bookmark to be used when performing an undo action so that the selection is before
				 * the change has been made.
				 *
				 * @method beforeChange
				 */
				beforeChange: function() {
					if (!locks) {
						beforeBookmark = editor.selection.getBookmark(2, true);
					}
				},
	
				/**
				 * Adds a new undo level/snapshot to the undo list.
				 *
				 * @method add
				 * @param {Object} level Optional undo level object to add.
				 * @param {DOMEvent} event Optional event responsible for the creation of the undo level.
				 * @return {Object} Undo level that got added or null it a level wasn't needed.
				 */
				add: function(level, event) {
					var i, settings = editor.settings, lastLevel;
	
					level = level || {};
					level.content = getContent();
	
					if (locks || editor.removed) {
						return null;
					}
	
					lastLevel = data[index];
					if (editor.fire('BeforeAddUndo', {level: level, lastLevel: lastLevel, originalEvent: event}).isDefaultPrevented()) {
						return null;
					}
	
					// Add undo level if needed
					if (lastLevel && lastLevel.content == level.content) {
						return null;
					}
	
					// Set before bookmark on previous level
					if (data[index]) {
						data[index].beforeBookmark = beforeBookmark;
					}
	
					// Time to compress
					if (settings.custom_undo_redo_levels) {
						if (data.length > settings.custom_undo_redo_levels) {
							for (i = 0; i < data.length - 1; i++) {
								data[i] = data[i + 1];
							}
	
							data.length--;
							index = data.length;
						}
					}
	
					// Get a non intrusive normalized bookmark
					level.bookmark = editor.selection.getBookmark(2, true);
	
					// Crop array if needed
					if (index < data.length - 1) {
						data.length = index + 1;
					}
	
					data.push(level);
					index = data.length - 1;
	
					var args = {level: level, lastLevel: lastLevel, originalEvent: event};
	
					editor.fire('AddUndo', args);
	
					if (index > 0) {
						setDirty(true);
						editor.fire('change', args);
					}
	
					return level;
				},
	
				/**
				 * Undoes the last action.
				 *
				 * @method undo
				 * @return {Object} Undo level or null if no undo was performed.
				 */
				undo: function() {
					var level;
	
					if (self.typing) {
						self.add();
						self.typing = false;
					}
	
					if (index > 0) {
						level = data[--index];
	
						editor.setContent(level.content, {format: 'raw'});
						editor.selection.moveToBookmark(level.beforeBookmark);
						setDirty(true);
	
						editor.fire('undo', {level: level});
					}
	
					return level;
				},
	
				/**
				 * Redoes the last action.
				 *
				 * @method redo
				 * @return {Object} Redo level or null if no redo was performed.
				 */
				redo: function() {
					var level;
	
					if (index < data.length - 1) {
						level = data[++index];
	
						editor.setContent(level.content, {format: 'raw'});
						editor.selection.moveToBookmark(level.bookmark);
						setDirty(true);
	
						editor.fire('redo', {level: level});
					}
	
					return level;
				},
	
				/**
				 * Removes all undo levels.
				 *
				 * @method clear
				 */
				clear: function() {
					data = [];
					index = 0;
					self.typing = false;
					self.data = data;
					editor.fire('ClearUndos');
				},
	
				/**
				 * Returns true/false if the undo manager has any undo levels.
				 *
				 * @method hasUndo
				 * @return {Boolean} true/false if the undo manager has any undo levels.
				 */
				hasUndo: function() {
					// Has undo levels or typing and content isn't the same as the initial level
					return index > 0 || (self.typing && data[0] && getContent() != data[0].content);
				},
	
				/**
				 * Returns true/false if the undo manager has any redo levels.
				 *
				 * @method hasRedo
				 * @return {Boolean} true/false if the undo manager has any redo levels.
				 */
				hasRedo: function() {
					return index < data.length - 1 && !this.typing;
				},
	
				/**
				 * Executes the specified mutator function as an undo transaction. The selection
				 * before the modification will be stored to the undo stack and if the DOM changes
				 * it will add a new undo level. Any methods within the translation that adds undo levels will
				 * be ignored. So a translation can include calls to execCommand or editor.insertContent.
				 *
				 * @method transact
				 * @param {function} callback Function that gets executed and has dom manipulation logic in it.
				 * @return {Object} Undo level that got added or null it a level wasn't needed.
				 */
				transact: function(callback) {
					self.beforeChange();
	
					try {
						locks++;
						callback();
					} finally {
						locks--;
					}
	
					return self.add();
				},
	
				/**
				 * Adds an extra "hidden" undo level by first applying the first mutation and store that to the undo stack
				 * then roll back that change and do the second mutation on top of the stack. This will produce an extra
				 * undo level that the user doesn't see until they undo.
				 *
				 * @method extra
				 * @param {function} callback1 Function that does mutation but gets stored as a "hidden" extra undo level.
				 * @param {function} callback2 Function that does mutation but gets displayed to the user.
				 */
				extra: function (callback1, callback2) {
					var lastLevel, bookmark;
	
					if (self.transact(callback1)) {
						bookmark = data[index].bookmark;
						lastLevel = data[index - 1];
						editor.setContent(lastLevel.content, {format: 'raw'});
						editor.selection.moveToBookmark(lastLevel.beforeBookmark);
	
						if (self.transact(callback2)) {
							data[index - 1].beforeBookmark = bookmark;
						}
					}
				}
			};
	
			return self;
		};
	});
	
	// Included from: js/tinymce/classes/EnterKey.js
	
	/**
	 * EnterKey.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains logic for handling the enter key to split/generate block elements.
	 *
	 * @private
	 * @class tinymce.EnterKey
	 */
	define("tinymce/EnterKey", [
		"tinymce/dom/TreeWalker",
		"tinymce/dom/RangeUtils",
		"tinymce/Env"
	], function(TreeWalker, RangeUtils, Env) {
		var isIE = Env.ie && Env.ie < 11;
	
		return function(editor) {
			var dom = editor.dom, selection = editor.selection, settings = editor.settings;
			var undoManager = editor.undoManager, schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements(),
				moveCaretBeforeOnEnterElementsMap = schema.getMoveCaretBeforeOnEnterElements();
	
			function handleEnterKey(evt) {
				var rng, tmpRng, editableRoot, container, offset, parentBlock, documentMode, shiftKey,
					newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;
	
				// Returns true if the block can be split into two blocks or not
				function canSplitBlock(node) {
					return node &&
						dom.isBlock(node) &&
						!/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) &&
						!/^(fixed|absolute)/i.test(node.style.position) &&
						dom.getContentEditable(node) !== "true";
				}
	
				function isTableCell(node) {
					return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
				}
	
				// Renders empty block on IE
				function renderBlockOnIE(block) {
					var oldRng;
	
					if (dom.isBlock(block)) {
						oldRng = selection.getRng();
						block.appendChild(dom.create('span', null, '\u00a0'));
						selection.select(block);
						block.lastChild.outerHTML = '';
						selection.setRng(oldRng);
					}
				}
	
				// Remove the first empty inline element of the block so this: <p><b><em></em></b>x</p> becomes this: <p>x</p>
				function trimInlineElementsOnLeftSideOfBlock(block) {
					var node = block, firstChilds = [], i;
	
					if (!node) {
						return;
					}
	
					// Find inner most first child ex: <p><i><b>*</b></i></p>
					while ((node = node.firstChild)) {
						if (dom.isBlock(node)) {
							return;
						}
	
						if (node.nodeType == 1 && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
							firstChilds.push(node);
						}
					}
	
					i = firstChilds.length;
					while (i--) {
						node = firstChilds[i];
						if (!node.hasChildNodes() || (node.firstChild == node.lastChild && node.firstChild.nodeValue === '')) {
							dom.remove(node);
						} else {
							// Remove <a> </a> see #5381
							if (node.nodeName == "A" && (node.innerText || node.textContent) === ' ') {
								dom.remove(node);
							}
						}
					}
				}
	
				// Moves the caret to a suitable position within the root for example in the first non
				// pure whitespace text node or before an image
				function moveToCaretPosition(root) {
					var walker, node, rng, lastNode = root, tempElm;
					function firstNonWhiteSpaceNodeSibling(node) {
						while (node) {
							if (node.nodeType == 1 || (node.nodeType == 3 && node.data && /[\r\n\s]/.test(node.data))) {
								return node;
							}
	
							node = node.nextSibling;
						}
					}
	
					if (!root) {
						return;
					}
	
					// Old IE versions doesn't properly render blocks with br elements in them
					// For example <p><br></p> wont be rendered correctly in a contentEditable area
					// until you remove the br producing <p></p>
					if (Env.ie && Env.ie < 9 && parentBlock && parentBlock.firstChild) {
						if (parentBlock.firstChild == parentBlock.lastChild && parentBlock.firstChild.tagName == 'BR') {
							dom.remove(parentBlock.firstChild);
						}
					}
	
					if (/^(LI|DT|DD)$/.test(root.nodeName)) {
						var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	
						if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
							root.insertBefore(dom.doc.createTextNode('\u00a0'), root.firstChild);
						}
					}
	
					rng = dom.createRng();
	
					// Normalize whitespace to remove empty text nodes. Fix for: #6904
					// Gecko will be able to place the caret in empty text nodes but it won't render propery
					// Older IE versions will sometimes crash so for now ignore all IE versions
					if (!Env.ie) {
						root.normalize();
					}
	
					if (root.hasChildNodes()) {
						walker = new TreeWalker(root, root);
	
						while ((node = walker.current())) {
							if (node.nodeType == 3) {
								rng.setStart(node, 0);
								rng.setEnd(node, 0);
								break;
							}
	
							if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
								rng.setStartBefore(node);
								rng.setEndBefore(node);
								break;
							}
	
							lastNode = node;
							node = walker.next();
						}
	
						if (!node) {
							rng.setStart(lastNode, 0);
							rng.setEnd(lastNode, 0);
						}
					} else {
						if (root.nodeName == 'BR') {
							if (root.nextSibling && dom.isBlock(root.nextSibling)) {
								// Trick on older IE versions to render the caret before the BR between two lists
								if (!documentMode || documentMode < 9) {
									tempElm = dom.create('br');
									root.parentNode.insertBefore(tempElm, root);
								}
	
								rng.setStartBefore(root);
								rng.setEndBefore(root);
							} else {
								rng.setStartAfter(root);
								rng.setEndAfter(root);
							}
						} else {
							rng.setStart(root, 0);
							rng.setEnd(root, 0);
						}
					}
	
					selection.setRng(rng);
	
					// Remove tempElm created for old IE:s
					dom.remove(tempElm);
					selection.scrollIntoView(root);
				}
	
				function setForcedBlockAttrs(node) {
					var forcedRootBlockName = settings.forced_root_block;
	
					if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
						dom.setAttribs(node, settings.forced_root_block_attrs);
					}
				}
	
				function emptyBlock(elm) {
					// BR is needed in empty blocks on non IE browsers
					elm.innerHTML = !isIE ? '<br data-mce-bogus="1">' : '';
				}
	
				// Creates a new block element by cloning the current one or creating a new one if the name is specified
				// This function will also copy any text formatting from the parent block and add it to the new one
				function createNewBlock(name) {
					var node = container, block, clonedNode, caretNode, textInlineElements = schema.getTextInlineElements();
	
					if (name || parentBlockName == "TABLE") {
						block = dom.create(name || newBlockName);
						setForcedBlockAttrs(block);
					} else {
						block = parentBlock.cloneNode(false);
					}
	
					caretNode = block;
	
					// Clone any parent styles
					if (settings.keep_styles !== false) {
						do {
							if (textInlineElements[node.nodeName]) {
								// Never clone a caret containers
								if (node.id == '_mce_caret') {
									continue;
								}
	
								clonedNode = node.cloneNode(false);
								dom.setAttrib(clonedNode, 'id', ''); // Remove ID since it needs to be document unique
	
								if (block.hasChildNodes()) {
									clonedNode.appendChild(block.firstChild);
									block.appendChild(clonedNode);
								} else {
									caretNode = clonedNode;
									block.appendChild(clonedNode);
								}
							}
						} while ((node = node.parentNode) && node != editableRoot);
					}
	
					// BR is needed in empty blocks on non IE browsers
					if (!isIE) {
						caretNode.innerHTML = '<br data-mce-bogus="1">';
					}
	
					return block;
				}
	
				// Returns true/false if the caret is at the start/end of the parent block element
				function isCaretAtStartOrEndOfBlock(start) {
					var walker, node, name;
	
					// Caret is in the middle of a text node like "a|b"
					if (container.nodeType == 3 && (start ? offset > 0 : offset < container.nodeValue.length)) {
						return false;
					}
	
					// If after the last element in block node edge case for #5091
					if (container.parentNode == parentBlock && isAfterLastNodeInContainer && !start) {
						return true;
					}
	
					// If the caret if before the first element in parentBlock
					if (start && container.nodeType == 1 && container == parentBlock.firstChild) {
						return true;
					}
	
					// Caret can be before/after a table
					if (container.nodeName === "TABLE" || (container.previousSibling && container.previousSibling.nodeName == "TABLE")) {
						return (isAfterLastNodeInContainer && !start) || (!isAfterLastNodeInContainer && start);
					}
	
					// Walk the DOM and look for text nodes or non empty elements
					walker = new TreeWalker(container, parentBlock);
	
					// If caret is in beginning or end of a text block then jump to the next/previous node
					if (container.nodeType == 3) {
						if (start && offset === 0) {
							walker.prev();
						} else if (!start && offset == container.nodeValue.length) {
							walker.next();
						}
					}
	
					while ((node = walker.current())) {
						if (node.nodeType === 1) {
							// Ignore bogus elements
							if (!node.getAttribute('data-mce-bogus')) {
								// Keep empty elements like <img /> <input /> but not trailing br:s like <p>text|<br></p>
								name = node.nodeName.toLowerCase();
								if (nonEmptyElementsMap[name] && name !== 'br') {
									return false;
								}
							}
						} else if (node.nodeType === 3 && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
							return false;
						}
	
						if (start) {
							walker.prev();
						} else {
							walker.next();
						}
					}
	
					return true;
				}
	
				// Wraps any text nodes or inline elements in the specified forced root block name
				function wrapSelfAndSiblingsInDefaultBlock(container, offset) {
					var newBlock, parentBlock, startNode, node, next, rootBlockName, blockName = newBlockName || 'P';
	
					// Not in a block element or in a table cell or caption
					parentBlock = dom.getParent(container, dom.isBlock);
					if (!parentBlock || !canSplitBlock(parentBlock)) {
						parentBlock = parentBlock || editableRoot;
	
						if (parentBlock == editor.getBody() || isTableCell(parentBlock)) {
							rootBlockName = parentBlock.nodeName.toLowerCase();
						} else {
							rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
						}
	
						if (!parentBlock.hasChildNodes()) {
							newBlock = dom.create(blockName);
							setForcedBlockAttrs(newBlock);
							parentBlock.appendChild(newBlock);
							rng.setStart(newBlock, 0);
							rng.setEnd(newBlock, 0);
							return newBlock;
						}
	
						// Find parent that is the first child of parentBlock
						node = container;
						while (node.parentNode != parentBlock) {
							node = node.parentNode;
						}
	
						// Loop left to find start node start wrapping at
						while (node && !dom.isBlock(node)) {
							startNode = node;
							node = node.previousSibling;
						}
	
						if (startNode && schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
							newBlock = dom.create(blockName);
							setForcedBlockAttrs(newBlock);
							startNode.parentNode.insertBefore(newBlock, startNode);
	
							// Start wrapping until we hit a block
							node = startNode;
							while (node && !dom.isBlock(node)) {
								next = node.nextSibling;
								newBlock.appendChild(node);
								node = next;
							}
	
							// Restore range to it's past location
							rng.setStart(container, offset);
							rng.setEnd(container, offset);
						}
					}
	
					return container;
				}
	
				// Inserts a block or br before/after or in the middle of a split list of the LI is empty
				function handleEmptyListItem() {
					function isFirstOrLastLi(first) {
						var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	
						// Find first/last element since there might be whitespace there
						while (node) {
							if (node.nodeType == 1) {
								break;
							}
	
							node = node[first ? 'nextSibling' : 'previousSibling'];
						}
	
						return node === parentBlock;
					}
	
					function getContainerBlock() {
						var containerBlockParent = containerBlock.parentNode;
	
						if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
							return containerBlockParent;
						}
	
						return containerBlock;
					}
	
					if (containerBlock == editor.getBody()) {
						return;
					}
	
					// Check if we are in an nested list
					var containerBlockParentName = containerBlock.parentNode.nodeName;
					if (/^(OL|UL|LI)$/.test(containerBlockParentName)) {
						newBlockName = 'LI';
					}
	
					newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	
					if (isFirstOrLastLi(true) && isFirstOrLastLi()) {
						if (containerBlockParentName == 'LI') {
							// Nested list is inside a LI
							dom.insertAfter(newBlock, getContainerBlock());
						} else {
							// Is first and last list item then replace the OL/UL with a text block
							dom.replace(newBlock, containerBlock);
						}
					} else if (isFirstOrLastLi(true)) {
						if (containerBlockParentName == 'LI') {
							// List nested in an LI then move the list to a new sibling LI
							dom.insertAfter(newBlock, getContainerBlock());
							newBlock.appendChild(dom.doc.createTextNode(' ')); // Needed for IE so the caret can be placed
							newBlock.appendChild(containerBlock);
						} else {
							// First LI in list then remove LI and add text block before list
							containerBlock.parentNode.insertBefore(newBlock, containerBlock);
						}
					} else if (isFirstOrLastLi()) {
						// Last LI in list then remove LI and add text block after list
						dom.insertAfter(newBlock, getContainerBlock());
						renderBlockOnIE(newBlock);
					} else {
						// Middle LI in list the split the list and insert a text block in the middle
						// Extract after fragment and insert it after the current block
						containerBlock = getContainerBlock();
						tmpRng = rng.cloneRange();
						tmpRng.setStartAfter(parentBlock);
						tmpRng.setEndAfter(containerBlock);
						fragment = tmpRng.extractContents();
	
						if (newBlockName == 'LI' && fragment.firstChild.nodeName == 'LI') {
							newBlock = fragment.firstChild;
							dom.insertAfter(fragment, containerBlock);
						} else {
							dom.insertAfter(fragment, containerBlock);
							dom.insertAfter(newBlock, containerBlock);
						}
					}
	
					dom.remove(parentBlock);
					moveToCaretPosition(newBlock);
					undoManager.add();
				}
	
				// Inserts a BR element if the forced_root_block option is set to false or empty string
				function insertBr() {
					editor.execCommand("InsertLineBreak", false, evt);
				}
	
				// Trims any linebreaks at the beginning of node user for example when pressing enter in a PRE element
				function trimLeadingLineBreaks(node) {
					do {
						if (node.nodeType === 3) {
							node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
						}
	
						node = node.firstChild;
					} while (node);
				}
	
				function getEditableRoot(node) {
					var root = dom.getRoot(), parent, editableRoot;
	
					// Get all parents until we hit a non editable parent or the root
					parent = node;
					while (parent !== root && dom.getContentEditable(parent) !== "false") {
						if (dom.getContentEditable(parent) === "true") {
							editableRoot = parent;
						}
	
						parent = parent.parentNode;
					}
	
					return parent !== root ? editableRoot : root;
				}
	
				// Adds a BR at the end of blocks that only contains an IMG or INPUT since
				// these might be floated and then they won't expand the block
				function addBrToBlockIfNeeded(block) {
					var lastChild;
	
					// IE will render the blocks correctly other browsers needs a BR
					if (!isIE) {
						block.normalize(); // Remove empty text nodes that got left behind by the extract
	
						// Check if the block is empty or contains a floated last child
						lastChild = block.lastChild;
						if (!lastChild || (/^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true)))) {
							dom.add(block, 'br');
						}
					}
				}
	
				function insertNewBlockAfter() {
					// If the caret is at the end of a header we produce a P tag after it similar to Word unless we are in a hgroup
					if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName != 'HGROUP') {
						newBlock = createNewBlock(newBlockName);
					} else {
						newBlock = createNewBlock();
					}
	
					// Split the current container block element if enter is pressed inside an empty inner block element
					if (settings.end_container_on_empty_block && canSplitBlock(containerBlock) && dom.isEmpty(parentBlock)) {
						// Split container block for example a BLOCKQUOTE at the current blockParent location for example a P
						newBlock = dom.split(containerBlock, parentBlock);
					} else {
						dom.insertAfter(newBlock, parentBlock);
					}
	
					moveToCaretPosition(newBlock);
				}
	
				rng = selection.getRng(true);
	
				// Event is blocked by some other handler for example the lists plugin
				if (evt.isDefaultPrevented()) {
					return;
				}
	
				// Delete any selected contents
				if (!rng.collapsed) {
					editor.execCommand('Delete');
					return;
				}
	
				// Setup range items and newBlockName
				new RangeUtils(dom).normalize(rng);
				container = rng.startContainer;
				offset = rng.startOffset;
				newBlockName = (settings.force_p_newlines ? 'p' : '') || settings.forced_root_block;
				newBlockName = newBlockName ? newBlockName.toUpperCase() : '';
				documentMode = dom.doc.documentMode;
				shiftKey = evt.shiftKey;
	
				// Resolve node index
				if (container.nodeType == 1 && container.hasChildNodes()) {
					isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	
					container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
					if (isAfterLastNodeInContainer && container.nodeType == 3) {
						offset = container.nodeValue.length;
					} else {
						offset = 0;
					}
				}
	
				// Get editable root node, normally the body element but sometimes a div or span
				editableRoot = getEditableRoot(container);
	
				// If there is no editable root then enter is done inside a contentEditable false element
				if (!editableRoot) {
					return;
				}
	
				undoManager.beforeChange();
	
				// If editable root isn't block nor the root of the editor
				if (!dom.isBlock(editableRoot) && editableRoot != dom.getRoot()) {
					if (!newBlockName || shiftKey) {
						insertBr();
					}
	
					return;
				}
	
				// Wrap the current node and it's sibling in a default block if it's needed.
				// for example this <td>text|<b>text2</b></td> will become this <td><p>text|<b>text2</p></b></td>
				// This won't happen if root blocks are disabled or the shiftKey is pressed
				if ((newBlockName && !shiftKey) || (!newBlockName && shiftKey)) {
					container = wrapSelfAndSiblingsInDefaultBlock(container, offset);
				}
	
				// Find parent block and setup empty block paddings
				parentBlock = dom.getParent(container, dom.isBlock);
				containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	
				// Setup block names
				parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
				containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
	
				// Enter inside block contained within a LI then split or insert before/after LI
				if (containerBlockName == 'LI' && !evt.ctrlKey) {
					parentBlock = containerBlock;
					parentBlockName = containerBlockName;
				}
	
				// Handle enter in list item
				if (/^(LI|DT|DD)$/.test(parentBlockName)) {
					if (!newBlockName && shiftKey) {
						insertBr();
						return;
					}
	
					// Handle enter inside an empty list item
					if (dom.isEmpty(parentBlock)) {
						handleEmptyListItem();
						return;
					}
				}
	
				// Don't split PRE tags but insert a BR instead easier when writing code samples etc
				if (parentBlockName == 'PRE' && settings.br_in_pre !== false) {
					if (!shiftKey) {
						insertBr();
						return;
					}
				} else {
					// If no root block is configured then insert a BR by default or if the shiftKey is pressed
					if ((!newBlockName && !shiftKey && parentBlockName != 'LI') || (newBlockName && shiftKey)) {
						insertBr();
						return;
					}
				}
	
				// If parent block is root then never insert new blocks
				if (newBlockName && parentBlock === editor.getBody()) {
					return;
				}
	
				// Default block name if it's not configured
				newBlockName = newBlockName || 'P';
	
				// Insert new block before/after the parent block depending on caret location
				if (isCaretAtStartOrEndOfBlock()) {
					insertNewBlockAfter();
				} else if (isCaretAtStartOrEndOfBlock(true)) {
					// Insert new block before
					newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
					renderBlockOnIE(newBlock);
					moveToCaretPosition(parentBlock);
				} else {
					// Extract after fragment and insert it after the current block
					tmpRng = rng.cloneRange();
					tmpRng.setEndAfter(parentBlock);
					fragment = tmpRng.extractContents();
					trimLeadingLineBreaks(fragment);
					newBlock = fragment.firstChild;
					dom.insertAfter(fragment, parentBlock);
					trimInlineElementsOnLeftSideOfBlock(newBlock);
					addBrToBlockIfNeeded(parentBlock);
	
					if (dom.isEmpty(parentBlock)) {
						emptyBlock(parentBlock);
					}
	
					newBlock.normalize();
	
					// New block might become empty if it's <p><b>a |</b></p>
					if (dom.isEmpty(newBlock)) {
						dom.remove(newBlock);
						insertNewBlockAfter();
					} else {
						moveToCaretPosition(newBlock);
					}
				}
	
				dom.setAttrib(newBlock, 'id', ''); // Remove ID since it needs to be document unique
	
				// Allow custom handling of new blocks
				editor.fire('NewBlock', {newBlock: newBlock});
	
				undoManager.add();
			}
	
			editor.on('keydown', function(evt) {
				if (evt.keyCode == 13) {
					if (handleEnterKey(evt) !== false) {
						evt.preventDefault();
					}
				}
			});
		};
	});
	
	// Included from: js/tinymce/classes/ForceBlocks.js
	
	/**
	 * ForceBlocks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Makes sure that everything gets wrapped in paragraphs.
	 *
	 * @private
	 * @class tinymce.ForceBlocks
	 */
	define("tinymce/ForceBlocks", [], function() {
		return function(editor) {
			var settings = editor.settings, dom = editor.dom, selection = editor.selection;
			var schema = editor.schema, blockElements = schema.getBlockElements();
	
			function addRootBlocks() {
				var node = selection.getStart(), rootNode = editor.getBody(), rng;
				var startContainer, startOffset, endContainer, endOffset, rootBlockNode;
				var tempNode, offset = -0xFFFFFF, wrapped, restoreSelection;
				var tmpRng, rootNodeName, forcedRootBlock;
	
				forcedRootBlock = settings.forced_root_block;
	
				if (!node || node.nodeType !== 1 || !forcedRootBlock) {
					return;
				}
	
				// Check if node is wrapped in block
				while (node && node != rootNode) {
					if (blockElements[node.nodeName]) {
						return;
					}
	
					node = node.parentNode;
				}
	
				// Get current selection
				rng = selection.getRng();
				if (rng.setStart) {
					startContainer = rng.startContainer;
					startOffset = rng.startOffset;
					endContainer = rng.endContainer;
					endOffset = rng.endOffset;
	
					try {
						restoreSelection = editor.getDoc().activeElement === rootNode;
					} catch (ex) {
						// IE throws unspecified error here sometimes
					}
				} else {
					// Force control range into text range
					if (rng.item) {
						node = rng.item(0);
						rng = editor.getDoc().body.createTextRange();
						rng.moveToElementText(node);
					}
	
					restoreSelection = rng.parentElement().ownerDocument === editor.getDoc();
					tmpRng = rng.duplicate();
					tmpRng.collapse(true);
					startOffset = tmpRng.move('character', offset) * -1;
	
					if (!tmpRng.collapsed) {
						tmpRng = rng.duplicate();
						tmpRng.collapse(false);
						endOffset = (tmpRng.move('character', offset) * -1) - startOffset;
					}
				}
	
				// Wrap non block elements and text nodes
				node = rootNode.firstChild;
				rootNodeName = rootNode.nodeName.toLowerCase();
				while (node) {
					// TODO: Break this up, too complex
					if (((node.nodeType === 3 || (node.nodeType == 1 && !blockElements[node.nodeName]))) &&
						schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase())) {
						// Remove empty text nodes
						if (node.nodeType === 3 && node.nodeValue.length === 0) {
							tempNode = node;
							node = node.nextSibling;
							dom.remove(tempNode);
							continue;
						}
	
						if (!rootBlockNode) {
							rootBlockNode = dom.create(forcedRootBlock, editor.settings.forced_root_block_attrs);
							node.parentNode.insertBefore(rootBlockNode, node);
							wrapped = true;
						}
	
						tempNode = node;
						node = node.nextSibling;
						rootBlockNode.appendChild(tempNode);
					} else {
						rootBlockNode = null;
						node = node.nextSibling;
					}
				}
	
				if (wrapped && restoreSelection) {
					if (rng.setStart) {
						rng.setStart(startContainer, startOffset);
						rng.setEnd(endContainer, endOffset);
						selection.setRng(rng);
					} else {
						// Only select if the previous selection was inside the document to prevent auto focus in quirks mode
						try {
							rng = editor.getDoc().body.createTextRange();
							rng.moveToElementText(rootNode);
							rng.collapse(true);
							rng.moveStart('character', startOffset);
	
							if (endOffset > 0) {
								rng.moveEnd('character', endOffset);
							}
	
							rng.select();
						} catch (ex) {
							// Ignore
						}
					}
	
					editor.nodeChanged();
				}
			}
	
			// Force root blocks
			if (settings.forced_root_block) {
				editor.on('NodeChange', addRootBlocks);
			}
		};
	});
	
	// Included from: js/tinymce/classes/caret/CaretUtils.js
	
	/**
	 * CaretUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions shared by the caret logic.
	 *
	 * @private
	 * @class tinymce.caret.CaretUtils
	 */
	define("tinymce/caret/CaretUtils", [
		"tinymce/util/Fun",
		"tinymce/dom/TreeWalker",
		"tinymce/dom/NodeType",
		"tinymce/caret/CaretPosition",
		"tinymce/caret/CaretContainer",
		"tinymce/caret/CaretCandidate"
	], function(Fun, TreeWalker, NodeType, CaretPosition, CaretContainer, CaretCandidate) {
		var isContentEditableTrue = NodeType.isContentEditableTrue,
			isContentEditableFalse = NodeType.isContentEditableFalse,
			isBlockLike = NodeType.matchStyleValues('display', 'block table table-cell table-caption'),
			isCaretContainer = CaretContainer.isCaretContainer,
			curry = Fun.curry,
			isElement = NodeType.isElement,
			isCaretCandidate = CaretCandidate.isCaretCandidate;
	
		function isForwards(direction) {
			return direction > 0;
		}
	
		function isBackwards(direction) {
			return direction < 0;
		}
	
		function findNode(node, direction, predicateFn, rootNode, shallow) {
			var walker = new TreeWalker(node, rootNode);
	
			if (isBackwards(direction)) {
				if (isContentEditableFalse(node)) {
					node = walker.prev(true);
					if (predicateFn(node)) {
						return node;
					}
				}
	
				while ((node = walker.prev(shallow))) {
					if (predicateFn(node)) {
						return node;
					}
				}
			}
	
			if (isForwards(direction)) {
				if (isContentEditableFalse(node)) {
					node = walker.next(true);
					if (predicateFn(node)) {
						return node;
					}
				}
	
				while ((node = walker.next(shallow))) {
					if (predicateFn(node)) {
						return node;
					}
				}
			}
	
			return null;
		}
	
		function getEditingHost(node, rootNode) {
			for (node = node.parentNode; node && node != rootNode; node = node.parentNode) {
				if (isContentEditableTrue(node)) {
					return node;
				}
			}
	
			return rootNode;
		}
	
		function getParentBlock(node, rootNode) {
			while (node && node != rootNode) {
				if (isBlockLike(node)) {
					return node;
				}
	
				node = node.parentNode;
			}
	
			return null;
		}
	
		function isInSameBlock(caretPosition1, caretPosition2, rootNode) {
			return getParentBlock(caretPosition1.container(), rootNode) == getParentBlock(caretPosition2.container(), rootNode);
		}
	
		function isInSameEditingHost(caretPosition1, caretPosition2, rootNode) {
			return getEditingHost(caretPosition1.container(), rootNode) == getEditingHost(caretPosition2.container(), rootNode);
		}
	
		function getChildNodeAtRelativeOffset(relativeOffset, caretPosition) {
			var container, offset;
	
			if (!caretPosition) {
				return null;
			}
	
			container = caretPosition.container();
			offset = caretPosition.offset();
	
			if (!isElement(container)) {
				return null;
			}
	
			return container.childNodes[offset + relativeOffset];
		}
	
		function beforeAfter(before, node) {
			var range = node.ownerDocument.createRange();
	
			if (before) {
				range.setStartBefore(node);
				range.setEndBefore(node);
			} else {
				range.setStartAfter(node);
				range.setEndAfter(node);
			}
	
			return range;
		}
	
		function isNodesInSameBlock(rootNode, node1, node2) {
			return getParentBlock(node1, rootNode) == getParentBlock(node2, rootNode);
		}
	
		function lean(left, rootNode, node) {
			var sibling, siblingName;
	
			if (left) {
				siblingName = 'previousSibling';
			} else {
				siblingName = 'nextSibling';
			}
	
			while (node && node != rootNode) {
				sibling = node[siblingName];
	
				if (isCaretContainer(sibling)) {
					sibling = sibling[siblingName];
				}
	
				if (isContentEditableFalse(sibling)) {
					if (isNodesInSameBlock(rootNode, sibling, node)) {
						return sibling;
					}
	
					break;
				}
	
				if (isCaretCandidate(sibling)) {
					break;
				}
	
				node = node.parentNode;
			}
	
			return null;
		}
	
		var before = curry(beforeAfter, true);
		var after = curry(beforeAfter, false);
	
		function normalizeRange(direction, rootNode, range) {
			var node, container, offset, location;
			var leanLeft = curry(lean, true, rootNode);
			var leanRight = curry(lean, false, rootNode);
	
			container = range.startContainer;
			offset = range.startOffset;
	
			if (CaretContainer.isCaretContainerBlock(container)) {
				if (!isElement(container)) {
					container = container.parentNode;
				}
	
				location = container.getAttribute('data-mce-caret');
	
				if (location == 'before') {
					node = container.nextSibling;
					if (isContentEditableFalse(node)) {
						return before(node);
					}
				}
	
				if (location == 'after') {
					node = container.previousSibling;
					if (isContentEditableFalse(node)) {
						return after(node);
					}
				}
			}
	
			if (!range.collapsed) {
				return range;
			}
	
			if (NodeType.isText(container)) {
				if (isCaretContainer(container)) {
					if (direction === 1) {
						node = leanRight(container);
						if (node) {
							return before(node);
						}
	
						node = leanLeft(container);
						if (node) {
							return after(node);
						}
					}
	
					if (direction === -1) {
						node = leanLeft(container);
						if (node) {
							return after(node);
						}
	
						node = leanRight(container);
						if (node) {
							return before(node);
						}
					}
	
					return range;
				}
	
				if (CaretContainer.endsWithCaretContainer(container) && offset >= container.data.length - 1) {
					if (direction === 1) {
						node = leanRight(container);
						if (node) {
							return before(node);
						}
					}
	
					return range;
				}
	
				if (CaretContainer.startsWithCaretContainer(container) && offset <= 1) {
					if (direction === -1) {
						node = leanLeft(container);
						if (node) {
							return after(node);
						}
					}
	
					return range;
				}
	
				if (offset === container.data.length) {
					node = leanRight(container);
					if (node) {
						return before(node);
					}
	
					return range;
				}
	
				if (offset === 0) {
					node = leanLeft(container);
					if (node) {
						return after(node);
					}
	
					return range;
				}
			}
	
			return range;
		}
	
		function isNextToContentEditableFalse(relativeOffset, caretPosition) {
			return isContentEditableFalse(getChildNodeAtRelativeOffset(relativeOffset, caretPosition));
		}
	
		return {
			isForwards: isForwards,
			isBackwards: isBackwards,
			findNode: findNode,
			getEditingHost: getEditingHost,
			getParentBlock: getParentBlock,
			isInSameBlock: isInSameBlock,
			isInSameEditingHost: isInSameEditingHost,
			isBeforeContentEditableFalse: curry(isNextToContentEditableFalse, 0),
			isAfterContentEditableFalse: curry(isNextToContentEditableFalse, -1),
			normalizeRange: normalizeRange
		};
	});
	
	// Included from: js/tinymce/classes/caret/CaretWalker.js
	
	/**
	 * CaretWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for moving around a virtual caret in logical order within a DOM element.
	 *
	 * It ignores the most obvious invalid caret locations such as within a script element or within a
	 * contentEditable=false element but it will return locations that isn't possible to render visually.
	 *
	 * @private
	 * @class tinymce.caret.CaretWalker
	 * @example
	 * var caretWalker = new CaretWalker(rootElm);
	 *
	 * var prevLogicalCaretPosition = caretWalker.prev(CaretPosition.fromRangeStart(range));
	 * var nextLogicalCaretPosition = caretWalker.next(CaretPosition.fromRangeEnd(range));
	 */
	define("tinymce/caret/CaretWalker", [
		"tinymce/dom/NodeType",
		"tinymce/caret/CaretCandidate",
		"tinymce/caret/CaretPosition",
		"tinymce/caret/CaretUtils",
		"tinymce/util/Arr",
		"tinymce/util/Fun"
	], function(NodeType, CaretCandidate, CaretPosition, CaretUtils, Arr, Fun) {
		var isContentEditableFalse = NodeType.isContentEditableFalse,
			isText = NodeType.isText,
			isElement = NodeType.isElement,
			isBr = NodeType.isBr,
			isForwards = CaretUtils.isForwards,
			isBackwards = CaretUtils.isBackwards,
			isCaretCandidate = CaretCandidate.isCaretCandidate,
			isAtomic = CaretCandidate.isAtomic,
			isEditableCaretCandidate = CaretCandidate.isEditableCaretCandidate;
	
		function getParents(node, rootNode) {
			var parents = [];
	
			while (node && node != rootNode) {
				parents.push(node);
				node = node.parentNode;
			}
	
			return parents;
		}
	
		function nodeAtIndex(container, offset) {
			if (container.hasChildNodes() && offset < container.childNodes.length) {
				return container.childNodes[offset];
			}
	
			return null;
		}
	
		function getCaretCandidatePosition(direction, node) {
			if (isForwards(direction)) {
				if (isCaretCandidate(node.previousSibling) && !isText(node.previousSibling)) {
					return CaretPosition.before(node);
				}
	
				if (isText(node)) {
					return CaretPosition(node, 0);
				}
			}
	
			if (isBackwards(direction)) {
				if (isCaretCandidate(node.nextSibling) && !isText(node.nextSibling)) {
					return CaretPosition.after(node);
				}
	
				if (isText(node)) {
					return CaretPosition(node, node.data.length);
				}
			}
	
			if (isBackwards(direction)) {
				if (isBr(node)) {
					return CaretPosition.before(node);
				}
	
				return CaretPosition.after(node);
			}
	
			return CaretPosition.before(node);
		}
	
		// Jumps over BR elements <p>|<br></p><p>a</p> -> <p><br></p><p>|a</p>
		function isBrBeforeBlock(node, rootNode) {
			var next;
	
			if (!NodeType.isBr(node)) {
				return false;
			}
	
			next = findCaretPosition(1, CaretPosition.after(node), rootNode);
			if (!next) {
				return false;
			}
	
			return !CaretUtils.isInSameBlock(CaretPosition.before(node), CaretPosition.before(next), rootNode);
		}
	
		function findCaretPosition(direction, startCaretPosition, rootNode) {
			var container, offset, node, nextNode, innerNode,
				rootContentEditableFalseElm, caretPosition;
	
			if (!isElement(rootNode) || !startCaretPosition) {
				return null;
			}
	
			caretPosition = startCaretPosition;
			container = caretPosition.container();
			offset = caretPosition.offset();
	
			if (isText(container)) {
				if (isBackwards(direction) && offset > 0) {
					return CaretPosition(container, --offset);
				}
	
				if (isForwards(direction) && offset < container.length) {
					return CaretPosition(container, ++offset);
				}
	
				node = container;
			} else {
				if (isBackwards(direction) && offset > 0) {
					nextNode = nodeAtIndex(container, offset - 1);
					if (isCaretCandidate(nextNode)) {
						if (!isAtomic(nextNode)) {
							innerNode = CaretUtils.findNode(nextNode, direction, isEditableCaretCandidate, nextNode);
							if (innerNode) {
								if (isText(innerNode)) {
									return CaretPosition(innerNode, innerNode.data.length);
								}
	
								return CaretPosition.after(innerNode);
							}
						}
	
						if (isText(nextNode)) {
							return CaretPosition(nextNode, nextNode.data.length);
						}
	
						return CaretPosition.before(nextNode);
					}
				}
	
				if (isForwards(direction) && offset < container.childNodes.length) {
					nextNode = nodeAtIndex(container, offset);
					if (isCaretCandidate(nextNode)) {
						if (isBrBeforeBlock(nextNode, rootNode)) {
							return findCaretPosition(direction, CaretPosition.after(nextNode), rootNode);
						}
	
						if (!isAtomic(nextNode)) {
							innerNode = CaretUtils.findNode(nextNode, direction, isEditableCaretCandidate, nextNode);
							if (innerNode) {
								if (isText(innerNode)) {
									return CaretPosition(innerNode, 0);
								}
	
								return CaretPosition.before(innerNode);
							}
						}
	
						if (isText(nextNode)) {
							return CaretPosition(nextNode, 0);
						}
	
						return CaretPosition.after(nextNode);
					}
				}
	
				node = caretPosition.getNode();
			}
	
			if ((isForwards(direction) && caretPosition.isAtEnd()) || (isBackwards(direction) && caretPosition.isAtStart())) {
				node = CaretUtils.findNode(node, direction, Fun.constant(true), rootNode, true);
				if (isEditableCaretCandidate(node)) {
					return getCaretCandidatePosition(direction, node);
				}
			}
	
			nextNode = CaretUtils.findNode(node, direction, isEditableCaretCandidate, rootNode);
	
			rootContentEditableFalseElm = Arr.last(Arr.filter(getParents(container, rootNode), isContentEditableFalse));
			if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
				if (isForwards(direction)) {
					caretPosition = CaretPosition.after(rootContentEditableFalseElm);
				} else {
					caretPosition = CaretPosition.before(rootContentEditableFalseElm);
				}
	
				return caretPosition;
			}
	
			if (nextNode) {
				return getCaretCandidatePosition(direction, nextNode);
			}
	
			return null;
		}
	
		return function(rootNode) {
			return {
				/**
				 * Returns the next logical caret position from the specificed input
				 * caretPoisiton or null if there isn't any more positions left for example
				 * at the end specified root element.
				 *
				 * @method next
				 * @param {tinymce.caret.CaretPosition} caretPosition Caret position to start from.
				 * @return {tinymce.caret.CaretPosition} CaretPosition or null if no position was found.
				 */
				next: function(caretPosition) {
					return findCaretPosition(1, caretPosition, rootNode);
				},
	
				/**
				 * Returns the previous logical caret position from the specificed input
				 * caretPoisiton or null if there isn't any more positions left for example
				 * at the end specified root element.
				 *
				 * @method prev
				 * @param {tinymce.caret.CaretPosition} caretPosition Caret position to start from.
				 * @return {tinymce.caret.CaretPosition} CaretPosition or null if no position was found.
				 */
				prev: function(caretPosition) {
					return findCaretPosition(-1, caretPosition, rootNode);
				}
			};
		};
	});
	
	// Included from: js/tinymce/classes/InsertList.js
	
	/**
	 * InsertList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles inserts of lists into the editor instance.
	 *
	 * @class tinymce.InsertList
	 * @private
	 */
	define("tinymce/InsertList", [
		"tinymce/util/Tools",
		"tinymce/caret/CaretWalker",
		"tinymce/caret/CaretPosition"
	], function(Tools, CaretWalker, CaretPosition) {
		var isListFragment = function(fragment) {
			var firstChild = fragment.firstChild;
			var lastChild = fragment.lastChild;
	
			// Skip meta since it's likely <meta><ul>..</ul>
			if (firstChild && firstChild.name === 'meta') {
				firstChild = firstChild.next;
			}
	
			// Skip mce_marker since it's likely <ul>..</ul><span id="mce_marker"></span>
			if (lastChild && lastChild.attr('id') === 'mce_marker') {
				lastChild = lastChild.prev;
			}
	
			if (!firstChild || firstChild !== lastChild) {
				return false;
			}
	
			return firstChild.name === 'ul' || firstChild.name === 'ol';
		};
	
		var cleanupDomFragment = function (domFragment) {
			var firstChild = domFragment.firstChild;
			var lastChild = domFragment.lastChild;
	
			// TODO: remove the meta tag from paste logic
			if (firstChild && firstChild.nodeName === 'META') {
				firstChild.parentNode.removeChild(firstChild);
			}
	
			if (lastChild && lastChild.id === 'mce_marker') {
				lastChild.parentNode.removeChild(lastChild);
			}
	
			return domFragment;
		};
	
		var toDomFragment = function(dom, serializer, fragment) {
			var html = serializer.serialize(fragment);
			var domFragment = dom.createFragment(html);
	
			return cleanupDomFragment(domFragment);
		};
	
		var listItems = function(elm) {
			return Tools.grep(elm.childNodes, function(child) {
				return child.nodeName === 'LI';
			});
		};
	
		var isEmpty = function (elm) {
			return !elm.firstChild;
		};
	
		var trimListItems = function(elms) {
			return elms.length > 0 && isEmpty(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
		};
	
		var getParentLi = function(dom, node) {
			var parentBlock = dom.getParent(node, dom.isBlock);
			return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
		};
	
		var isParentBlockLi = function(dom, node) {
			return !!getParentLi(dom, node);
		};
	
		var getSplit = function(parentNode, rng) {
			var beforeRng = rng.cloneRange();
			var afterRng = rng.cloneRange();
	
			beforeRng.setStartBefore(parentNode);
			afterRng.setEndAfter(parentNode);
	
			return [
				beforeRng.cloneContents(),
				afterRng.cloneContents()
			];
		};
	
		var findFirstIn = function(node, rootNode) {
			var caretPos = CaretPosition.before(node);
			var caretWalker = new CaretWalker(rootNode);
			var newCaretPos = caretWalker.next(caretPos);
	
			return newCaretPos ? newCaretPos.toRange() : null;
		};
	
		var findLastOf = function(node, rootNode) {
			var caretPos = CaretPosition.after(node);
			var caretWalker = new CaretWalker(rootNode);
			var newCaretPos = caretWalker.prev(caretPos);
	
			return newCaretPos ? newCaretPos.toRange() : null;
		};
	
		var insertMiddle = function(target, elms, rootNode, rng) {
			var parts = getSplit(target, rng);
			var parentElm = target.parentNode;
	
			parentElm.insertBefore(parts[0], target);
			Tools.each(elms, function(li) {
				parentElm.insertBefore(li, target);
			});
			parentElm.insertBefore(parts[1], target);
			parentElm.removeChild(target);
	
			return findLastOf(elms[elms.length - 1], rootNode);
		};
	
		var insertBefore = function(target, elms, rootNode) {
			var parentElm = target.parentNode;
	
			Tools.each(elms, function(elm) {
				parentElm.insertBefore(elm, target);
			});
	
			return findFirstIn(target, rootNode);
		};
	
		var insertAfter = function(target, elms, rootNode, dom) {
			dom.insertAfter(elms.reverse(), target);
			return findLastOf(elms[0], rootNode);
		};
	
		var insertAtCaret = function(serializer, dom, rng, fragment) {
			var domFragment = toDomFragment(dom, serializer, fragment);
			var liTarget = getParentLi(dom, rng.startContainer);
			var liElms = trimListItems(listItems(domFragment.firstChild));
			var BEGINNING = 1, END = 2;
			var rootNode = dom.getRoot();
	
			var isAt = function(location) {
				var caretPos = CaretPosition.fromRangeStart(rng);
				var caretWalker = new CaretWalker(dom.getRoot());
				var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	
				return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
			};
	
			if (isAt(BEGINNING)) {
				return insertBefore(liTarget, liElms, rootNode);
			} else if (isAt(END)) {
				return insertAfter(liTarget, liElms, rootNode, dom);
			}
	
			return insertMiddle(liTarget, liElms, rootNode, rng);
		};
	
		return {
			isListFragment: isListFragment,
			insertAtCaret: insertAtCaret,
			isParentBlockLi: isParentBlockLi,
			trimListItems: trimListItems,
			listItems: listItems
		};
	});
	
	// Included from: js/tinymce/classes/InsertContent.js
	
	/**
	 * InsertContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles inserts of contents into the editor instance.
	 *
	 * @class tinymce.InsertContent
	 * @private
	 */
	define("tinymce/InsertContent", [
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/html/Serializer",
		"tinymce/caret/CaretWalker",
		"tinymce/caret/CaretPosition",
		"tinymce/dom/ElementUtils",
		"tinymce/dom/NodeType",
		"tinymce/InsertList"
	], function(Env, Tools, Serializer, CaretWalker, CaretPosition, ElementUtils, NodeType, InsertList) {
		var isTableCell = NodeType.matchNodeNames('td th');
	
		var insertHtmlAtCaret = function(editor, value, details) {
			var parser, serializer, parentNode, rootNode, fragment, args;
			var marker, rng, node, node2, bookmarkHtml, merge;
			var textInlineElements = editor.schema.getTextInlineElements();
			var selection = editor.selection, dom = editor.dom;
	
			function trimOrPaddLeftRight(html) {
				var rng, container, offset;
	
				rng = selection.getRng(true);
				container = rng.startContainer;
				offset = rng.startOffset;
	
				function hasSiblingText(siblingName) {
					return container[siblingName] && container[siblingName].nodeType == 3;
				}
	
				if (container.nodeType == 3) {
					if (offset > 0) {
						html = html.replace(/^&nbsp;/, ' ');
					} else if (!hasSiblingText('previousSibling')) {
						html = html.replace(/^ /, '&nbsp;');
					}
	
					if (offset < container.length) {
						html = html.replace(/&nbsp;(<br>|)$/, ' ');
					} else if (!hasSiblingText('nextSibling')) {
						html = html.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;');
					}
				}
	
				return html;
			}
	
			// Removes &nbsp; from a [b] c -> a &nbsp;c -> a c
			function trimNbspAfterDeleteAndPaddValue() {
				var rng, container, offset;
	
				rng = selection.getRng(true);
				container = rng.startContainer;
				offset = rng.startOffset;
	
				if (container.nodeType == 3 && rng.collapsed) {
					if (container.data[offset] === '\u00a0') {
						container.deleteData(offset, 1);
	
						if (!/[\u00a0| ]$/.test(value)) {
							value += ' ';
						}
					} else if (container.data[offset - 1] === '\u00a0') {
						container.deleteData(offset - 1, 1);
	
						if (!/[\u00a0| ]$/.test(value)) {
							value = ' ' + value;
						}
					}
				}
			}
	
			function reduceInlineTextElements() {
				if (merge) {
					var root = editor.getBody(), elementUtils = new ElementUtils(dom);
	
					Tools.each(dom.select('*[data-mce-fragment]'), function(node) {
						for (var testNode = node.parentNode; testNode && testNode != root; testNode = testNode.parentNode) {
							if (textInlineElements[node.nodeName.toLowerCase()] && elementUtils.compare(testNode, node)) {
								dom.remove(node, true);
							}
						}
					});
				}
			}
	
			function markFragmentElements(fragment) {
				var node = fragment;
	
				while ((node = node.walk())) {
					if (node.type === 1) {
						node.attr('data-mce-fragment', '1');
					}
				}
			}
	
			function umarkFragmentElements(elm) {
				Tools.each(elm.getElementsByTagName('*'), function(elm) {
					elm.removeAttribute('data-mce-fragment');
				});
			}
	
			function isPartOfFragment(node) {
				return !!node.getAttribute('data-mce-fragment');
			}
	
			function canHaveChildren(node) {
				return node && !editor.schema.getShortEndedElements()[node.nodeName];
			}
	
			function moveSelectionToMarker(marker) {
				var parentEditableFalseElm, parentBlock, nextRng;
	
				function getContentEditableFalseParent(node) {
					var root = editor.getBody();
	
					for (; node && node !== root; node = node.parentNode) {
						if (editor.dom.getContentEditable(node) === 'false') {
							return node;
						}
					}
	
					return null;
				}
	
				if (!marker) {
					return;
				}
	
				selection.scrollIntoView(marker);
	
				// If marker is in cE=false then move selection to that element instead
				parentEditableFalseElm = getContentEditableFalseParent(marker);
				if (parentEditableFalseElm) {
					dom.remove(marker);
					selection.select(parentEditableFalseElm);
					return;
				}
	
				// Move selection before marker and remove it
				rng = dom.createRng();
	
				// If previous sibling is a text node set the selection to the end of that node
				node = marker.previousSibling;
				if (node && node.nodeType == 3) {
					rng.setStart(node, node.nodeValue.length);
	
					// TODO: Why can't we normalize on IE
					if (!Env.ie) {
						node2 = marker.nextSibling;
						if (node2 && node2.nodeType == 3) {
							node.appendData(node2.data);
							node2.parentNode.removeChild(node2);
						}
					}
				} else {
					// If the previous sibling isn't a text node or doesn't exist set the selection before the marker node
					rng.setStartBefore(marker);
					rng.setEndBefore(marker);
				}
	
				function findNextCaretRng(rng) {
					var caretPos = CaretPosition.fromRangeStart(rng);
					var caretWalker = new CaretWalker(editor.getBody());
	
					caretPos = caretWalker.next(caretPos);
					if (caretPos) {
						return caretPos.toRange();
					}
				}
	
				// Remove the marker node and set the new range
				parentBlock = dom.getParent(marker, dom.isBlock);
				dom.remove(marker);
	
				if (parentBlock && dom.isEmpty(parentBlock)) {
					editor.$(parentBlock).empty();
	
					rng.setStart(parentBlock, 0);
					rng.setEnd(parentBlock, 0);
	
					if (!isTableCell(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
						rng = nextRng;
						dom.remove(parentBlock);
					} else {
						dom.add(parentBlock, dom.create('br', {'data-mce-bogus': '1'}));
					}
				}
	
				selection.setRng(rng);
			}
	
			// Check for whitespace before/after value
			if (/^ | $/.test(value)) {
				value = trimOrPaddLeftRight(value);
			}
	
			// Setup parser and serializer
			parser = editor.parser;
			merge = details.merge;
	
			serializer = new Serializer({
				validate: editor.settings.validate
			}, editor.schema);
			bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
	
			// Run beforeSetContent handlers on the HTML to be inserted
			args = {content: value, format: 'html', selection: true};
			editor.fire('BeforeSetContent', args);
			value = args.content;
	
			// Add caret at end of contents if it's missing
			if (value.indexOf('{$caret}') == -1) {
				value += '{$caret}';
			}
	
			// Replace the caret marker with a span bookmark element
			value = value.replace(/\{\$caret\}/, bookmarkHtml);
	
			// If selection is at <body>|<p></p> then move it into <body><p>|</p>
			rng = selection.getRng();
			var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
			var body = editor.getBody();
			if (caretElement === body && selection.isCollapsed()) {
				if (dom.isBlock(body.firstChild) && canHaveChildren(body.firstChild) && dom.isEmpty(body.firstChild)) {
					rng = dom.createRng();
					rng.setStart(body.firstChild, 0);
					rng.setEnd(body.firstChild, 0);
					selection.setRng(rng);
				}
			}
	
			// Insert node maker where we will insert the new HTML and get it's parent
			if (!selection.isCollapsed()) {
				// Fix for #2595 seems that delete removes one extra character on
				// WebKit for some odd reason if you double click select a word
				editor.selection.setRng(editor.selection.getRng());
				editor.getDoc().execCommand('Delete', false, null);
				trimNbspAfterDeleteAndPaddValue();
			}
	
			parentNode = selection.getNode();
	
			// Parse the fragment within the context of the parent node
			var parserArgs = {context: parentNode.nodeName.toLowerCase(), data: details.data};
			fragment = parser.parse(value, parserArgs);
	
			// Custom handling of lists
			if (details.paste === true && InsertList.isListFragment(fragment) && InsertList.isParentBlockLi(dom, parentNode)) {
				rng = InsertList.insertAtCaret(serializer, dom, editor.selection.getRng(true), fragment);
				editor.selection.setRng(rng);
				editor.fire('SetContent', args);
				return;
			}
	
			markFragmentElements(fragment);
	
			// Move the caret to a more suitable location
			node = fragment.lastChild;
			if (node.attr('id') == 'mce_marker') {
				marker = node;
	
				for (node = node.prev; node; node = node.walk(true)) {
					if (node.type == 3 || !dom.isBlock(node.name)) {
						if (editor.schema.isValidChild(node.parent.name, 'span')) {
							node.parent.insert(marker, node, node.name === 'br');
						}
						break;
					}
				}
			}
	
			editor._selectionOverrides.showBlockCaretContainer(parentNode);
	
			// If parser says valid we can insert the contents into that parent
			if (!parserArgs.invalid) {
				value = serializer.serialize(fragment);
	
				// Check if parent is empty or only has one BR element then set the innerHTML of that parent
				node = parentNode.firstChild;
				node2 = parentNode.lastChild;
				if (!node || (node === node2 && node.nodeName === 'BR')) {
					dom.setHTML(parentNode, value);
				} else {
					selection.setContent(value);
				}
			} else {
				// If the fragment was invalid within that context then we need
				// to parse and process the parent it's inserted into
	
				// Insert bookmark node and get the parent
				selection.setContent(bookmarkHtml);
				parentNode = selection.getNode();
				rootNode = editor.getBody();
	
				// Opera will return the document node when selection is in root
				if (parentNode.nodeType == 9) {
					parentNode = node = rootNode;
				} else {
					node = parentNode;
				}
	
				// Find the ancestor just before the root element
				while (node !== rootNode) {
					parentNode = node;
					node = node.parentNode;
				}
	
				// Get the outer/inner HTML depending on if we are in the root and parser and serialize that
				value = parentNode == rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
				value = serializer.serialize(
					parser.parse(
						// Need to replace by using a function since $ in the contents would otherwise be a problem
						value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function() {
							return serializer.serialize(fragment);
						})
					)
				);
	
				// Set the inner/outer HTML depending on if we are in the root or not
				if (parentNode == rootNode) {
					dom.setHTML(rootNode, value);
				} else {
					dom.setOuterHTML(parentNode, value);
				}
			}
	
			reduceInlineTextElements();
			moveSelectionToMarker(dom.get('mce_marker'));
			umarkFragmentElements(editor.getBody());
			editor.fire('SetContent', args);
			editor.addVisual();
		};
	
		var processValue = function (value) {
			var details;
	
			if (typeof value !== 'string') {
				details = Tools.extend({
					paste: value.paste,
					data: {
						paste: value.paste
					}
				}, value);
	
				return {
					content: value.content,
					details: details
				};
			}
	
			return {
				content: value,
				details: {}
			};
		};
	
		var insertAtCaret = function (editor, value) {
			var result = processValue(value);
			insertHtmlAtCaret(editor, result.content, result.details);
		};
	
		return {
			insertAtCaret: insertAtCaret
		};
	});
	
	// Included from: js/tinymce/classes/EditorCommands.js
	
	/**
	 * EditorCommands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to add custom editor commands and it contains
	 * overrides for native browser commands to address various bugs and issues.
	 *
	 * @class tinymce.EditorCommands
	 */
	define("tinymce/EditorCommands", [
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/dom/RangeUtils",
		"tinymce/dom/TreeWalker",
		"tinymce/InsertContent"
	], function(Env, Tools, RangeUtils, TreeWalker, InsertContent) {
		// Added for compression purposes
		var each = Tools.each, extend = Tools.extend;
		var map = Tools.map, inArray = Tools.inArray, explode = Tools.explode;
		var isOldIE = Env.ie && Env.ie < 11;
		var TRUE = true, FALSE = false;
	
		return function(editor) {
			var dom, selection, formatter,
				commands = {state: {}, exec: {}, value: {}},
				settings = editor.settings,
				bookmark;
	
			editor.on('PreInit', function() {
				dom = editor.dom;
				selection = editor.selection;
				settings = editor.settings;
				formatter = editor.formatter;
			});
	
			/**
			 * Executes the specified command.
			 *
			 * @method execCommand
			 * @param {String} command Command to execute.
			 * @param {Boolean} ui Optional user interface state.
			 * @param {Object} value Optional value for command.
			 * @param {Object} args Optional extra arguments to the execCommand.
			 * @return {Boolean} true/false if the command was found or not.
			 */
			function execCommand(command, ui, value, args) {
				var func, customCommand, state = 0;
	
				if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
					editor.focus();
				}
	
				args = editor.fire('BeforeExecCommand', {command: command, ui: ui, value: value});
				if (args.isDefaultPrevented()) {
					return false;
				}
	
				customCommand = command.toLowerCase();
				if ((func = commands.exec[customCommand])) {
					func(customCommand, ui, value);
					editor.fire('ExecCommand', {command: command, ui: ui, value: value});
					return true;
				}
	
				// Plugin commands
				each(editor.plugins, function(p) {
					if (p.execCommand && p.execCommand(command, ui, value)) {
						editor.fire('ExecCommand', {command: command, ui: ui, value: value});
						state = true;
						return false;
					}
				});
	
				if (state) {
					return state;
				}
	
				// Theme commands
				if (editor.theme && editor.theme.execCommand && editor.theme.execCommand(command, ui, value)) {
					editor.fire('ExecCommand', {command: command, ui: ui, value: value});
					return true;
				}
	
				// Browser commands
				try {
					state = editor.getDoc().execCommand(command, ui, value);
				} catch (ex) {
					// Ignore old IE errors
				}
	
				if (state) {
					editor.fire('ExecCommand', {command: command, ui: ui, value: value});
					return true;
				}
	
				return false;
			}
	
			/**
			 * Queries the current state for a command for example if the current selection is "bold".
			 *
			 * @method queryCommandState
			 * @param {String} command Command to check the state of.
			 * @return {Boolean/Number} true/false if the selected contents is bold or not, -1 if it's not found.
			 */
			function queryCommandState(command) {
				var func;
	
				// Is hidden then return undefined
				if (editor.quirks.isHidden()) {
					return;
				}
	
				command = command.toLowerCase();
				if ((func = commands.state[command])) {
					return func(command);
				}
	
				// Browser commands
				try {
					return editor.getDoc().queryCommandState(command);
				} catch (ex) {
					// Fails sometimes see bug: 1896577
				}
	
				return false;
			}
	
			/**
			 * Queries the command value for example the current fontsize.
			 *
			 * @method queryCommandValue
			 * @param {String} command Command to check the value of.
			 * @return {Object} Command value of false if it's not found.
			 */
			function queryCommandValue(command) {
				var func;
	
				// Is hidden then return undefined
				if (editor.quirks.isHidden()) {
					return;
				}
	
				command = command.toLowerCase();
				if ((func = commands.value[command])) {
					return func(command);
				}
	
				// Browser commands
				try {
					return editor.getDoc().queryCommandValue(command);
				} catch (ex) {
					// Fails sometimes see bug: 1896577
				}
			}
	
			/**
			 * Adds commands to the command collection.
			 *
			 * @method addCommands
			 * @param {Object} command_list Name/value collection with commands to add, the names can also be comma separated.
			 * @param {String} type Optional type to add, defaults to exec. Can be value or state as well.
			 */
			function addCommands(command_list, type) {
				type = type || 'exec';
	
				each(command_list, function(callback, command) {
					each(command.toLowerCase().split(','), function(command) {
						commands[type][command] = callback;
					});
				});
			}
	
			function addCommand(command, callback, scope) {
				command = command.toLowerCase();
				commands.exec[command] = function(command, ui, value, args) {
					return callback.call(scope || editor, ui, value, args);
				};
			}
	
			/**
			 * Returns true/false if the command is supported or not.
			 *
			 * @method queryCommandSupported
			 * @param {String} command Command that we check support for.
			 * @return {Boolean} true/false if the command is supported or not.
			 */
			function queryCommandSupported(command) {
				command = command.toLowerCase();
	
				if (commands.exec[command]) {
					return true;
				}
	
				// Browser commands
				try {
					return editor.getDoc().queryCommandSupported(command);
				} catch (ex) {
					// Fails sometimes see bug: 1896577
				}
	
				return false;
			}
	
			function addQueryStateHandler(command, callback, scope) {
				command = command.toLowerCase();
				commands.state[command] = function() {
					return callback.call(scope || editor);
				};
			}
	
			function addQueryValueHandler(command, callback, scope) {
				command = command.toLowerCase();
				commands.value[command] = function() {
					return callback.call(scope || editor);
				};
			}
	
			function hasCustomCommand(command) {
				command = command.toLowerCase();
				return !!commands.exec[command];
			}
	
			// Expose public methods
			extend(this, {
				execCommand: execCommand,
				queryCommandState: queryCommandState,
				queryCommandValue: queryCommandValue,
				queryCommandSupported: queryCommandSupported,
				addCommands: addCommands,
				addCommand: addCommand,
				addQueryStateHandler: addQueryStateHandler,
				addQueryValueHandler: addQueryValueHandler,
				hasCustomCommand: hasCustomCommand
			});
	
			// Private methods
	
			function execNativeCommand(command, ui, value) {
				if (ui === undefined) {
					ui = FALSE;
				}
	
				if (value === undefined) {
					value = null;
				}
	
				return editor.getDoc().execCommand(command, ui, value);
			}
	
			function isFormatMatch(name) {
				return formatter.match(name);
			}
	
			function toggleFormat(name, value) {
				formatter.toggle(name, value ? {value: value} : undefined);
				editor.nodeChanged();
			}
	
			function storeSelection(type) {
				bookmark = selection.getBookmark(type);
			}
	
			function restoreSelection() {
				selection.moveToBookmark(bookmark);
			}
	
			// Add execCommand overrides
			addCommands({
				// Ignore these, added for compatibility
				'mceResetDesignMode,mceBeginUndoLevel': function() {},
	
				// Add undo manager logic
				'mceEndUndoLevel,mceAddUndoLevel': function() {
					editor.undoManager.add();
				},
	
				'Cut,Copy,Paste': function(command) {
					var doc = editor.getDoc(), failed;
	
					// Try executing the native command
					try {
						execNativeCommand(command);
					} catch (ex) {
						// Command failed
						failed = TRUE;
					}
	
					// Chrome reports the paste command as supported however older IE:s will return false for cut/paste
					if (command === 'paste' && !doc.queryCommandEnabled(command)) {
						failed = true;
					}
	
					// Present alert message about clipboard access not being available
					if (failed || !doc.queryCommandSupported(command)) {
						var msg = editor.translate(
							"Your browser doesn't support direct access to the clipboard. " +
							"Please use the Ctrl+X/C/V keyboard shortcuts instead."
						);
	
						if (Env.mac) {
							msg = msg.replace(/Ctrl\+/g, '\u2318+');
						}
	
						editor.notificationManager.open({text: msg, type: 'error'});
					}
				},
	
				// Override unlink command
				unlink: function() {
					if (selection.isCollapsed()) {
						var elm = selection.getNode();
						if (elm.tagName == 'A') {
							editor.dom.remove(elm, true);
						}
	
						return;
					}
	
					formatter.remove("link");
				},
	
				// Override justify commands to use the text formatter engine
				'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function(command) {
					var align = command.substring(7);
	
					if (align == 'full') {
						align = 'justify';
					}
	
					// Remove all other alignments first
					each('left,center,right,justify'.split(','), function(name) {
						if (align != name) {
							formatter.remove('align' + name);
						}
					});
	
					if (align != 'none') {
						toggleFormat('align' + align);
					}
				},
	
				// Override list commands to fix WebKit bug
				'InsertUnorderedList,InsertOrderedList': function(command) {
					var listElm, listParent;
	
					execNativeCommand(command);
	
					// WebKit produces lists within block elements so we need to split them
					// we will replace the native list creation logic to custom logic later on
					// TODO: Remove this when the list creation logic is removed
					listElm = dom.getParent(selection.getNode(), 'ol,ul');
					if (listElm) {
						listParent = listElm.parentNode;
	
						// If list is within a text block then split that block
						if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
							storeSelection();
							dom.split(listParent, listElm);
							restoreSelection();
						}
					}
				},
	
				// Override commands to use the text formatter engine
				'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function(command) {
					toggleFormat(command);
				},
	
				// Override commands to use the text formatter engine
				'ForeColor,HiliteColor,FontName': function(command, ui, value) {
					toggleFormat(command, value);
				},
	
				FontSize: function(command, ui, value) {
					var fontClasses, fontSizes;
	
					// Convert font size 1-7 to styles
					if (value >= 1 && value <= 7) {
						fontSizes = explode(settings.font_size_style_values);
						fontClasses = explode(settings.font_size_classes);
	
						if (fontClasses) {
							value = fontClasses[value - 1] || value;
						} else {
							value = fontSizes[value - 1] || value;
						}
					}
	
					toggleFormat(command, value);
				},
	
				RemoveFormat: function(command) {
					formatter.remove(command);
				},
	
				mceBlockQuote: function() {
					toggleFormat('blockquote');
				},
	
				FormatBlock: function(command, ui, value) {
					return toggleFormat(value || 'p');
				},
	
				mceCleanup: function() {
					var bookmark = selection.getBookmark();
	
					editor.setContent(editor.getContent({cleanup: TRUE}), {cleanup: TRUE});
	
					selection.moveToBookmark(bookmark);
				},
	
				mceRemoveNode: function(command, ui, value) {
					var node = value || selection.getNode();
	
					// Make sure that the body node isn't removed
					if (node != editor.getBody()) {
						storeSelection();
						editor.dom.remove(node, TRUE);
						restoreSelection();
					}
				},
	
				mceSelectNodeDepth: function(command, ui, value) {
					var counter = 0;
	
					dom.getParent(selection.getNode(), function(node) {
						if (node.nodeType == 1 && counter++ == value) {
							selection.select(node);
							return FALSE;
						}
					}, editor.getBody());
				},
	
				mceSelectNode: function(command, ui, value) {
					selection.select(value);
				},
	
				mceInsertContent: function(command, ui, value) {
					InsertContent.insertAtCaret(editor, value);
				},
	
				mceInsertRawHTML: function(command, ui, value) {
					selection.setContent('tiny_mce_marker');
					editor.setContent(
						editor.getContent().replace(/tiny_mce_marker/g, function() {
							return value;
						})
					);
				},
	
				mceToggleFormat: function(command, ui, value) {
					toggleFormat(value);
				},
	
				mceSetContent: function(command, ui, value) {
					editor.setContent(value);
				},
	
				'Indent,Outdent': function(command) {
					var intentValue, indentUnit, value;
	
					// Setup indent level
					intentValue = settings.indentation;
					indentUnit = /[a-z%]+$/i.exec(intentValue);
					intentValue = parseInt(intentValue, 10);
	
					if (!queryCommandState('InsertUnorderedList') && !queryCommandState('InsertOrderedList')) {
						// If forced_root_blocks is set to false we don't have a block to indent so lets create a div
						if (!settings.forced_root_block && !dom.getParent(selection.getNode(), dom.isBlock)) {
							formatter.apply('div');
						}
	
						each(selection.getSelectedBlocks(), function(element) {
							if (dom.getContentEditable(element) === "false") {
								return;
							}
	
							if (element.nodeName != "LI") {
								var indentStyleName = editor.getParam('indent_use_margin', false) ? 'margin' : 'padding';
	
								indentStyleName += dom.getStyle(element, 'direction', true) == 'rtl' ? 'Right' : 'Left';
	
								if (command == 'outdent') {
									value = Math.max(0, parseInt(element.style[indentStyleName] || 0, 10) - intentValue);
									dom.setStyle(element, indentStyleName, value ? value + indentUnit : '');
								} else {
									value = (parseInt(element.style[indentStyleName] || 0, 10) + intentValue) + indentUnit;
									dom.setStyle(element, indentStyleName, value);
								}
							}
						});
					} else {
						execNativeCommand(command);
					}
				},
	
				mceRepaint: function() {
				},
	
				InsertHorizontalRule: function() {
					editor.execCommand('mceInsertContent', false, '<hr />');
				},
	
				mceToggleVisualAid: function() {
					editor.hasVisual = !editor.hasVisual;
					editor.addVisual();
				},
	
				mceReplaceContent: function(command, ui, value) {
					editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, selection.getContent({format: 'text'})));
				},
	
				mceInsertLink: function(command, ui, value) {
					var anchor;
	
					if (typeof value == 'string') {
						value = {href: value};
					}
	
					anchor = dom.getParent(selection.getNode(), 'a');
	
					// Spaces are never valid in URLs and it's a very common mistake for people to make so we fix it here.
					value.href = value.href.replace(' ', '%20');
	
					// Remove existing links if there could be child links or that the href isn't specified
					if (!anchor || !value.href) {
						formatter.remove('link');
					}
	
					// Apply new link to selection
					if (value.href) {
						formatter.apply('link', value, anchor);
					}
				},
	
				selectAll: function() {
					var root = dom.getRoot(), rng;
	
					if (selection.getRng().setStart) {
						rng = dom.createRng();
						rng.setStart(root, 0);
						rng.setEnd(root, root.childNodes.length);
						selection.setRng(rng);
					} else {
						// IE will render it's own root level block elements and sometimes
						// even put font elements in them when the user starts typing. So we need to
						// move the selection to a more suitable element from this:
						// <body>|<p></p></body> to this: <body><p>|</p></body>
						rng = selection.getRng();
						if (!rng.item) {
							rng.moveToElementText(root);
							rng.select();
						}
					}
				},
	
				"delete": function() {
					execNativeCommand("Delete");
	
					// Check if body is empty after the delete call if so then set the contents
					// to an empty string and move the caret to any block produced by that operation
					// this fixes the issue with root blocks not being properly produced after a delete call on IE
					var body = editor.getBody();
	
					if (dom.isEmpty(body)) {
						editor.setContent('');
	
						if (body.firstChild && dom.isBlock(body.firstChild)) {
							editor.selection.setCursorLocation(body.firstChild, 0);
						} else {
							editor.selection.setCursorLocation(body, 0);
						}
					}
				},
	
				mceNewDocument: function() {
					editor.setContent('');
				},
	
				InsertLineBreak: function(command, ui, value) {
					// We load the current event in from EnterKey.js when appropriate to heed
					// certain event-specific variations such as ctrl-enter in a list
					var evt = value;
					var brElm, extraBr, marker;
					var rng = selection.getRng(true);
					new RangeUtils(dom).normalize(rng);
	
					var offset = rng.startOffset;
					var container = rng.startContainer;
	
					// Resolve node index
					if (container.nodeType == 1 && container.hasChildNodes()) {
						var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	
						container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
						if (isAfterLastNodeInContainer && container.nodeType == 3) {
							offset = container.nodeValue.length;
						} else {
							offset = 0;
						}
					}
	
					var parentBlock = dom.getParent(container, dom.isBlock);
					var parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
					var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
					var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
	
					// Enter inside block contained within a LI then split or insert before/after LI
					var isControlKey = evt && evt.ctrlKey;
					if (containerBlockName == 'LI' && !isControlKey) {
						parentBlock = containerBlock;
						parentBlockName = containerBlockName;
					}
	
					// Walks the parent block to the right and look for BR elements
					function hasRightSideContent() {
						var walker = new TreeWalker(container, parentBlock), node;
						var nonEmptyElementsMap = editor.schema.getNonEmptyElements();
	
						while ((node = walker.next())) {
							if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
								return true;
							}
						}
					}
	
					if (container && container.nodeType == 3 && offset >= container.nodeValue.length) {
						// Insert extra BR element at the end block elements
						if (!isOldIE && !hasRightSideContent()) {
							brElm = dom.create('br');
							rng.insertNode(brElm);
							rng.setStartAfter(brElm);
							rng.setEndAfter(brElm);
							extraBr = true;
						}
					}
	
					brElm = dom.create('br');
					rng.insertNode(brElm);
	
					// Rendering modes below IE8 doesn't display BR elements in PRE unless we have a \n before it
					var documentMode = dom.doc.documentMode;
					if (isOldIE && parentBlockName == 'PRE' && (!documentMode || documentMode < 8)) {
						brElm.parentNode.insertBefore(dom.doc.createTextNode('\r'), brElm);
					}
	
					// Insert temp marker and scroll to that
					marker = dom.create('span', {}, '&nbsp;');
					brElm.parentNode.insertBefore(marker, brElm);
					selection.scrollIntoView(marker);
					dom.remove(marker);
	
					if (!extraBr) {
						rng.setStartAfter(brElm);
						rng.setEndAfter(brElm);
					} else {
						rng.setStartBefore(brElm);
						rng.setEndBefore(brElm);
					}
	
					selection.setRng(rng);
					editor.undoManager.add();
	
					return TRUE;
				}
			});
	
			// Add queryCommandState overrides
			addCommands({
				// Override justify commands
				'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull': function(command) {
					var name = 'align' + command.substring(7);
					var nodes = selection.isCollapsed() ? [dom.getParent(selection.getNode(), dom.isBlock)] : selection.getSelectedBlocks();
					var matches = map(nodes, function(node) {
						return !!formatter.matchNode(node, name);
					});
					return inArray(matches, TRUE) !== -1;
				},
	
				'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function(command) {
					return isFormatMatch(command);
				},
	
				mceBlockQuote: function() {
					return isFormatMatch('blockquote');
				},
	
				Outdent: function() {
					var node;
	
					if (settings.inline_styles) {
						if ((node = dom.getParent(selection.getStart(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
							return TRUE;
						}
	
						if ((node = dom.getParent(selection.getEnd(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
							return TRUE;
						}
					}
	
					return (
						queryCommandState('InsertUnorderedList') ||
						queryCommandState('InsertOrderedList') ||
						(!settings.inline_styles && !!dom.getParent(selection.getNode(), 'BLOCKQUOTE'))
					);
				},
	
				'InsertUnorderedList,InsertOrderedList': function(command) {
					var list = dom.getParent(selection.getNode(), 'ul,ol');
	
					return list &&
						(
							command === 'insertunorderedlist' && list.tagName === 'UL' ||
							command === 'insertorderedlist' && list.tagName === 'OL'
						);
				}
			}, 'state');
	
			// Add queryCommandValue overrides
			addCommands({
				'FontSize,FontName': function(command) {
					var value = 0, parent;
	
					if ((parent = dom.getParent(selection.getNode(), 'span'))) {
						if (command == 'fontsize') {
							value = parent.style.fontSize;
						} else {
							value = parent.style.fontFamily.replace(/, /g, ',').replace(/[\'\"]/g, '').toLowerCase();
						}
					}
	
					return value;
				}
			}, 'value');
	
			// Add undo manager logic
			addCommands({
				Undo: function() {
					editor.undoManager.undo();
				},
	
				Redo: function() {
					editor.undoManager.redo();
				}
			});
		};
	});
	
	// Included from: js/tinymce/classes/util/URI.js
	
	/**
	 * URI.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles parsing, modification and serialization of URI/URL strings.
	 * @class tinymce.util.URI
	 */
	define("tinymce/util/URI", [
		"tinymce/util/Tools"
	], function(Tools) {
		var each = Tools.each, trim = Tools.trim;
		var queryParts = "source protocol authority userInfo user password host port relative path directory file query anchor".split(' ');
		var DEFAULT_PORTS = {
			'ftp': 21,
			'http': 80,
			'https': 443,
			'mailto': 25
		};
	
		/**
		 * Constructs a new URI instance.
		 *
		 * @constructor
		 * @method URI
		 * @param {String} url URI string to parse.
		 * @param {Object} settings Optional settings object.
		 */
		function URI(url, settings) {
			var self = this, baseUri, base_url;
	
			url = trim(url);
			settings = self.settings = settings || {};
			baseUri = settings.base_uri;
	
			// Strange app protocol that isn't http/https or local anchor
			// For example: mailto,skype,tel etc.
			if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
				self.source = url;
				return;
			}
	
			var isProtocolRelative = url.indexOf('//') === 0;
	
			// Absolute path with no host, fake host and protocol
			if (url.indexOf('/') === 0 && !isProtocolRelative) {
				url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
			}
	
			// Relative path http:// or protocol relative //path
			if (!/^[\w\-]*:?\/\//.test(url)) {
				base_url = settings.base_uri ? settings.base_uri.path : new URI(location.href).directory;
				if (settings.base_uri.protocol === "") {
					url = '//mce_host' + self.toAbsPath(base_url, url);
				} else {
					url = /([^#?]*)([#?]?.*)/.exec(url);
					url = ((baseUri && baseUri.protocol) || 'http') + '://mce_host' + self.toAbsPath(base_url, url[1]) + url[2];
				}
			}
	
			// Parse URL (Credits goes to Steave, http://blog.stevenlevithan.com/archives/parseuri)
			url = url.replace(/@@/g, '(mce_at)'); // Zope 3 workaround, they use @@something
	
			/*jshint maxlen: 255 */
			/*eslint max-len: 0 */
			url = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	
			each(queryParts, function(v, i) {
				var part = url[i];
	
				// Zope 3 workaround, they use @@something
				if (part) {
					part = part.replace(/\(mce_at\)/g, '@@');
				}
	
				self[v] = part;
			});
	
			if (baseUri) {
				if (!self.protocol) {
					self.protocol = baseUri.protocol;
				}
	
				if (!self.userInfo) {
					self.userInfo = baseUri.userInfo;
				}
	
				if (!self.port && self.host === 'mce_host') {
					self.port = baseUri.port;
				}
	
				if (!self.host || self.host === 'mce_host') {
					self.host = baseUri.host;
				}
	
				self.source = '';
			}
	
			if (isProtocolRelative) {
				self.protocol = '';
			}
	
			//t.path = t.path || '/';
		}
	
		URI.prototype = {
			/**
			 * Sets the internal path part of the URI.
			 *
			 * @method setPath
			 * @param {string} path Path string to set.
			 */
			setPath: function(path) {
				var self = this;
	
				path = /^(.*?)\/?(\w+)?$/.exec(path);
	
				// Update path parts
				self.path = path[0];
				self.directory = path[1];
				self.file = path[2];
	
				// Rebuild source
				self.source = '';
				self.getURI();
			},
	
			/**
			 * Converts the specified URI into a relative URI based on the current URI instance location.
			 *
			 * @method toRelative
			 * @param {String} uri URI to convert into a relative path/URI.
			 * @return {String} Relative URI from the point specified in the current URI instance.
			 * @example
			 * // Converts an absolute URL to an relative URL url will be somedir/somefile.htm
			 * var url = new tinymce.util.URI('http://www.site.com/dir/').toRelative('http://www.site.com/dir/somedir/somefile.htm');
			 */
			toRelative: function(uri) {
				var self = this, output;
	
				if (uri === "./") {
					return uri;
				}
	
				uri = new URI(uri, {base_uri: self});
	
				// Not on same domain/port or protocol
				if ((uri.host != 'mce_host' && self.host != uri.host && uri.host) || self.port != uri.port ||
					(self.protocol != uri.protocol && uri.protocol !== "")) {
					return uri.getURI();
				}
	
				var tu = self.getURI(), uu = uri.getURI();
	
				// Allow usage of the base_uri when relative_urls = true
				if (tu == uu || (tu.charAt(tu.length - 1) == "/" && tu.substr(0, tu.length - 1) == uu)) {
					return tu;
				}
	
				output = self.toRelPath(self.path, uri.path);
	
				// Add query
				if (uri.query) {
					output += '?' + uri.query;
				}
	
				// Add anchor
				if (uri.anchor) {
					output += '#' + uri.anchor;
				}
	
				return output;
			},
	
			/**
			 * Converts the specified URI into a absolute URI based on the current URI instance location.
			 *
			 * @method toAbsolute
			 * @param {String} uri URI to convert into a relative path/URI.
			 * @param {Boolean} noHost No host and protocol prefix.
			 * @return {String} Absolute URI from the point specified in the current URI instance.
			 * @example
			 * // Converts an relative URL to an absolute URL url will be http://www.site.com/dir/somedir/somefile.htm
			 * var url = new tinymce.util.URI('http://www.site.com/dir/').toAbsolute('somedir/somefile.htm');
			 */
			toAbsolute: function(uri, noHost) {
				uri = new URI(uri, {base_uri: this});
	
				return uri.getURI(noHost && this.isSameOrigin(uri));
			},
	
			/**
			 * Determine whether the given URI has the same origin as this URI.  Based on RFC-6454.
			 * Supports default ports for protocols listed in DEFAULT_PORTS.  Unsupported protocols will fail safe: they
			 * won't match, if the port specifications differ.
			 *
			 * @method isSameOrigin
			 * @param {tinymce.util.URI} uri Uri instance to compare.
			 * @returns {Boolean} True if the origins are the same.
			 */
			isSameOrigin: function(uri) {
				if (this.host == uri.host && this.protocol == uri.protocol) {
					if (this.port == uri.port) {
						return true;
					}
	
					var defaultPort = DEFAULT_PORTS[this.protocol];
					if (defaultPort && ((this.port || defaultPort) == (uri.port || defaultPort))) {
						return true;
					}
				}
	
				return false;
			},
	
			/**
			 * Converts a absolute path into a relative path.
			 *
			 * @method toRelPath
			 * @param {String} base Base point to convert the path from.
			 * @param {String} path Absolute path to convert into a relative path.
			 */
			toRelPath: function(base, path) {
				var items, breakPoint = 0, out = '', i, l;
	
				// Split the paths
				base = base.substring(0, base.lastIndexOf('/'));
				base = base.split('/');
				items = path.split('/');
	
				if (base.length >= items.length) {
					for (i = 0, l = base.length; i < l; i++) {
						if (i >= items.length || base[i] != items[i]) {
							breakPoint = i + 1;
							break;
						}
					}
				}
	
				if (base.length < items.length) {
					for (i = 0, l = items.length; i < l; i++) {
						if (i >= base.length || base[i] != items[i]) {
							breakPoint = i + 1;
							break;
						}
					}
				}
	
				if (breakPoint === 1) {
					return path;
				}
	
				for (i = 0, l = base.length - (breakPoint - 1); i < l; i++) {
					out += "../";
				}
	
				for (i = breakPoint - 1, l = items.length; i < l; i++) {
					if (i != breakPoint - 1) {
						out += "/" + items[i];
					} else {
						out += items[i];
					}
				}
	
				return out;
			},
	
			/**
			 * Converts a relative path into a absolute path.
			 *
			 * @method toAbsPath
			 * @param {String} base Base point to convert the path from.
			 * @param {String} path Relative path to convert into an absolute path.
			 */
			toAbsPath: function(base, path) {
				var i, nb = 0, o = [], tr, outPath;
	
				// Split paths
				tr = /\/$/.test(path) ? '/' : '';
				base = base.split('/');
				path = path.split('/');
	
				// Remove empty chunks
				each(base, function(k) {
					if (k) {
						o.push(k);
					}
				});
	
				base = o;
	
				// Merge relURLParts chunks
				for (i = path.length - 1, o = []; i >= 0; i--) {
					// Ignore empty or .
					if (path[i].length === 0 || path[i] === ".") {
						continue;
					}
	
					// Is parent
					if (path[i] === '..') {
						nb++;
						continue;
					}
	
					// Move up
					if (nb > 0) {
						nb--;
						continue;
					}
	
					o.push(path[i]);
				}
	
				i = base.length - nb;
	
				// If /a/b/c or /
				if (i <= 0) {
					outPath = o.reverse().join('/');
				} else {
					outPath = base.slice(0, i).join('/') + '/' + o.reverse().join('/');
				}
	
				// Add front / if it's needed
				if (outPath.indexOf('/') !== 0) {
					outPath = '/' + outPath;
				}
	
				// Add traling / if it's needed
				if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
					outPath += tr;
				}
	
				return outPath;
			},
	
			/**
			 * Returns the full URI of the internal structure.
			 *
			 * @method getURI
			 * @param {Boolean} noProtoHost Optional no host and protocol part. Defaults to false.
			 */
			getURI: function(noProtoHost) {
				var s, self = this;
	
				// Rebuild source
				if (!self.source || noProtoHost) {
					s = '';
	
					if (!noProtoHost) {
						if (self.protocol) {
							s += self.protocol + '://';
						} else {
							s += '//';
						}
	
						if (self.userInfo) {
							s += self.userInfo + '@';
						}
	
						if (self.host) {
							s += self.host;
						}
	
						if (self.port) {
							s += ':' + self.port;
						}
					}
	
					if (self.path) {
						s += self.path;
					}
	
					if (self.query) {
						s += '?' + self.query;
					}
	
					if (self.anchor) {
						s += '#' + self.anchor;
					}
	
					self.source = s;
				}
	
				return self.source;
			}
		};
	
		URI.parseDataUri = function(uri) {
			var type, matches;
	
			uri = decodeURIComponent(uri).split(',');
	
			matches = /data:([^;]+)/.exec(uri[0]);
			if (matches) {
				type = matches[1];
			}
	
			return {
				type: type,
				data: uri[1]
			};
		};
	
		URI.getDocumentBaseUrl = function(loc) {
			var baseUrl;
	
			// Pass applewebdata:// and other non web protocols though
			if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
				baseUrl = loc.href;
			} else {
				baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
			}
	
			if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
				baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	
				if (!/[\/\\]$/.test(baseUrl)) {
					baseUrl += '/';
				}
			}
	
			return baseUrl;
		};
	
		return URI;
	});
	
	// Included from: js/tinymce/classes/util/Class.js
	
	/**
	 * Class.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This utilitiy class is used for easier inheritance.
	 *
	 * Features:
	 * * Exposed super functions: this._super();
	 * * Mixins
	 * * Dummy functions
	 * * Property functions: var value = object.value(); and object.value(newValue);
	 * * Static functions
	 * * Defaults settings
	 */
	define("tinymce/util/Class", [
		"tinymce/util/Tools"
	], function(Tools) {
		var each = Tools.each, extend = Tools.extend;
	
		var extendClass, initializing;
	
		function Class() {
		}
	
		// Provides classical inheritance, based on code made by John Resig
		Class.extend = extendClass = function(prop) {
			var self = this, _super = self.prototype, prototype, name, member;
	
			// The dummy class constructor
			function Class() {
				var i, mixins, mixin, self = this;
	
				// All construction is actually done in the init method
				if (!initializing) {
					// Run class constuctor
					if (self.init) {
						self.init.apply(self, arguments);
					}
	
					// Run mixin constructors
					mixins = self.Mixins;
					if (mixins) {
						i = mixins.length;
						while (i--) {
							mixin = mixins[i];
							if (mixin.init) {
								mixin.init.apply(self, arguments);
							}
						}
					}
				}
			}
	
			// Dummy function, needs to be extended in order to provide functionality
			function dummy() {
				return this;
			}
	
			// Creates a overloaded method for the class
			// this enables you to use this._super(); to call the super function
			function createMethod(name, fn) {
				return function() {
					var self = this, tmp = self._super, ret;
	
					self._super = _super[name];
					ret = fn.apply(self, arguments);
					self._super = tmp;
	
					return ret;
				};
			}
	
			// Instantiate a base class (but only create the instance,
			// don't run the init constructor)
			initializing = true;
	
			/*eslint new-cap:0 */
			prototype = new self();
			initializing = false;
	
			// Add mixins
			if (prop.Mixins) {
				each(prop.Mixins, function(mixin) {
					for (var name in mixin) {
						if (name !== "init") {
							prop[name] = mixin[name];
						}
					}
				});
	
				if (_super.Mixins) {
					prop.Mixins = _super.Mixins.concat(prop.Mixins);
				}
			}
	
			// Generate dummy methods
			if (prop.Methods) {
				each(prop.Methods.split(','), function(name) {
					prop[name] = dummy;
				});
			}
	
			// Generate property methods
			if (prop.Properties) {
				each(prop.Properties.split(','), function(name) {
					var fieldName = '_' + name;
	
					prop[name] = function(value) {
						var self = this, undef;
	
						// Set value
						if (value !== undef) {
							self[fieldName] = value;
	
							return self;
						}
	
						// Get value
						return self[fieldName];
					};
				});
			}
	
			// Static functions
			if (prop.Statics) {
				each(prop.Statics, function(func, name) {
					Class[name] = func;
				});
			}
	
			// Default settings
			if (prop.Defaults && _super.Defaults) {
				prop.Defaults = extend({}, _super.Defaults, prop.Defaults);
			}
	
			// Copy the properties over onto the new prototype
			for (name in prop) {
				member = prop[name];
	
				if (typeof member == "function" && _super[name]) {
					prototype[name] = createMethod(name, member);
				} else {
					prototype[name] = member;
				}
			}
	
			// Populate our constructed prototype object
			Class.prototype = prototype;
	
			// Enforce the constructor to be what we expect
			Class.constructor = Class;
	
			// And make this class extendible
			Class.extend = extendClass;
	
			return Class;
		};
	
		return Class;
	});
	
	// Included from: js/tinymce/classes/util/EventDispatcher.js
	
	/**
	 * EventDispatcher.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class lets you add/remove and fire events by name on the specified scope. This makes
	 * it easy to add event listener logic to any class.
	 *
	 * @class tinymce.util.EventDispatcher
	 * @example
	 *  var eventDispatcher = new EventDispatcher();
	 *
	 *  eventDispatcher.on('click', function() {console.log('data');});
	 *  eventDispatcher.fire('click', {data: 123});
	 */
	define("tinymce/util/EventDispatcher", [
		"tinymce/util/Tools"
	], function(Tools) {
		var nativeEvents = Tools.makeMap(
			"focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange " +
			"mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover " +
			"draggesture dragdrop drop drag submit " +
			"compositionstart compositionend compositionupdate touchstart touchmove touchend",
			' '
		);
	
		function Dispatcher(settings) {
			var self = this, scope, bindings = {}, toggleEvent;
	
			function returnFalse() {
				return false;
			}
	
			function returnTrue() {
				return true;
			}
	
			settings = settings || {};
			scope = settings.scope || self;
			toggleEvent = settings.toggleEvent || returnFalse;
	
			/**
			 * Fires the specified event by name.
			 *
			 * @method fire
			 * @param {String} name Name of the event to fire.
			 * @param {Object?} args Event arguments.
			 * @return {Object} Event args instance passed in.
			 * @example
			 * instance.fire('event', {...});
			 */
			function fire(name, args) {
				var handlers, i, l, callback;
	
				name = name.toLowerCase();
				args = args || {};
				args.type = name;
	
				// Setup target is there isn't one
				if (!args.target) {
					args.target = scope;
				}
	
				// Add event delegation methods if they are missing
				if (!args.preventDefault) {
					// Add preventDefault method
					args.preventDefault = function() {
						args.isDefaultPrevented = returnTrue;
					};
	
					// Add stopPropagation
					args.stopPropagation = function() {
						args.isPropagationStopped = returnTrue;
					};
	
					// Add stopImmediatePropagation
					args.stopImmediatePropagation = function() {
						args.isImmediatePropagationStopped = returnTrue;
					};
	
					// Add event delegation states
					args.isDefaultPrevented = returnFalse;
					args.isPropagationStopped = returnFalse;
					args.isImmediatePropagationStopped = returnFalse;
				}
	
				if (settings.beforeFire) {
					settings.beforeFire(args);
				}
	
				handlers = bindings[name];
				if (handlers) {
					for (i = 0, l = handlers.length; i < l; i++) {
						callback = handlers[i];
	
						// Unbind handlers marked with "once"
						if (callback.once) {
							off(name, callback.func);
						}
	
						// Stop immediate propagation if needed
						if (args.isImmediatePropagationStopped()) {
							args.stopPropagation();
							return args;
						}
	
						// If callback returns false then prevent default and stop all propagation
						if (callback.func.call(scope, args) === false) {
							args.preventDefault();
							return args;
						}
					}
				}
	
				return args;
			}
	
			/**
			 * Binds an event listener to a specific event by name.
			 *
			 * @method on
			 * @param {String} name Event name or space separated list of events to bind.
			 * @param {callback} callback Callback to be executed when the event occurs.
			 * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
			 * @return {Object} Current class instance.
			 * @example
			 * instance.on('event', function(e) {
			 *     // Callback logic
			 * });
			 */
			function on(name, callback, prepend, extra) {
				var handlers, names, i;
	
				if (callback === false) {
					callback = returnFalse;
				}
	
				if (callback) {
					callback = {
						func: callback
					};
	
					if (extra) {
						Tools.extend(callback, extra);
					}
	
					names = name.toLowerCase().split(' ');
					i = names.length;
					while (i--) {
						name = names[i];
						handlers = bindings[name];
						if (!handlers) {
							handlers = bindings[name] = [];
							toggleEvent(name, true);
						}
	
						if (prepend) {
							handlers.unshift(callback);
						} else {
							handlers.push(callback);
						}
					}
				}
	
				return self;
			}
	
			/**
			 * Unbinds an event listener to a specific event by name.
			 *
			 * @method off
			 * @param {String?} name Name of the event to unbind.
			 * @param {callback?} callback Callback to unbind.
			 * @return {Object} Current class instance.
			 * @example
			 * // Unbind specific callback
			 * instance.off('event', handler);
			 *
			 * // Unbind all listeners by name
			 * instance.off('event');
			 *
			 * // Unbind all events
			 * instance.off();
			 */
			function off(name, callback) {
				var i, handlers, bindingName, names, hi;
	
				if (name) {
					names = name.toLowerCase().split(' ');
					i = names.length;
					while (i--) {
						name = names[i];
						handlers = bindings[name];
	
						// Unbind all handlers
						if (!name) {
							for (bindingName in bindings) {
								toggleEvent(bindingName, false);
								delete bindings[bindingName];
							}
	
							return self;
						}
	
						if (handlers) {
							// Unbind all by name
							if (!callback) {
								handlers.length = 0;
							} else {
								// Unbind specific ones
								hi = handlers.length;
								while (hi--) {
									if (handlers[hi].func === callback) {
										handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
										bindings[name] = handlers;
									}
								}
							}
	
							if (!handlers.length) {
								toggleEvent(name, false);
								delete bindings[name];
							}
						}
					}
				} else {
					for (name in bindings) {
						toggleEvent(name, false);
					}
	
					bindings = {};
				}
	
				return self;
			}
	
			/**
			 * Binds an event listener to a specific event by name
			 * and automatically unbind the event once the callback fires.
			 *
			 * @method once
			 * @param {String} name Event name or space separated list of events to bind.
			 * @param {callback} callback Callback to be executed when the event occurs.
			 * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
			 * @return {Object} Current class instance.
			 * @example
			 * instance.once('event', function(e) {
			 *     // Callback logic
			 * });
			 */
			function once(name, callback, prepend) {
				return on(name, callback, prepend, {once: true});
			}
	
			/**
			 * Returns true/false if the dispatcher has a event of the specified name.
			 *
			 * @method has
			 * @param {String} name Name of the event to check for.
			 * @return {Boolean} true/false if the event exists or not.
			 */
			function has(name) {
				name = name.toLowerCase();
				return !(!bindings[name] || bindings[name].length === 0);
			}
	
			// Expose
			self.fire = fire;
			self.on = on;
			self.off = off;
			self.once = once;
			self.has = has;
		}
	
		/**
		 * Returns true/false if the specified event name is a native browser event or not.
		 *
		 * @method isNative
		 * @param {String} name Name to check if it's native.
		 * @return {Boolean} true/false if the event is native or not.
		 * @static
		 */
		Dispatcher.isNative = function(name) {
			return !!nativeEvents[name.toLowerCase()];
		};
	
		return Dispatcher;
	});
	
	// Included from: js/tinymce/classes/data/Binding.js
	
	/**
	 * Binding.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class gets dynamically extended to provide a binding between two models. This makes it possible to
	 * sync the state of two properties in two models by a layer of abstraction.
	 *
	 * @private
	 * @class tinymce.data.Binding
	 */
	define("tinymce/data/Binding", [], function() {
		/**
		 * Constructs a new bidning.
		 *
		 * @constructor
		 * @method Binding
		 * @param {Object} settings Settings to the binding.
		 */
		function Binding(settings) {
			this.create = settings.create;
		}
	
		/**
		 * Creates a binding for a property on a model.
		 *
		 * @method create
		 * @param {tinymce.data.ObservableObject} model Model to create binding to.
		 * @param {String} name Name of property to bind.
		 * @return {tinymce.data.Binding} Binding instance.
		 */
		Binding.create = function(model, name) {
			return new Binding({
				create: function(otherModel, otherName) {
					var bindings;
	
					function fromSelfToOther(e) {
						otherModel.set(otherName, e.value);
					}
	
					function fromOtherToSelf(e) {
						model.set(name, e.value);
					}
	
					otherModel.on('change:' + otherName, fromOtherToSelf);
					model.on('change:' + name, fromSelfToOther);
	
					// Keep track of the bindings
					bindings = otherModel._bindings;
	
					if (!bindings) {
						bindings = otherModel._bindings = [];
	
						otherModel.on('destroy', function() {
							var i = bindings.length;
	
							while (i--) {
								bindings[i]();
							}
						});
					}
	
					bindings.push(function() {
						model.off('change:' + name, fromSelfToOther);
					});
	
					return model.get(name);
				}
			});
		};
	
		return Binding;
	});
	
	// Included from: js/tinymce/classes/util/Observable.js
	
	/**
	 * Observable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin will add event binding logic to classes.
	 *
	 * @mixin tinymce.util.Observable
	 */
	define("tinymce/util/Observable", [
		"tinymce/util/EventDispatcher"
	], function(EventDispatcher) {
		function getEventDispatcher(obj) {
			if (!obj._eventDispatcher) {
				obj._eventDispatcher = new EventDispatcher({
					scope: obj,
					toggleEvent: function(name, state) {
						if (EventDispatcher.isNative(name) && obj.toggleNativeEvent) {
							obj.toggleNativeEvent(name, state);
						}
					}
				});
			}
	
			return obj._eventDispatcher;
		}
	
		return {
			/**
			 * Fires the specified event by name.
			 *
			 * @method fire
			 * @param {String} name Name of the event to fire.
			 * @param {Object?} args Event arguments.
			 * @param {Boolean?} bubble True/false if the event is to be bubbled.
			 * @return {Object} Event args instance passed in.
			 * @example
			 * instance.fire('event', {...});
			 */
			fire: function(name, args, bubble) {
				var self = this;
	
				// Prevent all events except the remove event after the instance has been removed
				if (self.removed && name !== "remove") {
					return args;
				}
	
				args = getEventDispatcher(self).fire(name, args, bubble);
	
				// Bubble event up to parents
				if (bubble !== false && self.parent) {
					var parent = self.parent();
					while (parent && !args.isPropagationStopped()) {
						parent.fire(name, args, false);
						parent = parent.parent();
					}
				}
	
				return args;
			},
	
			/**
			 * Binds an event listener to a specific event by name.
			 *
			 * @method on
			 * @param {String} name Event name or space separated list of events to bind.
			 * @param {callback} callback Callback to be executed when the event occurs.
			 * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
			 * @return {Object} Current class instance.
			 * @example
			 * instance.on('event', function(e) {
			 *     // Callback logic
			 * });
			 */
			on: function(name, callback, prepend) {
				return getEventDispatcher(this).on(name, callback, prepend);
			},
	
			/**
			 * Unbinds an event listener to a specific event by name.
			 *
			 * @method off
			 * @param {String?} name Name of the event to unbind.
			 * @param {callback?} callback Callback to unbind.
			 * @return {Object} Current class instance.
			 * @example
			 * // Unbind specific callback
			 * instance.off('event', handler);
			 *
			 * // Unbind all listeners by name
			 * instance.off('event');
			 *
			 * // Unbind all events
			 * instance.off();
			 */
			off: function(name, callback) {
				return getEventDispatcher(this).off(name, callback);
			},
	
			/**
			 * Bind the event callback and once it fires the callback is removed.
			 *
			 * @method once
			 * @param {String} name Name of the event to bind.
			 * @param {callback} callback Callback to bind only once.
			 * @return {Object} Current class instance.
			 */
			once: function(name, callback) {
				return getEventDispatcher(this).once(name, callback);
			},
	
			/**
			 * Returns true/false if the object has a event of the specified name.
			 *
			 * @method hasEventListeners
			 * @param {String} name Name of the event to check for.
			 * @return {Boolean} true/false if the event exists or not.
			 */
			hasEventListeners: function(name) {
				return getEventDispatcher(this).has(name);
			}
		};
	});
	
	// Included from: js/tinymce/classes/data/ObservableObject.js
	
	/**
	 * ObservableObject.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a object that is observable when properties changes a change event gets emitted.
	 *
	 * @private
	 * @class tinymce.data.ObservableObject
	 */
	define("tinymce/data/ObservableObject", [
		"tinymce/data/Binding",
		"tinymce/util/Observable",
		"tinymce/util/Class",
		"tinymce/util/Tools"
	], function(Binding, Observable, Class, Tools) {
		function isNode(node) {
			return node.nodeType > 0;
		}
	
		// Todo: Maybe this should be shallow compare since it might be huge object references
		function isEqual(a, b) {
			var k, checked;
	
			// Strict equals
			if (a === b) {
				return true;
			}
	
			// Compare null
			if (a === null || b === null) {
				return a === b;
			}
	
			// Compare number, boolean, string, undefined
			if (typeof a !== "object" || typeof b !== "object") {
				return a === b;
			}
	
			// Compare arrays
			if (Tools.isArray(b)) {
				if (a.length !== b.length) {
					return false;
				}
	
				k = a.length;
				while (k--) {
					if (!isEqual(a[k], b[k])) {
						return false;
					}
				}
			}
	
			// Shallow compare nodes
			if (isNode(a) || isNode(b)) {
				return a === b;
			}
	
			// Compare objects
			checked = {};
			for (k in b) {
				if (!isEqual(a[k], b[k])) {
					return false;
				}
	
				checked[k] = true;
			}
	
			for (k in a) {
				if (!checked[k] && !isEqual(a[k], b[k])) {
					return false;
				}
			}
	
			return true;
		}
	
		return Class.extend({
			Mixins: [Observable],
	
			/**
			 * Constructs a new observable object instance.
			 *
			 * @constructor
			 * @param {Object} data Initial data for the object.
			 */
			init: function(data) {
				var name, value;
	
				data = data || {};
	
				for (name in data) {
					value = data[name];
	
					if (value instanceof Binding) {
						data[name] = value.create(this, name);
					}
				}
	
				this.data = data;
			},
	
			/**
			 * Sets a property on the value this will call
			 * observers if the value is a change from the current value.
			 *
			 * @method set
			 * @param {String/object} name Name of the property to set or a object of items to set.
			 * @param {Object} value Value to set for the property.
			 * @return {tinymce.data.ObservableObject} Observable object instance.
			 */
			set: function(name, value) {
				var key, args, oldValue = this.data[name];
	
				if (value instanceof Binding) {
					value = value.create(this, name);
				}
	
				if (typeof name === "object") {
					for (key in name) {
						this.set(key, name[key]);
					}
	
					return this;
				}
	
				if (!isEqual(oldValue, value)) {
					this.data[name] = value;
	
					args = {
						target: this,
						name: name,
						value: value,
						oldValue: oldValue
					};
	
					this.fire('change:' + name, args);
					this.fire('change', args);
				}
	
				return this;
			},
	
			/**
			 * Gets a property by name.
			 *
			 * @method get
			 * @param {String} name Name of the property to get.
			 * @return {Object} Object value of propery.
			 */
			get: function(name) {
				return this.data[name];
			},
	
			/**
			 * Returns true/false if the specified property exists.
			 *
			 * @method has
			 * @param {String} name Name of the property to check for.
			 * @return {Boolean} true/false if the item exists.
			 */
			has: function(name) {
				return name in this.data;
			},
	
			/**
			 * Returns a dynamic property binding for the specified property name. This makes
			 * it possible to sync the state of two properties in two ObservableObject instances.
			 *
			 * @method bind
			 * @param {String} name Name of the property to sync with the property it's inserted to.
			 * @return {tinymce.data.Binding} Data binding instance.
			 */
			bind: function(name) {
				return Binding.create(this, name);
			},
	
			/**
			 * Destroys the observable object and fires the "destroy"
			 * event and clean up any internal resources.
			 *
			 * @method destroy
			 */
			destroy: function() {
				this.fire('destroy');
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Selector.js
	
	/**
	 * Selector.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint no-nested-ternary:0 */
	
	/**
	 * Selector engine, enables you to select controls by using CSS like expressions.
	 * We currently only support basic CSS expressions to reduce the size of the core
	 * and the ones we support should be enough for most cases.
	 *
	 * @example
	 * Supported expressions:
	 *  element
	 *  element#name
	 *  element.class
	 *  element[attr]
	 *  element[attr*=value]
	 *  element[attr~=value]
	 *  element[attr!=value]
	 *  element[attr^=value]
	 *  element[attr$=value]
	 *  element:<state>
	 *  element:not(<expression>)
	 *  element:first
	 *  element:last
	 *  element:odd
	 *  element:even
	 *  element element
	 *  element > element
	 *
	 * @class tinymce.ui.Selector
	 */
	define("tinymce/ui/Selector", [
		"tinymce/util/Class"
	], function(Class) {
		"use strict";
	
		/**
		 * Produces an array with a unique set of objects. It will not compare the values
		 * but the references of the objects.
		 *
		 * @private
		 * @method unqiue
		 * @param {Array} array Array to make into an array with unique items.
		 * @return {Array} Array with unique items.
		 */
		function unique(array) {
			var uniqueItems = [], i = array.length, item;
	
			while (i--) {
				item = array[i];
	
				if (!item.__checked) {
					uniqueItems.push(item);
					item.__checked = 1;
				}
			}
	
			i = uniqueItems.length;
			while (i--) {
				delete uniqueItems[i].__checked;
			}
	
			return uniqueItems;
		}
	
		var expression = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
	
		/*jshint maxlen:255 */
		/*eslint max-len:0 */
		var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
			whiteSpace = /^\s*|\s*$/g,
			Collection;
	
		var Selector = Class.extend({
			/**
			 * Constructs a new Selector instance.
			 *
			 * @constructor
			 * @method init
			 * @param {String} selector CSS like selector expression.
			 */
			init: function(selector) {
				var match = this.match;
	
				function compileNameFilter(name) {
					if (name) {
						name = name.toLowerCase();
	
						return function(item) {
							return name === '*' || item.type === name;
						};
					}
				}
	
				function compileIdFilter(id) {
					if (id) {
						return function(item) {
							return item._name === id;
						};
					}
				}
	
				function compileClassesFilter(classes) {
					if (classes) {
						classes = classes.split('.');
	
						return function(item) {
							var i = classes.length;
	
							while (i--) {
								if (!item.classes.contains(classes[i])) {
									return false;
								}
							}
	
							return true;
						};
					}
				}
	
				function compileAttrFilter(name, cmp, check) {
					if (name) {
						return function(item) {
							var value = item[name] ? item[name]() : '';
	
							return !cmp ? !!check :
								cmp === "=" ? value === check :
								cmp === "*=" ? value.indexOf(check) >= 0 :
								cmp === "~=" ? (" " + value + " ").indexOf(" " + check + " ") >= 0 :
								cmp === "!=" ? value != check :
								cmp === "^=" ? value.indexOf(check) === 0 :
								cmp === "$=" ? value.substr(value.length - check.length) === check :
								false;
						};
					}
				}
	
				function compilePsuedoFilter(name) {
					var notSelectors;
	
					if (name) {
						name = /(?:not\((.+)\))|(.+)/i.exec(name);
	
						if (!name[1]) {
							name = name[2];
	
							return function(item, index, length) {
								return name === 'first' ? index === 0 :
									name === 'last' ? index === length - 1 :
									name === 'even' ? index % 2 === 0 :
									name === 'odd' ? index % 2 === 1 :
									item[name] ? item[name]() :
									false;
							};
						}
	
						// Compile not expression
						notSelectors = parseChunks(name[1], []);
	
						return function(item) {
							return !match(item, notSelectors);
						};
					}
				}
	
				function compile(selector, filters, direct) {
					var parts;
	
					function add(filter) {
						if (filter) {
							filters.push(filter);
						}
					}
	
					// Parse expression into parts
					parts = expression.exec(selector.replace(whiteSpace, ''));
	
					add(compileNameFilter(parts[1]));
					add(compileIdFilter(parts[2]));
					add(compileClassesFilter(parts[3]));
					add(compileAttrFilter(parts[4], parts[5], parts[6]));
					add(compilePsuedoFilter(parts[7]));
	
					// Mark the filter with pseudo for performance
					filters.pseudo = !!parts[7];
					filters.direct = direct;
	
					return filters;
				}
	
				// Parser logic based on Sizzle by John Resig
				function parseChunks(selector, selectors) {
					var parts = [], extra, matches, i;
	
					do {
						chunker.exec("");
						matches = chunker.exec(selector);
	
						if (matches) {
							selector = matches[3];
							parts.push(matches[1]);
	
							if (matches[2]) {
								extra = matches[3];
								break;
							}
						}
					} while (matches);
	
					if (extra) {
						parseChunks(extra, selectors);
					}
	
					selector = [];
					for (i = 0; i < parts.length; i++) {
						if (parts[i] != '>') {
							selector.push(compile(parts[i], [], parts[i - 1] === '>'));
						}
					}
	
					selectors.push(selector);
	
					return selectors;
				}
	
				this._selectors = parseChunks(selector, []);
			},
	
			/**
			 * Returns true/false if the selector matches the specified control.
			 *
			 * @method match
			 * @param {tinymce.ui.Control} control Control to match against the selector.
			 * @param {Array} selectors Optional array of selectors, mostly used internally.
			 * @return {Boolean} true/false state if the control matches or not.
			 */
			match: function(control, selectors) {
				var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
	
				selectors = selectors || this._selectors;
				for (i = 0, l = selectors.length; i < l; i++) {
					selector = selectors[i];
					sl = selector.length;
					item = control;
					count = 0;
	
					for (si = sl - 1; si >= 0; si--) {
						filters = selector[si];
	
						while (item) {
							// Find the index and length since a pseudo filter like :first needs it
							if (filters.pseudo) {
								siblings = item.parent().items();
								index = length = siblings.length;
								while (index--) {
									if (siblings[index] === item) {
										break;
									}
								}
							}
	
							for (fi = 0, fl = filters.length; fi < fl; fi++) {
								if (!filters[fi](item, index, length)) {
									fi = fl + 1;
									break;
								}
							}
	
							if (fi === fl) {
								count++;
								break;
							} else {
								// If it didn't match the right most expression then
								// break since it's no point looking at the parents
								if (si === sl - 1) {
									break;
								}
							}
	
							item = item.parent();
						}
					}
	
					// If we found all selectors then return true otherwise continue looking
					if (count === sl) {
						return true;
					}
				}
	
				return false;
			},
	
			/**
			 * Returns a tinymce.ui.Collection with matches of the specified selector inside the specified container.
			 *
			 * @method find
			 * @param {tinymce.ui.Control} container Container to look for items in.
			 * @return {tinymce.ui.Collection} Collection with matched elements.
			 */
			find: function(container) {
				var matches = [], i, l, selectors = this._selectors;
	
				function collect(items, selector, index) {
					var i, l, fi, fl, item, filters = selector[index];
	
					for (i = 0, l = items.length; i < l; i++) {
						item = items[i];
	
						// Run each filter against the item
						for (fi = 0, fl = filters.length; fi < fl; fi++) {
							if (!filters[fi](item, i, l)) {
								fi = fl + 1;
								break;
							}
						}
	
						// All filters matched the item
						if (fi === fl) {
							// Matched item is on the last expression like: panel toolbar [button]
							if (index == selector.length - 1) {
								matches.push(item);
							} else {
								// Collect next expression type
								if (item.items) {
									collect(item.items(), selector, index + 1);
								}
							}
						} else if (filters.direct) {
							return;
						}
	
						// Collect child items
						if (item.items) {
							collect(item.items(), selector, index);
						}
					}
				}
	
				if (container.items) {
					for (i = 0, l = selectors.length; i < l; i++) {
						collect(container.items(), selectors[i], 0);
					}
	
					// Unique the matches if needed
					if (l > 1) {
						matches = unique(matches);
					}
				}
	
				// Fix for circular reference
				if (!Collection) {
					// TODO: Fix me!
					Collection = Selector.Collection;
				}
	
				return new Collection(matches);
			}
		});
	
		return Selector;
	});
	
	// Included from: js/tinymce/classes/ui/Collection.js
	
	/**
	 * Collection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Control collection, this class contains control instances and it enables you to
	 * perform actions on all the contained items. This is very similar to how jQuery works.
	 *
	 * @example
	 * someCollection.show().disabled(true);
	 *
	 * @class tinymce.ui.Collection
	 */
	define("tinymce/ui/Collection", [
		"tinymce/util/Tools",
		"tinymce/ui/Selector",
		"tinymce/util/Class"
	], function(Tools, Selector, Class) {
		"use strict";
	
		var Collection, proto, push = Array.prototype.push, slice = Array.prototype.slice;
	
		proto = {
			/**
			 * Current number of contained control instances.
			 *
			 * @field length
			 * @type Number
			 */
			length: 0,
	
			/**
			 * Constructor for the collection.
			 *
			 * @constructor
			 * @method init
			 * @param {Array} items Optional array with items to add.
			 */
			init: function(items) {
				if (items) {
					this.add(items);
				}
			},
	
			/**
			 * Adds new items to the control collection.
			 *
			 * @method add
			 * @param {Array} items Array if items to add to collection.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			add: function(items) {
				var self = this;
	
				// Force single item into array
				if (!Tools.isArray(items)) {
					if (items instanceof Collection) {
						self.add(items.toArray());
					} else {
						push.call(self, items);
					}
				} else {
					push.apply(self, items);
				}
	
				return self;
			},
	
			/**
			 * Sets the contents of the collection. This will remove any existing items
			 * and replace them with the ones specified in the input array.
			 *
			 * @method set
			 * @param {Array} items Array with items to set into the Collection.
			 * @return {tinymce.ui.Collection} Collection instance.
			 */
			set: function(items) {
				var self = this, len = self.length, i;
	
				self.length = 0;
				self.add(items);
	
				// Remove old entries
				for (i = self.length; i < len; i++) {
					delete self[i];
				}
	
				return self;
			},
	
			/**
			 * Filters the collection item based on the specified selector expression or selector function.
			 *
			 * @method filter
			 * @param {String} selector Selector expression to filter items by.
			 * @return {tinymce.ui.Collection} Collection containing the filtered items.
			 */
			filter: function(selector) {
				var self = this, i, l, matches = [], item, match;
	
				// Compile string into selector expression
				if (typeof selector === "string") {
					selector = new Selector(selector);
	
					match = function(item) {
						return selector.match(item);
					};
				} else {
					// Use selector as matching function
					match = selector;
				}
	
				for (i = 0, l = self.length; i < l; i++) {
					item = self[i];
	
					if (match(item)) {
						matches.push(item);
					}
				}
	
				return new Collection(matches);
			},
	
			/**
			 * Slices the items within the collection.
			 *
			 * @method slice
			 * @param {Number} index Index to slice at.
			 * @param {Number} len Optional length to slice.
			 * @return {tinymce.ui.Collection} Current collection.
			 */
			slice: function() {
				return new Collection(slice.apply(this, arguments));
			},
	
			/**
			 * Makes the current collection equal to the specified index.
			 *
			 * @method eq
			 * @param {Number} index Index of the item to set the collection to.
			 * @return {tinymce.ui.Collection} Current collection.
			 */
			eq: function(index) {
				return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
			},
	
			/**
			 * Executes the specified callback on each item in collection.
			 *
			 * @method each
			 * @param {function} callback Callback to execute for each item in collection.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			each: function(callback) {
				Tools.each(this, callback);
	
				return this;
			},
	
			/**
			 * Returns an JavaScript array object of the contents inside the collection.
			 *
			 * @method toArray
			 * @return {Array} Array with all items from collection.
			 */
			toArray: function() {
				return Tools.toArray(this);
			},
	
			/**
			 * Finds the index of the specified control or return -1 if it isn't in the collection.
			 *
			 * @method indexOf
			 * @param {Control} ctrl Control instance to look for.
			 * @return {Number} Index of the specified control or -1.
			 */
			indexOf: function(ctrl) {
				var self = this, i = self.length;
	
				while (i--) {
					if (self[i] === ctrl) {
						break;
					}
				}
	
				return i;
			},
	
			/**
			 * Returns a new collection of the contents in reverse order.
			 *
			 * @method reverse
			 * @return {tinymce.ui.Collection} Collection instance with reversed items.
			 */
			reverse: function() {
				return new Collection(Tools.toArray(this).reverse());
			},
	
			/**
			 * Returns true/false if the class exists or not.
			 *
			 * @method hasClass
			 * @param {String} cls Class to check for.
			 * @return {Boolean} true/false state if the class exists or not.
			 */
			hasClass: function(cls) {
				return this[0] ? this[0].classes.contains(cls) : false;
			},
	
			/**
			 * Sets/gets the specific property on the items in the collection. The same as executing control.<property>(<value>);
			 *
			 * @method prop
			 * @param {String} name Property name to get/set.
			 * @param {Object} value Optional object value to set.
			 * @return {tinymce.ui.Collection} Current collection instance or value of the first item on a get operation.
			 */
			prop: function(name, value) {
				var self = this, undef, item;
	
				if (value !== undef) {
					self.each(function(item) {
						if (item[name]) {
							item[name](value);
						}
					});
	
					return self;
				}
	
				item = self[0];
	
				if (item && item[name]) {
					return item[name]();
				}
			},
	
			/**
			 * Executes the specific function name with optional arguments an all items in collection if it exists.
			 *
			 * @example collection.exec("myMethod", arg1, arg2, arg3);
			 * @method exec
			 * @param {String} name Name of the function to execute.
			 * @param {Object} ... Multiple arguments to pass to each function.
			 * @return {tinymce.ui.Collection} Current collection.
			 */
			exec: function(name) {
				var self = this, args = Tools.toArray(arguments).slice(1);
	
				self.each(function(item) {
					if (item[name]) {
						item[name].apply(item, args);
					}
				});
	
				return self;
			},
	
			/**
			 * Remove all items from collection and DOM.
			 *
			 * @method remove
			 * @return {tinymce.ui.Collection} Current collection.
			 */
			remove: function() {
				var i = this.length;
	
				while (i--) {
					this[i].remove();
				}
	
				return this;
			},
	
			/**
			 * Adds a class to all items in the collection.
			 *
			 * @method addClass
			 * @param {String} cls Class to add to each item.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			addClass: function(cls) {
				return this.each(function(item) {
					item.classes.add(cls);
				});
			},
	
			/**
			 * Removes the specified class from all items in collection.
			 *
			 * @method removeClass
			 * @param {String} cls Class to remove from each item.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			removeClass: function(cls) {
				return this.each(function(item) {
					item.classes.remove(cls);
				});
			}
	
			/**
			 * Fires the specified event by name and arguments on the control. This will execute all
			 * bound event handlers.
			 *
			 * @method fire
			 * @param {String} name Name of the event to fire.
			 * @param {Object} args Optional arguments to pass to the event.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			// fire: function(event, args) {}, -- Generated by code below
	
			/**
			 * Binds a callback to the specified event. This event can both be
			 * native browser events like "click" or custom ones like PostRender.
			 *
			 * The callback function will have two parameters the first one being the control that received the event
			 * the second one will be the event object either the browsers native event object or a custom JS object.
			 *
			 * @method on
			 * @param {String} name Name of the event to bind. For example "click".
			 * @param {String/function} callback Callback function to execute ones the event occurs.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			// on: function(name, callback) {}, -- Generated by code below
	
			/**
			 * Unbinds the specified event and optionally a specific callback. If you omit the name
			 * parameter all event handlers will be removed. If you omit the callback all event handles
			 * by the specified name will be removed.
			 *
			 * @method off
			 * @param {String} name Optional name for the event to unbind.
			 * @param {function} callback Optional callback function to unbind.
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			// off: function(name, callback) {}, -- Generated by code below
	
			/**
			 * Shows the items in the current collection.
			 *
			 * @method show
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			// show: function() {}, -- Generated by code below
	
			/**
			 * Hides the items in the current collection.
			 *
			 * @method hide
			 * @return {tinymce.ui.Collection} Current collection instance.
			 */
			// hide: function() {}, -- Generated by code below
	
			/**
			 * Sets/gets the text contents of the items in the current collection.
			 *
			 * @method text
			 * @return {tinymce.ui.Collection} Current collection instance or text value of the first item on a get operation.
			 */
			// text: function(value) {}, -- Generated by code below
	
			/**
			 * Sets/gets the name contents of the items in the current collection.
			 *
			 * @method name
			 * @return {tinymce.ui.Collection} Current collection instance or name value of the first item on a get operation.
			 */
			// name: function(value) {}, -- Generated by code below
	
			/**
			 * Sets/gets the disabled state on the items in the current collection.
			 *
			 * @method disabled
			 * @return {tinymce.ui.Collection} Current collection instance or disabled state of the first item on a get operation.
			 */
			// disabled: function(state) {}, -- Generated by code below
	
			/**
			 * Sets/gets the active state on the items in the current collection.
			 *
			 * @method active
			 * @return {tinymce.ui.Collection} Current collection instance or active state of the first item on a get operation.
			 */
			// active: function(state) {}, -- Generated by code below
	
			/**
			 * Sets/gets the selected state on the items in the current collection.
			 *
			 * @method selected
			 * @return {tinymce.ui.Collection} Current collection instance or selected state of the first item on a get operation.
			 */
			// selected: function(state) {}, -- Generated by code below
	
			/**
			 * Sets/gets the selected state on the items in the current collection.
			 *
			 * @method visible
			 * @return {tinymce.ui.Collection} Current collection instance or visible state of the first item on a get operation.
			 */
			// visible: function(state) {}, -- Generated by code below
		};
	
		// Extend tinymce.ui.Collection prototype with some generated control specific methods
		Tools.each('fire on off show hide append prepend before after reflow'.split(' '), function(name) {
			proto[name] = function() {
				var args = Tools.toArray(arguments);
	
				this.each(function(ctrl) {
					if (name in ctrl) {
						ctrl[name].apply(ctrl, args);
					}
				});
	
				return this;
			};
		});
	
		// Extend tinymce.ui.Collection prototype with some property methods
		Tools.each('text name disabled active selected checked visible parent value data'.split(' '), function(name) {
			proto[name] = function(value) {
				return this.prop(name, value);
			};
		});
	
		// Create class based on the new prototype
		Collection = Class.extend(proto);
	
		// Stick Collection into Selector to prevent circual references
		Selector.Collection = Collection;
	
		return Collection;
	});
	
	// Included from: js/tinymce/classes/ui/DomUtils.js
	
	/**
	 * DomUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Private UI DomUtils proxy.
	 *
	 * @private
	 * @class tinymce.ui.DomUtils
	 */
	define("tinymce/ui/DomUtils", [
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/dom/DOMUtils"
	], function(Env, Tools, DOMUtils) {
		"use strict";
	
		var count = 0;
	
		var funcs = {
			id: function() {
				return 'mceu_' + (count++);
			},
	
			create: function(name, attrs, children) {
				var elm = document.createElement(name);
	
				DOMUtils.DOM.setAttribs(elm, attrs);
	
				if (typeof children === 'string') {
					elm.innerHTML = children;
				} else {
					Tools.each(children, function(child) {
						if (child.nodeType) {
							elm.appendChild(child);
						}
					});
				}
	
				return elm;
			},
	
			createFragment: function(html) {
				return DOMUtils.DOM.createFragment(html);
			},
	
			getWindowSize: function() {
				return DOMUtils.DOM.getViewPort();
			},
	
			getSize: function(elm) {
				var width, height;
	
				if (elm.getBoundingClientRect) {
					var rect = elm.getBoundingClientRect();
	
					width = Math.max(rect.width || (rect.right - rect.left), elm.offsetWidth);
					height = Math.max(rect.height || (rect.bottom - rect.bottom), elm.offsetHeight);
				} else {
					width = elm.offsetWidth;
					height = elm.offsetHeight;
				}
	
				return {width: width, height: height};
			},
	
			getPos: function(elm, root) {
				return DOMUtils.DOM.getPos(elm, root || funcs.getContainer());
			},
	
			getContainer: function () {
				return Env.container ? Env.container : document.body;
			},
	
			getViewPort: function(win) {
				return DOMUtils.DOM.getViewPort(win);
			},
	
			get: function(id) {
				return document.getElementById(id);
			},
	
			addClass: function(elm, cls) {
				return DOMUtils.DOM.addClass(elm, cls);
			},
	
			removeClass: function(elm, cls) {
				return DOMUtils.DOM.removeClass(elm, cls);
			},
	
			hasClass: function(elm, cls) {
				return DOMUtils.DOM.hasClass(elm, cls);
			},
	
			toggleClass: function(elm, cls, state) {
				return DOMUtils.DOM.toggleClass(elm, cls, state);
			},
	
			css: function(elm, name, value) {
				return DOMUtils.DOM.setStyle(elm, name, value);
			},
	
			getRuntimeStyle: function(elm, name) {
				return DOMUtils.DOM.getStyle(elm, name, true);
			},
	
			on: function(target, name, callback, scope) {
				return DOMUtils.DOM.bind(target, name, callback, scope);
			},
	
			off: function(target, name, callback) {
				return DOMUtils.DOM.unbind(target, name, callback);
			},
	
			fire: function(target, name, args) {
				return DOMUtils.DOM.fire(target, name, args);
			},
	
			innerHtml: function(elm, html) {
				// Workaround for <div> in <p> bug on IE 8 #6178
				DOMUtils.DOM.setHTML(elm, html);
			}
		};
	
		return funcs;
	});
	
	// Included from: js/tinymce/classes/ui/BoxUtils.js
	
	/**
	 * BoxUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for box parsing and measuring.
	 *
	 * @private
	 * @class tinymce.ui.BoxUtils
	 */
	define("tinymce/ui/BoxUtils", [
	], function() {
		"use strict";
	
		return {
			/**
			 * Parses the specified box value. A box value contains 1-4 properties in clockwise order.
			 *
			 * @method parseBox
			 * @param {String/Number} value Box value "0 1 2 3" or "0" etc.
			 * @return {Object} Object with top/right/bottom/left properties.
			 * @private
			 */
			parseBox: function(value) {
				var len, radix = 10;
	
				if (!value) {
					return;
				}
	
				if (typeof value === "number") {
					value = value || 0;
	
					return {
						top: value,
						left: value,
						bottom: value,
						right: value
					};
				}
	
				value = value.split(' ');
				len = value.length;
	
				if (len === 1) {
					value[1] = value[2] = value[3] = value[0];
				} else if (len === 2) {
					value[2] = value[0];
					value[3] = value[1];
				} else if (len === 3) {
					value[3] = value[1];
				}
	
				return {
					top: parseInt(value[0], radix) || 0,
					right: parseInt(value[1], radix) || 0,
					bottom: parseInt(value[2], radix) || 0,
					left: parseInt(value[3], radix) || 0
				};
			},
	
			measureBox: function(elm, prefix) {
				function getStyle(name) {
					var defaultView = document.defaultView;
	
					if (defaultView) {
						// Remove camelcase
						name = name.replace(/[A-Z]/g, function(a) {
							return '-' + a;
						});
	
						return defaultView.getComputedStyle(elm, null).getPropertyValue(name);
					}
	
					return elm.currentStyle[name];
				}
	
				function getSide(name) {
					var val = parseFloat(getStyle(name), 10);
	
					return isNaN(val) ? 0 : val;
				}
	
				return {
					top: getSide(prefix + "TopWidth"),
					right: getSide(prefix + "RightWidth"),
					bottom: getSide(prefix + "BottomWidth"),
					left: getSide(prefix + "LeftWidth")
				};
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/ClassList.js
	
	/**
	 * ClassList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles adding and removal of classes.
	 *
	 * @private
	 * @class tinymce.ui.ClassList
	 */
	define("tinymce/ui/ClassList", [
		"tinymce/util/Tools"
	], function(Tools) {
		"use strict";
	
		function noop() {
		}
	
		/**
		 * Constructs a new class list the specified onchange
		 * callback will be executed when the class list gets modifed.
		 *
		 * @constructor ClassList
		 * @param {function} onchange Onchange callback to be executed.
		 */
		function ClassList(onchange) {
			this.cls = [];
			this.cls._map = {};
			this.onchange = onchange || noop;
			this.prefix = '';
		}
	
		Tools.extend(ClassList.prototype, {
			/**
			 * Adds a new class to the class list.
			 *
			 * @method add
			 * @param {String} cls Class to be added.
			 * @return {tinymce.ui.ClassList} Current class list instance.
			 */
			add: function(cls) {
				if (cls && !this.contains(cls)) {
					this.cls._map[cls] = true;
					this.cls.push(cls);
					this._change();
				}
	
				return this;
			},
	
			/**
			 * Removes the specified class from the class list.
			 *
			 * @method remove
			 * @param {String} cls Class to be removed.
			 * @return {tinymce.ui.ClassList} Current class list instance.
			 */
			remove: function(cls) {
				if (this.contains(cls)) {
					for (var i = 0; i < this.cls.length; i++) {
						if (this.cls[i] === cls) {
							break;
						}
					}
	
					this.cls.splice(i, 1);
					delete this.cls._map[cls];
					this._change();
				}
	
				return this;
			},
	
			/**
			 * Toggles a class in the class list.
			 *
			 * @method toggle
			 * @param {String} cls Class to be added/removed.
			 * @param {Boolean} state Optional state if it should be added/removed.
			 * @return {tinymce.ui.ClassList} Current class list instance.
			 */
			toggle: function(cls, state) {
				var curState = this.contains(cls);
	
				if (curState !== state) {
					if (curState) {
						this.remove(cls);
					} else {
						this.add(cls);
					}
	
					this._change();
				}
	
				return this;
			},
	
			/**
			 * Returns true if the class list has the specified class.
			 *
			 * @method contains
			 * @param {String} cls Class to look for.
			 * @return {Boolean} true/false if the class exists or not.
			 */
			contains: function(cls) {
				return !!this.cls._map[cls];
			},
	
			/**
			 * Returns a space separated list of classes.
			 *
			 * @method toString
			 * @return {String} Space separated list of classes.
			 */
	
			_change: function() {
				delete this.clsValue;
				this.onchange.call(this);
			}
		});
	
		// IE 8 compatibility
		ClassList.prototype.toString = function() {
			var value;
	
			if (this.clsValue) {
				return this.clsValue;
			}
	
			value = '';
			for (var i = 0; i < this.cls.length; i++) {
				if (i > 0) {
					value += ' ';
				}
	
				value += this.prefix + this.cls[i];
			}
	
			return value;
		};
	
		return ClassList;
	});
	
	// Included from: js/tinymce/classes/ui/ReflowQueue.js
	
	/**
	 * ReflowQueue.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class will automatically reflow controls on the next animation frame within a few milliseconds on older browsers.
	 * If the user manually reflows then the automatic reflow will be cancelled. This class is used internally when various control states
	 * changes that triggers a reflow.
	 *
	 * @class tinymce.ui.ReflowQueue
	 * @static
	 */
	define("tinymce/ui/ReflowQueue", [
		"tinymce/util/Delay"
	], function(Delay) {
		var dirtyCtrls = {}, animationFrameRequested;
	
		return {
			/**
			 * Adds a control to the next automatic reflow call. This is the control that had a state
			 * change for example if the control was hidden/shown.
			 *
			 * @method add
			 * @param {tinymce.ui.Control} ctrl Control to add to queue.
			 */
			add: function(ctrl) {
				var parent = ctrl.parent();
	
				if (parent) {
					if (!parent._layout || parent._layout.isNative()) {
						return;
					}
	
					if (!dirtyCtrls[parent._id]) {
						dirtyCtrls[parent._id] = parent;
					}
	
					if (!animationFrameRequested) {
						animationFrameRequested = true;
	
						Delay.requestAnimationFrame(function() {
							var id, ctrl;
	
							animationFrameRequested = false;
	
							for (id in dirtyCtrls) {
								ctrl = dirtyCtrls[id];
	
								if (ctrl.state.get('rendered')) {
									ctrl.reflow();
								}
							}
	
							dirtyCtrls = {};
						}, document.body);
					}
				}
			},
	
			/**
			 * Removes the specified control from the automatic reflow. This will happen when for example the user
			 * manually triggers a reflow.
			 *
			 * @method remove
			 * @param {tinymce.ui.Control} ctrl Control to remove from queue.
			 */
			remove: function(ctrl) {
				if (dirtyCtrls[ctrl._id]) {
					delete dirtyCtrls[ctrl._id];
				}
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/Control.js
	
	/**
	 * Control.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint consistent-this:0 */
	
	/**
	 * This is the base class for all controls and containers. All UI control instances inherit
	 * from this one as it has the base logic needed by all of them.
	 *
	 * @class tinymce.ui.Control
	 */
	define("tinymce/ui/Control", [
		"tinymce/util/Class",
		"tinymce/util/Tools",
		"tinymce/util/EventDispatcher",
		"tinymce/data/ObservableObject",
		"tinymce/ui/Collection",
		"tinymce/ui/DomUtils",
		"tinymce/dom/DomQuery",
		"tinymce/ui/BoxUtils",
		"tinymce/ui/ClassList",
		"tinymce/ui/ReflowQueue"
	], function(Class, Tools, EventDispatcher, ObservableObject, Collection, DomUtils, $, BoxUtils, ClassList, ReflowQueue) {
		"use strict";
	
		var hasMouseWheelEventSupport = "onmousewheel" in document;
		var hasWheelEventSupport = false;
		var classPrefix = "mce-";
		var Control, idCounter = 0;
	
		var proto = {
			Statics: {
				classPrefix: classPrefix
			},
	
			isRtl: function() {
				return Control.rtl;
			},
	
			/**
			 * Class/id prefix to use for all controls.
			 *
			 * @final
			 * @field {String} classPrefix
			 */
			classPrefix: classPrefix,
	
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} style Style CSS properties to add.
			 * @setting {String} border Border box values example: 1 1 1 1
			 * @setting {String} padding Padding box values example: 1 1 1 1
			 * @setting {String} margin Margin box values example: 1 1 1 1
			 * @setting {Number} minWidth Minimal width for the control.
			 * @setting {Number} minHeight Minimal height for the control.
			 * @setting {String} classes Space separated list of classes to add.
			 * @setting {String} role WAI-ARIA role to use for control.
			 * @setting {Boolean} hidden Is the control hidden by default.
			 * @setting {Boolean} disabled Is the control disabled by default.
			 * @setting {String} name Name of the control instance.
			 */
			init: function(settings) {
				var self = this, classes, defaultClasses;
	
				function applyClasses(classes) {
					var i;
	
					classes = classes.split(' ');
					for (i = 0; i < classes.length; i++) {
						self.classes.add(classes[i]);
					}
				}
	
				self.settings = settings = Tools.extend({}, self.Defaults, settings);
	
				// Initial states
				self._id = settings.id || ('mceu_' + (idCounter++));
				self._aria = {role: settings.role};
				self._elmCache = {};
				self.$ = $;
	
				self.state = new ObservableObject({
					visible: true,
					active: false,
					disabled: false,
					value: ''
				});
	
				self.data = new ObservableObject(settings.data);
	
				self.classes = new ClassList(function() {
					if (self.state.get('rendered')) {
						self.getEl().className = this.toString();
					}
				});
				self.classes.prefix = self.classPrefix;
	
				// Setup classes
				classes = settings.classes;
				if (classes) {
					if (self.Defaults) {
						defaultClasses = self.Defaults.classes;
	
						if (defaultClasses && classes != defaultClasses) {
							applyClasses(defaultClasses);
						}
					}
	
					applyClasses(classes);
				}
	
				Tools.each('title text name visible disabled active value'.split(' '), function(name) {
					if (name in settings) {
						self[name](settings[name]);
					}
				});
	
				self.on('click', function() {
					if (self.disabled()) {
						return false;
					}
				});
	
				/**
				 * Name/value object with settings for the current control.
				 *
				 * @field {Object} settings
				 */
				self.settings = settings;
	
				self.borderBox = BoxUtils.parseBox(settings.border);
				self.paddingBox = BoxUtils.parseBox(settings.padding);
				self.marginBox = BoxUtils.parseBox(settings.margin);
	
				if (settings.hidden) {
					self.hide();
				}
			},
	
			// Will generate getter/setter methods for these properties
			Properties: 'parent,name',
	
			/**
			 * Returns the root element to render controls into.
			 *
			 * @method getContainerElm
			 * @return {Element} HTML DOM element to render into.
			 */
			getContainerElm: function() {
				return DomUtils.getContainer();
			},
	
			/**
			 * Returns a control instance for the current DOM element.
			 *
			 * @method getParentCtrl
			 * @param {Element} elm HTML dom element to get parent control from.
			 * @return {tinymce.ui.Control} Control instance or undefined.
			 */
			getParentCtrl: function(elm) {
				var ctrl, lookup = this.getRoot().controlIdLookup;
	
				while (elm && lookup) {
					ctrl = lookup[elm.id];
					if (ctrl) {
						break;
					}
	
					elm = elm.parentNode;
				}
	
				return ctrl;
			},
	
			/**
			 * Initializes the current controls layout rect.
			 * This will be executed by the layout managers to determine the
			 * default minWidth/minHeight etc.
			 *
			 * @method initLayoutRect
			 * @return {Object} Layout rect instance.
			 */
			initLayoutRect: function() {
				var self = this, settings = self.settings, borderBox, layoutRect;
				var elm = self.getEl(), width, height, minWidth, minHeight, autoResize;
				var startMinWidth, startMinHeight, initialSize;
	
				// Measure the current element
				borderBox = self.borderBox = self.borderBox || BoxUtils.measureBox(elm, 'border');
				self.paddingBox = self.paddingBox || BoxUtils.measureBox(elm, 'padding');
				self.marginBox = self.marginBox || BoxUtils.measureBox(elm, 'margin');
				initialSize = DomUtils.getSize(elm);
	
				// Setup minWidth/minHeight and width/height
				startMinWidth = settings.minWidth;
				startMinHeight = settings.minHeight;
				minWidth = startMinWidth || initialSize.width;
				minHeight = startMinHeight || initialSize.height;
				width = settings.width;
				height = settings.height;
				autoResize = settings.autoResize;
				autoResize = typeof autoResize != "undefined" ? autoResize : !width && !height;
	
				width = width || minWidth;
				height = height || minHeight;
	
				var deltaW = borderBox.left + borderBox.right;
				var deltaH = borderBox.top + borderBox.bottom;
	
				var maxW = settings.maxWidth || 0xFFFF;
				var maxH = settings.maxHeight || 0xFFFF;
	
				// Setup initial layout rect
				self._layoutRect = layoutRect = {
					x: settings.x || 0,
					y: settings.y || 0,
					w: width,
					h: height,
					deltaW: deltaW,
					deltaH: deltaH,
					contentW: width - deltaW,
					contentH: height - deltaH,
					innerW: width - deltaW,
					innerH: height - deltaH,
					startMinWidth: startMinWidth || 0,
					startMinHeight: startMinHeight || 0,
					minW: Math.min(minWidth, maxW),
					minH: Math.min(minHeight, maxH),
					maxW: maxW,
					maxH: maxH,
					autoResize: autoResize,
					scrollW: 0
				};
	
				self._lastLayoutRect = {};
	
				return layoutRect;
			},
	
			/**
			 * Getter/setter for the current layout rect.
			 *
			 * @method layoutRect
			 * @param {Object} [newRect] Optional new layout rect.
			 * @return {tinymce.ui.Control/Object} Current control or rect object.
			 */
			layoutRect: function(newRect) {
				var self = this, curRect = self._layoutRect, lastLayoutRect, size, deltaWidth, deltaHeight, undef, repaintControls;
	
				// Initialize default layout rect
				if (!curRect) {
					curRect = self.initLayoutRect();
				}
	
				// Set new rect values
				if (newRect) {
					// Calc deltas between inner and outer sizes
					deltaWidth = curRect.deltaW;
					deltaHeight = curRect.deltaH;
	
					// Set x position
					if (newRect.x !== undef) {
						curRect.x = newRect.x;
					}
	
					// Set y position
					if (newRect.y !== undef) {
						curRect.y = newRect.y;
					}
	
					// Set minW
					if (newRect.minW !== undef) {
						curRect.minW = newRect.minW;
					}
	
					// Set minH
					if (newRect.minH !== undef) {
						curRect.minH = newRect.minH;
					}
	
					// Set new width and calculate inner width
					size = newRect.w;
					if (size !== undef) {
						size = size < curRect.minW ? curRect.minW : size;
						size = size > curRect.maxW ? curRect.maxW : size;
						curRect.w = size;
						curRect.innerW = size - deltaWidth;
					}
	
					// Set new height and calculate inner height
					size = newRect.h;
					if (size !== undef) {
						size = size < curRect.minH ? curRect.minH : size;
						size = size > curRect.maxH ? curRect.maxH : size;
						curRect.h = size;
						curRect.innerH = size - deltaHeight;
					}
	
					// Set new inner width and calculate width
					size = newRect.innerW;
					if (size !== undef) {
						size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
						size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
						curRect.innerW = size;
						curRect.w = size + deltaWidth;
					}
	
					// Set new height and calculate inner height
					size = newRect.innerH;
					if (size !== undef) {
						size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
						size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
						curRect.innerH = size;
						curRect.h = size + deltaHeight;
					}
	
					// Set new contentW
					if (newRect.contentW !== undef) {
						curRect.contentW = newRect.contentW;
					}
	
					// Set new contentH
					if (newRect.contentH !== undef) {
						curRect.contentH = newRect.contentH;
					}
	
					// Compare last layout rect with the current one to see if we need to repaint or not
					lastLayoutRect = self._lastLayoutRect;
					if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y ||
						lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
						repaintControls = Control.repaintControls;
	
						if (repaintControls) {
							if (repaintControls.map && !repaintControls.map[self._id]) {
								repaintControls.push(self);
								repaintControls.map[self._id] = true;
							}
						}
	
						lastLayoutRect.x = curRect.x;
						lastLayoutRect.y = curRect.y;
						lastLayoutRect.w = curRect.w;
						lastLayoutRect.h = curRect.h;
					}
	
					return self;
				}
	
				return curRect;
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, style, bodyStyle, bodyElm, rect, borderBox;
				var borderW, borderH, lastRepaintRect, round, value;
	
				// Use Math.round on all values on IE < 9
				round = !document.createRange ? Math.round : function(value) {
					return value;
				};
	
				style = self.getEl().style;
				rect = self._layoutRect;
				lastRepaintRect = self._lastRepaintRect || {};
	
				borderBox = self.borderBox;
				borderW = borderBox.left + borderBox.right;
				borderH = borderBox.top + borderBox.bottom;
	
				if (rect.x !== lastRepaintRect.x) {
					style.left = round(rect.x) + 'px';
					lastRepaintRect.x = rect.x;
				}
	
				if (rect.y !== lastRepaintRect.y) {
					style.top = round(rect.y) + 'px';
					lastRepaintRect.y = rect.y;
				}
	
				if (rect.w !== lastRepaintRect.w) {
					value = round(rect.w - borderW);
					style.width = (value >= 0 ? value : 0) + 'px';
					lastRepaintRect.w = rect.w;
				}
	
				if (rect.h !== lastRepaintRect.h) {
					value = round(rect.h - borderH);
					style.height = (value >= 0 ? value : 0) + 'px';
					lastRepaintRect.h = rect.h;
				}
	
				// Update body if needed
				if (self._hasBody && rect.innerW !== lastRepaintRect.innerW) {
					value = round(rect.innerW);
	
					bodyElm = self.getEl('body');
					if (bodyElm) {
						bodyStyle = bodyElm.style;
						bodyStyle.width = (value >= 0 ? value : 0) + 'px';
					}
	
					lastRepaintRect.innerW = rect.innerW;
				}
	
				if (self._hasBody && rect.innerH !== lastRepaintRect.innerH) {
					value = round(rect.innerH);
	
					bodyElm = bodyElm || self.getEl('body');
					if (bodyElm) {
						bodyStyle = bodyStyle || bodyElm.style;
						bodyStyle.height = (value >= 0 ? value : 0) + 'px';
					}
	
					lastRepaintRect.innerH = rect.innerH;
				}
	
				self._lastRepaintRect = lastRepaintRect;
				self.fire('repaint', {}, false);
			},
	
			/**
			 * Updates the controls layout rect by re-measuing it.
			 */
			updateLayoutRect: function() {
				var self = this;
	
				self.parent()._lastRect = null;
	
				DomUtils.css(self.getEl(), {width: '', height: ''});
	
				self._layoutRect = self._lastRepaintRect = self._lastLayoutRect = null;
				self.initLayoutRect();
			},
	
			/**
			 * Binds a callback to the specified event. This event can both be
			 * native browser events like "click" or custom ones like PostRender.
			 *
			 * The callback function will be passed a DOM event like object that enables yout do stop propagation.
			 *
			 * @method on
			 * @param {String} name Name of the event to bind. For example "click".
			 * @param {String/function} callback Callback function to execute ones the event occurs.
			 * @return {tinymce.ui.Control} Current control object.
			 */
			on: function(name, callback) {
				var self = this;
	
				function resolveCallbackName(name) {
					var callback, scope;
	
					if (typeof name != 'string') {
						return name;
					}
	
					return function(e) {
						if (!callback) {
							self.parentsAndSelf().each(function(ctrl) {
								var callbacks = ctrl.settings.callbacks;
	
								if (callbacks && (callback = callbacks[name])) {
									scope = ctrl;
									return false;
								}
							});
						}
	
						if (!callback) {
							e.action = name;
							this.fire('execute', e);
							return;
						}
	
						return callback.call(scope, e);
					};
				}
	
				getEventDispatcher(self).on(name, resolveCallbackName(callback));
	
				return self;
			},
	
			/**
			 * Unbinds the specified event and optionally a specific callback. If you omit the name
			 * parameter all event handlers will be removed. If you omit the callback all event handles
			 * by the specified name will be removed.
			 *
			 * @method off
			 * @param {String} [name] Name for the event to unbind.
			 * @param {function} [callback] Callback function to unbind.
			 * @return {tinymce.ui.Control} Current control object.
			 */
			off: function(name, callback) {
				getEventDispatcher(this).off(name, callback);
				return this;
			},
	
			/**
			 * Fires the specified event by name and arguments on the control. This will execute all
			 * bound event handlers.
			 *
			 * @method fire
			 * @param {String} name Name of the event to fire.
			 * @param {Object} [args] Arguments to pass to the event.
			 * @param {Boolean} [bubble] Value to control bubbling. Defaults to true.
			 * @return {Object} Current arguments object.
			 */
			fire: function(name, args, bubble) {
				var self = this;
	
				args = args || {};
	
				if (!args.control) {
					args.control = self;
				}
	
				args = getEventDispatcher(self).fire(name, args);
	
				// Bubble event up to parents
				if (bubble !== false && self.parent) {
					var parent = self.parent();
					while (parent && !args.isPropagationStopped()) {
						parent.fire(name, args, false);
						parent = parent.parent();
					}
				}
	
				return args;
			},
	
			/**
			 * Returns true/false if the specified event has any listeners.
			 *
			 * @method hasEventListeners
			 * @param {String} name Name of the event to check for.
			 * @return {Boolean} True/false state if the event has listeners.
			 */
			hasEventListeners: function(name) {
				return getEventDispatcher(this).has(name);
			},
	
			/**
			 * Returns a control collection with all parent controls.
			 *
			 * @method parents
			 * @param {String} selector Optional selector expression to find parents.
			 * @return {tinymce.ui.Collection} Collection with all parent controls.
			 */
			parents: function(selector) {
				var self = this, ctrl, parents = new Collection();
	
				// Add each parent to collection
				for (ctrl = self.parent(); ctrl; ctrl = ctrl.parent()) {
					parents.add(ctrl);
				}
	
				// Filter away everything that doesn't match the selector
				if (selector) {
					parents = parents.filter(selector);
				}
	
				return parents;
			},
	
			/**
			 * Returns the current control and it's parents.
			 *
			 * @method parentsAndSelf
			 * @param {String} selector Optional selector expression to find parents.
			 * @return {tinymce.ui.Collection} Collection with all parent controls.
			 */
			parentsAndSelf: function(selector) {
				return new Collection(this).add(this.parents(selector));
			},
	
			/**
			 * Returns the control next to the current control.
			 *
			 * @method next
			 * @return {tinymce.ui.Control} Next control instance.
			 */
			next: function() {
				var parentControls = this.parent().items();
	
				return parentControls[parentControls.indexOf(this) + 1];
			},
	
			/**
			 * Returns the control previous to the current control.
			 *
			 * @method prev
			 * @return {tinymce.ui.Control} Previous control instance.
			 */
			prev: function() {
				var parentControls = this.parent().items();
	
				return parentControls[parentControls.indexOf(this) - 1];
			},
	
			/**
			 * Sets the inner HTML of the control element.
			 *
			 * @method innerHtml
			 * @param {String} html Html string to set as inner html.
			 * @return {tinymce.ui.Control} Current control object.
			 */
			innerHtml: function(html) {
				this.$el.html(html);
				return this;
			},
	
			/**
			 * Returns the control DOM element or sub element.
			 *
			 * @method getEl
			 * @param {String} [suffix] Suffix to get element by.
			 * @return {Element} HTML DOM element for the current control or it's children.
			 */
			getEl: function(suffix) {
				var id = suffix ? this._id + '-' + suffix : this._id;
	
				if (!this._elmCache[id]) {
					this._elmCache[id] = $('#' + id)[0];
				}
	
				return this._elmCache[id];
			},
	
			/**
			 * Sets the visible state to true.
			 *
			 * @method show
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			show: function() {
				return this.visible(true);
			},
	
			/**
			 * Sets the visible state to false.
			 *
			 * @method hide
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			hide: function() {
				return this.visible(false);
			},
	
			/**
			 * Focuses the current control.
			 *
			 * @method focus
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			focus: function() {
				try {
					this.getEl().focus();
				} catch (ex) {
					// Ignore IE error
				}
	
				return this;
			},
	
			/**
			 * Blurs the current control.
			 *
			 * @method blur
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			blur: function() {
				this.getEl().blur();
	
				return this;
			},
	
			/**
			 * Sets the specified aria property.
			 *
			 * @method aria
			 * @param {String} name Name of the aria property to set.
			 * @param {String} value Value of the aria property.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			aria: function(name, value) {
				var self = this, elm = self.getEl(self.ariaTarget);
	
				if (typeof value === "undefined") {
					return self._aria[name];
				}
	
				self._aria[name] = value;
	
				if (self.state.get('rendered')) {
					elm.setAttribute(name == 'role' ? name : 'aria-' + name, value);
				}
	
				return self;
			},
	
			/**
			 * Encodes the specified string with HTML entities. It will also
			 * translate the string to different languages.
			 *
			 * @method encode
			 * @param {String/Object/Array} text Text to entity encode.
			 * @param {Boolean} [translate=true] False if the contents shouldn't be translated.
			 * @return {String} Encoded and possible traslated string.
			 */
			encode: function(text, translate) {
				if (translate !== false) {
					text = this.translate(text);
				}
	
				return (text || '').replace(/[&<>"]/g, function(match) {
					return '&#' + match.charCodeAt(0) + ';';
				});
			},
	
			/**
			 * Returns the translated string.
			 *
			 * @method translate
			 * @param {String} text Text to translate.
			 * @return {String} Translated string or the same as the input.
			 */
			translate: function(text) {
				return Control.translate ? Control.translate(text) : text;
			},
	
			/**
			 * Adds items before the current control.
			 *
			 * @method before
			 * @param {Array/tinymce.ui.Collection} items Array of items to prepend before this control.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			before: function(items) {
				var self = this, parent = self.parent();
	
				if (parent) {
					parent.insert(items, parent.items().indexOf(self), true);
				}
	
				return self;
			},
	
			/**
			 * Adds items after the current control.
			 *
			 * @method after
			 * @param {Array/tinymce.ui.Collection} items Array of items to append after this control.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			after: function(items) {
				var self = this, parent = self.parent();
	
				if (parent) {
					parent.insert(items, parent.items().indexOf(self));
				}
	
				return self;
			},
	
			/**
			 * Removes the current control from DOM and from UI collections.
			 *
			 * @method remove
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			remove: function() {
				var self = this, elm = self.getEl(), parent = self.parent(), newItems, i;
	
				if (self.items) {
					var controls = self.items().toArray();
					i = controls.length;
					while (i--) {
						controls[i].remove();
					}
				}
	
				if (parent && parent.items) {
					newItems = [];
	
					parent.items().each(function(item) {
						if (item !== self) {
							newItems.push(item);
						}
					});
	
					parent.items().set(newItems);
					parent._lastRect = null;
				}
	
				if (self._eventsRoot && self._eventsRoot == self) {
					$(elm).off();
				}
	
				var lookup = self.getRoot().controlIdLookup;
				if (lookup) {
					delete lookup[self._id];
				}
	
				if (elm && elm.parentNode) {
					elm.parentNode.removeChild(elm);
				}
	
				self.state.set('rendered', false);
				self.state.destroy();
	
				self.fire('remove');
	
				return self;
			},
	
			/**
			 * Renders the control before the specified element.
			 *
			 * @method renderBefore
			 * @param {Element} elm Element to render before.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			renderBefore: function(elm) {
				$(elm).before(this.renderHtml());
				this.postRender();
				return this;
			},
	
			/**
			 * Renders the control to the specified element.
			 *
			 * @method renderBefore
			 * @param {Element} elm Element to render to.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			renderTo: function(elm) {
				$(elm || this.getContainerElm()).append(this.renderHtml());
				this.postRender();
				return this;
			},
	
			preRender: function() {
			},
	
			render: function() {
			},
	
			renderHtml: function() {
				return '<div id="' + this._id + '" class="' + this.classes + '"></div>';
			},
	
			/**
			 * Post render method. Called after the control has been rendered to the target.
			 *
			 * @method postRender
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			postRender: function() {
				var self = this, settings = self.settings, elm, box, parent, name, parentEventsRoot;
	
				self.$el = $(self.getEl());
				self.state.set('rendered', true);
	
				// Bind on<event> settings
				for (name in settings) {
					if (name.indexOf("on") === 0) {
						self.on(name.substr(2), settings[name]);
					}
				}
	
				if (self._eventsRoot) {
					for (parent = self.parent(); !parentEventsRoot && parent; parent = parent.parent()) {
						parentEventsRoot = parent._eventsRoot;
					}
	
					if (parentEventsRoot) {
						for (name in parentEventsRoot._nativeEvents) {
							self._nativeEvents[name] = true;
						}
					}
				}
	
				bindPendingEvents(self);
	
				if (settings.style) {
					elm = self.getEl();
					if (elm) {
						elm.setAttribute('style', settings.style);
						elm.style.cssText = settings.style;
					}
				}
	
				if (self.settings.border) {
					box = self.borderBox;
					self.$el.css({
						'border-top-width': box.top,
						'border-right-width': box.right,
						'border-bottom-width': box.bottom,
						'border-left-width': box.left
					});
				}
	
				// Add instance to lookup
				var root = self.getRoot();
				if (!root.controlIdLookup) {
					root.controlIdLookup = {};
				}
	
				root.controlIdLookup[self._id] = self;
	
				for (var key in self._aria) {
					self.aria(key, self._aria[key]);
				}
	
				if (self.state.get('visible') === false) {
					self.getEl().style.display = 'none';
				}
	
				self.bindStates();
	
				self.state.on('change:visible', function(e) {
					var state = e.value, parentCtrl;
	
					if (self.state.get('rendered')) {
						self.getEl().style.display = state === false ? 'none' : '';
	
						// Need to force a reflow here on IE 8
						self.getEl().getBoundingClientRect();
					}
	
					// Parent container needs to reflow
					parentCtrl = self.parent();
					if (parentCtrl) {
						parentCtrl._lastRect = null;
					}
	
					self.fire(state ? 'show' : 'hide');
	
					ReflowQueue.add(self);
				});
	
				self.fire('postrender', {}, false);
			},
	
			bindStates: function() {
			},
	
			/**
			 * Scrolls the current control into view.
			 *
			 * @method scrollIntoView
			 * @param {String} align Alignment in view top|center|bottom.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			scrollIntoView: function(align) {
				function getOffset(elm, rootElm) {
					var x, y, parent = elm;
	
					x = y = 0;
					while (parent && parent != rootElm && parent.nodeType) {
						x += parent.offsetLeft || 0;
						y += parent.offsetTop || 0;
						parent = parent.offsetParent;
					}
	
					return {x: x, y: y};
				}
	
				var elm = this.getEl(), parentElm = elm.parentNode;
				var x, y, width, height, parentWidth, parentHeight;
				var pos = getOffset(elm, parentElm);
	
				x = pos.x;
				y = pos.y;
				width = elm.offsetWidth;
				height = elm.offsetHeight;
				parentWidth = parentElm.clientWidth;
				parentHeight = parentElm.clientHeight;
	
				if (align == "end") {
					x -= parentWidth - width;
					y -= parentHeight - height;
				} else if (align == "center") {
					x -= (parentWidth / 2) - (width / 2);
					y -= (parentHeight / 2) - (height / 2);
				}
	
				parentElm.scrollLeft = x;
				parentElm.scrollTop = y;
	
				return this;
			},
	
			getRoot: function() {
				var ctrl = this, rootControl, parents = [];
	
				while (ctrl) {
					if (ctrl.rootControl) {
						rootControl = ctrl.rootControl;
						break;
					}
	
					parents.push(ctrl);
					rootControl = ctrl;
					ctrl = ctrl.parent();
				}
	
				if (!rootControl) {
					rootControl = this;
				}
	
				var i = parents.length;
				while (i--) {
					parents[i].rootControl = rootControl;
				}
	
				return rootControl;
			},
	
			/**
			 * Reflows the current control and it's parents.
			 * This should be used after you for example append children to the current control so
			 * that the layout managers know that they need to reposition everything.
			 *
			 * @example
			 * container.append({type: 'button', text: 'My button'}).reflow();
			 *
			 * @method reflow
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			reflow: function() {
				ReflowQueue.remove(this);
	
				var parent = this.parent();
				if (parent._layout && !parent._layout.isNative()) {
					parent.reflow();
				}
	
				return this;
			}
	
			/**
			 * Sets/gets the parent container for the control.
			 *
			 * @method parent
			 * @param {tinymce.ui.Container} parent Optional parent to set.
			 * @return {tinymce.ui.Control} Parent control or the current control on a set action.
			 */
			// parent: function(parent) {} -- Generated
	
			/**
			 * Sets/gets the text for the control.
			 *
			 * @method text
			 * @param {String} value Value to set to control.
			 * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
			 */
			// text: function(value) {} -- Generated
	
			/**
			 * Sets/gets the disabled state on the control.
			 *
			 * @method disabled
			 * @param {Boolean} state Value to set to control.
			 * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
			 */
			// disabled: function(state) {} -- Generated
	
			/**
			 * Sets/gets the active for the control.
			 *
			 * @method active
			 * @param {Boolean} state Value to set to control.
			 * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
			 */
			// active: function(state) {} -- Generated
	
			/**
			 * Sets/gets the name for the control.
			 *
			 * @method name
			 * @param {String} value Value to set to control.
			 * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
			 */
			// name: function(value) {} -- Generated
	
			/**
			 * Sets/gets the title for the control.
			 *
			 * @method title
			 * @param {String} value Value to set to control.
			 * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
			 */
			// title: function(value) {} -- Generated
	
			/**
			 * Sets/gets the visible for the control.
			 *
			 * @method visible
			 * @param {Boolean} state Value to set to control.
			 * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
			 */
			// visible: function(value) {} -- Generated
		};
	
		/**
		 * Setup state properties.
		 */
		Tools.each('text title visible disabled active value'.split(' '), function(name) {
			proto[name] = function(value) {
				if (arguments.length === 0) {
					return this.state.get(name);
				}
	
				if (typeof value != "undefined") {
					this.state.set(name, value);
				}
	
				return this;
			};
		});
	
		Control = Class.extend(proto);
	
		function getEventDispatcher(obj) {
			if (!obj._eventDispatcher) {
				obj._eventDispatcher = new EventDispatcher({
					scope: obj,
					toggleEvent: function(name, state) {
						if (state && EventDispatcher.isNative(name)) {
							if (!obj._nativeEvents) {
								obj._nativeEvents = {};
							}
	
							obj._nativeEvents[name] = true;
	
							if (obj.state.get('rendered')) {
								bindPendingEvents(obj);
							}
						}
					}
				});
			}
	
			return obj._eventDispatcher;
		}
	
		function bindPendingEvents(eventCtrl) {
			var i, l, parents, eventRootCtrl, nativeEvents, name;
	
			function delegate(e) {
				var control = eventCtrl.getParentCtrl(e.target);
	
				if (control) {
					control.fire(e.type, e);
				}
			}
	
			function mouseLeaveHandler() {
				var ctrl = eventRootCtrl._lastHoverCtrl;
	
				if (ctrl) {
					ctrl.fire("mouseleave", {target: ctrl.getEl()});
	
					ctrl.parents().each(function(ctrl) {
						ctrl.fire("mouseleave", {target: ctrl.getEl()});
					});
	
					eventRootCtrl._lastHoverCtrl = null;
				}
			}
	
			function mouseEnterHandler(e) {
				var ctrl = eventCtrl.getParentCtrl(e.target), lastCtrl = eventRootCtrl._lastHoverCtrl, idx = 0, i, parents, lastParents;
	
				// Over on a new control
				if (ctrl !== lastCtrl) {
					eventRootCtrl._lastHoverCtrl = ctrl;
	
					parents = ctrl.parents().toArray().reverse();
					parents.push(ctrl);
	
					if (lastCtrl) {
						lastParents = lastCtrl.parents().toArray().reverse();
						lastParents.push(lastCtrl);
	
						for (idx = 0; idx < lastParents.length; idx++) {
							if (parents[idx] !== lastParents[idx]) {
								break;
							}
						}
	
						for (i = lastParents.length - 1; i >= idx; i--) {
							lastCtrl = lastParents[i];
							lastCtrl.fire("mouseleave", {
								target: lastCtrl.getEl()
							});
						}
					}
	
					for (i = idx; i < parents.length; i++) {
						ctrl = parents[i];
						ctrl.fire("mouseenter", {
							target: ctrl.getEl()
						});
					}
				}
			}
	
			function fixWheelEvent(e) {
				e.preventDefault();
	
				if (e.type == "mousewheel") {
					e.deltaY = -1 / 40 * e.wheelDelta;
	
					if (e.wheelDeltaX) {
						e.deltaX = -1 / 40 * e.wheelDeltaX;
					}
				} else {
					e.deltaX = 0;
					e.deltaY = e.detail;
				}
	
				e = eventCtrl.fire("wheel", e);
			}
	
			nativeEvents = eventCtrl._nativeEvents;
			if (nativeEvents) {
				// Find event root element if it exists
				parents = eventCtrl.parents().toArray();
				parents.unshift(eventCtrl);
				for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
					eventRootCtrl = parents[i]._eventsRoot;
				}
	
				// Event root wasn't found the use the root control
				if (!eventRootCtrl) {
					eventRootCtrl = parents[parents.length - 1] || eventCtrl;
				}
	
				// Set the eventsRoot property on children that didn't have it
				eventCtrl._eventsRoot = eventRootCtrl;
				for (l = i, i = 0; i < l; i++) {
					parents[i]._eventsRoot = eventRootCtrl;
				}
	
				var eventRootDelegates = eventRootCtrl._delegates;
				if (!eventRootDelegates) {
					eventRootDelegates = eventRootCtrl._delegates = {};
				}
	
				// Bind native event delegates
				for (name in nativeEvents) {
					if (!nativeEvents) {
						return false;
					}
	
					if (name === "wheel" && !hasWheelEventSupport) {
						if (hasMouseWheelEventSupport) {
							$(eventCtrl.getEl()).on("mousewheel", fixWheelEvent);
						} else {
							$(eventCtrl.getEl()).on("DOMMouseScroll", fixWheelEvent);
						}
	
						continue;
					}
	
					// Special treatment for mousenter/mouseleave since these doesn't bubble
					if (name === "mouseenter" || name === "mouseleave") {
						// Fake mousenter/mouseleave
						if (!eventRootCtrl._hasMouseEnter) {
							$(eventRootCtrl.getEl()).on("mouseleave", mouseLeaveHandler).on("mouseover", mouseEnterHandler);
							eventRootCtrl._hasMouseEnter = 1;
						}
					} else if (!eventRootDelegates[name]) {
						$(eventRootCtrl.getEl()).on(name, delegate);
						eventRootDelegates[name] = true;
					}
	
					// Remove the event once it's bound
					nativeEvents[name] = false;
				}
			}
		}
	
		return Control;
	});
	
	// Included from: js/tinymce/classes/ui/Factory.js
	
	/**
	 * Factory.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	/**
	 * This class is a factory for control instances. This enables you
	 * to create instances of controls without having to require the UI controls directly.
	 *
	 * It also allow you to override or add new control types.
	 *
	 * @class tinymce.ui.Factory
	 */
	define("tinymce/ui/Factory", [], function() {
		"use strict";
	
		var types = {}, namespaceInit;
	
		return {
			/**
			 * Adds a new control instance type to the factory.
			 *
			 * @method add
			 * @param {String} type Type name for example "button".
			 * @param {function} typeClass Class type function.
			 */
			add: function(type, typeClass) {
				types[type.toLowerCase()] = typeClass;
			},
	
			/**
			 * Returns true/false if the specified type exists or not.
			 *
			 * @method has
			 * @param {String} type Type to look for.
			 * @return {Boolean} true/false if the control by name exists.
			 */
			has: function(type) {
				return !!types[type.toLowerCase()];
			},
	
			/**
			 * Creates a new control instance based on the settings provided. The instance created will be
			 * based on the specified type property it can also create whole structures of components out of
			 * the specified JSON object.
			 *
			 * @example
			 * tinymce.ui.Factory.create({
			 *     type: 'button',
			 *     text: 'Hello world!'
			 * });
			 *
			 * @method create
			 * @param {Object/String} settings Name/Value object with items used to create the type.
			 * @return {tinymce.ui.Control} Control instance based on the specified type.
			 */
			create: function(type, settings) {
				var ControlType, name, namespace;
	
				// Build type lookup
				if (!namespaceInit) {
					namespace = tinymce.ui;
	
					for (name in namespace) {
						types[name.toLowerCase()] = namespace[name];
					}
	
					namespaceInit = true;
				}
	
				// If string is specified then use it as the type
				if (typeof type == 'string') {
					settings = settings || {};
					settings.type = type;
				} else {
					settings = type;
					type = settings.type;
				}
	
				// Find control type
				type = type.toLowerCase();
				ControlType = types[type];
	
				// #if debug
	
				if (!ControlType) {
					throw new Error("Could not find control by type: " + type);
				}
	
				// #endif
	
				ControlType = new ControlType(settings);
				ControlType.type = type; // Set the type on the instance, this will be used by the Selector engine
	
				return ControlType;
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/KeyboardNavigation.js
	
	/**
	 * KeyboardNavigation.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles keyboard navigation of controls and elements.
	 *
	 * @class tinymce.ui.KeyboardNavigation
	 */
	define("tinymce/ui/KeyboardNavigation", [
	], function() {
		"use strict";
	
		/**
		 * This class handles all keyboard navigation for WAI-ARIA support. Each root container
		 * gets an instance of this class.
		 *
		 * @constructor
		 */
		return function(settings) {
			var root = settings.root, focusedElement, focusedControl;
	
			function isElement(node) {
				return node && node.nodeType === 1;
			}
	
			try {
				focusedElement = document.activeElement;
			} catch (ex) {
				// IE sometimes fails to return a proper element
				focusedElement = document.body;
			}
	
			focusedControl = root.getParentCtrl(focusedElement);
	
			/**
			 * Returns the currently focused elements wai aria role of the currently
			 * focused element or specified element.
			 *
			 * @private
			 * @param {Element} elm Optional element to get role from.
			 * @return {String} Role of specified element.
			 */
			function getRole(elm) {
				elm = elm || focusedElement;
	
				if (isElement(elm)) {
					return elm.getAttribute('role');
				}
	
				return null;
			}
	
			/**
			 * Returns the wai role of the parent element of the currently
			 * focused element or specified element.
			 *
			 * @private
			 * @param {Element} elm Optional element to get parent role from.
			 * @return {String} Role of the first parent that has a role.
			 */
			function getParentRole(elm) {
				var role, parent = elm || focusedElement;
	
				while ((parent = parent.parentNode)) {
					if ((role = getRole(parent))) {
						return role;
					}
				}
			}
	
			/**
			 * Returns a wai aria property by name for example aria-selected.
			 *
			 * @private
			 * @param {String} name Name of the aria property to get for example "disabled".
			 * @return {String} Aria property value.
			 */
			function getAriaProp(name) {
				var elm = focusedElement;
	
				if (isElement(elm)) {
					return elm.getAttribute('aria-' + name);
				}
			}
	
			/**
			 * Is the element a text input element or not.
			 *
			 * @private
			 * @param {Element} elm Element to check if it's an text input element or not.
			 * @return {Boolean} True/false if the element is a text element or not.
			 */
			function isTextInputElement(elm) {
				var tagName = elm.tagName.toUpperCase();
	
				// Notice: since type can be "email" etc we don't check the type
				// So all input elements gets treated as text input elements
				return tagName == "INPUT" || tagName == "TEXTAREA" || tagName == "SELECT";
			}
	
			/**
			 * Returns true/false if the specified element can be focused or not.
			 *
			 * @private
			 * @param {Element} elm DOM element to check if it can be focused or not.
			 * @return {Boolean} True/false if the element can have focus.
			 */
			function canFocus(elm) {
				if (isTextInputElement(elm) && !elm.hidden) {
					return true;
				}
	
				if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(elm))) {
					return true;
				}
	
				return false;
			}
	
			/**
			 * Returns an array of focusable visible elements within the specified container element.
			 *
			 * @private
			 * @param {Element} elm DOM element to find focusable elements within.
			 * @return {Array} Array of focusable elements.
			 */
			function getFocusElements(elm) {
				var elements = [];
	
				function collect(elm) {
					if (elm.nodeType != 1 || elm.style.display == 'none') {
						return;
					}
	
					if (canFocus(elm)) {
						elements.push(elm);
					}
	
					for (var i = 0; i < elm.childNodes.length; i++) {
						collect(elm.childNodes[i]);
					}
				}
	
				collect(elm || root.getEl());
	
				return elements;
			}
	
			/**
			 * Returns the navigation root control for the specified control. The navigation root
			 * is the control that the keyboard navigation gets scoped to for example a menubar or toolbar group.
			 * It will look for parents of the specified target control or the currently focused control if this option is omitted.
			 *
			 * @private
			 * @param {tinymce.ui.Control} targetControl Optional target control to find root of.
			 * @return {tinymce.ui.Control} Navigation root control.
			 */
			function getNavigationRoot(targetControl) {
				var navigationRoot, controls;
	
				targetControl = targetControl || focusedControl;
				controls = targetControl.parents().toArray();
				controls.unshift(targetControl);
	
				for (var i = 0; i < controls.length; i++) {
					navigationRoot = controls[i];
	
					if (navigationRoot.settings.ariaRoot) {
						break;
					}
				}
	
				return navigationRoot;
			}
	
			/**
			 * Focuses the first item in the specified targetControl element or the last aria index if the
			 * navigation root has the ariaRemember option enabled.
			 *
			 * @private
			 * @param {tinymce.ui.Control} targetControl Target control to focus the first item in.
			 */
			function focusFirst(targetControl) {
				var navigationRoot = getNavigationRoot(targetControl);
				var focusElements = getFocusElements(navigationRoot.getEl());
	
				if (navigationRoot.settings.ariaRemember && "lastAriaIndex" in navigationRoot) {
					moveFocusToIndex(navigationRoot.lastAriaIndex, focusElements);
				} else {
					moveFocusToIndex(0, focusElements);
				}
			}
	
			/**
			 * Moves the focus to the specified index within the elements list.
			 * This will scope the index to the size of the element list if it changed.
			 *
			 * @private
			 * @param {Number} idx Specified index to move to.
			 * @param {Array} elements Array with dom elements to move focus within.
			 * @return {Number} Input index or a changed index if it was out of range.
			 */
			function moveFocusToIndex(idx, elements) {
				if (idx < 0) {
					idx = elements.length - 1;
				} else if (idx >= elements.length) {
					idx = 0;
				}
	
				if (elements[idx]) {
					elements[idx].focus();
				}
	
				return idx;
			}
	
			/**
			 * Moves the focus forwards or backwards.
			 *
			 * @private
			 * @param {Number} dir Direction to move in positive means forward, negative means backwards.
			 * @param {Array} elements Optional array of elements to move within defaults to the current navigation roots elements.
			 */
			function moveFocus(dir, elements) {
				var idx = -1, navigationRoot = getNavigationRoot();
	
				elements = elements || getFocusElements(navigationRoot.getEl());
	
				for (var i = 0; i < elements.length; i++) {
					if (elements[i] === focusedElement) {
						idx = i;
					}
				}
	
				idx += dir;
				navigationRoot.lastAriaIndex = moveFocusToIndex(idx, elements);
			}
	
			/**
			 * Moves the focus to the left this is called by the left key.
			 *
			 * @private
			 */
			function left() {
				var parentRole = getParentRole();
	
				if (parentRole == "tablist") {
					moveFocus(-1, getFocusElements(focusedElement.parentNode));
				} else if (focusedControl.parent().submenu) {
					cancel();
				} else {
					moveFocus(-1);
				}
			}
	
			/**
			 * Moves the focus to the right this is called by the right key.
			 *
			 * @private
			 */
			function right() {
				var role = getRole(), parentRole = getParentRole();
	
				if (parentRole == "tablist") {
					moveFocus(1, getFocusElements(focusedElement.parentNode));
				} else if (role == "menuitem" && parentRole == "menu" && getAriaProp('haspopup')) {
					enter();
				} else {
					moveFocus(1);
				}
			}
	
			/**
			 * Moves the focus to the up this is called by the up key.
			 *
			 * @private
			 */
			function up() {
				moveFocus(-1);
			}
	
			/**
			 * Moves the focus to the up this is called by the down key.
			 *
			 * @private
			 */
			function down() {
				var role = getRole(), parentRole = getParentRole();
	
				if (role == "menuitem" && parentRole == "menubar") {
					enter();
				} else if (role == "button" && getAriaProp('haspopup')) {
					enter({key: 'down'});
				} else {
					moveFocus(1);
				}
			}
	
			/**
			 * Moves the focus to the next item or previous item depending on shift key.
			 *
			 * @private
			 * @param {DOMEvent} e DOM event object.
			 */
			function tab(e) {
				var parentRole = getParentRole();
	
				if (parentRole == "tablist") {
					var elm = getFocusElements(focusedControl.getEl('body'))[0];
	
					if (elm) {
						elm.focus();
					}
				} else {
					moveFocus(e.shiftKey ? -1 : 1);
				}
			}
	
			/**
			 * Calls the cancel event on the currently focused control. This is normally done using the Esc key.
			 *
			 * @private
			 */
			function cancel() {
				focusedControl.fire('cancel');
			}
	
			/**
			 * Calls the click event on the currently focused control. This is normally done using the Enter/Space keys.
			 *
			 * @private
			 * @param {Object} aria Optional aria data to pass along with the enter event.
			 */
			function enter(aria) {
				aria = aria || {};
				focusedControl.fire('click', {target: focusedElement, aria: aria});
			}
	
			root.on('keydown', function(e) {
				function handleNonTabOrEscEvent(e, handler) {
					// Ignore non tab keys for text elements
					if (isTextInputElement(focusedElement)) {
						return;
					}
	
					if (getRole(focusedElement) === 'slider') {
						return;
					}
	
					if (handler(e) !== false) {
						e.preventDefault();
					}
				}
	
				if (e.isDefaultPrevented()) {
					return;
				}
	
				switch (e.keyCode) {
					case 37: // DOM_VK_LEFT
						handleNonTabOrEscEvent(e, left);
						break;
	
					case 39: // DOM_VK_RIGHT
						handleNonTabOrEscEvent(e, right);
						break;
	
					case 38: // DOM_VK_UP
						handleNonTabOrEscEvent(e, up);
						break;
	
					case 40: // DOM_VK_DOWN
						handleNonTabOrEscEvent(e, down);
						break;
	
					case 27: // DOM_VK_ESCAPE
						cancel();
						break;
	
					case 14: // DOM_VK_ENTER
					case 13: // DOM_VK_RETURN
					case 32: // DOM_VK_SPACE
						handleNonTabOrEscEvent(e, enter);
						break;
	
					case 9: // DOM_VK_TAB
						if (tab(e) !== false) {
							e.preventDefault();
						}
						break;
				}
			});
	
			root.on('focusin', function(e) {
				focusedElement = e.target;
				focusedControl = e.control;
			});
	
			return {
				focusFirst: focusFirst
			};
		};
	});
	
	// Included from: js/tinymce/classes/ui/Container.js
	
	/**
	 * Container.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Container control. This is extended by all controls that can have
	 * children such as panels etc. You can also use this class directly as an
	 * generic container instance. The container doesn't have any specific role or style.
	 *
	 * @-x-less Container.less
	 * @class tinymce.ui.Container
	 * @extends tinymce.ui.Control
	 */
	define("tinymce/ui/Container", [
		"tinymce/ui/Control",
		"tinymce/ui/Collection",
		"tinymce/ui/Selector",
		"tinymce/ui/Factory",
		"tinymce/ui/KeyboardNavigation",
		"tinymce/util/Tools",
		"tinymce/dom/DomQuery",
		"tinymce/ui/ClassList",
		"tinymce/ui/ReflowQueue"
	], function(Control, Collection, Selector, Factory, KeyboardNavigation, Tools, $, ClassList, ReflowQueue) {
		"use strict";
	
		var selectorCache = {};
	
		return Control.extend({
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Array} items Items to add to container in JSON format or control instances.
			 * @setting {String} layout Layout manager by name to use.
			 * @setting {Object} defaults Default settings to apply to all items.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				settings = self.settings;
	
				if (settings.fixed) {
					self.state.set('fixed', true);
				}
	
				self._items = new Collection();
	
				if (self.isRtl()) {
					self.classes.add('rtl');
				}
	
				self.bodyClasses = new ClassList(function() {
					if (self.state.get('rendered')) {
						self.getEl('body').className = this.toString();
					}
				});
				self.bodyClasses.prefix = self.classPrefix;
	
				self.classes.add('container');
				self.bodyClasses.add('container-body');
	
				if (settings.containerCls) {
					self.classes.add(settings.containerCls);
				}
	
				self._layout = Factory.create((settings.layout || '') + 'layout');
	
				if (self.settings.items) {
					self.add(self.settings.items);
				} else {
					self.add(self.render());
				}
	
				// TODO: Fix this!
				self._hasBody = true;
			},
	
			/**
			 * Returns a collection of child items that the container currently have.
			 *
			 * @method items
			 * @return {tinymce.ui.Collection} Control collection direct child controls.
			 */
			items: function() {
				return this._items;
			},
	
			/**
			 * Find child controls by selector.
			 *
			 * @method find
			 * @param {String} selector Selector CSS pattern to find children by.
			 * @return {tinymce.ui.Collection} Control collection with child controls.
			 */
			find: function(selector) {
				selector = selectorCache[selector] = selectorCache[selector] || new Selector(selector);
	
				return selector.find(this);
			},
	
			/**
			 * Adds one or many items to the current container. This will create instances of
			 * the object representations if needed.
			 *
			 * @method add
			 * @param {Array/Object/tinymce.ui.Control} items Array or item that will be added to the container.
			 * @return {tinymce.ui.Collection} Current collection control.
			 */
			add: function(items) {
				var self = this;
	
				self.items().add(self.create(items)).parent(self);
	
				return self;
			},
	
			/**
			 * Focuses the current container instance. This will look
			 * for the first control in the container and focus that.
			 *
			 * @method focus
			 * @param {Boolean} keyboard Optional true/false if the focus was a keyboard focus or not.
			 * @return {tinymce.ui.Collection} Current instance.
			 */
			focus: function(keyboard) {
				var self = this, focusCtrl, keyboardNav, items;
	
				if (keyboard) {
					keyboardNav = self.keyboardNav || self.parents().eq(-1)[0].keyboardNav;
	
					if (keyboardNav) {
						keyboardNav.focusFirst(self);
						return;
					}
				}
	
				items = self.find('*');
	
				// TODO: Figure out a better way to auto focus alert dialog buttons
				if (self.statusbar) {
					items.add(self.statusbar.items());
				}
	
				items.each(function(ctrl) {
					if (ctrl.settings.autofocus) {
						focusCtrl = null;
						return false;
					}
	
					if (ctrl.canFocus) {
						focusCtrl = focusCtrl || ctrl;
					}
				});
	
				if (focusCtrl) {
					focusCtrl.focus();
				}
	
				return self;
			},
	
			/**
			 * Replaces the specified child control with a new control.
			 *
			 * @method replace
			 * @param {tinymce.ui.Control} oldItem Old item to be replaced.
			 * @param {tinymce.ui.Control} newItem New item to be inserted.
			 */
			replace: function(oldItem, newItem) {
				var ctrlElm, items = this.items(), i = items.length;
	
				// Replace the item in collection
				while (i--) {
					if (items[i] === oldItem) {
						items[i] = newItem;
						break;
					}
				}
	
				if (i >= 0) {
					// Remove new item from DOM
					ctrlElm = newItem.getEl();
					if (ctrlElm) {
						ctrlElm.parentNode.removeChild(ctrlElm);
					}
	
					// Remove old item from DOM
					ctrlElm = oldItem.getEl();
					if (ctrlElm) {
						ctrlElm.parentNode.removeChild(ctrlElm);
					}
				}
	
				// Adopt the item
				newItem.parent(this);
			},
	
			/**
			 * Creates the specified items. If any of the items is plain JSON style objects
			 * it will convert these into real tinymce.ui.Control instances.
			 *
			 * @method create
			 * @param {Array} items Array of items to convert into control instances.
			 * @return {Array} Array with control instances.
			 */
			create: function(items) {
				var self = this, settings, ctrlItems = [];
	
				// Non array structure, then force it into an array
				if (!Tools.isArray(items)) {
					items = [items];
				}
	
				// Add default type to each child control
				Tools.each(items, function(item) {
					if (item) {
						// Construct item if needed
						if (!(item instanceof Control)) {
							// Name only then convert it to an object
							if (typeof item == "string") {
								item = {type: item};
							}
	
							// Create control instance based on input settings and default settings
							settings = Tools.extend({}, self.settings.defaults, item);
							item.type = settings.type = settings.type || item.type || self.settings.defaultType ||
								(settings.defaults ? settings.defaults.type : null);
							item = Factory.create(settings);
						}
	
						ctrlItems.push(item);
					}
				});
	
				return ctrlItems;
			},
	
			/**
			 * Renders new control instances.
			 *
			 * @private
			 */
			renderNew: function() {
				var self = this;
	
				// Render any new items
				self.items().each(function(ctrl, index) {
					var containerElm;
	
					ctrl.parent(self);
	
					if (!ctrl.state.get('rendered')) {
						containerElm = self.getEl('body');
	
						// Insert or append the item
						if (containerElm.hasChildNodes() && index <= containerElm.childNodes.length - 1) {
							$(containerElm.childNodes[index]).before(ctrl.renderHtml());
						} else {
							$(containerElm).append(ctrl.renderHtml());
						}
	
						ctrl.postRender();
						ReflowQueue.add(ctrl);
					}
				});
	
				self._layout.applyClasses(self.items().filter(':visible'));
				self._lastRect = null;
	
				return self;
			},
	
			/**
			 * Appends new instances to the current container.
			 *
			 * @method append
			 * @param {Array/tinymce.ui.Collection} items Array if controls to append.
			 * @return {tinymce.ui.Container} Current container instance.
			 */
			append: function(items) {
				return this.add(items).renderNew();
			},
	
			/**
			 * Prepends new instances to the current container.
			 *
			 * @method prepend
			 * @param {Array/tinymce.ui.Collection} items Array if controls to prepend.
			 * @return {tinymce.ui.Container} Current container instance.
			 */
			prepend: function(items) {
				var self = this;
	
				self.items().set(self.create(items).concat(self.items().toArray()));
	
				return self.renderNew();
			},
	
			/**
			 * Inserts an control at a specific index.
			 *
			 * @method insert
			 * @param {Array/tinymce.ui.Collection} items Array if controls to insert.
			 * @param {Number} index Index to insert controls at.
			 * @param {Boolean} [before=false] Inserts controls before the index.
			 */
			insert: function(items, index, before) {
				var self = this, curItems, beforeItems, afterItems;
	
				items = self.create(items);
				curItems = self.items();
	
				if (!before && index < curItems.length - 1) {
					index += 1;
				}
	
				if (index >= 0 && index < curItems.length) {
					beforeItems = curItems.slice(0, index).toArray();
					afterItems = curItems.slice(index).toArray();
					curItems.set(beforeItems.concat(items, afterItems));
				}
	
				return self.renderNew();
			},
	
			/**
			 * Populates the form fields from the specified JSON data object.
			 *
			 * Control items in the form that matches the data will have it's value set.
			 *
			 * @method fromJSON
			 * @param {Object} data JSON data object to set control values by.
			 * @return {tinymce.ui.Container} Current form instance.
			 */
			fromJSON: function(data) {
				var self = this;
	
				for (var name in data) {
					self.find('#' + name).value(data[name]);
				}
	
				return self;
			},
	
			/**
			 * Serializes the form into a JSON object by getting all items
			 * that has a name and a value.
			 *
			 * @method toJSON
			 * @return {Object} JSON object with form data.
			 */
			toJSON: function() {
				var self = this, data = {};
	
				self.find('*').each(function(ctrl) {
					var name = ctrl.name(), value = ctrl.value();
	
					if (name && typeof value != "undefined") {
						data[name] = value;
					}
				});
	
				return data;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, role = this.settings.role;
	
				self.preRender();
				layout.preRender(self);
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' +
						'<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
							(self.settings.html || '') + layout.renderHtml(self) +
						'</div>' +
					'</div>'
				);
			},
	
			/**
			 * Post render method. Called after the control has been rendered to the target.
			 *
			 * @method postRender
			 * @return {tinymce.ui.Container} Current combobox instance.
			 */
			postRender: function() {
				var self = this, box;
	
				self.items().exec('postRender');
				self._super();
	
				self._layout.postRender(self);
				self.state.set('rendered', true);
	
				if (self.settings.style) {
					self.$el.css(self.settings.style);
				}
	
				if (self.settings.border) {
					box = self.borderBox;
					self.$el.css({
						'border-top-width': box.top,
						'border-right-width': box.right,
						'border-bottom-width': box.bottom,
						'border-left-width': box.left
					});
				}
	
				if (!self.parent()) {
					self.keyboardNav = new KeyboardNavigation({
						root: self
					});
				}
	
				return self;
			},
	
			/**
			 * Initializes the current controls layout rect.
			 * This will be executed by the layout managers to determine the
			 * default minWidth/minHeight etc.
			 *
			 * @method initLayoutRect
			 * @return {Object} Layout rect instance.
			 */
			initLayoutRect: function() {
				var self = this, layoutRect = self._super();
	
				// Recalc container size by asking layout manager
				self._layout.recalc(self);
	
				return layoutRect;
			},
	
			/**
			 * Recalculates the positions of the controls in the current container.
			 * This is invoked by the reflow method and shouldn't be called directly.
			 *
			 * @method recalc
			 */
			recalc: function() {
				var self = this, rect = self._layoutRect, lastRect = self._lastRect;
	
				if (!lastRect || lastRect.w != rect.w || lastRect.h != rect.h) {
					self._layout.recalc(self);
					rect = self.layoutRect();
					self._lastRect = {x: rect.x, y: rect.y, w: rect.w, h: rect.h};
					return true;
				}
			},
	
			/**
			 * Reflows the current container and it's children and possible parents.
			 * This should be used after you for example append children to the current control so
			 * that the layout managers know that they need to reposition everything.
			 *
			 * @example
			 * container.append({type: 'button', text: 'My button'}).reflow();
			 *
			 * @method reflow
			 * @return {tinymce.ui.Container} Current container instance.
			 */
			reflow: function() {
				var i;
	
				ReflowQueue.remove(this);
	
				if (this.visible()) {
					Control.repaintControls = [];
					Control.repaintControls.map = {};
	
					this.recalc();
					i = Control.repaintControls.length;
	
					while (i--) {
						Control.repaintControls[i].repaint();
					}
	
					// TODO: Fix me!
					if (this.settings.layout !== "flow" && this.settings.layout !== "stack") {
						this.repaint();
					}
	
					Control.repaintControls = [];
				}
	
				return this;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/DragHelper.js
	
	/**
	 * DragHelper.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Drag/drop helper class.
	 *
	 * @example
	 * var dragHelper = new tinymce.ui.DragHelper('mydiv', {
	 *     start: function(evt) {
	 *     },
	 *
	 *     drag: function(evt) {
	 *     },
	 *
	 *     end: function(evt) {
	 *     }
	 * });
	 *
	 * @class tinymce.ui.DragHelper
	 */
	define("tinymce/ui/DragHelper", [
		"tinymce/dom/DomQuery"
	], function($) {
		"use strict";
	
		function getDocumentSize(doc) {
			var documentElement, body, scrollWidth, clientWidth;
			var offsetWidth, scrollHeight, clientHeight, offsetHeight, max = Math.max;
	
			documentElement = doc.documentElement;
			body = doc.body;
	
			scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
			clientWidth = max(documentElement.clientWidth, body.clientWidth);
			offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	
			scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
			clientHeight = max(documentElement.clientHeight, body.clientHeight);
			offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	
			return {
				width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
				height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
			};
		}
	
		function updateWithTouchData(e) {
			var keys, i;
	
			if (e.changedTouches) {
				keys = "screenX screenY pageX pageY clientX clientY".split(' ');
				for (i = 0; i < keys.length; i++) {
					e[keys[i]] = e.changedTouches[0][keys[i]];
				}
			}
		}
	
		return function(id, settings) {
			var $eventOverlay, doc = settings.document || document, downButton, start, stop, drag, startX, startY;
	
			settings = settings || {};
	
			function getHandleElm() {
				return doc.getElementById(settings.handle || id);
			}
	
			start = function(e) {
				var docSize = getDocumentSize(doc), handleElm, cursor;
	
				updateWithTouchData(e);
	
				e.preventDefault();
				downButton = e.button;
				handleElm = getHandleElm();
				startX = e.screenX;
				startY = e.screenY;
	
				// Grab cursor from handle so we can place it on overlay
				if (window.getComputedStyle) {
					cursor = window.getComputedStyle(handleElm, null).getPropertyValue("cursor");
				} else {
					cursor = handleElm.runtimeStyle.cursor;
				}
	
				$eventOverlay = $('<div>').css({
					position: "absolute",
					top: 0, left: 0,
					width: docSize.width,
					height: docSize.height,
					zIndex: 0x7FFFFFFF,
					opacity: 0.0001,
					cursor: cursor
				}).appendTo(doc.body);
	
				$(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
	
				settings.start(e);
			};
	
			drag = function(e) {
				updateWithTouchData(e);
	
				if (e.button !== downButton) {
					return stop(e);
				}
	
				e.deltaX = e.screenX - startX;
				e.deltaY = e.screenY - startY;
	
				e.preventDefault();
				settings.drag(e);
			};
	
			stop = function(e) {
				updateWithTouchData(e);
	
				$(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
	
				$eventOverlay.remove();
	
				if (settings.stop) {
					settings.stop(e);
				}
			};
	
			/**
			 * Destroys the drag/drop helper instance.
			 *
			 * @method destroy
			 */
			this.destroy = function() {
				$(getHandleElm()).off();
			};
	
			$(getHandleElm()).on('mousedown touchstart', start);
		};
	});
	
	// Included from: js/tinymce/classes/ui/Scrollable.js
	
	/**
	 * Scrollable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin makes controls scrollable using custom scrollbars.
	 *
	 * @-x-less Scrollable.less
	 * @mixin tinymce.ui.Scrollable
	 */
	define("tinymce/ui/Scrollable", [
		"tinymce/dom/DomQuery",
		"tinymce/ui/DragHelper"
	], function($, DragHelper) {
		"use strict";
	
		return {
			init: function() {
				var self = this;
				self.on('repaint', self.renderScroll);
			},
	
			renderScroll: function() {
				var self = this, margin = 2;
	
				function repaintScroll() {
					var hasScrollH, hasScrollV, bodyElm;
	
					function repaintAxis(axisName, posName, sizeName, contentSizeName, hasScroll, ax) {
						var containerElm, scrollBarElm, scrollThumbElm;
						var containerSize, scrollSize, ratio, rect;
						var posNameLower, sizeNameLower;
	
						scrollBarElm = self.getEl('scroll' + axisName);
						if (scrollBarElm) {
							posNameLower = posName.toLowerCase();
							sizeNameLower = sizeName.toLowerCase();
	
							$(self.getEl('absend')).css(posNameLower, self.layoutRect()[contentSizeName] - 1);
	
							if (!hasScroll) {
								$(scrollBarElm).css('display', 'none');
								return;
							}
	
							$(scrollBarElm).css('display', 'block');
							containerElm = self.getEl('body');
							scrollThumbElm = self.getEl('scroll' + axisName + "t");
							containerSize = containerElm["client" + sizeName] - (margin * 2);
							containerSize -= hasScrollH && hasScrollV ? scrollBarElm["client" + ax] : 0;
							scrollSize = containerElm["scroll" + sizeName];
							ratio = containerSize / scrollSize;
	
							rect = {};
							rect[posNameLower] = containerElm["offset" + posName] + margin;
							rect[sizeNameLower] = containerSize;
							$(scrollBarElm).css(rect);
	
							rect = {};
							rect[posNameLower] = containerElm["scroll" + posName] * ratio;
							rect[sizeNameLower] = containerSize * ratio;
							$(scrollThumbElm).css(rect);
						}
					}
	
					bodyElm = self.getEl('body');
					hasScrollH = bodyElm.scrollWidth > bodyElm.clientWidth;
					hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
	
					repaintAxis("h", "Left", "Width", "contentW", hasScrollH, "Height");
					repaintAxis("v", "Top", "Height", "contentH", hasScrollV, "Width");
				}
	
				function addScroll() {
					function addScrollAxis(axisName, posName, sizeName, deltaPosName, ax) {
						var scrollStart, axisId = self._id + '-scroll' + axisName, prefix = self.classPrefix;
	
						$(self.getEl()).append(
							'<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + axisName + '">' +
								'<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' +
							'</div>'
						);
	
						self.draghelper = new DragHelper(axisId + 't', {
							start: function() {
								scrollStart = self.getEl('body')["scroll" + posName];
								$('#' + axisId).addClass(prefix + 'active');
							},
	
							drag: function(e) {
								var ratio, hasScrollH, hasScrollV, containerSize, layoutRect = self.layoutRect();
	
								hasScrollH = layoutRect.contentW > layoutRect.innerW;
								hasScrollV = layoutRect.contentH > layoutRect.innerH;
								containerSize = self.getEl('body')["client" + sizeName] - (margin * 2);
								containerSize -= hasScrollH && hasScrollV ? self.getEl('scroll' + axisName)["client" + ax] : 0;
	
								ratio = containerSize / self.getEl('body')["scroll" + sizeName];
								self.getEl('body')["scroll" + posName] = scrollStart + (e["delta" + deltaPosName] / ratio);
							},
	
							stop: function() {
								$('#' + axisId).removeClass(prefix + 'active');
							}
						});
					}
	
					self.classes.add('scroll');
	
					addScrollAxis("v", "Top", "Height", "Y", "Width");
					addScrollAxis("h", "Left", "Width", "X", "Height");
				}
	
				if (self.settings.autoScroll) {
					if (!self._hasScroll) {
						self._hasScroll = true;
						addScroll();
	
						self.on('wheel', function(e) {
							var bodyEl = self.getEl('body');
	
							bodyEl.scrollLeft += (e.deltaX || 0) * 10;
							bodyEl.scrollTop += e.deltaY * 10;
	
							repaintScroll();
						});
	
						$(self.getEl('body')).on("scroll", repaintScroll);
					}
	
					repaintScroll();
				}
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/Panel.js
	
	/**
	 * Panel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new panel.
	 *
	 * @-x-less Panel.less
	 * @class tinymce.ui.Panel
	 * @extends tinymce.ui.Container
	 * @mixes tinymce.ui.Scrollable
	 */
	define("tinymce/ui/Panel", [
		"tinymce/ui/Container",
		"tinymce/ui/Scrollable"
	], function(Container, Scrollable) {
		"use strict";
	
		return Container.extend({
			Defaults: {
				layout: 'fit',
				containerCls: 'panel'
			},
	
			Mixins: [Scrollable],
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, innerHtml = self.settings.html;
	
				self.preRender();
				layout.preRender(self);
	
				if (typeof innerHtml == "undefined") {
					innerHtml = (
						'<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
							layout.renderHtml(self) +
						'</div>'
					);
				} else {
					if (typeof innerHtml == 'function') {
						innerHtml = innerHtml.call(self);
					}
	
					self._hasBody = false;
				}
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1" role="group">' +
						(self._preBodyHtml || '') +
						innerHtml +
					'</div>'
				);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Movable.js
	
	/**
	 * Movable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Movable mixin. Makes controls movable absolute and relative to other elements.
	 *
	 * @mixin tinymce.ui.Movable
	 */
	define("tinymce/ui/Movable", [
		"tinymce/ui/DomUtils"
	], function(DomUtils) {
		"use strict";
	
		function calculateRelativePosition(ctrl, targetElm, rel) {
			var ctrlElm, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
	
			viewport = DomUtils.getViewPort();
	
			// Get pos of target
			pos = DomUtils.getPos(targetElm);
			x = pos.x;
			y = pos.y;
	
			if (ctrl.state.get('fixed') && DomUtils.getRuntimeStyle(document.body, 'position') == 'static') {
				x -= viewport.x;
				y -= viewport.y;
			}
	
			// Get size of self
			ctrlElm = ctrl.getEl();
			size = DomUtils.getSize(ctrlElm);
			selfW = size.width;
			selfH = size.height;
	
			// Get size of target
			size = DomUtils.getSize(targetElm);
			targetW = size.width;
			targetH = size.height;
	
			// Parse align string
			rel = (rel || '').split('');
	
			// Target corners
			if (rel[0] === 'b') {
				y += targetH;
			}
	
			if (rel[1] === 'r') {
				x += targetW;
			}
	
			if (rel[0] === 'c') {
				y += Math.round(targetH / 2);
			}
	
			if (rel[1] === 'c') {
				x += Math.round(targetW / 2);
			}
	
			// Self corners
			if (rel[3] === 'b') {
				y -= selfH;
			}
	
			if (rel[4] === 'r') {
				x -= selfW;
			}
	
			if (rel[3] === 'c') {
				y -= Math.round(selfH / 2);
			}
	
			if (rel[4] === 'c') {
				x -= Math.round(selfW / 2);
			}
	
			return {
				x: x,
				y: y,
				w: selfW,
				h: selfH
			};
		}
	
		return {
			/**
			 * Tests various positions to get the most suitable one.
			 *
			 * @method testMoveRel
			 * @param {DOMElement} elm Element to position against.
			 * @param {Array} rels Array with relative positions.
			 * @return {String} Best suitable relative position.
			 */
			testMoveRel: function(elm, rels) {
				var viewPortRect = DomUtils.getViewPort();
	
				for (var i = 0; i < rels.length; i++) {
					var pos = calculateRelativePosition(this, elm, rels[i]);
	
					if (this.state.get('fixed')) {
						if (pos.x > 0 && pos.x + pos.w < viewPortRect.w && pos.y > 0 && pos.y + pos.h < viewPortRect.h) {
							return rels[i];
						}
					} else {
						if (pos.x > viewPortRect.x && pos.x + pos.w < viewPortRect.w + viewPortRect.x &&
							pos.y > viewPortRect.y && pos.y + pos.h < viewPortRect.h + viewPortRect.y) {
							return rels[i];
						}
					}
				}
	
				return rels[0];
			},
	
			/**
			 * Move relative to the specified element.
			 *
			 * @method moveRel
			 * @param {Element} elm Element to move relative to.
			 * @param {String} rel Relative mode. For example: br-tl.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			moveRel: function(elm, rel) {
				if (typeof rel != 'string') {
					rel = this.testMoveRel(elm, rel);
				}
	
				var pos = calculateRelativePosition(this, elm, rel);
				return this.moveTo(pos.x, pos.y);
			},
	
			/**
			 * Move by a relative x, y values.
			 *
			 * @method moveBy
			 * @param {Number} dx Relative x position.
			 * @param {Number} dy Relative y position.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			moveBy: function(dx, dy) {
				var self = this, rect = self.layoutRect();
	
				self.moveTo(rect.x + dx, rect.y + dy);
	
				return self;
			},
	
			/**
			 * Move to absolute position.
			 *
			 * @method moveTo
			 * @param {Number} x Absolute x position.
			 * @param {Number} y Absolute y position.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			moveTo: function(x, y) {
				var self = this;
	
				// TODO: Move this to some global class
				function constrain(value, max, size) {
					if (value < 0) {
						return 0;
					}
	
					if (value + size > max) {
						value = max - size;
						return value < 0 ? 0 : value;
					}
	
					return value;
				}
	
				if (self.settings.constrainToViewport) {
					var viewPortRect = DomUtils.getViewPort(window);
					var layoutRect = self.layoutRect();
	
					x = constrain(x, viewPortRect.w + viewPortRect.x, layoutRect.w);
					y = constrain(y, viewPortRect.h + viewPortRect.y, layoutRect.h);
				}
	
				if (self.state.get('rendered')) {
					self.layoutRect({x: x, y: y}).repaint();
				} else {
					self.settings.x = x;
					self.settings.y = y;
				}
	
				self.fire('move', {x: x, y: y});
	
				return self;
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/Resizable.js
	
	/**
	 * Resizable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Resizable mixin. Enables controls to be resized.
	 *
	 * @mixin tinymce.ui.Resizable
	 */
	define("tinymce/ui/Resizable", [
		"tinymce/ui/DomUtils"
	], function(DomUtils) {
		"use strict";
	
		return {
			/**
			 * Resizes the control to contents.
			 *
			 * @method resizeToContent
			 */
			resizeToContent: function() {
				this._layoutRect.autoResize = true;
				this._lastRect = null;
				this.reflow();
			},
	
			/**
			 * Resizes the control to a specific width/height.
			 *
			 * @method resizeTo
			 * @param {Number} w Control width.
			 * @param {Number} h Control height.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			resizeTo: function(w, h) {
				// TODO: Fix hack
				if (w <= 1 || h <= 1) {
					var rect = DomUtils.getWindowSize();
	
					w = w <= 1 ? w * rect.w : w;
					h = h <= 1 ? h * rect.h : h;
				}
	
				this._layoutRect.autoResize = false;
				return this.layoutRect({minW: w, minH: h, w: w, h: h}).reflow();
			},
	
			/**
			 * Resizes the control to a specific relative width/height.
			 *
			 * @method resizeBy
			 * @param {Number} dw Relative control width.
			 * @param {Number} dh Relative control height.
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			resizeBy: function(dw, dh) {
				var self = this, rect = self.layoutRect();
	
				return self.resizeTo(rect.w + dw, rect.h + dh);
			}
		};
	});
	
	// Included from: js/tinymce/classes/ui/FloatPanel.js
	
	/**
	 * FloatPanel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a floating panel.
	 *
	 * @-x-less FloatPanel.less
	 * @class tinymce.ui.FloatPanel
	 * @extends tinymce.ui.Panel
	 * @mixes tinymce.ui.Movable
	 * @mixes tinymce.ui.Resizable
	 */
	define("tinymce/ui/FloatPanel", [
		"tinymce/ui/Panel",
		"tinymce/ui/Movable",
		"tinymce/ui/Resizable",
		"tinymce/ui/DomUtils",
		"tinymce/dom/DomQuery",
		"tinymce/util/Delay"
	], function(Panel, Movable, Resizable, DomUtils, $, Delay) {
		"use strict";
	
		var documentClickHandler, documentScrollHandler, windowResizeHandler, visiblePanels = [];
		var zOrder = [], hasModal;
	
		function isChildOf(ctrl, parent) {
			while (ctrl) {
				if (ctrl == parent) {
					return true;
				}
	
				ctrl = ctrl.parent();
			}
		}
	
		function skipOrHidePanels(e) {
			// Hide any float panel when a click/focus out is out side that float panel and the
			// float panels direct parent for example a click on a menu button
			var i = visiblePanels.length;
	
			while (i--) {
				var panel = visiblePanels[i], clickCtrl = panel.getParentCtrl(e.target);
	
				if (panel.settings.autohide) {
					if (clickCtrl) {
						if (isChildOf(clickCtrl, panel) || panel.parent() === clickCtrl) {
							continue;
						}
					}
	
					e = panel.fire('autohide', {target: e.target});
					if (!e.isDefaultPrevented()) {
						panel.hide();
					}
				}
			}
		}
	
		function bindDocumentClickHandler() {
	
			if (!documentClickHandler) {
				documentClickHandler = function(e) {
					// Gecko fires click event and in the wrong order on Mac so lets normalize
					if (e.button == 2) {
						return;
					}
	
					skipOrHidePanels(e);
				};
	
				$(document).on('click touchstart', documentClickHandler);
			}
		}
	
		function bindDocumentScrollHandler() {
			if (!documentScrollHandler) {
				documentScrollHandler = function() {
					var i;
	
					i = visiblePanels.length;
					while (i--) {
						repositionPanel(visiblePanels[i]);
					}
				};
	
				$(window).on('scroll', documentScrollHandler);
			}
		}
	
		function bindWindowResizeHandler() {
			if (!windowResizeHandler) {
				var docElm = document.documentElement, clientWidth = docElm.clientWidth, clientHeight = docElm.clientHeight;
	
				windowResizeHandler = function() {
					// Workaround for #7065 IE 7 fires resize events event though the window wasn't resized
					if (!document.all || clientWidth != docElm.clientWidth || clientHeight != docElm.clientHeight) {
						clientWidth = docElm.clientWidth;
						clientHeight = docElm.clientHeight;
						FloatPanel.hideAll();
					}
				};
	
				$(window).on('resize', windowResizeHandler);
			}
		}
	
		/**
		 * Repositions the panel to the top of page if the panel is outside of the visual viewport. It will
		 * also reposition all child panels of the current panel.
		 */
		function repositionPanel(panel) {
			var scrollY = DomUtils.getViewPort().y;
	
			function toggleFixedChildPanels(fixed, deltaY) {
				var parent;
	
				for (var i = 0; i < visiblePanels.length; i++) {
					if (visiblePanels[i] != panel) {
						parent = visiblePanels[i].parent();
	
						while (parent && (parent = parent.parent())) {
							if (parent == panel) {
								visiblePanels[i].fixed(fixed).moveBy(0, deltaY).repaint();
							}
						}
					}
				}
			}
	
			if (panel.settings.autofix) {
				if (!panel.state.get('fixed')) {
					panel._autoFixY = panel.layoutRect().y;
	
					if (panel._autoFixY < scrollY) {
						panel.fixed(true).layoutRect({y: 0}).repaint();
						toggleFixedChildPanels(true, scrollY - panel._autoFixY);
					}
				} else {
					if (panel._autoFixY > scrollY) {
						panel.fixed(false).layoutRect({y: panel._autoFixY}).repaint();
						toggleFixedChildPanels(false, panel._autoFixY - scrollY);
					}
				}
			}
		}
	
		function addRemove(add, ctrl) {
			var i, zIndex = FloatPanel.zIndex || 0xFFFF, topModal;
	
			if (add) {
				zOrder.push(ctrl);
			} else {
				i = zOrder.length;
	
				while (i--) {
					if (zOrder[i] === ctrl) {
						zOrder.splice(i, 1);
					}
				}
			}
	
			if (zOrder.length) {
				for (i = 0; i < zOrder.length; i++) {
					if (zOrder[i].modal) {
						zIndex++;
						topModal = zOrder[i];
					}
	
					zOrder[i].getEl().style.zIndex = zIndex;
					zOrder[i].zIndex = zIndex;
					zIndex++;
				}
			}
	
			var modalBlockEl = $('#' + ctrl.classPrefix + 'modal-block', ctrl.getContainerElm())[0];
	
			if (topModal) {
				$(modalBlockEl).css('z-index', topModal.zIndex - 1);
			} else if (modalBlockEl) {
				modalBlockEl.parentNode.removeChild(modalBlockEl);
				hasModal = false;
			}
	
			FloatPanel.currentZIndex = zIndex;
		}
	
		var FloatPanel = Panel.extend({
			Mixins: [Movable, Resizable],
	
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} autohide Automatically hide the panel.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				self._eventsRoot = self;
	
				self.classes.add('floatpanel');
	
				// Hide floatpanes on click out side the root button
				if (settings.autohide) {
					bindDocumentClickHandler();
					bindWindowResizeHandler();
					visiblePanels.push(self);
				}
	
				if (settings.autofix) {
					bindDocumentScrollHandler();
	
					self.on('move', function() {
						repositionPanel(this);
					});
				}
	
				self.on('postrender show', function(e) {
					if (e.control == self) {
						var $modalBlockEl, prefix = self.classPrefix;
	
						if (self.modal && !hasModal) {
							$modalBlockEl = $('#' + prefix + 'modal-block', self.getContainerElm());
							if (!$modalBlockEl[0]) {
								$modalBlockEl = $(
									'<div id="' + prefix + 'modal-block" class="' + prefix + 'reset ' + prefix + 'fade"></div>'
								).appendTo(self.getContainerElm());
							}
	
							Delay.setTimeout(function() {
								$modalBlockEl.addClass(prefix + 'in');
								$(self.getEl()).addClass(prefix + 'in');
							});
	
							hasModal = true;
						}
	
						addRemove(true, self);
					}
				});
	
				self.on('show', function() {
					self.parents().each(function(ctrl) {
						if (ctrl.state.get('fixed')) {
							self.fixed(true);
							return false;
						}
					});
				});
	
				if (settings.popover) {
					self._preBodyHtml = '<div class="' + self.classPrefix + 'arrow"></div>';
					self.classes.add('popover').add('bottom').add(self.isRtl() ? 'end' : 'start');
				}
	
				self.aria('label', settings.ariaLabel);
				self.aria('labelledby', self._id);
				self.aria('describedby', self.describedBy || self._id + '-none');
			},
	
			fixed: function(state) {
				var self = this;
	
				if (self.state.get('fixed') != state) {
					if (self.state.get('rendered')) {
						var viewport = DomUtils.getViewPort();
	
						if (state) {
							self.layoutRect().y -= viewport.y;
						} else {
							self.layoutRect().y += viewport.y;
						}
					}
	
					self.classes.toggle('fixed', state);
					self.state.set('fixed', state);
				}
	
				return self;
			},
	
			/**
			 * Shows the current float panel.
			 *
			 * @method show
			 * @return {tinymce.ui.FloatPanel} Current floatpanel instance.
			 */
			show: function() {
				var self = this, i, state = self._super();
	
				i = visiblePanels.length;
				while (i--) {
					if (visiblePanels[i] === self) {
						break;
					}
				}
	
				if (i === -1) {
					visiblePanels.push(self);
				}
	
				return state;
			},
	
			/**
			 * Hides the current float panel.
			 *
			 * @method hide
			 * @return {tinymce.ui.FloatPanel} Current floatpanel instance.
			 */
			hide: function() {
				removeVisiblePanel(this);
				addRemove(false, this);
	
				return this._super();
			},
	
			/**
			 * Hide all visible float panels with he autohide setting enabled. This is for
			 * manually hiding floating menus or panels.
			 *
			 * @method hideAll
			 */
			hideAll: function() {
				FloatPanel.hideAll();
			},
	
			/**
			 * Closes the float panel. This will remove the float panel from page and fire the close event.
			 *
			 * @method close
			 */
			close: function() {
				var self = this;
	
				if (!self.fire('close').isDefaultPrevented()) {
					self.remove();
					addRemove(false, self);
				}
	
				return self;
			},
	
			/**
			 * Removes the float panel from page.
			 *
			 * @method remove
			 */
			remove: function() {
				removeVisiblePanel(this);
				this._super();
			},
	
			postRender: function() {
				var self = this;
	
				if (self.settings.bodyRole) {
					this.getEl('body').setAttribute('role', self.settings.bodyRole);
				}
	
				return self._super();
			}
		});
	
		/**
		 * Hide all visible float panels with he autohide setting enabled. This is for
		 * manually hiding floating menus or panels.
		 *
		 * @static
		 * @method hideAll
		 */
		FloatPanel.hideAll = function() {
			var i = visiblePanels.length;
	
			while (i--) {
				var panel = visiblePanels[i];
	
				if (panel && panel.settings.autohide) {
					panel.hide();
					visiblePanels.splice(i, 1);
				}
			}
		};
	
		function removeVisiblePanel(panel) {
			var i;
	
			i = visiblePanels.length;
			while (i--) {
				if (visiblePanels[i] === panel) {
					visiblePanels.splice(i, 1);
				}
			}
	
			i = zOrder.length;
			while (i--) {
				if (zOrder[i] === panel) {
					zOrder.splice(i, 1);
				}
			}
		}
	
		return FloatPanel;
	});
	
	// Included from: js/tinymce/classes/ui/Window.js
	
	/**
	 * Window.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new window.
	 *
	 * @-x-less Window.less
	 * @class tinymce.ui.Window
	 * @extends tinymce.ui.FloatPanel
	 */
	define("tinymce/ui/Window", [
		"tinymce/ui/FloatPanel",
		"tinymce/ui/Panel",
		"tinymce/ui/DomUtils",
		"tinymce/dom/DomQuery",
		"tinymce/ui/DragHelper",
		"tinymce/ui/BoxUtils",
		"tinymce/Env",
		"tinymce/util/Delay"
	], function(FloatPanel, Panel, DomUtils, $, DragHelper, BoxUtils, Env, Delay) {
		"use strict";
	
		var windows = [], oldMetaValue = '';
	
		function toggleFullScreenState(state) {
			var noScaleMetaValue = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0',
				viewport = $("meta[name=viewport]")[0],
				contentValue;
	
			if (Env.overrideViewPort === false) {
				return;
			}
	
			if (!viewport) {
				viewport = document.createElement('meta');
				viewport.setAttribute('name', 'viewport');
				document.getElementsByTagName('head')[0].appendChild(viewport);
			}
	
			contentValue = viewport.getAttribute('content');
			if (contentValue && typeof oldMetaValue != 'undefined') {
				oldMetaValue = contentValue;
			}
	
			viewport.setAttribute('content', state ? noScaleMetaValue : oldMetaValue);
		}
	
		function toggleBodyFullScreenClasses(classPrefix) {
			for (var i = 0; i < windows.length; i++) {
				if (windows[i]._fullscreen) {
					return;
				}
			}
	
			$([document.documentElement, document.body]).removeClass(classPrefix + 'fullscreen');
		}
	
		function handleWindowResize() {
			if (!Env.desktop) {
				var lastSize = {
					w: window.innerWidth,
					h: window.innerHeight
				};
	
				Delay.setInterval(function() {
					var w = window.innerWidth,
						h = window.innerHeight;
	
					if (lastSize.w != w || lastSize.h != h) {
						lastSize = {
							w: w,
							h: h
						};
	
						$(window).trigger('resize');
					}
				}, 100);
			}
	
			function reposition() {
				var i, rect = DomUtils.getWindowSize(), layoutRect;
	
				for (i = 0; i < windows.length; i++) {
					layoutRect = windows[i].layoutRect();
	
					windows[i].moveTo(
						windows[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2),
						windows[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2)
					);
				}
			}
	
			$(window).on('resize', reposition);
		}
	
		var Window = FloatPanel.extend({
			modal: true,
	
			Defaults: {
				border: 1,
				layout: 'flex',
				containerCls: 'panel',
				role: 'dialog',
				callbacks: {
					submit: function() {
						this.fire('submit', {data: this.toJSON()});
					},
	
					close: function() {
						this.close();
					}
				}
			},
	
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
	
				if (self.isRtl()) {
					self.classes.add('rtl');
				}
	
				self.classes.add('window');
				self.bodyClasses.add('window-body');
				self.state.set('fixed', true);
	
				// Create statusbar
				if (settings.buttons) {
					self.statusbar = new Panel({
						layout: 'flex',
						border: '1 0 0 0',
						spacing: 3,
						padding: 10,
						align: 'center',
						pack: self.isRtl() ? 'start' : 'end',
						defaults: {
							type: 'button'
						},
						items: settings.buttons
					});
	
					self.statusbar.classes.add('foot');
					self.statusbar.parent(self);
				}
	
				self.on('click', function(e) {
					var closeClass = self.classPrefix + 'close';
	
					if (DomUtils.hasClass(e.target, closeClass) || DomUtils.hasClass(e.target.parentNode, closeClass)) {
						self.close();
					}
				});
	
				self.on('cancel', function() {
					self.close();
				});
	
				self.aria('describedby', self.describedBy || self._id + '-none');
				self.aria('label', settings.title);
				self._fullscreen = false;
			},
	
			/**
			 * Recalculates the positions of the controls in the current container.
			 * This is invoked by the reflow method and shouldn't be called directly.
			 *
			 * @method recalc
			 */
			recalc: function() {
				var self = this, statusbar = self.statusbar, layoutRect, width, x, needsRecalc;
	
				if (self._fullscreen) {
					self.layoutRect(DomUtils.getWindowSize());
					self.layoutRect().contentH = self.layoutRect().innerH;
				}
	
				self._super();
	
				layoutRect = self.layoutRect();
	
				// Resize window based on title width
				if (self.settings.title && !self._fullscreen) {
					width = layoutRect.headerW;
					if (width > layoutRect.w) {
						x = layoutRect.x - Math.max(0, width / 2);
						self.layoutRect({w: width, x: x});
						needsRecalc = true;
					}
				}
	
				// Resize window based on statusbar width
				if (statusbar) {
					statusbar.layoutRect({w: self.layoutRect().innerW}).recalc();
	
					width = statusbar.layoutRect().minW + layoutRect.deltaW;
					if (width > layoutRect.w) {
						x = layoutRect.x - Math.max(0, width - layoutRect.w);
						self.layoutRect({w: width, x: x});
						needsRecalc = true;
					}
				}
	
				// Recalc body and disable auto resize
				if (needsRecalc) {
					self.recalc();
				}
			},
	
			/**
			 * Initializes the current controls layout rect.
			 * This will be executed by the layout managers to determine the
			 * default minWidth/minHeight etc.
			 *
			 * @method initLayoutRect
			 * @return {Object} Layout rect instance.
			 */
			initLayoutRect: function() {
				var self = this, layoutRect = self._super(), deltaH = 0, headEl;
	
				// Reserve vertical space for title
				if (self.settings.title && !self._fullscreen) {
					headEl = self.getEl('head');
	
					var size = DomUtils.getSize(headEl);
	
					layoutRect.headerW = size.width;
					layoutRect.headerH = size.height;
	
					deltaH += layoutRect.headerH;
				}
	
				// Reserve vertical space for statusbar
				if (self.statusbar) {
					deltaH += self.statusbar.layoutRect().h;
				}
	
				layoutRect.deltaH += deltaH;
				layoutRect.minH += deltaH;
				//layoutRect.innerH -= deltaH;
				layoutRect.h += deltaH;
	
				var rect = DomUtils.getWindowSize();
	
				layoutRect.x = self.settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2);
				layoutRect.y = self.settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2);
	
				return layoutRect;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, id = self._id, prefix = self.classPrefix;
				var settings = self.settings, headerHtml = '', footerHtml = '', html = settings.html;
	
				self.preRender();
				layout.preRender(self);
	
				if (settings.title) {
					headerHtml = (
						'<div id="' + id + '-head" class="' + prefix + 'window-head">' +
							'<div id="' + id + '-title" class="' + prefix + 'title">' + self.encode(settings.title) + '</div>' +
							'<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' +
							'<button type="button" class="' + prefix + 'close" aria-hidden="true">' +
								'<i class="mce-ico mce-i-remove"></i>' +
							'</button>' +
						'</div>'
					);
				}
	
				if (settings.url) {
					html = '<iframe src="' + settings.url + '" tabindex="-1"></iframe>';
				}
	
				if (typeof html == "undefined") {
					html = layout.renderHtml(self);
				}
	
				if (self.statusbar) {
					footerHtml = self.statusbar.renderHtml();
				}
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" hidefocus="1">' +
						'<div class="' + self.classPrefix + 'reset" role="application">' +
							headerHtml +
							'<div id="' + id + '-body" class="' + self.bodyClasses + '">' +
								html +
							'</div>' +
							footerHtml +
						'</div>' +
					'</div>'
				);
			},
	
			/**
			 * Switches the window fullscreen mode.
			 *
			 * @method fullscreen
			 * @param {Boolean} state True/false state.
			 * @return {tinymce.ui.Window} Current window instance.
			 */
			fullscreen: function(state) {
				var self = this, documentElement = document.documentElement, slowRendering, prefix = self.classPrefix, layoutRect;
	
				if (state != self._fullscreen) {
					$(window).on('resize', function() {
						var time;
	
						if (self._fullscreen) {
							// Time the layout time if it's to slow use a timeout to not hog the CPU
							if (!slowRendering) {
								time = new Date().getTime();
	
								var rect = DomUtils.getWindowSize();
								self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	
								if ((new Date().getTime()) - time > 50) {
									slowRendering = true;
								}
							} else {
								if (!self._timer) {
									self._timer = Delay.setTimeout(function() {
										var rect = DomUtils.getWindowSize();
										self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	
										self._timer = 0;
									}, 50);
								}
							}
						}
					});
	
					layoutRect = self.layoutRect();
					self._fullscreen = state;
	
					if (!state) {
						self.borderBox = BoxUtils.parseBox(self.settings.border);
						self.getEl('head').style.display = '';
						layoutRect.deltaH += layoutRect.headerH;
						$([documentElement, document.body]).removeClass(prefix + 'fullscreen');
						self.classes.remove('fullscreen');
						self.moveTo(self._initial.x, self._initial.y).resizeTo(self._initial.w, self._initial.h);
					} else {
						self._initial = {x: layoutRect.x, y: layoutRect.y, w: layoutRect.w, h: layoutRect.h};
	
						self.borderBox = BoxUtils.parseBox('0');
						self.getEl('head').style.display = 'none';
						layoutRect.deltaH -= layoutRect.headerH + 2;
						$([documentElement, document.body]).addClass(prefix + 'fullscreen');
						self.classes.add('fullscreen');
	
						var rect = DomUtils.getWindowSize();
						self.moveTo(0, 0).resizeTo(rect.w, rect.h);
					}
				}
	
				return self.reflow();
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this, startPos;
	
				setTimeout(function() {
					self.classes.add('in');
					self.fire('open');
				}, 0);
	
				self._super();
	
				if (self.statusbar) {
					self.statusbar.postRender();
				}
	
				self.focus();
	
				this.dragHelper = new DragHelper(self._id + '-dragh', {
					start: function() {
						startPos = {
							x: self.layoutRect().x,
							y: self.layoutRect().y
						};
					},
	
					drag: function(e) {
						self.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY);
					}
				});
	
				self.on('submit', function(e) {
					if (!e.isDefaultPrevented()) {
						self.close();
					}
				});
	
				windows.push(self);
				toggleFullScreenState(true);
			},
	
			/**
			 * Fires a submit event with the serialized form.
			 *
			 * @method submit
			 * @return {Object} Event arguments object.
			 */
			submit: function() {
				return this.fire('submit', {data: this.toJSON()});
			},
	
			/**
			 * Removes the current control from DOM and from UI collections.
			 *
			 * @method remove
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			remove: function() {
				var self = this, i;
	
				self.dragHelper.destroy();
				self._super();
	
				if (self.statusbar) {
					this.statusbar.remove();
				}
	
				i = windows.length;
				while (i--) {
					if (windows[i] === self) {
						windows.splice(i, 1);
					}
				}
	
				toggleFullScreenState(windows.length > 0);
				toggleBodyFullScreenClasses(self.classPrefix);
			},
	
			/**
			 * Returns the contentWindow object of the iframe if it exists.
			 *
			 * @method getContentWindow
			 * @return {Window} window object or null.
			 */
			getContentWindow: function() {
				var ifr = this.getEl().getElementsByTagName('iframe')[0];
				return ifr ? ifr.contentWindow : null;
			}
		});
	
		handleWindowResize();
	
		return Window;
	});
	
	// Included from: js/tinymce/classes/ui/MessageBox.js
	
	/**
	 * MessageBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to create MessageBoxes like alerts/confirms etc.
	 *
	 * @class tinymce.ui.MessageBox
	 * @extends tinymce.ui.FloatPanel
	 */
	define("tinymce/ui/MessageBox", [
		"tinymce/ui/Window"
	], function(Window) {
		"use strict";
	
		var MessageBox = Window.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				settings = {
					border: 1,
					padding: 20,
					layout: 'flex',
					pack: "center",
					align: "center",
					containerCls: 'panel',
					autoScroll: true,
					buttons: {type: "button", text: "Ok", action: "ok"},
					items: {
						type: "label",
						multiline: true,
						maxWidth: 500,
						maxHeight: 200
					}
				};
	
				this._super(settings);
			},
	
			Statics: {
				/**
				 * Ok buttons constant.
				 *
				 * @static
				 * @final
				 * @field {Number} OK
				 */
				OK: 1,
	
				/**
				 * Ok/cancel buttons constant.
				 *
				 * @static
				 * @final
				 * @field {Number} OK_CANCEL
				 */
				OK_CANCEL: 2,
	
				/**
				 * yes/no buttons constant.
				 *
				 * @static
				 * @final
				 * @field {Number} YES_NO
				 */
				YES_NO: 3,
	
				/**
				 * yes/no/cancel buttons constant.
				 *
				 * @static
				 * @final
				 * @field {Number} YES_NO_CANCEL
				 */
				YES_NO_CANCEL: 4,
	
				/**
				 * Constructs a new message box and renders it to the body element.
				 *
				 * @static
				 * @method msgBox
				 * @param {Object} settings Name/value object with settings.
				 */
				msgBox: function(settings) {
					var buttons, callback = settings.callback || function() {};
	
					function createButton(text, status, primary) {
						return {
							type: "button",
							text: text,
							subtype: primary ? 'primary' : '',
							onClick: function(e) {
								e.control.parents()[1].close();
								callback(status);
							}
						};
					}
	
					switch (settings.buttons) {
						case MessageBox.OK_CANCEL:
							buttons = [
								createButton('Ok', true, true),
								createButton('Cancel', false)
							];
							break;
	
						case MessageBox.YES_NO:
						case MessageBox.YES_NO_CANCEL:
							buttons = [
								createButton('Yes', 1, true),
								createButton('No', 0)
							];
	
							if (settings.buttons == MessageBox.YES_NO_CANCEL) {
								buttons.push(createButton('Cancel', -1));
							}
							break;
	
						default:
							buttons = [
								createButton('Ok', true, true)
							];
							break;
					}
	
					return new Window({
						padding: 20,
						x: settings.x,
						y: settings.y,
						minWidth: 300,
						minHeight: 100,
						layout: "flex",
						pack: "center",
						align: "center",
						buttons: buttons,
						title: settings.title,
						role: 'alertdialog',
						items: {
							type: "label",
							multiline: true,
							maxWidth: 500,
							maxHeight: 200,
							text: settings.text
						},
						onPostRender: function() {
							this.aria('describedby', this.items()[0]._id);
						},
						onClose: settings.onClose,
						onCancel: function() {
							callback(false);
						}
					}).renderTo(document.body).reflow();
				},
	
				/**
				 * Creates a new alert dialog.
				 *
				 * @method alert
				 * @param {Object} settings Settings for the alert dialog.
				 * @param {function} [callback] Callback to execute when the user makes a choice.
				 */
				alert: function(settings, callback) {
					if (typeof settings == "string") {
						settings = {text: settings};
					}
	
					settings.callback = callback;
					return MessageBox.msgBox(settings);
				},
	
				/**
				 * Creates a new confirm dialog.
				 *
				 * @method confirm
				 * @param {Object} settings Settings for the confirm dialog.
				 * @param {function} [callback] Callback to execute when the user makes a choice.
				 */
				confirm: function(settings, callback) {
					if (typeof settings == "string") {
						settings = {text: settings};
					}
	
					settings.callback = callback;
					settings.buttons = MessageBox.OK_CANCEL;
	
					return MessageBox.msgBox(settings);
				}
			}
		});
	
		return MessageBox;
	});
	
	// Included from: js/tinymce/classes/WindowManager.js
	
	/**
	 * WindowManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the creation of native windows and dialogs. This class can be extended to provide for example inline dialogs.
	 *
	 * @class tinymce.WindowManager
	 * @example
	 * // Opens a new dialog with the file.htm file and the size 320x240
	 * // It also adds a custom parameter this can be retrieved by using tinyMCEPopup.getWindowArg inside the dialog.
	 * tinymce.activeEditor.windowManager.open({
	 *    url: 'file.htm',
	 *    width: 320,
	 *    height: 240
	 * }, {
	 *    custom_param: 1
	 * });
	 *
	 * // Displays an alert box using the active editors window manager instance
	 * tinymce.activeEditor.windowManager.alert('Hello world!');
	 *
	 * // Displays an confirm box and an alert message will be displayed depending on what you choose in the confirm
	 * tinymce.activeEditor.windowManager.confirm("Do you want to do something", function(s) {
	 *    if (s)
	 *       tinymce.activeEditor.windowManager.alert("Ok");
	 *    else
	 *       tinymce.activeEditor.windowManager.alert("Cancel");
	 * });
	 */
	define("tinymce/WindowManager", [
		"tinymce/ui/Window",
		"tinymce/ui/MessageBox"
	], function(Window, MessageBox) {
		return function(editor) {
			var self = this, windows = [];
	
			function getTopMostWindow() {
				if (windows.length) {
					return windows[windows.length - 1];
				}
			}
	
			function fireOpenEvent(win) {
				editor.fire('OpenWindow', {
					win: win
				});
			}
	
			function fireCloseEvent(win) {
				editor.fire('CloseWindow', {
					win: win
				});
			}
	
			self.windows = windows;
	
			editor.on('remove', function() {
				var i = windows.length;
	
				while (i--) {
					windows[i].close();
				}
			});
	
			/**
			 * Opens a new window.
			 *
			 * @method open
			 * @param {Object} args Optional name/value settings collection contains things like width/height/url etc.
			 * @param {Object} params Options like title, file, width, height etc.
			 * @option {String} title Window title.
			 * @option {String} file URL of the file to open in the window.
			 * @option {Number} width Width in pixels.
			 * @option {Number} height Height in pixels.
			 * @option {Boolean} autoScroll Specifies whether the popup window can have scrollbars if required (i.e. content
			 * larger than the popup size specified).
			 */
			self.open = function(args, params) {
				var win;
	
				editor.editorManager.setActive(editor);
	
				args.title = args.title || ' ';
	
				// Handle URL
				args.url = args.url || args.file; // Legacy
				if (args.url) {
					args.width = parseInt(args.width || 320, 10);
					args.height = parseInt(args.height || 240, 10);
				}
	
				// Handle body
				if (args.body) {
					args.items = {
						defaults: args.defaults,
						type: args.bodyType || 'form',
						items: args.body,
						data: args.data,
						callbacks: args.commands
					};
				}
	
				if (!args.url && !args.buttons) {
					args.buttons = [
						{text: 'Ok', subtype: 'primary', onclick: function() {
							win.find('form')[0].submit();
						}},
	
						{text: 'Cancel', onclick: function() {
							win.close();
						}}
					];
				}
	
				win = new Window(args);
				windows.push(win);
	
				win.on('close', function() {
					var i = windows.length;
	
					while (i--) {
						if (windows[i] === win) {
							windows.splice(i, 1);
						}
					}
	
					if (!windows.length) {
						editor.focus();
					}
	
					fireCloseEvent(win);
				});
	
				// Handle data
				if (args.data) {
					win.on('postRender', function() {
						this.find('*').each(function(ctrl) {
							var name = ctrl.name();
	
							if (name in args.data) {
								ctrl.value(args.data[name]);
							}
						});
					});
				}
	
				// store args and parameters
				win.features = args || {};
				win.params = params || {};
	
				// Takes a snapshot in the FocusManager of the selection before focus is lost to dialog
				if (windows.length === 1) {
					editor.nodeChanged();
				}
	
				win = win.renderTo().reflow();
	
				fireOpenEvent(win);
	
				return win;
			};
	
			/**
			 * Creates a alert dialog. Please don't use the blocking behavior of this
			 * native version use the callback method instead then it can be extended.
			 *
			 * @method alert
			 * @param {String} message Text to display in the new alert dialog.
			 * @param {function} callback Callback function to be executed after the user has selected ok.
			 * @param {Object} scope Optional scope to execute the callback in.
			 * @example
			 * // Displays an alert box using the active editors window manager instance
			 * tinymce.activeEditor.windowManager.alert('Hello world!');
			 */
			self.alert = function(message, callback, scope) {
				var win;
	
				win = MessageBox.alert(message, function() {
					if (callback) {
						callback.call(scope || this);
					} else {
						editor.focus();
					}
				});
	
				win.on('close', function() {
					fireCloseEvent(win);
				});
	
				fireOpenEvent(win);
			};
	
			/**
			 * Creates a confirm dialog. Please don't use the blocking behavior of this
			 * native version use the callback method instead then it can be extended.
			 *
			 * @method confirm
			 * @param {String} message Text to display in the new confirm dialog.
			 * @param {function} callback Callback function to be executed after the user has selected ok or cancel.
			 * @param {Object} scope Optional scope to execute the callback in.
			 * @example
			 * // Displays an confirm box and an alert message will be displayed depending on what you choose in the confirm
			 * tinymce.activeEditor.windowManager.confirm("Do you want to do something", function(s) {
			 *    if (s)
			 *       tinymce.activeEditor.windowManager.alert("Ok");
			 *    else
			 *       tinymce.activeEditor.windowManager.alert("Cancel");
			 * });
			 */
			self.confirm = function(message, callback, scope) {
				var win;
	
				win = MessageBox.confirm(message, function(state) {
					callback.call(scope || this, state);
				});
	
				win.on('close', function() {
					fireCloseEvent(win);
				});
	
				fireOpenEvent(win);
			};
	
			/**
			 * Closes the top most window.
			 *
			 * @method close
			 */
			self.close = function() {
				if (getTopMostWindow()) {
					getTopMostWindow().close();
				}
			};
	
			/**
			 * Returns the params of the last window open call. This can be used in iframe based
			 * dialog to get params passed from the tinymce plugin.
			 *
			 * @example
			 * var dialogArguments = top.tinymce.activeEditor.windowManager.getParams();
			 *
			 * @method getParams
			 * @return {Object} Name/value object with parameters passed from windowManager.open call.
			 */
			self.getParams = function() {
				return getTopMostWindow() ? getTopMostWindow().params : null;
			};
	
			/**
			 * Sets the params of the last opened window.
			 *
			 * @method setParams
			 * @param {Object} params Params object to set for the last opened window.
			 */
			self.setParams = function(params) {
				if (getTopMostWindow()) {
					getTopMostWindow().params = params;
				}
			};
	
			/**
			 * Returns the currently opened window objects.
			 *
			 * @method getWindows
			 * @return {Array} Array of the currently opened windows.
			 */
			self.getWindows = function() {
				return windows;
			};
		};
	});
	
	// Included from: js/tinymce/classes/ui/Tooltip.js
	
	/**
	 * Tooltip.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a tooltip instance.
	 *
	 * @-x-less ToolTip.less
	 * @class tinymce.ui.ToolTip
	 * @extends tinymce.ui.Control
	 * @mixes tinymce.ui.Movable
	 */
	define("tinymce/ui/Tooltip", [
		"tinymce/ui/Control",
		"tinymce/ui/Movable"
	], function(Control, Movable) {
		return Control.extend({
			Mixins: [Movable],
	
			Defaults: {
				classes: 'widget tooltip tooltip-n'
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, prefix = self.classPrefix;
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '" role="presentation">' +
						'<div class="' + prefix + 'tooltip-arrow"></div>' +
						'<div class="' + prefix + 'tooltip-inner">' + self.encode(self.state.get('text')) + '</div>' +
					'</div>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:text', function(e) {
					self.getEl().lastChild.innerHTML = self.encode(e.value);
				});
	
				return self._super();
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, style, rect;
	
				style = self.getEl().style;
				rect = self._layoutRect;
	
				style.left = rect.x + 'px';
				style.top = rect.y + 'px';
				style.zIndex = 0xFFFF + 0xFFFF;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Widget.js
	
	/**
	 * Widget.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Widget base class a widget is a control that has a tooltip and some basic states.
	 *
	 * @class tinymce.ui.Widget
	 * @extends tinymce.ui.Control
	 */
	define("tinymce/ui/Widget", [
		"tinymce/ui/Control",
		"tinymce/ui/Tooltip"
	], function(Control, Tooltip) {
		"use strict";
	
		var tooltip;
	
		var Widget = Control.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} tooltip Tooltip text to display when hovering.
			 * @setting {Boolean} autofocus True if the control should be focused when rendered.
			 * @setting {String} text Text to display inside widget.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				settings = self.settings;
				self.canFocus = true;
	
				if (settings.tooltip && Widget.tooltips !== false) {
					self.on('mouseenter', function(e) {
						var tooltip = self.tooltip().moveTo(-0xFFFF);
	
						if (e.control == self) {
							var rel = tooltip.text(settings.tooltip).show().testMoveRel(self.getEl(), ['bc-tc', 'bc-tl', 'bc-tr']);
	
							tooltip.classes.toggle('tooltip-n', rel == 'bc-tc');
							tooltip.classes.toggle('tooltip-nw', rel == 'bc-tl');
							tooltip.classes.toggle('tooltip-ne', rel == 'bc-tr');
	
							tooltip.moveRel(self.getEl(), rel);
						} else {
							tooltip.hide();
						}
					});
	
					self.on('mouseleave mousedown click', function() {
						self.tooltip().hide();
					});
				}
	
				self.aria('label', settings.ariaLabel || settings.tooltip);
			},
	
			/**
			 * Returns the current tooltip instance.
			 *
			 * @method tooltip
			 * @return {tinymce.ui.Tooltip} Tooltip instance.
			 */
			tooltip: function() {
				if (!tooltip) {
					tooltip = new Tooltip({type: 'tooltip'});
					tooltip.renderTo();
				}
	
				return tooltip;
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this, settings = self.settings;
	
				self._super();
	
				if (!self.parent() && (settings.width || settings.height)) {
					self.initLayoutRect();
					self.repaint();
				}
	
				if (settings.autofocus) {
					self.focus();
				}
			},
	
			bindStates: function() {
				var self = this;
	
				function disable(state) {
					self.aria('disabled', state);
					self.classes.toggle('disabled', state);
				}
	
				function active(state) {
					self.aria('pressed', state);
					self.classes.toggle('active', state);
				}
	
				self.state.on('change:disabled', function(e) {
					disable(e.value);
				});
	
				self.state.on('change:active', function(e) {
					active(e.value);
				});
	
				if (self.state.get('disabled')) {
					disable(true);
				}
	
				if (self.state.get('active')) {
					active(true);
				}
	
				return self._super();
			},
	
			/**
			 * Removes the current control from DOM and from UI collections.
			 *
			 * @method remove
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			remove: function() {
				this._super();
	
				if (tooltip) {
					tooltip.remove();
					tooltip = null;
				}
			}
		});
	
		return Widget;
	});
	
	// Included from: js/tinymce/classes/ui/Progress.js
	
	/**
	 * Progress.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Progress control.
	 *
	 * @-x-less Progress.less
	 * @class tinymce.ui.Progress
	 * @extends tinymce.ui.Control
	 */
	define("tinymce/ui/Progress", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			Defaults: {
				value: 0
			},
	
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				self.classes.add('progress');
	
				if (!self.settings.filter) {
					self.settings.filter = function(value) {
						return Math.round(value);
					};
				}
			},
	
			renderHtml: function() {
				var self = this, id = self._id, prefix = this.classPrefix;
	
				return (
					'<div id="' + id + '" class="' + self.classes + '">' +
						'<div class="' + prefix + 'bar-container">' +
							'<div class="' + prefix + 'bar"></div>' +
						'</div>' +
						'<div class="' + prefix + 'text">0%</div>' +
					'</div>'
				);
			},
	
			postRender: function() {
				var self = this;
	
				self._super();
				self.value(self.settings.value);
	
				return self;
			},
	
			bindStates: function() {
				var self = this;
	
				function setValue(value) {
					value = self.settings.filter(value);
					self.getEl().lastChild.innerHTML = value + '%';
					self.getEl().firstChild.firstChild.style.width = value + '%';
				}
	
				self.state.on('change:value', function(e) {
					setValue(e.value);
				});
	
				setValue(self.state.get('value'));
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Notification.js
	
	/**
	 * Notification.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a notification instance.
	 *
	 * @-x-less Notification.less
	 * @class tinymce.ui.Notification
	 * @extends tinymce.ui.Container
	 * @mixes tinymce.ui.Movable
	 */
	define("tinymce/ui/Notification", [
		"tinymce/ui/Control",
		"tinymce/ui/Movable",
		"tinymce/ui/Progress",
		"tinymce/util/Delay"
	], function(Control, Movable, Progress, Delay) {
		return Control.extend({
			Mixins: [Movable],
	
			Defaults: {
				classes: 'widget notification'
			},
	
			init: function(settings) {
				var self = this;
	
				self._super(settings);
	
				if (settings.text) {
					self.text(settings.text);
				}
	
				if (settings.icon) {
					self.icon = settings.icon;
				}
	
				if (settings.color) {
					self.color = settings.color;
				}
	
				if (settings.type) {
					self.classes.add('notification-' + settings.type);
				}
	
				if (settings.timeout && (settings.timeout < 0 || settings.timeout > 0) && !settings.closeButton) {
					self.closeButton = false;
				} else {
					self.classes.add('has-close');
					self.closeButton = true;
				}
	
				if (settings.progressBar) {
					self.progressBar = new Progress();
				}
	
				self.on('click', function(e) {
					if (e.target.className.indexOf(self.classPrefix + 'close') != -1) {
						self.close();
					}
				});
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, prefix = self.classPrefix, icon = '', closeButton = '', progressBar = '', notificationStyle = '';
	
				if (self.icon) {
					icon = '<i class="' + prefix + 'ico' + ' ' + prefix + 'i-' + self.icon + '"></i>';
				}
	
				if (self.color) {
					notificationStyle = ' style="background-color: ' + self.color + '"';
				}
	
				if (self.closeButton) {
					closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">\u00d7</button>';
				}
	
				if (self.progressBar) {
					progressBar = self.progressBar.renderHtml();
				}
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '"' + notificationStyle + ' role="presentation">' +
						icon +
						'<div class="' + prefix + 'notification-inner">' + self.state.get('text') + '</div>' +
						progressBar +
						closeButton +
					'</div>'
				);
			},
	
			postRender: function() {
				var self = this;
	
				Delay.setTimeout(function() {
					self.$el.addClass(self.classPrefix + 'in');
				});
	
				return self._super();
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:text', function(e) {
					self.getEl().childNodes[1].innerHTML = e.value;
				});
				if (self.progressBar) {
					self.progressBar.bindStates();
				}
				return self._super();
			},
	
			close: function() {
				var self = this;
	
				if (!self.fire('close').isDefaultPrevented()) {
					self.remove();
				}
	
				return self;
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, style, rect;
	
				style = self.getEl().style;
				rect = self._layoutRect;
	
				style.left = rect.x + 'px';
				style.top = rect.y + 'px';
				style.zIndex = 0xFFFF + 0xFFFF;
			}
		});
	});
	
	// Included from: js/tinymce/classes/NotificationManager.js
	
	/**
	 * NotificationManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the creation of TinyMCE's notifications.
	 *
	 * @class tinymce.notificationManager
	 * @example
	 * // Opens a new notification of type "error" with text "An error occurred."
	 * tinymce.activeEditor.notificationManager.open({
	 *    text: 'An error occurred.',
	 *    type: 'error'
	 * });
	 */
	define("tinymce/NotificationManager", [
		"tinymce/ui/Notification",
		"tinymce/util/Delay"
	], function(Notification, Delay) {
		return function(editor) {
			var self = this, notifications = [];
	
			function getLastNotification() {
				if (notifications.length) {
					return notifications[notifications.length - 1];
				}
			}
	
			self.notifications = notifications;
	
			function resizeWindowEvent() {
				Delay.requestAnimationFrame(function() {
					prePositionNotifications();
					positionNotifications();
				});
			}
	
			// Since the viewport will change based on the present notifications, we need to move them all to the
			// top left of the viewport to give an accurate size measurement so we can position them later.
			function prePositionNotifications() {
				for (var i = 0; i < notifications.length; i++) {
					notifications[i].moveTo(0, 0);
				}
			}
	
			function positionNotifications() {
				if (notifications.length > 0) {
					var firstItem = notifications.slice(0, 1)[0];
					var container = editor.inline ? editor.getElement() : editor.getContentAreaContainer();
					firstItem.moveRel(container, 'tc-tc');
					if (notifications.length > 1) {
						for (var i = 1; i < notifications.length; i++) {
							notifications[i].moveRel(notifications[i - 1].getEl(), 'bc-tc');
						}
					}
				}
			}
	
			editor.on('remove', function() {
				var i = notifications.length;
	
				while (i--) {
					notifications[i].close();
				}
			});
	
			editor.on('ResizeEditor', positionNotifications);
			editor.on('ResizeWindow', resizeWindowEvent);
	
			/**
			 * Opens a new notification.
			 *
			 * @method open
			 * @param {Object} args Optional name/value settings collection contains things like timeout/color/message etc.
			 */
			self.open = function(args) {
				var notif;
	
				editor.editorManager.setActive(editor);
	
				notif = new Notification(args);
				notifications.push(notif);
	
				//If we have a timeout value
				if (args.timeout > 0) {
					notif.timer = setTimeout(function() {
						notif.close();
					}, args.timeout);
				}
	
				notif.on('close', function() {
					var i = notifications.length;
	
					if (notif.timer) {
						editor.getWin().clearTimeout(notif.timer);
					}
	
					while (i--) {
						if (notifications[i] === notif) {
							notifications.splice(i, 1);
						}
					}
	
					positionNotifications();
				});
	
				notif.renderTo();
	
				positionNotifications();
	
				return notif;
			};
	
			/**
			 * Closes the top most notification.
			 *
			 * @method close
			 */
			self.close = function() {
				if (getLastNotification()) {
					getLastNotification().close();
				}
			};
	
			/**
			 * Returns the currently opened notification objects.
			 *
			 * @method getNotifications
			 * @return {Array} Array of the currently opened notifications.
			 */
			self.getNotifications = function() {
				return notifications;
			};
	
			editor.on('SkinLoaded', function() {
				var serviceMessage = editor.settings.service_message;
	
				if (serviceMessage) {
					editor.notificationManager.open({
						text: serviceMessage,
						type: 'warning',
						timeout: 0,
						icon: ''
					});
				}
			});
	
			//self.positionNotifications = positionNotifications;
		};
	});
	
	// Included from: js/tinymce/classes/dom/NodePath.js
	
	/**
	 * NodePath.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles paths of nodes within an element.
	 *
	 * @private
	 * @class tinymce.dom.NodePath
	 */
	define("tinymce/dom/NodePath", [
		"tinymce/dom/DOMUtils"
	], function(DOMUtils) {
		function create(rootNode, targetNode, normalized) {
			var path = [];
	
			for (; targetNode && targetNode != rootNode; targetNode = targetNode.parentNode) {
				path.push(DOMUtils.nodeIndex(targetNode, normalized));
			}
	
			return path;
		}
	
		function resolve(rootNode, path) {
			var i, node, children;
	
			for (node = rootNode, i = path.length - 1; i >= 0; i--) {
				children = node.childNodes;
	
				if (path[i] > children.length - 1) {
					return null;
				}
	
				node = children[path[i]];
			}
	
			return node;
		}
	
		return {
			create: create,
			resolve: resolve
		};
	});
	
	// Included from: js/tinymce/classes/util/Quirks.js
	
	/**
	 * Quirks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 *
	 * @ignore-file
	 */
	
	/**
	 * This file includes fixes for various browser quirks it's made to make it easy to add/remove browser specific fixes.
	 *
	 * @private
	 * @class tinymce.util.Quirks
	 */
	define("tinymce/util/Quirks", [
		"tinymce/util/VK",
		"tinymce/dom/RangeUtils",
		"tinymce/dom/TreeWalker",
		"tinymce/dom/NodePath",
		"tinymce/html/Node",
		"tinymce/html/Entities",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/util/Delay",
		"tinymce/caret/CaretContainer",
		"tinymce/caret/CaretPosition",
		"tinymce/caret/CaretWalker"
	], function(VK, RangeUtils, TreeWalker, NodePath, Node, Entities, Env, Tools, Delay, CaretContainer, CaretPosition, CaretWalker) {
		return function(editor) {
			var each = Tools.each, $ = editor.$;
			var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection,
				settings = editor.settings, parser = editor.parser, serializer = editor.serializer;
			var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
			var mceInternalUrlPrefix = 'data:text/mce-internal,';
			var mceInternalDataType = isIE ? 'Text' : 'URL';
	
			/**
			 * Executes a command with a specific state this can be to enable/disable browser editing features.
			 */
			function setEditorCommandState(cmd, state) {
				try {
					editor.getDoc().execCommand(cmd, false, state);
				} catch (ex) {
					// Ignore
				}
			}
	
			/**
			 * Returns current IE document mode.
			 */
			function getDocumentMode() {
				var documentMode = editor.getDoc().documentMode;
	
				return documentMode ? documentMode : 6;
			}
	
			/**
			 * Returns true/false if the event is prevented or not.
			 *
			 * @private
			 * @param {Event} e Event object.
			 * @return {Boolean} true/false if the event is prevented or not.
			 */
			function isDefaultPrevented(e) {
				return e.isDefaultPrevented();
			}
	
			/**
			 * Sets Text/URL data on the event's dataTransfer object to a special data:text/mce-internal url.
			 * This is to workaround the inability to set custom contentType on IE and Safari.
			 * The editor's selected content is encoded into this url so drag and drop between editors will work.
			 *
			 * @private
			 * @param {DragEvent} e Event object
			 */
			function setMceInternalContent(e) {
				var selectionHtml, internalContent;
	
				if (e.dataTransfer) {
					if (editor.selection.isCollapsed() && e.target.tagName == 'IMG') {
						selection.select(e.target);
					}
	
					selectionHtml = editor.selection.getContent();
	
					// Safari/IE doesn't support custom dataTransfer items so we can only use URL and Text
					if (selectionHtml.length > 0) {
						internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
						e.dataTransfer.setData(mceInternalDataType, internalContent);
					}
				}
			}
	
			/**
			 * Gets content of special data:text/mce-internal url on the event's dataTransfer object.
			 * This is to workaround the inability to set custom contentType on IE and Safari.
			 * The editor's selected content is encoded into this url so drag and drop between editors will work.
			 *
			 * @private
			 * @param {DragEvent} e Event object
			 * @returns {String} mce-internal content
			 */
			function getMceInternalContent(e) {
				var internalContent;
	
				if (e.dataTransfer) {
					internalContent = e.dataTransfer.getData(mceInternalDataType);
	
					if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
						internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	
						return {
							id: unescape(internalContent[0]),
							html: unescape(internalContent[1])
						};
					}
				}
	
				return null;
			}
	
			/**
			 * Inserts contents using the paste clipboard command if it's available if it isn't it will fallback
			 * to the core command.
			 *
			 * @private
			 * @param {String} content Content to insert at selection.
			 */
			function insertClipboardContents(content) {
				if (editor.queryCommandSupported('mceInsertClipboardContent')) {
					editor.execCommand('mceInsertClipboardContent', false, {content: content});
				} else {
					editor.execCommand('mceInsertContent', false, content);
				}
			}
	
			/**
			 * Fixes a WebKit bug when deleting contents using backspace or delete key.
			 * WebKit will produce a span element if you delete across two block elements.
			 *
			 * Example:
			 * <h1>a</h1><p>|b</p>
			 *
			 * Will produce this on backspace:
			 * <h1>a<span style="<all runtime styles>">b</span></p>
			 *
			 * This fixes the backspace to produce:
			 * <h1>a|b</p>
			 *
			 * See bug: https://bugs.webkit.org/show_bug.cgi?id=45784
			 *
			 * This fixes the following delete scenarios:
			 *  1. Delete by pressing backspace key.
			 *  2. Delete by pressing delete key.
			 *  3. Delete by pressing backspace key with ctrl/cmd (Word delete).
			 *  4. Delete by pressing delete key with ctrl/cmd (Word delete).
			 *  5. Delete by drag/dropping contents inside the editor.
			 *  6. Delete by using Cut Ctrl+X/Cmd+X.
			 *  7. Delete by selecting contents and writing a character.
			 *
			 * This code is a ugly hack since writing full custom delete logic for just this bug
			 * fix seemed like a huge task. I hope we can remove this before the year 2030.
			 */
			function cleanupStylesWhenDeleting() {
				var doc = editor.getDoc(), dom = editor.dom, selection = editor.selection;
				var MutationObserver = window.MutationObserver, olderWebKit, dragStartRng;
	
				// Add mini polyfill for older WebKits
				// TODO: Remove this when old Safari versions gets updated
				if (!MutationObserver) {
					olderWebKit = true;
	
					MutationObserver = function() {
						var records = [], target;
	
						function nodeInsert(e) {
							var target = e.relatedNode || e.target;
							records.push({target: target, addedNodes: [target]});
						}
	
						function attrModified(e) {
							var target = e.relatedNode || e.target;
							records.push({target: target, attributeName: e.attrName});
						}
	
						this.observe = function(node) {
							target = node;
							target.addEventListener('DOMSubtreeModified', nodeInsert, false);
							target.addEventListener('DOMNodeInsertedIntoDocument', nodeInsert, false);
							target.addEventListener('DOMNodeInserted', nodeInsert, false);
							target.addEventListener('DOMAttrModified', attrModified, false);
						};
	
						this.disconnect = function() {
							target.removeEventListener('DOMSubtreeModified', nodeInsert, false);
							target.removeEventListener('DOMNodeInsertedIntoDocument', nodeInsert, false);
							target.removeEventListener('DOMNodeInserted', nodeInsert, false);
							target.removeEventListener('DOMAttrModified', attrModified, false);
						};
	
						this.takeRecords = function() {
							return records;
						};
					};
				}
	
				function isTrailingBr(node) {
					var blockElements = dom.schema.getBlockElements(), rootNode = editor.getBody();
	
					if (node.nodeName != 'BR') {
						return false;
					}
	
					for (; node != rootNode && !blockElements[node.nodeName]; node = node.parentNode) {
						if (node.nextSibling) {
							return false;
						}
					}
	
					return true;
				}
	
				function isSiblingsIgnoreWhiteSpace(node1, node2) {
					var node;
	
					for (node = node1.nextSibling; node && node != node2; node = node.nextSibling) {
						if (node.nodeType == 3 && $.trim(node.data).length === 0) {
							continue;
						}
	
						if (node !== node2) {
							return false;
						}
					}
	
					return node === node2;
				}
	
				function findCaretNode(node, forward, startNode) {
					var walker, current, nonEmptyElements;
	
					nonEmptyElements = dom.schema.getNonEmptyElements();
	
					walker = new TreeWalker(startNode || node, node);
	
					while ((current = walker[forward ? 'next' : 'prev']())) {
						if (nonEmptyElements[current.nodeName] && !isTrailingBr(current)) {
							return current;
						}
	
						if (current.nodeType == 3 && current.data.length > 0) {
							return current;
						}
					}
				}
	
				function deleteRangeBetweenTextBlocks(rng) {
					var startBlock, endBlock, caretNodeBefore, caretNodeAfter, textBlockElements;
	
					if (rng.collapsed) {
						return;
					}
	
					startBlock = dom.getParent(RangeUtils.getNode(rng.startContainer, rng.startOffset), dom.isBlock);
					endBlock = dom.getParent(RangeUtils.getNode(rng.endContainer, rng.endOffset), dom.isBlock);
					textBlockElements = editor.schema.getTextBlockElements();
	
					if (startBlock == endBlock) {
						return;
					}
	
					if (!textBlockElements[startBlock.nodeName] || !textBlockElements[endBlock.nodeName]) {
						return;
					}
	
					if (dom.getContentEditable(startBlock) === "false" || dom.getContentEditable(endBlock) === "false") {
						return;
					}
	
					rng.deleteContents();
	
					caretNodeBefore = findCaretNode(startBlock, false);
					caretNodeAfter = findCaretNode(endBlock, true);
	
					if (!dom.isEmpty(endBlock)) {
						$(startBlock).append(endBlock.childNodes);
					}
	
					$(endBlock).remove();
	
					if (caretNodeBefore) {
						if (caretNodeBefore.nodeType == 1) {
							if (caretNodeBefore.nodeName == "BR") {
								rng.setStartBefore(caretNodeBefore);
								rng.setEndBefore(caretNodeBefore);
							} else {
								rng.setStartAfter(caretNodeBefore);
								rng.setEndAfter(caretNodeBefore);
							}
						} else {
							rng.setStart(caretNodeBefore, caretNodeBefore.data.length);
							rng.setEnd(caretNodeBefore, caretNodeBefore.data.length);
						}
					} else if (caretNodeAfter) {
						if (caretNodeAfter.nodeType == 1) {
							rng.setStartBefore(caretNodeAfter);
							rng.setEndBefore(caretNodeAfter);
						} else {
							rng.setStart(caretNodeAfter, 0);
							rng.setEnd(caretNodeAfter, 0);
						}
					}
	
					selection.setRng(rng);
	
					return true;
				}
	
				function expandBetweenBlocks(rng, isForward) {
					var caretNode, targetCaretNode, textBlock, targetTextBlock, container, offset;
	
					if (!rng.collapsed) {
						return rng;
					}
	
					container = rng.startContainer;
					offset = rng.startOffset;
	
					if (container.nodeType == 3) {
						if (isForward) {
							if (offset < container.data.length) {
								return rng;
							}
						} else {
							if (offset > 0) {
								return rng;
							}
						}
					}
	
					caretNode = RangeUtils.getNode(rng.startContainer, rng.startOffset);
					textBlock = dom.getParent(caretNode, dom.isBlock);
					targetCaretNode = findCaretNode(editor.getBody(), isForward, caretNode);
					targetTextBlock = dom.getParent(targetCaretNode, dom.isBlock);
	
					if (!caretNode || !targetCaretNode) {
						return rng;
					}
	
					if (targetTextBlock && textBlock != targetTextBlock) {
						if (!isForward) {
							if (!isSiblingsIgnoreWhiteSpace(targetTextBlock, textBlock)) {
								return rng;
							}
	
							if (targetCaretNode.nodeType == 1) {
								if (targetCaretNode.nodeName == "BR") {
									rng.setStartBefore(targetCaretNode);
								} else {
									rng.setStartAfter(targetCaretNode);
								}
							} else {
								rng.setStart(targetCaretNode, targetCaretNode.data.length);
							}
	
							if (caretNode.nodeType == 1) {
								rng.setEnd(caretNode, 0);
							} else {
								rng.setEndBefore(caretNode);
							}
						} else {
							if (!isSiblingsIgnoreWhiteSpace(textBlock, targetTextBlock)) {
								return rng;
							}
	
							if (caretNode.nodeType == 1) {
								if (caretNode.nodeName == "BR") {
									rng.setStartBefore(caretNode);
								} else {
									rng.setStartAfter(caretNode);
								}
							} else {
								rng.setStart(caretNode, caretNode.data.length);
							}
	
							if (targetCaretNode.nodeType == 1) {
								rng.setEnd(targetCaretNode, 0);
							} else {
								rng.setEndBefore(targetCaretNode);
							}
						}
					}
	
					return rng;
				}
	
				function handleTextBlockMergeDelete(isForward) {
					var rng = selection.getRng();
	
					rng = expandBetweenBlocks(rng, isForward);
	
					if (deleteRangeBetweenTextBlocks(rng)) {
						return true;
					}
				}
	
				/**
				 * This retains the formatting if the last character is to be deleted.
				 *
				 * Backspace on this: <p><b><i>a|</i></b></p> would become <p>|</p> in WebKit.
				 * With this patch: <p><b><i>|<br></i></b></p>
				 */
				function handleLastBlockCharacterDelete(isForward, rng) {
					var path, blockElm, newBlockElm, clonedBlockElm, sibling,
						container, offset, br, currentFormatNodes;
	
					function cloneTextBlockWithFormats(blockElm, node) {
						currentFormatNodes = $(node).parents().filter(function(idx, node) {
							return !!editor.schema.getTextInlineElements()[node.nodeName];
						});
	
						newBlockElm = blockElm.cloneNode(false);
	
						currentFormatNodes = Tools.map(currentFormatNodes, function(formatNode) {
							formatNode = formatNode.cloneNode(false);
	
							if (newBlockElm.hasChildNodes()) {
								formatNode.appendChild(newBlockElm.firstChild);
								newBlockElm.appendChild(formatNode);
							} else {
								newBlockElm.appendChild(formatNode);
							}
	
							newBlockElm.appendChild(formatNode);
	
							return formatNode;
						});
	
						if (currentFormatNodes.length) {
							br = dom.create('br');
							currentFormatNodes[0].appendChild(br);
							dom.replace(newBlockElm, blockElm);
	
							rng.setStartBefore(br);
							rng.setEndBefore(br);
							editor.selection.setRng(rng);
	
							return br;
						}
	
						return null;
					}
	
					function isTextBlock(node) {
						return node && editor.schema.getTextBlockElements()[node.tagName];
					}
	
					if (!rng.collapsed) {
						return;
					}
	
					container = rng.startContainer;
					offset = rng.startOffset;
					blockElm = dom.getParent(container, dom.isBlock);
					if (!isTextBlock(blockElm)) {
						return;
					}
	
					if (container.nodeType == 1) {
						container = container.childNodes[offset];
						if (container && container.tagName != 'BR') {
							return;
						}
	
						if (isForward) {
							sibling = blockElm.nextSibling;
						} else {
							sibling = blockElm.previousSibling;
						}
	
						if (dom.isEmpty(blockElm) && isTextBlock(sibling) && dom.isEmpty(sibling)) {
							if (cloneTextBlockWithFormats(blockElm, container)) {
								dom.remove(sibling);
								return true;
							}
						}
					} else if (container.nodeType == 3) {
						path = NodePath.create(blockElm, container);
						clonedBlockElm = blockElm.cloneNode(true);
						container = NodePath.resolve(clonedBlockElm, path);
	
						if (isForward) {
							if (offset >= container.data.length) {
								return;
							}
	
							container.deleteData(offset, 1);
						} else {
							if (offset <= 0) {
								return;
							}
	
							container.deleteData(offset - 1, 1);
						}
	
						if (dom.isEmpty(clonedBlockElm)) {
							return cloneTextBlockWithFormats(blockElm, container);
						}
					}
				}
	
				function customDelete(isForward) {
					var mutationObserver, rng, caretElement;
	
					if (handleTextBlockMergeDelete(isForward)) {
						return;
					}
	
					Tools.each(editor.getBody().getElementsByTagName('*'), function(elm) {
						// Mark existing spans
						if (elm.tagName == 'SPAN') {
							elm.setAttribute('mce-data-marked', 1);
						}
	
						// Make sure all elements has a data-mce-style attribute
						if (!elm.hasAttribute('data-mce-style') && elm.hasAttribute('style')) {
							editor.dom.setAttrib(elm, 'style', editor.dom.getAttrib(elm, 'style'));
						}
					});
	
					// Observe added nodes and style attribute changes
					mutationObserver = new MutationObserver(function() {});
					mutationObserver.observe(editor.getDoc(), {
						childList: true,
						attributes: true,
						subtree: true,
						attributeFilter: ['style']
					});
	
					editor.getDoc().execCommand(isForward ? 'ForwardDelete' : 'Delete', false, null);
	
					rng = editor.selection.getRng();
					caretElement = rng.startContainer.parentNode;
	
					Tools.each(mutationObserver.takeRecords(), function(record) {
						if (!dom.isChildOf(record.target, editor.getBody())) {
							return;
						}
	
						// Restore style attribute to previous value
						if (record.attributeName == "style") {
							var oldValue = record.target.getAttribute('data-mce-style');
	
							if (oldValue) {
								record.target.setAttribute("style", oldValue);
							} else {
								record.target.removeAttribute("style");
							}
						}
	
						// Remove all spans that aren't marked and retain selection
						Tools.each(record.addedNodes, function(node) {
							if (node.nodeName == "SPAN" && !node.getAttribute('mce-data-marked')) {
								var offset, container;
	
								if (node == caretElement) {
									offset = rng.startOffset;
									container = node.firstChild;
								}
	
								dom.remove(node, true);
	
								if (container) {
									rng.setStart(container, offset);
									rng.setEnd(container, offset);
									editor.selection.setRng(rng);
								}
							}
						});
					});
	
					mutationObserver.disconnect();
	
					// Remove any left over marks
					Tools.each(editor.dom.select('span[mce-data-marked]'), function(span) {
						span.removeAttribute('mce-data-marked');
					});
				}
	
				editor.on('keydown', function(e) {
					var isForward = e.keyCode == DELETE, isMetaOrCtrl = e.ctrlKey || e.metaKey;
	
					if (!isDefaultPrevented(e) && (isForward || e.keyCode == BACKSPACE)) {
						var rng = editor.selection.getRng(), container = rng.startContainer, offset = rng.startOffset;
	
						// Shift+Delete is cut
						if (isForward && e.shiftKey) {
							return;
						}
	
						if (handleLastBlockCharacterDelete(isForward, rng)) {
							e.preventDefault();
							return;
						}
	
						// Ignore non meta delete in the where there is text before/after the caret
						if (!isMetaOrCtrl && rng.collapsed && container.nodeType == 3) {
							if (isForward ? offset < container.data.length : offset > 0) {
								return;
							}
						}
	
						e.preventDefault();
	
						if (isMetaOrCtrl) {
							editor.selection.getSel().modify("extend", isForward ? "forward" : "backward", e.metaKey ? "lineboundary" : "word");
						}
	
						customDelete(isForward);
					}
				});
	
				// Handle case where text is deleted by typing over
				editor.on('keypress', function(e) {
					if (!isDefaultPrevented(e) && !selection.isCollapsed() && e.charCode > 31 && !VK.metaKeyPressed(e)) {
						var rng, currentFormatNodes, fragmentNode, blockParent, caretNode, charText;
	
						rng = editor.selection.getRng();
						charText = String.fromCharCode(e.charCode);
						e.preventDefault();
	
						// Keep track of current format nodes
						currentFormatNodes = $(rng.startContainer).parents().filter(function(idx, node) {
							return !!editor.schema.getTextInlineElements()[node.nodeName];
						});
	
						customDelete(true);
	
						// Check if the browser removed them
						currentFormatNodes = currentFormatNodes.filter(function(idx, node) {
							return !$.contains(editor.getBody(), node);
						});
	
						// Then re-add them
						if (currentFormatNodes.length) {
							fragmentNode = dom.createFragment();
	
							currentFormatNodes.each(function(idx, formatNode) {
								formatNode = formatNode.cloneNode(false);
	
								if (fragmentNode.hasChildNodes()) {
									formatNode.appendChild(fragmentNode.firstChild);
									fragmentNode.appendChild(formatNode);
								} else {
									caretNode = formatNode;
									fragmentNode.appendChild(formatNode);
								}
	
								fragmentNode.appendChild(formatNode);
							});
	
							caretNode.appendChild(editor.getDoc().createTextNode(charText));
	
							// Prevent edge case where older WebKit would add an extra BR element
							blockParent = dom.getParent(rng.startContainer, dom.isBlock);
							if (dom.isEmpty(blockParent)) {
								$(blockParent).empty().append(fragmentNode);
							} else {
								rng.insertNode(fragmentNode);
							}
	
							rng.setStart(caretNode.firstChild, 1);
							rng.setEnd(caretNode.firstChild, 1);
							editor.selection.setRng(rng);
						} else {
							editor.selection.setContent(charText);
						}
					}
				});
	
				editor.addCommand('Delete', function() {
					customDelete();
				});
	
				editor.addCommand('ForwardDelete', function() {
					customDelete(true);
				});
	
				// Older WebKits doesn't properly handle the clipboard so we can't add the rest
				if (olderWebKit) {
					return;
				}
	
				editor.on('dragstart', function(e) {
					dragStartRng = selection.getRng();
					setMceInternalContent(e);
				});
	
				editor.on('drop', function(e) {
					if (!isDefaultPrevented(e)) {
						var internalContent = getMceInternalContent(e);
	
						if (internalContent) {
							e.preventDefault();
	
							// Safari has a weird issue where drag/dropping images sometimes
							// produces a green plus icon. When this happens the caretRangeFromPoint
							// will return "null" even though the x, y coordinate is correct.
							// But if we detach the insert from the drop event we will get a proper range
							Delay.setEditorTimeout(editor, function() {
								var pointRng = RangeUtils.getCaretRangeFromPoint(e.x, e.y, doc);
	
								if (dragStartRng) {
									selection.setRng(dragStartRng);
									dragStartRng = null;
								}
	
								customDelete();
								selection.setRng(pointRng);
								insertClipboardContents(internalContent.html);
							});
						}
					}
				});
	
				editor.on('cut', function(e) {
					if (!isDefaultPrevented(e) && e.clipboardData && !editor.selection.isCollapsed()) {
						e.preventDefault();
						e.clipboardData.clearData();
						e.clipboardData.setData('text/html', editor.selection.getContent());
						e.clipboardData.setData('text/plain', editor.selection.getContent({format: 'text'}));
	
						// Needed delay for https://code.google.com/p/chromium/issues/detail?id=363288#c3
						// Nested delete/forwardDelete not allowed on execCommand("cut")
						// This is ugly but not sure how to work around it otherwise
						Delay.setEditorTimeout(editor, function() {
							customDelete(true);
						});
					}
				});
			}
	
			/**
			 * Makes sure that the editor body becomes empty when backspace or delete is pressed in empty editors.
			 *
			 * For example:
			 * <p><b>|</b></p>
			 *
			 * Or:
			 * <h1>|</h1>
			 *
			 * Or:
			 * [<h1></h1>]
			 */
			function emptyEditorWhenDeleting() {
				function serializeRng(rng) {
					var body = dom.create("body");
					var contents = rng.cloneContents();
					body.appendChild(contents);
					return selection.serializer.serialize(body, {format: 'html'});
				}
	
				function allContentsSelected(rng) {
					if (!rng.setStart) {
						if (rng.item) {
							return false;
						}
	
						var bodyRng = rng.duplicate();
						bodyRng.moveToElementText(editor.getBody());
						return RangeUtils.compareRanges(rng, bodyRng);
					}
	
					var selection = serializeRng(rng);
	
					var allRng = dom.createRng();
					allRng.selectNode(editor.getBody());
	
					var allSelection = serializeRng(allRng);
					return selection === allSelection;
				}
	
				editor.on('keydown', function(e) {
					var keyCode = e.keyCode, isCollapsed, body;
	
					// Empty the editor if it's needed for example backspace at <p><b>|</b></p>
					if (!isDefaultPrevented(e) && (keyCode == DELETE || keyCode == BACKSPACE)) {
						isCollapsed = editor.selection.isCollapsed();
						body = editor.getBody();
	
						// Selection is collapsed but the editor isn't empty
						if (isCollapsed && !dom.isEmpty(body)) {
							return;
						}
	
						// Selection isn't collapsed but not all the contents is selected
						if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
							return;
						}
	
						// Manually empty the editor
						e.preventDefault();
						editor.setContent('');
	
						if (body.firstChild && dom.isBlock(body.firstChild)) {
							editor.selection.setCursorLocation(body.firstChild, 0);
						} else {
							editor.selection.setCursorLocation(body, 0);
						}
	
						editor.nodeChanged();
					}
				});
			}
	
			/**
			 * WebKit doesn't select all the nodes in the body when you press Ctrl+A.
			 * IE selects more than the contents <body>[<p>a</p>]</body> instead of <body><p>[a]</p]</body> see bug #6438
			 * This selects the whole body so that backspace/delete logic will delete everything
			 */
			function selectAll() {
				editor.shortcuts.add('meta+a', null, 'SelectAll');
			}
	
			/**
			 * WebKit has a weird issue where it some times fails to properly convert keypresses to input method keystrokes.
			 * The IME on Mac doesn't initialize when it doesn't fire a proper focus event.
			 *
			 * This seems to happen when the user manages to click the documentElement element then the window doesn't get proper focus until
			 * you enter a character into the editor.
			 *
			 * It also happens when the first focus in made to the body.
			 *
			 * See: https://bugs.webkit.org/show_bug.cgi?id=83566
			 */
			function inputMethodFocus() {
				if (!editor.settings.content_editable) {
					// Case 1 IME doesn't initialize if you focus the document
					// Disabled since it was interferring with the cE=false logic
					// Also coultn't reproduce the issue on Safari 9
					/*dom.bind(editor.getDoc(), 'focusin', function() {
						selection.setRng(selection.getRng());
					});*/
	
					// Case 2 IME doesn't initialize if you click the documentElement it also doesn't properly fire the focusin event
					// Needs to be both down/up due to weird rendering bug on Chrome Windows
					dom.bind(editor.getDoc(), 'mousedown mouseup', function(e) {
						var rng;
	
						if (e.target == editor.getDoc().documentElement) {
							rng = selection.getRng();
							editor.getBody().focus();
	
							if (e.type == 'mousedown') {
								if (CaretContainer.isCaretContainer(rng.startContainer)) {
									return;
								}
	
								// Edge case for mousedown, drag select and mousedown again within selection on Chrome Windows to render caret
								selection.placeCaretAt(e.clientX, e.clientY);
							} else {
								selection.setRng(rng);
							}
						}
					});
				}
			}
	
			/**
			 * Backspacing in FireFox/IE from a paragraph into a horizontal rule results in a floating text node because the
			 * browser just deletes the paragraph - the browser fails to merge the text node with a horizontal rule so it is
			 * left there. TinyMCE sees a floating text node and wraps it in a paragraph on the key up event (ForceBlocks.js
			 * addRootBlocks), meaning the action does nothing. With this code, FireFox/IE matche the behaviour of other
			 * browsers.
			 *
			 * It also fixes a bug on Firefox where it's impossible to delete HR elements.
			 */
			function removeHrOnBackspace() {
				editor.on('keydown', function(e) {
					if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
						// Check if there is any HR elements this is faster since getRng on IE 7 & 8 is slow
						if (!editor.getBody().getElementsByTagName('hr').length) {
							return;
						}
	
						if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
							var node = selection.getNode();
							var previousSibling = node.previousSibling;
	
							if (node.nodeName == 'HR') {
								dom.remove(node);
								e.preventDefault();
								return;
							}
	
							if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === "hr") {
								dom.remove(previousSibling);
								e.preventDefault();
							}
						}
					}
				});
			}
	
			/**
			 * Firefox 3.x has an issue where the body element won't get proper focus if you click out
			 * side it's rectangle.
			 */
			function focusBody() {
				// Fix for a focus bug in FF 3.x where the body element
				// wouldn't get proper focus if the user clicked on the HTML element
				if (!window.Range.prototype.getClientRects) { // Detect getClientRects got introduced in FF 4
					editor.on('mousedown', function(e) {
						if (!isDefaultPrevented(e) && e.target.nodeName === "HTML") {
							var body = editor.getBody();
	
							// Blur the body it's focused but not correctly focused
							body.blur();
	
							// Refocus the body after a little while
							Delay.setEditorTimeout(editor, function() {
								body.focus();
							});
						}
					});
				}
			}
	
			/**
			 * WebKit has a bug where it isn't possible to select image, hr or anchor elements
			 * by clicking on them so we need to fake that.
			 */
			function selectControlElements() {
				editor.on('click', function(e) {
					var target = e.target;
	
					// Workaround for bug, http://bugs.webkit.org/show_bug.cgi?id=12250
					// WebKit can't even do simple things like selecting an image
					// Needs to be the setBaseAndExtend or it will fail to select floated images
					if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== "false") {
						e.preventDefault();
						selection.getSel().setBaseAndExtent(target, 0, target, 1);
						editor.nodeChanged();
					}
	
					if (target.nodeName == 'A' && dom.hasClass(target, 'mce-item-anchor')) {
						e.preventDefault();
						selection.select(target);
					}
				});
			}
	
			/**
			 * Fixes a Gecko bug where the style attribute gets added to the wrong element when deleting between two block elements.
			 *
			 * Fixes do backspace/delete on this:
			 * <p>bla[ck</p><p style="color:red">r]ed</p>
			 *
			 * Would become:
			 * <p>bla|ed</p>
			 *
			 * Instead of:
			 * <p style="color:red">bla|ed</p>
			 */
			function removeStylesWhenDeletingAcrossBlockElements() {
				function getAttributeApplyFunction() {
					var template = dom.getAttribs(selection.getStart().cloneNode(false));
	
					return function() {
						var target = selection.getStart();
	
						if (target !== editor.getBody()) {
							dom.setAttrib(target, "style", null);
	
							each(template, function(attr) {
								target.setAttributeNode(attr.cloneNode(true));
							});
						}
					};
				}
	
				function isSelectionAcrossElements() {
					return !selection.isCollapsed() &&
						dom.getParent(selection.getStart(), dom.isBlock) != dom.getParent(selection.getEnd(), dom.isBlock);
				}
	
				editor.on('keypress', function(e) {
					var applyAttributes;
	
					if (!isDefaultPrevented(e) && (e.keyCode == 8 || e.keyCode == 46) && isSelectionAcrossElements()) {
						applyAttributes = getAttributeApplyFunction();
						editor.getDoc().execCommand('delete', false, null);
						applyAttributes();
						e.preventDefault();
						return false;
					}
				});
	
				dom.bind(editor.getDoc(), 'cut', function(e) {
					var applyAttributes;
	
					if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
						applyAttributes = getAttributeApplyFunction();
	
						Delay.setEditorTimeout(editor, function() {
							applyAttributes();
						});
					}
				});
			}
	
			/**
			 * Screen readers on IE needs to have the role application set on the body.
			 */
			function ensureBodyHasRoleApplication() {
				document.body.setAttribute("role", "application");
			}
	
			/**
			 * Backspacing into a table behaves differently depending upon browser type.
			 * Therefore, disable Backspace when cursor immediately follows a table.
			 */
			function disableBackspaceIntoATable() {
				editor.on('keydown', function(e) {
					if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
						if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
							var previousSibling = selection.getNode().previousSibling;
							if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === "table") {
								e.preventDefault();
								return false;
							}
						}
					}
				});
			}
	
			/**
			 * Old IE versions can't properly render BR elements in PRE tags white in contentEditable mode. So this
			 * logic adds a \n before the BR so that it will get rendered.
			 */
			function addNewLinesBeforeBrInPre() {
				// IE8+ rendering mode does the right thing with BR in PRE
				if (getDocumentMode() > 7) {
					return;
				}
	
				// Enable display: none in area and add a specific class that hides all BR elements in PRE to
				// avoid the caret from getting stuck at the BR elements while pressing the right arrow key
				setEditorCommandState('RespectVisibilityInDesign', true);
				editor.contentStyles.push('.mceHideBrInPre pre br {display: none}');
				dom.addClass(editor.getBody(), 'mceHideBrInPre');
	
				// Adds a \n before all BR elements in PRE to get them visual
				parser.addNodeFilter('pre', function(nodes) {
					var i = nodes.length, brNodes, j, brElm, sibling;
	
					while (i--) {
						brNodes = nodes[i].getAll('br');
						j = brNodes.length;
						while (j--) {
							brElm = brNodes[j];
	
							// Add \n before BR in PRE elements on older IE:s so the new lines get rendered
							sibling = brElm.prev;
							if (sibling && sibling.type === 3 && sibling.value.charAt(sibling.value - 1) != '\n') {
								sibling.value += '\n';
							} else {
								brElm.parent.insert(new Node('#text', 3), brElm, true).value = '\n';
							}
						}
					}
				});
	
				// Removes any \n before BR elements in PRE since other browsers and in contentEditable=false mode they will be visible
				serializer.addNodeFilter('pre', function(nodes) {
					var i = nodes.length, brNodes, j, brElm, sibling;
	
					while (i--) {
						brNodes = nodes[i].getAll('br');
						j = brNodes.length;
						while (j--) {
							brElm = brNodes[j];
							sibling = brElm.prev;
							if (sibling && sibling.type == 3) {
								sibling.value = sibling.value.replace(/\r?\n$/, '');
							}
						}
					}
				});
			}
	
			/**
			 * Moves style width/height to attribute width/height when the user resizes an image on IE.
			 */
			function removePreSerializedStylesWhenSelectingControls() {
				dom.bind(editor.getBody(), 'mouseup', function() {
					var value, node = selection.getNode();
	
					// Moved styles to attributes on IMG eements
					if (node.nodeName == 'IMG') {
						// Convert style width to width attribute
						if ((value = dom.getStyle(node, 'width'))) {
							dom.setAttrib(node, 'width', value.replace(/[^0-9%]+/g, ''));
							dom.setStyle(node, 'width', '');
						}
	
						// Convert style height to height attribute
						if ((value = dom.getStyle(node, 'height'))) {
							dom.setAttrib(node, 'height', value.replace(/[^0-9%]+/g, ''));
							dom.setStyle(node, 'height', '');
						}
					}
				});
			}
	
			/**
			 * Removes a blockquote when backspace is pressed at the beginning of it.
			 *
			 * For example:
			 * <blockquote><p>|x</p></blockquote>
			 *
			 * Becomes:
			 * <p>|x</p>
			 */
			function removeBlockQuoteOnBackSpace() {
				// Add block quote deletion handler
				editor.on('keydown', function(e) {
					var rng, container, offset, root, parent;
	
					if (isDefaultPrevented(e) || e.keyCode != VK.BACKSPACE) {
						return;
					}
	
					rng = selection.getRng();
					container = rng.startContainer;
					offset = rng.startOffset;
					root = dom.getRoot();
					parent = container;
	
					if (!rng.collapsed || offset !== 0) {
						return;
					}
	
					while (parent && parent.parentNode && parent.parentNode.firstChild == parent && parent.parentNode != root) {
						parent = parent.parentNode;
					}
	
					// Is the cursor at the beginning of a blockquote?
					if (parent.tagName === 'BLOCKQUOTE') {
						// Remove the blockquote
						editor.formatter.toggle('blockquote', null, parent);
	
						// Move the caret to the beginning of container
						rng = dom.createRng();
						rng.setStart(container, 0);
						rng.setEnd(container, 0);
						selection.setRng(rng);
					}
				});
			}
	
			/**
			 * Sets various Gecko editing options on mouse down and before a execCommand to disable inline table editing that is broken etc.
			 */
			function setGeckoEditingOptions() {
				function setOpts() {
					refreshContentEditable();
	
					setEditorCommandState("StyleWithCSS", false);
					setEditorCommandState("enableInlineTableEditing", false);
	
					if (!settings.object_resizing) {
						setEditorCommandState("enableObjectResizing", false);
					}
				}
	
				if (!settings.readonly) {
					editor.on('BeforeExecCommand MouseDown', setOpts);
				}
			}
	
			/**
			 * Fixes a gecko link bug, when a link is placed at the end of block elements there is
			 * no way to move the caret behind the link. This fix adds a bogus br element after the link.
			 *
			 * For example this:
			 * <p><b><a href="#">x</a></b></p>
			 *
			 * Becomes this:
			 * <p><b><a href="#">x</a></b><br></p>
			 */
			function addBrAfterLastLinks() {
				function fixLinks() {
					each(dom.select('a'), function(node) {
						var parentNode = node.parentNode, root = dom.getRoot();
	
						if (parentNode.lastChild === node) {
							while (parentNode && !dom.isBlock(parentNode)) {
								if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
									return;
								}
	
								parentNode = parentNode.parentNode;
							}
	
							dom.add(parentNode, 'br', {'data-mce-bogus': 1});
						}
					});
				}
	
				editor.on('SetContent ExecCommand', function(e) {
					if (e.type == "setcontent" || e.command === 'mceInsertLink') {
						fixLinks();
					}
				});
			}
	
			/**
			 * WebKit will produce DIV elements here and there by default. But since TinyMCE uses paragraphs by
			 * default we want to change that behavior.
			 */
			function setDefaultBlockType() {
				if (settings.forced_root_block) {
					editor.on('init', function() {
						setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block);
					});
				}
			}
	
			/**
			 * Deletes the selected image on IE instead of navigating to previous page.
			 */
			function deleteControlItemOnBackSpace() {
				editor.on('keydown', function(e) {
					var rng;
	
					if (!isDefaultPrevented(e) && e.keyCode == BACKSPACE) {
						rng = editor.getDoc().selection.createRange();
						if (rng && rng.item) {
							e.preventDefault();
							editor.undoManager.beforeChange();
							dom.remove(rng.item(0));
							editor.undoManager.add();
						}
					}
				});
			}
	
			/**
			 * IE10 doesn't properly render block elements with the right height until you add contents to them.
			 * This fixes that by adding a padding-right to all empty text block elements.
			 * See: https://connect.microsoft.com/IE/feedback/details/743881
			 */
			function renderEmptyBlocksFix() {
				var emptyBlocksCSS;
	
				// IE10+
				if (getDocumentMode() >= 10) {
					emptyBlocksCSS = '';
					each('p div h1 h2 h3 h4 h5 h6'.split(' '), function(name, i) {
						emptyBlocksCSS += (i > 0 ? ',' : '') + name + ':empty';
					});
	
					editor.contentStyles.push(emptyBlocksCSS + '{padding-right: 1px !important}');
				}
			}
	
			/**
			 * Old IE versions can't retain contents within noscript elements so this logic will store the contents
			 * as a attribute and the insert that value as it's raw text when the DOM is serialized.
			 */
			function keepNoScriptContents() {
				if (getDocumentMode() < 9) {
					parser.addNodeFilter('noscript', function(nodes) {
						var i = nodes.length, node, textNode;
	
						while (i--) {
							node = nodes[i];
							textNode = node.firstChild;
	
							if (textNode) {
								node.attr('data-mce-innertext', textNode.value);
							}
						}
					});
	
					serializer.addNodeFilter('noscript', function(nodes) {
						var i = nodes.length, node, textNode, value;
	
						while (i--) {
							node = nodes[i];
							textNode = nodes[i].firstChild;
	
							if (textNode) {
								textNode.value = Entities.decode(textNode.value);
							} else {
								// Old IE can't retain noscript value so an attribute is used to store it
								value = node.attributes.map['data-mce-innertext'];
								if (value) {
									node.attr('data-mce-innertext', null);
									textNode = new Node('#text', 3);
									textNode.value = value;
									textNode.raw = true;
									node.append(textNode);
								}
							}
						}
					});
				}
			}
	
			/**
			 * IE has an issue where you can't select/move the caret by clicking outside the body if the document is in standards mode.
			 */
			function fixCaretSelectionOfDocumentElementOnIe() {
				var doc = dom.doc, body = doc.body, started, startRng, htmlElm;
	
				// Return range from point or null if it failed
				function rngFromPoint(x, y) {
					var rng = body.createTextRange();
	
					try {
						rng.moveToPoint(x, y);
					} catch (ex) {
						// IE sometimes throws and exception, so lets just ignore it
						rng = null;
					}
	
					return rng;
				}
	
				// Fires while the selection is changing
				function selectionChange(e) {
					var pointRng;
	
					// Check if the button is down or not
					if (e.button) {
						// Create range from mouse position
						pointRng = rngFromPoint(e.x, e.y);
	
						if (pointRng) {
							// Check if pointRange is before/after selection then change the endPoint
							if (pointRng.compareEndPoints('StartToStart', startRng) > 0) {
								pointRng.setEndPoint('StartToStart', startRng);
							} else {
								pointRng.setEndPoint('EndToEnd', startRng);
							}
	
							pointRng.select();
						}
					} else {
						endSelection();
					}
				}
	
				// Removes listeners
				function endSelection() {
					var rng = doc.selection.createRange();
	
					// If the range is collapsed then use the last start range
					if (startRng && !rng.item && rng.compareEndPoints('StartToEnd', rng) === 0) {
						startRng.select();
					}
	
					dom.unbind(doc, 'mouseup', endSelection);
					dom.unbind(doc, 'mousemove', selectionChange);
					startRng = started = 0;
				}
	
				// Make HTML element unselectable since we are going to handle selection by hand
				doc.documentElement.unselectable = true;
	
				// Detect when user selects outside BODY
				dom.bind(doc, 'mousedown contextmenu', function(e) {
					if (e.target.nodeName === 'HTML') {
						if (started) {
							endSelection();
						}
	
						// Detect vertical scrollbar, since IE will fire a mousedown on the scrollbar and have target set as HTML
						htmlElm = doc.documentElement;
						if (htmlElm.scrollHeight > htmlElm.clientHeight) {
							return;
						}
	
						started = 1;
						// Setup start position
						startRng = rngFromPoint(e.x, e.y);
						if (startRng) {
							// Listen for selection change events
							dom.bind(doc, 'mouseup', endSelection);
							dom.bind(doc, 'mousemove', selectionChange);
	
							dom.getRoot().focus();
							startRng.select();
						}
					}
				});
			}
	
			/**
			 * Fixes selection issues where the caret can be placed between two inline elements like <b>a</b>|<b>b</b>
			 * this fix will lean the caret right into the closest inline element.
			 */
			function normalizeSelection() {
				// Normalize selection for example <b>a</b><i>|a</i> becomes <b>a|</b><i>a</i> except for Ctrl+A since it selects everything
				editor.on('keyup focusin mouseup', function(e) {
					if (e.keyCode != 65 || !VK.metaKeyPressed(e)) {
						selection.normalize();
					}
				}, true);
			}
	
			/**
			 * Forces Gecko to render a broken image icon if it fails to load an image.
			 */
			function showBrokenImageIcon() {
				editor.contentStyles.push(
					'img:-moz-broken {' +
						'-moz-force-broken-image-icon:1;' +
						'min-width:24px;' +
						'min-height:24px' +
					'}'
				);
			}
	
			/**
			 * iOS has a bug where it's impossible to type if the document has a touchstart event
			 * bound and the user touches the document while having the on screen keyboard visible.
			 *
			 * The touch event moves the focus to the parent document while having the caret inside the iframe
			 * this fix moves the focus back into the iframe document.
			 */
			function restoreFocusOnKeyDown() {
				if (!editor.inline) {
					editor.on('keydown', function() {
						if (document.activeElement == document.body) {
							editor.getWin().focus();
						}
					});
				}
			}
	
			/**
			 * IE 11 has an annoying issue where you can't move focus into the editor
			 * by clicking on the white area HTML element. We used to be able to to fix this with
			 * the fixCaretSelectionOfDocumentElementOnIe fix. But since M$ removed the selection
			 * object it's not possible anymore. So we need to hack in a ungly CSS to force the
			 * body to be at least 150px. If the user clicks the HTML element out side this 150px region
			 * we simply move the focus into the first paragraph. Not ideal since you loose the
			 * positioning of the caret but goot enough for most cases.
			 */
			function bodyHeight() {
				if (!editor.inline) {
					editor.contentStyles.push('body {min-height: 150px}');
					editor.on('click', function(e) {
						var rng;
	
						if (e.target.nodeName == 'HTML') {
							// Edge seems to only need focus if we set the range
							// the caret will become invisible and moved out of the iframe!!
							if (Env.ie > 11) {
								editor.getBody().focus();
								return;
							}
	
							// Need to store away non collapsed ranges since the focus call will mess that up see #7382
							rng = editor.selection.getRng();
							editor.getBody().focus();
							editor.selection.setRng(rng);
							editor.selection.normalize();
							editor.nodeChanged();
						}
					});
				}
			}
	
			/**
			 * Firefox on Mac OS will move the browser back to the previous page if you press CMD+Left arrow.
			 * You might then loose all your work so we need to block that behavior and replace it with our own.
			 */
			function blockCmdArrowNavigation() {
				if (Env.mac) {
					editor.on('keydown', function(e) {
						if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode == 37 || e.keyCode == 39)) {
							e.preventDefault();
							editor.selection.getSel().modify('move', e.keyCode == 37 ? 'backward' : 'forward', 'lineboundary');
						}
					});
				}
			}
	
			/**
			 * Disables the autolinking in IE 9+ this is then re-enabled by the autolink plugin.
			 */
			function disableAutoUrlDetect() {
				setEditorCommandState("AutoUrlDetect", false);
			}
	
			/**
			 * iOS 7.1 introduced two new bugs:
			 * 1) It's possible to open links within a contentEditable area by clicking on them.
			 * 2) If you hold down the finger it will display the link/image touch callout menu.
			 */
			function tapLinksAndImages() {
				editor.on('click', function(e) {
					var elm = e.target;
	
					do {
						if (elm.tagName === 'A') {
							e.preventDefault();
							return;
						}
					} while ((elm = elm.parentNode));
				});
	
				editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
			}
	
			/**
			 * iOS Safari and possible other browsers have a bug where it won't fire
			 * a click event when a contentEditable is focused. This function fakes click events
			 * by using touchstart/touchend and measuring the time and distance travelled.
			 */
			/*
			function touchClickEvent() {
				editor.on('touchstart', function(e) {
					var elm, time, startTouch, changedTouches;
	
					elm = e.target;
					time = new Date().getTime();
					changedTouches = e.changedTouches;
	
					if (!changedTouches || changedTouches.length > 1) {
						return;
					}
	
					startTouch = changedTouches[0];
	
					editor.once('touchend', function(e) {
						var endTouch = e.changedTouches[0], args;
	
						if (new Date().getTime() - time > 500) {
							return;
						}
	
						if (Math.abs(startTouch.clientX - endTouch.clientX) > 5) {
							return;
						}
	
						if (Math.abs(startTouch.clientY - endTouch.clientY) > 5) {
							return;
						}
	
						args = {
							target: elm
						};
	
						each('pageX pageY clientX clientY screenX screenY'.split(' '), function(key) {
							args[key] = endTouch[key];
						});
	
						args = editor.fire('click', args);
	
						if (!args.isDefaultPrevented()) {
							// iOS WebKit can't place the caret properly once
							// you bind touch events so we need to do this manually
							// TODO: Expand to the closest word? Touble tap still works.
							editor.selection.placeCaretAt(endTouch.clientX, endTouch.clientY);
							editor.nodeChanged();
						}
					});
				});
			}
			*/
	
			/**
			 * WebKit has a bug where it will allow forms to be submitted if they are inside a contentEditable element.
			 * For example this: <form><button></form>
			 */
			function blockFormSubmitInsideEditor() {
				editor.on('init', function() {
					editor.dom.bind(editor.getBody(), 'submit', function(e) {
						e.preventDefault();
					});
				});
			}
	
			/**
			 * Sometimes WebKit/Blink generates BR elements with the Apple-interchange-newline class.
			 *
			 * Scenario:
			 *  1) Create a table 2x2.
			 *  2) Select and copy cells A2-B2.
			 *  3) Paste and it will add BR element to table cell.
			 */
			function removeAppleInterchangeBrs() {
				parser.addNodeFilter('br', function(nodes) {
					var i = nodes.length;
	
					while (i--) {
						if (nodes[i].attr('class') == 'Apple-interchange-newline') {
							nodes[i].remove();
						}
					}
				});
			}
	
			/**
			 * IE cannot set custom contentType's on drag events, and also does not properly drag/drop between
			 * editors. This uses a special data:text/mce-internal URL to pass data when drag/drop between editors.
			 */
			function ieInternalDragAndDrop() {
				editor.on('dragstart', function(e) {
					setMceInternalContent(e);
				});
	
				editor.on('drop', function(e) {
					if (!isDefaultPrevented(e)) {
						var internalContent = getMceInternalContent(e);
	
						if (internalContent && internalContent.id != editor.id) {
							e.preventDefault();
	
							var rng = RangeUtils.getCaretRangeFromPoint(e.x, e.y, editor.getDoc());
							selection.setRng(rng);
							insertClipboardContents(internalContent.html);
						}
					}
				});
			}
	
			function refreshContentEditable() {
				var body, parent;
	
				// Check if the editor was hidden and the re-initialize contentEditable mode by removing and adding the body again
				if (isHidden()) {
					body = editor.getBody();
					parent = body.parentNode;
	
					parent.removeChild(body);
					parent.appendChild(body);
	
					body.focus();
				}
			}
	
			function isHidden() {
				var sel;
	
				if (!isGecko) {
					return 0;
				}
	
				// Weird, wheres that cursor selection?
				sel = editor.selection.getSel();
				return (!sel || !sel.rangeCount || sel.rangeCount === 0);
			}
	
			/**
			 * Properly empties the editor if all contents is selected and deleted this to
			 * prevent empty paragraphs from being produced at beginning/end of contents.
			 */
			function emptyEditorOnDeleteEverything() {
				function isEverythingSelected(editor) {
					var caretWalker = new CaretWalker(editor.getBody());
					var rng = editor.selection.getRng();
					var startCaretPos = CaretPosition.fromRangeStart(rng);
					var endCaretPos = CaretPosition.fromRangeEnd(rng);
	
					return !editor.selection.isCollapsed() && !caretWalker.prev(startCaretPos) && !caretWalker.next(endCaretPos);
				}
	
				// Type over case delete and insert this won't cover typeover with a IME but at least it covers the common case
				editor.on('keypress', function (e) {
					if (!isDefaultPrevented(e) && !selection.isCollapsed() && e.charCode > 31 && !VK.metaKeyPressed(e)) {
						if (isEverythingSelected(editor)) {
							e.preventDefault();
							editor.setContent(String.fromCharCode(e.charCode));
							editor.selection.select(editor.getBody(), true);
							editor.selection.collapse(false);
							editor.nodeChanged();
						}
					}
				});
	
				editor.on('keydown', function (e) {
					var keyCode = e.keyCode;
	
					if (!isDefaultPrevented(e) && (keyCode == DELETE || keyCode == BACKSPACE)) {
						if (isEverythingSelected(editor)) {
							e.preventDefault();
							editor.setContent('');
							editor.nodeChanged();
						}
					}
				});
			}
	
			// All browsers
			removeBlockQuoteOnBackSpace();
			emptyEditorWhenDeleting();
	
			// Windows phone will return a range like [body, 0] on mousedown so
			// it will always normalize to the wrong location
			if (!Env.windowsPhone) {
				normalizeSelection();
			}
	
			// WebKit
			if (isWebKit) {
				emptyEditorOnDeleteEverything();
				cleanupStylesWhenDeleting();
				inputMethodFocus();
				selectControlElements();
				setDefaultBlockType();
				blockFormSubmitInsideEditor();
				disableBackspaceIntoATable();
				removeAppleInterchangeBrs();
	
				//touchClickEvent();
	
				// iOS
				if (Env.iOS) {
					restoreFocusOnKeyDown();
					bodyHeight();
					tapLinksAndImages();
				} else {
					selectAll();
				}
			}
	
			// IE
			if (isIE && Env.ie < 11) {
				removeHrOnBackspace();
				ensureBodyHasRoleApplication();
				addNewLinesBeforeBrInPre();
				removePreSerializedStylesWhenSelectingControls();
				deleteControlItemOnBackSpace();
				renderEmptyBlocksFix();
				keepNoScriptContents();
				fixCaretSelectionOfDocumentElementOnIe();
			}
	
			if (Env.ie >= 11) {
				bodyHeight();
				disableBackspaceIntoATable();
			}
	
			if (Env.ie) {
				selectAll();
				disableAutoUrlDetect();
				ieInternalDragAndDrop();
			}
	
			// Gecko
			if (isGecko) {
				emptyEditorOnDeleteEverything();
				removeHrOnBackspace();
				focusBody();
				removeStylesWhenDeletingAcrossBlockElements();
				setGeckoEditingOptions();
				addBrAfterLastLinks();
				showBrokenImageIcon();
				blockCmdArrowNavigation();
				disableBackspaceIntoATable();
			}
	
			return {
				refreshContentEditable: refreshContentEditable,
				isHidden: isHidden
			};
		};
	});
	
	// Included from: js/tinymce/classes/EditorObservable.js
	
	/**
	 * EditorObservable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin contains the event logic for the tinymce.Editor class.
	 *
	 * @mixin tinymce.EditorObservable
	 * @extends tinymce.util.Observable
	 */
	define("tinymce/EditorObservable", [
		"tinymce/util/Observable",
		"tinymce/dom/DOMUtils",
		"tinymce/util/Tools"
	], function(Observable, DOMUtils, Tools) {
		var DOM = DOMUtils.DOM, customEventRootDelegates;
	
		/**
		 * Returns the event target so for the specified event. Some events fire
		 * only on document, some fire on documentElement etc. This also handles the
		 * custom event root setting where it returns that element instead of the body.
		 *
		 * @private
		 * @param {tinymce.Editor} editor Editor instance to get event target from.
		 * @param {String} eventName Name of the event for example "click".
		 * @return {Element/Document} HTML Element or document target to bind on.
		 */
		function getEventTarget(editor, eventName) {
			if (eventName == 'selectionchange') {
				return editor.getDoc();
			}
	
			// Need to bind mousedown/mouseup etc to document not body in iframe mode
			// Since the user might click on the HTML element not the BODY
			if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
				return editor.getDoc().documentElement;
			}
	
			// Bind to event root instead of body if it's defined
			if (editor.settings.event_root) {
				if (!editor.eventRoot) {
					editor.eventRoot = DOM.select(editor.settings.event_root)[0];
				}
	
				return editor.eventRoot;
			}
	
			return editor.getBody();
		}
	
		/**
		 * Binds a event delegate for the specified name this delegate will fire
		 * the event to the editor dispatcher.
		 *
		 * @private
		 * @param {tinymce.Editor} editor Editor instance to get event target from.
		 * @param {String} eventName Name of the event for example "click".
		 */
		function bindEventDelegate(editor, eventName) {
			var eventRootElm = getEventTarget(editor, eventName), delegate;
	
			function isListening(editor) {
				return !editor.hidden && !editor.readonly;
			}
	
			if (!editor.delegates) {
				editor.delegates = {};
			}
	
			if (editor.delegates[eventName]) {
				return;
			}
	
			if (editor.settings.event_root) {
				if (!customEventRootDelegates) {
					customEventRootDelegates = {};
					editor.editorManager.on('removeEditor', function() {
						var name;
	
						if (!editor.editorManager.activeEditor) {
							if (customEventRootDelegates) {
								for (name in customEventRootDelegates) {
									editor.dom.unbind(getEventTarget(editor, name));
								}
	
								customEventRootDelegates = null;
							}
						}
					});
				}
	
				if (customEventRootDelegates[eventName]) {
					return;
				}
	
				delegate = function(e) {
					var target = e.target, editors = editor.editorManager.editors, i = editors.length;
	
					while (i--) {
						var body = editors[i].getBody();
	
						if (body === target || DOM.isChildOf(target, body)) {
							if (isListening(editors[i])) {
								editors[i].fire(eventName, e);
							}
						}
					}
				};
	
				customEventRootDelegates[eventName] = delegate;
				DOM.bind(eventRootElm, eventName, delegate);
			} else {
				delegate = function(e) {
					if (isListening(editor)) {
						editor.fire(eventName, e);
					}
				};
	
				DOM.bind(eventRootElm, eventName, delegate);
				editor.delegates[eventName] = delegate;
			}
		}
	
		var EditorObservable = {
			/**
			 * Bind any pending event delegates. This gets executed after the target body/document is created.
			 *
			 * @private
			 */
			bindPendingEventDelegates: function() {
				var self = this;
	
				Tools.each(self._pendingNativeEvents, function(name) {
					bindEventDelegate(self, name);
				});
			},
	
			/**
			 * Toggles a native event on/off this is called by the EventDispatcher when
			 * the first native event handler is added and when the last native event handler is removed.
			 *
			 * @private
			 */
			toggleNativeEvent: function(name, state) {
				var self = this;
	
				// Never bind focus/blur since the FocusManager fakes those
				if (name == "focus" || name == "blur") {
					return;
				}
	
				if (state) {
					if (self.initialized) {
						bindEventDelegate(self, name);
					} else {
						if (!self._pendingNativeEvents) {
							self._pendingNativeEvents = [name];
						} else {
							self._pendingNativeEvents.push(name);
						}
					}
				} else if (self.initialized) {
					self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
					delete self.delegates[name];
				}
			},
	
			/**
			 * Unbinds all native event handlers that means delegates, custom events bound using the Events API etc.
			 *
			 * @private
			 */
			unbindAllNativeEvents: function() {
				var self = this, name;
	
				if (self.delegates) {
					for (name in self.delegates) {
						self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
					}
	
					delete self.delegates;
				}
	
				if (!self.inline) {
					self.getBody().onload = null;
					self.dom.unbind(self.getWin());
					self.dom.unbind(self.getDoc());
				}
	
				self.dom.unbind(self.getBody());
				self.dom.unbind(self.getContainer());
			}
		};
	
		EditorObservable = Tools.extend({}, Observable, EditorObservable);
	
		return EditorObservable;
	});
	
	// Included from: js/tinymce/classes/Mode.js
	
	/**
	 * Mode.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Mode switcher logic.
	 *
	 * @private
	 * @class tinymce.Mode
	 */
	define("tinymce/Mode", [], function() {
		function setEditorCommandState(editor, cmd, state) {
			try {
				editor.getDoc().execCommand(cmd, false, state);
			} catch (ex) {
				// Ignore
			}
		}
	
		function clickBlocker(editor) {
			var target, handler;
	
			target = editor.getBody();
	
			handler = function(e) {
				if (editor.dom.getParents(e.target, 'a').length > 0) {
					e.preventDefault();
				}
			};
	
			editor.dom.bind(target, 'click', handler);
	
			return {
				unbind: function() {
					editor.dom.unbind(target, 'click', handler);
				}
			};
		}
	
		function toggleReadOnly(editor, state) {
			if (editor._clickBlocker) {
				editor._clickBlocker.unbind();
				editor._clickBlocker = null;
			}
	
			if (state) {
				editor._clickBlocker = clickBlocker(editor);
				editor.selection.controlSelection.hideResizeRect();
				editor.readonly = true;
				editor.getBody().contentEditable = false;
			} else {
				editor.readonly = false;
				editor.getBody().contentEditable = true;
				setEditorCommandState(editor, "StyleWithCSS", false);
				setEditorCommandState(editor, "enableInlineTableEditing", false);
				setEditorCommandState(editor, "enableObjectResizing", false);
				editor.focus();
				editor.nodeChanged();
			}
		}
	
		function setMode(editor, mode) {
			var currentMode = editor.readonly ? 'readonly' : 'design';
	
			if (mode == currentMode) {
				return;
			}
	
			if (editor.initialized) {
				toggleReadOnly(editor, mode == 'readonly');
			} else {
				editor.on('init', function() {
					toggleReadOnly(editor, mode == 'readonly');
				});
			}
	
			// Event is NOT preventable
			editor.fire('SwitchMode', {mode: mode});
		}
	
		return {
			setMode: setMode
		};
	});
	
	// Included from: js/tinymce/classes/Shortcuts.js
	
	/**
	 * Shortcuts.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains all logic for handling of keyboard shortcuts.
	 *
	 * @class tinymce.Shortcuts
	 * @example
	 * editor.shortcuts.add('ctrl+a', function() {});
	 * editor.shortcuts.add('meta+a', function() {}); // "meta" maps to Command on Mac and Ctrl on PC
	 * editor.shortcuts.add('ctrl+alt+a', function() {});
	 * editor.shortcuts.add('access+a', function() {}); // "access" maps to ctrl+alt on Mac and shift+alt on PC
	 */
	define("tinymce/Shortcuts", [
		"tinymce/util/Tools",
		"tinymce/Env"
	], function(Tools, Env) {
		var each = Tools.each, explode = Tools.explode;
	
		var keyCodeLookup = {
			"f9": 120,
			"f10": 121,
			"f11": 122
		};
	
		var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	
		return function(editor) {
			var self = this, shortcuts = {}, pendingPatterns = [];
	
			function parseShortcut(pattern) {
				var id, key, shortcut = {};
	
				// Parse modifiers and keys ctrl+alt+b for example
				each(explode(pattern, '+'), function(value) {
					if (value in modifierNames) {
						shortcut[value] = true;
					} else {
						// Allow numeric keycodes like ctrl+219 for ctrl+[
						if (/^[0-9]{2,}$/.test(value)) {
							shortcut.keyCode = parseInt(value, 10);
						} else {
							shortcut.charCode = value.charCodeAt(0);
							shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
						}
					}
				});
	
				// Generate unique id for modifier combination and set default state for unused modifiers
				id = [shortcut.keyCode];
				for (key in modifierNames) {
					if (shortcut[key]) {
						id.push(key);
					} else {
						shortcut[key] = false;
					}
				}
				shortcut.id = id.join(',');
	
				// Handle special access modifier differently depending on Mac/Win
				if (shortcut.access) {
					shortcut.alt = true;
	
					if (Env.mac) {
						shortcut.ctrl = true;
					} else {
						shortcut.shift = true;
					}
				}
	
				// Handle special meta modifier differently depending on Mac/Win
				if (shortcut.meta) {
					if (Env.mac) {
						shortcut.meta = true;
					} else {
						shortcut.ctrl = true;
						shortcut.meta = false;
					}
				}
	
				return shortcut;
			}
	
			function createShortcut(pattern, desc, cmdFunc, scope) {
				var shortcuts;
	
				shortcuts = Tools.map(explode(pattern, '>'), parseShortcut);
				shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
					func: cmdFunc,
					scope: scope || editor
				});
	
				return Tools.extend(shortcuts[0], {
					desc: editor.translate(desc),
					subpatterns: shortcuts.slice(1)
				});
			}
	
			function hasModifier(e) {
				return e.altKey || e.ctrlKey || e.metaKey;
			}
	
			function isFunctionKey(e) {
				return e.keyCode >= 112 && e.keyCode <= 123;
			}
	
			function matchShortcut(e, shortcut) {
				if (!shortcut) {
					return false;
				}
	
				if (shortcut.ctrl != e.ctrlKey || shortcut.meta != e.metaKey) {
					return false;
				}
	
				if (shortcut.alt != e.altKey || shortcut.shift != e.shiftKey) {
					return false;
				}
	
				if (e.keyCode == shortcut.keyCode || (e.charCode && e.charCode == shortcut.charCode)) {
					e.preventDefault();
					return true;
				}
	
				return false;
			}
	
			function executeShortcutAction(shortcut) {
				return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
			}
	
			editor.on('keyup keypress keydown', function(e) {
				if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
					each(shortcuts, function(shortcut) {
						if (matchShortcut(e, shortcut)) {
							pendingPatterns = shortcut.subpatterns.slice(0);
	
							if (e.type == "keydown") {
								executeShortcutAction(shortcut);
							}
	
							return true;
						}
					});
	
					if (matchShortcut(e, pendingPatterns[0])) {
						if (pendingPatterns.length === 1) {
							if (e.type == "keydown") {
								executeShortcutAction(pendingPatterns[0]);
							}
						}
	
						pendingPatterns.shift();
					}
				}
			});
	
			/**
			 * Adds a keyboard shortcut for some command or function.
			 *
			 * @method addShortcut
			 * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
			 * @param {String} desc Text description for the command.
			 * @param {String/Function} cmdFunc Command name string or function to execute when the key is pressed.
			 * @param {Object} scope Optional scope to execute the function in.
			 * @return {Boolean} true/false state if the shortcut was added or not.
			 */
			self.add = function(pattern, desc, cmdFunc, scope) {
				var cmd;
	
				cmd = cmdFunc;
	
				if (typeof cmdFunc === 'string') {
					cmdFunc = function() {
						editor.execCommand(cmd, false, null);
					};
				} else if (Tools.isArray(cmd)) {
					cmdFunc = function() {
						editor.execCommand(cmd[0], cmd[1], cmd[2]);
					};
				}
	
				each(explode(Tools.trim(pattern.toLowerCase())), function(pattern) {
					var shortcut = createShortcut(pattern, desc, cmdFunc, scope);
					shortcuts[shortcut.id] = shortcut;
				});
	
				return true;
			};
	
			/**
			 * Remove a keyboard shortcut by pattern.
			 *
			 * @method remove
			 * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
			 * @return {Boolean} true/false state if the shortcut was removed or not.
			 */
			self.remove = function(pattern) {
				var shortcut = createShortcut(pattern);
	
				if (shortcuts[shortcut.id]) {
					delete shortcuts[shortcut.id];
					return true;
				}
	
				return false;
			};
		};
	});
	
	// Included from: js/tinymce/classes/file/Uploader.js
	
	/**
	 * Uploader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Upload blobs or blob infos to the specified URL or handler.
	 *
	 * @private
	 * @class tinymce.file.Uploader
	 * @example
	 * var uploader = new Uploader({
	 *     url: '/upload.php',
	 *     basePath: '/base/path',
	 *     credentials: true,
	 *     handler: function(data, success, failure) {
	 *         ...
	 *     }
	 * });
	 *
	 * uploader.upload(blobInfos).then(function(result) {
	 *     ...
	 * });
	 */
	define("tinymce/file/Uploader", [
		"tinymce/util/Promise",
		"tinymce/util/Tools",
		"tinymce/util/Fun"
	], function(Promise, Tools, Fun) {
		return function(uploadStatus, settings) {
			var pendingPromises = {};
	
			function fileName(blobInfo) {
				var ext, extensions;
	
				extensions = {
					'image/jpeg': 'jpg',
					'image/jpg': 'jpg',
					'image/gif': 'gif',
					'image/png': 'png'
				};
	
				ext = extensions[blobInfo.blob().type.toLowerCase()] || 'dat';
	
				return blobInfo.id() + '.' + ext;
			}
	
			function pathJoin(path1, path2) {
				if (path1) {
					return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
				}
	
				return path2;
			}
	
			function blobInfoToData(blobInfo) {
				return {
					id: blobInfo.id,
					blob: blobInfo.blob,
					base64: blobInfo.base64,
					filename: Fun.constant(fileName(blobInfo))
				};
			}
	
			function defaultHandler(blobInfo, success, failure, progress) {
				var xhr, formData;
	
				xhr = new XMLHttpRequest();
				xhr.open('POST', settings.url);
				xhr.withCredentials = settings.credentials;
	
				xhr.upload.onprogress = function(e) {
					progress(e.loaded / e.total * 100);
				};
	
				xhr.onerror = function() {
					failure("Image upload failed due to a XHR Transport error. Code: " + xhr.status);
				};
	
				xhr.onload = function() {
					var json;
	
					if (xhr.status != 200) {
						failure("HTTP Error: " + xhr.status);
						return;
					}
	
					json = JSON.parse(xhr.responseText);
	
					if (!json || typeof json.location != "string") {
						failure("Invalid JSON: " + xhr.responseText);
						return;
					}
	
					success(pathJoin(settings.basePath, json.location));
				};
	
				formData = new FormData();
				formData.append('file', blobInfo.blob(), fileName(blobInfo));
	
				xhr.send(formData);
			}
	
			function noUpload() {
				return new Promise(function(resolve) {
					resolve([]);
				});
			}
	
			function handlerSuccess(blobInfo, url) {
				return {
					url: url,
					blobInfo: blobInfo,
					status: true
				};
			}
	
			function handlerFailure(blobInfo, error) {
				return {
					url: '',
					blobInfo: blobInfo,
					status: false,
					error: error
				};
			}
	
			function resolvePending(blobUri, result) {
				Tools.each(pendingPromises[blobUri], function(resolve) {
					resolve(result);
				});
	
				delete pendingPromises[blobUri];
			}
	
			function uploadBlobInfo(blobInfo, handler, openNotification) {
				uploadStatus.markPending(blobInfo.blobUri());
	
				return new Promise(function(resolve) {
					var notification, progress;
	
					var noop = function() {
					};
	
					try {
						var closeNotification = function() {
							if (notification) {
								notification.close();
								progress = noop; // Once it's closed it's closed
							}
						};
	
						var success = function(url) {
							closeNotification();
							uploadStatus.markUploaded(blobInfo.blobUri(), url);
							resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
							resolve(handlerSuccess(blobInfo, url));
						};
	
						var failure = function() {
							closeNotification();
							uploadStatus.removeFailed(blobInfo.blobUri());
							resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, failure));
							resolve(handlerFailure(blobInfo, failure));
						};
	
						progress = function(percent) {
							if (percent < 0 || percent > 100) {
								return;
							}
	
							if (!notification) {
								notification = openNotification();
							}
	
							notification.progressBar.value(percent);
						};
	
						handler(blobInfoToData(blobInfo), success, failure, progress);
					} catch (ex) {
						resolve(handlerFailure(blobInfo, ex.message));
					}
				});
			}
	
			function isDefaultHandler(handler) {
				return handler === defaultHandler;
			}
	
			function pendingUploadBlobInfo(blobInfo) {
				var blobUri = blobInfo.blobUri();
	
				return new Promise(function(resolve) {
					pendingPromises[blobUri] = pendingPromises[blobUri] || [];
					pendingPromises[blobUri].push(resolve);
				});
			}
	
			function uploadBlobs(blobInfos, openNotification) {
				blobInfos = Tools.grep(blobInfos, function(blobInfo) {
					return !uploadStatus.isUploaded(blobInfo.blobUri());
				});
	
				return Promise.all(Tools.map(blobInfos, function(blobInfo) {
					return uploadStatus.isPending(blobInfo.blobUri()) ?
						pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
				}));
			}
	
			function upload(blobInfos, openNotification) {
				return (!settings.url && isDefaultHandler(settings.handler)) ? noUpload() : uploadBlobs(blobInfos, openNotification);
			}
	
			settings = Tools.extend({
				credentials: false,
				// We are adding a notify argument to this (at the moment, until it doesn't work)
				handler: defaultHandler
			}, settings);
	
			return {
				upload: upload
			};
		};
	});
	
	// Included from: js/tinymce/classes/file/Conversions.js
	
	/**
	 * Conversions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Converts blob/uris back and forth.
	 *
	 * @private
	 * @class tinymce.file.Conversions
	 */
	define("tinymce/file/Conversions", [
		"tinymce/util/Promise"
	], function(Promise) {
		function blobUriToBlob(url) {
			return new Promise(function(resolve) {
				var xhr = new XMLHttpRequest();
	
				xhr.open('GET', url, true);
				xhr.responseType = 'blob';
	
				xhr.onload = function() {
					if (this.status == 200) {
						resolve(this.response);
					}
				};
	
				xhr.send();
			});
		}
	
		function parseDataUri(uri) {
			var type, matches;
	
			uri = decodeURIComponent(uri).split(',');
	
			matches = /data:([^;]+)/.exec(uri[0]);
			if (matches) {
				type = matches[1];
			}
	
			return {
				type: type,
				data: uri[1]
			};
		}
	
		function dataUriToBlob(uri) {
			return new Promise(function(resolve) {
				var str, arr, i;
	
				uri = parseDataUri(uri);
	
				// Might throw error if data isn't proper base64
				try {
					str = atob(uri.data);
				} catch (e) {
					resolve(new Blob([]));
					return;
				}
	
				arr = new Uint8Array(str.length);
	
				for (i = 0; i < arr.length; i++) {
					arr[i] = str.charCodeAt(i);
				}
	
				resolve(new Blob([arr], {type: uri.type}));
			});
		}
	
		function uriToBlob(url) {
			if (url.indexOf('blob:') === 0) {
				return blobUriToBlob(url);
			}
	
			if (url.indexOf('data:') === 0) {
				return dataUriToBlob(url);
			}
	
			return null;
		}
	
		function blobToDataUri(blob) {
			return new Promise(function(resolve) {
				var reader = new FileReader();
	
				reader.onloadend = function() {
					resolve(reader.result);
				};
	
				reader.readAsDataURL(blob);
			});
		}
	
		return {
			uriToBlob: uriToBlob,
			blobToDataUri: blobToDataUri,
			parseDataUri: parseDataUri
		};
	});
	
	// Included from: js/tinymce/classes/file/ImageScanner.js
	
	/**
	 * ImageScanner.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Finds images with data uris or blob uris. If data uris are found it will convert them into blob uris.
	 *
	 * @private
	 * @class tinymce.file.ImageScanner
	 */
	define("tinymce/file/ImageScanner", [
		"tinymce/util/Promise",
		"tinymce/util/Arr",
		"tinymce/util/Fun",
		"tinymce/file/Conversions",
		"tinymce/Env"
	], function(Promise, Arr, Fun, Conversions, Env) {
		var count = 0;
	
		return function(uploadStatus, blobCache) {
			var cachedPromises = {};
	
			function findAll(elm, predicate) {
				var images, promises;
	
				function imageToBlobInfo(img, resolve) {
					var base64, blobInfo;
	
					if (img.src.indexOf('blob:') === 0) {
						blobInfo = blobCache.getByUri(img.src);
	
						if (blobInfo) {
							resolve({
								image: img,
								blobInfo: blobInfo
							});
						}
	
						return;
					}
	
					base64 = Conversions.parseDataUri(img.src).data;
					blobInfo = blobCache.findFirst(function(cachedBlobInfo) {
						return cachedBlobInfo.base64() === base64;
					});
	
					if (blobInfo) {
						resolve({
							image: img,
							blobInfo: blobInfo
						});
					} else {
						Conversions.uriToBlob(img.src).then(function(blob) {
							var blobInfoId = 'blobid' + (count++),
								blobInfo = blobCache.create(blobInfoId, blob, base64);
	
							blobCache.add(blobInfo);
	
							resolve({
								image: img,
								blobInfo: blobInfo
							});
						});
					}
				}
	
				if (!predicate) {
					predicate = Fun.constant(true);
				}
	
				images = Arr.filter(elm.getElementsByTagName('img'), function(img) {
					var src = img.src;
	
					if (!Env.fileApi) {
						return false;
					}
	
					if (img.hasAttribute('data-mce-bogus')) {
						return false;
					}
	
					if (img.hasAttribute('data-mce-placeholder')) {
						return false;
					}
	
					if (!src || src == Env.transparentSrc) {
						return false;
					}
	
					if (src.indexOf('blob:') === 0) {
						return !uploadStatus.isUploaded(src);
					}
	
					if (src.indexOf('data:') === 0) {
						return predicate(img);
					}
	
					return false;
				});
	
				promises = Arr.map(images, function(img) {
					var newPromise;
	
					if (cachedPromises[img.src]) {
						// Since the cached promise will return the cached image
						// We need to wrap it and resolve with the actual image
						return new Promise(function(resolve) {
							cachedPromises[img.src].then(function(imageInfo) {
								resolve({
									image: img,
									blobInfo: imageInfo.blobInfo
								});
							});
						});
					}
	
					newPromise = new Promise(function(resolve) {
						imageToBlobInfo(img, resolve);
					}).then(function(result) {
						delete cachedPromises[result.image.src];
						return result;
					})['catch'](function(error) {
						delete cachedPromises[img.src];
						return error;
					});
	
					cachedPromises[img.src] = newPromise;
	
					return newPromise;
				});
	
				return Promise.all(promises);
			}
	
			return {
				findAll: findAll
			};
		};
	});
	
	// Included from: js/tinymce/classes/file/BlobCache.js
	
	/**
	 * BlobCache.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Hold blob info objects where a blob has extra internal information.
	 *
	 * @private
	 * @class tinymce.file.BlobCache
	 */
	define("tinymce/file/BlobCache", [
		"tinymce/util/Arr",
		"tinymce/util/Fun"
	], function(Arr, Fun) {
		return function() {
			var cache = [], constant = Fun.constant;
	
			function create(id, blob, base64) {
				return {
					id: constant(id),
					blob: constant(blob),
					base64: constant(base64),
					blobUri: constant(URL.createObjectURL(blob))
				};
			}
	
			function add(blobInfo) {
				if (!get(blobInfo.id())) {
					cache.push(blobInfo);
				}
			}
	
			function get(id) {
				return findFirst(function(cachedBlobInfo) {
					return cachedBlobInfo.id() === id;
				});
			}
	
			function findFirst(predicate) {
				return Arr.filter(cache, predicate)[0];
			}
	
			function getByUri(blobUri) {
				return findFirst(function(blobInfo) {
					return blobInfo.blobUri() == blobUri;
				});
			}
	
			function removeByUri(blobUri) {
				cache = Arr.filter(cache, function(blobInfo) {
					if (blobInfo.blobUri() === blobUri) {
						URL.revokeObjectURL(blobInfo.blobUri());
						return false;
					}
	
					return true;
				});
			}
	
			function destroy() {
				Arr.each(cache, function(cachedBlobInfo) {
					URL.revokeObjectURL(cachedBlobInfo.blobUri());
				});
	
				cache = [];
			}
	
			return {
				create: create,
				add: add,
				get: get,
				getByUri: getByUri,
				findFirst: findFirst,
				removeByUri: removeByUri,
				destroy: destroy
			};
		};
	});
	
	// Included from: js/tinymce/classes/file/UploadStatus.js
	
	/**
	 * UploadStatus.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Holds the current status of a blob uri, if it's pending or uploaded and what the result urls was.
	 *
	 * @private
	 * @class tinymce.file.UploadStatus
	 */
	define("tinymce/file/UploadStatus", [
	], function() {
		return function() {
			var PENDING = 1, UPLOADED = 2;
			var blobUriStatuses = {};
	
			function createStatus(status, resultUri) {
				return {
					status: status,
					resultUri: resultUri
				};
			}
	
			function hasBlobUri(blobUri) {
				return blobUri in blobUriStatuses;
			}
	
			function getResultUri(blobUri) {
				var result = blobUriStatuses[blobUri];
	
				return result ? result.resultUri : null;
			}
	
			function isPending(blobUri) {
				return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
			}
	
			function isUploaded(blobUri) {
				return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
			}
	
			function markPending(blobUri) {
				blobUriStatuses[blobUri] = createStatus(PENDING, null);
			}
	
			function markUploaded(blobUri, resultUri) {
				blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
			}
	
			function removeFailed(blobUri) {
				delete blobUriStatuses[blobUri];
			}
	
			function destroy() {
				blobUriStatuses = {};
			}
	
			return {
				hasBlobUri: hasBlobUri,
				getResultUri: getResultUri,
				isPending: isPending,
				isUploaded: isUploaded,
				markPending: markPending,
				markUploaded: markUploaded,
				removeFailed: removeFailed,
				destroy: destroy
			};
		};
	});
	
	// Included from: js/tinymce/classes/EditorUpload.js
	
	/**
	 * EditorUpload.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles image uploads, updates undo stack and patches over various internal functions.
	 *
	 * @private
	 * @class tinymce.EditorUpload
	 */
	define("tinymce/EditorUpload", [
		"tinymce/util/Arr",
		"tinymce/file/Uploader",
		"tinymce/file/ImageScanner",
		"tinymce/file/BlobCache",
		"tinymce/file/UploadStatus"
	], function(Arr, Uploader, ImageScanner, BlobCache, UploadStatus) {
		return function(editor) {
			var blobCache = new BlobCache(), uploader, imageScanner, settings = editor.settings;
			var uploadStatus = new UploadStatus();
	
			function aliveGuard(callback) {
				return function(result) {
					if (editor.selection) {
						return callback(result);
					}
	
					return [];
				};
			}
	
			// Replaces strings without regexps to avoid FF regexp to big issue
			function replaceString(content, search, replace) {
				var index = 0;
	
				do {
					index = content.indexOf(search, index);
	
					if (index !== -1) {
						content = content.substring(0, index) + replace + content.substr(index + search.length);
						index += replace.length - search.length + 1;
					}
				} while (index !== -1);
	
				return content;
			}
	
			function replaceImageUrl(content, targetUrl, replacementUrl) {
				content = replaceString(content, 'src="' + targetUrl + '"', 'src="' + replacementUrl + '"');
				content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	
				return content;
			}
	
			function replaceUrlInUndoStack(targetUrl, replacementUrl) {
				Arr.each(editor.undoManager.data, function(level) {
					level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
				});
			}
	
			function openNotification() {
				return editor.notificationManager.open({
					text: editor.translate('Image uploading...'),
					type: 'info',
					timeout: -1,
					progressBar: true
				});
			}
	
			function replaceImageUri(image, resultUri) {
				blobCache.removeByUri(image.src);
				replaceUrlInUndoStack(image.src, resultUri);
	
				editor.$(image).attr({
					src: resultUri,
					'data-mce-src': editor.convertURL(resultUri, 'src')
				});
			}
	
			function uploadImages(callback) {
				if (!uploader) {
					uploader = new Uploader(uploadStatus, {
						url: settings.images_upload_url,
						basePath: settings.images_upload_base_path,
						credentials: settings.images_upload_credentials,
						handler: settings.images_upload_handler
					});
				}
	
				return scanForImages().then(aliveGuard(function(imageInfos) {
					var blobInfos;
	
					blobInfos = Arr.map(imageInfos, function(imageInfo) {
						return imageInfo.blobInfo;
					});
	
					return uploader.upload(blobInfos, openNotification).then(aliveGuard(function(result) {
						result = Arr.map(result, function(uploadInfo, index) {
							var image = imageInfos[index].image;
	
							if (uploadInfo.status && editor.settings.images_replace_blob_uris !== false) {
								replaceImageUri(image, uploadInfo.url);
							}
	
							return {
								element: image,
								status: uploadInfo.status
							};
						});
	
						if (callback) {
							callback(result);
						}
	
						return result;
					}));
				}));
			}
	
			function uploadImagesAuto(callback) {
				if (settings.automatic_uploads !== false) {
					return uploadImages(callback);
				}
			}
	
			function isValidDataUriImage(imgElm) {
				return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
			}
	
			function scanForImages() {
				if (!imageScanner) {
					imageScanner = new ImageScanner(uploadStatus, blobCache);
				}
	
				return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function(result) {
					Arr.each(result, function(resultItem) {
						replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
						resultItem.image.src = resultItem.blobInfo.blobUri();
						resultItem.image.removeAttribute('data-mce-src');
					});
	
					return result;
				}));
			}
	
			function destroy() {
				blobCache.destroy();
				uploadStatus.destroy();
				imageScanner = uploader = null;
			}
	
			function replaceBlobUris(content) {
				return content.replace(/src="(blob:[^"]+)"/g, function(match, blobUri) {
					var resultUri = uploadStatus.getResultUri(blobUri);
	
					if (resultUri) {
						return 'src="' + resultUri + '"';
					}
	
					var blobInfo = blobCache.getByUri(blobUri);
	
					if (!blobInfo) {
						blobInfo = Arr.reduce(editor.editorManager.editors, function(result, editor) {
							return result || editor.editorUpload.blobCache.getByUri(blobUri);
						}, null);
					}
	
					if (blobInfo) {
						return 'src="data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64() + '"';
					}
	
					return match;
				});
			}
	
			editor.on('setContent', function() {
				if (editor.settings.automatic_uploads !== false) {
					uploadImagesAuto();
				} else {
					scanForImages();
				}
			});
	
			editor.on('RawSaveContent', function(e) {
				e.content = replaceBlobUris(e.content);
			});
	
			editor.on('getContent', function(e) {
				if (e.source_view || e.format == 'raw') {
					return;
				}
	
				e.content = replaceBlobUris(e.content);
			});
	
			editor.on('PostRender', function() {
				editor.parser.addNodeFilter('img', function(images) {
					Arr.each(images, function(img) {
						var src = img.attr('src');
	
						if (blobCache.getByUri(src)) {
							return;
						}
	
						var resultUri = uploadStatus.getResultUri(src);
						if (resultUri) {
							img.attr('src', resultUri);
						}
					});
				});
			});
	
			return {
				blobCache: blobCache,
				uploadImages: uploadImages,
				uploadImagesAuto: uploadImagesAuto,
				scanForImages: scanForImages,
				destroy: destroy
			};
		};
	});
	
	// Included from: js/tinymce/classes/caret/FakeCaret.js
	
	/**
	 * FakeCaret.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for rendering a fake visual caret.
	 *
	 * @private
	 * @class tinymce.caret.FakeCaret
	 */
	define("tinymce/caret/FakeCaret", [
		"tinymce/caret/CaretContainer",
		"tinymce/caret/CaretPosition",
		"tinymce/dom/NodeType",
		"tinymce/dom/RangeUtils",
		"tinymce/dom/DomQuery",
		"tinymce/geom/ClientRect",
		"tinymce/util/Delay"
	], function(CaretContainer, CaretPosition, NodeType, RangeUtils, $, ClientRect, Delay) {
		var isContentEditableFalse = NodeType.isContentEditableFalse;
	
		return function(rootNode, isBlock) {
			var cursorInterval, $lastVisualCaret, caretContainerNode;
	
			function getAbsoluteClientRect(node, before) {
				var clientRect = ClientRect.collapse(node.getBoundingClientRect(), before),
					docElm, scrollX, scrollY, margin, rootRect;
	
				if (rootNode.tagName == 'BODY') {
					docElm = rootNode.ownerDocument.documentElement;
					scrollX = rootNode.scrollLeft || docElm.scrollLeft;
					scrollY = rootNode.scrollTop || docElm.scrollTop;
				} else {
					rootRect = rootNode.getBoundingClientRect();
					scrollX = rootNode.scrollLeft - rootRect.left;
					scrollY = rootNode.scrollTop - rootRect.top;
				}
	
				clientRect.left += scrollX;
				clientRect.right += scrollX;
				clientRect.top += scrollY;
				clientRect.bottom += scrollY;
				clientRect.width = 1;
	
				margin = node.offsetWidth - node.clientWidth;
	
				if (margin > 0) {
					if (before) {
						margin *= -1;
					}
	
					clientRect.left += margin;
					clientRect.right += margin;
				}
	
				return clientRect;
			}
	
			function trimInlineCaretContainers() {
				var contentEditableFalseNodes, node, sibling, i, data;
	
				contentEditableFalseNodes = $('*[contentEditable=false]', rootNode);
				for (i = 0; i < contentEditableFalseNodes.length; i++) {
					node = contentEditableFalseNodes[i];
	
					sibling = node.previousSibling;
					if (CaretContainer.endsWithCaretContainer(sibling)) {
						data = sibling.data;
	
						if (data.length == 1) {
							sibling.parentNode.removeChild(sibling);
						} else {
							sibling.deleteData(data.length - 1, 1);
						}
					}
	
					sibling = node.nextSibling;
					if (CaretContainer.startsWithCaretContainer(sibling)) {
						data = sibling.data;
	
						if (data.length == 1) {
							sibling.parentNode.removeChild(sibling);
						} else {
							sibling.deleteData(0, 1);
						}
					}
				}
	
				return null;
			}
	
			function show(before, node) {
				var clientRect, rng, container;
	
				hide();
	
				if (isBlock(node)) {
					caretContainerNode = CaretContainer.insertBlock('p', node, before);
					clientRect = getAbsoluteClientRect(node, before);
					$(caretContainerNode).css('top', clientRect.top);
	
					$lastVisualCaret = $('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(rootNode);
	
					if (before) {
						$lastVisualCaret.addClass('mce-visual-caret-before');
					}
	
					startBlink();
	
					rng = node.ownerDocument.createRange();
					container = caretContainerNode.firstChild;
					rng.setStart(container, 0);
					rng.setEnd(container, 1);
				} else {
					caretContainerNode = CaretContainer.insertInline(node, before);
					rng = node.ownerDocument.createRange();
	
					if (isContentEditableFalse(caretContainerNode.nextSibling)) {
						rng.setStart(caretContainerNode, 0);
						rng.setEnd(caretContainerNode, 0);
					} else {
						rng.setStart(caretContainerNode, 1);
						rng.setEnd(caretContainerNode, 1);
					}
	
					return rng;
				}
	
				return rng;
			}
	
			function hide() {
				trimInlineCaretContainers();
	
				if (caretContainerNode) {
					CaretContainer.remove(caretContainerNode);
					caretContainerNode = null;
				}
	
				if ($lastVisualCaret) {
					$lastVisualCaret.remove();
					$lastVisualCaret = null;
				}
	
				clearInterval(cursorInterval);
			}
	
			function startBlink() {
				cursorInterval = Delay.setInterval(function() {
					$('div.mce-visual-caret', rootNode).toggleClass('mce-visual-caret-hidden');
				}, 500);
			}
	
			function destroy() {
				Delay.clearInterval(cursorInterval);
			}
	
			function getCss() {
				return (
					'.mce-visual-caret {' +
						'position: absolute;' +
						'background-color: black;' +
						'background-color: currentcolor;' +
					'}' +
					'.mce-visual-caret-hidden {' +
						'display: none;' +
					'}' +
					'*[data-mce-caret] {' +
						'position: absolute;' +
						'left: -1000px;' +
						'right: auto;' +
						'top: 0;' +
						'margin: 0;' +
						'padding: 0;' +
					'}'
				);
			}
	
			return {
				show: show,
				hide: hide,
				getCss: getCss,
				destroy: destroy
			};
		};
	});
	
	// Included from: js/tinymce/classes/dom/Dimensions.js
	
	/**
	 * Dimensions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module measures nodes and returns client rects. The client rects has an
	 * extra node property.
	 *
	 * @private
	 * @class tinymce.dom.Dimensions
	 */
	define("tinymce/dom/Dimensions", [
		"tinymce/util/Arr",
		"tinymce/dom/NodeType",
		"tinymce/geom/ClientRect"
	], function(Arr, NodeType, ClientRect) {
	
		function getClientRects(node) {
			function toArrayWithNode(clientRects) {
				return Arr.map(clientRects, function(clientRect) {
					clientRect = ClientRect.clone(clientRect);
					clientRect.node = node;
	
					return clientRect;
				});
			}
	
			if (Arr.isArray(node)) {
				return Arr.reduce(node, function(result, node) {
					return result.concat(getClientRects(node));
				}, []);
			}
	
			if (NodeType.isElement(node)) {
				return toArrayWithNode(node.getClientRects());
			}
	
			if (NodeType.isText(node)) {
				var rng = node.ownerDocument.createRange();
	
				rng.setStart(node, 0);
				rng.setEnd(node, node.data.length);
	
				return toArrayWithNode(rng.getClientRects());
			}
		}
	
		return {
			/**
			 * Returns the client rects for a specific node.
			 *
			 * @method getClientRects
			 * @param {Array/DOMNode} node Node or array of nodes to get client rects on.
			 * @param {Array} Array of client rects with a extra node property.
			 */
			getClientRects: getClientRects
		};
	});
	
	// Included from: js/tinymce/classes/caret/LineWalker.js
	
	/**
	 * LineWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module lets you walk the document line by line
	 * returing nodes and client rects for each line.
	 *
	 * @private
	 * @class tinymce.caret.LineWalker
	 */
	define("tinymce/caret/LineWalker", [
		"tinymce/util/Fun",
		"tinymce/util/Arr",
		"tinymce/dom/Dimensions",
		"tinymce/caret/CaretCandidate",
		"tinymce/caret/CaretUtils",
		"tinymce/caret/CaretWalker",
		"tinymce/caret/CaretPosition",
		"tinymce/geom/ClientRect"
	], function(Fun, Arr, Dimensions, CaretCandidate, CaretUtils, CaretWalker, CaretPosition, ClientRect) {
		var curry = Fun.curry;
	
		function findUntil(direction, rootNode, predicateFn, node) {
			while ((node = CaretUtils.findNode(node, direction, CaretCandidate.isEditableCaretCandidate, rootNode))) {
				if (predicateFn(node)) {
					return;
				}
			}
		}
	
		function walkUntil(direction, isAboveFn, isBeflowFn, rootNode, predicateFn, caretPosition) {
			var line = 0, node, result = [], targetClientRect;
	
			function add(node) {
				var i, clientRect, clientRects;
	
				clientRects = Dimensions.getClientRects(node);
				if (direction == -1) {
					clientRects = clientRects.reverse();
				}
	
				for (i = 0; i < clientRects.length; i++) {
					clientRect = clientRects[i];
					if (isBeflowFn(clientRect, targetClientRect)) {
						continue;
					}
	
					if (result.length > 0 && isAboveFn(clientRect, Arr.last(result))) {
						line++;
					}
	
					clientRect.line = line;
	
					if (predicateFn(clientRect)) {
						return true;
					}
	
					result.push(clientRect);
				}
			}
	
			targetClientRect = Arr.last(caretPosition.getClientRects());
			if (!targetClientRect) {
				return result;
			}
	
			node = caretPosition.getNode();
			add(node);
			findUntil(direction, rootNode, add, node);
	
			return result;
		}
	
		function aboveLineNumber(lineNumber, clientRect) {
			return clientRect.line > lineNumber;
		}
	
		function isLine(lineNumber, clientRect) {
			return clientRect.line === lineNumber;
		}
	
		var upUntil = curry(walkUntil, -1, ClientRect.isAbove, ClientRect.isBelow);
		var downUntil = curry(walkUntil, 1, ClientRect.isBelow, ClientRect.isAbove);
	
		function positionsUntil(direction, rootNode, predicateFn, node) {
			var caretWalker = new CaretWalker(rootNode), walkFn, isBelowFn, isAboveFn,
				caretPosition, result = [], line = 0, clientRect, targetClientRect;
	
			function getClientRect(caretPosition) {
				if (direction == 1) {
					return Arr.last(caretPosition.getClientRects());
				}
	
				return Arr.last(caretPosition.getClientRects());
			}
	
			if (direction == 1) {
				walkFn = caretWalker.next;
				isBelowFn = ClientRect.isBelow;
				isAboveFn = ClientRect.isAbove;
				caretPosition = CaretPosition.after(node);
			} else {
				walkFn = caretWalker.prev;
				isBelowFn = ClientRect.isAbove;
				isAboveFn = ClientRect.isBelow;
				caretPosition = CaretPosition.before(node);
			}
	
			targetClientRect = getClientRect(caretPosition);
	
			do {
				if (!caretPosition.isVisible()) {
					continue;
				}
	
				clientRect = getClientRect(caretPosition);
	
				if (isAboveFn(clientRect, targetClientRect)) {
					continue;
				}
	
				if (result.length > 0 && isBelowFn(clientRect, Arr.last(result))) {
					line++;
				}
	
				clientRect = ClientRect.clone(clientRect);
				clientRect.position = caretPosition;
				clientRect.line = line;
	
				if (predicateFn(clientRect)) {
					return result;
				}
	
				result.push(clientRect);
			} while ((caretPosition = walkFn(caretPosition)));
	
			return result;
		}
	
		return {
			upUntil: upUntil,
			downUntil: downUntil,
	
			/**
			 * Find client rects with line and caret position until the predicate returns true.
			 *
			 * @method positionsUntil
			 * @param {Number} direction Direction forward/backward 1/-1.
			 * @param {DOMNode} rootNode Root node to walk within.
			 * @param {function} predicateFn Gets the client rect as it's input.
			 * @param {DOMNode} node Node to start walking from.
			 * @return {Array} Array of client rects with line and position properties.
			 */
			positionsUntil: positionsUntil,
	
			isAboveLine: curry(aboveLineNumber),
			isLine: curry(isLine)
		};
	});
	
	// Included from: js/tinymce/classes/caret/LineUtils.js
	
	/**
	 * LineUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with lines.
	 *
	 * @private
	 * @class tinymce.caret.LineUtils
	 */
	define("tinymce/caret/LineUtils", [
		"tinymce/util/Fun",
		"tinymce/util/Arr",
		"tinymce/dom/NodeType",
		"tinymce/dom/Dimensions",
		"tinymce/geom/ClientRect",
		"tinymce/caret/CaretUtils",
		"tinymce/caret/CaretCandidate"
	], function(Fun, Arr, NodeType, Dimensions, ClientRect, CaretUtils, CaretCandidate) {
		var isContentEditableFalse = NodeType.isContentEditableFalse,
			findNode = CaretUtils.findNode,
			curry = Fun.curry;
	
		function distanceToRectLeft(clientRect, clientX) {
			return Math.abs(clientRect.left - clientX);
		}
	
		function distanceToRectRight(clientRect, clientX) {
			return Math.abs(clientRect.right - clientX);
		}
	
		function findClosestClientRect(clientRects, clientX) {
			function isInside(clientX, clientRect) {
				return clientX >= clientRect.left && clientX <= clientRect.right;
			}
	
			return Arr.reduce(clientRects, function(oldClientRect, clientRect) {
				var oldDistance, newDistance;
	
				oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
				newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	
				if (isInside(clientX, clientRect)) {
					return clientRect;
				}
	
				if (isInside(clientX, oldClientRect)) {
					return oldClientRect;
				}
	
				// cE=false has higher priority
				if (newDistance == oldDistance && isContentEditableFalse(clientRect.node)) {
					return clientRect;
				}
	
				if (newDistance < oldDistance) {
					return clientRect;
				}
	
				return oldClientRect;
			});
		}
	
		function walkUntil(direction, rootNode, predicateFn, node) {
			while ((node = findNode(node, direction, CaretCandidate.isEditableCaretCandidate, rootNode))) {
				if (predicateFn(node)) {
					return;
				}
			}
		}
	
		function findLineNodeRects(rootNode, targetNodeRect) {
			var clientRects = [];
	
			function collect(checkPosFn, node) {
				var lineRects;
	
				lineRects = Arr.filter(Dimensions.getClientRects(node), function(clientRect) {
					return !checkPosFn(clientRect, targetNodeRect);
				});
	
				clientRects = clientRects.concat(lineRects);
	
				return lineRects.length === 0;
			}
	
			clientRects.push(targetNodeRect);
			walkUntil(-1, rootNode, curry(collect, ClientRect.isAbove), targetNodeRect.node);
			walkUntil(1, rootNode, curry(collect, ClientRect.isBelow), targetNodeRect.node);
	
			return clientRects;
		}
	
		function getContentEditableFalseChildren(rootNode) {
			return Arr.filter(Arr.toArray(rootNode.getElementsByTagName('*')), isContentEditableFalse);
		}
	
		function caretInfo(clientRect, clientX) {
			return {
				node: clientRect.node,
				before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
			};
		}
	
		function closestCaret(rootNode, clientX, clientY) {
			var contentEditableFalseNodeRects, closestNodeRect;
	
			contentEditableFalseNodeRects = Dimensions.getClientRects(getContentEditableFalseChildren(rootNode));
			contentEditableFalseNodeRects = Arr.filter(contentEditableFalseNodeRects, function(clientRect) {
				return clientY >= clientRect.top && clientY <= clientRect.bottom;
			});
	
			closestNodeRect = findClosestClientRect(contentEditableFalseNodeRects, clientX);
			if (closestNodeRect) {
				closestNodeRect = findClosestClientRect(findLineNodeRects(rootNode, closestNodeRect), clientX);
				if (closestNodeRect && isContentEditableFalse(closestNodeRect.node)) {
					return caretInfo(closestNodeRect, clientX);
				}
			}
	
			return null;
		}
	
		return {
			findClosestClientRect: findClosestClientRect,
			findLineNodeRects: findLineNodeRects,
			closestCaret: closestCaret
		};
	});
	
	// Included from: js/tinymce/classes/dom/MousePosition.js
	
	/**
	 * MousePosition.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module calculates an absolute coordinate inside the editor body for both local and global mouse events.
	 *
	 * @private
	 * @class tinymce.dom.MousePosition
	 */
	define("tinymce/dom/MousePosition", [
	], function() {
		var getAbsolutePosition = function (elm) {
			var doc, docElem, win, clientRect;
	
			clientRect = elm.getBoundingClientRect();
			doc = elm.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: clientRect.top + win.pageYOffset - docElem.clientTop,
				left: clientRect.left + win.pageXOffset - docElem.clientLeft
			};
		};
	
		var getBodyPosition = function (editor) {
			return editor.inline ? getAbsolutePosition(editor.getBody()) : {left: 0, top: 0};
		};
	
		var getScrollPosition = function (editor) {
			var body = editor.getBody();
			return editor.inline ? {left: body.scrollLeft, top: body.scrollTop} : {left: 0, top: 0};
		};
	
		var getBodyScroll = function (editor) {
			var body = editor.getBody(), docElm = editor.getDoc().documentElement;
			var inlineScroll = {left: body.scrollLeft, top: body.scrollTop};
			var iframeScroll = {left: body.scrollLeft || docElm.scrollLeft, top: body.scrollTop || docElm.scrollTop};
	
			return editor.inline ? inlineScroll : iframeScroll;
		};
	
		var getMousePosition = function (editor, event) {
			if (event.target.ownerDocument !== editor.getDoc()) {
				var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
				var scrollPosition = getBodyScroll(editor);
	
				return {
					left: event.pageX - iframePosition.left + scrollPosition.left,
					top: event.pageY - iframePosition.top + scrollPosition.top
				};
			}
	
			return {
				left: event.pageX,
				top: event.pageY
			};
		};
	
		var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
			return {
				pageX: (mousePosition.left - bodyPosition.left) + scrollPosition.left,
				pageY: (mousePosition.top - bodyPosition.top) + scrollPosition.top
			};
		};
	
		var calc = function (editor, event) {
			return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
		};
	
		return {
			calc: calc
		};
	});
	
	// Included from: js/tinymce/classes/DragDropOverrides.js
	
	/**
	 * DragDropOverrides.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic overriding the drag/drop logic of the editor.
	 *
	 * @private
	 * @class tinymce.DragDropOverrides
	 */
	define("tinymce/DragDropOverrides", [
		"tinymce/dom/NodeType",
		"tinymce/util/Arr",
		"tinymce/util/Fun",
		"tinymce/util/Delay",
		"tinymce/dom/DOMUtils",
		"tinymce/dom/MousePosition"
	], function(
		NodeType, Arr, Fun, Delay, DOMUtils, MousePosition
	) {
		var isContentEditableFalse = NodeType.isContentEditableFalse,
			isContentEditableTrue = NodeType.isContentEditableTrue;
	
		var isDraggable = function (elm) {
			return isContentEditableFalse(elm);
		};
	
		var isValidDropTarget = function (editor, targetElement, dragElement) {
			if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
				return false;
			}
	
			if (isContentEditableFalse(targetElement)) {
				return false;
			}
	
			return true;
		};
	
		var cloneElement = function (elm) {
			var cloneElm = elm.cloneNode(true);
			cloneElm.removeAttribute('data-mce-selected');
			return cloneElm;
		};
	
		var createGhost = function (editor, elm, width, height) {
			var clonedElm = elm.cloneNode(true);
	
			editor.dom.setStyles(clonedElm, {width: width, height: height});
			editor.dom.setAttrib(clonedElm, 'data-mce-selected', null);
	
			var ghostElm = editor.dom.create('div', {
				'class': 'mce-drag-container',
				'data-mce-bogus': 'all',
				unselectable: 'on',
				contenteditable: 'false'
			});
	
			editor.dom.setStyles(ghostElm, {
				position: 'absolute',
				opacity: 0.5,
				overflow: 'hidden',
				border: 0,
				padding: 0,
				margin: 0,
				width: width,
				height: height
			});
	
			editor.dom.setStyles(clonedElm, {
				margin: 0,
				boxSizing: 'border-box'
			});
	
			ghostElm.appendChild(clonedElm);
	
			return ghostElm;
		};
	
		var appendGhostToBody = function (ghostElm, bodyElm) {
			if (ghostElm.parentNode !== bodyElm) {
				bodyElm.appendChild(ghostElm);
			}
		};
	
		var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
			var overflowX = 0, overflowY = 0;
	
			ghostElm.style.left = position.pageX + 'px';
			ghostElm.style.top = position.pageY + 'px';
	
			if (position.pageX + width > maxX) {
				overflowX = (position.pageX + width) - maxX;
			}
	
			if (position.pageY + height > maxY) {
				overflowY = (position.pageY + height) - maxY;
			}
	
			ghostElm.style.width = (width - overflowX) + 'px';
			ghostElm.style.height = (height - overflowY) + 'px';
		};
	
		var removeElement = function (elm) {
			if (elm && elm.parentNode) {
				elm.parentNode.removeChild(elm);
			}
		};
	
		var isLeftMouseButtonPressed = function (e) {
			return e.button === 0;
		};
	
		var hasDraggableElement = function (state) {
			return state.element;
		};
	
		var applyRelPos = function (state, position) {
			return {
				pageX: position.pageX - state.relX,
				pageY: position.pageY + 5
			};
		};
	
		var start = function (state, editor) {
			return function (e) {
				if (isLeftMouseButtonPressed(e)) {
					var ceElm = Arr.find(editor.dom.getParents(e.target), Fun.or(isContentEditableFalse, isContentEditableTrue));
	
					if (isDraggable(ceElm)) {
						var elmPos = editor.dom.getPos(ceElm);
						var bodyElm = editor.getBody();
						var docElm = editor.getDoc().documentElement;
	
						state.element = ceElm;
						state.screenX = e.screenX;
						state.screenY = e.screenY;
						state.maxX = (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2;
						state.maxY = (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2;
						state.relX = e.pageX - elmPos.x;
						state.relY = e.pageY - elmPos.y;
						state.width = ceElm.offsetWidth;
						state.height = ceElm.offsetHeight;
						state.ghost = createGhost(editor, ceElm, state.width, state.height);
					}
				}
			};
		};
	
		var move = function (state, editor) {
			// Reduces laggy drag behavior on Gecko
			var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
				editor._selectionOverrides.hideFakeCaret();
				editor.selection.placeCaretAt(clientX, clientY);
			}, 0);
	
			return function (e) {
				var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	
				if (hasDraggableElement(state) && !state.dragging && movement > 10) {
					var args = editor.fire('dragstart', {target: state.element});
					if (args.isDefaultPrevented()) {
						return;
					}
	
					state.dragging = true;
					editor.focus();
				}
	
				if (state.dragging) {
					var targetPos = applyRelPos(state, MousePosition.calc(editor, e));
	
					appendGhostToBody(state.ghost, editor.getBody());
					moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	
					throttledPlaceCaretAt(e.clientX, e.clientY);
				}
			};
		};
	
		var drop = function (state, editor) {
			return function (e) {
				if (state.dragging) {
					if (isValidDropTarget(editor, editor.selection.getNode(), state.element)) {
						var targetClone = cloneElement(state.element);
	
						var args = editor.fire('drop', {
							targetClone: targetClone,
							clientX: e.clientX,
							clientY: e.clientY
						});
	
						if (!args.isDefaultPrevented()) {
							targetClone = args.targetClone;
	
							editor.undoManager.transact(function() {
								removeElement(state.element);
								editor.insertContent(editor.dom.getOuterHTML(targetClone));
								editor._selectionOverrides.hideFakeCaret();
							});
						}
					}
				}
	
				removeDragState(state);
			};
		};
	
		var stop = function (state, editor) {
			return function () {
				removeDragState(state);
				if (state.dragging) {
					editor.fire('dragend');
				}
			};
		};
	
		var removeDragState = function (state) {
			state.dragging = false;
			state.element = null;
			removeElement(state.ghost);
		};
	
		var bindFakeDragEvents = function (editor) {
			var state = {}, pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
	
			pageDom = DOMUtils.DOM;
			rootDocument = document;
			dragStartHandler = start(state, editor);
			dragHandler = move(state, editor);
			dropHandler = drop(state, editor);
			dragEndHandler = stop(state, editor);
	
			editor.on('mousedown', dragStartHandler);
			editor.on('mousemove', dragHandler);
			editor.on('mouseup', dropHandler);
	
			pageDom.bind(rootDocument, 'mousemove', dragHandler);
			pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	
			editor.on('remove', function () {
				pageDom.unbind(rootDocument, 'mousemove', dragHandler);
				pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
			});
		};
	
		var blockIeDrop = function (editor) {
			editor.on('drop', function(e) {
				// FF doesn't pass out clientX/clientY for drop since this is for IE we just use null instead
				var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	
				if (isContentEditableFalse(realTarget) || isContentEditableFalse(editor.dom.getContentEditableParent(realTarget))) {
					e.preventDefault();
				}
			});
		};
	
		var init = function (editor) {
			bindFakeDragEvents(editor);
			blockIeDrop(editor);
		};
	
		return {
			init: init
		};
	});
	
	// Included from: js/tinymce/classes/SelectionOverrides.js
	
	/**
	 * SelectionOverrides.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic overriding the selection with keyboard/mouse
	 * around contentEditable=false regions.
	 *
	 * @example
	 * // Disable the default cE=false selection
	 * tinymce.activeEditor.on('ShowCaret BeforeObjectSelected', function(e) {
	 *     e.preventDefault();
	 * });
	 *
	 * @private
	 * @class tinymce.SelectionOverrides
	 */
	define("tinymce/SelectionOverrides", [
		"tinymce/Env",
		"tinymce/caret/CaretWalker",
		"tinymce/caret/CaretPosition",
		"tinymce/caret/CaretContainer",
		"tinymce/caret/CaretUtils",
		"tinymce/caret/FakeCaret",
		"tinymce/caret/LineWalker",
		"tinymce/caret/LineUtils",
		"tinymce/dom/NodeType",
		"tinymce/dom/RangeUtils",
		"tinymce/geom/ClientRect",
		"tinymce/util/VK",
		"tinymce/util/Fun",
		"tinymce/util/Arr",
		"tinymce/util/Delay",
		"tinymce/DragDropOverrides",
		"tinymce/text/Zwsp"
	], function(
		Env, CaretWalker, CaretPosition, CaretContainer, CaretUtils, FakeCaret, LineWalker,
		LineUtils, NodeType, RangeUtils, ClientRect, VK, Fun, Arr, Delay, DragDropOverrides, Zwsp
	) {
		var curry = Fun.curry,
			isContentEditableTrue = NodeType.isContentEditableTrue,
			isContentEditableFalse = NodeType.isContentEditableFalse,
			isElement = NodeType.isElement,
			isAfterContentEditableFalse = CaretUtils.isAfterContentEditableFalse,
			isBeforeContentEditableFalse = CaretUtils.isBeforeContentEditableFalse,
			getSelectedNode = RangeUtils.getSelectedNode;
	
		function getVisualCaretPosition(walkFn, caretPosition) {
			while ((caretPosition = walkFn(caretPosition))) {
				if (caretPosition.isVisible()) {
					return caretPosition;
				}
			}
	
			return caretPosition;
		}
	
		function SelectionOverrides(editor) {
			var rootNode = editor.getBody(), caretWalker = new CaretWalker(rootNode);
			var getNextVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.next);
			var getPrevVisualCaretPosition = curry(getVisualCaretPosition, caretWalker.prev),
				fakeCaret = new FakeCaret(editor.getBody(), isBlock),
				realSelectionId = 'sel-' + editor.dom.uniqueId(),
				selectedContentEditableNode, $ = editor.$;
	
			function getRealSelectionElement() {
				var container = editor.dom.get(realSelectionId);
				return container ? container.getElementsByTagName('*')[0] : container;
			}
	
			function isBlock(node) {
				return editor.dom.isBlock(node);
			}
	
			function setRange(range) {
				//console.log('setRange', range);
				if (range) {
					editor.selection.setRng(range);
				}
			}
	
			function getRange() {
				return editor.selection.getRng();
			}
	
			function scrollIntoView(node, alignToTop) {
				editor.selection.scrollIntoView(node, alignToTop);
			}
	
			function showCaret(direction, node, before) {
				var e;
	
				e = editor.fire('ShowCaret', {
					target: node,
					direction: direction,
					before: before
				});
	
				if (e.isDefaultPrevented()) {
					return null;
				}
	
				scrollIntoView(node, direction === -1);
	
				return fakeCaret.show(before, node);
			}
	
			function selectNode(node) {
				var e;
	
				fakeCaret.hide();
	
				e = editor.fire('BeforeObjectSelected', {target: node});
				if (e.isDefaultPrevented()) {
					return null;
				}
	
				return getNodeRange(node);
			}
	
			function getNodeRange(node) {
				var rng = node.ownerDocument.createRange();
	
				rng.selectNode(node);
	
				return rng;
			}
	
			function isMoveInsideSameBlock(fromCaretPosition, toCaretPosition) {
				var inSameBlock = CaretUtils.isInSameBlock(fromCaretPosition, toCaretPosition);
	
				// Handle bogus BR <p>abc|<br></p>
				if (!inSameBlock && NodeType.isBr(fromCaretPosition.getNode())) {
					return true;
				}
	
				return inSameBlock;
			}
	
			function getNormalizedRangeEndPoint(direction, range) {
				range = CaretUtils.normalizeRange(direction, rootNode, range);
	
				if (direction == -1) {
					return CaretPosition.fromRangeStart(range);
				}
	
				return CaretPosition.fromRangeEnd(range);
			}
	
			function isRangeInCaretContainerBlock(range) {
				return CaretContainer.isCaretContainerBlock(range.startContainer);
			}
	
			function moveToCeFalseHorizontally(direction, getNextPosFn, isBeforeContentEditableFalseFn, range) {
				var node, caretPosition, peekCaretPosition, rangeIsInContainerBlock;
	
				if (!range.collapsed) {
					node = getSelectedNode(range);
					if (isContentEditableFalse(node)) {
						return showCaret(direction, node, direction == -1);
					}
				}
	
				rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
				caretPosition = getNormalizedRangeEndPoint(direction, range);
	
				if (isBeforeContentEditableFalseFn(caretPosition)) {
					return selectNode(caretPosition.getNode(direction == -1));
				}
	
				caretPosition = getNextPosFn(caretPosition);
				if (!caretPosition) {
					if (rangeIsInContainerBlock) {
						return range;
					}
	
					return null;
				}
	
				if (isBeforeContentEditableFalseFn(caretPosition)) {
					return showCaret(direction, caretPosition.getNode(direction == -1), direction == 1);
				}
	
				// Peek ahead for handling of ab|c<span cE=false> -> abc|<span cE=false>
				peekCaretPosition = getNextPosFn(caretPosition);
				if (isBeforeContentEditableFalseFn(peekCaretPosition)) {
					if (isMoveInsideSameBlock(caretPosition, peekCaretPosition)) {
						return showCaret(direction, peekCaretPosition.getNode(direction == -1), direction == 1);
					}
				}
	
				if (rangeIsInContainerBlock) {
					return renderRangeCaret(caretPosition.toRange());
				}
	
				return null;
			}
	
			function moveToCeFalseVertically(direction, walkerFn, range) {
				var caretPosition, linePositions, nextLinePositions,
					closestNextLineRect, caretClientRect, clientX,
					dist1, dist2, contentEditableFalseNode;
	
				contentEditableFalseNode = getSelectedNode(range);
				caretPosition = getNormalizedRangeEndPoint(direction, range);
				linePositions = walkerFn(rootNode, LineWalker.isAboveLine(1), caretPosition);
				nextLinePositions = Arr.filter(linePositions, LineWalker.isLine(1));
				caretClientRect = Arr.last(caretPosition.getClientRects());
	
				if (isBeforeContentEditableFalse(caretPosition)) {
					contentEditableFalseNode = caretPosition.getNode();
				}
	
				if (isAfterContentEditableFalse(caretPosition)) {
					contentEditableFalseNode = caretPosition.getNode(true);
				}
	
				if (!caretClientRect) {
					return null;
				}
	
				clientX = caretClientRect.left;
	
				closestNextLineRect = LineUtils.findClosestClientRect(nextLinePositions, clientX);
				if (closestNextLineRect) {
					if (isContentEditableFalse(closestNextLineRect.node)) {
						dist1 = Math.abs(clientX - closestNextLineRect.left);
						dist2 = Math.abs(clientX - closestNextLineRect.right);
	
						return showCaret(direction, closestNextLineRect.node, dist1 < dist2);
					}
				}
	
				if (contentEditableFalseNode) {
					var caretPositions = LineWalker.positionsUntil(direction, rootNode, LineWalker.isAboveLine(1), contentEditableFalseNode);
	
					closestNextLineRect = LineUtils.findClosestClientRect(Arr.filter(caretPositions, LineWalker.isLine(1)), clientX);
					if (closestNextLineRect) {
						return renderRangeCaret(closestNextLineRect.position.toRange());
					}
	
					closestNextLineRect = Arr.last(Arr.filter(caretPositions, LineWalker.isLine(0)));
					if (closestNextLineRect) {
						return renderRangeCaret(closestNextLineRect.position.toRange());
					}
				}
			}
	
			function exitPreBlock(direction, range) {
				var pre, caretPos, newBlock;
	
				function createTextBlock() {
					var textBlock = editor.dom.create(editor.settings.forced_root_block);
	
					if (!Env.ie || Env.ie >= 11) {
						textBlock.innerHTML = '<br data-mce-bogus="1">';
					}
	
					return textBlock;
				}
	
				if (range.collapsed && editor.settings.forced_root_block) {
					pre = editor.dom.getParent(range.startContainer, 'PRE');
					if (!pre) {
						return;
					}
	
					if (direction == 1) {
						caretPos = getNextVisualCaretPosition(CaretPosition.fromRangeStart(range));
					} else {
						caretPos = getPrevVisualCaretPosition(CaretPosition.fromRangeStart(range));
					}
	
					if (!caretPos) {
						newBlock = createTextBlock();
	
						if (direction == 1) {
							editor.$(pre).after(newBlock);
						} else {
							editor.$(pre).before(newBlock);
						}
	
						editor.selection.select(newBlock, true);
						editor.selection.collapse();
					}
				}
			}
	
			function moveH(direction, getNextPosFn, isBeforeContentEditableFalseFn, range) {
				var newRange;
	
				newRange = moveToCeFalseHorizontally(direction, getNextPosFn, isBeforeContentEditableFalseFn, range);
				if (newRange) {
					return newRange;
				}
	
				newRange = exitPreBlock(direction, range);
				if (newRange) {
					return newRange;
				}
	
				return null;
			}
	
			function moveV(direction, walkerFn, range) {
				var newRange;
	
				newRange = moveToCeFalseVertically(direction, walkerFn, range);
				if (newRange) {
					return newRange;
				}
	
				newRange = exitPreBlock(direction, range);
				if (newRange) {
					return newRange;
				}
	
				return null;
			}
	
			function getBlockCaretContainer() {
				return $('*[data-mce-caret]')[0];
			}
	
			function showBlockCaretContainer(blockCaretContainer) {
				blockCaretContainer = $(blockCaretContainer);
	
				if (blockCaretContainer.attr('data-mce-caret')) {
					fakeCaret.hide();
					blockCaretContainer.removeAttr('data-mce-caret');
					blockCaretContainer.removeAttr('data-mce-bogus');
					blockCaretContainer.removeAttr('style');
	
					// Removes control rect on IE
					setRange(getRange());
					scrollIntoView(blockCaretContainer[0]);
				}
			}
	
			function renderCaretAtRange(range) {
				var caretPosition, ceRoot;
	
				range = CaretUtils.normalizeRange(1, rootNode, range);
				caretPosition = CaretPosition.fromRangeStart(range);
	
				if (isContentEditableFalse(caretPosition.getNode())) {
					return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd());
				}
	
				if (isContentEditableFalse(caretPosition.getNode(true))) {
					return showCaret(1, caretPosition.getNode(true), false);
				}
	
				// TODO: Should render caret before/after depending on where you click on the page forces after now
				ceRoot = editor.dom.getParent(caretPosition.getNode(), Fun.or(isContentEditableFalse, isContentEditableTrue));
				if (isContentEditableFalse(ceRoot)) {
					return showCaret(1, ceRoot, false);
				}
	
				fakeCaret.hide();
	
				return null;
			}
	
			function renderRangeCaret(range) {
				var caretRange;
	
				if (!range || !range.collapsed) {
					return range;
				}
	
				caretRange = renderCaretAtRange(range);
				if (caretRange) {
					return caretRange;
				}
	
				return range;
			}
	
			function deleteContentEditableNode(node) {
				var nextCaretPosition, prevCaretPosition, prevCeFalseElm, nextElement;
	
				if (!isContentEditableFalse(node)) {
					return null;
				}
	
				if (isContentEditableFalse(node.previousSibling)) {
					prevCeFalseElm = node.previousSibling;
				}
	
				prevCaretPosition = getPrevVisualCaretPosition(CaretPosition.before(node));
				if (!prevCaretPosition) {
					nextCaretPosition = getNextVisualCaretPosition(CaretPosition.after(node));
				}
	
				if (nextCaretPosition && isElement(nextCaretPosition.getNode())) {
					nextElement = nextCaretPosition.getNode();
				}
	
				CaretContainer.remove(node.previousSibling);
				CaretContainer.remove(node.nextSibling);
				editor.dom.remove(node);
				clearContentEditableSelection();
	
				if (editor.dom.isEmpty(editor.getBody())) {
					editor.setContent('');
					editor.focus();
					return;
				}
	
				if (prevCeFalseElm) {
					return CaretPosition.after(prevCeFalseElm).toRange();
				}
	
				if (nextElement) {
					return CaretPosition.before(nextElement).toRange();
				}
	
				if (prevCaretPosition) {
					return prevCaretPosition.toRange();
				}
	
				if (nextCaretPosition) {
					return nextCaretPosition.toRange();
				}
	
				return null;
			}
	
			function isTextBlock(node) {
				var textBlocks = editor.schema.getTextBlockElements();
				return node.nodeName in textBlocks;
			}
	
			function isEmpty(elm) {
				return editor.dom.isEmpty(elm);
			}
	
			function mergeTextBlocks(direction, fromCaretPosition, toCaretPosition) {
				var dom = editor.dom, fromBlock, toBlock, node, ceTarget;
	
				fromBlock = dom.getParent(fromCaretPosition.getNode(), dom.isBlock);
				toBlock = dom.getParent(toCaretPosition.getNode(), dom.isBlock);
	
				if (direction === -1) {
					ceTarget = toCaretPosition.getNode(true);
					if (isAfterContentEditableFalse(toCaretPosition) && isBlock(ceTarget)) {
						if (isTextBlock(fromBlock)) {
							if (isEmpty(fromBlock)) {
								dom.remove(fromBlock);
							}
	
							return CaretPosition.after(ceTarget).toRange();
						}
	
						return deleteContentEditableNode(toCaretPosition.getNode(true));
					}
				} else {
					ceTarget = fromCaretPosition.getNode();
					if (isBeforeContentEditableFalse(fromCaretPosition) && isBlock(ceTarget)) {
						if (isTextBlock(toBlock)) {
							if (isEmpty(toBlock)) {
								dom.remove(toBlock);
							}
	
							return CaretPosition.before(ceTarget).toRange();
						}
	
						return deleteContentEditableNode(fromCaretPosition.getNode());
					}
				}
	
				// Verify that both blocks are text blocks
				if (fromBlock === toBlock || !isTextBlock(fromBlock) || !isTextBlock(toBlock)) {
					return null;
				}
	
				while ((node = fromBlock.firstChild)) {
					toBlock.appendChild(node);
				}
	
				editor.dom.remove(fromBlock);
	
				return toCaretPosition.toRange();
			}
	
			function backspaceDelete(direction, beforeFn, afterFn, range) {
				var node, caretPosition, peekCaretPosition, newCaretPosition;
	
				if (!range.collapsed) {
					node = getSelectedNode(range);
					if (isContentEditableFalse(node)) {
						return renderRangeCaret(deleteContentEditableNode(node));
					}
				}
	
				caretPosition = getNormalizedRangeEndPoint(direction, range);
	
				if (afterFn(caretPosition) && CaretContainer.isCaretContainerBlock(range.startContainer)) {
					newCaretPosition = direction == -1 ? caretWalker.prev(caretPosition) : caretWalker.next(caretPosition);
					return newCaretPosition ? renderRangeCaret(newCaretPosition.toRange()) : range;
				}
	
				if (beforeFn(caretPosition)) {
					return renderRangeCaret(deleteContentEditableNode(caretPosition.getNode(direction == -1)));
				}
	
				peekCaretPosition = direction == -1 ? caretWalker.prev(caretPosition) : caretWalker.next(caretPosition);
				if (beforeFn(peekCaretPosition)) {
					if (direction === -1) {
						return mergeTextBlocks(direction, caretPosition, peekCaretPosition);
					}
	
					return mergeTextBlocks(direction, peekCaretPosition, caretPosition);
				}
			}
	
			function registerEvents() {
				var right = curry(moveH, 1, getNextVisualCaretPosition, isBeforeContentEditableFalse);
				var left = curry(moveH, -1, getPrevVisualCaretPosition, isAfterContentEditableFalse);
				var deleteForward = curry(backspaceDelete, 1, isBeforeContentEditableFalse, isAfterContentEditableFalse);
				var backspace = curry(backspaceDelete, -1, isAfterContentEditableFalse, isBeforeContentEditableFalse);
				var up = curry(moveV, -1, LineWalker.upUntil);
				var down = curry(moveV, 1, LineWalker.downUntil);
	
				function override(evt, moveFn) {
					var range = moveFn(getRange());
	
					if (range && !evt.isDefaultPrevented()) {
						evt.preventDefault();
						setRange(range);
					}
				}
	
				function getContentEditableRoot(node) {
					var root = editor.getBody();
	
					while (node && node != root) {
						if (isContentEditableTrue(node) || isContentEditableFalse(node)) {
							return node;
						}
	
						node = node.parentNode;
					}
	
					return null;
				}
	
				function isXYWithinRange(clientX, clientY, range) {
					if (range.collapsed) {
						return false;
					}
	
					return Arr.reduce(range.getClientRects(), function(state, rect) {
						return state || ClientRect.containsXY(rect, clientX, clientY);
					}, false);
				}
	
				// Some browsers (Chrome) lets you place the caret after a cE=false
				// Make sure we render the caret container in this case
				editor.on('mouseup', function() {
					var range = getRange();
	
					if (range.collapsed) {
						setRange(renderCaretAtRange(range));
					}
				});
	
				editor.on('click', function(e) {
					var contentEditableRoot;
	
					// Prevent clicks on links in a cE=false element
					contentEditableRoot	= getContentEditableRoot(e.target);
					if (contentEditableRoot) {
						if (isContentEditableFalse(contentEditableRoot)) {
							e.preventDefault();
							editor.focus();
						}
					}
				});
	
				function handleTouchSelect(editor) {
					var moved = false;
	
					editor.on('touchstart', function () {
						moved = false;
					});
	
					editor.on('touchmove', function () {
						moved = true;
					});
	
					editor.on('touchend', function (e) {
						var contentEditableRoot	= getContentEditableRoot(e.target);
	
						if (isContentEditableFalse(contentEditableRoot)) {
							if (!moved) {
								e.preventDefault();
								setContentEditableSelection(selectNode(contentEditableRoot));
							}
						} else {
							clearContentEditableSelection();
						}
					});
				}
	
				var hasNormalCaretPosition = function (elm) {
					var caretWalker = new CaretWalker(elm);
	
					if (!elm.firstChild) {
						return false;
					}
	
					var startPos = CaretPosition.before(elm.firstChild);
					var newPos = caretWalker.next(startPos);
	
					return newPos && !isBeforeContentEditableFalse(newPos) && !isAfterContentEditableFalse(newPos);
				};
	
				var isInSameBlock = function (node1, node2) {
					var block1 = editor.dom.getParent(node1, editor.dom.isBlock);
					var block2 = editor.dom.getParent(node2, editor.dom.isBlock);
					return block1 === block2;
				};
	
				// Checks if the target node is in a block and if that block has a caret position better than the
				// suggested caretNode this is to prevent the caret from being sucked in towards a cE=false block if
				// they are adjacent on the vertical axis
				var hasBetterMouseTarget = function (targetNode, caretNode) {
					var targetBlock = editor.dom.getParent(targetNode, editor.dom.isBlock);
					var caretBlock = editor.dom.getParent(caretNode, editor.dom.isBlock);
	
					return targetBlock && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
				};
	
				handleTouchSelect(editor);
	
				editor.on('mousedown', function(e) {
					var contentEditableRoot;
	
					contentEditableRoot	= getContentEditableRoot(e.target);
					if (contentEditableRoot) {
						if (isContentEditableFalse(contentEditableRoot)) {
							e.preventDefault();
							setContentEditableSelection(selectNode(contentEditableRoot));
						} else {
							clearContentEditableSelection();
	
							if (!isXYWithinRange(e.clientX, e.clientY, editor.selection.getRng())) {
								editor.selection.placeCaretAt(e.clientX, e.clientY);
							}
						}
					} else {
						clearContentEditableSelection();
						fakeCaret.hide();
	
						var caretInfo = LineUtils.closestCaret(rootNode, e.clientX, e.clientY);
						if (caretInfo) {
							if (!hasBetterMouseTarget(e.target, caretInfo.node)) {
								e.preventDefault();
								editor.getBody().focus();
								setRange(showCaret(1, caretInfo.node, caretInfo.before));
							}
						}
					}
				});
	
				editor.on('keydown', function(e) {
					if (VK.modifierPressed(e)) {
						return;
					}
	
					switch (e.keyCode) {
						case VK.RIGHT:
							override(e, right);
							break;
	
						case VK.DOWN:
							override(e, down);
							break;
	
						case VK.LEFT:
							override(e, left);
							break;
	
						case VK.UP:
							override(e, up);
							break;
	
						case VK.DELETE:
							override(e, deleteForward);
							break;
	
						case VK.BACKSPACE:
							override(e, backspace);
							break;
	
						default:
							if (isContentEditableFalse(editor.selection.getNode())) {
								e.preventDefault();
							}
							break;
					}
				});
	
				function paddEmptyContentEditableArea() {
					var br, ceRoot = getContentEditableRoot(editor.selection.getNode());
	
					if (isContentEditableTrue(ceRoot) && isBlock(ceRoot) && editor.dom.isEmpty(ceRoot)) {
						br = editor.dom.create('br', {"data-mce-bogus": "1"});
						editor.$(ceRoot).empty().append(br);
						editor.selection.setRng(CaretPosition.before(br).toRange());
					}
				}
	
				function handleBlockContainer(e) {
					var blockCaretContainer = getBlockCaretContainer();
	
					if (!blockCaretContainer) {
						return;
					}
	
					if (e.type == 'compositionstart') {
						e.preventDefault();
						e.stopPropagation();
						showBlockCaretContainer(blockCaretContainer);
						return;
					}
	
					if (blockCaretContainer.innerHTML != '&nbsp;') {
						showBlockCaretContainer(blockCaretContainer);
					}
				}
	
				function handleEmptyBackspaceDelete(e) {
					var prevent;
	
					switch (e.keyCode) {
						case VK.DELETE:
							prevent = paddEmptyContentEditableArea();
							break;
	
						case VK.BACKSPACE:
							prevent = paddEmptyContentEditableArea();
							break;
					}
	
					if (prevent) {
						e.preventDefault();
					}
				}
	
				// Must be added to "top" since undoManager needs to be executed after
				editor.on('keyup compositionstart', function(e) {
					handleBlockContainer(e);
					handleEmptyBackspaceDelete(e);
				}, true);
	
				editor.on('cut', function() {
					var node = editor.selection.getNode();
	
					if (isContentEditableFalse(node)) {
						Delay.setEditorTimeout(editor, function() {
							setRange(renderRangeCaret(deleteContentEditableNode(node)));
						});
					}
				});
	
				editor.on('getSelectionRange', function(e) {
					var rng = e.range;
	
					if (selectedContentEditableNode) {
						if (!selectedContentEditableNode.parentNode) {
							selectedContentEditableNode = null;
							return;
						}
	
						rng = rng.cloneRange();
						rng.selectNode(selectedContentEditableNode);
						e.range = rng;
					}
				});
	
				editor.on('setSelectionRange', function(e) {
					var rng;
	
					rng = setContentEditableSelection(e.range);
					if (rng) {
						e.range = rng;
					}
				});
	
				editor.on('focus', function() {
					// Make sure we have a proper fake caret on focus
					Delay.setEditorTimeout(editor, function() {
						editor.selection.setRng(renderRangeCaret(editor.selection.getRng()));
					}, 0);
				});
	
				editor.on('copy', function (e) {
					var clipboardData = e.clipboardData;
	
					// Make sure we get proper html/text for the fake cE=false selection
					// Doesn't work at all on Edge since it doesn't have proper clipboardData support
					if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
						var realSelectionElement = getRealSelectionElement();
						if (realSelectionElement) {
							e.preventDefault();
							clipboardData.clearData();
							clipboardData.setData('text/html', realSelectionElement.outerHTML);
							clipboardData.setData('text/plain', realSelectionElement.outerText);
						}
					}
				});
	
				DragDropOverrides.init(editor);
			}
	
			function addCss() {
				var styles = editor.contentStyles, rootClass = '.mce-content-body';
	
				styles.push(fakeCaret.getCss());
				styles.push(
					rootClass + ' .mce-offscreen-selection {' +
						'position: absolute;' +
						'left: -9999999999px;' +
					'}' +
					rootClass + ' *[contentEditable=false] {' +
						'cursor: default;' +
					'}' +
					rootClass + ' *[contentEditable=true] {' +
						'cursor: text;' +
					'}'
				);
			}
	
			function isRangeInCaretContainer(rng) {
				return CaretContainer.isCaretContainer(rng.startContainer) || CaretContainer.isCaretContainer(rng.endContainer);
			}
	
			function setContentEditableSelection(range) {
				var node, $ = editor.$, dom = editor.dom, $realSelectionContainer, sel,
					startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
	
				if (!range) {
					clearContentEditableSelection();
					return null;
				}
	
				if (range.collapsed) {
					clearContentEditableSelection();
	
					if (!isRangeInCaretContainer(range)) {
						caretPosition = getNormalizedRangeEndPoint(1, range);
	
						if (isContentEditableFalse(caretPosition.getNode())) {
							return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd());
						}
	
						if (isContentEditableFalse(caretPosition.getNode(true))) {
							return showCaret(1, caretPosition.getNode(true), false);
						}
					}
	
					return null;
				}
	
				startContainer = range.startContainer;
				startOffset = range.startOffset;
				endOffset = range.endOffset;
	
				// Normalizes <span cE=false>[</span>] to [<span cE=false></span>]
				if (startContainer.nodeType == 3 && startOffset == 0 && isContentEditableFalse(startContainer.parentNode)) {
					startContainer = startContainer.parentNode;
					startOffset = dom.nodeIndex(startContainer);
					startContainer = startContainer.parentNode;
				}
	
				if (startContainer.nodeType != 1) {
					clearContentEditableSelection();
					return null;
				}
	
				if (endOffset == startOffset + 1) {
					node = startContainer.childNodes[startOffset];
				}
	
				if (!isContentEditableFalse(node)) {
					clearContentEditableSelection();
					return null;
				}
	
				targetClone = origTargetClone = node.cloneNode(true);
				e = editor.fire('ObjectSelected', {target: node, targetClone: targetClone});
				if (e.isDefaultPrevented()) {
					clearContentEditableSelection();
					return null;
				}
	
				targetClone = e.targetClone;
				$realSelectionContainer = $('#' + realSelectionId);
				if ($realSelectionContainer.length === 0) {
					$realSelectionContainer = $(
						'<div data-mce-bogus="all" class="mce-offscreen-selection"></div>'
					).attr('id', realSelectionId);
	
					$realSelectionContainer.appendTo(editor.getBody());
				}
	
				range = editor.dom.createRng();
	
				// WHY is IE making things so hard! Copy on <i contentEditable="false">x</i> produces: <em>x</em>
				if (targetClone === origTargetClone && Env.ie) {
					$realSelectionContainer.empty().append(Zwsp.ZWSP).append(targetClone).append(Zwsp.ZWSP);
					range.setStart($realSelectionContainer[0].firstChild, 0);
					range.setEnd($realSelectionContainer[0].lastChild, 1);
				} else {
					$realSelectionContainer.empty().append('\u00a0').append(targetClone).append('\u00a0');
					range.setStart($realSelectionContainer[0].firstChild, 1);
					range.setEnd($realSelectionContainer[0].lastChild, 0);
				}
	
				$realSelectionContainer.css({
					top: dom.getPos(node, editor.getBody()).y
				});
	
				$realSelectionContainer[0].focus();
				sel = editor.selection.getSel();
				sel.removeAllRanges();
				sel.addRange(range);
	
				editor.$('*[data-mce-selected]').removeAttr('data-mce-selected');
				node.setAttribute('data-mce-selected', 1);
				selectedContentEditableNode = node;
	
				return range;
			}
	
			function clearContentEditableSelection() {
				if (selectedContentEditableNode) {
					selectedContentEditableNode.removeAttribute('data-mce-selected');
					editor.$('#' + realSelectionId).remove();
					selectedContentEditableNode = null;
				}
			}
	
			function destroy() {
				fakeCaret.destroy();
				selectedContentEditableNode = null;
			}
	
			function hideFakeCaret() {
				fakeCaret.hide();
			}
	
			if (Env.ceFalse) {
				registerEvents();
				addCss();
			}
	
			return {
				showBlockCaretContainer: showBlockCaretContainer,
				hideFakeCaret: hideFakeCaret,
				destroy: destroy
			};
		}
	
		return SelectionOverrides;
	});
	
	// Included from: js/tinymce/classes/util/Uuid.js
	
	/**
	 * Uuid.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Generates unique ids.
	 *
	 * @class tinymce.util.Uuid
	 * @private
	 */
	define("tinymce/util/Uuid", [
	], function() {
		var count = 0;
	
		var seed = function () {
			var rnd = function () {
				return Math.round(Math.random() * 0xFFFFFFFF).toString(36);
			};
	
			var now = new Date().getTime();
			return 's' + now.toString(36) + rnd() + rnd() + rnd();
		};
	
		var uuid = function (prefix) {
			return prefix + (count++) + seed();
		};
	
		return {
			uuid: uuid
		};
	});
	
	// Included from: js/tinymce/classes/Editor.js
	
	/**
	 * Editor.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint scripturl:true */
	
	/**
	 * Include the base event class documentation.
	 *
	 * @include ../../../tools/docs/tinymce.Event.js
	 */
	
	/**
	 * This class contains the core logic for a TinyMCE editor.
	 *
	 * @class tinymce.Editor
	 * @mixes tinymce.util.Observable
	 * @example
	 * // Add a class to all paragraphs in the editor.
	 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'someclass');
	 *
	 * // Gets the current editors selection as text
	 * tinymce.activeEditor.selection.getContent({format: 'text'});
	 *
	 * // Creates a new editor instance
	 * var ed = new tinymce.Editor('textareaid', {
	 *     some_setting: 1
	 * }, tinymce.EditorManager);
	 *
	 * // Select each item the user clicks on
	 * ed.on('click', function(e) {
	 *     ed.selection.select(e.target);
	 * });
	 *
	 * ed.render();
	 */
	define("tinymce/Editor", [
		"tinymce/dom/DOMUtils",
		"tinymce/dom/DomQuery",
		"tinymce/AddOnManager",
		"tinymce/NodeChange",
		"tinymce/html/Node",
		"tinymce/dom/Serializer",
		"tinymce/html/Serializer",
		"tinymce/dom/Selection",
		"tinymce/Formatter",
		"tinymce/UndoManager",
		"tinymce/EnterKey",
		"tinymce/ForceBlocks",
		"tinymce/EditorCommands",
		"tinymce/util/URI",
		"tinymce/dom/ScriptLoader",
		"tinymce/dom/EventUtils",
		"tinymce/WindowManager",
		"tinymce/NotificationManager",
		"tinymce/html/Schema",
		"tinymce/html/DomParser",
		"tinymce/util/Quirks",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/util/Delay",
		"tinymce/EditorObservable",
		"tinymce/Mode",
		"tinymce/Shortcuts",
		"tinymce/EditorUpload",
		"tinymce/SelectionOverrides",
		"tinymce/util/Uuid"
	], function(
		DOMUtils, DomQuery, AddOnManager, NodeChange, Node, DomSerializer, Serializer,
		Selection, Formatter, UndoManager, EnterKey, ForceBlocks, EditorCommands,
		URI, ScriptLoader, EventUtils, WindowManager, NotificationManager,
		Schema, DomParser, Quirks, Env, Tools, Delay, EditorObservable, Mode, Shortcuts, EditorUpload,
		SelectionOverrides, Uuid
	) {
		// Shorten these names
		var DOM = DOMUtils.DOM, ThemeManager = AddOnManager.ThemeManager, PluginManager = AddOnManager.PluginManager;
		var extend = Tools.extend, each = Tools.each, explode = Tools.explode;
		var inArray = Tools.inArray, trim = Tools.trim, resolve = Tools.resolve;
		var Event = EventUtils.Event;
		var isGecko = Env.gecko, ie = Env.ie;
	
		/**
		 * Include documentation for all the events.
		 *
		 * @include ../../../tools/docs/tinymce.Editor.js
		 */
	
		/**
		 * Constructs a editor instance by id.
		 *
		 * @constructor
		 * @method Editor
		 * @param {String} id Unique id for the editor.
		 * @param {Object} settings Settings for the editor.
		 * @param {tinymce.EditorManager} editorManager EditorManager instance.
		 */
		function Editor(id, settings, editorManager) {
			var self = this, documentBaseUrl, baseUri, defaultSettings;
	
			documentBaseUrl = self.documentBaseUrl = editorManager.documentBaseURL;
			baseUri = editorManager.baseURI;
			defaultSettings = editorManager.defaultSettings;
	
			/**
			 * Name/value collection with editor settings.
			 *
			 * @property settings
			 * @type Object
			 * @example
			 * // Get the value of the theme setting
			 * tinymce.activeEditor.windowManager.alert("You are using the " + tinymce.activeEditor.settings.theme + " theme");
			 */
			settings = extend({
				id: id,
				theme: 'modern',
				delta_width: 0,
				delta_height: 0,
				popup_css: '',
				plugins: '',
				document_base_url: documentBaseUrl,
				add_form_submit_trigger: true,
				submit_patch: true,
				add_unload_trigger: true,
				convert_urls: true,
				relative_urls: true,
				remove_script_host: true,
				object_resizing: true,
				doctype: '<!DOCTYPE html>',
				visual: true,
				font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
	
				// See: http://www.w3.org/TR/CSS2/fonts.html#propdef-font-size
				font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
				forced_root_block: 'p',
				hidden_input: true,
				padd_empty_editor: true,
				render_ui: true,
				indentation: '30px',
				inline_styles: true,
				convert_fonts_to_spans: true,
				indent: 'simple',
				indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' +
					'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
				indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' +
					'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
				validate: true,
				entity_encoding: 'named',
				url_converter: self.convertURL,
				url_converter_scope: self,
				ie7_compat: true
			}, defaultSettings, settings);
	
			// Merge external_plugins
			if (defaultSettings && defaultSettings.external_plugins && settings.external_plugins) {
				settings.external_plugins = extend({}, defaultSettings.external_plugins, settings.external_plugins);
			}
	
			self.settings = settings;
			AddOnManager.language = settings.language || 'en';
			AddOnManager.languageLoad = settings.language_load;
			AddOnManager.baseURL = editorManager.baseURL;
	
			/**
			 * Editor instance id, normally the same as the div/textarea that was replaced.
			 *
			 * @property id
			 * @type String
			 */
			self.id = settings.id = id;
	
			/**
			 * State to force the editor to return false on a isDirty call.
			 *
			 * @property isNotDirty
			 * @type Boolean
			 * @deprecated Use editor.setDirty instead.
			 */
			self.setDirty(false);
	
			/**
			 * Name/Value object containing plugin instances.
			 *
			 * @property plugins
			 * @type Object
			 * @example
			 * // Execute a method inside a plugin directly
			 * tinymce.activeEditor.plugins.someplugin.someMethod();
			 */
			self.plugins = {};
	
			/**
			 * URI object to document configured for the TinyMCE instance.
			 *
			 * @property documentBaseURI
			 * @type tinymce.util.URI
			 * @example
			 * // Get relative URL from the location of document_base_url
			 * tinymce.activeEditor.documentBaseURI.toRelative('/somedir/somefile.htm');
			 *
			 * // Get absolute URL from the location of document_base_url
			 * tinymce.activeEditor.documentBaseURI.toAbsolute('somefile.htm');
			 */
			self.documentBaseURI = new URI(settings.document_base_url || documentBaseUrl, {
				base_uri: baseUri
			});
	
			/**
			 * URI object to current document that holds the TinyMCE editor instance.
			 *
			 * @property baseURI
			 * @type tinymce.util.URI
			 * @example
			 * // Get relative URL from the location of the API
			 * tinymce.activeEditor.baseURI.toRelative('/somedir/somefile.htm');
			 *
			 * // Get absolute URL from the location of the API
			 * tinymce.activeEditor.baseURI.toAbsolute('somefile.htm');
			 */
			self.baseURI = baseUri;
	
			/**
			 * Array with CSS files to load into the iframe.
			 *
			 * @property contentCSS
			 * @type Array
			 */
			self.contentCSS = [];
	
			/**
			 * Array of CSS styles to add to head of document when the editor loads.
			 *
			 * @property contentStyles
			 * @type Array
			 */
			self.contentStyles = [];
	
			// Creates all events like onClick, onSetContent etc see Editor.Events.js for the actual logic
			self.shortcuts = new Shortcuts(self);
			self.loadedCSS = {};
			self.editorCommands = new EditorCommands(self);
	
			if (settings.target) {
				self.targetElm = settings.target;
			}
	
			self.suffix = editorManager.suffix;
			self.editorManager = editorManager;
			self.inline = settings.inline;
			self.settings.content_editable = self.inline;
	
			if (settings.cache_suffix) {
				Env.cacheSuffix = settings.cache_suffix.replace(/^[\?\&]+/, '');
			}
	
			if (settings.override_viewport === false) {
				Env.overrideViewPort = false;
			}
	
			// Call setup
			editorManager.fire('SetupEditor', self);
			self.execCallback('setup', self);
	
			/**
			 * Dom query instance with default scope to the editor document and default element is the body of the editor.
			 *
			 * @property $
			 * @type tinymce.dom.DomQuery
			 * @example
			 * tinymce.activeEditor.$('p').css('color', 'red');
			 * tinymce.activeEditor.$().append('<p>new</p>');
			 */
			self.$ = DomQuery.overrideDefaults(function() {
				return {
					context: self.inline ? self.getBody() : self.getDoc(),
					element: self.getBody()
				};
			});
		}
	
		Editor.prototype = {
			/**
			 * Renders the editor/adds it to the page.
			 *
			 * @method render
			 */
			render: function() {
				var self = this, settings = self.settings, id = self.id, suffix = self.suffix;
	
				function readyHandler() {
					DOM.unbind(window, 'ready', readyHandler);
					self.render();
				}
	
				// Page is not loaded yet, wait for it
				if (!Event.domLoaded) {
					DOM.bind(window, 'ready', readyHandler);
					return;
				}
	
				// Element not found, then skip initialization
				if (!self.getElement()) {
					return;
				}
	
				// No editable support old iOS versions etc
				if (!Env.contentEditable) {
					return;
				}
	
				// Hide target element early to prevent content flashing
				if (!settings.inline) {
					self.orgVisibility = self.getElement().style.visibility;
					self.getElement().style.visibility = 'hidden';
				} else {
					self.inline = true;
				}
	
				var form = self.getElement().form || DOM.getParent(id, 'form');
				if (form) {
					self.formElement = form;
	
					// Add hidden input for non input elements inside form elements
					if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(self.getElement().nodeName)) {
						DOM.insertAfter(DOM.create('input', {type: 'hidden', name: id}), id);
						self.hasHiddenInput = true;
					}
	
					// Pass submit/reset from form to editor instance
					self.formEventDelegate = function(e) {
						self.fire(e.type, e);
					};
	
					DOM.bind(form, 'submit reset', self.formEventDelegate);
	
					// Reset contents in editor when the form is reset
					self.on('reset', function() {
						self.setContent(self.startContent, {format: 'raw'});
					});
	
					// Check page uses id="submit" or name="submit" for it's submit button
					if (settings.submit_patch && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
						form._mceOldSubmit = form.submit;
						form.submit = function() {
							self.editorManager.triggerSave();
							self.setDirty(false);
	
							return form._mceOldSubmit(form);
						};
					}
				}
	
				/**
				 * Window manager reference, use this to open new windows and dialogs.
				 *
				 * @property windowManager
				 * @type tinymce.WindowManager
				 * @example
				 * // Shows an alert message
				 * tinymce.activeEditor.windowManager.alert('Hello world!');
				 *
				 * // Opens a new dialog with the file.htm file and the size 320x240
				 * // It also adds a custom parameter this can be retrieved by using tinyMCEPopup.getWindowArg inside the dialog.
				 * tinymce.activeEditor.windowManager.open({
				 *    url: 'file.htm',
				 *    width: 320,
				 *    height: 240
				 * }, {
				 *    custom_param: 1
				 * });
				 */
				self.windowManager = new WindowManager(self);
	
				/**
				 * Notification manager reference, use this to open new windows and dialogs.
				 *
				 * @property notificationManager
				 * @type tinymce.NotificationManager
				 * @example
				 * // Shows a notification info message.
				 * tinymce.activeEditor.notificationManager.open({text: 'Hello world!', type: 'info'});
				 */
				self.notificationManager = new NotificationManager(self);
	
				if (settings.encoding == 'xml') {
					self.on('GetContent', function(e) {
						if (e.save) {
							e.content = DOM.encode(e.content);
						}
					});
				}
	
				if (settings.add_form_submit_trigger) {
					self.on('submit', function() {
						if (self.initialized) {
							self.save();
						}
					});
				}
	
				if (settings.add_unload_trigger) {
					self._beforeUnload = function() {
						if (self.initialized && !self.destroyed && !self.isHidden()) {
							self.save({format: 'raw', no_events: true, set_dirty: false});
						}
					};
	
					self.editorManager.on('BeforeUnload', self._beforeUnload);
				}
	
				// Load scripts
				function loadScripts() {
					var scriptLoader = ScriptLoader.ScriptLoader;
	
					if (settings.language && settings.language != 'en' && !settings.language_url) {
						settings.language_url = self.editorManager.baseURL + '/langs/' + settings.language + '.js';
					}
	
					if (settings.language_url) {
						scriptLoader.add(settings.language_url);
					}
	
					if (settings.theme && typeof settings.theme != "function" &&
						settings.theme.charAt(0) != '-' && !ThemeManager.urls[settings.theme]) {
						var themeUrl = settings.theme_url;
	
						if (themeUrl) {
							themeUrl = self.documentBaseURI.toAbsolute(themeUrl);
						} else {
							themeUrl = 'themes/' + settings.theme + '/theme' + suffix + '.js';
						}
	
						ThemeManager.load(settings.theme, themeUrl);
					}
	
					if (Tools.isArray(settings.plugins)) {
						settings.plugins = settings.plugins.join(' ');
					}
	
					each(settings.external_plugins, function(url, name) {
						PluginManager.load(name, url);
						settings.plugins += ' ' + name;
					});
	
					each(settings.plugins.split(/[ ,]/), function(plugin) {
						plugin = trim(plugin);
	
						if (plugin && !PluginManager.urls[plugin]) {
							if (plugin.charAt(0) == '-') {
								plugin = plugin.substr(1, plugin.length);
	
								var dependencies = PluginManager.dependencies(plugin);
	
								each(dependencies, function(dep) {
									var defaultSettings = {
										prefix: 'plugins/',
										resource: dep,
										suffix: '/plugin' + suffix + '.js'
									};
	
									dep = PluginManager.createUrl(defaultSettings, dep);
									PluginManager.load(dep.resource, dep);
								});
							} else {
								PluginManager.load(plugin, {
									prefix: 'plugins/',
									resource: plugin,
									suffix: '/plugin' + suffix + '.js'
								});
							}
						}
					});
	
					scriptLoader.loadQueue(function() {
						if (!self.removed) {
							self.init();
						}
					});
				}
	
				self.editorManager.add(self);
				loadScripts();
			},
	
			/**
			 * Initializes the editor this will be called automatically when
			 * all plugins/themes and language packs are loaded by the rendered method.
			 * This method will setup the iframe and create the theme and plugin instances.
			 *
			 * @method init
			 */
			init: function() {
				var self = this, settings = self.settings, elm = self.getElement();
				var w, h, minHeight, n, o, Theme, url, bodyId, bodyClass, re, i, initializedPlugins = [];
	
				self.rtl = settings.rtl_ui || self.editorManager.i18n.rtl;
				self.editorManager.i18n.setCode(settings.language);
				settings.aria_label = settings.aria_label || DOM.getAttrib(elm, 'aria-label', self.getLang('aria.rich_text_area'));
	
				self.fire('ScriptsLoaded');
	
				/**
				 * Reference to the theme instance that was used to generate the UI.
				 *
				 * @property theme
				 * @type tinymce.Theme
				 * @example
				 * // Executes a method on the theme directly
				 * tinymce.activeEditor.theme.someMethod();
				 */
				if (settings.theme) {
					if (typeof settings.theme != "function") {
						settings.theme = settings.theme.replace(/-/, '');
						Theme = ThemeManager.get(settings.theme);
						self.theme = new Theme(self, ThemeManager.urls[settings.theme]);
	
						if (self.theme.init) {
							self.theme.init(self, ThemeManager.urls[settings.theme] || self.documentBaseUrl.replace(/\/$/, ''), self.$);
						}
					} else {
						self.theme = settings.theme;
					}
				}
	
				function initPlugin(plugin) {
					var Plugin = PluginManager.get(plugin), pluginUrl, pluginInstance;
	
					pluginUrl = PluginManager.urls[plugin] || self.documentBaseUrl.replace(/\/$/, '');
					plugin = trim(plugin);
					if (Plugin && inArray(initializedPlugins, plugin) === -1) {
						each(PluginManager.dependencies(plugin), function(dep) {
							initPlugin(dep);
						});
	
						if (self.plugins[plugin]) {
							return;
						}
	
						pluginInstance = new Plugin(self, pluginUrl, self.$);
	
						self.plugins[plugin] = pluginInstance;
	
						if (pluginInstance.init) {
							pluginInstance.init(self, pluginUrl);
							initializedPlugins.push(plugin);
						}
					}
				}
	
				// Create all plugins
				each(settings.plugins.replace(/\-/g, '').split(/[ ,]/), initPlugin);
	
				// Measure box
				if (settings.render_ui && self.theme) {
					self.orgDisplay = elm.style.display;
	
					if (typeof settings.theme != "function") {
						w = settings.width || elm.style.width || elm.offsetWidth;
						h = settings.height || elm.style.height || elm.offsetHeight;
						minHeight = settings.min_height || 100;
						re = /^[0-9\.]+(|px)$/i;
	
						if (re.test('' + w)) {
							w = Math.max(parseInt(w, 10), 100);
						}
	
						if (re.test('' + h)) {
							h = Math.max(parseInt(h, 10), minHeight);
						}
	
						// Render UI
						o = self.theme.renderUI({
							targetNode: elm,
							width: w,
							height: h,
							deltaWidth: settings.delta_width,
							deltaHeight: settings.delta_height
						});
	
						// Resize editor
						if (!settings.content_editable) {
							h = (o.iframeHeight || h) + (typeof h == 'number' ? (o.deltaHeight || 0) : '');
							if (h < minHeight) {
								h = minHeight;
							}
						}
					} else {
						o = settings.theme(self, elm);
	
						// Convert element type to id:s
						if (o.editorContainer.nodeType) {
							o.editorContainer = o.editorContainer.id = o.editorContainer.id || self.id + "_parent";
						}
	
						// Convert element type to id:s
						if (o.iframeContainer.nodeType) {
							o.iframeContainer = o.iframeContainer.id = o.iframeContainer.id || self.id + "_iframecontainer";
						}
	
						// Use specified iframe height or the targets offsetHeight
						h = o.iframeHeight || elm.offsetHeight;
					}
	
					self.editorContainer = o.editorContainer;
				}
	
				// Load specified content CSS last
				if (settings.content_css) {
					each(explode(settings.content_css), function(u) {
						self.contentCSS.push(self.documentBaseURI.toAbsolute(u));
					});
				}
	
				// Load specified content CSS last
				if (settings.content_style) {
					self.contentStyles.push(settings.content_style);
				}
	
				// Content editable mode ends here
				if (settings.content_editable) {
					elm = n = o = null; // Fix IE leak
					return self.initContentBody();
				}
	
				self.iframeHTML = settings.doctype + '<html><head>';
	
				// We only need to override paths if we have to
				// IE has a bug where it remove site absolute urls to relative ones if this is specified
				if (settings.document_base_url != self.documentBaseUrl) {
					self.iframeHTML += '<base href="' + self.documentBaseURI.getURI() + '" />';
				}
	
				// IE8 doesn't support carets behind images setting ie7_compat would force IE8+ to run in IE7 compat mode.
				if (!Env.caretAfter && settings.ie7_compat) {
					self.iframeHTML += '<meta http-equiv="X-UA-Compatible" content="IE=7" />';
				}
	
				self.iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	
				// Load the CSS by injecting them into the HTML this will reduce "flicker"
				// However we can't do that on Chrome since # will scroll to the editor for some odd reason see #2427
				if (!/#$/.test(document.location.href)) {
					for (i = 0; i < self.contentCSS.length; i++) {
						var cssUrl = self.contentCSS[i];
						self.iframeHTML += (
							'<link type="text/css" ' +
								'rel="stylesheet" ' +
								'href="' + Tools._addCacheSuffix(cssUrl) + '" />'
						);
						self.loadedCSS[cssUrl] = true;
					}
				}
	
				bodyId = settings.body_id || 'tinymce';
				if (bodyId.indexOf('=') != -1) {
					bodyId = self.getParam('body_id', '', 'hash');
					bodyId = bodyId[self.id] || bodyId;
				}
	
				bodyClass = settings.body_class || '';
				if (bodyClass.indexOf('=') != -1) {
					bodyClass = self.getParam('body_class', '', 'hash');
					bodyClass = bodyClass[self.id] || '';
				}
	
				if (settings.content_security_policy) {
					self.iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + settings.content_security_policy + '" />';
				}
	
				self.iframeHTML += '</head><body id="' + bodyId +
					'" class="mce-content-body ' + bodyClass +
					'" data-id="' + self.id + '"><br></body></html>';
	
				/*eslint no-script-url:0 */
				var domainRelaxUrl = 'javascript:(function(){' +
					'document.open();document.domain="' + document.domain + '";' +
					'var ed = window.parent.tinymce.get("' + self.id + '");document.write(ed.iframeHTML);' +
					'document.close();ed.initContentBody(true);})()';
	
				// Domain relaxing is required since the user has messed around with document.domain
				if (document.domain != location.hostname) {
					// Edge seems to be able to handle domain relaxing
					if (Env.ie && Env.ie < 12) {
						url = domainRelaxUrl;
					}
				}
	
				// Create iframe
				// TODO: ACC add the appropriate description on this.
				var ifr = DOM.create('iframe', {
					id: self.id + "_ifr",
					//src: url || 'javascript:""', // Workaround for HTTPS warning in IE6/7
					frameBorder: '0',
					allowTransparency: "true",
					title: self.editorManager.translate(
							"Rich Text Area. Press ALT-F9 for menu. " +
							"Press ALT-F10 for toolbar. Press ALT-0 for help"
					),
					style: {
						width: '100%',
						height: h,
						display: 'block' // Important for Gecko to render the iframe correctly
					}
				});
	
				ifr.onload = function() {
					ifr.onload = null;
					self.fire("load");
				};
	
				DOM.setAttrib(ifr, "src", url || 'javascript:""');
	
				self.contentAreaContainer = o.iframeContainer;
				self.iframeElement = ifr;
	
				n = DOM.add(o.iframeContainer, ifr);
	
				// Try accessing the document this will fail on IE when document.domain is set to the same as location.hostname
				// Then we have to force domain relaxing using the domainRelaxUrl approach very ugly!!
				if (ie) {
					try {
						self.getDoc();
					} catch (e) {
						n.src = url = domainRelaxUrl;
					}
				}
	
				if (o.editorContainer) {
					DOM.get(o.editorContainer).style.display = self.orgDisplay;
					self.hidden = DOM.isHidden(o.editorContainer);
				}
	
				self.getElement().style.display = 'none';
				DOM.setAttrib(self.id, 'aria-hidden', true);
	
				if (!url) {
					self.initContentBody();
				}
	
				elm = n = o = null; // Cleanup
			},
	
			/**
			 * This method get called by the init method once the iframe is loaded.
			 * It will fill the iframe with contents, sets up DOM and selection objects for the iframe.
			 *
			 * @method initContentBody
			 * @private
			 */
			initContentBody: function(skipWrite) {
				var self = this, settings = self.settings, targetElm = self.getElement(), doc = self.getDoc(), body, contentCssText;
	
				// Restore visibility on target element
				if (!settings.inline) {
					self.getElement().style.visibility = self.orgVisibility;
				}
	
				// Setup iframe body
				if (!skipWrite && !settings.content_editable) {
					doc.open();
					doc.write(self.iframeHTML);
					doc.close();
				}
	
				if (settings.content_editable) {
					self.on('remove', function() {
						var bodyEl = this.getBody();
	
						DOM.removeClass(bodyEl, 'mce-content-body');
						DOM.removeClass(bodyEl, 'mce-edit-focus');
						DOM.setAttrib(bodyEl, 'contentEditable', null);
					});
	
					DOM.addClass(targetElm, 'mce-content-body');
					self.contentDocument = doc = settings.content_document || document;
					self.contentWindow = settings.content_window || window;
					self.bodyElement = targetElm;
	
					// Prevent leak in IE
					settings.content_document = settings.content_window = null;
	
					// TODO: Fix this
					settings.root_name = targetElm.nodeName.toLowerCase();
				}
	
				// It will not steal focus while setting contentEditable
				body = self.getBody();
				body.disabled = true;
				self.readonly = settings.readonly;
	
				if (!self.readonly) {
					if (self.inline && DOM.getStyle(body, 'position', true) == 'static') {
						body.style.position = 'relative';
					}
	
					body.contentEditable = self.getParam('content_editable_state', true);
				}
	
				body.disabled = false;
	
				self.editorUpload = new EditorUpload(self);
	
				/**
				 * Schema instance, enables you to validate elements and its children.
				 *
				 * @property schema
				 * @type tinymce.html.Schema
				 */
				self.schema = new Schema(settings);
	
				/**
				 * DOM instance for the editor.
				 *
				 * @property dom
				 * @type tinymce.dom.DOMUtils
				 * @example
				 * // Adds a class to all paragraphs within the editor
				 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'someclass');
				 */
				self.dom = new DOMUtils(doc, {
					keep_values: true,
					url_converter: self.convertURL,
					url_converter_scope: self,
					hex_colors: settings.force_hex_style_colors,
					class_filter: settings.class_filter,
					update_styles: true,
					root_element: self.inline ? self.getBody() : null,
					collect: settings.content_editable,
					schema: self.schema,
					onSetAttrib: function(e) {
						self.fire('SetAttrib', e);
					}
				});
	
				/**
				 * HTML parser will be used when contents is inserted into the editor.
				 *
				 * @property parser
				 * @type tinymce.html.DomParser
				 */
				self.parser = new DomParser(settings, self.schema);
	
				// Convert src and href into data-mce-src, data-mce-href and data-mce-style
				self.parser.addAttributeFilter('src,href,style,tabindex', function(nodes, name) {
					var i = nodes.length, node, dom = self.dom, value, internalName;
	
					while (i--) {
						node = nodes[i];
						value = node.attr(name);
						internalName = 'data-mce-' + name;
	
						// Add internal attribute if we need to we don't on a refresh of the document
						if (!node.attributes.map[internalName]) {
							// Don't duplicate these since they won't get modified by any browser
							if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
								continue;
							}
	
							if (name === "style") {
								value = dom.serializeStyle(dom.parseStyle(value), node.name);
	
								if (!value.length) {
									value = null;
								}
	
								node.attr(internalName, value);
								node.attr(name, value);
							} else if (name === "tabindex") {
								node.attr(internalName, value);
								node.attr(name, null);
							} else {
								node.attr(internalName, self.convertURL(value, name, node.name));
							}
						}
					}
				});
	
				// Keep scripts from executing
				self.parser.addNodeFilter('script', function(nodes) {
					var i = nodes.length, node, type;
	
					while (i--) {
						node = nodes[i];
						type = node.attr('type') || 'no/type';
						if (type.indexOf('mce-') !== 0) {
							node.attr('type', 'mce-' + type);
						}
					}
				});
	
				self.parser.addNodeFilter('#cdata', function(nodes) {
					var i = nodes.length, node;
	
					while (i--) {
						node = nodes[i];
						node.type = 8;
						node.name = '#comment';
						node.value = '[CDATA[' + node.value + ']]';
					}
				});
	
				self.parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function(nodes) {
					var i = nodes.length, node, nonEmptyElements = self.schema.getNonEmptyElements();
	
					while (i--) {
						node = nodes[i];
	
						if (node.isEmpty(nonEmptyElements)) {
							node.append(new Node('br', 1)).shortEnded = true;
						}
					}
				});
	
				/**
				 * DOM serializer for the editor. Will be used when contents is extracted from the editor.
				 *
				 * @property serializer
				 * @type tinymce.dom.Serializer
				 * @example
				 * // Serializes the first paragraph in the editor into a string
				 * tinymce.activeEditor.serializer.serialize(tinymce.activeEditor.dom.select('p')[0]);
				 */
				self.serializer = new DomSerializer(settings, self);
	
				/**
				 * Selection instance for the editor.
				 *
				 * @property selection
				 * @type tinymce.dom.Selection
				 * @example
				 * // Sets some contents to the current selection in the editor
				 * tinymce.activeEditor.selection.setContent('Some contents');
				 *
				 * // Gets the current selection
				 * alert(tinymce.activeEditor.selection.getContent());
				 *
				 * // Selects the first paragraph found
				 * tinymce.activeEditor.selection.select(tinymce.activeEditor.dom.select('p')[0]);
				 */
				self.selection = new Selection(self.dom, self.getWin(), self.serializer, self);
	
				/**
				 * Formatter instance.
				 *
				 * @property formatter
				 * @type tinymce.Formatter
				 */
				self.formatter = new Formatter(self);
	
				/**
				 * Undo manager instance, responsible for handling undo levels.
				 *
				 * @property undoManager
				 * @type tinymce.UndoManager
				 * @example
				 * // Undoes the last modification to the editor
				 * tinymce.activeEditor.undoManager.undo();
				 */
				self.undoManager = new UndoManager(self);
	
				self.forceBlocks = new ForceBlocks(self);
				self.enterKey = new EnterKey(self);
				self._nodeChangeDispatcher = new NodeChange(self);
				self._selectionOverrides = new SelectionOverrides(self);
	
				self.fire('PreInit');
	
				if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
					doc.body.spellcheck = false; // Gecko
					DOM.setAttrib(body, "spellcheck", "false");
				}
	
				self.quirks = new Quirks(self);
				self.fire('PostRender');
	
				if (settings.directionality) {
					body.dir = settings.directionality;
				}
	
				if (settings.nowrap) {
					body.style.whiteSpace = "nowrap";
				}
	
				if (settings.protect) {
					self.on('BeforeSetContent', function(e) {
						each(settings.protect, function(pattern) {
							e.content = e.content.replace(pattern, function(str) {
								return '<!--mce:protected ' + escape(str) + '-->';
							});
						});
					});
				}
	
				self.on('SetContent', function() {
					self.addVisual(self.getBody());
				});
	
				// Remove empty contents
				if (settings.padd_empty_editor) {
					self.on('PostProcess', function(e) {
						e.content = e.content.replace(/^(<p[^>]*>(&nbsp;|&#160;|\s|\u00a0|)<\/p>[\r\n]*|<br \/>[\r\n]*)$/, '');
					});
				}
	
				self.load({initial: true, format: 'html'});
				self.startContent = self.getContent({format: 'raw'});
	
				/**
				 * Is set to true after the editor instance has been initialized
				 *
				 * @property initialized
				 * @type Boolean
				 * @example
				 * function isEditorInitialized(editor) {
				 *     return editor && editor.initialized;
				 * }
				 */
				self.initialized = true;
				self.bindPendingEventDelegates();
	
				self.fire('init');
				self.focus(true);
				self.nodeChanged({initial: true});
				self.execCallback('init_instance_callback', self);
	
				self.on('compositionstart compositionend', function(e) {
					self.composing = e.type === 'compositionstart';
				});
	
				// Add editor specific CSS styles
				if (self.contentStyles.length > 0) {
					contentCssText = '';
	
					each(self.contentStyles, function(style) {
						contentCssText += style + "\r\n";
					});
	
					self.dom.addStyle(contentCssText);
				}
	
				// Load specified content CSS last
				each(self.contentCSS, function(cssUrl) {
					if (!self.loadedCSS[cssUrl]) {
						self.dom.loadCSS(cssUrl);
						self.loadedCSS[cssUrl] = true;
					}
				});
	
				// Handle auto focus
				if (settings.auto_focus) {
					Delay.setEditorTimeout(self, function() {
						var editor;
	
						if (settings.auto_focus === true) {
							editor = self;
						} else {
							editor = self.editorManager.get(settings.auto_focus);
						}
	
						if (!editor.destroyed) {
							editor.focus();
						}
					}, 100);
				}
	
				// Clean up references for IE
				targetElm = doc = body = null;
			},
	
			/**
			 * Focuses/activates the editor. This will set this editor as the activeEditor in the tinymce collection
			 * it will also place DOM focus inside the editor.
			 *
			 * @method focus
			 * @param {Boolean} skipFocus Skip DOM focus. Just set is as the active editor.
			 */
			focus: function(skipFocus) {
				var self = this, selection = self.selection, contentEditable = self.settings.content_editable, rng;
				var controlElm, doc = self.getDoc(), body = self.getBody(), contentEditableHost;
	
				function getContentEditableHost(node) {
					return self.dom.getParent(node, function(node) {
						return self.dom.getContentEditable(node) === "true";
					});
				}
	
				if (!skipFocus) {
					// Get selected control element
					rng = selection.getRng();
					if (rng.item) {
						controlElm = rng.item(0);
					}
	
					self.quirks.refreshContentEditable();
	
					// Move focus to contentEditable=true child if needed
					contentEditableHost = getContentEditableHost(selection.getNode());
					if (self.$.contains(body, contentEditableHost)) {
						contentEditableHost.focus();
						selection.normalize();
						self.editorManager.setActive(self);
						return;
					}
	
					// Focus the window iframe
					if (!contentEditable) {
						// WebKit needs this call to fire focusin event properly see #5948
						// But Opera pre Blink engine will produce an empty selection so skip Opera
						if (!Env.opera) {
							self.getBody().focus();
						}
	
						self.getWin().focus();
					}
	
					// Focus the body as well since it's contentEditable
					if (isGecko || contentEditable) {
						// Check for setActive since it doesn't scroll to the element
						if (body.setActive) {
							// IE 11 sometimes throws "Invalid function" then fallback to focus
							try {
								body.setActive();
							} catch (ex) {
								body.focus();
							}
						} else {
							body.focus();
						}
	
						if (contentEditable) {
							selection.normalize();
						}
					}
	
					// Restore selected control element
					// This is needed when for example an image is selected within a
					// layer a call to focus will then remove the control selection
					if (controlElm && controlElm.ownerDocument == doc) {
						rng = doc.body.createControlRange();
						rng.addElement(controlElm);
						rng.select();
					}
				}
	
				self.editorManager.setActive(self);
			},
	
			/**
			 * Executes a legacy callback. This method is useful to call old 2.x option callbacks.
			 * There new event model is a better way to add callback so this method might be removed in the future.
			 *
			 * @method execCallback
			 * @param {String} name Name of the callback to execute.
			 * @return {Object} Return value passed from callback function.
			 */
			execCallback: function(name) {
				var self = this, callback = self.settings[name], scope;
	
				if (!callback) {
					return;
				}
	
				// Look through lookup
				if (self.callbackLookup && (scope = self.callbackLookup[name])) {
					callback = scope.func;
					scope = scope.scope;
				}
	
				if (typeof callback === 'string') {
					scope = callback.replace(/\.\w+$/, '');
					scope = scope ? resolve(scope) : 0;
					callback = resolve(callback);
					self.callbackLookup = self.callbackLookup || {};
					self.callbackLookup[name] = {func: callback, scope: scope};
				}
	
				return callback.apply(scope || self, Array.prototype.slice.call(arguments, 1));
			},
	
			/**
			 * Translates the specified string by replacing variables with language pack items it will also check if there is
			 * a key matching the input.
			 *
			 * @method translate
			 * @param {String} text String to translate by the language pack data.
			 * @return {String} Translated string.
			 */
			translate: function(text) {
				var lang = this.settings.language || 'en', i18n = this.editorManager.i18n;
	
				if (!text) {
					return '';
				}
	
				text = i18n.data[lang + '.' + text] || text.replace(/\{\#([^\}]+)\}/g, function(a, b) {
					return i18n.data[lang + '.' + b] || '{#' + b + '}';
				});
	
				return this.editorManager.translate(text);
			},
	
			/**
			 * Returns a language pack item by name/key.
			 *
			 * @method getLang
			 * @param {String} name Name/key to get from the language pack.
			 * @param {String} defaultVal Optional default value to retrieve.
			 */
			getLang: function(name, defaultVal) {
				return (
					this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + name] ||
					(defaultVal !== undefined ? defaultVal : '{#' + name + '}')
				);
			},
	
			/**
			 * Returns a configuration parameter by name.
			 *
			 * @method getParam
			 * @param {String} name Configruation parameter to retrieve.
			 * @param {String} defaultVal Optional default value to return.
			 * @param {String} type Optional type parameter.
			 * @return {String} Configuration parameter value or default value.
			 * @example
			 * // Returns a specific config value from the currently active editor
			 * var someval = tinymce.activeEditor.getParam('myvalue');
			 *
			 * // Returns a specific config value from a specific editor instance by id
			 * var someval2 = tinymce.get('my_editor').getParam('myvalue');
			 */
			getParam: function(name, defaultVal, type) {
				var value = name in this.settings ? this.settings[name] : defaultVal, output;
	
				if (type === 'hash') {
					output = {};
	
					if (typeof value === 'string') {
						each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function(value) {
							value = value.split('=');
	
							if (value.length > 1) {
								output[trim(value[0])] = trim(value[1]);
							} else {
								output[trim(value[0])] = trim(value);
							}
						});
					} else {
						output = value;
					}
	
					return output;
				}
	
				return value;
			},
	
			/**
			 * Dispatches out a onNodeChange event to all observers. This method should be called when you
			 * need to update the UI states or element path etc.
			 *
			 * @method nodeChanged
			 * @param {Object} args Optional args to pass to NodeChange event handlers.
			 */
			nodeChanged: function(args) {
				this._nodeChangeDispatcher.nodeChanged(args);
			},
	
			/**
			 * Adds a button that later gets created by the theme in the editors toolbars.
			 *
			 * @method addButton
			 * @param {String} name Button name to add.
			 * @param {Object} settings Settings object with title, cmd etc.
			 * @example
			 * // Adds a custom button to the editor that inserts contents when clicked
			 * tinymce.init({
			 *    ...
			 *
			 *    toolbar: 'example'
			 *
			 *    setup: function(ed) {
			 *       ed.addButton('example', {
			 *          title: 'My title',
			 *          image: '../js/tinymce/plugins/example/img/example.gif',
			 *          onclick: function() {
			 *             ed.insertContent('Hello world!!');
			 *          }
			 *       });
			 *    }
			 * });
			 */
			addButton: function(name, settings) {
				var self = this;
	
				if (settings.cmd) {
					settings.onclick = function() {
						self.execCommand(settings.cmd);
					};
				}
	
				if (!settings.text && !settings.icon) {
					settings.icon = name;
				}
	
				self.buttons = self.buttons || {};
				settings.tooltip = settings.tooltip || settings.title;
				self.buttons[name] = settings;
			},
	
			/**
			 * Adds a menu item to be used in the menus of the theme. There might be multiple instances
			 * of this menu item for example it might be used in the main menus of the theme but also in
			 * the context menu so make sure that it's self contained and supports multiple instances.
			 *
			 * @method addMenuItem
			 * @param {String} name Menu item name to add.
			 * @param {Object} settings Settings object with title, cmd etc.
			 * @example
			 * // Adds a custom menu item to the editor that inserts contents when clicked
			 * // The context option allows you to add the menu item to an existing default menu
			 * tinymce.init({
			 *    ...
			 *
			 *    setup: function(ed) {
			 *       ed.addMenuItem('example', {
			 *          text: 'My menu item',
			 *          context: 'tools',
			 *          onclick: function() {
			 *             ed.insertContent('Hello world!!');
			 *          }
			 *       });
			 *    }
			 * });
			 */
			addMenuItem: function(name, settings) {
				var self = this;
	
				if (settings.cmd) {
					settings.onclick = function() {
						self.execCommand(settings.cmd);
					};
				}
	
				self.menuItems = self.menuItems || {};
				self.menuItems[name] = settings;
			},
	
			/**
			 * Adds a contextual toolbar to be rendered when the selector matches.
			 *
			 * @method addContextToolbar
			 * @param {function/string} predicate Predicate that needs to return true if provided strings get converted into CSS predicates.
			 * @param {String/Array} items String or array with items to add to the context toolbar.
			 */
			addContextToolbar: function(predicate, items) {
				var self = this, selector;
	
				self.contextToolbars = self.contextToolbars || [];
	
				// Convert selector to predicate
				if (typeof predicate == "string") {
					selector = predicate;
					predicate = function(elm) {
						return self.dom.is(elm, selector);
					};
				}
	
				self.contextToolbars.push({
					id: Uuid.uuid('mcet'),
					predicate: predicate,
					items: items
				});
			},
	
			/**
			 * Adds a custom command to the editor, you can also override existing commands with this method.
			 * The command that you add can be executed with execCommand.
			 *
			 * @method addCommand
			 * @param {String} name Command name to add/override.
			 * @param {addCommandCallback} callback Function to execute when the command occurs.
			 * @param {Object} scope Optional scope to execute the function in.
			 * @example
			 * // Adds a custom command that later can be executed using execCommand
			 * tinymce.init({
			 *    ...
			 *
			 *    setup: function(ed) {
			 *       // Register example command
			 *       ed.addCommand('mycommand', function(ui, v) {
			 *          ed.windowManager.alert('Hello world!! Selection: ' + ed.selection.getContent({format: 'text'}));
			 *       });
			 *    }
			 * });
			 */
			addCommand: function(name, callback, scope) {
				/**
				 * Callback function that gets called when a command is executed.
				 *
				 * @callback addCommandCallback
				 * @param {Boolean} ui Display UI state true/false.
				 * @param {Object} value Optional value for command.
				 * @return {Boolean} True/false state if the command was handled or not.
				 */
				this.editorCommands.addCommand(name, callback, scope);
			},
	
			/**
			 * Adds a custom query state command to the editor, you can also override existing commands with this method.
			 * The command that you add can be executed with queryCommandState function.
			 *
			 * @method addQueryStateHandler
			 * @param {String} name Command name to add/override.
			 * @param {addQueryStateHandlerCallback} callback Function to execute when the command state retrieval occurs.
			 * @param {Object} scope Optional scope to execute the function in.
			 */
			addQueryStateHandler: function(name, callback, scope) {
				/**
				 * Callback function that gets called when a queryCommandState is executed.
				 *
				 * @callback addQueryStateHandlerCallback
				 * @return {Boolean} True/false state if the command is enabled or not like is it bold.
				 */
				this.editorCommands.addQueryStateHandler(name, callback, scope);
			},
	
			/**
			 * Adds a custom query value command to the editor, you can also override existing commands with this method.
			 * The command that you add can be executed with queryCommandValue function.
			 *
			 * @method addQueryValueHandler
			 * @param {String} name Command name to add/override.
			 * @param {addQueryValueHandlerCallback} callback Function to execute when the command value retrieval occurs.
			 * @param {Object} scope Optional scope to execute the function in.
			 */
			addQueryValueHandler: function(name, callback, scope) {
				/**
				 * Callback function that gets called when a queryCommandValue is executed.
				 *
				 * @callback addQueryValueHandlerCallback
				 * @return {Object} Value of the command or undefined.
				 */
				this.editorCommands.addQueryValueHandler(name, callback, scope);
			},
	
			/**
			 * Adds a keyboard shortcut for some command or function.
			 *
			 * @method addShortcut
			 * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
			 * @param {String} desc Text description for the command.
			 * @param {String/Function} cmdFunc Command name string or function to execute when the key is pressed.
			 * @param {Object} sc Optional scope to execute the function in.
			 * @return {Boolean} true/false state if the shortcut was added or not.
			 */
			addShortcut: function(pattern, desc, cmdFunc, scope) {
				this.shortcuts.add(pattern, desc, cmdFunc, scope);
			},
	
			/**
			 * Executes a command on the current instance. These commands can be TinyMCE internal commands prefixed with "mce" or
			 * they can be build in browser commands such as "Bold". A compleate list of browser commands is available on MSDN or Mozilla.org.
			 * This function will dispatch the execCommand function on each plugin, theme or the execcommand_callback option if none of these
			 * return true it will handle the command as a internal browser command.
			 *
			 * @method execCommand
			 * @param {String} cmd Command name to execute, for example mceLink or Bold.
			 * @param {Boolean} ui True/false state if a UI (dialog) should be presented or not.
			 * @param {mixed} value Optional command value, this can be anything.
			 * @param {Object} args Optional arguments object.
			 */
			execCommand: function(cmd, ui, value, args) {
				return this.editorCommands.execCommand(cmd, ui, value, args);
			},
	
			/**
			 * Returns a command specific state, for example if bold is enabled or not.
			 *
			 * @method queryCommandState
			 * @param {string} cmd Command to query state from.
			 * @return {Boolean} Command specific state, for example if bold is enabled or not.
			 */
			queryCommandState: function(cmd) {
				return this.editorCommands.queryCommandState(cmd);
			},
	
			/**
			 * Returns a command specific value, for example the current font size.
			 *
			 * @method queryCommandValue
			 * @param {string} cmd Command to query value from.
			 * @return {Object} Command specific value, for example the current font size.
			 */
			queryCommandValue: function(cmd) {
				return this.editorCommands.queryCommandValue(cmd);
			},
	
			/**
			 * Returns true/false if the command is supported or not.
			 *
			 * @method queryCommandSupported
			 * @param {String} cmd Command that we check support for.
			 * @return {Boolean} true/false if the command is supported or not.
			 */
			queryCommandSupported: function(cmd) {
				return this.editorCommands.queryCommandSupported(cmd);
			},
	
			/**
			 * Shows the editor and hides any textarea/div that the editor is supposed to replace.
			 *
			 * @method show
			 */
			show: function() {
				var self = this;
	
				if (self.hidden) {
					self.hidden = false;
	
					if (self.inline) {
						self.getBody().contentEditable = true;
					} else {
						DOM.show(self.getContainer());
						DOM.hide(self.id);
					}
	
					self.load();
					self.fire('show');
				}
			},
	
			/**
			 * Hides the editor and shows any textarea/div that the editor is supposed to replace.
			 *
			 * @method hide
			 */
			hide: function() {
				var self = this, doc = self.getDoc();
	
				if (!self.hidden) {
					// Fixed bug where IE has a blinking cursor left from the editor
					if (ie && doc && !self.inline) {
						doc.execCommand('SelectAll');
					}
	
					// We must save before we hide so Safari doesn't crash
					self.save();
	
					if (self.inline) {
						self.getBody().contentEditable = false;
	
						// Make sure the editor gets blurred
						if (self == self.editorManager.focusedEditor) {
							self.editorManager.focusedEditor = null;
						}
					} else {
						DOM.hide(self.getContainer());
						DOM.setStyle(self.id, 'display', self.orgDisplay);
					}
	
					self.hidden = true;
					self.fire('hide');
				}
			},
	
			/**
			 * Returns true/false if the editor is hidden or not.
			 *
			 * @method isHidden
			 * @return {Boolean} True/false if the editor is hidden or not.
			 */
			isHidden: function() {
				return !!this.hidden;
			},
	
			/**
			 * Sets the progress state, this will display a throbber/progess for the editor.
			 * This is ideal for asynchronous operations like an AJAX save call.
			 *
			 * @method setProgressState
			 * @param {Boolean} state Boolean state if the progress should be shown or hidden.
			 * @param {Number} time Optional time to wait before the progress gets shown.
			 * @return {Boolean} Same as the input state.
			 * @example
			 * // Show progress for the active editor
			 * tinymce.activeEditor.setProgressState(true);
			 *
			 * // Hide progress for the active editor
			 * tinymce.activeEditor.setProgressState(false);
			 *
			 * // Show progress after 3 seconds
			 * tinymce.activeEditor.setProgressState(true, 3000);
			 */
			setProgressState: function(state, time) {
				this.fire('ProgressState', {state: state, time: time});
			},
	
			/**
			 * Loads contents from the textarea or div element that got converted into an editor instance.
			 * This method will move the contents from that textarea or div into the editor by using setContent
			 * so all events etc that method has will get dispatched as well.
			 *
			 * @method load
			 * @param {Object} args Optional content object, this gets passed around through the whole load process.
			 * @return {String} HTML string that got set into the editor.
			 */
			load: function(args) {
				var self = this, elm = self.getElement(), html;
	
				if (elm) {
					args = args || {};
					args.load = true;
	
					html = self.setContent(elm.value !== undefined ? elm.value : elm.innerHTML, args);
					args.element = elm;
	
					if (!args.no_events) {
						self.fire('LoadContent', args);
					}
	
					args.element = elm = null;
	
					return html;
				}
			},
	
			/**
			 * Saves the contents from a editor out to the textarea or div element that got converted into an editor instance.
			 * This method will move the HTML contents from the editor into that textarea or div by getContent
			 * so all events etc that method has will get dispatched as well.
			 *
			 * @method save
			 * @param {Object} args Optional content object, this gets passed around through the whole save process.
			 * @return {String} HTML string that got set into the textarea/div.
			 */
			save: function(args) {
				var self = this, elm = self.getElement(), html, form;
	
				if (!elm || !self.initialized) {
					return;
				}
	
				args = args || {};
				args.save = true;
	
				args.element = elm;
				html = args.content = self.getContent(args);
	
				if (!args.no_events) {
					self.fire('SaveContent', args);
				}
	
				// Always run this internal event
				if (args.format == 'raw') {
					self.fire('RawSaveContent', args);
				}
	
				html = args.content;
	
				if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
					// Update DIV element when not in inline mode
					if (!self.inline) {
						elm.innerHTML = html;
					}
	
					// Update hidden form element
					if ((form = DOM.getParent(self.id, 'form'))) {
						each(form.elements, function(elm) {
							if (elm.name == self.id) {
								elm.value = html;
								return false;
							}
						});
					}
				} else {
					elm.value = html;
				}
	
				args.element = elm = null;
	
				if (args.set_dirty !== false) {
					self.setDirty(false);
				}
	
				return html;
			},
	
			/**
			 * Sets the specified content to the editor instance, this will cleanup the content before it gets set using
			 * the different cleanup rules options.
			 *
			 * @method setContent
			 * @param {String} content Content to set to editor, normally HTML contents but can be other formats as well.
			 * @param {Object} args Optional content object, this gets passed around through the whole set process.
			 * @return {String} HTML string that got set into the editor.
			 * @example
			 * // Sets the HTML contents of the activeEditor editor
			 * tinymce.activeEditor.setContent('<span>some</span> html');
			 *
			 * // Sets the raw contents of the activeEditor editor
			 * tinymce.activeEditor.setContent('<span>some</span> html', {format: 'raw'});
			 *
			 * // Sets the content of a specific editor (my_editor in this example)
			 * tinymce.get('my_editor').setContent(data);
			 *
			 * // Sets the bbcode contents of the activeEditor editor if the bbcode plugin was added
			 * tinymce.activeEditor.setContent('[b]some[/b] html', {format: 'bbcode'});
			 */
			setContent: function(content, args) {
				var self = this, body = self.getBody(), forcedRootBlockName, padd;
	
				// Setup args object
				args = args || {};
				args.format = args.format || 'html';
				args.set = true;
				args.content = content;
	
				// Do preprocessing
				if (!args.no_events) {
					self.fire('BeforeSetContent', args);
				}
	
				content = args.content;
	
				// Padd empty content in Gecko and Safari. Commands will otherwise fail on the content
				// It will also be impossible to place the caret in the editor unless there is a BR element present
				if (content.length === 0 || /^\s+$/.test(content)) {
					padd = ie && ie < 11 ? '' : '<br data-mce-bogus="1">';
	
					// Todo: There is a lot more root elements that need special padding
					// so separate this and add all of them at some point.
					if (body.nodeName == 'TABLE') {
						content = '<tr><td>' + padd + '</td></tr>';
					} else if (/^(UL|OL)$/.test(body.nodeName)) {
						content = '<li>' + padd + '</li>';
					}
	
					forcedRootBlockName = self.settings.forced_root_block;
	
					// Check if forcedRootBlock is configured and that the block is a valid child of the body
					if (forcedRootBlockName && self.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
						// Padd with bogus BR elements on modern browsers and IE 7 and 8 since they don't render empty P tags properly
						content = padd;
						content = self.dom.createHTML(forcedRootBlockName, self.settings.forced_root_block_attrs, content);
					} else if (!ie && !content) {
						// We need to add a BR when forced_root_block is disabled on non IE browsers to place the caret
						content = '<br data-mce-bogus="1">';
					}
	
					self.dom.setHTML(body, content);
	
					self.fire('SetContent', args);
				} else {
					// Parse and serialize the html
					if (args.format !== 'raw') {
						content = new Serializer({
							validate: self.validate
						}, self.schema).serialize(
							self.parser.parse(content, {isRootContent: true})
						);
					}
	
					// Set the new cleaned contents to the editor
					args.content = trim(content);
					self.dom.setHTML(body, args.content);
	
					// Do post processing
					if (!args.no_events) {
						self.fire('SetContent', args);
					}
	
					// Don't normalize selection if the focused element isn't the body in
					// content editable mode since it will steal focus otherwise
					/*if (!self.settings.content_editable || document.activeElement === self.getBody()) {
						self.selection.normalize();
					}*/
				}
	
				return args.content;
			},
	
			/**
			 * Gets the content from the editor instance, this will cleanup the content before it gets returned using
			 * the different cleanup rules options.
			 *
			 * @method getContent
			 * @param {Object} args Optional content object, this gets passed around through the whole get process.
			 * @return {String} Cleaned content string, normally HTML contents.
			 * @example
			 * // Get the HTML contents of the currently active editor
			 * console.debug(tinymce.activeEditor.getContent());
			 *
			 * // Get the raw contents of the currently active editor
			 * tinymce.activeEditor.getContent({format: 'raw'});
			 *
			 * // Get content of a specific editor:
			 * tinymce.get('content id').getContent()
			 */
			getContent: function(args) {
				var self = this, content, body = self.getBody();
	
				// Setup args object
				args = args || {};
				args.format = args.format || 'html';
				args.get = true;
				args.getInner = true;
	
				// Do preprocessing
				if (!args.no_events) {
					self.fire('BeforeGetContent', args);
				}
	
				// Get raw contents or by default the cleaned contents
				if (args.format == 'raw') {
					content = self.serializer.getTrimmedContent();
				} else if (args.format == 'text') {
					content = body.innerText || body.textContent;
				} else {
					content = self.serializer.serialize(body, args);
				}
	
				// Trim whitespace in beginning/end of HTML
				if (args.format != 'text') {
					args.content = trim(content);
				} else {
					args.content = content;
				}
	
				// Do post processing
				if (!args.no_events) {
					self.fire('GetContent', args);
				}
	
				return args.content;
			},
	
			/**
			 * Inserts content at caret position.
			 *
			 * @method insertContent
			 * @param {String} content Content to insert.
			 * @param {Object} args Optional args to pass to insert call.
			 */
			insertContent: function(content, args) {
				if (args) {
					content = extend({content: content}, args);
				}
	
				this.execCommand('mceInsertContent', false, content);
			},
	
			/**
			 * Returns true/false if the editor is dirty or not. It will get dirty if the user has made modifications to the contents.
			 *
			 * The dirty state is automatically set to true if you do modifications to the content in other
			 * words when new undo levels is created or if you undo/redo to update the contents of the editor. It will also be set
			 * to false if you call editor.save().
			 *
			 * @method isDirty
			 * @return {Boolean} True/false if the editor is dirty or not. It will get dirty if the user has made modifications to the contents.
			 * @example
			 * if (tinymce.activeEditor.isDirty())
			 *     alert("You must save your contents.");
			 */
			isDirty: function() {
				return !this.isNotDirty;
			},
	
			/**
			 * Explicitly sets the dirty state. This will fire the dirty event if the editor dirty state is changed from false to true
			 * by invoking this method.
			 *
			 * @method setDirty
			 * @param {Boolean} state True/false if the editor is considered dirty.
			 * @example
			 * function ajaxSave() {
			 *     var editor = tinymce.get('elm1');
			 *
			 *     // Save contents using some XHR call
			 *     alert(editor.getContent());
			 *
			 *     editor.setDirty(false); // Force not dirty state
			 * }
			 */
			setDirty: function(state) {
				var oldState = !this.isNotDirty;
	
				this.isNotDirty = !state;
	
				if (state && state != oldState) {
					this.fire('dirty');
				}
			},
	
			/**
			 * Sets the editor mode. Mode can be for example "design", "code" or "readonly".
			 *
			 * @method setMode
			 * @param {String} mode Mode to set the editor in.
			 */
			setMode: function(mode) {
				Mode.setMode(this, mode);
			},
	
			/**
			 * Returns the editors container element. The container element wrappes in
			 * all the elements added to the page for the editor. Such as UI, iframe etc.
			 *
			 * @method getContainer
			 * @return {Element} HTML DOM element for the editor container.
			 */
			getContainer: function() {
				var self = this;
	
				if (!self.container) {
					self.container = DOM.get(self.editorContainer || self.id + '_parent');
				}
	
				return self.container;
			},
	
			/**
			 * Returns the editors content area container element. The this element is the one who
			 * holds the iframe or the editable element.
			 *
			 * @method getContentAreaContainer
			 * @return {Element} HTML DOM element for the editor area container.
			 */
			getContentAreaContainer: function() {
				return this.contentAreaContainer;
			},
	
			/**
			 * Returns the target element/textarea that got replaced with a TinyMCE editor instance.
			 *
			 * @method getElement
			 * @return {Element} HTML DOM element for the replaced element.
			 */
			getElement: function() {
				if (!this.targetElm) {
					this.targetElm = DOM.get(this.id);
				}
	
				return this.targetElm;
			},
	
			/**
			 * Returns the iframes window object.
			 *
			 * @method getWin
			 * @return {Window} Iframe DOM window object.
			 */
			getWin: function() {
				var self = this, elm;
	
				if (!self.contentWindow) {
					elm = self.iframeElement;
	
					if (elm) {
						self.contentWindow = elm.contentWindow;
					}
				}
	
				return self.contentWindow;
			},
	
			/**
			 * Returns the iframes document object.
			 *
			 * @method getDoc
			 * @return {Document} Iframe DOM document object.
			 */
			getDoc: function() {
				var self = this, win;
	
				if (!self.contentDocument) {
					win = self.getWin();
	
					if (win) {
						self.contentDocument = win.document;
					}
				}
	
				return self.contentDocument;
			},
	
			/**
			 * Returns the root element of the editable area.
			 * For a non-inline iframe-based editor, returns the iframe's body element.
			 *
			 * @method getBody
			 * @return {Element} The root element of the editable area.
			 */
			getBody: function() {
				var doc = this.getDoc();
				return this.bodyElement || (doc ? doc.body : null);
			},
	
			/**
			 * URL converter function this gets executed each time a user adds an img, a or
			 * any other element that has a URL in it. This will be called both by the DOM and HTML
			 * manipulation functions.
			 *
			 * @method convertURL
			 * @param {string} url URL to convert.
			 * @param {string} name Attribute name src, href etc.
			 * @param {string/HTMLElement} elm Tag name or HTML DOM element depending on HTML or DOM insert.
			 * @return {string} Converted URL string.
			 */
			convertURL: function(url, name, elm) {
				var self = this, settings = self.settings;
	
				// Use callback instead
				if (settings.urlconverter_callback) {
					return self.execCallback('urlconverter_callback', url, elm, true, name);
				}
	
				// Don't convert link href since thats the CSS files that gets loaded into the editor also skip local file URLs
				if (!settings.convert_urls || (elm && elm.nodeName == 'LINK') || url.indexOf('file:') === 0 || url.length === 0) {
					return url;
				}
	
				// Convert to relative
				if (settings.relative_urls) {
					return self.documentBaseURI.toRelative(url);
				}
	
				// Convert to absolute
				url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	
				return url;
			},
	
			/**
			 * Adds visual aid for tables, anchors etc so they can be more easily edited inside the editor.
			 *
			 * @method addVisual
			 * @param {Element} elm Optional root element to loop though to find tables etc that needs the visual aid.
			 */
			addVisual: function(elm) {
				var self = this, settings = self.settings, dom = self.dom, cls;
	
				elm = elm || self.getBody();
	
				if (self.hasVisual === undefined) {
					self.hasVisual = settings.visual;
				}
	
				each(dom.select('table,a', elm), function(elm) {
					var value;
	
					switch (elm.nodeName) {
						case 'TABLE':
							cls = settings.visual_table_class || 'mce-item-table';
							value = dom.getAttrib(elm, 'border');
	
							if ((!value || value == '0') && self.hasVisual) {
								dom.addClass(elm, cls);
							} else {
								dom.removeClass(elm, cls);
							}
	
							return;
	
						case 'A':
							if (!dom.getAttrib(elm, 'href', false)) {
								value = dom.getAttrib(elm, 'name') || elm.id;
								cls = settings.visual_anchor_class || 'mce-item-anchor';
	
								if (value && self.hasVisual) {
									dom.addClass(elm, cls);
								} else {
									dom.removeClass(elm, cls);
								}
							}
	
							return;
					}
				});
	
				self.fire('VisualAid', {element: elm, hasVisual: self.hasVisual});
			},
	
			/**
			 * Removes the editor from the dom and tinymce collection.
			 *
			 * @method remove
			 */
			remove: function() {
				var self = this;
	
				if (!self.removed) {
					self.save();
					self.removed = 1;
					self.unbindAllNativeEvents();
	
					// Remove any hidden input
					if (self.hasHiddenInput) {
						DOM.remove(self.getElement().nextSibling);
					}
	
					if (!self.inline) {
						// IE 9 has a bug where the selection stops working if you place the
						// caret inside the editor then remove the iframe
						if (ie && ie < 10) {
							self.getDoc().execCommand('SelectAll', false, null);
						}
	
						DOM.setStyle(self.id, 'display', self.orgDisplay);
						self.getBody().onload = null; // Prevent #6816
					}
	
					self.fire('remove');
	
					self.editorManager.remove(self);
					DOM.remove(self.getContainer());
					self._selectionOverrides.destroy();
					self.editorUpload.destroy();
					self.destroy();
				}
			},
	
			/**
			 * Destroys the editor instance by removing all events, element references or other resources
			 * that could leak memory. This method will be called automatically when the page is unloaded
			 * but you can also call it directly if you know what you are doing.
			 *
			 * @method destroy
			 * @param {Boolean} automatic Optional state if the destroy is an automatic destroy or user called one.
			 */
			destroy: function(automatic) {
				var self = this, form;
	
				// One time is enough
				if (self.destroyed) {
					return;
				}
	
				// If user manually calls destroy and not remove
				// Users seems to have logic that calls destroy instead of remove
				if (!automatic && !self.removed) {
					self.remove();
					return;
				}
	
				if (!automatic) {
					self.editorManager.off('beforeunload', self._beforeUnload);
	
					// Manual destroy
					if (self.theme && self.theme.destroy) {
						self.theme.destroy();
					}
	
					// Destroy controls, selection and dom
					self.selection.destroy();
					self.dom.destroy();
				}
	
				form = self.formElement;
				if (form) {
					if (form._mceOldSubmit) {
						form.submit = form._mceOldSubmit;
						form._mceOldSubmit = null;
					}
	
					DOM.unbind(form, 'submit reset', self.formEventDelegate);
				}
	
				self.contentAreaContainer = self.formElement = self.container = self.editorContainer = null;
				self.bodyElement = self.contentDocument = self.contentWindow = null;
				self.iframeElement = self.targetElm = null;
	
				if (self.selection) {
					self.selection = self.selection.win = self.selection.dom = self.selection.dom.doc = null;
				}
	
				self.destroyed = 1;
			},
	
			/**
			 * Uploads all data uri/blob uri images in the editor contents to server.
			 *
			 * @method uploadImages
			 * @param {function} callback Optional callback with images and status for each image.
			 * @return {tinymce.util.Promise} Promise instance.
			 */
			uploadImages: function(callback) {
				return this.editorUpload.uploadImages(callback);
			},
	
			// Internal functions
	
			_scanForImages: function() {
				return this.editorUpload.scanForImages();
			}
		};
	
		extend(Editor.prototype, EditorObservable);
	
		return Editor;
	});
	
	// Included from: js/tinymce/classes/util/I18n.js
	
	/**
	 * I18n.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * I18n class that handles translation of TinyMCE UI.
	 * Uses po style with csharp style parameters.
	 *
	 * @class tinymce.util.I18n
	 */
	define("tinymce/util/I18n", [], function() {
		"use strict";
	
		var data = {}, code = "en";
	
		return {
			/**
			 * Sets the current language code.
			 *
			 * @method setCode
			 * @param {String} newCode Current language code.
			 */
			setCode: function(newCode) {
				if (newCode) {
					code = newCode;
					this.rtl = this.data[newCode] ? this.data[newCode]._dir === 'rtl' : false;
				}
			},
	
			/**
			 * Returns the current language code.
			 *
			 * @method getCode
			 * @return {String} Current language code.
			 */
			getCode: function() {
				return code;
			},
	
			/**
			 * Property gets set to true if a RTL language pack was loaded.
			 *
			 * @property rtl
			 * @type Boolean
			 */
			rtl: false,
	
			/**
			 * Adds translations for a specific language code.
			 *
			 * @method add
			 * @param {String} code Language code like sv_SE.
			 * @param {Array} items Name/value array with English en_US to sv_SE.
			 */
			add: function(code, items) {
				var langData = data[code];
	
				if (!langData) {
					data[code] = langData = {};
				}
	
				for (var name in items) {
					langData[name] = items[name];
				}
	
				this.setCode(code);
			},
	
			/**
			 * Translates the specified text.
			 *
			 * It has a few formats:
			 * I18n.translate("Text");
			 * I18n.translate(["Text {0}/{1}", 0, 1]);
			 * I18n.translate({raw: "Raw string"});
			 *
			 * @method translate
			 * @param {String/Object/Array} text Text to translate.
			 * @return {String} String that got translated.
			 */
			translate: function(text) {
				var langData;
	
				langData = data[code];
				if (!langData) {
					langData = {};
				}
	
				if (typeof text == "undefined") {
					return text;
				}
	
				if (typeof text != "string" && text.raw) {
					return text.raw;
				}
	
				if (text.push) {
					var values = text.slice(1);
	
					text = (langData[text[0]] || text[0]).replace(/\{([0-9]+)\}/g, function(match1, match2) {
						return values[match2];
					});
				}
	
				return (langData[text] || text).replace(/{context:\w+}$/, '');
			},
	
			data: data
		};
	});
	
	// Included from: js/tinymce/classes/FocusManager.js
	
	/**
	 * FocusManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class manages the focus/blur state of the editor. This class is needed since some
	 * browsers fire false focus/blur states when the selection is moved to a UI dialog or similar.
	 *
	 * This class will fire two events focus and blur on the editor instances that got affected.
	 * It will also handle the restore of selection when the focus is lost and returned.
	 *
	 * @class tinymce.FocusManager
	 */
	define("tinymce/FocusManager", [
		"tinymce/dom/DOMUtils",
		"tinymce/util/Delay",
		"tinymce/Env"
	], function(DOMUtils, Delay, Env) {
		var selectionChangeHandler, documentFocusInHandler, documentMouseUpHandler, DOM = DOMUtils.DOM;
	
		/**
		 * Constructs a new focus manager instance.
		 *
		 * @constructor FocusManager
		 * @param {tinymce.EditorManager} editorManager Editor manager instance to handle focus for.
		 */
		function FocusManager(editorManager) {
			function getActiveElement() {
				try {
					return document.activeElement;
				} catch (ex) {
					// IE sometimes fails to get the activeElement when resizing table
					// TODO: Investigate this
					return document.body;
				}
			}
	
			// We can't store a real range on IE 11 since it gets mutated so we need to use a bookmark object
			// TODO: Move this to a separate range utils class since it's it's logic is present in Selection as well.
			function createBookmark(dom, rng) {
				if (rng && rng.startContainer) {
					// Verify that the range is within the root of the editor
					if (!dom.isChildOf(rng.startContainer, dom.getRoot()) || !dom.isChildOf(rng.endContainer, dom.getRoot())) {
						return;
					}
	
					return {
						startContainer: rng.startContainer,
						startOffset: rng.startOffset,
						endContainer: rng.endContainer,
						endOffset: rng.endOffset
					};
				}
	
				return rng;
			}
	
			function bookmarkToRng(editor, bookmark) {
				var rng;
	
				if (bookmark.startContainer) {
					rng = editor.getDoc().createRange();
					rng.setStart(bookmark.startContainer, bookmark.startOffset);
					rng.setEnd(bookmark.endContainer, bookmark.endOffset);
				} else {
					rng = bookmark;
				}
	
				return rng;
			}
	
			function isUIElement(elm) {
				return !!DOM.getParent(elm, FocusManager.isEditorUIElement);
			}
	
			function registerEvents(e) {
				var editor = e.editor;
	
				editor.on('init', function() {
					// Gecko/WebKit has ghost selections in iframes and IE only has one selection per browser tab
					if (editor.inline || Env.ie) {
						// Use the onbeforedeactivate event when available since it works better see #7023
						if ("onbeforedeactivate" in document && Env.ie < 9) {
							editor.dom.bind(editor.getBody(), 'beforedeactivate', function(e) {
								if (e.target != editor.getBody()) {
									return;
								}
	
								try {
									editor.lastRng = editor.selection.getRng();
								} catch (ex) {
									// IE throws "Unexcpected call to method or property access" some times so lets ignore it
								}
							});
						} else {
							// On other browsers take snapshot on nodechange in inline mode since they have Ghost selections for iframes
							editor.on('nodechange mouseup keyup', function(e) {
								var node = getActiveElement();
	
								// Only act on manual nodechanges
								if (e.type == 'nodechange' && e.selectionChange) {
									return;
								}
	
								// IE 11 reports active element as iframe not body of iframe
								if (node && node.id == editor.id + '_ifr') {
									node = editor.getBody();
								}
	
								if (editor.dom.isChildOf(node, editor.getBody())) {
									editor.lastRng = editor.selection.getRng();
								}
							});
						}
	
						// Handles the issue with WebKit not retaining selection within inline document
						// If the user releases the mouse out side the body since a mouse up event wont occur on the body
						if (Env.webkit && !selectionChangeHandler) {
							selectionChangeHandler = function() {
								var activeEditor = editorManager.activeEditor;
	
								if (activeEditor && activeEditor.selection) {
									var rng = activeEditor.selection.getRng();
	
									// Store when it's non collapsed
									if (rng && !rng.collapsed) {
										editor.lastRng = rng;
									}
								}
							};
	
							DOM.bind(document, 'selectionchange', selectionChangeHandler);
						}
					}
				});
	
				editor.on('setcontent', function() {
					editor.lastRng = null;
				});
	
				// Remove last selection bookmark on mousedown see #6305
				editor.on('mousedown', function() {
					editor.selection.lastFocusBookmark = null;
				});
	
				editor.on('focusin', function() {
					var focusedEditor = editorManager.focusedEditor, lastRng;
	
					if (editor.selection.lastFocusBookmark) {
						lastRng = bookmarkToRng(editor, editor.selection.lastFocusBookmark);
						editor.selection.lastFocusBookmark = null;
						editor.selection.setRng(lastRng);
					}
	
					if (focusedEditor != editor) {
						if (focusedEditor) {
							focusedEditor.fire('blur', {focusedEditor: editor});
						}
	
						editorManager.setActive(editor);
						editorManager.focusedEditor = editor;
						editor.fire('focus', {blurredEditor: focusedEditor});
						editor.focus(true);
					}
	
					editor.lastRng = null;
				});
	
				editor.on('focusout', function() {
					Delay.setEditorTimeout(editor, function() {
						var focusedEditor = editorManager.focusedEditor;
	
						// Still the same editor the blur was outside any editor UI
						if (!isUIElement(getActiveElement()) && focusedEditor == editor) {
							editor.fire('blur', {focusedEditor: null});
							editorManager.focusedEditor = null;
	
							// Make sure selection is valid could be invalid if the editor is blured and removed before the timeout occurs
							if (editor.selection) {
								editor.selection.lastFocusBookmark = null;
							}
						}
					});
				});
	
				// Check if focus is moved to an element outside the active editor by checking if the target node
				// isn't within the body of the activeEditor nor a UI element such as a dialog child control
				if (!documentFocusInHandler) {
					documentFocusInHandler = function(e) {
						var activeEditor = editorManager.activeEditor, target;
	
						target = e.target;
	
						if (activeEditor && target.ownerDocument == document) {
							// Check to make sure we have a valid selection don't update the bookmark if it's
							// a focusin to the body of the editor see #7025
							if (activeEditor.selection && target != activeEditor.getBody()) {
								activeEditor.selection.lastFocusBookmark = createBookmark(activeEditor.dom, activeEditor.lastRng);
							}
	
							// Fire a blur event if the element isn't a UI element
							if (target != document.body && !isUIElement(target) && editorManager.focusedEditor == activeEditor) {
								activeEditor.fire('blur', {focusedEditor: null});
								editorManager.focusedEditor = null;
							}
						}
					};
	
					DOM.bind(document, 'focusin', documentFocusInHandler);
				}
	
				// Handle edge case when user starts the selection inside the editor and releases
				// the mouse outside the editor producing a new selection. This weird workaround is needed since
				// Gecko doesn't have the "selectionchange" event we need to do this. Fixes: #6843
				if (editor.inline && !documentMouseUpHandler) {
					documentMouseUpHandler = function(e) {
						var activeEditor = editorManager.activeEditor, dom = activeEditor.dom;
	
						if (activeEditor.inline && dom && !dom.isChildOf(e.target, activeEditor.getBody())) {
							var rng = activeEditor.selection.getRng();
	
							if (!rng.collapsed) {
								activeEditor.lastRng = rng;
							}
						}
					};
	
					DOM.bind(document, 'mouseup', documentMouseUpHandler);
				}
			}
	
			function unregisterDocumentEvents(e) {
				if (editorManager.focusedEditor == e.editor) {
					editorManager.focusedEditor = null;
				}
	
				if (!editorManager.activeEditor) {
					DOM.unbind(document, 'selectionchange', selectionChangeHandler);
					DOM.unbind(document, 'focusin', documentFocusInHandler);
					DOM.unbind(document, 'mouseup', documentMouseUpHandler);
					selectionChangeHandler = documentFocusInHandler = documentMouseUpHandler = null;
				}
			}
	
			editorManager.on('AddEditor', registerEvents);
			editorManager.on('RemoveEditor', unregisterDocumentEvents);
		}
	
		/**
		 * Returns true if the specified element is part of the UI for example an button or text input.
		 *
		 * @method isEditorUIElement
		 * @param  {Element} elm Element to check if it's part of the UI or not.
		 * @return {Boolean} True/false state if the element is part of the UI or not.
		 */
		FocusManager.isEditorUIElement = function(elm) {
			// Needs to be converted to string since svg can have focus: #6776
			return elm.className.toString().indexOf('mce-') !== -1;
		};
	
		return FocusManager;
	});
	
	// Included from: js/tinymce/classes/EditorManager.js
	
	/**
	 * EditorManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class used as a factory for manager for tinymce.Editor instances.
	 *
	 * @example
	 * tinymce.EditorManager.init({});
	 *
	 * @class tinymce.EditorManager
	 * @mixes tinymce.util.Observable
	 * @static
	 */
	define("tinymce/EditorManager", [
		"tinymce/Editor",
		"tinymce/dom/DomQuery",
		"tinymce/dom/DOMUtils",
		"tinymce/util/URI",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/util/Promise",
		"tinymce/util/Observable",
		"tinymce/util/I18n",
		"tinymce/FocusManager"
	], function(Editor, $, DOMUtils, URI, Env, Tools, Promise, Observable, I18n, FocusManager) {
		var DOM = DOMUtils.DOM;
		var explode = Tools.explode, each = Tools.each, extend = Tools.extend;
		var instanceCounter = 0, beforeUnloadDelegate, EditorManager, boundGlobalEvents = false;
	
		function globalEventDelegate(e) {
			each(EditorManager.editors, function(editor) {
				if (e.type === 'scroll') {
					editor.fire('ScrollWindow', e);
				} else {
					editor.fire('ResizeWindow', e);
				}
			});
		}
	
		function toggleGlobalEvents(editors, state) {
			if (state !== boundGlobalEvents) {
				if (state) {
					$(window).on('resize scroll', globalEventDelegate);
				} else {
					$(window).off('resize scroll', globalEventDelegate);
				}
	
				boundGlobalEvents = state;
			}
		}
	
		function removeEditorFromList(editor) {
			var editors = EditorManager.editors, removedFromList;
	
			delete editors[editor.id];
	
			for (var i = 0; i < editors.length; i++) {
				if (editors[i] == editor) {
					editors.splice(i, 1);
					removedFromList = true;
					break;
				}
			}
	
			// Select another editor since the active one was removed
			if (EditorManager.activeEditor == editor) {
				EditorManager.activeEditor = editors[0];
			}
	
			// Clear focusedEditor if necessary, so that we don't try to blur the destroyed editor
			if (EditorManager.focusedEditor == editor) {
				EditorManager.focusedEditor = null;
			}
	
			return removedFromList;
		}
	
		function purgeDestroyedEditor(editor) {
			// User has manually destroyed the editor lets clean up the mess
			if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
				removeEditorFromList(editor);
				editor.unbindAllNativeEvents();
				editor.destroy(true);
				editor.removed = true;
				editor = null;
			}
	
			return editor;
		}
	
		EditorManager = {
			/**
			 * Dom query instance.
			 *
			 * @property $
			 * @type tinymce.dom.DomQuery
			 */
			$: $,
	
			/**
			 * Major version of TinyMCE build.
			 *
			 * @property majorVersion
			 * @type String
			 */
			majorVersion: '4',
	
			/**
			 * Minor version of TinyMCE build.
			 *
			 * @property minorVersion
			 * @type String
			 */
			minorVersion: '4.3',
	
			/**
			 * Release date of TinyMCE build.
			 *
			 * @property releaseDate
			 * @type String
			 */
			releaseDate: '2016-09-01',
	
			/**
			 * Collection of editor instances.
			 *
			 * @property editors
			 * @type Object
			 * @example
			 * for (edId in tinymce.editors)
			 *     tinymce.editors[edId].save();
			 */
			editors: [],
	
			/**
			 * Collection of language pack data.
			 *
			 * @property i18n
			 * @type Object
			 */
			i18n: I18n,
	
			/**
			 * Currently active editor instance.
			 *
			 * @property activeEditor
			 * @type tinymce.Editor
			 * @example
			 * tinyMCE.activeEditor.selection.getContent();
			 * tinymce.EditorManager.activeEditor.selection.getContent();
			 */
			activeEditor: null,
	
			setup: function() {
				var self = this, baseURL, documentBaseURL, suffix = "", preInit, src;
	
				// Get base URL for the current document
				documentBaseURL = URI.getDocumentBaseUrl(document.location);
	
				// Check if the URL is a document based format like: http://site/dir/file and file:///
				// leave other formats like applewebdata://... intact
				if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
					documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	
					if (!/[\/\\]$/.test(documentBaseURL)) {
						documentBaseURL += '/';
					}
				}
	
				// If tinymce is defined and has a base use that or use the old tinyMCEPreInit
				preInit = window.tinymce || window.tinyMCEPreInit;
				if (preInit) {
					baseURL = preInit.base || preInit.baseURL;
					suffix = preInit.suffix;
				} else {
					// Get base where the tinymce script is located
					var scripts = document.getElementsByTagName('script');
					for (var i = 0; i < scripts.length; i++) {
						src = scripts[i].src;
	
						// Script types supported:
						// tinymce.js tinymce.min.js tinymce.dev.js
						// tinymce.jquery.js tinymce.jquery.min.js tinymce.jquery.dev.js
						// tinymce.full.js tinymce.full.min.js tinymce.full.dev.js
						var srcScript = src.substring(src.lastIndexOf('/'));
						if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
							if (srcScript.indexOf('.min') != -1) {
								suffix = '.min';
							}
	
							baseURL = src.substring(0, src.lastIndexOf('/'));
							break;
						}
					}
	
					// We didn't find any baseURL by looking at the script elements
					// Try to use the document.currentScript as a fallback
					if (!baseURL && document.currentScript) {
						src = document.currentScript.src;
	
						if (src.indexOf('.min') != -1) {
							suffix = '.min';
						}
	
						baseURL = src.substring(0, src.lastIndexOf('/'));
					}
				}
	
				/**
				 * Base URL where the root directory if TinyMCE is located.
				 *
				 * @property baseURL
				 * @type String
				 */
				self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	
				/**
				 * Document base URL where the current document is located.
				 *
				 * @property documentBaseURL
				 * @type String
				 */
				self.documentBaseURL = documentBaseURL;
	
				/**
				 * Absolute baseURI for the installation path of TinyMCE.
				 *
				 * @property baseURI
				 * @type tinymce.util.URI
				 */
				self.baseURI = new URI(self.baseURL);
	
				/**
				 * Current suffix to add to each plugin/theme that gets loaded for example ".min".
				 *
				 * @property suffix
				 * @type String
				 */
				self.suffix = suffix;
	
				self.focusManager = new FocusManager(self);
			},
	
			/**
			 * Overrides the default settings for editor instances.
			 *
			 * @method overrideDefaults
			 * @param {Object} defaultSettings Defaults settings object.
			 */
			overrideDefaults: function(defaultSettings) {
				var baseUrl, suffix;
	
				baseUrl = defaultSettings.base_url;
				if (baseUrl) {
					this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
					this.baseURI = new URI(this.baseURL);
				}
	
				suffix = defaultSettings.suffix;
				if (defaultSettings.suffix) {
					this.suffix = suffix;
				}
	
				this.defaultSettings = defaultSettings;
			},
	
			/**
			 * Initializes a set of editors. This method will create editors based on various settings.
			 *
			 * @method init
			 * @param {Object} settings Settings object to be passed to each editor instance.
			 * @return {tinymce.util.Promise} Promise that gets resolved with an array of editors when all editor instances are initialized.
			 * @example
			 * // Initializes a editor using the longer method
			 * tinymce.EditorManager.init({
			 *    some_settings : 'some value'
			 * });
			 *
			 * // Initializes a editor instance using the shorter version and with a promise
			 * tinymce.init({
			 *    some_settings : 'some value'
			 * }).then(function(editors) {
			 *    ...
			 * });
			 */
			init: function(settings) {
				var self = this, result, invalidInlineTargets;
	
				invalidInlineTargets = Tools.makeMap(
					'area base basefont br col frame hr img input isindex link meta param embed source wbr track ' +
					'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu',
					' '
				);
	
				function isInvalidInlineTarget(settings, elm) {
					return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
				}
	
				function report(msg, elm) {
					// Log in a non test environment
					if (window.console && !window.test) {
						window.console.log(msg, elm);
					}
				}
	
				function createId(elm) {
					var id = elm.id;
	
					// Use element id, or unique name or generate a unique id
					if (!id) {
						id = elm.name;
	
						if (id && !DOM.get(id)) {
							id = elm.name;
						} else {
							// Generate unique name
							id = DOM.uniqueId();
						}
	
						elm.setAttribute('id', id);
					}
	
					return id;
				}
	
				function execCallback(name) {
					var callback = settings[name];
	
					if (!callback) {
						return;
					}
	
					return callback.apply(self, Array.prototype.slice.call(arguments, 2));
				}
	
				function hasClass(elm, className) {
					return className.constructor === RegExp ? className.test(elm.className) : DOM.hasClass(elm, className);
				}
	
				function findTargets(settings) {
					var l, targets = [];
	
					if (settings.types) {
						each(settings.types, function(type) {
							targets = targets.concat(DOM.select(type.selector));
						});
	
						return targets;
					} else if (settings.selector) {
						return DOM.select(settings.selector);
					} else if (settings.target) {
						return [settings.target];
					}
	
					// Fallback to old setting
					switch (settings.mode) {
						case "exact":
							l = settings.elements || '';
	
							if (l.length > 0) {
								each(explode(l), function(id) {
									var elm;
	
									if ((elm = DOM.get(id))) {
										targets.push(elm);
									} else {
										each(document.forms, function(f) {
											each(f.elements, function(e) {
												if (e.name === id) {
													id = 'mce_editor_' + instanceCounter++;
													DOM.setAttrib(e, 'id', id);
													targets.push(e);
												}
											});
										});
									}
								});
							}
							break;
	
						case "textareas":
						case "specific_textareas":
							each(DOM.select('textarea'), function(elm) {
								if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
									return;
								}
	
								if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
									targets.push(elm);
								}
							});
							break;
					}
	
					return targets;
				}
	
				var provideResults = function(editors) {
					result = editors;
				};
	
				function initEditors() {
					var initCount = 0, editors = [], targets;
	
					function createEditor(id, settings, targetElm) {
						var editor = new Editor(id, settings, self);
	
						editors.push(editor);
	
						editor.on('init', function() {
							if (++initCount === targets.length) {
								provideResults(editors);
							}
						});
	
						editor.targetElm = editor.targetElm || targetElm;
						editor.render();
					}
	
					DOM.unbind(window, 'ready', initEditors);
					execCallback('onpageload');
	
					targets = $.unique(findTargets(settings));
	
					// TODO: Deprecate this one
					if (settings.types) {
						each(settings.types, function(type) {
							Tools.each(targets, function(elm) {
								if (DOM.is(elm, type.selector)) {
									createEditor(createId(elm), extend({}, settings, type), elm);
									return false;
								}
	
								return true;
							});
						});
	
						return;
					}
	
					Tools.each(targets, function(elm) {
						purgeDestroyedEditor(self.get(elm.id));
					});
	
					targets = Tools.grep(targets, function(elm) {
						return !self.get(elm.id);
					});
	
					each(targets, function(elm) {
						if (isInvalidInlineTarget(settings, elm)) {
							report('Could not initialize inline editor on invalid inline target element', elm);
						} else {
							createEditor(createId(elm), settings, elm);
						}
					});
				}
	
				self.settings = settings;
				DOM.bind(window, 'ready', initEditors);
	
				return new Promise(function(resolve) {
					if (result) {
						resolve(result);
					} else {
						provideResults = function(editors) {
							resolve(editors);
						};
					}
				});
			},
	
			/**
			 * Returns a editor instance by id.
			 *
			 * @method get
			 * @param {String/Number} id Editor instance id or index to return.
			 * @return {tinymce.Editor} Editor instance to return.
			 * @example
			 * // Adds an onclick event to an editor by id (shorter version)
			 * tinymce.get('mytextbox').on('click', function(e) {
			 *    ed.windowManager.alert('Hello world!');
			 * });
			 *
			 * // Adds an onclick event to an editor by id (longer version)
			 * tinymce.EditorManager.get('mytextbox').on('click', function(e) {
			 *    ed.windowManager.alert('Hello world!');
			 * });
			 */
			get: function(id) {
				if (!arguments.length) {
					return this.editors;
				}
	
				return id in this.editors ? this.editors[id] : null;
			},
	
			/**
			 * Adds an editor instance to the editor collection. This will also set it as the active editor.
			 *
			 * @method add
			 * @param {tinymce.Editor} editor Editor instance to add to the collection.
			 * @return {tinymce.Editor} The same instance that got passed in.
			 */
			add: function(editor) {
				var self = this, editors = self.editors;
	
				// Add named and index editor instance
				editors[editor.id] = editor;
				editors.push(editor);
	
				toggleGlobalEvents(editors, true);
	
				// Doesn't call setActive method since we don't want
				// to fire a bunch of activate/deactivate calls while initializing
				self.activeEditor = editor;
	
				/**
				 * Fires when an editor is added to the EditorManager collection.
				 *
				 * @event AddEditor
				 * @param {Object} e Event arguments.
				 */
				self.fire('AddEditor', {editor: editor});
	
				if (!beforeUnloadDelegate) {
					beforeUnloadDelegate = function() {
						self.fire('BeforeUnload');
					};
	
					DOM.bind(window, 'beforeunload', beforeUnloadDelegate);
				}
	
				return editor;
			},
	
			/**
			 * Creates an editor instance and adds it to the EditorManager collection.
			 *
			 * @method createEditor
			 * @param {String} id Instance id to use for editor.
			 * @param {Object} settings Editor instance settings.
			 * @return {tinymce.Editor} Editor instance that got created.
			 */
			createEditor: function(id, settings) {
				return this.add(new Editor(id, settings, this));
			},
	
			/**
			 * Removes a editor or editors form page.
			 *
			 * @example
			 * // Remove all editors bound to divs
			 * tinymce.remove('div');
			 *
			 * // Remove all editors bound to textareas
			 * tinymce.remove('textarea');
			 *
			 * // Remove all editors
			 * tinymce.remove();
			 *
			 * // Remove specific instance by id
			 * tinymce.remove('#id');
			 *
			 * @method remove
			 * @param {tinymce.Editor/String/Object} [selector] CSS selector or editor instance to remove.
			 * @return {tinymce.Editor} The editor that got passed in will be return if it was found otherwise null.
			 */
			remove: function(selector) {
				var self = this, i, editors = self.editors, editor;
	
				// Remove all editors
				if (!selector) {
					for (i = editors.length - 1; i >= 0; i--) {
						self.remove(editors[i]);
					}
	
					return;
				}
	
				// Remove editors by selector
				if (typeof selector == "string") {
					selector = selector.selector || selector;
	
					each(DOM.select(selector), function(elm) {
						editor = editors[elm.id];
	
						if (editor) {
							self.remove(editor);
						}
					});
	
					return;
				}
	
				// Remove specific editor
				editor = selector;
	
				// Not in the collection
				if (!editors[editor.id]) {
					return null;
				}
	
				/**
				 * Fires when an editor is removed from EditorManager collection.
				 *
				 * @event RemoveEditor
				 * @param {Object} e Event arguments.
				 */
				if (removeEditorFromList(editor)) {
					self.fire('RemoveEditor', {editor: editor});
				}
	
				if (!editors.length) {
					DOM.unbind(window, 'beforeunload', beforeUnloadDelegate);
				}
	
				editor.remove();
	
				toggleGlobalEvents(editors, editors.length > 0);
	
				return editor;
			},
	
			/**
			 * Executes a specific command on the currently active editor.
			 *
			 * @method execCommand
			 * @param {String} cmd Command to perform for example Bold.
			 * @param {Boolean} ui Optional boolean state if a UI should be presented for the command or not.
			 * @param {String} value Optional value parameter like for example an URL to a link.
			 * @return {Boolean} true/false if the command was executed or not.
			 */
			execCommand: function(cmd, ui, value) {
				var self = this, editor = self.get(value);
	
				// Manager commands
				switch (cmd) {
					case "mceAddEditor":
						if (!self.get(value)) {
							new Editor(value, self.settings, self).render();
						}
	
						return true;
	
					case "mceRemoveEditor":
						if (editor) {
							editor.remove();
						}
	
						return true;
	
					case 'mceToggleEditor':
						if (!editor) {
							self.execCommand('mceAddEditor', 0, value);
							return true;
						}
	
						if (editor.isHidden()) {
							editor.show();
						} else {
							editor.hide();
						}
	
						return true;
				}
	
				// Run command on active editor
				if (self.activeEditor) {
					return self.activeEditor.execCommand(cmd, ui, value);
				}
	
				return false;
			},
	
			/**
			 * Calls the save method on all editor instances in the collection. This can be useful when a form is to be submitted.
			 *
			 * @method triggerSave
			 * @example
			 * // Saves all contents
			 * tinyMCE.triggerSave();
			 */
			triggerSave: function() {
				each(this.editors, function(editor) {
					editor.save();
				});
			},
	
			/**
			 * Adds a language pack, this gets called by the loaded language files like en.js.
			 *
			 * @method addI18n
			 * @param {String} code Optional language code.
			 * @param {Object} items Name/value object with translations.
			 */
			addI18n: function(code, items) {
				I18n.add(code, items);
			},
	
			/**
			 * Translates the specified string using the language pack items.
			 *
			 * @method translate
			 * @param {String/Array/Object} text String to translate
			 * @return {String} Translated string.
			 */
			translate: function(text) {
				return I18n.translate(text);
			},
	
			/**
			 * Sets the active editor instance and fires the deactivate/activate events.
			 *
			 * @method setActive
			 * @param {tinymce.Editor} editor Editor instance to set as the active instance.
			 */
			setActive: function(editor) {
				var activeEditor = this.activeEditor;
	
				if (this.activeEditor != editor) {
					if (activeEditor) {
						activeEditor.fire('deactivate', {relatedTarget: editor});
					}
	
					editor.fire('activate', {relatedTarget: activeEditor});
				}
	
				this.activeEditor = editor;
			}
		};
	
		extend(EditorManager, Observable);
	
		EditorManager.setup();
	
		// Export EditorManager as tinymce/tinymce in global namespace
		window.tinymce = window.tinyMCE = EditorManager;
	
		return EditorManager;
	});
	
	// Included from: js/tinymce/classes/LegacyInput.js
	
	/**
	 * LegacyInput.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Converts legacy input to modern HTML.
	 *
	 * @class tinymce.LegacyInput
	 * @private
	 */
	define("tinymce/LegacyInput", [
		"tinymce/EditorManager",
		"tinymce/util/Tools"
	], function(EditorManager, Tools) {
		var each = Tools.each, explode = Tools.explode;
	
		EditorManager.on('AddEditor', function(e) {
			var editor = e.editor;
	
			editor.on('preInit', function() {
				var filters, fontSizes, dom, settings = editor.settings;
	
				function replaceWithSpan(node, styles) {
					each(styles, function(value, name) {
						if (value) {
							dom.setStyle(node, name, value);
						}
					});
	
					dom.rename(node, 'span');
				}
	
				function convert(e) {
					dom = editor.dom;
	
					if (settings.convert_fonts_to_spans) {
						each(dom.select('font,u,strike', e.node), function(node) {
							filters[node.nodeName.toLowerCase()](dom, node);
						});
					}
				}
	
				if (settings.inline_styles) {
					fontSizes = explode(settings.font_size_legacy_values);
	
					filters = {
						font: function(dom, node) {
							replaceWithSpan(node, {
								backgroundColor: node.style.backgroundColor,
								color: node.color,
								fontFamily: node.face,
								fontSize: fontSizes[parseInt(node.size, 10) - 1]
							});
						},
	
						u: function(dom, node) {
							// HTML5 allows U element
							if (editor.settings.schema === "html4") {
								replaceWithSpan(node, {
									textDecoration: 'underline'
								});
							}
						},
	
						strike: function(dom, node) {
							replaceWithSpan(node, {
								textDecoration: 'line-through'
							});
						}
					};
	
					editor.on('PreProcess SetContent', convert);
				}
			});
		});
	});
	
	// Included from: js/tinymce/classes/util/XHR.js
	
	/**
	 * XHR.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to send XMLHTTPRequests cross browser.
	 * @class tinymce.util.XHR
	 * @mixes tinymce.util.Observable
	 * @static
	 * @example
	 * // Sends a low level Ajax request
	 * tinymce.util.XHR.send({
	 *    url: 'someurl',
	 *    success: function(text) {
	 *       console.debug(text);
	 *    }
	 * });
	 *
	 * // Add custom header to XHR request
	 * tinymce.util.XHR.on('beforeSend', function(e) {
	 *     e.xhr.setRequestHeader('X-Requested-With', 'Something');
	 * });
	 */
	define("tinymce/util/XHR", [
		"tinymce/util/Observable",
		"tinymce/util/Tools"
	], function(Observable, Tools) {
		var XHR = {
			/**
			 * Sends a XMLHTTPRequest.
			 * Consult the Wiki for details on what settings this method takes.
			 *
			 * @method send
			 * @param {Object} settings Object will target URL, callbacks and other info needed to make the request.
			 */
			send: function(settings) {
				var xhr, count = 0;
	
				function ready() {
					if (!settings.async || xhr.readyState == 4 || count++ > 10000) {
						if (settings.success && count < 10000 && xhr.status == 200) {
							settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
						} else if (settings.error) {
							settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
						}
	
						xhr = null;
					} else {
						setTimeout(ready, 10);
					}
				}
	
				// Default settings
				settings.scope = settings.scope || this;
				settings.success_scope = settings.success_scope || settings.scope;
				settings.error_scope = settings.error_scope || settings.scope;
				settings.async = settings.async === false ? false : true;
				settings.data = settings.data || '';
	
				XHR.fire('beforeInitialize', {settings: settings});
	
				xhr = new XMLHttpRequest();
	
				if (xhr) {
					if (xhr.overrideMimeType) {
						xhr.overrideMimeType(settings.content_type);
					}
	
					xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	
					if (settings.crossDomain) {
						xhr.withCredentials = true;
					}
	
					if (settings.content_type) {
						xhr.setRequestHeader('Content-Type', settings.content_type);
					}
	
					if (settings.requestheaders) {
						Tools.each(settings.requestheaders, function(header) {
							xhr.setRequestHeader(header.key, header.value);
						});
					}
	
					xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
					xhr = XHR.fire('beforeSend', {xhr: xhr, settings: settings}).xhr;
					xhr.send(settings.data);
	
					// Syncronous request
					if (!settings.async) {
						return ready();
					}
	
					// Wait for response, onReadyStateChange can not be used since it leaks memory in IE
					setTimeout(ready, 10);
				}
			}
		};
	
		Tools.extend(XHR, Observable);
	
		return XHR;
	});
	
	// Included from: js/tinymce/classes/util/JSON.js
	
	/**
	 * JSON.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * JSON parser and serializer class.
	 *
	 * @class tinymce.util.JSON
	 * @static
	 * @example
	 * // JSON parse a string into an object
	 * var obj = tinymce.util.JSON.parse(somestring);
	 *
	 * // JSON serialize a object into an string
	 * var str = tinymce.util.JSON.serialize(obj);
	 */
	define("tinymce/util/JSON", [], function() {
		function serialize(o, quote) {
			var i, v, t, name;
	
			quote = quote || '"';
	
			if (o === null) {
				return 'null';
			}
	
			t = typeof o;
	
			if (t == 'string') {
				v = '\bb\tt\nn\ff\rr\""\'\'\\\\';
	
				/*eslint no-control-regex:0 */
				return quote + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function(a, b) {
					// Make sure single quotes never get encoded inside double quotes for JSON compatibility
					if (quote === '"' && a === "'") {
						return a;
					}
	
					i = v.indexOf(b);
	
					if (i + 1) {
						return '\\' + v.charAt(i + 1);
					}
	
					a = b.charCodeAt().toString(16);
	
					return '\\u' + '0000'.substring(a.length) + a;
				}) + quote;
			}
	
			if (t == 'object') {
				if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
					for (i = 0, v = '['; i < o.length; i++) {
						v += (i > 0 ? ',' : '') + serialize(o[i], quote);
					}
	
					return v + ']';
				}
	
				v = '{';
	
				for (name in o) {
					if (o.hasOwnProperty(name)) {
						v += typeof o[name] != 'function' ? (v.length > 1 ? ',' + quote : quote) + name +
							quote + ':' + serialize(o[name], quote) : '';
					}
				}
	
				return v + '}';
			}
	
			return '' + o;
		}
	
		return {
			/**
			 * Serializes the specified object as a JSON string.
			 *
			 * @method serialize
			 * @param {Object} obj Object to serialize as a JSON string.
			 * @param {String} quote Optional quote string defaults to ".
			 * @return {string} JSON string serialized from input.
			 */
			serialize: serialize,
	
			/**
			 * Unserializes/parses the specified JSON string into a object.
			 *
			 * @method parse
			 * @param {string} s JSON String to parse into a JavaScript object.
			 * @return {Object} Object from input JSON string or undefined if it failed.
			 */
			parse: function(text) {
				try {
					// Trick uglify JS
					return window[String.fromCharCode(101) + 'val']('(' + text + ')');
				} catch (ex) {
					// Ignore
				}
			}
	
			/**#@-*/
		};
	});
	
	// Included from: js/tinymce/classes/util/JSONRequest.js
	
	/**
	 * JSONRequest.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to use JSON-RPC to call backend methods.
	 *
	 * @class tinymce.util.JSONRequest
	 * @example
	 * var json = new tinymce.util.JSONRequest({
	 *     url: 'somebackend.php'
	 * });
	 *
	 * // Send RPC call 1
	 * json.send({
	 *     method: 'someMethod1',
	 *     params: ['a', 'b'],
	 *     success: function(result) {
	 *         console.dir(result);
	 *     }
	 * });
	 *
	 * // Send RPC call 2
	 * json.send({
	 *     method: 'someMethod2',
	 *     params: ['a', 'b'],
	 *     success: function(result) {
	 *         console.dir(result);
	 *     }
	 * });
	 */
	define("tinymce/util/JSONRequest", [
		"tinymce/util/JSON",
		"tinymce/util/XHR",
		"tinymce/util/Tools"
	], function(JSON, XHR, Tools) {
		var extend = Tools.extend;
	
		function JSONRequest(settings) {
			this.settings = extend({}, settings);
			this.count = 0;
		}
	
		/**
		 * Simple helper function to send a JSON-RPC request without the need to initialize an object.
		 * Consult the Wiki API documentation for more details on what you can pass to this function.
		 *
		 * @method sendRPC
		 * @static
		 * @param {Object} o Call object where there are three field id, method and params this object should also contain callbacks etc.
		 */
		JSONRequest.sendRPC = function(o) {
			return new JSONRequest().send(o);
		};
	
		JSONRequest.prototype = {
			/**
			 * Sends a JSON-RPC call. Consult the Wiki API documentation for more details on what you can pass to this function.
			 *
			 * @method send
			 * @param {Object} args Call object where there are three field id, method and params this object should also contain callbacks etc.
			 */
			send: function(args) {
				var ecb = args.error, scb = args.success;
	
				args = extend(this.settings, args);
	
				args.success = function(c, x) {
					c = JSON.parse(c);
	
					if (typeof c == 'undefined') {
						c = {
							error: 'JSON Parse error.'
						};
					}
	
					if (c.error) {
						ecb.call(args.error_scope || args.scope, c.error, x);
					} else {
						scb.call(args.success_scope || args.scope, c.result);
					}
				};
	
				args.error = function(ty, x) {
					if (ecb) {
						ecb.call(args.error_scope || args.scope, ty, x);
					}
				};
	
				args.data = JSON.serialize({
					id: args.id || 'c' + (this.count++),
					method: args.method,
					params: args.params
				});
	
				// JSON content type for Ruby on rails. Bug: #1883287
				args.content_type = 'application/json';
	
				XHR.send(args);
			}
		};
	
		return JSONRequest;
	});
	
	// Included from: js/tinymce/classes/util/JSONP.js
	
	/**
	 * JSONP.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define("tinymce/util/JSONP", [
		"tinymce/dom/DOMUtils"
	], function(DOMUtils) {
		return {
			callbacks: {},
			count: 0,
	
			send: function(settings) {
				var self = this, dom = DOMUtils.DOM, count = settings.count !== undefined ? settings.count : self.count;
				var id = 'tinymce_jsonp_' + count;
	
				self.callbacks[count] = function(json) {
					dom.remove(id);
					delete self.callbacks[count];
	
					settings.callback(json);
				};
	
				dom.add(dom.doc.body, 'script', {
					id: id,
					src: settings.url,
					type: 'text/javascript'
				});
	
				self.count++;
			}
		};
	});
	
	// Included from: js/tinymce/classes/util/LocalStorage.js
	
	/**
	 * LocalStorage.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class will simulate LocalStorage on IE 7 and return the native version on modern browsers.
	 * Storage is done using userData on IE 7 and a special serialization format. The format is designed
	 * to be as small as possible by making sure that the keys and values doesn't need to be encoded. This
	 * makes it possible to store for example HTML data.
	 *
	 * Storage format for userData:
	 * <base 32 key length>,<key string>,<base 32 value length>,<value>,...
	 *
	 * For example this data key1=value1,key2=value2 would be:
	 * 4,key1,6,value1,4,key2,6,value2
	 *
	 * @class tinymce.util.LocalStorage
	 * @static
	 * @version 4.0
	 * @example
	 * tinymce.util.LocalStorage.setItem('key', 'value');
	 * var value = tinymce.util.LocalStorage.getItem('key');
	 */
	define("tinymce/util/LocalStorage", [], function() {
		var LocalStorage, storageElm, items, keys, userDataKey, hasOldIEDataSupport;
	
		// Check for native support
		try {
			if (window.localStorage) {
				return localStorage;
			}
		} catch (ex) {
			// Ignore
		}
	
		userDataKey = "tinymce";
		storageElm = document.documentElement;
		hasOldIEDataSupport = !!storageElm.addBehavior;
	
		if (hasOldIEDataSupport) {
			storageElm.addBehavior('#default#userData');
		}
	
		/**
		 * Gets the keys names and updates LocalStorage.length property. Since IE7 doesn't have any getters/setters.
		 */
		function updateKeys() {
			keys = [];
	
			for (var key in items) {
				keys.push(key);
			}
	
			LocalStorage.length = keys.length;
		}
	
		/**
		 * Loads the userData string and parses it into the items structure.
		 */
		function load() {
			var key, data, value, pos = 0;
	
			items = {};
	
			// localStorage can be disabled on WebKit/Gecko so make a dummy storage
			if (!hasOldIEDataSupport) {
				return;
			}
	
			function next(end) {
				var value, nextPos;
	
				nextPos = end !== undefined ? pos + end : data.indexOf(',', pos);
				if (nextPos === -1 || nextPos > data.length) {
					return null;
				}
	
				value = data.substring(pos, nextPos);
				pos = nextPos + 1;
	
				return value;
			}
	
			storageElm.load(userDataKey);
			data = storageElm.getAttribute(userDataKey) || '';
	
			do {
				var offset = next();
				if (offset === null) {
					break;
				}
	
				key = next(parseInt(offset, 32) || 0);
				if (key !== null) {
					offset = next();
					if (offset === null) {
						break;
					}
	
					value = next(parseInt(offset, 32) || 0);
	
					if (key) {
						items[key] = value;
					}
				}
			} while (key !== null);
	
			updateKeys();
		}
	
		/**
		 * Saves the items structure into a the userData format.
		 */
		function save() {
			var value, data = '';
	
			// localStorage can be disabled on WebKit/Gecko so make a dummy storage
			if (!hasOldIEDataSupport) {
				return;
			}
	
			for (var key in items) {
				value = items[key];
				data += (data ? ',' : '') + key.length.toString(32) + ',' + key + ',' + value.length.toString(32) + ',' + value;
			}
	
			storageElm.setAttribute(userDataKey, data);
	
			try {
				storageElm.save(userDataKey);
			} catch (ex) {
				// Ignore disk full
			}
	
			updateKeys();
		}
	
		LocalStorage = {
			/**
			 * Length of the number of items in storage.
			 *
			 * @property length
			 * @type Number
			 * @return {Number} Number of items in storage.
			 */
			//length:0,
	
			/**
			 * Returns the key name by index.
			 *
			 * @method key
			 * @param {Number} index Index of key to return.
			 * @return {String} Key value or null if it wasn't found.
			 */
			key: function(index) {
				return keys[index];
			},
	
			/**
			 * Returns the value if the specified key or null if it wasn't found.
			 *
			 * @method getItem
			 * @param {String} key Key of item to retrieve.
			 * @return {String} Value of the specified item or null if it wasn't found.
			 */
			getItem: function(key) {
				return key in items ? items[key] : null;
			},
	
			/**
			 * Sets the value of the specified item by it's key.
			 *
			 * @method setItem
			 * @param {String} key Key of the item to set.
			 * @param {String} value Value of the item to set.
			 */
			setItem: function(key, value) {
				items[key] = "" + value;
				save();
			},
	
			/**
			 * Removes the specified item by key.
			 *
			 * @method removeItem
			 * @param {String} key Key of item to remove.
			 */
			removeItem: function(key) {
				delete items[key];
				save();
			},
	
			/**
			 * Removes all items.
			 *
			 * @method clear
			 */
			clear: function() {
				items = {};
				save();
			}
		};
	
		load();
	
		return LocalStorage;
	});
	
	// Included from: js/tinymce/classes/Compat.js
	
	/**
	 * Compat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * TinyMCE core class.
	 *
	 * @static
	 * @class tinymce
	 * @borrow-members tinymce.EditorManager
	 * @borrow-members tinymce.util.Tools
	 */
	define("tinymce/Compat", [
		"tinymce/dom/DOMUtils",
		"tinymce/dom/EventUtils",
		"tinymce/dom/ScriptLoader",
		"tinymce/AddOnManager",
		"tinymce/util/Tools",
		"tinymce/Env"
	], function(DOMUtils, EventUtils, ScriptLoader, AddOnManager, Tools, Env) {
		var tinymce = window.tinymce;
	
		/**
		 * @property {tinymce.dom.DOMUtils} DOM Global DOM instance.
		 * @property {tinymce.dom.ScriptLoader} ScriptLoader Global ScriptLoader instance.
		 * @property {tinymce.AddOnManager} PluginManager Global PluginManager instance.
		 * @property {tinymce.AddOnManager} ThemeManager Global ThemeManager instance.
		 */
		tinymce.DOM = DOMUtils.DOM;
		tinymce.ScriptLoader = ScriptLoader.ScriptLoader;
		tinymce.PluginManager = AddOnManager.PluginManager;
		tinymce.ThemeManager = AddOnManager.ThemeManager;
	
		tinymce.dom = tinymce.dom || {};
		tinymce.dom.Event = EventUtils.Event;
	
		Tools.each(Tools, function(func, key) {
			tinymce[key] = func;
		});
	
		Tools.each('isOpera isWebKit isIE isGecko isMac'.split(' '), function(name) {
			tinymce[name] = Env[name.substr(2).toLowerCase()];
		});
	
		return {};
	});
	
	// Describe the different namespaces
	
	/**
	 * Root level namespace this contains classes directly related to the TinyMCE editor.
	 *
	 * @namespace tinymce
	 */
	
	/**
	 * Contains classes for handling the browsers DOM.
	 *
	 * @namespace tinymce.dom
	 */
	
	/**
	 * Contains html parser and serializer logic.
	 *
	 * @namespace tinymce.html
	 */
	
	/**
	 * Contains the different UI types such as buttons, listboxes etc.
	 *
	 * @namespace tinymce.ui
	 */
	
	/**
	 * Contains various utility classes such as json parser, cookies etc.
	 *
	 * @namespace tinymce.util
	 */
	
	/**
	 * Contains modules to handle data binding.
	 *
	 * @namespace tinymce.data
	 */
	
	// Included from: js/tinymce/classes/ui/Layout.js
	
	/**
	 * Layout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Base layout manager class.
	 *
	 * @class tinymce.ui.Layout
	 */
	define("tinymce/ui/Layout", [
		"tinymce/util/Class",
		"tinymce/util/Tools"
	], function(Class, Tools) {
		"use strict";
	
		return Class.extend({
			Defaults: {
				firstControlClass: 'first',
				lastControlClass: 'last'
			},
	
			/**
			 * Constructs a layout instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				this.settings = Tools.extend({}, this.Defaults, settings);
			},
	
			/**
			 * This method gets invoked before the layout renders the controls.
			 *
			 * @method preRender
			 * @param {tinymce.ui.Container} container Container instance to preRender.
			 */
			preRender: function(container) {
				container.bodyClasses.add(this.settings.containerClass);
			},
	
			/**
			 * Applies layout classes to the container.
			 *
			 * @private
			 */
			applyClasses: function(items) {
				var self = this, settings = self.settings, firstClass, lastClass, firstItem, lastItem;
	
				firstClass = settings.firstControlClass;
				lastClass = settings.lastControlClass;
	
				items.each(function(item) {
					item.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
	
					if (item.visible()) {
						if (!firstItem) {
							firstItem = item;
						}
	
						lastItem = item;
					}
				});
	
				if (firstItem) {
					firstItem.classes.add(firstClass);
				}
	
				if (lastItem) {
					lastItem.classes.add(lastClass);
				}
			},
	
			/**
			 * Renders the specified container and any layout specific HTML.
			 *
			 * @method renderHtml
			 * @param {tinymce.ui.Container} container Container to render HTML for.
			 */
			renderHtml: function(container) {
				var self = this, html = '';
	
				self.applyClasses(container.items());
	
				container.items().each(function(item) {
					html += item.renderHtml();
				});
	
				return html;
			},
	
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function() {
			},
	
			/**
			 * This method gets invoked after the layout renders the controls.
			 *
			 * @method postRender
			 * @param {tinymce.ui.Container} container Container instance to postRender.
			 */
			postRender: function() {
			},
	
			isNative: function() {
				return false;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/AbsoluteLayout.js
	
	/**
	 * AbsoluteLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * LayoutManager for absolute positioning. This layout manager is more of
	 * a base class for other layouts but can be created and used directly.
	 *
	 * @-x-less AbsoluteLayout.less
	 * @class tinymce.ui.AbsoluteLayout
	 * @extends tinymce.ui.Layout
	 */
	define("tinymce/ui/AbsoluteLayout", [
		"tinymce/ui/Layout"
	], function(Layout) {
		"use strict";
	
		return Layout.extend({
			Defaults: {
				containerClass: 'abs-layout',
				controlClass: 'abs-layout-item'
			},
	
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function(container) {
				container.items().filter(':visible').each(function(ctrl) {
					var settings = ctrl.settings;
	
					ctrl.layoutRect({
						x: settings.x,
						y: settings.y,
						w: settings.w,
						h: settings.h
					});
	
					if (ctrl.recalc) {
						ctrl.recalc();
					}
				});
			},
	
			/**
			 * Renders the specified container and any layout specific HTML.
			 *
			 * @method renderHtml
			 * @param {tinymce.ui.Container} container Container to render HTML for.
			 */
			renderHtml: function(container) {
				return '<div id="' + container._id + '-absend" class="' + container.classPrefix + 'abs-end"></div>' + this._super(container);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Button.js
	
	/**
	 * Button.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to create buttons. You can create them directly or through the Factory.
	 *
	 * @example
	 * // Create and render a button to the body element
	 * tinymce.ui.Factory.create({
	 *     type: 'button',
	 *     text: 'My button'
	 * }).renderTo(document.body);
	 *
	 * @-x-less Button.less
	 * @class tinymce.ui.Button
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Button", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			Defaults: {
				classes: "widget btn",
				role: "button"
			},
	
			/**
			 * Constructs a new button instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} size Size of the button small|medium|large.
			 * @setting {String} image Image to use for icon.
			 * @setting {String} icon Icon to use for button.
			 */
			init: function(settings) {
				var self = this, size;
	
				self._super(settings);
				settings = self.settings;
	
				size = self.settings.size;
	
				self.on('click mousedown', function(e) {
					e.preventDefault();
				});
	
				self.on('touchstart', function(e) {
					self.fire('click', e);
					e.preventDefault();
				});
	
				if (settings.subtype) {
					self.classes.add(settings.subtype);
				}
	
				if (size) {
					self.classes.add('btn-' + size);
				}
	
				if (settings.icon) {
					self.icon(settings.icon);
				}
			},
	
			/**
			 * Sets/gets the current button icon.
			 *
			 * @method icon
			 * @param {String} [icon] New icon identifier.
			 * @return {String|tinymce.ui.MenuButton} Current icon or current MenuButton instance.
			 */
			icon: function(icon) {
				if (!arguments.length) {
					return this.state.get('icon');
				}
	
				this.state.set('icon', icon);
	
				return this;
			},
	
			/**
			 * Repaints the button for example after it's been resizes by a layout engine.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var btnElm = this.getEl().firstChild,
					btnStyle;
	
				if (btnElm) {
					btnStyle = btnElm.style;
					btnStyle.width = btnStyle.height = "100%";
				}
	
				this._super();
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix;
				var icon = self.state.get('icon'), image, text = self.state.get('text'), textHtml = '';
	
				image = self.settings.image;
				if (image) {
					icon = 'none';
	
					// Support for [high dpi, low dpi] image sources
					if (typeof image != "string") {
						image = window.getSelection ? image[0] : image[1];
					}
	
					image = ' style="background-image: url(\'' + image + '\')"';
				} else {
					image = '';
				}
	
				if (text) {
					self.classes.add('btn-has-text');
					textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
				}
	
				icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" tabindex="-1" aria-labelledby="' + id + '">' +
						'<button role="presentation" type="button" tabindex="-1">' +
							(icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
							textHtml +
						'</button>' +
					'</div>'
				);
			},
	
			bindStates: function() {
				var self = this, $ = self.$, textCls = self.classPrefix + 'txt';
	
				function setButtonText(text) {
					var $span = $('span.' + textCls, self.getEl());
	
					if (text) {
						if (!$span[0]) {
							$('button:first', self.getEl()).append('<span class="' + textCls + '"></span>');
							$span = $('span.' + textCls, self.getEl());
						}
	
						$span.html(self.encode(text));
					} else {
						$span.remove();
					}
	
					self.classes.toggle('btn-has-text', !!text);
				}
	
				self.state.on('change:text', function(e) {
					setButtonText(e.value);
				});
	
				self.state.on('change:icon', function(e) {
					var icon = e.value, prefix = self.classPrefix;
	
					self.settings.icon = icon;
					icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	
					var btnElm = self.getEl().firstChild, iconElm = btnElm.getElementsByTagName('i')[0];
	
					if (icon) {
						if (!iconElm || iconElm != btnElm.firstChild) {
							iconElm = document.createElement('i');
							btnElm.insertBefore(iconElm, btnElm.firstChild);
						}
	
						iconElm.className = icon;
					} else if (iconElm) {
						btnElm.removeChild(iconElm);
					}
	
					setButtonText(self.state.get('text'));
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ButtonGroup.js
	
	/**
	 * ButtonGroup.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control enables you to put multiple buttons into a group. This is
	 * useful when you want to combine similar toolbar buttons into a group.
	 *
	 * @example
	 * // Create and render a buttongroup with two buttons to the body element
	 * tinymce.ui.Factory.create({
	 *     type: 'buttongroup',
	 *     items: [
	 *         {text: 'Button A'},
	 *         {text: 'Button B'}
	 *     ]
	 * }).renderTo(document.body);
	 *
	 * @-x-less ButtonGroup.less
	 * @class tinymce.ui.ButtonGroup
	 * @extends tinymce.ui.Container
	 */
	define("tinymce/ui/ButtonGroup", [
		"tinymce/ui/Container"
	], function(Container) {
		"use strict";
	
		return Container.extend({
			Defaults: {
				defaultType: 'button',
				role: 'group'
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout;
	
				self.classes.add('btn-group');
				self.preRender();
				layout.preRender(self);
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '">' +
						'<div id="' + self._id + '-body">' +
							(self.settings.html || '') + layout.renderHtml(self) +
						'</div>' +
					'</div>'
				);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Checkbox.js
	
	/**
	 * Checkbox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control creates a custom checkbox.
	 *
	 * @example
	 * // Create and render a checkbox to the body element
	 * tinymce.ui.Factory.create({
	 *     type: 'checkbox',
	 *     checked: true,
	 *     text: 'My checkbox'
	 * }).renderTo(document.body);
	 *
	 * @-x-less Checkbox.less
	 * @class tinymce.ui.Checkbox
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Checkbox", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			Defaults: {
				classes: "checkbox",
				role: "checkbox",
				checked: false
			},
	
			/**
			 * Constructs a new Checkbox instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} checked True if the checkbox should be checked by default.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
	
				self.on('click mousedown', function(e) {
					e.preventDefault();
				});
	
				self.on('click', function(e) {
					e.preventDefault();
	
					if (!self.disabled()) {
						self.checked(!self.checked());
					}
				});
	
				self.checked(self.settings.checked);
			},
	
			/**
			 * Getter/setter function for the checked state.
			 *
			 * @method checked
			 * @param {Boolean} [state] State to be set.
			 * @return {Boolean|tinymce.ui.Checkbox} True/false or checkbox if it's a set operation.
			 */
			checked: function(state) {
				if (!arguments.length) {
					return this.state.get('checked');
				}
	
				this.state.set('checked', state);
	
				return this;
			},
	
			/**
			 * Getter/setter function for the value state.
			 *
			 * @method value
			 * @param {Boolean} [state] State to be set.
			 * @return {Boolean|tinymce.ui.Checkbox} True/false or checkbox if it's a set operation.
			 */
			value: function(state) {
				if (!arguments.length) {
					return this.checked();
				}
	
				return this.checked(state);
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix;
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' +
						'<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' +
						'<span id="' + id + '-al" class="' + prefix + 'label">' + self.encode(self.state.get('text')) + '</span>' +
					'</div>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				function checked(state) {
					self.classes.toggle("checked", state);
					self.aria('checked', state);
				}
	
				self.state.on('change:text', function(e) {
					self.getEl('al').firstChild.data = self.translate(e.value);
				});
	
				self.state.on('change:checked change:value', function(e) {
					self.fire('change');
					checked(e.value);
				});
	
				self.state.on('change:icon', function(e) {
					var icon = e.value, prefix = self.classPrefix;
	
					if (typeof icon == 'undefined') {
						return self.settings.icon;
					}
	
					self.settings.icon = icon;
					icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	
					var btnElm = self.getEl().firstChild, iconElm = btnElm.getElementsByTagName('i')[0];
	
					if (icon) {
						if (!iconElm || iconElm != btnElm.firstChild) {
							iconElm = document.createElement('i');
							btnElm.insertBefore(iconElm, btnElm.firstChild);
						}
	
						iconElm.className = icon;
					} else if (iconElm) {
						btnElm.removeChild(iconElm);
					}
				});
	
				if (self.state.get('checked')) {
					checked(true);
				}
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ComboBox.js
	
	/**
	 * ComboBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a combobox control. Select box that you select a value from or
	 * type a value into.
	 *
	 * @-x-less ComboBox.less
	 * @class tinymce.ui.ComboBox
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/ComboBox", [
		"tinymce/ui/Widget",
		"tinymce/ui/Factory",
		"tinymce/ui/DomUtils",
		"tinymce/dom/DomQuery"
	], function(Widget, Factory, DomUtils, $) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} placeholder Placeholder text to display.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				settings = self.settings;
	
				self.classes.add('combobox');
				self.subinput = true;
				self.ariaTarget = 'inp'; // TODO: Figure out a better way
	
				settings.menu = settings.menu || settings.values;
	
				if (settings.menu) {
					settings.icon = 'caret';
				}
	
				self.on('click', function(e) {
					var elm = e.target, root = self.getEl();
	
					if (!$.contains(root, elm) && elm != root) {
						return;
					}
	
					while (elm && elm != root) {
						if (elm.id && elm.id.indexOf('-open') != -1) {
							self.fire('action');
	
							if (settings.menu) {
								self.showMenu();
	
								if (e.aria) {
									self.menu.items()[0].focus();
								}
							}
						}
	
						elm = elm.parentNode;
					}
				});
	
				// TODO: Rework this
				self.on('keydown', function(e) {
					if (e.target.nodeName == "INPUT" && e.keyCode == 13) {
						self.parents().reverse().each(function(ctrl) {
							var stateValue = self.state.get('value'), inputValue = self.getEl('inp').value;
	
							e.preventDefault();
	
							self.state.set('value', inputValue);
	
							if (stateValue != inputValue) {
								self.fire('change');
							}
	
							if (ctrl.hasEventListeners('submit') && ctrl.toJSON) {
								ctrl.fire('submit', {data: ctrl.toJSON()});
								return false;
							}
						});
					}
				});
	
				self.on('keyup', function(e) {
					if (e.target.nodeName == "INPUT") {
						self.state.set('value', e.target.value);
					}
				});
			},
	
			showMenu: function() {
				var self = this, settings = self.settings, menu;
	
				if (!self.menu) {
					menu = settings.menu || [];
	
					// Is menu array then auto constuct menu control
					if (menu.length) {
						menu = {
							type: 'menu',
							items: menu
						};
					} else {
						menu.type = menu.type || 'menu';
					}
	
					self.menu = Factory.create(menu).parent(self).renderTo(self.getContainerElm());
					self.fire('createmenu');
					self.menu.reflow();
					self.menu.on('cancel', function(e) {
						if (e.control === self.menu) {
							self.focus();
						}
					});
	
					self.menu.on('show hide', function(e) {
						e.control.items().each(function(ctrl) {
							ctrl.active(ctrl.value() == self.value());
						});
					}).fire('show');
	
					self.menu.on('select', function(e) {
						self.value(e.control.value());
					});
	
					self.on('focusin', function(e) {
						if (e.target.tagName.toUpperCase() == 'INPUT') {
							self.menu.hide();
						}
					});
	
					self.aria('expanded', true);
				}
	
				self.menu.show();
				self.menu.layoutRect({w: self.layoutRect().w});
				self.menu.moveRel(self.getEl(), self.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
			},
	
			/**
			 * Focuses the input area of the control.
			 *
			 * @method focus
			 */
			focus: function() {
				this.getEl('inp').focus();
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, elm = self.getEl(), openElm = self.getEl('open'), rect = self.layoutRect();
				var width, lineHeight;
	
				if (openElm) {
					width = rect.w - DomUtils.getSize(openElm).width - 10;
				} else {
					width = rect.w - 10;
				}
	
				// Detect old IE 7+8 add lineHeight to align caret vertically in the middle
				var doc = document;
				if (doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
					lineHeight = (self.layoutRect().h - 2) + 'px';
				}
	
				$(elm.firstChild).css({
					width: width,
					lineHeight: lineHeight
				});
	
				self._super();
	
				return self;
			},
	
			/**
			 * Post render method. Called after the control has been rendered to the target.
			 *
			 * @method postRender
			 * @return {tinymce.ui.ComboBox} Current combobox instance.
			 */
			postRender: function() {
				var self = this;
	
				$(this.getEl('inp')).on('change', function(e) {
					self.state.set('value', e.target.value);
					self.fire('change', e);
				});
	
				return self._super();
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix;
				var value = self.state.get('value') || '';
				var icon, text, openBtnHtml = '', extraAttrs = '';
	
				if ("spellcheck" in settings) {
					extraAttrs += ' spellcheck="' + settings.spellcheck + '"';
				}
	
				if (settings.maxLength) {
					extraAttrs += ' maxlength="' + settings.maxLength + '"';
				}
	
				if (settings.size) {
					extraAttrs += ' size="' + settings.size + '"';
				}
	
				if (settings.subtype) {
					extraAttrs += ' type="' + settings.subtype + '"';
				}
	
				if (self.disabled()) {
					extraAttrs += ' disabled="disabled"';
				}
	
				icon = settings.icon;
				if (icon && icon != 'caret') {
					icon = prefix + 'ico ' + prefix + 'i-' + settings.icon;
				}
	
				text = self.state.get('text');
	
				if (icon || text) {
					openBtnHtml = (
						'<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' +
							'<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' +
								(icon != 'caret' ? '<i class="' + icon + '"></i>' : '<i class="' + prefix + 'caret"></i>') +
								(text ? (icon ? ' ' : '') + text : '') +
							'</button>' +
						'</div>'
					);
	
					self.classes.add('has-open');
				}
	
				return (
					'<div id="' + id + '" class="' + self.classes + '">' +
						'<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' +
						self.encode(value, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' +
						self.encode(settings.placeholder) + '" />' +
						openBtnHtml +
					'</div>'
				);
			},
	
			value: function(value) {
				if (arguments.length) {
					this.state.set('value', value);
					return this;
				}
	
				// Make sure the real state is in sync
				if (this.state.get('rendered')) {
					this.state.set('value', this.getEl('inp').value);
				}
	
				return this.state.get('value');
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:value', function(e) {
					if (self.getEl('inp').value != e.value) {
						self.getEl('inp').value = e.value;
					}
				});
	
				self.state.on('change:disabled', function(e) {
					self.getEl('inp').disabled = e.value;
				});
	
				return self._super();
			},
	
			remove: function() {
				$(this.getEl('inp')).off();
				this._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ColorBox.js
	
	/**
	 * ColorBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This widget lets you enter colors and browse for colors by pressing the color button. It also displays
	 * a preview of the current color.
	 *
	 * @-x-less ColorBox.less
	 * @class tinymce.ui.ColorBox
	 * @extends tinymce.ui.ComboBox
	 */
	define("tinymce/ui/ColorBox", [
		"tinymce/ui/ComboBox"
	], function(ComboBox) {
		"use strict";
	
		return ComboBox.extend({
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this;
	
				settings.spellcheck = false;
	
				if (settings.onaction) {
					settings.icon = 'none';
				}
	
				self._super(settings);
	
				self.classes.add('colorbox');
				self.on('change keyup postrender', function() {
					self.repaintColor(self.value());
				});
			},
	
			repaintColor: function(value) {
				var elm = this.getEl().getElementsByTagName('i')[0];
	
				if (elm) {
					try {
						elm.style.background = value;
					} catch (ex) {
						// Ignore
					}
				}
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:value', function(e) {
					if (self.state.get('rendered')) {
						self.repaintColor(e.value);
					}
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/PanelButton.js
	
	/**
	 * PanelButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new panel button.
	 *
	 * @class tinymce.ui.PanelButton
	 * @extends tinymce.ui.Button
	 */
	define("tinymce/ui/PanelButton", [
		"tinymce/ui/Button",
		"tinymce/ui/FloatPanel"
	], function(Button, FloatPanel) {
		"use strict";
	
		return Button.extend({
			/**
			 * Shows the panel for the button.
			 *
			 * @method showPanel
			 */
			showPanel: function() {
				var self = this, settings = self.settings;
	
				self.active(true);
	
				if (!self.panel) {
					var panelSettings = settings.panel;
	
					// Wrap panel in grid layout if type if specified
					// This makes it possible to add forms or other containers directly in the panel option
					if (panelSettings.type) {
						panelSettings = {
							layout: 'grid',
							items: panelSettings
						};
					}
	
					panelSettings.role = panelSettings.role || 'dialog';
					panelSettings.popover = true;
					panelSettings.autohide = true;
					panelSettings.ariaRoot = true;
	
					self.panel = new FloatPanel(panelSettings).on('hide', function() {
						self.active(false);
					}).on('cancel', function(e) {
						e.stopPropagation();
						self.focus();
						self.hidePanel();
					}).parent(self).renderTo(self.getContainerElm());
	
					self.panel.fire('show');
					self.panel.reflow();
				} else {
					self.panel.show();
				}
	
				self.panel.moveRel(self.getEl(), settings.popoverAlign || (self.isRtl() ? ['bc-tr', 'bc-tc'] : ['bc-tl', 'bc-tc']));
			},
	
			/**
			 * Hides the panel for the button.
			 *
			 * @method hidePanel
			 */
			hidePanel: function() {
				var self = this;
	
				if (self.panel) {
					self.panel.hide();
				}
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self.aria('haspopup', true);
	
				self.on('click', function(e) {
					if (e.control === self) {
						if (self.panel && self.panel.visible()) {
							self.hidePanel();
						} else {
							self.showPanel();
							self.panel.focus(!!e.aria);
						}
					}
				});
	
				return self._super();
			},
	
			remove: function() {
				if (this.panel) {
					this.panel.remove();
					this.panel = null;
				}
	
				return this._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ColorButton.js
	
	/**
	 * ColorButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a color button control. This is a split button in which the main
	 * button has a visual representation of the currently selected color. When clicked
	 * the caret button displays a color picker, allowing the user to select a new color.
	 *
	 * @-x-less ColorButton.less
	 * @class tinymce.ui.ColorButton
	 * @extends tinymce.ui.PanelButton
	 */
	define("tinymce/ui/ColorButton", [
		"tinymce/ui/PanelButton",
		"tinymce/dom/DOMUtils"
	], function(PanelButton, DomUtils) {
		"use strict";
	
		var DOM = DomUtils.DOM;
	
		return PanelButton.extend({
			/**
			 * Constructs a new ColorButton instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				this._super(settings);
				this.classes.add('colorbutton');
			},
	
			/**
			 * Getter/setter for the current color.
			 *
			 * @method color
			 * @param {String} [color] Color to set.
			 * @return {String|tinymce.ui.ColorButton} Current color or current instance.
			 */
			color: function(color) {
				if (color) {
					this._color = color;
					this.getEl('preview').style.backgroundColor = color;
					return this;
				}
	
				return this._color;
			},
	
			/**
			 * Resets the current color.
			 *
			 * @method resetColor
			 * @return {tinymce.ui.ColorButton} Current instance.
			 */
			resetColor: function() {
				this._color = null;
				this.getEl('preview').style.backgroundColor = null;
				return this;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix, text = self.state.get('text');
				var icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
				var image = self.settings.image ? ' style="background-image: url(\'' + self.settings.image + '\')"' : '',
					textHtml = '';
	
				if (text) {
					self.classes.add('btn-has-text');
					textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
				}
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1" aria-haspopup="true">' +
						'<button role="presentation" hidefocus="1" type="button" tabindex="-1">' +
							(icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
							'<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' +
							textHtml +
						'</button>' +
						'<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' +
							' <i class="' + prefix + 'caret"></i>' +
						'</button>' +
					'</div>'
				);
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this, onClickHandler = self.settings.onclick;
	
				self.on('click', function(e) {
					if (e.aria && e.aria.key == 'down') {
						return;
					}
	
					if (e.control == self && !DOM.getParent(e.target, '.' + self.classPrefix + 'open')) {
						e.stopImmediatePropagation();
						onClickHandler.call(self, e);
					}
				});
	
				delete self.settings.onclick;
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/util/Color.js
	
	/**
	 * Color.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class lets you parse/serialize colors and convert rgb/hsb.
	 *
	 * @class tinymce.util.Color
	 * @example
	 * var white = new tinymce.util.Color({r: 255, g: 255, b: 255});
	 * var red = new tinymce.util.Color('#FF0000');
	 *
	 * console.log(white.toHex(), red.toHsv());
	 */
	define("tinymce/util/Color", [], function() {
		var min = Math.min, max = Math.max, round = Math.round;
	
		/**
		 * Constructs a new color instance.
		 *
		 * @constructor
		 * @method Color
		 * @param {String} value Optional initial value to parse.
		 */
		function Color(value) {
			var self = this, r = 0, g = 0, b = 0;
	
			function rgb2hsv(r, g, b) {
				var h, s, v, d, minRGB, maxRGB;
	
				h = 0;
				s = 0;
				v = 0;
				r = r / 255;
				g = g / 255;
				b = b / 255;
	
				minRGB = min(r, min(g, b));
				maxRGB = max(r, max(g, b));
	
				if (minRGB == maxRGB) {
					v = minRGB;
	
					return {
						h: 0,
						s: 0,
						v: v * 100
					};
				}
	
				/*eslint no-nested-ternary:0 */
				d = (r == minRGB) ? g - b : ((b == minRGB) ? r - g : b - r);
				h = (r == minRGB) ? 3 : ((b == minRGB) ? 1 : 5);
				h = 60 * (h - d / (maxRGB - minRGB));
				s = (maxRGB - minRGB) / maxRGB;
				v = maxRGB;
	
				return {
					h: round(h),
					s: round(s * 100),
					v: round(v * 100)
				};
			}
	
			function hsvToRgb(hue, saturation, brightness) {
				var side, chroma, x, match;
	
				hue = (parseInt(hue, 10) || 0) % 360;
				saturation = parseInt(saturation, 10) / 100;
				brightness = parseInt(brightness, 10) / 100;
				saturation = max(0, min(saturation, 1));
				brightness = max(0, min(brightness, 1));
	
				if (saturation === 0) {
					r = g = b = round(255 * brightness);
					return;
				}
	
				side = hue / 60;
				chroma = brightness * saturation;
				x = chroma * (1 - Math.abs(side % 2 - 1));
				match = brightness - chroma;
	
				switch (Math.floor(side)) {
					case 0:
						r = chroma;
						g = x;
						b = 0;
						break;
	
					case 1:
						r = x;
						g = chroma;
						b = 0;
						break;
	
					case 2:
						r = 0;
						g = chroma;
						b = x;
						break;
	
					case 3:
						r = 0;
						g = x;
						b = chroma;
						break;
	
					case 4:
						r = x;
						g = 0;
						b = chroma;
						break;
	
					case 5:
						r = chroma;
						g = 0;
						b = x;
						break;
	
					default:
						r = g = b = 0;
				}
	
				r = round(255 * (r + match));
				g = round(255 * (g + match));
				b = round(255 * (b + match));
			}
	
			/**
			 * Returns the hex string of the current color. For example: #ff00ff
			 *
			 * @method toHex
			 * @return {String} Hex string of current color.
			 */
			function toHex() {
				function hex(val) {
					val = parseInt(val, 10).toString(16);
	
					return val.length > 1 ? val : '0' + val;
				}
	
				return '#' + hex(r) + hex(g) + hex(b);
			}
	
			/**
			 * Returns the r, g, b values of the color. Each channel has a range from 0-255.
			 *
			 * @method toRgb
			 * @return {Object} Object with r, g, b fields.
			 */
			function toRgb() {
				return {
					r: r,
					g: g,
					b: b
				};
			}
	
			/**
			 * Returns the h, s, v values of the color. Ranges: h=0-360, s=0-100, v=0-100.
			 *
			 * @method toHsv
			 * @return {Object} Object with h, s, v fields.
			 */
			function toHsv() {
				return rgb2hsv(r, g, b);
			}
	
			/**
			 * Parses the specified value and populates the color instance.
			 *
			 * Supported format examples:
			 *  * rbg(255,0,0)
			 *  * #ff0000
			 *  * #fff
			 *  * {r: 255, g: 0, b: 0}
			 *  * {h: 360, s: 100, v: 100}
			 *
			 * @method parse
			 * @param {Object/String} value Color value to parse.
			 * @return {tinymce.util.Color} Current color instance.
			 */
			function parse(value) {
				var matches;
	
				if (typeof value == 'object') {
					if ("r" in value) {
						r = value.r;
						g = value.g;
						b = value.b;
					} else if ("v" in value) {
						hsvToRgb(value.h, value.s, value.v);
					}
				} else {
					if ((matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value))) {
						r = parseInt(matches[1], 10);
						g = parseInt(matches[2], 10);
						b = parseInt(matches[3], 10);
					} else if ((matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value))) {
						r = parseInt(matches[1], 16);
						g = parseInt(matches[2], 16);
						b = parseInt(matches[3], 16);
					} else if ((matches = /#([0-F])([0-F])([0-F])/gi.exec(value))) {
						r = parseInt(matches[1] + matches[1], 16);
						g = parseInt(matches[2] + matches[2], 16);
						b = parseInt(matches[3] + matches[3], 16);
					}
				}
	
				r = r < 0 ? 0 : (r > 255 ? 255 : r);
				g = g < 0 ? 0 : (g > 255 ? 255 : g);
				b = b < 0 ? 0 : (b > 255 ? 255 : b);
	
				return self;
			}
	
			if (value) {
				parse(value);
			}
	
			self.toRgb = toRgb;
			self.toHsv = toHsv;
			self.toHex = toHex;
			self.parse = parse;
		}
	
		return Color;
	});
	
	// Included from: js/tinymce/classes/ui/ColorPicker.js
	
	/**
	 * ColorPicker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Color picker widget lets you select colors.
	 *
	 * @-x-less ColorPicker.less
	 * @class tinymce.ui.ColorPicker
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/ColorPicker", [
		"tinymce/ui/Widget",
		"tinymce/ui/DragHelper",
		"tinymce/ui/DomUtils",
		"tinymce/util/Color"
	], function(Widget, DragHelper, DomUtils, Color) {
		"use strict";
	
		return Widget.extend({
			Defaults: {
				classes: "widget colorpicker"
			},
	
			/**
			 * Constructs a new colorpicker instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} color Initial color value.
			 */
			init: function(settings) {
				this._super(settings);
			},
	
			postRender: function() {
				var self = this, color = self.color(), hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
	
				hueRootElm = self.getEl('h');
				huePointElm = self.getEl('hp');
				svRootElm = self.getEl('sv');
				svPointElm = self.getEl('svp');
	
				function getPos(elm, event) {
					var pos = DomUtils.getPos(elm), x, y;
	
					x = event.pageX - pos.x;
					y = event.pageY - pos.y;
	
					x = Math.max(0, Math.min(x / elm.clientWidth, 1));
					y = Math.max(0, Math.min(y / elm.clientHeight, 1));
	
					return {
						x: x,
						y: y
					};
				}
	
				function updateColor(hsv, hueUpdate) {
					var hue = (360 - hsv.h) / 360;
	
					DomUtils.css(huePointElm, {
						top: (hue * 100) + '%'
					});
	
					if (!hueUpdate) {
						DomUtils.css(svPointElm, {
							left: hsv.s + '%',
							top: (100 - hsv.v) + '%'
						});
					}
	
					svRootElm.style.background = new Color({s: 100, v: 100, h: hsv.h}).toHex();
					self.color().parse({s: hsv.s, v: hsv.v, h: hsv.h});
				}
	
				function updateSaturationAndValue(e) {
					var pos;
	
					pos = getPos(svRootElm, e);
					hsv.s = pos.x * 100;
					hsv.v = (1 - pos.y) * 100;
	
					updateColor(hsv);
					self.fire('change');
				}
	
				function updateHue(e) {
					var pos;
	
					pos = getPos(hueRootElm, e);
					hsv = color.toHsv();
					hsv.h = (1 - pos.y) * 360;
					updateColor(hsv, true);
					self.fire('change');
				}
	
				self._repaint = function() {
					hsv = color.toHsv();
					updateColor(hsv);
				};
	
				self._super();
	
				self._svdraghelper = new DragHelper(self._id + '-sv', {
					start: updateSaturationAndValue,
					drag: updateSaturationAndValue
				});
	
				self._hdraghelper = new DragHelper(self._id + '-h', {
					start: updateHue,
					drag: updateHue
				});
	
				self._repaint();
			},
	
			rgb: function() {
				return this.color().toRgb();
			},
	
			value: function(value) {
				var self = this;
	
				if (arguments.length) {
					self.color().parse(value);
	
					if (self._rendered) {
						self._repaint();
					}
				} else {
					return self.color().toHex();
				}
			},
	
			color: function() {
				if (!this._color) {
					this._color = new Color();
				}
	
				return this._color;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix, hueHtml;
				var stops = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';
	
				function getOldIeFallbackHtml() {
					var i, l, html = '', gradientPrefix, stopsList;
	
					gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
					stopsList = stops.split(',');
					for (i = 0, l = stopsList.length - 1; i < l; i++) {
						html += (
							'<div class="' + prefix + 'colorpicker-h-chunk" style="' +
								'height:' + (100 / l) + '%;' +
								gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' +
								'-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' +
							'"></div>'
						);
					}
	
					return html;
				}
	
				var gradientCssText = (
					'background: -ms-linear-gradient(top,' + stops + ');' +
					'background: linear-gradient(to bottom,' + stops + ');'
				);
	
				hueHtml = (
					'<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + gradientCssText + '">' +
						getOldIeFallbackHtml() +
						'<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' +
					'</div>'
				);
	
				return (
					'<div id="' + id + '" class="' + self.classes + '">' +
						'<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' +
							'<div class="' + prefix + 'colorpicker-overlay1">' +
								'<div class="' + prefix + 'colorpicker-overlay2">' +
									'<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' +
										'<div class="' + prefix + 'colorpicker-selector2"></div>' +
									'</div>' +
								'</div>' +
							'</div>' +
						'</div>' +
						hueHtml +
					'</div>'
				);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Path.js
	
	/**
	 * Path.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new path control.
	 *
	 * @-x-less Path.less
	 * @class tinymce.ui.Path
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Path", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {String} delimiter Delimiter to display between row in path.
			 */
			init: function(settings) {
				var self = this;
	
				if (!settings.delimiter) {
					settings.delimiter = '\u00BB';
				}
	
				self._super(settings);
				self.classes.add('path');
				self.canFocus = true;
	
				self.on('click', function(e) {
					var index, target = e.target;
	
					if ((index = target.getAttribute('data-index'))) {
						self.fire('select', {value: self.row()[index], index: index});
					}
				});
	
				self.row(self.settings.row);
			},
	
			/**
			 * Focuses the current control.
			 *
			 * @method focus
			 * @return {tinymce.ui.Control} Current control instance.
			 */
			focus: function() {
				var self = this;
	
				self.getEl().firstChild.focus();
	
				return self;
			},
	
			/**
			 * Sets/gets the data to be used for the path.
			 *
			 * @method row
			 * @param {Array} row Array with row name is rendered to path.
			 */
			row: function(row) {
				if (!arguments.length) {
					return this.state.get('row');
				}
	
				this.state.set('row', row);
	
				return this;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this;
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '">' +
						self._getDataPathHtml(self.state.get('row')) +
					'</div>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:row', function(e) {
					self.innerHtml(self._getDataPathHtml(e.value));
				});
	
				return self._super();
			},
	
			_getDataPathHtml: function(data) {
				var self = this, parts = data || [], i, l, html = '', prefix = self.classPrefix;
	
				for (i = 0, l = parts.length; i < l; i++) {
					html += (
						(i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + self.settings.delimiter + ' </div>' : '') +
						'<div role="button" class="' + prefix + 'path-item' + (i == l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' +
						i + '" tabindex="-1" id="' + self._id + '-' + i + '" aria-level="' + i + '">' + parts[i].name + '</div>'
					);
				}
	
				if (!html) {
					html = '<div class="' + prefix + 'path-item">\u00a0</div>';
				}
	
				return html;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ElementPath.js
	
	/**
	 * ElementPath.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control creates an path for the current selections parent elements in TinyMCE.
	 *
	 * @class tinymce.ui.ElementPath
	 * @extends tinymce.ui.Path
	 */
	define("tinymce/ui/ElementPath", [
		"tinymce/ui/Path"
	], function(Path) {
		return Path.extend({
			/**
			 * Post render method. Called after the control has been rendered to the target.
			 *
			 * @method postRender
			 * @return {tinymce.ui.ElementPath} Current combobox instance.
			 */
			postRender: function() {
				var self = this, editor = self.settings.editor;
	
				function isHidden(elm) {
					if (elm.nodeType === 1) {
						if (elm.nodeName == "BR" || !!elm.getAttribute('data-mce-bogus')) {
							return true;
						}
	
						if (elm.getAttribute('data-mce-type') === 'bookmark') {
							return true;
						}
					}
	
					return false;
				}
	
				if (editor.settings.elementpath !== false) {
					self.on('select', function(e) {
						editor.focus();
						editor.selection.select(this.row()[e.index].element);
						editor.nodeChanged();
					});
	
					editor.on('nodeChange', function(e) {
						var outParents = [], parents = e.parents, i = parents.length;
	
						while (i--) {
							if (parents[i].nodeType == 1 && !isHidden(parents[i])) {
								var args = editor.fire('ResolveName', {
									name: parents[i].nodeName.toLowerCase(),
									target: parents[i]
								});
	
								if (!args.isDefaultPrevented()) {
									outParents.push({name: args.name, element: parents[i]});
								}
	
								if (args.isPropagationStopped()) {
									break;
								}
							}
						}
	
						self.row(outParents);
					});
				}
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FormItem.js
	
	/**
	 * FormItem.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a container created by the form element with
	 * a label and control item.
	 *
	 * @class tinymce.ui.FormItem
	 * @extends tinymce.ui.Container
	 * @setting {String} label Label to display for the form item.
	 */
	define("tinymce/ui/FormItem", [
		"tinymce/ui/Container"
	], function(Container) {
		"use strict";
	
		return Container.extend({
			Defaults: {
				layout: 'flex',
				align: 'center',
				defaults: {
					flex: 1
				}
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, prefix = self.classPrefix;
	
				self.classes.add('formitem');
				layout.preRender(self);
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
						(self.settings.title ? ('<div id="' + self._id + '-title" class="' + prefix + 'title">' +
							self.settings.title + '</div>') : '') +
						'<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
							(self.settings.html || '') + layout.renderHtml(self) +
						'</div>' +
					'</div>'
				);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Form.js
	
	/**
	 * Form.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a form container. A form container has the ability
	 * to automatically wrap items in tinymce.ui.FormItem instances.
	 *
	 * Each FormItem instance is a container for the label and the item.
	 *
	 * @example
	 * tinymce.ui.Factory.create({
	 *     type: 'form',
	 *     items: [
	 *         {type: 'textbox', label: 'My text box'}
	 *     ]
	 * }).renderTo(document.body);
	 *
	 * @class tinymce.ui.Form
	 * @extends tinymce.ui.Container
	 */
	define("tinymce/ui/Form", [
		"tinymce/ui/Container",
		"tinymce/ui/FormItem",
		"tinymce/util/Tools"
	], function(Container, FormItem, Tools) {
		"use strict";
	
		return Container.extend({
			Defaults: {
				containerCls: 'form',
				layout: 'flex',
				direction: 'column',
				align: 'stretch',
				flex: 1,
				padding: 20,
				labelGap: 30,
				spacing: 10,
				callbacks: {
					submit: function() {
						this.submit();
					}
				}
			},
	
			/**
			 * This method gets invoked before the control is rendered.
			 *
			 * @method preRender
			 */
			preRender: function() {
				var self = this, items = self.items();
	
				if (!self.settings.formItemDefaults) {
					self.settings.formItemDefaults = {
						layout: 'flex',
						autoResize: "overflow",
						defaults: {flex: 1}
					};
				}
	
				// Wrap any labeled items in FormItems
				items.each(function(ctrl) {
					var formItem, label = ctrl.settings.label;
	
					if (label) {
						formItem = new FormItem(Tools.extend({
							items: {
								type: 'label',
								id: ctrl._id + '-l',
								text: label,
								flex: 0,
								forId: ctrl._id,
								disabled: ctrl.disabled()
							}
						}, self.settings.formItemDefaults));
	
						formItem.type = 'formitem';
						ctrl.aria('labelledby', ctrl._id + '-l');
	
						if (typeof ctrl.settings.flex == "undefined") {
							ctrl.settings.flex = 1;
						}
	
						self.replace(ctrl, formItem);
						formItem.add(ctrl);
					}
				});
			},
	
			/**
			 * Fires a submit event with the serialized form.
			 *
			 * @method submit
			 * @return {Object} Event arguments object.
			 */
			submit: function() {
				return this.fire('submit', {data: this.toJSON()});
			},
	
			/**
			 * Post render method. Called after the control has been rendered to the target.
			 *
			 * @method postRender
			 * @return {tinymce.ui.ComboBox} Current combobox instance.
			 */
			postRender: function() {
				var self = this;
	
				self._super();
				self.fromJSON(self.settings.data);
			},
	
			bindStates: function() {
				var self = this;
	
				self._super();
	
				function recalcLabels() {
					var maxLabelWidth = 0, labels = [], i, labelGap, items;
	
					if (self.settings.labelGapCalc === false) {
						return;
					}
	
					if (self.settings.labelGapCalc == "children") {
						items = self.find('formitem');
					} else {
						items = self.items();
					}
	
					items.filter('formitem').each(function(item) {
						var labelCtrl = item.items()[0], labelWidth = labelCtrl.getEl().clientWidth;
	
						maxLabelWidth = labelWidth > maxLabelWidth ? labelWidth : maxLabelWidth;
						labels.push(labelCtrl);
					});
	
					labelGap = self.settings.labelGap || 0;
	
					i = labels.length;
					while (i--) {
						labels[i].settings.minWidth = maxLabelWidth + labelGap;
					}
				}
	
				self.on('show', recalcLabels);
				recalcLabels();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FieldSet.js
	
	/**
	 * FieldSet.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates fieldset containers.
	 *
	 * @-x-less FieldSet.less
	 * @class tinymce.ui.FieldSet
	 * @extends tinymce.ui.Form
	 */
	define("tinymce/ui/FieldSet", [
		"tinymce/ui/Form"
	], function(Form) {
		"use strict";
	
		return Form.extend({
			Defaults: {
				containerCls: 'fieldset',
				layout: 'flex',
				direction: 'column',
				align: 'stretch',
				flex: 1,
				padding: "25 15 5 15",
				labelGap: 30,
				spacing: 10,
				border: 1
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, prefix = self.classPrefix;
	
				self.preRender();
				layout.preRender(self);
	
				return (
					'<fieldset id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
						(self.settings.title ? ('<legend id="' + self._id + '-title" class="' + prefix + 'fieldset-title">' +
							self.settings.title + '</legend>') : '') +
						'<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
							(self.settings.html || '') + layout.renderHtml(self) +
						'</div>' +
					'</fieldset>'
				);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FilePicker.js
	
	/**
	 * FilePicker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	/**
	 * This class creates a file picker control.
	 *
	 * @class tinymce.ui.FilePicker
	 * @extends tinymce.ui.ComboBox
	 */
	define("tinymce/ui/FilePicker", [
		"tinymce/ui/ComboBox",
		"tinymce/util/Tools"
	], function(ComboBox, Tools) {
		"use strict";
	
		return ComboBox.extend({
			/**
			 * Constructs a new control instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this, editor = tinymce.activeEditor, editorSettings = editor.settings;
				var actionCallback, fileBrowserCallback, fileBrowserCallbackTypes;
	
				settings.spellcheck = false;
	
				fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
				if (fileBrowserCallbackTypes) {
					fileBrowserCallbackTypes = Tools.makeMap(fileBrowserCallbackTypes, /[, ]/);
				}
	
				if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[settings.filetype]) {
					fileBrowserCallback = editorSettings.file_picker_callback;
					if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[settings.filetype])) {
						actionCallback = function() {
							var meta = self.fire('beforecall').meta;
	
							meta = Tools.extend({filetype: settings.filetype}, meta);
	
							// file_picker_callback(callback, currentValue, metaData)
							fileBrowserCallback.call(
								editor,
								function(value, meta) {
									self.value(value).fire('change', {meta: meta});
								},
								self.value(),
								meta
							);
						};
					} else {
						// Legacy callback: file_picker_callback(id, currentValue, filetype, window)
						fileBrowserCallback = editorSettings.file_browser_callback;
						if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[settings.filetype])) {
							actionCallback = function() {
								fileBrowserCallback(
									self.getEl('inp').id,
									self.value(),
									settings.filetype,
									window
								);
							};
						}
					}
				}
	
				if (actionCallback) {
					settings.icon = 'browse';
					settings.onaction = actionCallback;
				}
	
				self._super(settings);
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FitLayout.js
	
	/**
	 * FitLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager will resize the control to be the size of it's parent container.
	 * In other words width: 100% and height: 100%.
	 *
	 * @-x-less FitLayout.less
	 * @class tinymce.ui.FitLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define("tinymce/ui/FitLayout", [
		"tinymce/ui/AbsoluteLayout"
	], function(AbsoluteLayout) {
		"use strict";
	
		return AbsoluteLayout.extend({
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function(container) {
				var contLayoutRect = container.layoutRect(), paddingBox = container.paddingBox;
	
				container.items().filter(':visible').each(function(ctrl) {
					ctrl.layoutRect({
						x: paddingBox.left,
						y: paddingBox.top,
						w: contLayoutRect.innerW - paddingBox.right - paddingBox.left,
						h: contLayoutRect.innerH - paddingBox.top - paddingBox.bottom
					});
	
					if (ctrl.recalc) {
						ctrl.recalc();
					}
				});
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FlexLayout.js
	
	/**
	 * FlexLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager works similar to the CSS flex box.
	 *
	 * @setting {String} direction row|row-reverse|column|column-reverse
	 * @setting {Number} flex A positive-number to flex by.
	 * @setting {String} align start|end|center|stretch
	 * @setting {String} pack start|end|justify
	 *
	 * @class tinymce.ui.FlexLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define("tinymce/ui/FlexLayout", [
		"tinymce/ui/AbsoluteLayout"
	], function(AbsoluteLayout) {
		"use strict";
	
		return AbsoluteLayout.extend({
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function(container) {
				// A ton of variables, needs to be in the same scope for performance
				var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
				var ctrl, ctrlLayoutRect, ctrlSettings, flex, maxSizeItems = [], size, maxSize, ratio, rect, pos, maxAlignEndPos;
				var sizeName, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
				var alignAxisName, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
				var alignDeltaSizeName, alignContentSizeName;
				var max = Math.max, min = Math.min;
	
				// Get container items, properties and settings
				items = container.items().filter(':visible');
				contLayoutRect = container.layoutRect();
				contPaddingBox = container.paddingBox;
				contSettings = container.settings;
				direction = container.isRtl() ? (contSettings.direction || 'row-reversed') : contSettings.direction;
				align = contSettings.align;
				pack = container.isRtl() ? (contSettings.pack || 'end') : contSettings.pack;
				spacing = contSettings.spacing || 0;
	
				if (direction == "row-reversed" || direction == "column-reverse") {
					items = items.set(items.toArray().reverse());
					direction = direction.split('-')[0];
				}
	
				// Setup axis variable name for row/column direction since the calculations is the same
				if (direction == "column") {
					posName = "y";
					sizeName = "h";
					minSizeName = "minH";
					maxSizeName = "maxH";
					innerSizeName = "innerH";
					beforeName = 'top';
					deltaSizeName = "deltaH";
					contentSizeName = "contentH";
	
					alignBeforeName = "left";
					alignSizeName = "w";
					alignAxisName = "x";
					alignInnerSizeName = "innerW";
					alignMinSizeName = "minW";
					alignAfterName = "right";
					alignDeltaSizeName = "deltaW";
					alignContentSizeName = "contentW";
				} else {
					posName = "x";
					sizeName = "w";
					minSizeName = "minW";
					maxSizeName = "maxW";
					innerSizeName = "innerW";
					beforeName = 'left';
					deltaSizeName = "deltaW";
					contentSizeName = "contentW";
	
					alignBeforeName = "top";
					alignSizeName = "h";
					alignAxisName = "y";
					alignInnerSizeName = "innerH";
					alignMinSizeName = "minH";
					alignAfterName = "bottom";
					alignDeltaSizeName = "deltaH";
					alignContentSizeName = "contentH";
				}
	
				// Figure out total flex, availableSpace and collect any max size elements
				availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
				maxAlignEndPos = totalFlex = 0;
				for (i = 0, l = items.length; i < l; i++) {
					ctrl = items[i];
					ctrlLayoutRect = ctrl.layoutRect();
					ctrlSettings = ctrl.settings;
					flex = ctrlSettings.flex;
					availableSpace -= (i < l - 1 ? spacing : 0);
	
					if (flex > 0) {
						totalFlex += flex;
	
						// Flexed item has a max size then we need to check if we will hit that size
						if (ctrlLayoutRect[maxSizeName]) {
							maxSizeItems.push(ctrl);
						}
	
						ctrlLayoutRect.flex = flex;
					}
	
					availableSpace -= ctrlLayoutRect[minSizeName];
	
					// Calculate the align end position to be used to check for overflow/underflow
					size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
					if (size > maxAlignEndPos) {
						maxAlignEndPos = size;
					}
				}
	
				// Calculate minW/minH
				rect = {};
				if (availableSpace < 0) {
					rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName];
				} else {
					rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName];
				}
	
				rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[alignDeltaSizeName];
	
				rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
				rect[alignContentSizeName] = maxAlignEndPos;
				rect.minW = min(rect.minW, contLayoutRect.maxW);
				rect.minH = min(rect.minH, contLayoutRect.maxH);
				rect.minW = max(rect.minW, contLayoutRect.startMinWidth);
				rect.minH = max(rect.minH, contLayoutRect.startMinHeight);
	
				// Resize container container if minSize was changed
				if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
					rect.w = rect.minW;
					rect.h = rect.minH;
	
					container.layoutRect(rect);
					this.recalc(container);
	
					// Forced recalc for example if items are hidden/shown
					if (container._lastRect === null) {
						var parentCtrl = container.parent();
						if (parentCtrl) {
							parentCtrl._lastRect = null;
							parentCtrl.recalc();
						}
					}
	
					return;
				}
	
				// Handle max size elements, check if they will become to wide with current options
				ratio = availableSpace / totalFlex;
				for (i = 0, l = maxSizeItems.length; i < l; i++) {
					ctrl = maxSizeItems[i];
					ctrlLayoutRect = ctrl.layoutRect();
					maxSize = ctrlLayoutRect[maxSizeName];
					size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
	
					if (size > maxSize) {
						availableSpace -= (ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName]);
						totalFlex -= ctrlLayoutRect.flex;
						ctrlLayoutRect.flex = 0;
						ctrlLayoutRect.maxFlexSize = maxSize;
					} else {
						ctrlLayoutRect.maxFlexSize = 0;
					}
				}
	
				// Setup new ratio, target layout rect, start position
				ratio = availableSpace / totalFlex;
				pos = contPaddingBox[beforeName];
				rect = {};
	
				// Handle pack setting moves the start position to end, center
				if (totalFlex === 0) {
					if (pack == "end") {
						pos = availableSpace + contPaddingBox[beforeName];
					} else if (pack == "center") {
						pos = Math.round(
							(contLayoutRect[innerSizeName] / 2) - ((contLayoutRect[innerSizeName] - availableSpace) / 2)
						) + contPaddingBox[beforeName];
	
						if (pos < 0) {
							pos = contPaddingBox[beforeName];
						}
					} else if (pack == "justify") {
						pos = contPaddingBox[beforeName];
						spacing = Math.floor(availableSpace / (items.length - 1));
					}
				}
	
				// Default aligning (start) the other ones needs to be calculated while doing the layout
				rect[alignAxisName] = contPaddingBox[alignBeforeName];
	
				// Start laying out controls
				for (i = 0, l = items.length; i < l; i++) {
					ctrl = items[i];
					ctrlLayoutRect = ctrl.layoutRect();
					size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
	
					// Align the control on the other axis
					if (align === "center") {
						rect[alignAxisName] = Math.round((contLayoutRect[alignInnerSizeName] / 2) - (ctrlLayoutRect[alignSizeName] / 2));
					} else if (align === "stretch") {
						rect[alignSizeName] = max(
							ctrlLayoutRect[alignMinSizeName] || 0,
							contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]
						);
						rect[alignAxisName] = contPaddingBox[alignBeforeName];
					} else if (align === "end") {
						rect[alignAxisName] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top;
					}
	
					// Calculate new size based on flex
					if (ctrlLayoutRect.flex > 0) {
						size += ctrlLayoutRect.flex * ratio;
					}
	
					rect[sizeName] = size;
					rect[posName] = pos;
					ctrl.layoutRect(rect);
	
					// Recalculate containers
					if (ctrl.recalc) {
						ctrl.recalc();
					}
	
					// Move x/y position
					pos += size + spacing;
				}
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FlowLayout.js
	
	/**
	 * FlowLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager will place the controls by using the browsers native layout.
	 *
	 * @-x-less FlowLayout.less
	 * @class tinymce.ui.FlowLayout
	 * @extends tinymce.ui.Layout
	 */
	define("tinymce/ui/FlowLayout", [
		"tinymce/ui/Layout"
	], function(Layout) {
		return Layout.extend({
			Defaults: {
				containerClass: 'flow-layout',
				controlClass: 'flow-layout-item',
				endClass: 'break'
			},
	
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function(container) {
				container.items().filter(':visible').each(function(ctrl) {
					if (ctrl.recalc) {
						ctrl.recalc();
					}
				});
			},
	
			isNative: function() {
				return true;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/FormatControls.js
	
	/**
	 * FormatControls.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class containing all TinyMCE specific control types such as
	 * format listboxes, fontlist boxes, toolbar buttons etc.
	 *
	 * @class tinymce.ui.FormatControls
	 */
	define("tinymce/ui/FormatControls", [
		"tinymce/ui/Control",
		"tinymce/ui/Widget",
		"tinymce/ui/FloatPanel",
		"tinymce/util/Tools",
		"tinymce/dom/DOMUtils",
		"tinymce/EditorManager",
		"tinymce/Env"
	], function(Control, Widget, FloatPanel, Tools, DOMUtils, EditorManager, Env) {
		var each = Tools.each;
	
		EditorManager.on('AddEditor', function(e) {
			var editor = e.editor;
	
			setupRtlMode(editor);
			registerControls(editor);
			setupContainer(editor);
		});
	
		Control.translate = function(text) {
			return EditorManager.translate(text);
		};
	
		Widget.tooltips = !Env.iOS;
	
		function setupContainer(editor) {
			if (editor.settings.ui_container) {
				Env.container = DOMUtils.DOM.select(editor.settings.ui_container)[0];
			}
		}
	
		function setupRtlMode(editor) {
			editor.on('ScriptsLoaded', function () {
				if (editor.rtl) {
					Control.rtl = true;
				}
			});
		}
	
		function registerControls(editor) {
			var formatMenu;
	
			function createListBoxChangeHandler(items, formatName) {
				return function() {
					var self = this;
	
					editor.on('nodeChange', function(e) {
						var formatter = editor.formatter;
						var value = null;
	
						each(e.parents, function(node) {
							each(items, function(item) {
								if (formatName) {
									if (formatter.matchNode(node, formatName, {value: item.value})) {
										value = item.value;
									}
								} else {
									if (formatter.matchNode(node, item.value)) {
										value = item.value;
									}
								}
	
								if (value) {
									return false;
								}
							});
	
							if (value) {
								return false;
							}
						});
	
						self.value(value);
					});
				};
			}
	
			function createFormats(formats) {
				formats = formats.replace(/;$/, '').split(';');
	
				var i = formats.length;
				while (i--) {
					formats[i] = formats[i].split('=');
				}
	
				return formats;
			}
	
			function createFormatMenu() {
				var count = 0, newFormats = [];
	
				var defaultStyleFormats = [
					{title: 'Headings', items: [
						{title: 'Heading 1', format: 'h1'},
						{title: 'Heading 2', format: 'h2'},
						{title: 'Heading 3', format: 'h3'},
						{title: 'Heading 4', format: 'h4'},
						{title: 'Heading 5', format: 'h5'},
						{title: 'Heading 6', format: 'h6'}
					]},
	
					{title: 'Inline', items: [
						{title: 'Bold', icon: 'bold', format: 'bold'},
						{title: 'Italic', icon: 'italic', format: 'italic'},
						{title: 'Underline', icon: 'underline', format: 'underline'},
						{title: 'Strikethrough', icon: 'strikethrough', format: 'strikethrough'},
						{title: 'Superscript', icon: 'superscript', format: 'superscript'},
						{title: 'Subscript', icon: 'subscript', format: 'subscript'},
						{title: 'Code', icon: 'code', format: 'code'}
					]},
	
					{title: 'Blocks', items: [
						{title: 'Paragraph', format: 'p'},
						{title: 'Blockquote', format: 'blockquote'},
						{title: 'Div', format: 'div'},
						{title: 'Pre', format: 'pre'}
					]},
	
					{title: 'Alignment', items: [
						{title: 'Left', icon: 'alignleft', format: 'alignleft'},
						{title: 'Center', icon: 'aligncenter', format: 'aligncenter'},
						{title: 'Right', icon: 'alignright', format: 'alignright'},
						{title: 'Justify', icon: 'alignjustify', format: 'alignjustify'}
					]}
				];
	
				function createMenu(formats) {
					var menu = [];
	
					if (!formats) {
						return;
					}
	
					each(formats, function(format) {
						var menuItem = {
							text: format.title,
							icon: format.icon
						};
	
						if (format.items) {
							menuItem.menu = createMenu(format.items);
						} else {
							var formatName = format.format || "custom" + count++;
	
							if (!format.format) {
								format.name = formatName;
								newFormats.push(format);
							}
	
							menuItem.format = formatName;
							menuItem.cmd = format.cmd;
						}
	
						menu.push(menuItem);
					});
	
					return menu;
				}
	
				function createStylesMenu() {
					var menu;
	
					if (editor.settings.style_formats_merge) {
						if (editor.settings.style_formats) {
							menu = createMenu(defaultStyleFormats.concat(editor.settings.style_formats));
						} else {
							menu = createMenu(defaultStyleFormats);
						}
					} else {
						menu = createMenu(editor.settings.style_formats || defaultStyleFormats);
					}
	
					return menu;
				}
	
				editor.on('init', function() {
					each(newFormats, function(format) {
						editor.formatter.register(format.name, format);
					});
				});
	
				return {
					type: 'menu',
					items: createStylesMenu(),
					onPostRender: function(e) {
						editor.fire('renderFormatsMenu', {control: e.control});
					},
					itemDefaults: {
						preview: true,
	
						textStyle: function() {
							if (this.settings.format) {
								return editor.formatter.getCssText(this.settings.format);
							}
						},
	
						onPostRender: function() {
							var self = this;
	
							self.parent().on('show', function() {
								var formatName, command;
	
								formatName = self.settings.format;
								if (formatName) {
									self.disabled(!editor.formatter.canApply(formatName));
									self.active(editor.formatter.match(formatName));
								}
	
								command = self.settings.cmd;
								if (command) {
									self.active(editor.queryCommandState(command));
								}
							});
						},
	
						onclick: function() {
							if (this.settings.format) {
								toggleFormat(this.settings.format);
							}
	
							if (this.settings.cmd) {
								editor.execCommand(this.settings.cmd);
							}
						}
					}
				};
			}
	
			formatMenu = createFormatMenu();
	
			function initOnPostRender(name) {
				return function() {
					var self = this;
	
					// TODO: Fix this
					if (editor.formatter) {
						editor.formatter.formatChanged(name, function(state) {
							self.active(state);
						});
					} else {
						editor.on('init', function() {
							editor.formatter.formatChanged(name, function(state) {
								self.active(state);
							});
						});
					}
				};
			}
	
			// Simple format controls <control/format>:<UI text>
			each({
				bold: 'Bold',
				italic: 'Italic',
				underline: 'Underline',
				strikethrough: 'Strikethrough',
				subscript: 'Subscript',
				superscript: 'Superscript'
			}, function(text, name) {
				editor.addButton(name, {
					tooltip: text,
					onPostRender: initOnPostRender(name),
					onclick: function() {
						toggleFormat(name);
					}
				});
			});
	
			// Simple command controls <control>:[<UI text>,<Command>]
			each({
				outdent: ['Decrease indent', 'Outdent'],
				indent: ['Increase indent', 'Indent'],
				cut: ['Cut', 'Cut'],
				copy: ['Copy', 'Copy'],
				paste: ['Paste', 'Paste'],
				help: ['Help', 'mceHelp'],
				selectall: ['Select all', 'SelectAll'],
				removeformat: ['Clear formatting', 'RemoveFormat'],
				visualaid: ['Visual aids', 'mceToggleVisualAid'],
				newdocument: ['New document', 'mceNewDocument']
			}, function(item, name) {
				editor.addButton(name, {
					tooltip: item[0],
					cmd: item[1]
				});
			});
	
			// Simple command controls with format state
			each({
				blockquote: ['Blockquote', 'mceBlockQuote'],
				numlist: ['Numbered list', 'InsertOrderedList'],
				bullist: ['Bullet list', 'InsertUnorderedList'],
				subscript: ['Subscript', 'Subscript'],
				superscript: ['Superscript', 'Superscript'],
				alignleft: ['Align left', 'JustifyLeft'],
				aligncenter: ['Align center', 'JustifyCenter'],
				alignright: ['Align right', 'JustifyRight'],
				alignjustify: ['Justify', 'JustifyFull'],
				alignnone: ['No alignment', 'JustifyNone']
			}, function(item, name) {
				editor.addButton(name, {
					tooltip: item[0],
					cmd: item[1],
					onPostRender: initOnPostRender(name)
				});
			});
	
			function toggleUndoRedoState(type) {
				return function() {
					var self = this;
	
					type = type == 'redo' ? 'hasRedo' : 'hasUndo';
	
					function checkState() {
						return editor.undoManager ? editor.undoManager[type]() : false;
					}
	
					self.disabled(!checkState());
					editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function() {
						self.disabled(editor.readonly || !checkState());
					});
				};
			}
	
			function toggleVisualAidState() {
				var self = this;
	
				editor.on('VisualAid', function(e) {
					self.active(e.hasVisual);
				});
	
				self.active(editor.hasVisual);
			}
	
			editor.addButton('undo', {
				tooltip: 'Undo',
				onPostRender: toggleUndoRedoState('undo'),
				cmd: 'undo'
			});
	
			editor.addButton('redo', {
				tooltip: 'Redo',
				onPostRender: toggleUndoRedoState('redo'),
				cmd: 'redo'
			});
	
			editor.addMenuItem('newdocument', {
				text: 'New document',
				icon: 'newdocument',
				cmd: 'mceNewDocument'
			});
	
			editor.addMenuItem('undo', {
				text: 'Undo',
				icon: 'undo',
				shortcut: 'Meta+Z',
				onPostRender: toggleUndoRedoState('undo'),
				cmd: 'undo'
			});
	
			editor.addMenuItem('redo', {
				text: 'Redo',
				icon: 'redo',
				shortcut: 'Meta+Y',
				onPostRender: toggleUndoRedoState('redo'),
				cmd: 'redo'
			});
	
			editor.addMenuItem('visualaid', {
				text: 'Visual aids',
				selectable: true,
				onPostRender: toggleVisualAidState,
				cmd: 'mceToggleVisualAid'
			});
	
			editor.addButton('remove', {
				tooltip: 'Remove',
				icon: 'remove',
				cmd: 'Delete'
			});
	
			each({
				cut: ['Cut', 'Cut', 'Meta+X'],
				copy: ['Copy', 'Copy', 'Meta+C'],
				paste: ['Paste', 'Paste', 'Meta+V'],
				selectall: ['Select all', 'SelectAll', 'Meta+A'],
				bold: ['Bold', 'Bold', 'Meta+B'],
				italic: ['Italic', 'Italic', 'Meta+I'],
				underline: ['Underline', 'Underline'],
				strikethrough: ['Strikethrough', 'Strikethrough'],
				subscript: ['Subscript', 'Subscript'],
				superscript: ['Superscript', 'Superscript'],
				removeformat: ['Clear formatting', 'RemoveFormat']
			}, function(item, name) {
				editor.addMenuItem(name, {
					text: item[0],
					icon: name,
					shortcut: item[2],
					cmd: item[1]
				});
			});
	
			editor.on('mousedown', function() {
				FloatPanel.hideAll();
			});
	
			function toggleFormat(fmt) {
				if (fmt.control) {
					fmt = fmt.control.value();
				}
	
				if (fmt) {
					editor.execCommand('mceToggleFormat', false, fmt);
				}
			}
	
			editor.addButton('styleselect', {
				type: 'menubutton',
				text: 'Formats',
				menu: formatMenu
			});
	
			editor.addButton('formatselect', function() {
				var items = [], blocks = createFormats(editor.settings.block_formats ||
					'Paragraph=p;' +
					'Heading 1=h1;' +
					'Heading 2=h2;' +
					'Heading 3=h3;' +
					'Heading 4=h4;' +
					'Heading 5=h5;' +
					'Heading 6=h6;' +
					'Preformatted=pre'
				);
	
				each(blocks, function(block) {
					items.push({
						text: block[0],
						value: block[1],
						textStyle: function() {
							return editor.formatter.getCssText(block[1]);
						}
					});
				});
	
				return {
					type: 'listbox',
					text: blocks[0][0],
					values: items,
					fixedWidth: true,
					onselect: toggleFormat,
					onPostRender: createListBoxChangeHandler(items)
				};
			});
	
			editor.addButton('fontselect', function() {
				var defaultFontsFormats =
					'Andale Mono=andale mono,monospace;' +
					'Arial=arial,helvetica,sans-serif;' +
					'Arial Black=arial black,sans-serif;' +
					'Book Antiqua=book antiqua,palatino,serif;' +
					'Comic Sans MS=comic sans ms,sans-serif;' +
					'Courier New=courier new,courier,monospace;' +
					'Georgia=georgia,palatino,serif;' +
					'Helvetica=helvetica,arial,sans-serif;' +
					'Impact=impact,sans-serif;' +
					'Symbol=symbol;' +
					'Tahoma=tahoma,arial,helvetica,sans-serif;' +
					'Terminal=terminal,monaco,monospace;' +
					'Times New Roman=times new roman,times,serif;' +
					'Trebuchet MS=trebuchet ms,geneva,sans-serif;' +
					'Verdana=verdana,geneva,sans-serif;' +
					'Webdings=webdings;' +
					'Wingdings=wingdings,zapf dingbats';
	
				var items = [], fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
	
				each(fonts, function(font) {
					items.push({
						text: {raw: font[0]},
						value: font[1],
						textStyle: font[1].indexOf('dings') == -1 ? 'font-family:' + font[1] : ''
					});
				});
	
				return {
					type: 'listbox',
					text: 'Font Family',
					tooltip: 'Font Family',
					values: items,
					fixedWidth: true,
					onPostRender: createListBoxChangeHandler(items, 'fontname'),
					onselect: function(e) {
						if (e.control.settings.value) {
							editor.execCommand('FontName', false, e.control.settings.value);
						}
					}
				};
			});
	
			editor.addButton('fontsizeselect', function() {
				var items = [], defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
				var fontsize_formats = editor.settings.fontsize_formats || defaultFontsizeFormats;
	
				each(fontsize_formats.split(' '), function(item) {
					var text = item, value = item;
					// Allow text=value font sizes.
					var values = item.split('=');
					if (values.length > 1) {
						text = values[0];
						value = values[1];
					}
					items.push({text: text, value: value});
				});
	
				return {
					type: 'listbox',
					text: 'Font Sizes',
					tooltip: 'Font Sizes',
					values: items,
					fixedWidth: true,
					onPostRender: createListBoxChangeHandler(items, 'fontsize'),
					onclick: function(e) {
						if (e.control.settings.value) {
							editor.execCommand('FontSize', false, e.control.settings.value);
						}
					}
				};
			});
	
			editor.addMenuItem('formats', {
				text: 'Formats',
				menu: formatMenu
			});
		}
	});
	
	// Included from: js/tinymce/classes/ui/GridLayout.js
	
	/**
	 * GridLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager places controls in a grid.
	 *
	 * @setting {Number} spacing Spacing between controls.
	 * @setting {Number} spacingH Horizontal spacing between controls.
	 * @setting {Number} spacingV Vertical spacing between controls.
	 * @setting {Number} columns Number of columns to use.
	 * @setting {String/Array} alignH start|end|center|stretch or array of values for each column.
	 * @setting {String/Array} alignV start|end|center|stretch or array of values for each column.
	 * @setting {String} pack start|end
	 *
	 * @class tinymce.ui.GridLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define("tinymce/ui/GridLayout", [
		"tinymce/ui/AbsoluteLayout"
	], function(AbsoluteLayout) {
		"use strict";
	
		return AbsoluteLayout.extend({
			/**
			 * Recalculates the positions of the controls in the specified container.
			 *
			 * @method recalc
			 * @param {tinymce.ui.Container} container Container instance to recalc.
			 */
			recalc: function(container) {
				var settings, rows, cols, items, contLayoutRect, width, height, rect,
					ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY,
					colWidths = [], rowHeights = [], ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
	
				// Get layout settings
				settings = container.settings;
				items = container.items().filter(':visible');
				contLayoutRect = container.layoutRect();
				cols = settings.columns || Math.ceil(Math.sqrt(items.length));
				rows = Math.ceil(items.length / cols);
				spacingH = settings.spacingH || settings.spacing || 0;
				spacingV = settings.spacingV || settings.spacing || 0;
				alignH = settings.alignH || settings.align;
				alignV = settings.alignV || settings.align;
				contPaddingBox = container.paddingBox;
				reverseRows = 'reverseRows' in settings ? settings.reverseRows : container.isRtl();
	
				if (alignH && typeof alignH == "string") {
					alignH = [alignH];
				}
	
				if (alignV && typeof alignV == "string") {
					alignV = [alignV];
				}
	
				// Zero padd columnWidths
				for (x = 0; x < cols; x++) {
					colWidths.push(0);
				}
	
				// Zero padd rowHeights
				for (y = 0; y < rows; y++) {
					rowHeights.push(0);
				}
	
				// Calculate columnWidths and rowHeights
				for (y = 0; y < rows; y++) {
					for (x = 0; x < cols; x++) {
						ctrl = items[y * cols + x];
	
						// Out of bounds
						if (!ctrl) {
							break;
						}
	
						ctrlLayoutRect = ctrl.layoutRect();
						ctrlMinWidth = ctrlLayoutRect.minW;
						ctrlMinHeight = ctrlLayoutRect.minH;
	
						colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
						rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y];
					}
				}
	
				// Calculate maxX
				availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
				for (maxX = 0, x = 0; x < cols; x++) {
					maxX += colWidths[x] + (x > 0 ? spacingH : 0);
					availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x];
				}
	
				// Calculate maxY
				availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
				for (maxY = 0, y = 0; y < rows; y++) {
					maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
					availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y];
				}
	
				maxX += contPaddingBox.left + contPaddingBox.right;
				maxY += contPaddingBox.top + contPaddingBox.bottom;
	
				// Calculate minW/minH
				rect = {};
				rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
				rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
	
				rect.contentW = rect.minW - contLayoutRect.deltaW;
				rect.contentH = rect.minH - contLayoutRect.deltaH;
				rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
				rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
				rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
				rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
	
				// Resize container container if minSize was changed
				if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
					rect.w = rect.minW;
					rect.h = rect.minH;
	
					container.layoutRect(rect);
					this.recalc(container);
	
					// Forced recalc for example if items are hidden/shown
					if (container._lastRect === null) {
						var parentCtrl = container.parent();
						if (parentCtrl) {
							parentCtrl._lastRect = null;
							parentCtrl.recalc();
						}
					}
	
					return;
				}
	
				// Update contentW/contentH so absEnd moves correctly
				if (contLayoutRect.autoResize) {
					rect = container.layoutRect(rect);
					rect.contentW = rect.minW - contLayoutRect.deltaW;
					rect.contentH = rect.minH - contLayoutRect.deltaH;
				}
	
				var flexV;
	
				if (settings.packV == 'start') {
					flexV = 0;
				} else {
					flexV = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0;
				}
	
				// Calculate totalFlex
				var totalFlex = 0;
				var flexWidths = settings.flexWidths;
				if (flexWidths) {
					for (x = 0; x < flexWidths.length; x++) {
						totalFlex += flexWidths[x];
					}
				} else {
					totalFlex = cols;
				}
	
				// Calculate new column widths based on flex values
				var ratio = availableWidth / totalFlex;
				for (x = 0; x < cols; x++) {
					colWidths[x] += flexWidths ? flexWidths[x] * ratio : ratio;
				}
	
				// Move/resize controls
				posY = contPaddingBox.top;
				for (y = 0; y < rows; y++) {
					posX = contPaddingBox.left;
					height = rowHeights[y] + flexV;
	
					for (x = 0; x < cols; x++) {
						if (reverseRows) {
							idx = y * cols + cols - 1 - x;
						} else {
							idx = y * cols + x;
						}
	
						ctrl = items[idx];
	
						// No more controls to render then break
						if (!ctrl) {
							break;
						}
	
						// Get control settings and calculate x, y
						ctrlSettings = ctrl.settings;
						ctrlLayoutRect = ctrl.layoutRect();
						width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
						ctrlLayoutRect.x = posX;
						ctrlLayoutRect.y = posY;
	
						// Align control horizontal
						align = ctrlSettings.alignH || (alignH ? (alignH[x] || alignH[0]) : null);
						if (align == "center") {
							ctrlLayoutRect.x = posX + (width / 2) - (ctrlLayoutRect.w / 2);
						} else if (align == "right") {
							ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w;
						} else if (align == "stretch") {
							ctrlLayoutRect.w = width;
						}
	
						// Align control vertical
						align = ctrlSettings.alignV || (alignV ? (alignV[x] || alignV[0]) : null);
						if (align == "center") {
							ctrlLayoutRect.y = posY + (height / 2) - (ctrlLayoutRect.h / 2);
						} else if (align == "bottom") {
							ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h;
						} else if (align == "stretch") {
							ctrlLayoutRect.h = height;
						}
	
						ctrl.layoutRect(ctrlLayoutRect);
	
						posX += width + spacingH;
	
						if (ctrl.recalc) {
							ctrl.recalc();
						}
					}
	
					posY += height + spacingV;
				}
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Iframe.js
	
	/**
	 * Iframe.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint scripturl:true */
	
	/**
	 * This class creates an iframe.
	 *
	 * @setting {String} url Url to open in the iframe.
	 *
	 * @-x-less Iframe.less
	 * @class tinymce.ui.Iframe
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Iframe", [
		"tinymce/ui/Widget",
		"tinymce/util/Delay"
	], function(Widget, Delay) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this;
	
				self.classes.add('iframe');
				self.canFocus = false;
	
				/*eslint no-script-url:0 */
				return (
					'<iframe id="' + self._id + '" class="' + self.classes + '" tabindex="-1" src="' +
					(self.settings.url || "javascript:''") + '" frameborder="0"></iframe>'
				);
			},
	
			/**
			 * Setter for the iframe source.
			 *
			 * @method src
			 * @param {String} src Source URL for iframe.
			 */
			src: function(src) {
				this.getEl().src = src;
			},
	
			/**
			 * Inner HTML for the iframe.
			 *
			 * @method html
			 * @param {String} html HTML string to set as HTML inside the iframe.
			 * @param {function} callback Optional callback to execute when the iframe body is filled with contents.
			 * @return {tinymce.ui.Iframe} Current iframe control.
			 */
			html: function(html, callback) {
				var self = this, body = this.getEl().contentWindow.document.body;
	
				// Wait for iframe to initialize IE 10 takes time
				if (!body) {
					Delay.setTimeout(function() {
						self.html(html);
					});
				} else {
					body.innerHTML = html;
	
					if (callback) {
						callback();
					}
				}
	
				return this;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/InfoBox.js
	
	/**
	 * InfoBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * ....
	 *
	 * @-x-less InfoBox.less
	 * @class tinymce.ui.InfoBox
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/InfoBox", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} multiline Multiline label.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				self.classes.add('widget').add('infobox');
				self.canFocus = false;
			},
	
			severity: function(level) {
				this.classes.remove('error');
				this.classes.remove('warning');
				this.classes.remove('success');
				this.classes.add(level);
			},
	
			help: function(state) {
				this.state.set('help', state);
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, prefix = self.classPrefix;
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '">' +
						'<div id="' + self._id + '-body">' +
							self.encode(self.state.get('text')) +
							'<button role="button" tabindex="-1">' +
								'<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' +
							'</button>' +
						'</div>' +
					'</div>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:text', function(e) {
					self.getEl('body').firstChild.data = self.encode(e.value);
	
					if (self.state.get('rendered')) {
						self.updateLayoutRect();
					}
				});
	
				self.state.on('change:help', function(e) {
					self.classes.toggle('has-help', e.value);
	
					if (self.state.get('rendered')) {
						self.updateLayoutRect();
					}
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Label.js
	
	/**
	 * Label.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a label element. A label is a simple text control
	 * that can be bound to other controls.
	 *
	 * @-x-less Label.less
	 * @class tinymce.ui.Label
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Label", [
		"tinymce/ui/Widget",
		"tinymce/ui/DomUtils"
	], function(Widget, DomUtils) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} multiline Multiline label.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				self.classes.add('widget').add('label');
				self.canFocus = false;
	
				if (settings.multiline) {
					self.classes.add('autoscroll');
				}
	
				if (settings.strong) {
					self.classes.add('strong');
				}
			},
	
			/**
			 * Initializes the current controls layout rect.
			 * This will be executed by the layout managers to determine the
			 * default minWidth/minHeight etc.
			 *
			 * @method initLayoutRect
			 * @return {Object} Layout rect instance.
			 */
			initLayoutRect: function() {
				var self = this, layoutRect = self._super();
	
				if (self.settings.multiline) {
					var size = DomUtils.getSize(self.getEl());
	
					// Check if the text fits within maxW if not then try word wrapping it
					if (size.width > layoutRect.maxW) {
						layoutRect.minW = layoutRect.maxW;
						self.classes.add('multiline');
					}
	
					self.getEl().style.width = layoutRect.minW + 'px';
					layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, DomUtils.getSize(self.getEl()).height);
				}
	
				return layoutRect;
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this;
	
				if (!self.settings.multiline) {
					self.getEl().style.lineHeight = self.layoutRect().h + 'px';
				}
	
				return self._super();
			},
	
			severity: function(level) {
				this.classes.remove('error');
				this.classes.remove('warning');
				this.classes.remove('success');
				this.classes.add(level);
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, targetCtrl, forName, forId = self.settings.forId;
	
				if (!forId && (forName = self.settings.forName)) {
					targetCtrl = self.getRoot().find('#' + forName)[0];
	
					if (targetCtrl) {
						forId = targetCtrl._id;
					}
				}
	
				if (forId) {
					return (
						'<label id="' + self._id + '" class="' + self.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' +
							self.encode(self.state.get('text')) +
						'</label>'
					);
				}
	
				return (
					'<span id="' + self._id + '" class="' + self.classes + '">' +
						self.encode(self.state.get('text')) +
					'</span>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:text', function(e) {
					self.innerHtml(self.encode(e.value));
	
					if (self.state.get('rendered')) {
						self.updateLayoutRect();
					}
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Toolbar.js
	
	/**
	 * Toolbar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new toolbar.
	 *
	 * @class tinymce.ui.Toolbar
	 * @extends tinymce.ui.Container
	 */
	define("tinymce/ui/Toolbar", [
		"tinymce/ui/Container"
	], function(Container) {
		"use strict";
	
		return Container.extend({
			Defaults: {
				role: 'toolbar',
				layout: 'flow'
			},
	
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
				self.classes.add('toolbar');
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self.items().each(function(ctrl) {
					ctrl.classes.add('toolbar-item');
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/MenuBar.js
	
	/**
	 * MenuBar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menubar.
	 *
	 * @-x-less MenuBar.less
	 * @class tinymce.ui.MenuBar
	 * @extends tinymce.ui.Container
	 */
	define("tinymce/ui/MenuBar", [
		"tinymce/ui/Toolbar"
	], function(Toolbar) {
		"use strict";
	
		return Toolbar.extend({
			Defaults: {
				role: 'menubar',
				containerCls: 'menubar',
				ariaRoot: true,
				defaults: {
					type: 'menubutton'
				}
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/MenuButton.js
	
	/**
	 * MenuButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu button.
	 *
	 * @-x-less MenuButton.less
	 * @class tinymce.ui.MenuButton
	 * @extends tinymce.ui.Button
	 */
	define("tinymce/ui/MenuButton", [
		"tinymce/ui/Button",
		"tinymce/ui/Factory",
		"tinymce/ui/MenuBar"
	], function(Button, Factory, MenuBar) {
		"use strict";
	
		// TODO: Maybe add as some global function
		function isChildOf(node, parent) {
			while (node) {
				if (parent === node) {
					return true;
				}
	
				node = node.parentNode;
			}
	
			return false;
		}
	
		var MenuButton = Button.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this;
	
				self._renderOpen = true;
	
				self._super(settings);
				settings = self.settings;
	
				self.classes.add('menubtn');
	
				if (settings.fixedWidth) {
					self.classes.add('fixed-width');
				}
	
				self.aria('haspopup', true);
	
				self.state.set('menu', settings.menu || self.render());
			},
	
			/**
			 * Shows the menu for the button.
			 *
			 * @method showMenu
			 */
			showMenu: function() {
				var self = this, menu;
	
				if (self.menu && self.menu.visible()) {
					return self.hideMenu();
				}
	
				if (!self.menu) {
					menu = self.state.get('menu') || [];
	
					// Is menu array then auto constuct menu control
					if (menu.length) {
						menu = {
							type: 'menu',
							items: menu
						};
					} else {
						menu.type = menu.type || 'menu';
					}
	
					if (!menu.renderTo) {
						self.menu = Factory.create(menu).parent(self).renderTo();
					} else {
						self.menu = menu.parent(self).show().renderTo();
					}
	
					self.fire('createmenu');
					self.menu.reflow();
					self.menu.on('cancel', function(e) {
						if (e.control.parent() === self.menu) {
							e.stopPropagation();
							self.focus();
							self.hideMenu();
						}
					});
	
					// Move focus to button when a menu item is selected/clicked
					self.menu.on('select', function() {
						self.focus();
					});
	
					self.menu.on('show hide', function(e) {
						if (e.control == self.menu) {
							self.activeMenu(e.type == 'show');
						}
	
						self.aria('expanded', e.type == 'show');
					}).fire('show');
				}
	
				self.menu.show();
				self.menu.layoutRect({w: self.layoutRect().w});
				self.menu.moveRel(self.getEl(), self.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
			},
	
			/**
			 * Hides the menu for the button.
			 *
			 * @method hideMenu
			 */
			hideMenu: function() {
				var self = this;
	
				if (self.menu) {
					self.menu.items().each(function(item) {
						if (item.hideMenu) {
							item.hideMenu();
						}
					});
	
					self.menu.hide();
				}
			},
	
			/**
			 * Sets the active menu state.
			 *
			 * @private
			 */
			activeMenu: function(state) {
				this.classes.toggle('active', state);
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix;
				var icon = self.settings.icon, image, text = self.state.get('text'),
					textHtml = '';
	
				image = self.settings.image;
				if (image) {
					icon = 'none';
	
					// Support for [high dpi, low dpi] image sources
					if (typeof image != "string") {
						image = window.getSelection ? image[0] : image[1];
					}
	
					image = ' style="background-image: url(\'' + image + '\')"';
				} else {
					image = '';
				}
	
				if (text) {
					self.classes.add('btn-has-text');
					textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
				}
	
				icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	
				self.aria('role', self.parent() instanceof MenuBar ? 'menuitem' : 'button');
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" tabindex="-1" aria-labelledby="' + id + '">' +
						'<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' +
							(icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
							textHtml +
							' <i class="' + prefix + 'caret"></i>' +
						'</button>' +
					'</div>'
				);
			},
	
			/**
			 * Gets invoked after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self.on('click', function(e) {
					if (e.control === self && isChildOf(e.target, self.getEl())) {
						self.showMenu();
	
						if (e.aria) {
							self.menu.items()[0].focus();
						}
					}
				});
	
				self.on('mouseenter', function(e) {
					var overCtrl = e.control, parent = self.parent(), hasVisibleSiblingMenu;
	
					if (overCtrl && parent && overCtrl instanceof MenuButton && overCtrl.parent() == parent) {
						parent.items().filter('MenuButton').each(function(ctrl) {
							if (ctrl.hideMenu && ctrl != overCtrl) {
								if (ctrl.menu && ctrl.menu.visible()) {
									hasVisibleSiblingMenu = true;
								}
	
								ctrl.hideMenu();
							}
						});
	
						if (hasVisibleSiblingMenu) {
							overCtrl.focus(); // Fix for: #5887
							overCtrl.showMenu();
						}
					}
				});
	
				return self._super();
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:menu', function() {
					if (self.menu) {
						self.menu.remove();
					}
	
					self.menu = null;
				});
	
				return self._super();
			},
	
			/**
			 * Removes the control and it's menus.
			 *
			 * @method remove
			 */
			remove: function() {
				this._super();
	
				if (this.menu) {
					this.menu.remove();
				}
			}
		});
	
		return MenuButton;
	});
	
	// Included from: js/tinymce/classes/ui/MenuItem.js
	
	/**
	 * MenuItem.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu item.
	 *
	 * @-x-less MenuItem.less
	 * @class tinymce.ui.MenuItem
	 * @extends tinymce.ui.Control
	 */
	define("tinymce/ui/MenuItem", [
		"tinymce/ui/Widget",
		"tinymce/ui/Factory",
		"tinymce/Env",
		"tinymce/util/Delay"
	], function(Widget, Factory, Env, Delay) {
		"use strict";
	
		return Widget.extend({
			Defaults: {
				border: 0,
				role: 'menuitem'
			},
	
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} selectable Selectable menu.
			 * @setting {Array} menu Submenu array with items.
			 * @setting {String} shortcut Shortcut to display for menu item. Example: Ctrl+X
			 */
			init: function(settings) {
				var self = this, text;
	
				self._super(settings);
	
				settings = self.settings;
	
				self.classes.add('menu-item');
	
				if (settings.menu) {
					self.classes.add('menu-item-expand');
				}
	
				if (settings.preview) {
					self.classes.add('menu-item-preview');
				}
	
				text = self.state.get('text');
				if (text === '-' || text === '|') {
					self.classes.add('menu-item-sep');
					self.aria('role', 'separator');
					self.state.set('text', '-');
				}
	
				if (settings.selectable) {
					self.aria('role', 'menuitemcheckbox');
					self.classes.add('menu-item-checkbox');
					settings.icon = 'selected';
				}
	
				if (!settings.preview && !settings.selectable) {
					self.classes.add('menu-item-normal');
				}
	
				self.on('mousedown', function(e) {
					e.preventDefault();
				});
	
				if (settings.menu && !settings.ariaHideMenu) {
					self.aria('haspopup', true);
				}
			},
	
			/**
			 * Returns true/false if the menuitem has sub menu.
			 *
			 * @method hasMenus
			 * @return {Boolean} True/false state if it has submenu.
			 */
			hasMenus: function() {
				return !!this.settings.menu;
			},
	
			/**
			 * Shows the menu for the menu item.
			 *
			 * @method showMenu
			 */
			showMenu: function() {
				var self = this, settings = self.settings, menu, parent = self.parent();
	
				parent.items().each(function(ctrl) {
					if (ctrl !== self) {
						ctrl.hideMenu();
					}
				});
	
				if (settings.menu) {
					menu = self.menu;
	
					if (!menu) {
						menu = settings.menu;
	
						// Is menu array then auto constuct menu control
						if (menu.length) {
							menu = {
								type: 'menu',
								items: menu
							};
						} else {
							menu.type = menu.type || 'menu';
						}
	
						if (parent.settings.itemDefaults) {
							menu.itemDefaults = parent.settings.itemDefaults;
						}
	
						menu = self.menu = Factory.create(menu).parent(self).renderTo();
						menu.reflow();
						menu.on('cancel', function(e) {
							e.stopPropagation();
							self.focus();
							menu.hide();
						});
						menu.on('show hide', function(e) {
							e.control.items().each(function(ctrl) {
								ctrl.active(ctrl.settings.selected);
							});
						}).fire('show');
	
						menu.on('hide', function(e) {
							if (e.control === menu) {
								self.classes.remove('selected');
							}
						});
	
						menu.submenu = true;
					} else {
						menu.show();
					}
	
					menu._parentMenu = parent;
	
					menu.classes.add('menu-sub');
	
					var rel = menu.testMoveRel(
						self.getEl(),
						self.isRtl() ? ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'] : ['tr-tl', 'br-bl', 'tl-tr', 'bl-br']
					);
	
					menu.moveRel(self.getEl(), rel);
					menu.rel = rel;
	
					rel = 'menu-sub-' + rel;
					menu.classes.remove(menu._lastRel).add(rel);
					menu._lastRel = rel;
	
					self.classes.add('selected');
					self.aria('expanded', true);
				}
			},
	
			/**
			 * Hides the menu for the menu item.
			 *
			 * @method hideMenu
			 */
			hideMenu: function() {
				var self = this;
	
				if (self.menu) {
					self.menu.items().each(function(item) {
						if (item.hideMenu) {
							item.hideMenu();
						}
					});
	
					self.menu.hide();
					self.aria('expanded', false);
				}
	
				return self;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix, text = self.encode(self.state.get('text'));
				var icon = self.settings.icon, image = '', shortcut = settings.shortcut;
	
				// Converts shortcut format to Mac/PC variants
				function convertShortcut(shortcut) {
					var i, value, replace = {};
	
					if (Env.mac) {
						replace = {
							alt: '&#x2325;',
							ctrl: '&#x2318;',
							shift: '&#x21E7;',
							meta: '&#x2318;'
						};
					} else {
						replace = {
							meta: 'Ctrl'
						};
					}
	
					shortcut = shortcut.split('+');
	
					for (i = 0; i < shortcut.length; i++) {
						value = replace[shortcut[i].toLowerCase()];
	
						if (value) {
							shortcut[i] = value;
						}
					}
	
					return shortcut.join('+');
				}
	
				if (icon) {
					self.parent().classes.add('menu-has-icons');
				}
	
				if (settings.image) {
					image = ' style="background-image: url(\'' + settings.image + '\')"';
				}
	
				if (shortcut) {
					shortcut = convertShortcut(shortcut);
				}
	
				icon = prefix + 'ico ' + prefix + 'i-' + (self.settings.icon || 'none');
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" tabindex="-1">' +
						(text !== '-' ? '<i class="' + icon + '"' + image + '></i>\u00a0' : '') +
						(text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') +
						(shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') +
						(settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') +
					'</div>'
				);
			},
	
			/**
			 * Gets invoked after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this, settings = self.settings;
	
				var textStyle = settings.textStyle;
				if (typeof textStyle == "function") {
					textStyle = textStyle.call(this);
				}
	
				if (textStyle) {
					var textElm = self.getEl('text');
					if (textElm) {
						textElm.setAttribute('style', textStyle);
					}
				}
	
				self.on('mouseenter click', function(e) {
					if (e.control === self) {
						if (!settings.menu && e.type === 'click') {
							self.fire('select');
	
							// Edge will crash if you stress it see #2660
							Delay.requestAnimationFrame(function() {
								self.parent().hideAll();
							});
						} else {
							self.showMenu();
	
							if (e.aria) {
								self.menu.focus(true);
							}
						}
					}
				});
	
				self._super();
	
				return self;
			},
	
			hover: function() {
				var self = this;
	
				self.parent().items().each(function(ctrl) {
					ctrl.classes.remove('selected');
				});
	
				self.classes.toggle('selected', true);
	
				return self;
			},
	
			active: function(state) {
				if (typeof state != "undefined") {
					this.aria('checked', state);
				}
	
				return this._super(state);
			},
	
			/**
			 * Removes the control and it's menus.
			 *
			 * @method remove
			 */
			remove: function() {
				this._super();
	
				if (this.menu) {
					this.menu.remove();
				}
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Throbber.js
	
	/**
	 * Throbber.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to display a Throbber for any element.
	 *
	 * @-x-less Throbber.less
	 * @class tinymce.ui.Throbber
	 */
	define("tinymce/ui/Throbber", [
		"tinymce/dom/DomQuery",
		"tinymce/ui/Control",
		"tinymce/util/Delay"
	], function($, Control, Delay) {
		"use strict";
	
		/**
		 * Constructs a new throbber.
		 *
		 * @constructor
		 * @param {Element} elm DOM Html element to display throbber in.
		 * @param {Boolean} inline Optional true/false state if the throbber should be appended to end of element for infinite scroll.
		 */
		return function(elm, inline) {
			var self = this, state, classPrefix = Control.classPrefix, timer;
	
			/**
			 * Shows the throbber.
			 *
			 * @method show
			 * @param {Number} [time] Time to wait before showing.
			 * @param {function} [callback] Optional callback to execute when the throbber is shown.
			 * @return {tinymce.ui.Throbber} Current throbber instance.
			 */
			self.show = function(time, callback) {
				function render() {
						if (state) {
							$(elm).append(
								'<div class="' + classPrefix + 'throbber' + (inline ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>'
							);
	
							if (callback) {
								callback();
							}
						}
				}
	
				self.hide();
	
				state = true;
	
				if (time) {
					timer = Delay.setTimeout(render, time);
				} else {
					render();
				}
	
				return self;
			};
	
			/**
			 * Hides the throbber.
			 *
			 * @method hide
			 * @return {tinymce.ui.Throbber} Current throbber instance.
			 */
			self.hide = function() {
				var child = elm.lastChild;
	
				Delay.clearTimeout(timer);
	
				if (child && child.className.indexOf('throbber') != -1) {
					child.parentNode.removeChild(child);
				}
	
				state = false;
	
				return self;
			};
		};
	});
	
	// Included from: js/tinymce/classes/ui/Menu.js
	
	/**
	 * Menu.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu.
	 *
	 * @-x-less Menu.less
	 * @class tinymce.ui.Menu
	 * @extends tinymce.ui.FloatPanel
	 */
	define("tinymce/ui/Menu", [
		"tinymce/ui/FloatPanel",
		"tinymce/ui/MenuItem",
		"tinymce/ui/Throbber",
		"tinymce/util/Tools"
	], function(FloatPanel, MenuItem, Throbber, Tools) {
		"use strict";
	
		return FloatPanel.extend({
			Defaults: {
				defaultType: 'menuitem',
				border: 1,
				layout: 'stack',
				role: 'application',
				bodyRole: 'menu',
				ariaRoot: true
			},
	
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 */
			init: function(settings) {
				var self = this;
	
				settings.autohide = true;
				settings.constrainToViewport = true;
	
				if (typeof settings.items === 'function') {
					settings.itemsFactory = settings.items;
					settings.items = [];
				}
	
				if (settings.itemDefaults) {
					var items = settings.items, i = items.length;
	
					while (i--) {
						items[i] = Tools.extend({}, settings.itemDefaults, items[i]);
					}
				}
	
				self._super(settings);
				self.classes.add('menu');
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				this.classes.toggle('menu-align', true);
	
				this._super();
	
				this.getEl().style.height = '';
				this.getEl('body').style.height = '';
	
				return this;
			},
	
			/**
			 * Hides/closes the menu.
			 *
			 * @method cancel
			 */
			cancel: function() {
				var self = this;
	
				self.hideAll();
				self.fire('select');
			},
	
			/**
			 * Loads new items from the factory items function.
			 *
			 * @method load
			 */
			load: function() {
				var self = this, time, factory;
	
				function hideThrobber() {
					if (self.throbber) {
						self.throbber.hide();
						self.throbber = null;
					}
				}
	
				factory = self.settings.itemsFactory;
				if (!factory) {
					return;
				}
	
				if (!self.throbber) {
					self.throbber = new Throbber(self.getEl('body'), true);
	
					if (self.items().length === 0) {
						self.throbber.show();
						self.fire('loading');
					} else {
						self.throbber.show(100, function() {
							self.items().remove();
							self.fire('loading');
						});
					}
	
					self.on('hide close', hideThrobber);
				}
	
				self.requestTime = time = new Date().getTime();
	
				self.settings.itemsFactory(function(items) {
					if (items.length === 0) {
						self.hide();
						return;
					}
	
					if (self.requestTime !== time) {
						return;
					}
	
					self.getEl().style.width = '';
					self.getEl('body').style.width = '';
	
					hideThrobber();
					self.items().remove();
					self.getEl('body').innerHTML = '';
	
					self.add(items);
					self.renderNew();
					self.fire('loaded');
				});
			},
	
			/**
			 * Hide menu and all sub menus.
			 *
			 * @method hideAll
			 */
			hideAll: function() {
				var self = this;
	
				this.find('menuitem').exec('hideMenu');
	
				return self._super();
			},
	
			/**
			 * Invoked before the menu is rendered.
			 *
			 * @method preRender
			 */
			preRender: function() {
				var self = this;
	
				self.items().each(function(ctrl) {
					var settings = ctrl.settings;
	
					if (settings.icon || settings.image || settings.selectable) {
						self._hasIcons = true;
						return false;
					}
				});
	
				if (self.settings.itemsFactory) {
					self.on('postrender', function() {
						if (self.settings.itemsFactory) {
							self.load();
						}
					});
				}
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ListBox.js
	
	/**
	 * ListBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new list box control.
	 *
	 * @-x-less ListBox.less
	 * @class tinymce.ui.ListBox
	 * @extends tinymce.ui.MenuButton
	 */
	define("tinymce/ui/ListBox", [
		"tinymce/ui/MenuButton",
		"tinymce/ui/Menu"
	], function(MenuButton, Menu) {
		"use strict";
	
		return MenuButton.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Array} values Array with values to add to list box.
			 */
			init: function(settings) {
				var self = this, values, selected, selectedText, lastItemCtrl;
	
				function setSelected(menuValues) {
					// Try to find a selected value
					for (var i = 0; i < menuValues.length; i++) {
						selected = menuValues[i].selected || settings.value === menuValues[i].value;
	
						if (selected) {
							selectedText = selectedText || menuValues[i].text;
							self.state.set('value', menuValues[i].value);
							return true;
						}
	
						// If the value has a submenu, try to find the selected values in that menu
						if (menuValues[i].menu) {
							if (setSelected(menuValues[i].menu)) {
								return true;
							}
						}
					}
				}
	
				self._super(settings);
				settings = self.settings;
	
				self._values = values = settings.values;
				if (values) {
					if (typeof settings.value != "undefined") {
						setSelected(values);
					}
	
					// Default with first item
					if (!selected && values.length > 0) {
						selectedText = values[0].text;
						self.state.set('value', values[0].value);
					}
	
					self.state.set('menu', values);
				}
	
				self.state.set('text', settings.text || selectedText);
	
				self.classes.add('listbox');
	
				self.on('select', function(e) {
					var ctrl = e.control;
	
					if (lastItemCtrl) {
						e.lastControl = lastItemCtrl;
					}
	
					if (settings.multiple) {
						ctrl.active(!ctrl.active());
					} else {
						self.value(e.control.value());
					}
	
					lastItemCtrl = ctrl;
				});
			},
	
			/**
			 * Getter/setter function for the control value.
			 *
			 * @method value
			 * @param {String} [value] Value to be set.
			 * @return {Boolean/tinymce.ui.ListBox} Value or self if it's a set operation.
			 */
			bindStates: function() {
				var self = this;
	
				function activateMenuItemsByValue(menu, value) {
					if (menu instanceof Menu) {
						menu.items().each(function(ctrl) {
							if (!ctrl.hasMenus()) {
								ctrl.active(ctrl.value() === value);
							}
						});
					}
				}
	
				function getSelectedItem(menuValues, value) {
					var selectedItem;
	
					if (!menuValues) {
						return;
					}
	
					for (var i = 0; i < menuValues.length; i++) {
						if (menuValues[i].value === value) {
							return menuValues[i];
						}
	
						if (menuValues[i].menu) {
							selectedItem = getSelectedItem(menuValues[i].menu, value);
							if (selectedItem) {
								return selectedItem;
							}
						}
					}
				}
	
				self.on('show', function(e) {
					activateMenuItemsByValue(e.control, self.value());
				});
	
				self.state.on('change:value', function(e) {
					var selectedItem = getSelectedItem(self.state.get('menu'), e.value);
	
					if (selectedItem) {
						self.text(selectedItem.text);
					} else {
						self.text(self.settings.text);
					}
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Radio.js
	
	/**
	 * Radio.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new radio button.
	 *
	 * @-x-less Radio.less
	 * @class tinymce.ui.Radio
	 * @extends tinymce.ui.Checkbox
	 */
	define("tinymce/ui/Radio", [
		"tinymce/ui/Checkbox"
	], function(Checkbox) {
		"use strict";
	
		return Checkbox.extend({
			Defaults: {
				classes: "radio",
				role: "radio"
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/ResizeHandle.js
	
	/**
	 * ResizeHandle.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Renders a resize handle that fires ResizeStart, Resize and ResizeEnd events.
	 *
	 * @-x-less ResizeHandle.less
	 * @class tinymce.ui.ResizeHandle
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/ResizeHandle", [
		"tinymce/ui/Widget",
		"tinymce/ui/DragHelper"
	], function(Widget, DragHelper) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, prefix = self.classPrefix;
	
				self.classes.add('resizehandle');
	
				if (self.settings.direction == "both") {
					self.classes.add('resizehandle-both');
				}
	
				self.canFocus = false;
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '">' +
						'<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' +
					'</div>'
				);
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self._super();
	
				self.resizeDragHelper = new DragHelper(this._id, {
					start: function() {
						self.fire('ResizeStart');
					},
	
					drag: function(e) {
						if (self.settings.direction != "both") {
							e.deltaX = 0;
						}
	
						self.fire('Resize', e);
					},
	
					stop: function() {
						self.fire('ResizeEnd');
					}
				});
			},
	
			remove: function() {
				if (this.resizeDragHelper) {
					this.resizeDragHelper.destroy();
				}
	
				return this._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/SelectBox.js
	
	/**
	 * SelectBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new select box control.
	 *
	 * @-x-less SelectBox.less
	 * @class tinymce.ui.SelectBox
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/SelectBox", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		function createOptions(options) {
			var strOptions = '';
			if (options) {
				for (var i = 0; i < options.length; i++) {
					strOptions += '<option value="' + options[i] + '">' + options[i] + '</option>';
				}
			}
			return strOptions;
		}
	
		return Widget.extend({
			Defaults: {
				classes: "selectbox",
				role: "selectbox",
				options: []
			},
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Array} values Array with values to add to list box.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
	
				if (self.settings.size) {
					self.size = self.settings.size;
				}
	
				if (self.settings.options) {
					self._options = self.settings.options;
				}
	
				self.on('keydown', function(e) {
					var rootControl;
	
					if (e.keyCode == 13) {
						e.preventDefault();
	
						// Find root control that we can do toJSON on
						self.parents().reverse().each(function(ctrl) {
							if (ctrl.toJSON) {
								rootControl = ctrl;
								return false;
							}
						});
	
						// Fire event on current text box with the serialized data of the whole form
						self.fire('submit', {data: rootControl.toJSON()});
					}
				});
			},
	
			/**
			 * Getter/setter function for the options state.
			 *
			 * @method options
			 * @param {Array} [state] State to be set.
			 * @return {Array|tinymce.ui.SelectBox} Array of string options.
			 */
			options: function(state) {
				if (!arguments.length) {
					return this.state.get('options');
				}
	
				this.state.set('options', state);
	
				return this;
			},
	
			renderHtml: function() {
				var self = this, options, size = '';
	
				options = createOptions(self._options);
	
				if (self.size) {
					size = ' size = "' + self.size + '"';
				}
	
				return (
					'<select id="' + self._id + '" class="' + self.classes + '"' + size + '>' +
						options +
					'</select>'
				);
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:options', function(e) {
					self.getEl().innerHTML = createOptions(e.value);
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Slider.js
	
	/**
	 * Slider.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Slider control.
	 *
	 * @-x-less Slider.less
	 * @class tinymce.ui.Slider
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Slider", [
		"tinymce/ui/Widget",
		"tinymce/ui/DragHelper",
		"tinymce/ui/DomUtils"
	], function(Widget, DragHelper, DomUtils) {
		"use strict";
	
		function constrain(value, minVal, maxVal) {
			if (value < minVal) {
				value = minVal;
			}
	
			if (value > maxVal) {
				value = maxVal;
			}
	
			return value;
		}
	
		function setAriaProp(el, name, value) {
			el.setAttribute('aria-' + name, value);
		}
	
		function updateSliderHandle(ctrl, value) {
			var maxHandlePos, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
	
			if (ctrl.settings.orientation == "v") {
				stylePosName = "top";
				sizeName = "height";
				shortSizeName = "h";
			} else {
				stylePosName = "left";
				sizeName = "width";
				shortSizeName = "w";
			}
	
			handleEl = ctrl.getEl('handle');
			maxHandlePos = (ctrl.layoutRect()[shortSizeName] || 100) - DomUtils.getSize(handleEl)[sizeName];
	
			styleValue = (maxHandlePos * ((value - ctrl._minValue) / (ctrl._maxValue - ctrl._minValue))) + 'px';
			handleEl.style[stylePosName] = styleValue;
			handleEl.style.height = ctrl.layoutRect().h + 'px';
	
			setAriaProp(handleEl, 'valuenow', value);
			setAriaProp(handleEl, 'valuetext', '' + ctrl.settings.previewFilter(value));
			setAriaProp(handleEl, 'valuemin', ctrl._minValue);
			setAriaProp(handleEl, 'valuemax', ctrl._maxValue);
		}
	
		return Widget.extend({
			init: function(settings) {
				var self = this;
	
				if (!settings.previewFilter) {
					settings.previewFilter = function(value) {
						return Math.round(value * 100) / 100.0;
					};
				}
	
				self._super(settings);
				self.classes.add('slider');
	
				if (settings.orientation == "v") {
					self.classes.add('vertical');
				}
	
				self._minValue = settings.minValue || 0;
				self._maxValue = settings.maxValue || 100;
				self._initValue = self.state.get('value');
			},
	
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix;
	
				return (
					'<div id="' + id + '" class="' + self.classes + '">' +
						'<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' +
					'</div>'
				);
			},
	
			reset: function() {
				this.value(this._initValue).repaint();
			},
	
			postRender: function() {
				var self = this, minValue, maxValue, screenCordName,
						stylePosName, sizeName, shortSizeName;
	
				function toFraction(min, max, val) {
					return (val + min) / (max - min);
				}
	
				function fromFraction(min, max, val) {
					return (val * (max - min)) - min;
				}
	
				function handleKeyboard(minValue, maxValue) {
					function alter(delta) {
						var value;
	
						value = self.value();
						value = fromFraction(minValue, maxValue, toFraction(minValue, maxValue, value) + (delta * 0.05));
						value = constrain(value, minValue, maxValue);
	
						self.value(value);
	
						self.fire('dragstart', {value: value});
						self.fire('drag', {value: value});
						self.fire('dragend', {value: value});
					}
	
					self.on('keydown', function(e) {
						switch (e.keyCode) {
							case 37:
							case 38:
								alter(-1);
								break;
	
							case 39:
							case 40:
								alter(1);
								break;
						}
					});
				}
	
				function handleDrag(minValue, maxValue, handleEl) {
					var startPos, startHandlePos, maxHandlePos, handlePos, value;
	
					self._dragHelper = new DragHelper(self._id, {
						handle: self._id + "-handle",
	
						start: function(e) {
							startPos = e[screenCordName];
							startHandlePos = parseInt(self.getEl('handle').style[stylePosName], 10);
							maxHandlePos = (self.layoutRect()[shortSizeName] || 100) - DomUtils.getSize(handleEl)[sizeName];
							self.fire('dragstart', {value: value});
						},
	
						drag: function(e) {
							var delta = e[screenCordName] - startPos;
	
							handlePos = constrain(startHandlePos + delta, 0, maxHandlePos);
							handleEl.style[stylePosName] = handlePos + 'px';
	
							value = minValue + (handlePos / maxHandlePos) * (maxValue - minValue);
							self.value(value);
	
							self.tooltip().text('' + self.settings.previewFilter(value)).show().moveRel(handleEl, 'bc tc');
	
							self.fire('drag', {value: value});
						},
	
						stop: function() {
							self.tooltip().hide();
							self.fire('dragend', {value: value});
						}
					});
				}
	
				minValue = self._minValue;
				maxValue = self._maxValue;
	
				if (self.settings.orientation == "v") {
					screenCordName = "screenY";
					stylePosName = "top";
					sizeName = "height";
					shortSizeName = "h";
				} else {
					screenCordName = "screenX";
					stylePosName = "left";
					sizeName = "width";
					shortSizeName = "w";
				}
	
				self._super();
	
				handleKeyboard(minValue, maxValue, self.getEl('handle'));
				handleDrag(minValue, maxValue, self.getEl('handle'));
			},
	
			repaint: function() {
				this._super();
				updateSliderHandle(this, this.value());
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:value', function(e) {
					updateSliderHandle(self, e.value);
				});
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/Spacer.js
	
	/**
	 * Spacer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a spacer. This control is used in flex layouts for example.
	 *
	 * @-x-less Spacer.less
	 * @class tinymce.ui.Spacer
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/Spacer", [
		"tinymce/ui/Widget"
	], function(Widget) {
		"use strict";
	
		return Widget.extend({
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this;
	
				self.classes.add('spacer');
				self.canFocus = false;
	
				return '<div id="' + self._id + '" class="' + self.classes + '"></div>';
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/SplitButton.js
	
	/**
	 * SplitButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a split button.
	 *
	 * @-x-less SplitButton.less
	 * @class tinymce.ui.SplitButton
	 * @extends tinymce.ui.Button
	 */
	define("tinymce/ui/SplitButton", [
		"tinymce/ui/MenuButton",
		"tinymce/ui/DomUtils",
		"tinymce/dom/DomQuery"
	], function(MenuButton, DomUtils, $) {
		return MenuButton.extend({
			Defaults: {
				classes: "widget btn splitbtn",
				role: "button"
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, elm = self.getEl(), rect = self.layoutRect(), mainButtonElm, menuButtonElm;
	
				self._super();
	
				mainButtonElm = elm.firstChild;
				menuButtonElm = elm.lastChild;
	
				$(mainButtonElm).css({
					width: rect.w - DomUtils.getSize(menuButtonElm).width,
					height: rect.h - 2
				});
	
				$(menuButtonElm).css({
					height: rect.h - 2
				});
	
				return self;
			},
	
			/**
			 * Sets the active menu state.
			 *
			 * @private
			 */
			activeMenu: function(state) {
				var self = this;
	
				$(self.getEl().lastChild).toggleClass(self.classPrefix + 'active', state);
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, id = self._id, prefix = self.classPrefix, image;
				var icon = self.state.get('icon'), text = self.state.get('text'),
					textHtml = '';
	
				image = self.settings.image;
				if (image) {
					icon = 'none';
	
					// Support for [high dpi, low dpi] image sources
					if (typeof image != "string") {
						image = window.getSelection ? image[0] : image[1];
					}
	
					image = ' style="background-image: url(\'' + image + '\')"';
				} else {
					image = '';
				}
	
				icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	
				if (text) {
					self.classes.add('btn-has-text');
					textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
				}
	
				return (
					'<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1">' +
						'<button type="button" hidefocus="1" tabindex="-1">' +
							(icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
							textHtml +
						'</button>' +
						'<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' +
							//(icon ? '<i class="' + icon + '"></i>' : '') +
							(self._menuBtnText ? (icon ? '\u00a0' : '') + self._menuBtnText : '') +
							' <i class="' + prefix + 'caret"></i>' +
						'</button>' +
					'</div>'
				);
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this, onClickHandler = self.settings.onclick;
	
				self.on('click', function(e) {
					var node = e.target;
	
					if (e.control == this) {
						// Find clicks that is on the main button
						while (node) {
							if ((e.aria && e.aria.key != 'down') || (node.nodeName == 'BUTTON' && node.className.indexOf('open') == -1)) {
								e.stopImmediatePropagation();
	
								if (onClickHandler) {
									onClickHandler.call(this, e);
								}
	
								return;
							}
	
							node = node.parentNode;
						}
					}
				});
	
				delete self.settings.onclick;
	
				return self._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/StackLayout.js
	
	/**
	 * StackLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout uses the browsers layout when the items are blocks.
	 *
	 * @-x-less StackLayout.less
	 * @class tinymce.ui.StackLayout
	 * @extends tinymce.ui.FlowLayout
	 */
	define("tinymce/ui/StackLayout", [
		"tinymce/ui/FlowLayout"
	], function(FlowLayout) {
		"use strict";
	
		return FlowLayout.extend({
			Defaults: {
				containerClass: 'stack-layout',
				controlClass: 'stack-layout-item',
				endClass: 'break'
			},
	
			isNative: function() {
				return true;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/TabPanel.js
	
	/**
	 * TabPanel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a tab panel control.
	 *
	 * @-x-less TabPanel.less
	 * @class tinymce.ui.TabPanel
	 * @extends tinymce.ui.Panel
	 *
	 * @setting {Number} activeTab Active tab index.
	 */
	define("tinymce/ui/TabPanel", [
		"tinymce/ui/Panel",
		"tinymce/dom/DomQuery",
		"tinymce/ui/DomUtils"
	], function(Panel, $, DomUtils) {
		"use strict";
	
		return Panel.extend({
			Defaults: {
				layout: 'absolute',
				defaults: {
					type: 'panel'
				}
			},
	
			/**
			 * Activates the specified tab by index.
			 *
			 * @method activateTab
			 * @param {Number} idx Index of the tab to activate.
			 */
			activateTab: function(idx) {
				var activeTabElm;
	
				if (this.activeTabId) {
					activeTabElm = this.getEl(this.activeTabId);
					$(activeTabElm).removeClass(this.classPrefix + 'active');
					activeTabElm.setAttribute('aria-selected', "false");
				}
	
				this.activeTabId = 't' + idx;
	
				activeTabElm = this.getEl('t' + idx);
				activeTabElm.setAttribute('aria-selected', "true");
				$(activeTabElm).addClass(this.classPrefix + 'active');
	
				this.items()[idx].show().fire('showtab');
				this.reflow();
	
				this.items().each(function(item, i) {
					if (idx != i) {
						item.hide();
					}
				});
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, layout = self._layout, tabsHtml = '', prefix = self.classPrefix;
	
				self.preRender();
				layout.preRender(self);
	
				self.items().each(function(ctrl, i) {
					var id = self._id + '-t' + i;
	
					ctrl.aria('role', 'tabpanel');
					ctrl.aria('labelledby', id);
	
					tabsHtml += (
						'<div id="' + id + '" class="' + prefix + 'tab" ' +
							'unselectable="on" role="tab" aria-controls="' + ctrl._id + '" aria-selected="false" tabIndex="-1">' +
							self.encode(ctrl.settings.title) +
						'</div>'
					);
				});
	
				return (
					'<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
						'<div id="' + self._id + '-head" class="' + prefix + 'tabs" role="tablist">' +
							tabsHtml +
						'</div>' +
						'<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
							layout.renderHtml(self) +
						'</div>' +
					'</div>'
				);
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self._super();
	
				self.settings.activeTab = self.settings.activeTab || 0;
				self.activateTab(self.settings.activeTab);
	
				this.on('click', function(e) {
					var targetParent = e.target.parentNode;
	
					if (e.target.parentNode.id == self._id + '-head') {
						var i = targetParent.childNodes.length;
	
						while (i--) {
							if (targetParent.childNodes[i] == e.target) {
								self.activateTab(i);
							}
						}
					}
				});
			},
	
			/**
			 * Initializes the current controls layout rect.
			 * This will be executed by the layout managers to determine the
			 * default minWidth/minHeight etc.
			 *
			 * @method initLayoutRect
			 * @return {Object} Layout rect instance.
			 */
			initLayoutRect: function() {
				var self = this, rect, minW, minH;
	
				minW = DomUtils.getSize(self.getEl('head')).width;
				minW = minW < 0 ? 0 : minW;
				minH = 0;
	
				self.items().each(function(item) {
					minW = Math.max(minW, item.layoutRect().minW);
					minH = Math.max(minH, item.layoutRect().minH);
				});
	
				self.items().each(function(ctrl) {
					ctrl.settings.x = 0;
					ctrl.settings.y = 0;
					ctrl.settings.w = minW;
					ctrl.settings.h = minH;
	
					ctrl.layoutRect({
						x: 0,
						y: 0,
						w: minW,
						h: minH
					});
				});
	
				var headH = DomUtils.getSize(self.getEl('head')).height;
	
				self.settings.minWidth = minW;
				self.settings.minHeight = minH + headH;
	
				rect = self._super();
				rect.deltaH += headH;
				rect.innerH = rect.h - rect.deltaH;
	
				return rect;
			}
		});
	});
	
	// Included from: js/tinymce/classes/ui/TextBox.js
	
	/**
	 * TextBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new textbox.
	 *
	 * @-x-less TextBox.less
	 * @class tinymce.ui.TextBox
	 * @extends tinymce.ui.Widget
	 */
	define("tinymce/ui/TextBox", [
		"tinymce/ui/Widget",
		"tinymce/util/Tools",
		"tinymce/ui/DomUtils"
	], function(Widget, Tools, DomUtils) {
		return Widget.extend({
			/**
			 * Constructs a instance with the specified settings.
			 *
			 * @constructor
			 * @param {Object} settings Name/value object with settings.
			 * @setting {Boolean} multiline True if the textbox is a multiline control.
			 * @setting {Number} maxLength Max length for the textbox.
			 * @setting {Number} size Size of the textbox in characters.
			 */
			init: function(settings) {
				var self = this;
	
				self._super(settings);
	
				self.classes.add('textbox');
	
				if (settings.multiline) {
					self.classes.add('multiline');
				} else {
					self.on('keydown', function(e) {
						var rootControl;
	
						if (e.keyCode == 13) {
							e.preventDefault();
	
							// Find root control that we can do toJSON on
							self.parents().reverse().each(function(ctrl) {
								if (ctrl.toJSON) {
									rootControl = ctrl;
									return false;
								}
							});
	
							// Fire event on current text box with the serialized data of the whole form
							self.fire('submit', {data: rootControl.toJSON()});
						}
					});
	
					self.on('keyup', function(e) {
						self.state.set('value', e.target.value);
					});
				}
			},
	
			/**
			 * Repaints the control after a layout operation.
			 *
			 * @method repaint
			 */
			repaint: function() {
				var self = this, style, rect, borderBox, borderW, borderH = 0, lastRepaintRect;
	
				style = self.getEl().style;
				rect = self._layoutRect;
				lastRepaintRect = self._lastRepaintRect || {};
	
				// Detect old IE 7+8 add lineHeight to align caret vertically in the middle
				var doc = document;
				if (!self.settings.multiline && doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
					style.lineHeight = (rect.h - borderH) + 'px';
				}
	
				borderBox = self.borderBox;
				borderW = borderBox.left + borderBox.right + 8;
				borderH = borderBox.top + borderBox.bottom + (self.settings.multiline ? 8 : 0);
	
				if (rect.x !== lastRepaintRect.x) {
					style.left = rect.x + 'px';
					lastRepaintRect.x = rect.x;
				}
	
				if (rect.y !== lastRepaintRect.y) {
					style.top = rect.y + 'px';
					lastRepaintRect.y = rect.y;
				}
	
				if (rect.w !== lastRepaintRect.w) {
					style.width = (rect.w - borderW) + 'px';
					lastRepaintRect.w = rect.w;
				}
	
				if (rect.h !== lastRepaintRect.h) {
					style.height = (rect.h - borderH) + 'px';
					lastRepaintRect.h = rect.h;
				}
	
				self._lastRepaintRect = lastRepaintRect;
				self.fire('repaint', {}, false);
	
				return self;
			},
	
			/**
			 * Renders the control as a HTML string.
			 *
			 * @method renderHtml
			 * @return {String} HTML representing the control.
			 */
			renderHtml: function() {
				var self = this, settings = self.settings, attrs, elm;
	
				attrs = {
					id: self._id,
					hidefocus: '1'
				};
	
				Tools.each([
					'rows',	'spellcheck',	'maxLength', 'size', 'readonly', 'min',
					'max', 'step', 'list', 'pattern', 'placeholder', 'required', 'multiple'
				], function(name) {
					attrs[name] = settings[name];
				});
	
				if (self.disabled()) {
					attrs.disabled = 'disabled';
				}
	
				if (settings.subtype) {
					attrs.type = settings.subtype;
				}
	
				elm = DomUtils.create(settings.multiline ? 'textarea' : 'input', attrs);
				elm.value = self.state.get('value');
				elm.className = self.classes;
	
				return elm.outerHTML;
			},
	
			value: function(value) {
				if (arguments.length) {
					this.state.set('value', value);
					return this;
				}
	
				// Make sure the real state is in sync
				if (this.state.get('rendered')) {
					this.state.set('value', this.getEl().value);
				}
	
				return this.state.get('value');
			},
	
			/**
			 * Called after the control has been rendered.
			 *
			 * @method postRender
			 */
			postRender: function() {
				var self = this;
	
				self.getEl().value = self.state.get('value');
				self._super();
	
				self.$el.on('change', function(e) {
					self.state.set('value', e.target.value);
					self.fire('change', e);
				});
			},
	
			bindStates: function() {
				var self = this;
	
				self.state.on('change:value', function(e) {
					if (self.getEl().value != e.value) {
						self.getEl().value = e.value;
					}
				});
	
				self.state.on('change:disabled', function(e) {
					self.getEl().disabled = e.value;
				});
	
				return self._super();
			},
	
			remove: function() {
				this.$el.off();
				this._super();
			}
		});
	});
	
	// Included from: js/tinymce/classes/Register.js
	
	/**
	 * Register.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This registers tinymce in common module loaders.
	 *
	 * @private
	 * @class tinymce.Register
	 */
	define("tinymce/Register", [
	], function() {
		/*eslint consistent-this: 0 */
		var context = this || window;
	
		var tinymce = function() {
			return context.tinymce;
		};
	
		if (typeof context.define === "function") {
			// Bolt
			if (!context.define.amd) {
				context.define("ephox/tinymce", [], tinymce);
			}
		}
	
		return {};
	});
	
	expose(["tinymce/geom/Rect","tinymce/util/Promise","tinymce/util/Delay","tinymce/Env","tinymce/dom/EventUtils","tinymce/dom/Sizzle","tinymce/util/Tools","tinymce/dom/DomQuery","tinymce/html/Styles","tinymce/dom/TreeWalker","tinymce/html/Entities","tinymce/dom/DOMUtils","tinymce/dom/ScriptLoader","tinymce/AddOnManager","tinymce/dom/RangeUtils","tinymce/html/Node","tinymce/html/Schema","tinymce/html/SaxParser","tinymce/html/DomParser","tinymce/html/Writer","tinymce/html/Serializer","tinymce/dom/Serializer","tinymce/util/VK","tinymce/dom/ControlSelection","tinymce/dom/BookmarkManager","tinymce/dom/Selection","tinymce/Formatter","tinymce/UndoManager","tinymce/EditorCommands","tinymce/util/URI","tinymce/util/Class","tinymce/util/EventDispatcher","tinymce/util/Observable","tinymce/ui/Selector","tinymce/ui/Collection","tinymce/ui/ReflowQueue","tinymce/ui/Control","tinymce/ui/Factory","tinymce/ui/KeyboardNavigation","tinymce/ui/Container","tinymce/ui/DragHelper","tinymce/ui/Scrollable","tinymce/ui/Panel","tinymce/ui/Movable","tinymce/ui/Resizable","tinymce/ui/FloatPanel","tinymce/ui/Window","tinymce/ui/MessageBox","tinymce/WindowManager","tinymce/ui/Tooltip","tinymce/ui/Widget","tinymce/ui/Progress","tinymce/ui/Notification","tinymce/NotificationManager","tinymce/EditorObservable","tinymce/Shortcuts","tinymce/Editor","tinymce/util/I18n","tinymce/FocusManager","tinymce/EditorManager","tinymce/util/XHR","tinymce/util/JSON","tinymce/util/JSONRequest","tinymce/util/JSONP","tinymce/util/LocalStorage","tinymce/Compat","tinymce/ui/Layout","tinymce/ui/AbsoluteLayout","tinymce/ui/Button","tinymce/ui/ButtonGroup","tinymce/ui/Checkbox","tinymce/ui/ComboBox","tinymce/ui/ColorBox","tinymce/ui/PanelButton","tinymce/ui/ColorButton","tinymce/util/Color","tinymce/ui/ColorPicker","tinymce/ui/Path","tinymce/ui/ElementPath","tinymce/ui/FormItem","tinymce/ui/Form","tinymce/ui/FieldSet","tinymce/ui/FilePicker","tinymce/ui/FitLayout","tinymce/ui/FlexLayout","tinymce/ui/FlowLayout","tinymce/ui/FormatControls","tinymce/ui/GridLayout","tinymce/ui/Iframe","tinymce/ui/InfoBox","tinymce/ui/Label","tinymce/ui/Toolbar","tinymce/ui/MenuBar","tinymce/ui/MenuButton","tinymce/ui/MenuItem","tinymce/ui/Throbber","tinymce/ui/Menu","tinymce/ui/ListBox","tinymce/ui/Radio","tinymce/ui/ResizeHandle","tinymce/ui/SelectBox","tinymce/ui/Slider","tinymce/ui/Spacer","tinymce/ui/SplitButton","tinymce/ui/StackLayout","tinymce/ui/TabPanel","tinymce/ui/TextBox"]);
	})(this);
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.tinymce;
	}.call(window));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89).setImmediate))

/***/ },
/* 224 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('autolink', function(editor) {
		var AutoUrlDetectState;
		var AutoLinkPattern = /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.|(?:mailto:)?[A-Z0-9._%+\-]+@)(.+)$/i;
	
		if (editor.settings.autolink_pattern) {
			AutoLinkPattern = editor.settings.autolink_pattern;
		}
	
		editor.on("keydown", function(e) {
			if (e.keyCode == 13) {
				return handleEnter(editor);
			}
		});
	
		// Internet Explorer has built-in automatic linking for most cases
		if (tinymce.Env.ie) {
			editor.on("focus", function() {
				if (!AutoUrlDetectState) {
					AutoUrlDetectState = true;
	
					try {
						editor.execCommand('AutoUrlDetect', false, true);
					} catch (ex) {
						// Ignore
					}
				}
			});
	
			return;
		}
	
		editor.on("keypress", function(e) {
			if (e.keyCode == 41) {
				return handleEclipse(editor);
			}
		});
	
		editor.on("keyup", function(e) {
			if (e.keyCode == 32) {
				return handleSpacebar(editor);
			}
		});
	
		function handleEclipse(editor) {
			parseCurrentLine(editor, -1, '(', true);
		}
	
		function handleSpacebar(editor) {
			parseCurrentLine(editor, 0, '', true);
		}
	
		function handleEnter(editor) {
			parseCurrentLine(editor, -1, '', false);
		}
	
		function parseCurrentLine(editor, end_offset, delimiter) {
			var rng, end, start, endContainer, bookmark, text, matches, prev, len, rngText;
	
			function scopeIndex(container, index) {
				if (index < 0) {
					index = 0;
				}
	
				if (container.nodeType == 3) {
					var len = container.data.length;
	
					if (index > len) {
						index = len;
					}
				}
	
				return index;
			}
	
			function setStart(container, offset) {
				if (container.nodeType != 1 || container.hasChildNodes()) {
					rng.setStart(container, scopeIndex(container, offset));
				} else {
					rng.setStartBefore(container);
				}
			}
	
			function setEnd(container, offset) {
				if (container.nodeType != 1 || container.hasChildNodes()) {
					rng.setEnd(container, scopeIndex(container, offset));
				} else {
					rng.setEndAfter(container);
				}
			}
	
			// Never create a link when we are inside a link
			if (editor.selection.getNode().tagName == 'A') {
				return;
			}
	
			// We need at least five characters to form a URL,
			// hence, at minimum, five characters from the beginning of the line.
			rng = editor.selection.getRng(true).cloneRange();
			if (rng.startOffset < 5) {
				// During testing, the caret is placed between two text nodes.
				// The previous text node contains the URL.
				prev = rng.endContainer.previousSibling;
				if (!prev) {
					if (!rng.endContainer.firstChild || !rng.endContainer.firstChild.nextSibling) {
						return;
					}
	
					prev = rng.endContainer.firstChild.nextSibling;
				}
	
				len = prev.length;
				setStart(prev, len);
				setEnd(prev, len);
	
				if (rng.endOffset < 5) {
					return;
				}
	
				end = rng.endOffset;
				endContainer = prev;
			} else {
				endContainer = rng.endContainer;
	
				// Get a text node
				if (endContainer.nodeType != 3 && endContainer.firstChild) {
					while (endContainer.nodeType != 3 && endContainer.firstChild) {
						endContainer = endContainer.firstChild;
					}
	
					// Move range to text node
					if (endContainer.nodeType == 3) {
						setStart(endContainer, 0);
						setEnd(endContainer, endContainer.nodeValue.length);
					}
				}
	
				if (rng.endOffset == 1) {
					end = 2;
				} else {
					end = rng.endOffset - 1 - end_offset;
				}
			}
	
			start = end;
	
			do {
				// Move the selection one character backwards.
				setStart(endContainer, end >= 2 ? end - 2 : 0);
				setEnd(endContainer, end >= 1 ? end - 1 : 0);
				end -= 1;
				rngText = rng.toString();
	
				// Loop until one of the following is found: a blank space, &nbsp;, delimiter, (end-2) >= 0
			} while (rngText != ' ' && rngText !== '' && rngText.charCodeAt(0) != 160 && (end - 2) >= 0 && rngText != delimiter);
	
			if (rng.toString() == delimiter || rng.toString().charCodeAt(0) == 160) {
				setStart(endContainer, end);
				setEnd(endContainer, start);
				end += 1;
			} else if (rng.startOffset === 0) {
				setStart(endContainer, 0);
				setEnd(endContainer, start);
			} else {
				setStart(endContainer, end);
				setEnd(endContainer, start);
			}
	
			// Exclude last . from word like "www.site.com."
			text = rng.toString();
			if (text.charAt(text.length - 1) == '.') {
				setEnd(endContainer, start - 1);
			}
	
			text = rng.toString();
			matches = text.match(AutoLinkPattern);
	
			if (matches) {
				if (matches[1] == 'www.') {
					matches[1] = 'http://www.';
				} else if (/@$/.test(matches[1]) && !/^mailto:/.test(matches[1])) {
					matches[1] = 'mailto:' + matches[1];
				}
	
				bookmark = editor.selection.getBookmark();
	
				editor.selection.setRng(rng);
				editor.execCommand('createlink', false, matches[1] + matches[2]);
				editor.selection.moveToBookmark(bookmark);
				editor.nodeChanged();
			}
		}
	});
	
	}.call(window));

/***/ },
/* 225 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	/*eslint no-nested-ternary:0 */
	
	/**
	 * Auto Resize
	 *
	 * This plugin automatically resizes the content area to fit its content height.
	 * It will retain a minimum height, which is the height of the content area when
	 * it's initialized.
	 */
	tinymce.PluginManager.add('autoresize', function(editor) {
		var settings = editor.settings, oldSize = 0;
	
		function isFullscreen() {
			return editor.plugins.fullscreen && editor.plugins.fullscreen.isFullscreen();
		}
	
		if (editor.settings.inline) {
			return;
		}
	
		/**
		 * This method gets executed each time the editor needs to resize.
		 */
		function resize(e) {
			var deltaSize, doc, body, docElm, DOM = tinymce.DOM, resizeHeight, myHeight,
				marginTop, marginBottom, paddingTop, paddingBottom, borderTop, borderBottom;
	
			doc = editor.getDoc();
			if (!doc) {
				return;
			}
	
			body = doc.body;
			docElm = doc.documentElement;
			resizeHeight = settings.autoresize_min_height;
	
			if (!body || (e && e.type === "setcontent" && e.initial) || isFullscreen()) {
				if (body && docElm) {
					body.style.overflowY = "auto";
					docElm.style.overflowY = "auto"; // Old IE
				}
	
				return;
			}
	
			// Calculate outer height of the body element using CSS styles
			marginTop = editor.dom.getStyle(body, 'margin-top', true);
			marginBottom = editor.dom.getStyle(body, 'margin-bottom', true);
			paddingTop = editor.dom.getStyle(body, 'padding-top', true);
			paddingBottom = editor.dom.getStyle(body, 'padding-bottom', true);
			borderTop = editor.dom.getStyle(body, 'border-top-width', true);
			borderBottom = editor.dom.getStyle(body, 'border-bottom-width', true);
			myHeight = body.offsetHeight + parseInt(marginTop, 10) + parseInt(marginBottom, 10) +
				parseInt(paddingTop, 10) + parseInt(paddingBottom, 10) +
				parseInt(borderTop, 10) + parseInt(borderBottom, 10);
	
			// Make sure we have a valid height
			if (isNaN(myHeight) || myHeight <= 0) {
				// Get height differently depending on the browser used
				myHeight = tinymce.Env.ie ? body.scrollHeight : (tinymce.Env.webkit && body.clientHeight === 0 ? 0 : body.offsetHeight);
			}
	
			// Don't make it smaller than the minimum height
			if (myHeight > settings.autoresize_min_height) {
				resizeHeight = myHeight;
			}
	
			// If a maximum height has been defined don't exceed this height
			if (settings.autoresize_max_height && myHeight > settings.autoresize_max_height) {
				resizeHeight = settings.autoresize_max_height;
				body.style.overflowY = "auto";
				docElm.style.overflowY = "auto"; // Old IE
			} else {
				body.style.overflowY = "hidden";
				docElm.style.overflowY = "hidden"; // Old IE
				body.scrollTop = 0;
			}
	
			// Resize content element
			if (resizeHeight !== oldSize) {
				deltaSize = resizeHeight - oldSize;
				DOM.setStyle(editor.iframeElement, 'height', resizeHeight + 'px');
				oldSize = resizeHeight;
	
				// WebKit doesn't decrease the size of the body element until the iframe gets resized
				// So we need to continue to resize the iframe down until the size gets fixed
				if (tinymce.isWebKit && deltaSize < 0) {
					resize(e);
				}
			}
		}
	
		/**
		 * Calls the resize x times in 100ms intervals. We can't wait for load events since
		 * the CSS files might load async.
		 */
		function wait(times, interval, callback) {
			tinymce.util.Delay.setEditorTimeout(editor, function() {
				resize({});
	
				if (times--) {
					wait(times, interval, callback);
				} else if (callback) {
					callback();
				}
			}, interval);
		}
	
		// Define minimum height
		settings.autoresize_min_height = parseInt(editor.getParam('autoresize_min_height', editor.getElement().offsetHeight), 10);
	
		// Define maximum height
		settings.autoresize_max_height = parseInt(editor.getParam('autoresize_max_height', 0), 10);
	
		// Add padding at the bottom for better UX
		editor.on("init", function() {
			var overflowPadding, bottomMargin;
	
			overflowPadding = editor.getParam('autoresize_overflow_padding', 1);
			bottomMargin = editor.getParam('autoresize_bottom_margin', 50);
	
			if (overflowPadding !== false) {
				editor.dom.setStyles(editor.getBody(), {
					paddingLeft: overflowPadding,
					paddingRight: overflowPadding
				});
			}
	
			if (bottomMargin !== false) {
				editor.dom.setStyles(editor.getBody(), {
					paddingBottom: bottomMargin
				});
			}
		});
	
		// Add appropriate listeners for resizing content area
		editor.on("nodechange setcontent keyup FullscreenStateChanged", resize);
	
		if (editor.getParam('autoresize_on_init', true)) {
			editor.on('init', function() {
				// Hit it 20 times in 100 ms intervals
				wait(20, 100, function() {
					// Hit it 5 times in 1 sec intervals
					wait(5, 1000);
				});
			});
		}
	
		// Register the command so that it can be invoked by using tinyMCE.activeEditor.execCommand('mceExample');
		editor.addCommand('mceAutoResize', resize);
	});
	
	}.call(window));

/***/ },
/* 226 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('fullscreen', function(editor) {
		var fullscreenState = false, DOM = tinymce.DOM, iframeWidth, iframeHeight, resizeHandler;
		var containerWidth, containerHeight, scrollPos;
	
		if (editor.settings.inline) {
			return;
		}
	
		function getWindowSize() {
			var w, h, win = window, doc = document;
			var body = doc.body;
	
			// Old IE
			if (body.offsetWidth) {
				w = body.offsetWidth;
				h = body.offsetHeight;
			}
	
			// Modern browsers
			if (win.innerWidth && win.innerHeight) {
				w = win.innerWidth;
				h = win.innerHeight;
			}
	
			return {w: w, h: h};
		}
	
		function getScrollPos() {
			var vp = tinymce.DOM.getViewPort();
	
			return {
				x: vp.x,
				y: vp.y
			};
		}
	
		function setScrollPos(pos) {
			scrollTo(pos.x, pos.y);
		}
	
		function toggleFullscreen() {
			var body = document.body, documentElement = document.documentElement, editorContainerStyle;
			var editorContainer, iframe, iframeStyle;
	
			function resize() {
				DOM.setStyle(iframe, 'height', getWindowSize().h - (editorContainer.clientHeight - iframe.clientHeight));
			}
	
			fullscreenState = !fullscreenState;
	
			editorContainer = editor.getContainer();
			editorContainerStyle = editorContainer.style;
			iframe = editor.getContentAreaContainer().firstChild;
			iframeStyle = iframe.style;
	
			if (fullscreenState) {
				scrollPos = getScrollPos();
				iframeWidth = iframeStyle.width;
				iframeHeight = iframeStyle.height;
				iframeStyle.width = iframeStyle.height = '100%';
				containerWidth = editorContainerStyle.width;
				containerHeight = editorContainerStyle.height;
				editorContainerStyle.width = editorContainerStyle.height = '';
	
				DOM.addClass(body, 'mce-fullscreen');
				DOM.addClass(documentElement, 'mce-fullscreen');
				DOM.addClass(editorContainer, 'mce-fullscreen');
	
				DOM.bind(window, 'resize', resize);
				resize();
				resizeHandler = resize;
			} else {
				iframeStyle.width = iframeWidth;
				iframeStyle.height = iframeHeight;
	
				if (containerWidth) {
					editorContainerStyle.width = containerWidth;
				}
	
				if (containerHeight) {
					editorContainerStyle.height = containerHeight;
				}
	
				DOM.removeClass(body, 'mce-fullscreen');
				DOM.removeClass(documentElement, 'mce-fullscreen');
				DOM.removeClass(editorContainer, 'mce-fullscreen');
				DOM.unbind(window, 'resize', resizeHandler);
				setScrollPos(scrollPos);
			}
	
			editor.fire('FullscreenStateChanged', {state: fullscreenState});
		}
	
		editor.on('init', function() {
			editor.addShortcut('Ctrl+Shift+F', '', toggleFullscreen);
		});
	
		editor.on('remove', function() {
			if (resizeHandler) {
				DOM.unbind(window, 'resize', resizeHandler);
			}
		});
	
		editor.addCommand('mceFullScreen', toggleFullscreen);
	
		editor.addMenuItem('fullscreen', {
			text: 'Fullscreen',
			shortcut: 'Ctrl+Shift+F',
			selectable: true,
			onClick: function() {
				toggleFullscreen();
				editor.focus();
			},
			onPostRender: function() {
				var self = this;
	
				editor.on('FullscreenStateChanged', function(e) {
					self.active(e.state);
				});
			},
			context: 'view'
		});
	
		editor.addButton('fullscreen', {
			tooltip: 'Fullscreen',
			shortcut: 'Ctrl+Shift+F',
			onClick: toggleFullscreen,
			onPostRender: function() {
				var self = this;
	
				editor.on('FullscreenStateChanged', function(e) {
					self.active(e.state);
				});
			}
		});
	
		return {
			isFullscreen: function() {
				return fullscreenState;
			}
		};
	});
	
	}.call(window));

/***/ },
/* 227 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * Compiled inline version. (Library mode)
	 */
	
	/*jshint smarttabs:true, undef:true, latedef:true, curly:true, bitwise:true, camelcase:true */
	/*globals $code */
	
	(function(exports, undefined) {
		"use strict";
	
		var modules = {};
	
		function require(ids, callback) {
			var module, defs = [];
	
			for (var i = 0; i < ids.length; ++i) {
				module = modules[ids[i]] || resolve(ids[i]);
				if (!module) {
					throw 'module definition dependecy not found: ' + ids[i];
				}
	
				defs.push(module);
			}
	
			callback.apply(null, defs);
		}
	
		function define(id, dependencies, definition) {
			if (typeof id !== 'string') {
				throw 'invalid module definition, module id must be defined and be a string';
			}
	
			if (dependencies === undefined) {
				throw 'invalid module definition, dependencies must be specified';
			}
	
			if (definition === undefined) {
				throw 'invalid module definition, definition function must be specified';
			}
	
			require(dependencies, function() {
				modules[id] = definition.apply(null, arguments);
			});
		}
	
		function defined(id) {
			return !!modules[id];
		}
	
		function resolve(id) {
			var target = exports;
			var fragments = id.split(/[.\/]/);
	
			for (var fi = 0; fi < fragments.length; ++fi) {
				if (!target[fragments[fi]]) {
					return;
				}
	
				target = target[fragments[fi]];
			}
	
			return target;
		}
	
		function expose(ids) {
			var i, target, id, fragments, privateModules;
	
			for (i = 0; i < ids.length; i++) {
				target = exports;
				id = ids[i];
				fragments = id.split(/[.\/]/);
	
				for (var fi = 0; fi < fragments.length - 1; ++fi) {
					if (target[fragments[fi]] === undefined) {
						target[fragments[fi]] = {};
					}
	
					target = target[fragments[fi]];
				}
	
				target[fragments[fragments.length - 1]] = modules[id];
			}
			
			// Expose private modules for unit tests
			if (exports.AMDLC_TESTS) {
				privateModules = exports.privateModules || {};
	
				for (id in modules) {
					privateModules[id] = modules[id];
				}
	
				for (i = 0; i < ids.length; i++) {
					delete privateModules[ids[i]];
				}
	
				exports.privateModules = privateModules;
			}
		}
	
	// Included from: js/tinymce/plugins/paste/classes/Utils.js
	
	/**
	 * Utils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contails various utility functions for the paste plugin.
	 *
	 * @class tinymce.pasteplugin.Utils
	 */
	define("tinymce/pasteplugin/Utils", [
		"tinymce/util/Tools",
		"tinymce/html/DomParser",
		"tinymce/html/Schema"
	], function(Tools, DomParser, Schema) {
		function filter(content, items) {
			Tools.each(items, function(v) {
				if (v.constructor == RegExp) {
					content = content.replace(v, '');
				} else {
					content = content.replace(v[0], v[1]);
				}
			});
	
			return content;
		}
	
		/**
		 * Gets the innerText of the specified element. It will handle edge cases
		 * and works better than textContent on Gecko.
		 *
		 * @param {String} html HTML string to get text from.
		 * @return {String} String of text with line feeds.
		 */
		function innerText(html) {
			var schema = new Schema(), domParser = new DomParser({}, schema), text = '';
			var shortEndedElements = schema.getShortEndedElements();
			var ignoreElements = Tools.makeMap('script noscript style textarea video audio iframe object', ' ');
			var blockElements = schema.getBlockElements();
	
			function walk(node) {
				var name = node.name, currentNode = node;
	
				if (name === 'br') {
					text += '\n';
					return;
				}
	
				// img/input/hr
				if (shortEndedElements[name]) {
					text += ' ';
				}
	
				// Ingore script, video contents
				if (ignoreElements[name]) {
					text += ' ';
					return;
				}
	
				if (node.type == 3) {
					text += node.value;
				}
	
				// Walk all children
				if (!node.shortEnded) {
					if ((node = node.firstChild)) {
						do {
							walk(node);
						} while ((node = node.next));
					}
				}
	
				// Add \n or \n\n for blocks or P
				if (blockElements[name] && currentNode.next) {
					text += '\n';
	
					if (name == 'p') {
						text += '\n';
					}
				}
			}
	
			html = filter(html, [
				/<!\[[^\]]+\]>/g // Conditional comments
			]);
	
			walk(domParser.parse(html));
	
			return text;
		}
	
		/**
		 * Trims the specified HTML by removing all WebKit fragments, all elements wrapping the body trailing BR elements etc.
		 *
		 * @param {String} html Html string to trim contents on.
		 * @return {String} Html contents that got trimmed.
		 */
		function trimHtml(html) {
			function trimSpaces(all, s1, s2) {
				// WebKit &nbsp; meant to preserve multiple spaces but instead inserted around all inline tags,
				// including the spans with inline styles created on paste
				if (!s1 && !s2) {
					return ' ';
				}
	
				return '\u00a0';
			}
	
			html = filter(html, [
				/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/g, // Remove anything but the contents within the BODY element
				/<!--StartFragment-->|<!--EndFragment-->/g, // Inner fragments (tables from excel on mac)
				[/( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g, trimSpaces],
				/<br class="Apple-interchange-newline">/g,
				/<br>$/i // Trailing BR elements
			]);
	
			return html;
		}
	
		// TODO: Should be in some global class
		function createIdGenerator(prefix) {
			var count = 0;
	
			return function() {
				return prefix + (count++);
			};
		}
	
		return {
			filter: filter,
			innerText: innerText,
			trimHtml: trimHtml,
			createIdGenerator: createIdGenerator
		};
	});
	
	// Included from: js/tinymce/plugins/paste/classes/SmartPaste.js
	
	/**
	 * SmartPaste.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Tries to be smart depending on what the user pastes if it looks like an url
	 * it will make a link out of the current selection. If it's an image url that looks
	 * like an image it will check if it's an image and insert it as an image.
	 *
	 * @class tinymce.pasteplugin.SmartPaste
	 * @private
	 */
	define("tinymce/pasteplugin/SmartPaste", [
		"tinymce/util/Tools"
	], function (Tools) {
		var isAbsoluteUrl = function (url) {
			return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
		};
	
		var isImageUrl = function (url) {
			return isAbsoluteUrl(url) && /.(gif|jpe?g|png)$/.test(url);
		};
	
		var createImage = function (editor, url, pasteHtml) {
			editor.undoManager.extra(function () {
				pasteHtml(editor, url);
			}, function () {
				editor.insertContent('<img src="' + url + '">');
			});
	
			return true;
		};
	
		var createLink = function (editor, url, pasteHtml) {
			editor.undoManager.extra(function () {
				pasteHtml(editor, url);
			}, function () {
				editor.execCommand('mceInsertLink', false, url);
			});
	
			return true;
		};
	
		var linkSelection = function (editor, html, pasteHtml) {
			return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtml) : false;
		};
	
		var insertImage = function (editor, html, pasteHtml) {
			return isImageUrl(html) ? createImage(editor, html, pasteHtml) : false;
		};
	
		var pasteHtml = function (editor, html) {
			editor.insertContent(html, {
				merge: editor.settings.paste_merge_formats !== false,
				paste: true
			});
	
			return true;
		};
	
		var smartInsertContent = function (editor, html) {
			Tools.each([
				linkSelection,
				insertImage,
				pasteHtml
			], function (action) {
				return action(editor, html, pasteHtml) !== true;
			});
		};
	
		var insertContent = function (editor, html) {
			if (editor.settings.smart_paste === false) {
				pasteHtml(editor, html);
			} else {
				smartInsertContent(editor, html);
			}
		};
	
		return {
			isImageUrl: isImageUrl,
			isAbsoluteUrl: isAbsoluteUrl,
			insertContent: insertContent
		};
	});
	
	// Included from: js/tinymce/plugins/paste/classes/Clipboard.js
	
	/**
	 * Clipboard.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains logic for getting HTML contents out of the clipboard.
	 *
	 * We need to make a lot of ugly hacks to get the contents out of the clipboard since
	 * the W3C Clipboard API is broken in all browsers that have it: Gecko/WebKit/Blink.
	 * We might rewrite this the way those API:s stabilize. Browsers doesn't handle pasting
	 * from applications like Word the same way as it does when pasting into a contentEditable area
	 * so we need to do lots of extra work to try to get to this clipboard data.
	 *
	 * Current implementation steps:
	 *  1. On keydown with paste keys Ctrl+V or Shift+Insert create
	 *     a paste bin element and move focus to that element.
	 *  2. Wait for the browser to fire a "paste" event and get the contents out of the paste bin.
	 *  3. Check if the paste was successful if true, process the HTML.
	 *  (4). If the paste was unsuccessful use IE execCommand, Clipboard API, document.dataTransfer old WebKit API etc.
	 *
	 * @class tinymce.pasteplugin.Clipboard
	 * @private
	 */
	define("tinymce/pasteplugin/Clipboard", [
		"tinymce/Env",
		"tinymce/dom/RangeUtils",
		"tinymce/util/VK",
		"tinymce/pasteplugin/Utils",
		"tinymce/pasteplugin/SmartPaste",
		"tinymce/util/Delay"
	], function(Env, RangeUtils, VK, Utils, SmartPaste, Delay) {
		return function(editor) {
			var self = this, pasteBinElm, lastRng, keyboardPasteTimeStamp = 0, draggingInternally = false;
			var pasteBinDefaultContent = '%MCEPASTEBIN%', keyboardPastePlainTextState;
			var mceInternalUrlPrefix = 'data:text/mce-internal,';
			var uniqueId = Utils.createIdGenerator("mceclip");
	
			/**
			 * Pastes the specified HTML. This means that the HTML is filtered and then
			 * inserted at the current selection in the editor. It will also fire paste events
			 * for custom user filtering.
			 *
			 * @param {String} html HTML code to paste into the current selection.
			 */
			function pasteHtml(html) {
				var args, dom = editor.dom;
	
				args = editor.fire('BeforePastePreProcess', {content: html}); // Internal event used by Quirks
				args = editor.fire('PastePreProcess', args);
				html = args.content;
	
				if (!args.isDefaultPrevented()) {
					// User has bound PastePostProcess events then we need to pass it through a DOM node
					// This is not ideal but we don't want to let the browser mess up the HTML for example
					// some browsers add &nbsp; to P tags etc
					if (editor.hasEventListeners('PastePostProcess') && !args.isDefaultPrevented()) {
						// We need to attach the element to the DOM so Sizzle selectors work on the contents
						var tempBody = dom.add(editor.getBody(), 'div', {style: 'display:none'}, html);
						args = editor.fire('PastePostProcess', {node: tempBody});
						dom.remove(tempBody);
						html = args.node.innerHTML;
					}
	
					if (!args.isDefaultPrevented()) {
						SmartPaste.insertContent(editor, html);
					}
				}
			}
	
			/**
			 * Pastes the specified text. This means that the plain text is processed
			 * and converted into BR and P elements. It will fire paste events for custom filtering.
			 *
			 * @param {String} text Text to paste as the current selection location.
			 */
			function pasteText(text) {
				text = editor.dom.encode(text).replace(/\r\n/g, '\n');
	
				var startBlock = editor.dom.getParent(editor.selection.getStart(), editor.dom.isBlock);
	
				// Create start block html for example <p attr="value">
				var forcedRootBlockName = editor.settings.forced_root_block;
				var forcedRootBlockStartHtml;
				if (forcedRootBlockName) {
					forcedRootBlockStartHtml = editor.dom.createHTML(forcedRootBlockName, editor.settings.forced_root_block_attrs);
					forcedRootBlockStartHtml = forcedRootBlockStartHtml.substr(0, forcedRootBlockStartHtml.length - 3) + '>';
				}
	
				if ((startBlock && /^(PRE|DIV)$/.test(startBlock.nodeName)) || !forcedRootBlockName) {
					text = Utils.filter(text, [
						[/\n/g, "<br>"]
					]);
				} else {
					text = Utils.filter(text, [
						[/\n\n/g, "</p>" + forcedRootBlockStartHtml],
						[/^(.*<\/p>)(<p>)$/, forcedRootBlockStartHtml + '$1'],
						[/\n/g, "<br />"]
					]);
	
					if (text.indexOf('<p>') != -1) {
						text = forcedRootBlockStartHtml + text;
					}
				}
	
				pasteHtml(text);
			}
	
			/**
			 * Creates a paste bin element as close as possible to the current caret location and places the focus inside that element
			 * so that when the real paste event occurs the contents gets inserted into this element
			 * instead of the current editor selection element.
			 */
			function createPasteBin() {
				var dom = editor.dom, body = editor.getBody();
				var viewport = editor.dom.getViewPort(editor.getWin()), scrollTop = viewport.y, top = 20;
				var scrollContainer;
	
				lastRng = editor.selection.getRng();
	
				if (editor.inline) {
					scrollContainer = editor.selection.getScrollContainer();
	
					// Can't always rely on scrollTop returning a useful value.
					// It returns 0 if the browser doesn't support scrollTop for the element or is non-scrollable
					if (scrollContainer && scrollContainer.scrollTop > 0) {
						scrollTop = scrollContainer.scrollTop;
					}
				}
	
				/**
				 * Returns the rect of the current caret if the caret is in an empty block before a
				 * BR we insert a temporary invisible character that we get the rect this way we always get a proper rect.
				 *
				 * TODO: This might be useful in core.
				 */
				function getCaretRect(rng) {
					var rects, textNode, node, container = rng.startContainer;
	
					rects = rng.getClientRects();
					if (rects.length) {
						return rects[0];
					}
	
					if (!rng.collapsed || container.nodeType != 1) {
						return;
					}
	
					node = container.childNodes[lastRng.startOffset];
	
					// Skip empty whitespace nodes
					while (node && node.nodeType == 3 && !node.data.length) {
						node = node.nextSibling;
					}
	
					if (!node) {
						return;
					}
	
					// Check if the location is |<br>
					// TODO: Might need to expand this to say |<table>
					if (node.tagName == 'BR') {
						textNode = dom.doc.createTextNode('\uFEFF');
						node.parentNode.insertBefore(textNode, node);
	
						rng = dom.createRng();
						rng.setStartBefore(textNode);
						rng.setEndAfter(textNode);
	
						rects = rng.getClientRects();
						dom.remove(textNode);
					}
	
					if (rects.length) {
						return rects[0];
					}
				}
	
				// Calculate top cordinate this is needed to avoid scrolling to top of document
				// We want the paste bin to be as close to the caret as possible to avoid scrolling
				if (lastRng.getClientRects) {
					var rect = getCaretRect(lastRng);
	
					if (rect) {
						// Client rects gets us closes to the actual
						// caret location in for example a wrapped paragraph block
						top = scrollTop + (rect.top - dom.getPos(body).y);
					} else {
						top = scrollTop;
	
						// Check if we can find a closer location by checking the range element
						var container = lastRng.startContainer;
						if (container) {
							if (container.nodeType == 3 && container.parentNode != body) {
								container = container.parentNode;
							}
	
							if (container.nodeType == 1) {
								top = dom.getPos(container, scrollContainer || body).y;
							}
						}
					}
				}
	
				// Create a pastebin
				pasteBinElm = dom.add(editor.getBody(), 'div', {
					id: "mcepastebin",
					contentEditable: true,
					"data-mce-bogus": "all",
					style: 'position: absolute; top: ' + top + 'px;' +
						'width: 10px; height: 10px; overflow: hidden; opacity: 0'
				}, pasteBinDefaultContent);
	
				// Move paste bin out of sight since the controlSelection rect gets displayed otherwise on IE and Gecko
				if (Env.ie || Env.gecko) {
					dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) == 'rtl' ? 0xFFFF : -0xFFFF);
				}
	
				// Prevent focus events from bubbeling fixed FocusManager issues
				dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function(e) {
					e.stopPropagation();
				});
	
				pasteBinElm.focus();
				editor.selection.select(pasteBinElm, true);
			}
	
			/**
			 * Removes the paste bin if it exists.
			 */
			function removePasteBin() {
				if (pasteBinElm) {
					var pasteBinClone;
	
					// WebKit/Blink might clone the div so
					// lets make sure we remove all clones
					// TODO: Man o man is this ugly. WebKit is the new IE! Remove this if they ever fix it!
					while ((pasteBinClone = editor.dom.get('mcepastebin'))) {
						editor.dom.remove(pasteBinClone);
						editor.dom.unbind(pasteBinClone);
					}
	
					if (lastRng) {
						editor.selection.setRng(lastRng);
					}
				}
	
				pasteBinElm = lastRng = null;
			}
	
			/**
			 * Returns the contents of the paste bin as a HTML string.
			 *
			 * @return {String} Get the contents of the paste bin.
			 */
			function getPasteBinHtml() {
				var html = '', pasteBinClones, i, clone, cloneHtml;
	
				// Since WebKit/Chrome might clone the paste bin when pasting
				// for example: <img style="float: right"> we need to check if any of them contains some useful html.
				// TODO: Man o man is this ugly. WebKit is the new IE! Remove this if they ever fix it!
				pasteBinClones = editor.dom.select('div[id=mcepastebin]');
				for (i = 0; i < pasteBinClones.length; i++) {
					clone = pasteBinClones[i];
	
					// Pasting plain text produces pastebins in pastebinds makes sence right!?
					if (clone.firstChild && clone.firstChild.id == 'mcepastebin') {
						clone = clone.firstChild;
					}
	
					cloneHtml = clone.innerHTML;
					if (html != pasteBinDefaultContent) {
						html += cloneHtml;
					}
				}
	
				return html;
			}
	
			/**
			 * Gets various content types out of a datatransfer object.
			 *
			 * @param {DataTransfer} dataTransfer Event fired on paste.
			 * @return {Object} Object with mime types and data for those mime types.
			 */
			function getDataTransferItems(dataTransfer) {
				var items = {};
	
				if (dataTransfer) {
					// Use old WebKit/IE API
					if (dataTransfer.getData) {
						var legacyText = dataTransfer.getData('Text');
						if (legacyText && legacyText.length > 0) {
							if (legacyText.indexOf(mceInternalUrlPrefix) == -1) {
								items['text/plain'] = legacyText;
							}
						}
					}
	
					if (dataTransfer.types) {
						for (var i = 0; i < dataTransfer.types.length; i++) {
							var contentType = dataTransfer.types[i];
							items[contentType] = dataTransfer.getData(contentType);
						}
					}
				}
	
				return items;
			}
	
			/**
			 * Gets various content types out of the Clipboard API. It will also get the
			 * plain text using older IE and WebKit API:s.
			 *
			 * @param {ClipboardEvent} clipboardEvent Event fired on paste.
			 * @return {Object} Object with mime types and data for those mime types.
			 */
			function getClipboardContent(clipboardEvent) {
				return getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
			}
	
			function hasHtmlOrText(content) {
				return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
			}
	
			function getBase64FromUri(uri) {
				var idx;
	
				idx = uri.indexOf(',');
				if (idx !== -1) {
					return uri.substr(idx + 1);
				}
	
				return null;
			}
	
			function isValidDataUriImage(settings, imgElm) {
				return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
			}
	
			function pasteImage(rng, reader, blob) {
				if (rng) {
					editor.selection.setRng(rng);
					rng = null;
				}
	
				var dataUri = reader.result;
				var base64 = getBase64FromUri(dataUri);
	
				var img = new Image();
				img.src = dataUri;
	
				// TODO: Move the bulk of the cache logic to EditorUpload
				if (isValidDataUriImage(editor.settings, img)) {
					var blobCache = editor.editorUpload.blobCache;
					var blobInfo, existingBlobInfo;
	
					existingBlobInfo = blobCache.findFirst(function(cachedBlobInfo) {
						return cachedBlobInfo.base64() === base64;
					});
	
					if (!existingBlobInfo) {
						blobInfo = blobCache.create(uniqueId(), blob, base64);
						blobCache.add(blobInfo);
					} else {
						blobInfo = existingBlobInfo;
					}
	
					pasteHtml('<img src="' + blobInfo.blobUri() + '">');
				} else {
					pasteHtml('<img src="' + dataUri + '">');
				}
			}
	
			/**
			 * Checks if the clipboard contains image data if it does it will take that data
			 * and convert it into a data url image and paste that image at the caret location.
			 *
			 * @param  {ClipboardEvent} e Paste/drop event object.
			 * @param  {DOMRange} rng Rng object to move selection to.
			 * @return {Boolean} true/false if the image data was found or not.
			 */
			function pasteImageData(e, rng) {
				var dataTransfer = e.clipboardData || e.dataTransfer;
	
				function processItems(items) {
					var i, item, reader, hadImage = false;
	
					if (items) {
						for (i = 0; i < items.length; i++) {
							item = items[i];
	
							if (/^image\/(jpeg|png|gif|bmp)$/.test(item.type)) {
								var blob = item.getAsFile ? item.getAsFile() : item;
	
								reader = new FileReader();
								reader.onload = pasteImage.bind(null, rng, reader, blob);
								reader.readAsDataURL(blob);
	
								e.preventDefault();
								hadImage = true;
							}
						}
					}
	
					return hadImage;
				}
	
				if (editor.settings.paste_data_images && dataTransfer) {
					return processItems(dataTransfer.items) || processItems(dataTransfer.files);
				}
			}
	
			/**
			 * Chrome on Android doesn't support proper clipboard access so we have no choice but to allow the browser default behavior.
			 *
			 * @param {Event} e Paste event object to check if it contains any data.
			 * @return {Boolean} true/false if the clipboard is empty or not.
			 */
			function isBrokenAndroidClipboardEvent(e) {
				var clipboardData = e.clipboardData;
	
				return navigator.userAgent.indexOf('Android') != -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
			}
	
			function getCaretRangeFromEvent(e) {
				return RangeUtils.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
			}
	
			function hasContentType(clipboardContent, mimeType) {
				return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
			}
	
			function isKeyboardPasteEvent(e) {
				return (VK.metaKeyPressed(e) && e.keyCode == 86) || (e.shiftKey && e.keyCode == 45);
			}
	
			function registerEventHandlers() {
				editor.on('keydown', function(e) {
					function removePasteBinOnKeyUp(e) {
						// Ctrl+V or Shift+Insert
						if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
							removePasteBin();
						}
					}
	
					// Ctrl+V or Shift+Insert
					if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
						keyboardPastePlainTextState = e.shiftKey && e.keyCode == 86;
	
						// Edge case on Safari on Mac where it doesn't handle Cmd+Shift+V correctly
						// it fires the keydown but no paste or keyup so we are left with a paste bin
						if (keyboardPastePlainTextState && Env.webkit && navigator.userAgent.indexOf('Version/') != -1) {
							return;
						}
	
						// Prevent undoManager keydown handler from making an undo level with the pastebin in it
						e.stopImmediatePropagation();
	
						keyboardPasteTimeStamp = new Date().getTime();
	
						// IE doesn't support Ctrl+Shift+V and it doesn't even produce a paste event
						// so lets fake a paste event and let IE use the execCommand/dataTransfer methods
						if (Env.ie && keyboardPastePlainTextState) {
							e.preventDefault();
							editor.fire('paste', {ieFake: true});
							return;
						}
	
						removePasteBin();
						createPasteBin();
	
						// Remove pastebin if we get a keyup and no paste event
						// For example pasting a file in IE 11 will not produce a paste event
						editor.once('keyup', removePasteBinOnKeyUp);
						editor.once('paste', function() {
							editor.off('keyup', removePasteBinOnKeyUp);
						});
					}
				});
	
				function insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode) {
					var content;
	
					// Grab HTML from Clipboard API or paste bin as a fallback
					if (hasContentType(clipboardContent, 'text/html')) {
						content = clipboardContent['text/html'];
					} else {
						content = getPasteBinHtml();
	
						// If paste bin is empty try using plain text mode
						// since that is better than nothing right
						if (content == pasteBinDefaultContent) {
							plainTextMode = true;
						}
					}
	
					content = Utils.trimHtml(content);
	
					// WebKit has a nice bug where it clones the paste bin if you paste from for example notepad
					// so we need to force plain text mode in this case
					if (pasteBinElm && pasteBinElm.firstChild && pasteBinElm.firstChild.id === 'mcepastebin') {
						plainTextMode = true;
					}
	
					removePasteBin();
	
					// If we got nothing from clipboard API and pastebin then we could try the last resort: plain/text
					if (!content.length) {
						plainTextMode = true;
					}
	
					// Grab plain text from Clipboard API or convert existing HTML to plain text
					if (plainTextMode) {
						// Use plain text contents from Clipboard API unless the HTML contains paragraphs then
						// we should convert the HTML to plain text since works better when pasting HTML/Word contents as plain text
						if (hasContentType(clipboardContent, 'text/plain') && content.indexOf('</p>') == -1) {
							content = clipboardContent['text/plain'];
						} else {
							content = Utils.innerText(content);
						}
					}
	
					// If the content is the paste bin default HTML then it was
					// impossible to get the cliboard data out.
					if (content == pasteBinDefaultContent) {
						if (!isKeyBoardPaste) {
							editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
						}
	
						return;
					}
	
					if (plainTextMode) {
						pasteText(content);
					} else {
						pasteHtml(content);
					}
				}
	
				var getLastRng = function() {
					return lastRng || editor.selection.getRng();
				};
	
				editor.on('paste', function(e) {
					// Getting content from the Clipboard can take some time
					var clipboardTimer = new Date().getTime();
					var clipboardContent = getClipboardContent(e);
					var clipboardDelay = new Date().getTime() - clipboardTimer;
	
					var isKeyBoardPaste = (new Date().getTime() - keyboardPasteTimeStamp - clipboardDelay) < 1000;
					var plainTextMode = self.pasteFormat == "text" || keyboardPastePlainTextState;
	
					keyboardPastePlainTextState = false;
	
					if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
						removePasteBin();
						return;
					}
	
					if (!hasHtmlOrText(clipboardContent) && pasteImageData(e, getLastRng())) {
						removePasteBin();
						return;
					}
	
					// Not a keyboard paste prevent default paste and try to grab the clipboard contents using different APIs
					if (!isKeyBoardPaste) {
						e.preventDefault();
					}
	
					// Try IE only method if paste isn't a keyboard paste
					if (Env.ie && (!isKeyBoardPaste || e.ieFake)) {
						createPasteBin();
	
						editor.dom.bind(pasteBinElm, 'paste', function(e) {
							e.stopPropagation();
						});
	
						editor.getDoc().execCommand('Paste', false, null);
						clipboardContent["text/html"] = getPasteBinHtml();
					}
	
					// If clipboard API has HTML then use that directly
					if (hasContentType(clipboardContent, 'text/html')) {
						e.preventDefault();
						insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode);
					} else {
						Delay.setEditorTimeout(editor, function() {
							insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode);
						}, 0);
					}
				});
	
				editor.on('dragstart dragend', function(e) {
					draggingInternally = e.type == 'dragstart';
				});
	
				function isPlainTextFileUrl(content) {
					return content['text/plain'].indexOf('file://') === 0;
				}
	
				editor.on('drop', function(e) {
					var dropContent, rng;
	
					rng = getCaretRangeFromEvent(e);
	
					if (e.isDefaultPrevented() || draggingInternally) {
						return;
					}
	
					dropContent = getDataTransferItems(e.dataTransfer);
	
					if ((!hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && pasteImageData(e, rng)) {
						return;
					}
	
					if (rng && editor.settings.paste_filter_drop !== false) {
						var content = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	
						if (content) {
							e.preventDefault();
	
							// FF 45 doesn't paint a caret when dragging in text in due to focus call by execCommand
							Delay.setEditorTimeout(editor, function() {
								editor.undoManager.transact(function() {
									if (dropContent['mce-internal']) {
										editor.execCommand('Delete');
									}
	
									editor.selection.setRng(rng);
	
									content = Utils.trimHtml(content);
	
									if (!dropContent['text/html']) {
										pasteText(content);
									} else {
										pasteHtml(content);
									}
								});
							});
						}
					}
				});
	
				editor.on('dragover dragend', function(e) {
					if (editor.settings.paste_data_images) {
						e.preventDefault();
					}
				});
			}
	
			self.pasteHtml = pasteHtml;
			self.pasteText = pasteText;
			self.pasteImageData = pasteImageData;
	
			editor.on('preInit', function() {
				registerEventHandlers();
	
				// Remove all data images from paste for example from Gecko
				// except internal images like video elements
				editor.parser.addNodeFilter('img', function(nodes, name, args) {
					function isPasteInsert(args) {
						return args.data && args.data.paste === true;
					}
	
					function remove(node) {
						if (!node.attr('data-mce-object') && src !== Env.transparentSrc) {
							node.remove();
						}
					}
	
					function isWebKitFakeUrl(src) {
						return src.indexOf("webkit-fake-url") === 0;
					}
	
					function isDataUri(src) {
						return src.indexOf("data:") === 0;
					}
	
					if (!editor.settings.paste_data_images && isPasteInsert(args)) {
						var i = nodes.length;
	
						while (i--) {
							var src = nodes[i].attributes.map.src;
	
							if (!src) {
								continue;
							}
	
							// Safari on Mac produces webkit-fake-url see: https://bugs.webkit.org/show_bug.cgi?id=49141
							if (isWebKitFakeUrl(src)) {
								remove(nodes[i]);
							} else if (!editor.settings.allow_html_data_urls && isDataUri(src)) {
								remove(nodes[i]);
							}
						}
					}
				});
			});
		};
	});
	
	// Included from: js/tinymce/plugins/paste/classes/WordFilter.js
	
	/**
	 * WordFilter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class parses word HTML into proper TinyMCE markup.
	 *
	 * @class tinymce.pasteplugin.WordFilter
	 * @private
	 */
	define("tinymce/pasteplugin/WordFilter", [
		"tinymce/util/Tools",
		"tinymce/html/DomParser",
		"tinymce/html/Schema",
		"tinymce/html/Serializer",
		"tinymce/html/Node",
		"tinymce/pasteplugin/Utils"
	], function(Tools, DomParser, Schema, Serializer, Node, Utils) {
		/**
		 * Checks if the specified content is from any of the following sources: MS Word/Office 365/Google docs.
		 */
		function isWordContent(content) {
			return (
				(/<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i).test(content) ||
				(/class="OutlineElement/).test(content) ||
				(/id="?docs\-internal\-guid\-/.test(content))
			);
		}
	
		/**
		 * Checks if the specified text starts with "1. " or "a. " etc.
		 */
		function isNumericList(text) {
			var found, patterns;
	
			patterns = [
				/^[IVXLMCD]{1,2}\.[ \u00a0]/,  // Roman upper case
				/^[ivxlmcd]{1,2}\.[ \u00a0]/,  // Roman lower case
				/^[a-z]{1,2}[\.\)][ \u00a0]/,  // Alphabetical a-z
				/^[A-Z]{1,2}[\.\)][ \u00a0]/,  // Alphabetical A-Z
				/^[0-9]+\.[ \u00a0]/,          // Numeric lists
				/^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/, // Japanese
				/^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/  // Chinese
			];
	
			text = text.replace(/^[\u00a0 ]+/, '');
	
			Tools.each(patterns, function(pattern) {
				if (pattern.test(text)) {
					found = true;
					return false;
				}
			});
	
			return found;
		}
	
		function isBulletList(text) {
			return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
		}
	
		function WordFilter(editor) {
			var settings = editor.settings;
	
			editor.on('BeforePastePreProcess', function(e) {
				var content = e.content, retainStyleProperties, validStyles;
	
				// Remove google docs internal guid markers
				content = content.replace(/<b[^>]+id="?docs-internal-[^>]*>/gi, '');
				content = content.replace(/<br class="?Apple-interchange-newline"?>/gi, '');
	
				retainStyleProperties = settings.paste_retain_style_properties;
				if (retainStyleProperties) {
					validStyles = Tools.makeMap(retainStyleProperties.split(/[, ]/));
				}
	
				/**
				 * Converts fake bullet and numbered lists to real semantic OL/UL.
				 *
				 * @param {tinymce.html.Node} node Root node to convert children of.
				 */
				function convertFakeListsToProperLists(node) {
					var currentListNode, prevListNode, lastLevel = 1;
	
					function getText(node) {
						var txt = '';
	
						if (node.type === 3) {
							return node.value;
						}
	
						if ((node = node.firstChild)) {
							do {
								txt += getText(node);
							} while ((node = node.next));
						}
	
						return txt;
					}
	
					function trimListStart(node, regExp) {
						if (node.type === 3) {
							if (regExp.test(node.value)) {
								node.value = node.value.replace(regExp, '');
								return false;
							}
						}
	
						if ((node = node.firstChild)) {
							do {
								if (!trimListStart(node, regExp)) {
									return false;
								}
							} while ((node = node.next));
						}
	
						return true;
					}
	
					function removeIgnoredNodes(node) {
						if (node._listIgnore) {
							node.remove();
							return;
						}
	
						if ((node = node.firstChild)) {
							do {
								removeIgnoredNodes(node);
							} while ((node = node.next));
						}
					}
	
					function convertParagraphToLi(paragraphNode, listName, start) {
						var level = paragraphNode._listLevel || lastLevel;
	
						// Handle list nesting
						if (level != lastLevel) {
							if (level < lastLevel) {
								// Move to parent list
								if (currentListNode) {
									currentListNode = currentListNode.parent.parent;
								}
							} else {
								// Create new list
								prevListNode = currentListNode;
								currentListNode = null;
							}
						}
	
						if (!currentListNode || currentListNode.name != listName) {
							prevListNode = prevListNode || currentListNode;
							currentListNode = new Node(listName, 1);
	
							if (start > 1) {
								currentListNode.attr('start', '' + start);
							}
	
							paragraphNode.wrap(currentListNode);
						} else {
							currentListNode.append(paragraphNode);
						}
	
						paragraphNode.name = 'li';
	
						// Append list to previous list if it exists
						if (level > lastLevel && prevListNode) {
							prevListNode.lastChild.append(currentListNode);
						}
	
						lastLevel = level;
	
						// Remove start of list item "1. " or "&middot; " etc
						removeIgnoredNodes(paragraphNode);
						trimListStart(paragraphNode, /^\u00a0+/);
						trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
						trimListStart(paragraphNode, /^\u00a0+/);
					}
	
					// Build a list of all root level elements before we start
					// altering them in the loop below.
					var elements = [], child = node.firstChild;
					while (typeof child !== 'undefined' && child !== null) {
						elements.push(child);
	
						child = child.walk();
						if (child !== null) {
							while (typeof child !== 'undefined' && child.parent !== node) {
								child = child.walk();
							}
						}
					}
	
					for (var i = 0; i < elements.length; i++) {
						node = elements[i];
	
						if (node.name == 'p' && node.firstChild) {
							// Find first text node in paragraph
							var nodeText = getText(node);
	
							// Detect unordered lists look for bullets
							if (isBulletList(nodeText)) {
								convertParagraphToLi(node, 'ul');
								continue;
							}
	
							// Detect ordered lists 1., a. or ixv.
							if (isNumericList(nodeText)) {
								// Parse OL start number
								var matches = /([0-9]+)\./.exec(nodeText);
								var start = 1;
								if (matches) {
									start = parseInt(matches[1], 10);
								}
	
								convertParagraphToLi(node, 'ol', start);
								continue;
							}
	
							// Convert paragraphs marked as lists but doesn't look like anything
							if (node._listLevel) {
								convertParagraphToLi(node, 'ul', 1);
								continue;
							}
	
							currentListNode = null;
						} else {
							// If the root level element isn't a p tag which can be
							// processed by convertParagraphToLi, it interrupts the
							// lists, causing a new list to start instead of having
							// elements from the next list inserted above this tag.
							prevListNode = currentListNode;
							currentListNode = null;
						}
					}
				}
	
				function filterStyles(node, styleValue) {
					var outputStyles = {}, matches, styles = editor.dom.parseStyle(styleValue);
	
					Tools.each(styles, function(value, name) {
						// Convert various MS styles to W3C styles
						switch (name) {
							case 'mso-list':
								// Parse out list indent level for lists
								matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
								if (matches) {
									node._listLevel = parseInt(matches[1], 10);
								}
	
								// Remove these nodes <span style="mso-list:Ignore">o</span>
								// Since the span gets removed we mark the text node and the span
								if (/Ignore/i.test(value) && node.firstChild) {
									node._listIgnore = true;
									node.firstChild._listIgnore = true;
								}
	
								break;
	
							case "horiz-align":
								name = "text-align";
								break;
	
							case "vert-align":
								name = "vertical-align";
								break;
	
							case "font-color":
							case "mso-foreground":
								name = "color";
								break;
	
							case "mso-background":
							case "mso-highlight":
								name = "background";
								break;
	
							case "font-weight":
							case "font-style":
								if (value != "normal") {
									outputStyles[name] = value;
								}
								return;
	
							case "mso-element":
								// Remove track changes code
								if (/^(comment|comment-list)$/i.test(value)) {
									node.remove();
									return;
								}
	
								break;
						}
	
						if (name.indexOf('mso-comment') === 0) {
							node.remove();
							return;
						}
	
						// Never allow mso- prefixed names
						if (name.indexOf('mso-') === 0) {
							return;
						}
	
						// Output only valid styles
						if (retainStyleProperties == "all" || (validStyles && validStyles[name])) {
							outputStyles[name] = value;
						}
					});
	
					// Convert bold style to "b" element
					if (/(bold)/i.test(outputStyles["font-weight"])) {
						delete outputStyles["font-weight"];
						node.wrap(new Node("b", 1));
					}
	
					// Convert italic style to "i" element
					if (/(italic)/i.test(outputStyles["font-style"])) {
						delete outputStyles["font-style"];
						node.wrap(new Node("i", 1));
					}
	
					// Serialize the styles and see if there is something left to keep
					outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
					if (outputStyles) {
						return outputStyles;
					}
	
					return null;
				}
	
				if (settings.paste_enable_default_filters === false) {
					return;
				}
	
				// Detect is the contents is Word junk HTML
				if (isWordContent(e.content)) {
					e.wordContent = true; // Mark it for other processors
	
					// Remove basic Word junk
					content = Utils.filter(content, [
						// Word comments like conditional comments etc
						/<!--[\s\S]+?-->/gi,
	
						// Remove comments, scripts (e.g., msoShowComment), XML tag, VML content,
						// MS Office namespaced tags, and a few other tags
						/<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	
						// Convert <s> into <strike> for line-though
						[/<(\/?)s>/gi, "<$1strike>"],
	
						// Replace nsbp entites to char since it's easier to handle
						[/&nbsp;/gi, "\u00a0"],
	
						// Convert <span style="mso-spacerun:yes">___</span> to string of alternating
						// breaking/non-breaking spaces of same length
						[/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
							function(str, spaces) {
								return (spaces.length > 0) ?
									spaces.replace(/./, " ").slice(Math.floor(spaces.length / 2)).split("").join("\u00a0") : "";
							}
						]
					]);
	
					var validElements = settings.paste_word_valid_elements;
					if (!validElements) {
						validElements = (
							'-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' +
							'-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' +
							'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody'
						);
					}
	
					// Setup strict schema
					var schema = new Schema({
						valid_elements: validElements,
						valid_children: '-li[p]'
					});
	
					// Add style/class attribute to all element rules since the user might have removed them from
					// paste_word_valid_elements config option and we need to check them for properties
					Tools.each(schema.elements, function(rule) {
						/*eslint dot-notation:0*/
						if (!rule.attributes["class"]) {
							rule.attributes["class"] = {};
							rule.attributesOrder.push("class");
						}
	
						if (!rule.attributes.style) {
							rule.attributes.style = {};
							rule.attributesOrder.push("style");
						}
					});
	
					// Parse HTML into DOM structure
					var domParser = new DomParser({}, schema);
	
					// Filter styles to remove "mso" specific styles and convert some of them
					domParser.addAttributeFilter('style', function(nodes) {
						var i = nodes.length, node;
	
						while (i--) {
							node = nodes[i];
							node.attr('style', filterStyles(node, node.attr('style')));
	
							// Remove pointess spans
							if (node.name == 'span' && node.parent && !node.attributes.length) {
								node.unwrap();
							}
						}
					});
	
					// Check the class attribute for comments or del items and remove those
					domParser.addAttributeFilter('class', function(nodes) {
						var i = nodes.length, node, className;
	
						while (i--) {
							node = nodes[i];
	
							className = node.attr('class');
							if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
								node.remove();
							}
	
							node.attr('class', null);
						}
					});
	
					// Remove all del elements since we don't want the track changes code in the editor
					domParser.addNodeFilter('del', function(nodes) {
						var i = nodes.length;
	
						while (i--) {
							nodes[i].remove();
						}
					});
	
					// Keep some of the links and anchors
					domParser.addNodeFilter('a', function(nodes) {
						var i = nodes.length, node, href, name;
	
						while (i--) {
							node = nodes[i];
							href = node.attr('href');
							name = node.attr('name');
	
							if (href && href.indexOf('#_msocom_') != -1) {
								node.remove();
								continue;
							}
	
							if (href && href.indexOf('file://') === 0) {
								href = href.split('#')[1];
								if (href) {
									href = '#' + href;
								}
							}
	
							if (!href && !name) {
								node.unwrap();
							} else {
								// Remove all named anchors that aren't specific to TOC, Footnotes or Endnotes
								if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
									node.unwrap();
									continue;
								}
	
								node.attr({
									href: href,
									name: name
								});
							}
						}
					});
	
					// Parse into DOM structure
					var rootNode = domParser.parse(content);
	
					// Process DOM
					if (settings.paste_convert_word_fake_lists !== false) {
						convertFakeListsToProperLists(rootNode);
					}
	
					// Serialize DOM back to HTML
					e.content = new Serializer({
						validate: settings.validate
					}, schema).serialize(rootNode);
				}
			});
		}
	
		WordFilter.isWordContent = isWordContent;
	
		return WordFilter;
	});
	
	// Included from: js/tinymce/plugins/paste/classes/Quirks.js
	
	/**
	 * Quirks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various fixes for browsers. These issues can not be feature
	 * detected since we have no direct control over the clipboard. However we might be able
	 * to remove some of these fixes once the browsers gets updated/fixed.
	 *
	 * @class tinymce.pasteplugin.Quirks
	 * @private
	 */
	define("tinymce/pasteplugin/Quirks", [
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/pasteplugin/WordFilter",
		"tinymce/pasteplugin/Utils"
	], function(Env, Tools, WordFilter, Utils) {
		"use strict";
	
		return function(editor) {
			function addPreProcessFilter(filterFunc) {
				editor.on('BeforePastePreProcess', function(e) {
					e.content = filterFunc(e.content);
				});
			}
	
			/**
			 * Removes BR elements after block elements. IE9 has a nasty bug where it puts a BR element after each
			 * block element when pasting from word. This removes those elements.
			 *
			 * This:
			 *  <p>a</p><br><p>b</p>
			 *
			 * Becomes:
			 *  <p>a</p><p>b</p>
			 */
			function removeExplorerBrElementsAfterBlocks(html) {
				// Only filter word specific content
				if (!WordFilter.isWordContent(html)) {
					return html;
				}
	
				// Produce block regexp based on the block elements in schema
				var blockElements = [];
	
				Tools.each(editor.schema.getBlockElements(), function(block, blockName) {
					blockElements.push(blockName);
				});
	
				var explorerBlocksRegExp = new RegExp(
					'(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*',
					'g'
				);
	
				// Remove BR:s from: <BLOCK>X</BLOCK><BR>
				html = Utils.filter(html, [
					[explorerBlocksRegExp, '$1']
				]);
	
				// IE9 also adds an extra BR element for each soft-linefeed and it also adds a BR for each word wrap break
				html = Utils.filter(html, [
					[/<br><br>/g, '<BR><BR>'], // Replace multiple BR elements with uppercase BR to keep them intact
					[/<br>/g, ' '],            // Replace single br elements with space since they are word wrap BR:s
					[/<BR><BR>/g, '<br>']      // Replace back the double brs but into a single BR
				]);
	
				return html;
			}
	
			/**
			 * WebKit has a nasty bug where the all computed styles gets added to style attributes when copy/pasting contents.
			 * This fix solves that by simply removing the whole style attribute.
			 *
			 * The paste_webkit_styles option can be set to specify what to keep:
			 *  paste_webkit_styles: "none" // Keep no styles
			 *  paste_webkit_styles: "all", // Keep all of them
			 *  paste_webkit_styles: "font-weight color" // Keep specific ones
			 *
			 * @param {String} content Content that needs to be processed.
			 * @return {String} Processed contents.
			 */
			function removeWebKitStyles(content) {
				// Passthrough all styles from Word and let the WordFilter handle that junk
				if (WordFilter.isWordContent(content)) {
					return content;
				}
	
				// Filter away styles that isn't matching the target node
				var webKitStyles = editor.settings.paste_webkit_styles;
	
				if (editor.settings.paste_remove_styles_if_webkit === false || webKitStyles == "all") {
					return content;
				}
	
				if (webKitStyles) {
					webKitStyles = webKitStyles.split(/[, ]/);
				}
	
				// Keep specific styles that doesn't match the current node computed style
				if (webKitStyles) {
					var dom = editor.dom, node = editor.selection.getNode();
	
					content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function(all, before, value, after) {
						var inputStyles = dom.parseStyle(value, 'span'), outputStyles = {};
	
						if (webKitStyles === "none") {
							return before + after;
						}
	
						for (var i = 0; i < webKitStyles.length; i++) {
							var inputValue = inputStyles[webKitStyles[i]], currentValue = dom.getStyle(node, webKitStyles[i], true);
	
							if (/color/.test(webKitStyles[i])) {
								inputValue = dom.toHex(inputValue);
								currentValue = dom.toHex(currentValue);
							}
	
							if (currentValue != inputValue) {
								outputStyles[webKitStyles[i]] = inputValue;
							}
						}
	
						outputStyles = dom.serializeStyle(outputStyles, 'span');
						if (outputStyles) {
							return before + ' style="' + outputStyles + '"' + after;
						}
	
						return before + after;
					});
				} else {
					// Remove all external styles
					content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
				}
	
				// Keep internal styles
				content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function(all, before, value, after) {
					return before + ' style="' + value + '"' + after;
				});
	
				return content;
			}
	
			// Sniff browsers and apply fixes since we can't feature detect
			if (Env.webkit) {
				addPreProcessFilter(removeWebKitStyles);
			}
	
			if (Env.ie) {
				addPreProcessFilter(removeExplorerBrElementsAfterBlocks);
			}
		};
	});
	
	// Included from: js/tinymce/plugins/paste/classes/Plugin.js
	
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains the tinymce plugin logic for the paste plugin.
	 *
	 * @class tinymce.pasteplugin.Plugin
	 * @private
	 */
	define("tinymce/pasteplugin/Plugin", [
		"tinymce/PluginManager",
		"tinymce/pasteplugin/Clipboard",
		"tinymce/pasteplugin/WordFilter",
		"tinymce/pasteplugin/Quirks"
	], function(PluginManager, Clipboard, WordFilter, Quirks) {
		var userIsInformed;
	
		PluginManager.add('paste', function(editor) {
			var self = this, clipboard, settings = editor.settings;
	
			function isUserInformedAboutPlainText() {
				return userIsInformed || editor.settings.paste_plaintext_inform === false;
			}
	
			function togglePlainTextPaste() {
				if (clipboard.pasteFormat == "text") {
					this.active(false);
					clipboard.pasteFormat = "html";
					editor.fire('PastePlainTextToggle', {state: false});
				} else {
					clipboard.pasteFormat = "text";
					this.active(true);
	
					if (!isUserInformedAboutPlainText()) {
						var message = editor.translate('Paste is now in plain text mode. Contents will now ' +
							'be pasted as plain text until you toggle this option off.');
	
						editor.notificationManager.open({
							text: message,
							type: 'info'
						});
	
						userIsInformed = true;
						editor.fire('PastePlainTextToggle', {state: true});
					}
				}
	
				editor.focus();
			}
	
			// draw back if power version is requested and registered
			if (/(^|[ ,])powerpaste([, ]|$)/.test(settings.plugins) && PluginManager.get('powerpaste')) {
				/*eslint no-console:0 */
				if (typeof console !== "undefined" && console.log) {
					console.log("PowerPaste is incompatible with Paste plugin! Remove 'paste' from the 'plugins' option.");
				}
				return;
			}
	
			self.clipboard = clipboard = new Clipboard(editor);
			self.quirks = new Quirks(editor);
			self.wordFilter = new WordFilter(editor);
	
			if (editor.settings.paste_as_text) {
				self.clipboard.pasteFormat = "text";
			}
	
			if (settings.paste_preprocess) {
				editor.on('PastePreProcess', function(e) {
					settings.paste_preprocess.call(self, self, e);
				});
			}
	
			if (settings.paste_postprocess) {
				editor.on('PastePostProcess', function(e) {
					settings.paste_postprocess.call(self, self, e);
				});
			}
	
			editor.addCommand('mceInsertClipboardContent', function(ui, value) {
				if (value.content) {
					self.clipboard.pasteHtml(value.content);
				}
	
				if (value.text) {
					self.clipboard.pasteText(value.text);
				}
			});
	
			// Block all drag/drop events
			if (editor.settings.paste_block_drop) {
				editor.on('dragend dragover draggesture dragdrop drop drag', function(e) {
					e.preventDefault();
					e.stopPropagation();
				});
			}
	
			// Prevent users from dropping data images on Gecko
			if (!editor.settings.paste_data_images) {
				editor.on('drop', function(e) {
					var dataTransfer = e.dataTransfer;
	
					if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
						e.preventDefault();
					}
				});
			}
	
			editor.addButton('pastetext', {
				icon: 'pastetext',
				tooltip: 'Paste as text',
				onclick: togglePlainTextPaste,
				active: self.clipboard.pasteFormat == "text"
			});
	
			editor.addMenuItem('pastetext', {
				text: 'Paste as text',
				selectable: true,
				active: clipboard.pasteFormat,
				onclick: togglePlainTextPaste
			});
		});
	});
	
	expose(["tinymce/pasteplugin/Utils"]);
	})(this);
	}.call(window));

/***/ },
/* 228 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('preview', function(editor) {
		var settings = editor.settings, sandbox = !tinymce.Env.ie;
	
		editor.addCommand('mcePreview', function() {
			editor.windowManager.open({
				title: 'Preview',
				width: parseInt(editor.getParam("plugin_preview_width", "650"), 10),
				height: parseInt(editor.getParam("plugin_preview_height", "500"), 10),
				html: '<iframe src="javascript:\'\'" frameborder="0"' + (sandbox ? ' sandbox="allow-scripts"' : '') + '></iframe>',
				buttons: {
					text: 'Close',
					onclick: function() {
						this.parent().parent().close();
					}
				},
				onPostRender: function() {
					var previewHtml, headHtml = '';
	
					headHtml += '<base href="' + editor.documentBaseURI.getURI() + '">';
	
					tinymce.each(editor.contentCSS, function(url) {
						headHtml += '<link type="text/css" rel="stylesheet" href="' + editor.documentBaseURI.toAbsolute(url) + '">';
					});
	
					var bodyId = settings.body_id || 'tinymce';
					if (bodyId.indexOf('=') != -1) {
						bodyId = editor.getParam('body_id', '', 'hash');
						bodyId = bodyId[editor.id] || bodyId;
					}
	
					var bodyClass = settings.body_class || '';
					if (bodyClass.indexOf('=') != -1) {
						bodyClass = editor.getParam('body_class', '', 'hash');
						bodyClass = bodyClass[editor.id] || '';
					}
	
					var preventClicksOnLinksScript = (
						'<script>' +
							'document.addEventListener && document.addEventListener("click", function(e) {' +
								'for (var elm = e.target; elm; elm = elm.parentNode) {' +
									'if (elm.nodeName === "A") {' +
										'e.preventDefault();' +
									'}' +
								'}' +
							'}, false);' +
						'</script> '
					);
	
					var dirAttr = editor.settings.directionality ? ' dir="' + editor.settings.directionality + '"' : '';
	
					previewHtml = (
						'<!DOCTYPE html>' +
						'<html>' +
						'<head>' +
							headHtml +
						'</head>' +
						'<body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '"' + dirAttr + '>' +
							editor.getContent() +
							preventClicksOnLinksScript +
						'</body>' +
						'</html>'
					);
	
					if (!sandbox) {
						// IE 6-11 doesn't support data uris on iframes
						// so I guess they will have to be less secure since we can't sandbox on those
						// TODO: Use sandbox if future versions of IE supports iframes with data: uris.
						var doc = this.getEl('body').firstChild.contentWindow.document;
						doc.open();
						doc.write(previewHtml);
						doc.close();
					} else {
						this.getEl('body').firstChild.src = 'data:text/html;charset=utf-8,' + encodeURIComponent(previewHtml);
					}
				}
			});
		});
	
		editor.addButton('preview', {
			title: 'Preview',
			cmd: 'mcePreview'
		});
	
		editor.addMenuItem('preview', {
			text: 'Preview',
			cmd: 'mcePreview',
			context: 'view'
		});
	});
	
	}.call(window));

/***/ },
/* 229 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('tabfocus', function(editor) {
		var DOM = tinymce.DOM, each = tinymce.each, explode = tinymce.explode;
	
		function tabCancel(e) {
			if (e.keyCode === 9 && !e.ctrlKey && !e.altKey && !e.metaKey) {
				e.preventDefault();
			}
		}
	
		function tabHandler(e) {
			var x, el, v, i;
	
			if (e.keyCode !== 9 || e.ctrlKey || e.altKey || e.metaKey || e.isDefaultPrevented()) {
				return;
			}
	
			function find(direction) {
				el = DOM.select(':input:enabled,*[tabindex]:not(iframe)');
	
				function canSelectRecursive(e) {
					return e.nodeName === "BODY" || (e.type != 'hidden' &&
						e.style.display != "none" &&
						e.style.visibility != "hidden" && canSelectRecursive(e.parentNode));
				}
	
				function canSelect(el) {
					return /INPUT|TEXTAREA|BUTTON/.test(el.tagName) && tinymce.get(e.id) && el.tabIndex != -1 && canSelectRecursive(el);
				}
	
				each(el, function(e, i) {
					if (e.id == editor.id) {
						x = i;
						return false;
					}
				});
				if (direction > 0) {
					for (i = x + 1; i < el.length; i++) {
						if (canSelect(el[i])) {
							return el[i];
						}
					}
				} else {
					for (i = x - 1; i >= 0; i--) {
						if (canSelect(el[i])) {
							return el[i];
						}
					}
				}
	
				return null;
			}
	
			v = explode(editor.getParam('tab_focus', editor.getParam('tabfocus_elements', ':prev,:next')));
	
			if (v.length == 1) {
				v[1] = v[0];
				v[0] = ':prev';
			}
	
			// Find element to focus
			if (e.shiftKey) {
				if (v[0] == ':prev') {
					el = find(-1);
				} else {
					el = DOM.get(v[0]);
				}
			} else {
				if (v[1] == ':next') {
					el = find(1);
				} else {
					el = DOM.get(v[1]);
				}
			}
	
			if (el) {
				var focusEditor = tinymce.get(el.id || el.name);
	
				if (el.id && focusEditor) {
					focusEditor.focus();
				} else {
					tinymce.util.Delay.setTimeout(function() {
						if (!tinymce.Env.webkit) {
							window.focus();
						}
	
						el.focus();
					}, 10);
				}
	
				e.preventDefault();
			}
		}
	
		editor.on('init', function() {
			if (editor.inline) {
				// Remove default tabIndex in inline mode
				tinymce.DOM.setAttrib(editor.getBody(), 'tabIndex', null);
			}
	
			editor.on('keyup', tabCancel);
	
			if (tinymce.Env.gecko) {
				editor.on('keypress keydown', tabHandler);
			} else {
				editor.on('keydown', tabHandler);
			}
		});
	});
	
	}.call(window));

/***/ },
/* 230 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	/*eslint consistent-this:0 */
	
	tinymce.PluginManager.add('textcolor', function(editor) {
		var cols, rows;
	
		rows = {
			forecolor: editor.settings.forecolor_rows || editor.settings.textcolor_rows || 5,
			backcolor: editor.settings.backcolor_rows || editor.settings.textcolor_rows || 5
		};
		cols = {
			forecolor: editor.settings.forecolor_cols || editor.settings.textcolor_cols || 8,
			backcolor: editor.settings.backcolor_cols || editor.settings.textcolor_cols || 8
		};
	
		function getCurrentColor(format) {
			var color;
	
			editor.dom.getParents(editor.selection.getStart(), function(elm) {
				var value;
	
				if ((value = elm.style[format == 'forecolor' ? 'color' : 'background-color'])) {
					color = value;
				}
			});
	
			return color;
		}
	
		function mapColors(type) {
			var i, colors = [], colorMap;
	
			colorMap = [
				"000000", "Black",
				"993300", "Burnt orange",
				"333300", "Dark olive",
				"003300", "Dark green",
				"003366", "Dark azure",
				"000080", "Navy Blue",
				"333399", "Indigo",
				"333333", "Very dark gray",
				"800000", "Maroon",
				"FF6600", "Orange",
				"808000", "Olive",
				"008000", "Green",
				"008080", "Teal",
				"0000FF", "Blue",
				"666699", "Grayish blue",
				"808080", "Gray",
				"FF0000", "Red",
				"FF9900", "Amber",
				"99CC00", "Yellow green",
				"339966", "Sea green",
				"33CCCC", "Turquoise",
				"3366FF", "Royal blue",
				"800080", "Purple",
				"999999", "Medium gray",
				"FF00FF", "Magenta",
				"FFCC00", "Gold",
				"FFFF00", "Yellow",
				"00FF00", "Lime",
				"00FFFF", "Aqua",
				"00CCFF", "Sky blue",
				"993366", "Red violet",
				"FFFFFF", "White",
				"FF99CC", "Pink",
				"FFCC99", "Peach",
				"FFFF99", "Light yellow",
				"CCFFCC", "Pale green",
				"CCFFFF", "Pale cyan",
				"99CCFF", "Light sky blue",
				"CC99FF", "Plum"
			];
	
			colorMap = editor.settings.textcolor_map || colorMap;
			colorMap = editor.settings[type + '_map'] || colorMap;
	
			for (i = 0; i < colorMap.length; i += 2) {
				colors.push({
					text: colorMap[i + 1],
					color: '#' + colorMap[i]
				});
			}
	
			return colors;
		}
	
		function renderColorPicker() {
			var ctrl = this, colors, color, html, last, x, y, i, id = ctrl._id, count = 0, type;
	
			type = ctrl.settings.origin;
	
			function getColorCellHtml(color, title) {
				var isNoColor = color == 'transparent';
	
				return (
					'<td class="mce-grid-cell' + (isNoColor ? ' mce-colorbtn-trans' : '') + '">' +
						'<div id="' + id + '-' + (count++) + '"' +
							' data-mce-color="' + (color ? color : '') + '"' +
							' role="option"' +
							' tabIndex="-1"' +
							' style="' + (color ? 'background-color: ' + color : '') + '"' +
							' title="' + tinymce.translate(title) + '">' +
							(isNoColor ? '&#215;' : '') +
						'</div>' +
					'</td>'
				);
			}
	
			colors = mapColors(type);
			colors.push({
				text: tinymce.translate("No color"),
				color: "transparent"
			});
	
			html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
			last = colors.length - 1;
	
			for (y = 0; y < rows[type]; y++) {
				html += '<tr>';
	
				for (x = 0; x < cols[type]; x++) {
					i = y * cols[type] + x;
	
					if (i > last) {
						html += '<td></td>';
					} else {
						color = colors[i];
						html += getColorCellHtml(color.color, color.text);
					}
				}
	
				html += '</tr>';
			}
	
			if (editor.settings.color_picker_callback) {
				html += (
					'<tr>' +
						'<td colspan="' + cols[type] + '" class="mce-custom-color-btn">' +
							'<div id="' + id + '-c" class="mce-widget mce-btn mce-btn-small mce-btn-flat" ' +
								'role="button" tabindex="-1" aria-labelledby="' + id + '-c" style="width: 100%">' +
								'<button type="button" role="presentation" tabindex="-1">' + tinymce.translate('Custom...') + '</button>' +
							'</div>' +
						'</td>' +
					'</tr>'
				);
	
				html += '<tr>';
	
				for (x = 0; x < cols[type]; x++) {
					html += getColorCellHtml('', 'Custom color');
				}
	
				html += '</tr>';
			}
	
			html += '</tbody></table>';
	
			return html;
		}
	
		function applyFormat(format, value) {
			editor.undoManager.transact(function() {
				editor.focus();
				editor.formatter.apply(format, {value: value});
				editor.nodeChanged();
			});
		}
	
		function removeFormat(format) {
			editor.undoManager.transact(function() {
				editor.focus();
				editor.formatter.remove(format, {value: null}, null, true);
				editor.nodeChanged();
			});
		}
	
		function onPanelClick(e) {
			var buttonCtrl = this.parent(), value, type;
	
			type = buttonCtrl.settings.origin;
	
			function selectColor(value) {
				buttonCtrl.hidePanel();
				buttonCtrl.color(value);
				applyFormat(buttonCtrl.settings.format, value);
			}
	
			function resetColor() {
				buttonCtrl.hidePanel();
				buttonCtrl.resetColor();
				removeFormat(buttonCtrl.settings.format);
			}
	
			function setDivColor(div, value) {
				div.style.background = value;
				div.setAttribute('data-mce-color', value);
			}
	
			if (tinymce.DOM.getParent(e.target, '.mce-custom-color-btn')) {
				buttonCtrl.hidePanel();
	
				editor.settings.color_picker_callback.call(editor, function(value) {
					var tableElm = buttonCtrl.panel.getEl().getElementsByTagName('table')[0];
					var customColorCells, div, i;
	
					customColorCells = tinymce.map(tableElm.rows[tableElm.rows.length - 1].childNodes, function(elm) {
						return elm.firstChild;
					});
	
					for (i = 0; i < customColorCells.length; i++) {
						div = customColorCells[i];
						if (!div.getAttribute('data-mce-color')) {
							break;
						}
					}
	
					// Shift colors to the right
					// TODO: Might need to be the left on RTL
					if (i == cols[type]) {
						for (i = 0; i < cols[type] - 1; i++) {
							setDivColor(customColorCells[i], customColorCells[i + 1].getAttribute('data-mce-color'));
						}
					}
	
					setDivColor(div, value);
					selectColor(value);
				}, getCurrentColor(buttonCtrl.settings.format));
			}
	
			value = e.target.getAttribute('data-mce-color');
			if (value) {
				if (this.lastId) {
					document.getElementById(this.lastId).setAttribute('aria-selected', false);
				}
	
				e.target.setAttribute('aria-selected', true);
				this.lastId = e.target.id;
	
				if (value == 'transparent') {
					resetColor();
				} else {
					selectColor(value);
				}
			} else if (value !== null) {
				buttonCtrl.hidePanel();
			}
		}
	
		function onButtonClick() {
			var self = this;
	
			if (self._color) {
				applyFormat(self.settings.format, self._color);
			} else {
				removeFormat(self.settings.format);
			}
		}
	
		editor.addButton('forecolor', {
			type: 'colorbutton',
			tooltip: 'Text color',
			format: 'forecolor',
			panel: {
				origin: 'forecolor',
				role: 'application',
				ariaRemember: true,
				html: renderColorPicker,
				onclick: onPanelClick
			},
			onclick: onButtonClick
		});
	
		editor.addButton('backcolor', {
			type: 'colorbutton',
			tooltip: 'Background color',
			format: 'hilitecolor',
			panel: {
				origin: 'backcolor',
				role: 'application',
				ariaRemember: true,
				html: renderColorPicker,
				onclick: onPanelClick
			},
			onclick: onButtonClick
		});
	});
	
	}.call(window));

/***/ },
/* 231 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.PluginManager.add('wordcount', function(editor) {
		var self = this, countre, cleanre;
	
		// Included most unicode blocks see: http://en.wikipedia.org/wiki/Unicode_block
		// Latin-1_Supplement letters, a-z, u2019 == &rsquo;
		countre = editor.getParam('wordcount_countregex', /[\w\u2019\x27\-\u00C0-\u1FFF]+/g);
		cleanre = editor.getParam('wordcount_cleanregex', /[0-9.(),;:!?%#$?\x27\x22_+=\\\/\-]*/g);
	
		function update() {
			editor.theme.panel.find('#wordcount').text(['Words: {0}', self.getCount()]);
		}
	
		editor.on('init', function() {
			var statusbar = editor.theme.panel && editor.theme.panel.find('#statusbar')[0];
	
			if (statusbar) {
				tinymce.util.Delay.setEditorTimeout(editor, function() {
					statusbar.insert({
						type: 'label',
						name: 'wordcount',
						text: ['Words: {0}', self.getCount()],
						classes: 'wordcount',
						disabled: editor.settings.readonly
					}, 0);
	
					editor.on('setcontent beforeaddundo', update);
	
					editor.on('keyup', function(e) {
						if (e.keyCode == 32) {
							update();
						}
					});
				}, 0);
			}
		});
	
		self.getCount = function() {
			var tx = editor.getContent({format: 'raw'});
			var tc = 0;
	
			if (tx) {
				tx = tx.replace(/\.\.\./g, ' '); // convert ellipses to spaces
				tx = tx.replace(/<.[^<>]*?>/g, ' ').replace(/&nbsp;|&#160;/gi, ' '); // remove html tags and space chars
	
				// deal with html entities
				tx = tx.replace(/(\w+)(&#?[a-z0-9]+;)+(\w+)/i, "$1$3").replace(/&.+?;/g, ' ');
				tx = tx.replace(cleanre, ''); // remove numbers and punctuation
	
				var wordArray = tx.match(countre);
				if (wordArray) {
					tc = wordArray.length;
				}
			}
	
			return tc;
		};
	});
	}.call(window));

/***/ },
/* 232 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/**
	 * theme.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	tinymce.ThemeManager.add('modern', function(editor) {
		var self = this, settings = editor.settings, Factory = tinymce.ui.Factory,
			each = tinymce.each, DOM = tinymce.DOM, Rect = tinymce.geom.Rect, FloatPanel = tinymce.ui.FloatPanel;
	
		// Default menus
		var defaultMenus = {
			file: {title: 'File', items: 'newdocument'},
			edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
			insert: {title: 'Insert', items: '|'},
			view: {title: 'View', items: 'visualaid |'},
			format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
			table: {title: 'Table'},
			tools: {title: 'Tools'}
		};
	
		var defaultToolbar = "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | " +
			"bullist numlist outdent indent | link image";
	
		function createToolbar(items, size) {
			var toolbarItems = [], buttonGroup;
	
			if (!items) {
				return;
			}
	
			each(items.split(/[ ,]/), function(item) {
				var itemName;
	
				function bindSelectorChanged() {
					var selection = editor.selection;
	
					function setActiveItem(name) {
						return function(state, args) {
							var nodeName, i = args.parents.length;
	
							while (i--) {
								nodeName = args.parents[i].nodeName;
								if (nodeName == "OL" || nodeName == "UL") {
									break;
								}
							}
	
							item.active(state && nodeName == name);
						};
					}
	
					if (itemName == "bullist") {
						selection.selectorChanged('ul > li', setActiveItem("UL"));
					}
	
					if (itemName == "numlist") {
						selection.selectorChanged('ol > li', setActiveItem("OL"));
					}
	
					if (item.settings.stateSelector) {
						selection.selectorChanged(item.settings.stateSelector, function(state) {
							item.active(state);
						}, true);
					}
	
					if (item.settings.disabledStateSelector) {
						selection.selectorChanged(item.settings.disabledStateSelector, function(state) {
							item.disabled(state);
						});
					}
				}
	
				if (item == "|") {
					buttonGroup = null;
				} else {
					if (Factory.has(item)) {
						item = {type: item, size: size};
						toolbarItems.push(item);
						buttonGroup = null;
					} else {
						if (!buttonGroup) {
							buttonGroup = {type: 'buttongroup', items: []};
							toolbarItems.push(buttonGroup);
						}
	
						if (editor.buttons[item]) {
							// TODO: Move control creation to some UI class
							itemName = item;
							item = editor.buttons[itemName];
	
							if (typeof item == "function") {
								item = item();
							}
	
							item.type = item.type || 'button';
							item.size = size;
	
							item = Factory.create(item);
							buttonGroup.items.push(item);
	
							if (editor.initialized) {
								bindSelectorChanged();
							} else {
								editor.on('init', bindSelectorChanged);
							}
						}
					}
				}
			});
	
			return {
				type: 'toolbar',
				layout: 'flow',
				items: toolbarItems
			};
		}
	
		/**
		 * Creates the toolbars from config and returns a toolbar array.
		 *
		 * @param {String} size Optional toolbar item size.
		 * @return {Array} Array with toolbars.
		 */
		function createToolbars(size) {
			var toolbars = [];
	
			function addToolbar(items) {
				if (items) {
					toolbars.push(createToolbar(items, size));
					return true;
				}
			}
	
			// Convert toolbar array to multiple options
			if (tinymce.isArray(settings.toolbar)) {
				// Empty toolbar array is the same as a disabled toolbar
				if (settings.toolbar.length === 0) {
					return;
				}
	
				tinymce.each(settings.toolbar, function(toolbar, i) {
					settings["toolbar" + (i + 1)] = toolbar;
				});
	
				delete settings.toolbar;
			}
	
			// Generate toolbar<n>
			for (var i = 1; i < 10; i++) {
				if (!addToolbar(settings["toolbar" + i])) {
					break;
				}
			}
	
			// Generate toolbar or default toolbar unless it's disabled
			if (!toolbars.length && settings.toolbar !== false) {
				addToolbar(settings.toolbar || defaultToolbar);
			}
	
			if (toolbars.length) {
				return {
					type: 'panel',
					layout: 'stack',
					classes: "toolbar-grp",
					ariaRoot: true,
					ariaRemember: true,
					items: toolbars
				};
			}
		}
	
		/**
		 * Creates the menu buttons based on config.
		 *
		 * @return {Array} Menu buttons array.
		 */
		function createMenuButtons() {
			var name, menuButtons = [];
	
			function createMenuItem(name) {
				var menuItem;
	
				if (name == '|') {
					return {text: '|'};
				}
	
				menuItem = editor.menuItems[name];
	
				return menuItem;
			}
	
			function createMenu(context) {
				var menuButton, menu, menuItems, isUserDefined, removedMenuItems;
	
				removedMenuItems = tinymce.makeMap((settings.removed_menuitems || '').split(/[ ,]/));
	
				// User defined menu
				if (settings.menu) {
					menu = settings.menu[context];
					isUserDefined = true;
				} else {
					menu = defaultMenus[context];
				}
	
				if (menu) {
					menuButton = {text: menu.title};
					menuItems = [];
	
					// Default/user defined items
					each((menu.items || '').split(/[ ,]/), function(item) {
						var menuItem = createMenuItem(item);
	
						if (menuItem && !removedMenuItems[item]) {
							menuItems.push(createMenuItem(item));
						}
					});
	
					// Added though context
					if (!isUserDefined) {
						each(editor.menuItems, function(menuItem) {
							if (menuItem.context == context) {
								if (menuItem.separator == 'before') {
									menuItems.push({text: '|'});
								}
	
								if (menuItem.prependToContext) {
									menuItems.unshift(menuItem);
								} else {
									menuItems.push(menuItem);
								}
	
								if (menuItem.separator == 'after') {
									menuItems.push({text: '|'});
								}
							}
						});
					}
	
					for (var i = 0; i < menuItems.length; i++) {
						if (menuItems[i].text == '|') {
							if (i === 0 || i == menuItems.length - 1) {
								menuItems.splice(i, 1);
							}
						}
					}
	
					menuButton.menu = menuItems;
	
					if (!menuButton.menu.length) {
						return null;
					}
				}
	
				return menuButton;
			}
	
			var defaultMenuBar = [];
			if (settings.menu) {
				for (name in settings.menu) {
					defaultMenuBar.push(name);
				}
			} else {
				for (name in defaultMenus) {
					defaultMenuBar.push(name);
				}
			}
	
			var enabledMenuNames = typeof settings.menubar == "string" ? settings.menubar.split(/[ ,]/) : defaultMenuBar;
			for (var i = 0; i < enabledMenuNames.length; i++) {
				var menu = enabledMenuNames[i];
				menu = createMenu(menu);
	
				if (menu) {
					menuButtons.push(menu);
				}
			}
	
			return menuButtons;
		}
	
		/**
		 * Adds accessibility shortcut keys to panel.
		 *
		 * @param {tinymce.ui.Panel} panel Panel to add focus to.
		 */
		function addAccessibilityKeys(panel) {
			function focus(type) {
				var item = panel.find(type)[0];
	
				if (item) {
					item.focus(true);
				}
			}
	
			editor.shortcuts.add('Alt+F9', '', function() {
				focus('menubar');
			});
	
			editor.shortcuts.add('Alt+F10', '', function() {
				focus('toolbar');
			});
	
			editor.shortcuts.add('Alt+F11', '', function() {
				focus('elementpath');
			});
	
			panel.on('cancel', function() {
				editor.focus();
			});
		}
	
		/**
		 * Resizes the editor to the specified width, height.
		 */
		function resizeTo(width, height) {
			var containerElm, iframeElm, containerSize, iframeSize;
	
			function getSize(elm) {
				return {
					width: elm.clientWidth,
					height: elm.clientHeight
				};
			}
	
			containerElm = editor.getContainer();
			iframeElm = editor.getContentAreaContainer().firstChild;
			containerSize = getSize(containerElm);
			iframeSize = getSize(iframeElm);
	
			if (width !== null) {
				width = Math.max(settings.min_width || 100, width);
				width = Math.min(settings.max_width || 0xFFFF, width);
	
				DOM.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
				DOM.setStyle(iframeElm, 'width', width);
			}
	
			height = Math.max(settings.min_height || 100, height);
			height = Math.min(settings.max_height || 0xFFFF, height);
			DOM.setStyle(iframeElm, 'height', height);
	
			editor.fire('ResizeEditor');
		}
	
		function resizeBy(dw, dh) {
			var elm = editor.getContentAreaContainer();
			self.resizeTo(elm.clientWidth + dw, elm.clientHeight + dh);
		}
	
		/**
		 * Handles contextual toolbars.
		 */
		function addContextualToolbars() {
			var scrollContainer;
	
			function getContextToolbars() {
				return editor.contextToolbars || [];
			}
	
			function getElementRect(elm) {
				var pos, targetRect, root;
	
				pos = tinymce.DOM.getPos(editor.getContentAreaContainer());
				targetRect = editor.dom.getRect(elm);
				root = editor.dom.getRoot();
	
				// Adjust targetPos for scrolling in the editor
				if (root.nodeName == 'BODY') {
					targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
					targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
				}
	
				targetRect.x += pos.x;
				targetRect.y += pos.y;
	
				return targetRect;
			}
	
			function hideAllFloatingPanels() {
				each(editor.contextToolbars, function(toolbar) {
					if (toolbar.panel) {
						toolbar.panel.hide();
					}
				});
			}
	
			function togglePositionClass(panel, relPos, predicate) {
				relPos = relPos ? relPos.substr(0, 2) : '';
	
				each({
					t: 'down',
					b: 'up'
				}, function(cls, pos) {
					panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
				});
	
				each({
					l: 'left',
					r: 'right'
				}, function(cls, pos) {
					panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
				});
			}
	
			function toClientRect(geomRect) {
				return {
					left: geomRect.x,
					top: geomRect.y,
					width: geomRect.w,
					height: geomRect.h,
					right: geomRect.x + geomRect.w,
					bottom: geomRect.y + geomRect.h
				};
			}
	
			function userConstrain(x, y, elementRect, contentAreaRect, panelRect) {
					panelRect = toClientRect({x: x, y: y, w: panelRect.w, h: panelRect.h});
	
					if (settings.inline_toolbar_position_handler) {
						panelRect = settings.inline_toolbar_position_handler({
							elementRect: toClientRect(elementRect),
							contentAreaRect: toClientRect(contentAreaRect),
							panelRect: panelRect
						});
					}
	
					return panelRect;
			}
	
			function movePanelTo(panel, pos) {
				panel.moveTo(pos.left, pos.top);
			}
	
			function reposition(match) {
				var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
	
				if (editor.removed) {
					return;
				}
	
				if (!match || !match.toolbar.panel) {
					hideAllFloatingPanels();
					return;
				}
	
				testPositions = [
					'bc-tc', 'tc-bc',
					'tl-bl', 'bl-tl',
					'tr-br', 'br-tr'
				];
	
				panel = match.toolbar.panel;
				panel.show();
	
				elementRect = getElementRect(match.element);
				panelRect = tinymce.DOM.getRect(panel.getEl());
				contentAreaRect = tinymce.DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
				smallElementWidthThreshold = 25;
	
				// We need to use these instead of the rect values since the style
				// size properites might not be the same as the real size for a table
				elementRect.w = match.element.clientWidth;
				elementRect.h = match.element.clientHeight;
	
				if (!editor.inline) {
					contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
				}
	
				// Inflate the elementRect so it doesn't get placed above resize handles
				if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
					elementRect = Rect.inflate(elementRect, 0, 8);
				}
	
				relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
				elementRect = Rect.clamp(elementRect, contentAreaRect);
	
				if (relPos) {
					relRect = Rect.relativePosition(panelRect, elementRect, relPos);
					movePanelTo(panel, userConstrain(relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
				} else {
					// Allow overflow below the editor to avoid placing toolbars ontop of tables
					contentAreaRect.h += panelRect.h;
	
					elementRect = Rect.intersect(contentAreaRect, elementRect);
					if (elementRect) {
						relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, [
							'bc-tc', 'bl-tl', 'br-tr'
						]);
	
						if (relPos) {
							relRect = Rect.relativePosition(panelRect, elementRect, relPos);
							movePanelTo(panel, userConstrain(relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
						} else {
							movePanelTo(panel, userConstrain(elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
						}
					} else {
						panel.hide();
					}
				}
	
				togglePositionClass(panel, relPos, function(pos1, pos2) {
					return pos1 === pos2;
				});
	
				//drawRect(contentAreaRect, 'blue');
				//drawRect(elementRect, 'red');
				//drawRect(panelRect, 'green');
			}
	
			function repositionHandler() {
				function execute() {
					if (editor.selection) {
						reposition(findFrontMostMatch(editor.selection.getNode()));
					}
				}
	
				tinymce.util.Delay.requestAnimationFrame(execute);
			}
	
			function bindScrollEvent() {
				if (!scrollContainer) {
					scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
					tinymce.$(scrollContainer).on('scroll', repositionHandler);
	
					editor.on('remove', function() {
						tinymce.$(scrollContainer).off('scroll');
					});
				}
			}
	
			function showContextToolbar(match) {
				var panel;
	
				if (match.toolbar.panel) {
					match.toolbar.panel.show();
					reposition(match);
					return;
				}
	
				bindScrollEvent();
	
				panel = Factory.create({
					type: 'floatpanel',
					role: 'dialog',
					classes: 'tinymce tinymce-inline arrow',
					ariaLabel: 'Inline toolbar',
					layout: 'flex',
					direction: 'column',
					align: 'stretch',
					autohide: false,
					autofix: true,
					fixed: true,
					border: 1,
					items: createToolbar(match.toolbar.items),
					oncancel: function() {
						editor.focus();
					}
				});
	
				match.toolbar.panel = panel;
				panel.renderTo(document.body).reflow();
				reposition(match);
			}
	
			function hideAllContextToolbars() {
				tinymce.each(getContextToolbars(), function(toolbar) {
					if (toolbar.panel) {
						toolbar.panel.hide();
					}
				});
			}
	
			function findFrontMostMatch(targetElm) {
				var i, y, parentsAndSelf, toolbars = getContextToolbars();
	
				parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
				for (i = parentsAndSelf.length - 1; i >= 0; i--) {
					for (y = toolbars.length - 1; y >= 0; y--) {
						if (toolbars[y].predicate(parentsAndSelf[i])) {
							return {
								toolbar: toolbars[y],
								element: parentsAndSelf[i]
							};
						}
					}
				}
	
				return null;
			}
	
			editor.on('click keyup setContent', function(e) {
				// Only act on partial inserts
				if (e.type == 'setcontent' && !e.selection) {
					return;
				}
	
				// Needs to be delayed to avoid Chrome img focus out bug
				tinymce.util.Delay.setEditorTimeout(editor, function() {
					var match;
	
					match = findFrontMostMatch(editor.selection.getNode());
					if (match) {
						hideAllContextToolbars();
						showContextToolbar(match);
					} else {
						hideAllContextToolbars();
					}
				});
			});
	
			editor.on('blur hide', hideAllContextToolbars);
	
			editor.on('ObjectResizeStart', function() {
				var match = findFrontMostMatch(editor.selection.getNode());
	
				if (match && match.toolbar.panel) {
					match.toolbar.panel.hide();
				}
			});
	
			editor.on('nodeChange ResizeEditor ResizeWindow', repositionHandler);
	
			editor.on('remove', function() {
				tinymce.each(getContextToolbars(), function(toolbar) {
					if (toolbar.panel) {
						toolbar.panel.remove();
					}
				});
	
				editor.contextToolbars = {};
			});
	
			editor.shortcuts.add('ctrl+shift+e > ctrl+shift+p', '', function() {
				var match = findFrontMostMatch(editor.selection.getNode());
				if (match && match.toolbar.panel) {
					match.toolbar.panel.items()[0].focus();
				}
			});
		}
	
		function fireSkinLoaded(editor) {
			return function() {
				if (editor.initialized) {
					editor.fire('SkinLoaded');
				} else {
					editor.on('init', function() {
						editor.fire('SkinLoaded');
					});
				}
			};
		}
	
		/**
		 * Renders the inline editor UI.
		 *
		 * @return {Object} Name/value object with theme data.
		 */
		function renderInlineUI(args) {
			var panel, inlineToolbarContainer;
	
			if (settings.fixed_toolbar_container) {
				inlineToolbarContainer = DOM.select(settings.fixed_toolbar_container)[0];
			}
	
			function reposition() {
				if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
					// TODO: This is kind of ugly and doesn't handle multiple scrollable elements
					var scrollContainer = editor.selection.getScrollContainer(), body = editor.getBody();
					var deltaX = 0, deltaY = 0;
	
					if (scrollContainer) {
						var bodyPos = DOM.getPos(body), scrollContainerPos = DOM.getPos(scrollContainer);
	
						deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
						deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
					}
	
					panel.fixed(false).moveRel(body, editor.rtl ? ['tr-br', 'br-tr'] : ['tl-bl', 'bl-tl', 'tr-br']).moveBy(deltaX, deltaY);
				}
			}
	
			function show() {
				if (panel) {
					panel.show();
					reposition();
					DOM.addClass(editor.getBody(), 'mce-edit-focus');
				}
			}
	
			function hide() {
				if (panel) {
					// We require two events as the inline float panel based toolbar does not have autohide=true
					panel.hide();
	
					// All other autohidden float panels will be closed below.
					FloatPanel.hideAll();
	
					DOM.removeClass(editor.getBody(), 'mce-edit-focus');
				}
			}
	
			function render() {
				if (panel) {
					if (!panel.visible()) {
						show();
					}
	
					return;
				}
	
				// Render a plain panel inside the inlineToolbarContainer if it's defined
				panel = self.panel = Factory.create({
					type: inlineToolbarContainer ? 'panel' : 'floatpanel',
					role: 'application',
					classes: 'tinymce tinymce-inline',
					layout: 'flex',
					direction: 'column',
					align: 'stretch',
					autohide: false,
					autofix: true,
					fixed: !!inlineToolbarContainer,
					border: 1,
					items: [
						settings.menubar === false ? null : {type: 'menubar', border: '0 0 1 0', items: createMenuButtons()},
						createToolbars(settings.toolbar_items_size)
					]
				});
	
				// Add statusbar
				/*if (settings.statusbar !== false) {
					panel.add({type: 'panel', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', items: [
						{type: 'elementpath'}
					]});
				}*/
	
				editor.fire('BeforeRenderUI');
				panel.renderTo(inlineToolbarContainer || document.body).reflow();
	
				addAccessibilityKeys(panel);
				show();
				addContextualToolbars();
	
				editor.on('nodeChange', reposition);
				editor.on('activate', show);
				editor.on('deactivate', hide);
	
				editor.nodeChanged();
			}
	
			settings.content_editable = true;
	
			editor.on('focus', function() {
				// Render only when the CSS file has been loaded
				if (args.skinUiCss) {
					tinymce.DOM.styleSheetLoader.load(args.skinUiCss, render, render);
				} else {
					render();
				}
			});
	
			editor.on('blur hide', hide);
	
			// Remove the panel when the editor is removed
			editor.on('remove', function() {
				if (panel) {
					panel.remove();
					panel = null;
				}
			});
	
			// Preload skin css
			if (args.skinUiCss) {
				tinymce.DOM.styleSheetLoader.load(args.skinUiCss, fireSkinLoaded(editor));
			}
	
			return {};
		}
	
		/**
		 * Renders the iframe editor UI.
		 *
		 * @param {Object} args Details about target element etc.
		 * @return {Object} Name/value object with theme data.
		 */
		function renderIframeUI(args) {
			var panel, resizeHandleCtrl, startSize;
	
			function switchMode() {
				return function(e) {
					if (e.mode == 'readonly') {
						panel.find('*').disabled(true);
					} else {
						panel.find('*').disabled(false);
					}
				};
			}
	
			if (args.skinUiCss) {
				tinymce.DOM.styleSheetLoader.load(args.skinUiCss, fireSkinLoaded(editor));
			}
	
			// Basic UI layout
			panel = self.panel = Factory.create({
				type: 'panel',
				role: 'application',
				classes: 'tinymce',
				style: 'visibility: hidden',
				layout: 'stack',
				border: 1,
				items: [
					settings.menubar === false ? null : {type: 'menubar', border: '0 0 1 0', items: createMenuButtons()},
					createToolbars(settings.toolbar_items_size),
					{type: 'panel', name: 'iframe', layout: 'stack', classes: 'edit-area', html: '', border: '1 0 0 0'}
				]
			});
	
			if (settings.resize !== false) {
				resizeHandleCtrl = {
					type: 'resizehandle',
					direction: settings.resize,
	
					onResizeStart: function() {
						var elm = editor.getContentAreaContainer().firstChild;
	
						startSize = {
							width: elm.clientWidth,
							height: elm.clientHeight
						};
					},
	
					onResize: function(e) {
						if (settings.resize == 'both') {
							resizeTo(startSize.width + e.deltaX, startSize.height + e.deltaY);
						} else {
							resizeTo(null, startSize.height + e.deltaY);
						}
					}
				};
			}
	
			// Add statusbar if needed
			if (settings.statusbar !== false) {
				panel.add({type: 'panel', name: 'statusbar', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', ariaRoot: true, items: [
					{type: 'elementpath', editor: editor},
					resizeHandleCtrl
				]});
			}
	
			editor.fire('BeforeRenderUI');
			editor.on('SwitchMode', switchMode());
			panel.renderBefore(args.targetNode).reflow();
	
			if (settings.readonly) {
				editor.setMode('readonly');
			}
	
			if (settings.width) {
				tinymce.DOM.setStyle(panel.getEl(), 'width', settings.width);
			}
	
			// Remove the panel when the editor is removed
			editor.on('remove', function() {
				panel.remove();
				panel = null;
			});
	
			// Add accesibility shortcuts
			addAccessibilityKeys(panel);
			addContextualToolbars();
	
			return {
				iframeContainer: panel.find('#iframe')[0].getEl(),
				editorContainer: panel.getEl()
			};
		}
	
		/**
		 * Renders the UI for the theme. This gets called by the editor.
		 *
		 * @param {Object} args Details about target element etc.
		 * @return {Object} Theme UI data items.
		 */
		self.renderUI = function(args) {
			var skin = settings.skin !== false ? settings.skin || 'lightgray' : false;
	
			if (skin) {
				var skinUrl = settings.skin_url;
	
				if (skinUrl) {
					skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
				} else {
					skinUrl = tinymce.baseURL + '/skins/' + skin;
				}
	
				// Load special skin for IE7
				// TODO: Remove this when we drop IE7 support
				if (tinymce.Env.documentMode <= 7) {
					args.skinUiCss = skinUrl + '/skin.ie7.min.css';
				} else {
					args.skinUiCss = skinUrl + '/skin.min.css';
				}
	
				// Load content.min.css or content.inline.min.css
				editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
			}
	
			// Handle editor setProgressState change
			editor.on('ProgressState', function(e) {
				self.throbber = self.throbber || new tinymce.ui.Throbber(self.panel.getEl('body'));
	
				if (e.state) {
					self.throbber.show(e.time);
				} else {
					self.throbber.hide();
				}
			});
	
			if (settings.inline) {
				return renderInlineUI(args);
			}
	
			return renderIframeUI(args);
		};
	
		self.resizeTo = resizeTo;
		self.resizeBy = resizeBy;
	});
	
	}.call(window));

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  'plugins': ['autolink', 'autoresize', 'fullscreen',
	  // 'image',
	  // 'link',
	  // 'media',
	  'paste', 'preview', 'tabfocus', 'textcolor', 'wordcount',
	  // custom plugins
	  'image', 'link', 'media', 'embed'],
	
	  'toolbar': ['bold, italic, underline', 'link', 'bullist, numlist, blockquote', 'alignleft, aligncenter, alignright, alignjustify', 'indent, outdent', 'formatselect, fontselect, fontsizeselect forecolor', 'cut, copy, paste, undo, redo, removeformat', 'image media embed', 'preview fullscreen'].join(' | '),
	
	  'style': {
	    'formats': [{
	      'title': 'Image Left',
	      'selector': 'img',
	      'styles': {
	        'float': 'left',
	        'margin': '0 10px 0 10px'
	      }
	    }, {
	      'title': 'Image Right',
	      'selector': 'img',
	      'styles': {
	        'float': 'right',
	        'margin': '0 10px 0 10px'
	      }
	    }]
	  }
	
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactMdl = __webpack_require__(47);
	
	var cardStyles = {
	  'float': 'left',
	  'width': 256,
	  'height': 256,
	  'backgroundColor': '#f4f4f4',
	  'cursor': 'pointer'
	};
	
	var actionStyles = {
	  'height': 52,
	  'padding': 16
	};
	
	var captionStyles = {
	  'color': '#a4a4a4',
	  'fontSize': 14,
	  'fontWeight': '500'
	};
	
	var iconStyles = {
	  'position': 'absolute',
	  'margin': 100,
	  'fontSize': 60
	};
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'CustomImageDialog',
	
	  getInitialState: function getInitialState() {
	    var data = this.props.data;
	
	    return {
	      'showUrl': !!data.src
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var data = nextProps.data;
	
	    if (this.props.show) return;
	
	    this.setState({
	      'showUrl': !!data.src
	    });
	  },
	
	  onUploadImage: function onUploadImage() {
	    var file = this.refs.file;
	
	    _reactDom2['default'].findDOMNode(file.inputRef).click();
	  },
	
	  onAddImage: function onAddImage() {
	    var _this = this;
	
	    this.setState({
	      'showUrl': true
	    }, function () {
	      var src = _this.refs.src;
	
	      _reactDom2['default'].findDOMNode(src.inputRef).focus();
	    });
	  },
	
	  onSubmit: function onSubmit() {
	    this.setState({
	      'showUrl': false
	    }, this.props.onSubmit);
	  },
	
	  onCancel: function onCancel() {
	    this.setState({
	      'showUrl': false
	    }, this.props.onCancel);
	  },
	
	  render: function render() {
	    var onUploadImage = this.onUploadImage;
	    var onAddImage = this.onAddImage;
	    var showUrl = this.state.showUrl;
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = this.onSubmit;
	    var onCancel = this.onCancel;
	
	    return _react2['default'].createElement(
	      _reactMdl.Dialog,
	      { open: show, style: { 'width': 600 } },
	      _react2['default'].createElement(
	        _reactMdl.DialogTitle,
	        null,
	        'Insert/Edit image'
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogContent,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Card,
	          { shadow: 0, style: cardStyles, onClick: onUploadImage },
	          _react2['default'].createElement(_reactMdl.CardTitle, { expand: true }),
	          _react2['default'].createElement(_reactMdl.Icon, { name: 'photo', style: iconStyles }),
	          _react2['default'].createElement(
	            _reactMdl.CardActions,
	            { style: actionStyles },
	            _react2['default'].createElement(
	              'span',
	              { style: captionStyles },
	              'Upload an image'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Card,
	          { shadow: 0, style: cardStyles, onClick: onAddImage },
	          _react2['default'].createElement(_reactMdl.CardTitle, { expand: true }),
	          _react2['default'].createElement(_reactMdl.Icon, { name: 'language', style: iconStyles }),
	          _react2['default'].createElement(
	            _reactMdl.CardActions,
	            { style: actionStyles },
	            _react2['default'].createElement(
	              'span',
	              { style: captionStyles },
	              'Add an image from the web'
	            )
	          )
	        ),
	        _react2['default'].createElement(_reactMdl.Textfield, {
	          style: { 'display': 'none' },
	          ref: 'file',
	          label: '',
	          type: 'file',
	          onChange: function (e) {
	            return onChange('file', e.target.value);
	          }
	        }),
	        _react2['default'].createElement(_reactMdl.Textfield, {
	          style: { 'visibility': showUrl ? '' : 'hidden', 'width': '100%' },
	          ref: 'src',
	          label: 'Paste a URL:',
	          value: data.src,
	          onChange: function (e) {
	            return onChange('src', e.target.value);
	          }
	        })
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogActions,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onSubmit },
	          'Ok'
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onCancel },
	          'Cancel'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(310);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'CustomLinkDialog',
	
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = _props.onSubmit;
	    var onCancel = _props.onCancel;
	
	    return _react2['default'].createElement(
	      _reactBootstrap.Modal,
	      { show: show },
	      _react2['default'].createElement(
	        _reactBootstrap.Modal.Header,
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.Modal.Title,
	          null,
	          'Insert/Edit Link (Custom Dialog)'
	        )
	      ),
	      _react2['default'].createElement(
	        _reactBootstrap.Modal.Body,
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2['default'].createElement(_reactBootstrap.FormControl, {
	            type: 'text',
	            placeholder: 'Text to display:',
	            value: data.text,
	            onChange: function (e) {
	              return onChange('text', e.target.value);
	            }
	          }),
	          _react2['default'].createElement(_reactBootstrap.FormControl, {
	            type: 'text',
	            placeholder: 'Link to:',
	            value: data.href,
	            onChange: function (e) {
	              return onChange('href', e.target.value);
	            }
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        _reactBootstrap.Modal.Footer,
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'default', onClick: onCancel },
	          'Close'
	        ),
	        _react2['default'].createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: onSubmit },
	          'Save changes'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMdl = __webpack_require__(47);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'EmbedDialog',
	
	  getInitialState: function getInitialState() {
	    return {
	      'activeTab': 0
	    };
	  },
	
	  setActiveTab: function setActiveTab(activeTab) {
	    var _this = this;
	
	    this.setState({
	      activeTab: activeTab
	    }, function () {
	      var _refs = _this.refs;
	      var source = _refs.source;
	      var embed = _refs.embed;
	
	      switch (activeTab) {
	        case 1:
	          embed.inputRef.focus();
	          break;
	        case 0:
	        default:
	          source.inputRef.focus();
	      }
	    });
	  },
	
	  render: function render() {
	    var activeTab = this.state.activeTab;
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = _props.onSubmit;
	    var onCancel = _props.onCancel;
	    var setActiveTab = this.setActiveTab;
	
	    return _react2['default'].createElement(
	      _reactMdl.Dialog,
	      { open: show, style: { 'width': 400 } },
	      _react2['default'].createElement(
	        _reactMdl.DialogTitle,
	        null,
	        'Insert/Edit Embeddable content'
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogContent,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.MDLComponent,
	          null,
	          _react2['default'].createElement(
	            _reactMdl.Tabs,
	            { activeTab: activeTab, onChange: setActiveTab },
	            _react2['default'].createElement(
	              _reactMdl.Tab,
	              null,
	              'Source'
	            ),
	            _react2['default'].createElement(
	              _reactMdl.Tab,
	              null,
	              'Embed code'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'content' },
	            _react2['default'].createElement(
	              'div',
	              { style: { 'display': activeTab === 0 ? '' : 'none' } },
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                ref: 'source',
	                label: 'Source:',
	                value: data.source,
	                onChange: function (e) {
	                  return onChange('source', e.target.value);
	                }
	              }),
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                pattern: '-?[0-9]*(\\.[0-9]+)?',
	                error: 'Please insert a number',
	                label: 'Width',
	                style: { 'width': '200px' },
	                value: data.width,
	                onChange: function (e) {
	                  return onChange('width', e.target.value);
	                }
	              }),
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                pattern: '-?[0-9]*(\\.[0-9]+)?',
	                error: 'Please insert a number',
	                label: 'Height',
	                style: { 'width': '200px' },
	                value: data.height,
	                onChange: function (e) {
	                  return onChange('height', e.target.value);
	                }
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: { 'display': activeTab === 1 ? '' : 'none' } },
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                ref: 'embed',
	                label: 'Embed code:',
	                value: data.embed,
	                onChange: function (e) {
	                  return onChange('embed', e.target.value);
	                },
	                rows: 5
	              })
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogActions,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onSubmit },
	          'Ok'
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onCancel },
	          'Cancel'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMdl = __webpack_require__(47);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'ImageDialog',
	
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = _props.onSubmit;
	    var onCancel = _props.onCancel;
	
	    return _react2['default'].createElement(
	      _reactMdl.Dialog,
	      { open: show },
	      _react2['default'].createElement(
	        _reactMdl.DialogTitle,
	        null,
	        'Insert/Edit image'
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogContent,
	        null,
	        _react2['default'].createElement(_reactMdl.Textfield, {
	          label: 'Paste a URL:',
	          value: data.src,
	          onChange: function (e) {
	            return onChange('src', e.target.value);
	          }
	        })
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogActions,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onSubmit },
	          'Ok'
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onCancel },
	          'Cancel'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];
	/*
	 Not supported yet
	 <Textfield
	   label=""
	   type="file"
	   onChange={(e) => onChange('file', e.target.value)}
	 />
	*/

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMdl = __webpack_require__(47);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'LinkDialog',
	
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = _props.onSubmit;
	    var onCancel = _props.onCancel;
	
	    return _react2['default'].createElement(
	      _reactMdl.Dialog,
	      { open: show },
	      _react2['default'].createElement(
	        _reactMdl.DialogTitle,
	        null,
	        'Insert/Edit Link'
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogContent,
	        null,
	        _react2['default'].createElement(_reactMdl.Textfield, {
	          label: 'Text to display:',
	          value: data.text,
	          onChange: function (e) {
	            return onChange('text', e.target.value);
	          }
	        }),
	        _react2['default'].createElement(_reactMdl.Textfield, {
	          label: 'Link to:',
	          value: data.href,
	          onChange: function (e) {
	            return onChange('href', e.target.value);
	          }
	        })
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogActions,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onSubmit },
	          'Ok'
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onCancel },
	          'Cancel'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMdl = __webpack_require__(47);
	
	exports['default'] = _react2['default'].createClass({
	  displayName: 'MediaDialog',
	
	  getInitialState: function getInitialState() {
	    return {
	      'activeTab': 0
	    };
	  },
	
	  setActiveTab: function setActiveTab(activeTab) {
	    var _this = this;
	
	    this.setState({
	      activeTab: activeTab
	    }, function () {
	      var _refs = _this.refs;
	      var source = _refs.source;
	      var embed = _refs.embed;
	
	      switch (activeTab) {
	        case 1:
	          embed.inputRef.focus();
	          break;
	        case 0:
	        default:
	          source.inputRef.focus();
	      }
	    });
	  },
	
	  render: function render() {
	    var activeTab = this.state.activeTab;
	    var _props = this.props;
	    var show = _props.show;
	    var data = _props.data;
	    var onChange = _props.onChange;
	    var onSubmit = _props.onSubmit;
	    var onCancel = _props.onCancel;
	    var setActiveTab = this.setActiveTab;
	
	    return _react2['default'].createElement(
	      _reactMdl.Dialog,
	      { open: show, style: { 'width': 400 } },
	      _react2['default'].createElement(
	        _reactMdl.DialogTitle,
	        null,
	        'Insert/Edit Video'
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogContent,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.MDLComponent,
	          null,
	          _react2['default'].createElement(
	            _reactMdl.Tabs,
	            { activeTab: activeTab, onChange: setActiveTab },
	            _react2['default'].createElement(
	              _reactMdl.Tab,
	              null,
	              'Source'
	            ),
	            _react2['default'].createElement(
	              _reactMdl.Tab,
	              null,
	              'Embed code'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'section',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'content' },
	            _react2['default'].createElement(
	              'div',
	              { style: { 'display': activeTab === 0 ? '' : 'none' } },
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                ref: 'source',
	                label: 'Source:',
	                value: data.source,
	                onChange: function (e) {
	                  return onChange('source', e.target.value);
	                }
	              }),
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                pattern: '-?[0-9]*(\\.[0-9]+)?',
	                error: 'Please insert a number',
	                label: 'Width',
	                style: { 'width': '200px' },
	                value: data.width,
	                onChange: function (e) {
	                  return onChange('width', e.target.value);
	                }
	              }),
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                pattern: '-?[0-9]*(\\.[0-9]+)?',
	                error: 'Please insert a number',
	                label: 'Height',
	                style: { 'width': '200px' },
	                value: data.height,
	                onChange: function (e) {
	                  return onChange('height', e.target.value);
	                }
	              })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: { 'display': activeTab === 1 ? '' : 'none' } },
	              _react2['default'].createElement(_reactMdl.Textfield, {
	                ref: 'embed',
	                label: 'Embed code:',
	                value: data.embed,
	                onChange: function (e) {
	                  return onChange('embed', e.target.value);
	                },
	                rows: 5
	              })
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        _reactMdl.DialogActions,
	        null,
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onSubmit },
	          'Ok'
	        ),
	        _react2['default'].createElement(
	          _reactMdl.Button,
	          { type: 'button', onClick: onCancel },
	          'Cancel'
	        )
	      )
	    );
	  }
	
	});
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/*
		PoC for React-TinyMCE integration inspired by
		https://github.com/Automattic/wp-calypso/
		https://github.com/instructure-react/react-tinymce
	*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tinymceTinymce = __webpack_require__(223);
	
	var _tinymceTinymce2 = _interopRequireDefault(_tinymceTinymce);
	
	__webpack_require__(232);
	
	__webpack_require__(248);
	
	__webpack_require__(245);
	
	// Plugins
	
	__webpack_require__(224);
	
	__webpack_require__(225);
	
	__webpack_require__(226);
	
	// import 'tinymce/plugins/image/plugin';
	// import 'tinymce/plugins/link/plugin';
	// import 'tinymce/plugins/media/plugin';
	
	__webpack_require__(227);
	
	__webpack_require__(228);
	
	__webpack_require__(229);
	
	__webpack_require__(230);
	
	__webpack_require__(231);
	
	// Customized plugins
	
	__webpack_require__(242);
	
	__webpack_require__(243);
	
	__webpack_require__(244);
	
	__webpack_require__(241);
	
	var _configConfig = __webpack_require__(233);
	
	var _configConfig2 = _interopRequireDefault(_configConfig);
	
	var _dialogsLinkDialog = __webpack_require__(238);
	
	var _dialogsLinkDialog2 = _interopRequireDefault(_dialogsLinkDialog);
	
	var _dialogsImageDialog = __webpack_require__(237);
	
	var _dialogsImageDialog2 = _interopRequireDefault(_dialogsImageDialog);
	
	var _dialogsMediaDialog = __webpack_require__(239);
	
	var _dialogsMediaDialog2 = _interopRequireDefault(_dialogsMediaDialog);
	
	var _dialogsEmbedDialog = __webpack_require__(236);
	
	var _dialogsEmbedDialog2 = _interopRequireDefault(_dialogsEmbedDialog);
	
	var _instance = 1;
	
	var EVENT_HANDLERS = {
		'change': 'onChange',
		// change event doesn't trigger changes immediately
		'keyup': 'onChange',
		'blur': 'onChange',
		'paste': 'onChange',
		'cut': 'onChange',
		'undo': 'onChange'
	
	};
	
	exports['default'] = _react2['default'].createClass({
		displayName: 'index',
	
		getDefaultProps: function getDefaultProps() {
			return {
				'linkDialog': _dialogsLinkDialog2['default'],
				'imageDialog': _dialogsImageDialog2['default'],
				'mediaDialog': _dialogsMediaDialog2['default'],
				'embedDialog': _dialogsEmbedDialog2['default'],
				'plugins': _configConfig2['default'].plugins,
				'toolbar': _configConfig2['default'].toolbar
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				'link': {
					'dialog': false,
					'text': '',
					'href': ''
				},
				'image': {
					'dialog': false,
					'src': '',
					'file': null
				},
				'media': {
					'dialog': false,
					'source': '',
					'embed': '',
					'width': 0,
					'height': 0
				},
				'embed': {
					'dialog': false,
					'source': '',
					'embed': '',
					'width': 0,
					'height': 0
				}
	
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._id = 'tinymce-' + _instance;
			_instance++;
		},
	
		componentDidMount: function componentDidMount() {
			var _this = this;
	
			var setContent = this.setContent;
			var bindEditorEvents = this.bindEditorEvents;
			var showLinkDialog = this.showLinkDialog;
			var showImageDialog = this.showImageDialog;
			var showMediaDialog = this.showMediaDialog;
			var showEmbedDialog = this.showEmbedDialog;
			var _props = this.props;
			var mode = _props.mode;
			var content = _props.content;
			var _props2 = this.props;
			var plugins = _props2.plugins;
			var toolbar = _props2.toolbar;
	
			var isReadOnly = mode === 'readonly';
	
			// Initialize
			_tinymceTinymce2['default'].init({
				'selector': '#' + this._id,
				'skin': false,
				'inline': false,
				'menubar': false,
				'plugins': !isReadOnly ? plugins : [],
				'toolbar': !isReadOnly ? toolbar : false,
				'content_css': [
					// test configurability
					// 'https://tleunen.github.io/react-mdl/styles.css'
				],
				'browser_spellcheck': true,
				'setup': function setup(editor) {
					_this._editor = editor;
	
					if (content) {
						editor.on('init', function () {
							if (mode) editor.setMode(mode);
							setContent(content);
						});
					}
	
					// tinymce.PluginManager.get('name') ?
					editor.namespaced = editor.namespaced || {};
					editor.namespaced.showLinkDialog = showLinkDialog;
					editor.namespaced.showImageDialog = showImageDialog;
					editor.namespaced.showMediaDialog = showMediaDialog;
					editor.namespaced.showEmbedDialog = showEmbedDialog;
	
					bindEditorEvents();
				},
				'style_formats': _configConfig2['default'].style.formats,
				'paste_as_text': false,
				'paste_remove_styles': false,
				'paste_remove_styles_if_webkit': false
	
			});
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			var mode = nextProps.mode;
	
			if (mode !== this.props.mode) {
				// TODO trigger init
				this._editor.setMode(mode);
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			var editor = this._editor;
			if (editor) {
				this.unbindEditorEvents();
				_tinymceTinymce2['default'].remove(editor);
			}
		},
	
		onChange: function onChange() {
			var content = this._editor.getContent();
			this.props.onChange(content);
		},
	
		setContent: function setContent(content) {
			this._editor.setContent(content);
		},
	
		getContent: function getContent() {
			return this._editor.getContent();
		},
	
		_editor: null,
	
		bindEditorEvents: function bindEditorEvents() {
			var _this2 = this;
	
			Object.keys(EVENT_HANDLERS).map(function (eventName) {
				var eventHandler = EVENT_HANDLERS[eventName];
				_this2._editor.on(eventName, _this2[eventHandler]);
			});
		},
	
		unbindEditorEvents: function unbindEditorEvents() {
			var _this3 = this;
	
			// TODO DRY
			Object.keys(EVENT_HANDLERS).map(function (eventName) {
				var eventHandler = _this3[EVENT_HANDLERS[eventName]];
				_this3._editor.off(eventName, _this3[eventHandler]);
			});
		},
	
		showLinkDialog: function showLinkDialog(params) {
			var editor = this._editor;
	
			var selectedElm = editor.selection.getNode();
			var anchorElm = editor.dom.getParent(selectedElm, 'a[href]');
	
			var data = {};
			data.text = anchorElm ? anchorElm.innerText || anchorElm.textContent : editor.selection.getContent({ format: 'text' });
			data.href = anchorElm ? editor.dom.getAttrib(anchorElm, 'href') : '';
			data.target = '_blank';
	
			this.setState({
				'link': Object.assign(this.state.link, {
					'dialog': true,
					'text': data.text,
					'href': data.href,
					'target': data.target,
					'onSubmit': params.onSubmit
				})
			});
		},
	
		showImageDialog: function showImageDialog(params) {
			var editor = this._editor;
	
			var imgElm = editor.selection.getNode();
			var figureElm = editor.dom.getParent(imgElm, 'figure.image');
	
			if (figureElm) {
				imgElm = editor.dom.select('img', figureElm)[0];
			}
			if (imgElm && (imgElm.nodeName != 'IMG' || imgElm.getAttribute('data-mce-object') || imgElm.getAttribute('data-mce-placeholder'))) {
				imgElm = null;
			}
	
			this.setState({
				'image': Object.assign(this.state.image, {
					'dialog': true,
					'src': imgElm ? editor.dom.getAttrib(imgElm, 'src') : '',
					'onSubmit': params.onSubmit
				})
			});
		},
	
		showMediaDialog: function showMediaDialog(params) {
			var editor = this._editor;
	
			var mediaElm = editor.selection.getNode();
			var data = editor.namespaced.getMediaData(mediaElm);
	
			if (data.type === 'iframe') {
				data.embed = editor.namespaced.getMediaHTML(data);
			}
	
			this.setState({
				'media': Object.assign(this.state.media, {
					'dialog': true,
					'source': data.source1 || '',
					'embed': data.embed || '',
					'width': data.width || 640,
					'height': data.height || 360,
					'onSubmit': params.onSubmit
				})
			});
		},
	
		showEmbedDialog: function showEmbedDialog(params) {
			var editor = this._editor;
	
			var mediaElm = editor.selection.getNode();
			var data = editor.namespaced.getEmbedData(mediaElm);
	
			if (data.type === 'iframe') {
				data.embed = editor.namespaced.getEmbedHTML(data);
			}
	
			this.setState({
				'embed': Object.assign(this.state.embed, {
					'dialog': true,
					'source': data.source1 || '',
					'embed': data.embed || '',
					'width': data.width || 640,
					'height': data.height || 360,
					'onSubmit': params.onSubmit
				})
			});
		},
	
		handleLinkChange: function handleLinkChange(key, value) {
			var link = this.state.link;
	
			this.setState({
				'link': Object.defineProperty(link, key, {
					'enumerable': true,
					value: value
				})
			});
		},
	
		handleImageChange: function handleImageChange(key, value) {
			var image = this.state.image;
	
			this.setState({
				'image': Object.defineProperty(image, key, {
					'enumerable': true,
					value: value
				})
			});
		},
	
		handleMediaChange: function handleMediaChange(key, value) {
			var media = this.state.media;
	
			this.setState({
				'media': Object.defineProperty(media, key, {
					'enumerable': true,
					value: value
				})
			});
		},
	
		handleEmbedChange: function handleEmbedChange(key, value) {
			var embed = this.state.embed;
	
			this.setState({
				'embed': Object.defineProperty(embed, key, {
					'enumerable': true,
					value: value
				})
			});
		},
	
		handleLinkSubmit: function handleLinkSubmit() {
			var _this4 = this;
	
			this.hideLinkDialog(function () {
				var link = _this4.state.link;
	
				_this4._editor.focus();
	
				link.onSubmit({ 'data': link });
			});
		},
	
		handleImageSubmit: function handleImageSubmit() {
			var _this5 = this;
	
			this.hideImageDialog(function () {
				var image = _this5.state.image;
	
				_this5._editor.focus();
	
				image.onSubmit({ 'data': image });
			});
		},
	
		handleMediaSubmit: function handleMediaSubmit() {
			var _this6 = this;
	
			this.hideMediaDialog(function () {
				var media = _this6.state.media;
	
				_this6._editor.focus();
	
				media.onSubmit({ 'data': media });
			});
		},
	
		handleEmbedSubmit: function handleEmbedSubmit() {
			var _this7 = this;
	
			this.hideEmbedDialog(function () {
				var embed = _this7.state.embed;
	
				_this7._editor.focus();
	
				embed.onSubmit({ 'data': embed });
			});
		},
	
		hideLinkDialog: function hideLinkDialog(callback) {
			var _this8 = this;
	
			this.setState({
				'link': Object.assign(this.state.link, {
					'dialog': false
				})
			}, function () {
				if (typeof callback === 'function') {
					callback();
				} else {
					_this8._editor.focus();
				}
			});
		},
	
		hideImageDialog: function hideImageDialog(callback) {
			var _this9 = this;
	
			this.setState({
				'image': Object.assign(this.state.image, {
					'dialog': false
				})
			}, function () {
				if (typeof callback === 'function') {
					callback();
				} else {
					_this9._editor.focus();
				}
			});
		},
	
		hideMediaDialog: function hideMediaDialog(callback) {
			var _this10 = this;
	
			this.setState({
				'media': Object.assign(this.state.media, {
					'dialog': false
				})
			}, function () {
				if (typeof callback === 'function') {
					callback();
				} else {
					_this10._editor.focus();
				}
			});
		},
	
		hideEmbedDialog: function hideEmbedDialog(callback) {
			var _this11 = this;
	
			this.setState({
				'embed': Object.assign(this.state.embed, {
					'dialog': false
				})
			}, function () {
				if (typeof callback === 'function') {
					callback();
				} else {
					_this11._editor.focus();
				}
			});
		},
	
		render: function render() {
			var handleLinkChange = this.handleLinkChange;
			var handleLinkSubmit = this.handleLinkSubmit;
			var hideLinkDialog = this.hideLinkDialog;
			var handleImageChange = this.handleImageChange;
			var handleImageSubmit = this.handleImageSubmit;
			var hideImageDialog = this.hideImageDialog;
			var handleMediaChange = this.handleMediaChange;
			var handleMediaSubmit = this.handleMediaSubmit;
			var hideMediaDialog = this.hideMediaDialog;
			var handleEmbedChange = this.handleEmbedChange;
			var handleEmbedSubmit = this.handleEmbedSubmit;
			var hideEmbedDialog = this.hideEmbedDialog;
			var _state = this.state;
			var link = _state.link;
			var image = _state.image;
			var media = _state.media;
			var embed = _state.embed;
			var _props3 = this.props;
			var linkDialog = _props3.linkDialog;
			var imageDialog = _props3.imageDialog;
			var mediaDialog = _props3.mediaDialog;
			var embedDialog = _props3.embedDialog;
	
			var LinkDialog = linkDialog;
			var ImageDialog = imageDialog;
			var MediaDialog = mediaDialog;
			var EmbedDialog = embedDialog;
	
			return _react2['default'].createElement(
				'section',
				null,
				_react2['default'].createElement('textarea', {
					id: this._id,
					ref: 'editor',
					className: 'tinymce',
					style: { 'visibility': 'hidden' }
				}),
				_react2['default'].createElement(LinkDialog, {
					show: link.dialog,
					data: link,
					onChange: handleLinkChange,
					onSubmit: handleLinkSubmit,
					onCancel: hideLinkDialog
				}),
				_react2['default'].createElement(ImageDialog, {
					show: image.dialog,
					data: image,
					onChange: handleImageChange,
					onSubmit: handleImageSubmit,
					onCancel: hideImageDialog
				}),
				_react2['default'].createElement(MediaDialog, {
					show: media.dialog,
					data: media,
					onChange: handleMediaChange,
					onSubmit: handleMediaSubmit,
					onCancel: hideMediaDialog
				}),
				_react2['default'].createElement(EmbedDialog, {
					show: embed.dialog,
					data: embed,
					onChange: handleEmbedChange,
					onSubmit: handleEmbedSubmit,
					onCancel: hideEmbedDialog
				})
			);
		}
	
	});
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/* jshint maxlen:255 */
	/* eslint max-len:0 */
	/* global tinymce:true */
	
	'use strict';
	
	tinymce.PluginManager.add('embed', function (editor, url) {
		var urlPatterns = [{ regex: /(.*(ai|avi|flv|mov|pdf|psd|wmv)$)/gi, type: 'iframe', w: 480, h: 360, url: '//docs.google.com/viewer?embedded=true&url=$0', allowFullscreen: true }, { regex: /(.*(doc|docx|ppt|pptx|xls|xlsx)$)/gi, type: 'iframe', w: 480, h: 360, url: '//view.officeapps.live.com/op/embed.aspx?src=$0', allowFullscreen: true }];
	
		var embedChange = tinymce.Env.ie && tinymce.Env.ie <= 8 ? 'onChange' : 'onInput';
	
		function guessMime(url) {
			url = url.toLowerCase();
	
			return '';
		}
	
		function getVideoScriptMatch(src) {
			var prefixes = editor.settings.media_scripts;
	
			if (prefixes) {
				for (var i = 0; i < prefixes.length; i++) {
					if (src.indexOf(prefixes[i].filter) !== -1) {
						return prefixes[i];
					}
				}
			}
		}
	
		function showDialog() {
			var win, width, height, data;
	
			var generalFormItems = [];
	
			function recalcSize(e) {
				var widthCtrl, heightCtrl, newWidth, newHeight;
	
				widthCtrl = win.find('#width')[0];
				heightCtrl = win.find('#height')[0];
	
				newWidth = widthCtrl.value();
				newHeight = heightCtrl.value();
	
				if (win.find('#constrain')[0].checked() && width && height && newWidth && newHeight) {
					if (e.control == widthCtrl) {
						newHeight = Math.round(newWidth / width * newHeight);
	
						if (!isNaN(newHeight)) {
							heightCtrl.value(newHeight);
						}
					} else {
						newWidth = Math.round(newHeight / height * newWidth);
	
						if (!isNaN(newWidth)) {
							widthCtrl.value(newWidth);
						}
					}
				}
	
				width = newWidth;
				height = newHeight;
			}
	
			data = getData(editor.selection.getNode());
			width = data.width;
			height = data.height;
	
			var embedTextBox = {
				id: 'mceembedsource',
				type: 'textbox',
				flex: 1,
				name: 'embed',
				value: getSource(),
				multiline: true,
				label: 'Source'
			};
	
			function updateValueOnChange() {
				data = htmlToData(this.value());
				this.parent().parent().fromJSON(data);
			}
	
			embedTextBox[embedChange] = updateValueOnChange;
	
			//
			editor.namespaced.getEmbedData = getData;
			editor.namespaced.getEmbedHTML = dataToHtml;
	
			// win = editor.windowManager.open(
			// Shows an external Dialog
			editor.namespaced.showEmbedDialog({
				title: 'Insert/edit video',
				data: data,
				bodyType: 'tabpanel',
				body: [],
				onSubmit: function onSubmit(e) {
					var beforeObjects, afterObjects, i, y;
	
					var info = {
						'source1': e.data.source,
						'source2': '',
						'poster': '',
						'embed': e.data.embed,
						'width': e.data.width || '',
						'height': e.data.height || '',
						'constrain': true
					};
	
					beforeObjects = editor.dom.select('img[data-mce-object]');
					// editor.insertContent(dataToHtml(this.toJSON()));
					editor.insertContent(dataToHtml(info));
					afterObjects = editor.dom.select('img[data-mce-object]');
	
					// Find new image placeholder so we can select it
					for (i = 0; i < beforeObjects.length; i++) {
						for (y = afterObjects.length - 1; y >= 0; y--) {
							if (beforeObjects[i] == afterObjects[y]) {
								afterObjects.splice(y, 1);
							}
						}
					}
	
					editor.selection.select(afterObjects[0]);
					editor.nodeChanged();
				}
			});
		}
	
		function getSource() {
			var elm = editor.selection.getNode();
	
			if (elm.getAttribute('data-mce-object')) {
				return editor.selection.getContent();
			}
		}
	
		function dataToHtml(data) {
			var html = '';
	
			if (!data.source1) {
				tinymce.extend(data, htmlToData(data.embed));
				if (!data.source1) {
					return '';
				}
			}
	
			if (!data.source2) {
				data.source2 = '';
			}
	
			if (!data.poster) {
				data.poster = '';
			}
	
			data.source1 = editor.convertURL(data.source1, "source");
			data.source2 = editor.convertURL(data.source2, "source");
			data.source1mime = guessMime(data.source1);
			data.source2mime = guessMime(data.source2);
			data.poster = editor.convertURL(data.poster, "poster");
			data.flashPlayerUrl = editor.convertURL(url + '/moxieplayer.swf', "movie");
	
			tinymce.each(urlPatterns, function (pattern) {
				var match, i, url;
	
				if (match = pattern.regex.exec(data.source1)) {
					url = pattern.url;
	
					for (i = 0; match[i]; i++) {
						/*jshint loopfunc:true*/
						/*eslint no-loop-func:0 */
						url = url.replace('$' + i, function () {
							return match[i];
						});
					}
	
					data.source1 = url;
					data.type = pattern.type;
					data.allowFullscreen = pattern.allowFullscreen;
					data.width = data.width || pattern.w;
					data.height = data.height || pattern.h;
				}
			});
	
			if (data.embed) {
				html = updateHtml(data.embed, data, true);
			} else {
				var videoScript = getVideoScriptMatch(data.source1);
				if (videoScript) {
					data.type = 'script';
					data.width = videoScript.width;
					data.height = videoScript.height;
				}
	
				data.width = data.width || 300;
				data.height = data.height || 150;
	
				tinymce.each(data, function (value, key) {
					data[key] = editor.dom.encode(value);
				});
	
				if (data.type == "iframe") {
					var allowFullscreen = data.allowFullscreen ? ' allowFullscreen="1"' : '';
					html += '<iframe src="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
				} else if (data.source1mime == "application/x-shockwave-flash") {
					html += '<object data="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
	
					if (data.poster) {
						html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
					}
	
					html += '</object>';
				} else if (data.source1mime.indexOf('audio') != -1) {
					if (editor.settings.audio_template_callback) {
						html = editor.settings.audio_template_callback(data);
					} else {
						html += '<audio controls="controls" src="' + data.source1 + '">' + (data.source2 ? '\n<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</audio>';
					}
				} else if (data.type == "script") {
					html += '<script src="' + data.source1 + '"></script>';
				} else {
					if (editor.settings.video_template_callback) {
						html = editor.settings.video_template_callback(data);
					} else {
						html = '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
					}
				}
			}
	
			return html;
		}
	
		function htmlToData(html) {
			var data = {};
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: true,
				special: 'script,noscript',
				start: function start(name, attrs) {
					if (!data.source1 && name == "param") {
						data.source1 = attrs.map.movie;
					}
	
					if (name == "iframe" || name == "object" || name == "embed" || name == "video" || name == "audio") {
						if (!data.type) {
							data.type = name;
						}
	
						data = tinymce.extend(attrs.map, data);
					}
	
					if (name == "script") {
						var videoScript = getVideoScriptMatch(attrs.map.src);
						if (!videoScript) {
							return;
						}
	
						data = {
							type: "script",
							source1: attrs.map.src,
							width: videoScript.width,
							height: videoScript.height
						};
					}
	
					if (name == "source") {
						if (!data.source1) {
							data.source1 = attrs.map.src;
						} else if (!data.source2) {
							data.source2 = attrs.map.src;
						}
					}
	
					if (name == "img" && !data.poster) {
						data.poster = attrs.map.src;
					}
				}
			}).parse(html);
	
			data.source1 = data.source1 || data.src || data.data;
			data.source2 = data.source2 || '';
			data.poster = data.poster || '';
	
			return data;
		}
	
		function getData(element) {
			if (element.getAttribute('data-mce-object')) {
				return htmlToData(editor.serializer.serialize(element, { selection: true }));
			}
	
			return {};
		}
	
		function sanitize(html) {
			if (editor.settings.media_filter_html === false) {
				return html;
			}
	
			var writer = new tinymce.html.Writer(),
			    blocked;
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: false,
				special: 'script,noscript',
	
				comment: function comment(text) {
					writer.comment(text);
				},
	
				cdata: function cdata(text) {
					writer.cdata(text);
				},
	
				text: function text(_text, raw) {
					writer.text(_text, raw);
				},
	
				start: function start(name, attrs, empty) {
					blocked = true;
	
					if (name == 'script' || name == 'noscript') {
						return;
					}
	
					for (var i = 0; i < attrs.length; i++) {
						if (attrs[i].name.indexOf('on') === 0) {
							return;
						}
	
						if (attrs[i].name == 'style') {
							attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
						}
					}
	
					writer.start(name, attrs, empty);
					blocked = false;
				},
	
				end: function end(name) {
					if (blocked) {
						return;
					}
	
					writer.end(name);
				}
			}, new tinymce.html.Schema({})).parse(html);
	
			return writer.getContent();
		}
	
		function updateHtml(html, data, updateAll) {
			var writer = new tinymce.html.Writer();
			var sourceCount = 0,
			    hasImage;
	
			function setAttributes(attrs, updatedAttrs) {
				var name, i, value, attr;
	
				for (name in updatedAttrs) {
					value = "" + updatedAttrs[name];
	
					if (attrs.map[name]) {
						i = attrs.length;
						while (i--) {
							attr = attrs[i];
	
							if (attr.name == name) {
								if (value) {
									attrs.map[name] = value;
									attr.value = value;
								} else {
									delete attrs.map[name];
									attrs.splice(i, 1);
								}
							}
						}
					} else if (value) {
						attrs.push({
							name: name,
							value: value
						});
	
						attrs.map[name] = value;
					}
				}
			}
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: true,
				special: 'script,noscript',
	
				comment: function comment(text) {
					writer.comment(text);
				},
	
				cdata: function cdata(text) {
					writer.cdata(text);
				},
	
				text: function text(_text2, raw) {
					writer.text(_text2, raw);
				},
	
				start: function start(name, attrs, empty) {
					switch (name) {
						case "video":
						case "object":
						case "embed":
						case "img":
						case "iframe":
							setAttributes(attrs, {
								width: data.width,
								height: data.height
							});
							break;
					}
	
					if (updateAll) {
						switch (name) {
							case "video":
								setAttributes(attrs, {
									poster: data.poster,
									src: ""
								});
	
								if (data.source2) {
									setAttributes(attrs, {
										src: ""
									});
								}
								break;
	
							case "iframe":
								setAttributes(attrs, {
									src: data.source1
								});
								break;
	
							case "source":
								sourceCount++;
	
								if (sourceCount <= 2) {
									setAttributes(attrs, {
										src: data["source" + sourceCount],
										type: data["source" + sourceCount + "mime"]
									});
	
									if (!data["source" + sourceCount]) {
										return;
									}
								}
								break;
	
							case "img":
								if (!data.poster) {
									return;
								}
	
								hasImage = true;
								break;
						}
					}
	
					writer.start(name, attrs, empty);
				},
	
				end: function end(name) {
					if (name == "video" && updateAll) {
						for (var index = 1; index <= 2; index++) {
							if (data["source" + index]) {
								var attrs = [];
								attrs.map = {};
	
								if (sourceCount < index) {
									setAttributes(attrs, {
										src: data["source" + index],
										type: data["source" + index + "mime"]
									});
	
									writer.start("source", attrs, true);
								}
							}
						}
					}
	
					if (data.poster && name == "object" && updateAll && !hasImage) {
						var imgAttrs = [];
						imgAttrs.map = {};
	
						setAttributes(imgAttrs, {
							src: data.poster,
							width: data.width,
							height: data.height
						});
	
						writer.start("img", imgAttrs, true);
					}
	
					writer.end(name);
				}
			}, new tinymce.html.Schema({})).parse(html);
	
			return writer.getContent();
		}
	
		editor.on('ResolveName', function (e) {
			var name;
	
			if (e.target.nodeType == 1 && (name = e.target.getAttribute("data-mce-object"))) {
				e.name = name;
			}
		});
	
		function retainAttributesAndInnerHtml(sourceNode, targetNode) {
			var attrName, attrValue, attribs, ai, innerHtml;
	
			// Prefix all attributes except width, height and style since we
			// will add these to the placeholder
			attribs = sourceNode.attributes;
			ai = attribs.length;
			while (ai--) {
				attrName = attribs[ai].name;
				attrValue = attribs[ai].value;
	
				if (attrName !== "width" && attrName !== "height" && attrName !== "style") {
					if (attrName == "data" || attrName == "src") {
						attrValue = editor.convertURL(attrValue, attrName);
					}
	
					targetNode.attr('data-mce-p-' + attrName, attrValue);
				}
			}
	
			// Place the inner HTML contents inside an escaped attribute
			// This enables us to copy/paste the fake object
			innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
			if (innerHtml) {
				targetNode.attr("data-mce-html", escape(innerHtml));
				targetNode.firstChild = null;
			}
		}
	
		function createPlaceholderNode(node) {
			var placeHolder,
			    name = node.name;
	
			placeHolder = new tinymce.html.Node('img', 1);
			placeHolder.shortEnded = true;
	
			retainAttributesAndInnerHtml(node, placeHolder);
	
			placeHolder.attr({
				width: node.attr('width') || "300",
				height: node.attr('height') || (name == "audio" ? "30" : "150"),
				style: node.attr('style'),
				src: tinymce.Env.transparentSrc,
				"data-mce-object": name,
				"class": "mce-object mce-object-" + name
			});
	
			return placeHolder;
		}
	
		function createPreviewNode(node) {
			var previewWrapper,
			    previewNode,
			    shimNode,
			    name = node.name;
	
			previewWrapper = new tinymce.html.Node('span', 1);
			previewWrapper.attr({
				contentEditable: 'false',
				style: node.attr('style'),
				"data-mce-object": name,
				"class": "mce-preview-object mce-object-" + name
			});
	
			retainAttributesAndInnerHtml(node, previewWrapper);
	
			previewNode = new tinymce.html.Node(name, 1);
			previewNode.attr({
				src: node.attr('src'),
				allowfullscreen: node.attr('allowfullscreen'),
				width: node.attr('width') || "300",
				height: node.attr('height') || (name == "audio" ? "30" : "150"),
				frameborder: '0'
			});
	
			shimNode = new tinymce.html.Node('span', 1);
			shimNode.attr('class', 'mce-shim');
	
			previewWrapper.append(previewNode);
			previewWrapper.append(shimNode);
	
			return previewWrapper;
		}
	
		editor.on('preInit', function () {
			// Make sure that any messy HTML is retained inside these
			var specialElements = editor.schema.getSpecialElements();
			tinymce.each('video audio iframe object'.split(' '), function (name) {
				specialElements[name] = new RegExp('<\/' + name + '[^>]*>', 'gi');
			});
	
			// Allow elements
			//editor.schema.addValidElements('object[id|style|width|height|classid|codebase|*],embed[id|style|width|height|type|src|*],video[*],audio[*]');
	
			// Set allowFullscreen attribs as boolean
			var boolAttrs = editor.schema.getBoolAttrs();
			tinymce.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
				boolAttrs[name] = {};
			});
	
			// Converts iframe, video etc into placeholder images
			editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', function (nodes) {
				var i = nodes.length,
				    node,
				    placeHolder,
				    videoScript;
	
				while (i--) {
					node = nodes[i];
					if (!node.parent) {
						continue;
					}
	
					if (node.parent.attr('data-mce-object')) {
						continue;
					}
	
					if (node.name == 'script') {
						videoScript = getVideoScriptMatch(node.attr('src'));
						if (!videoScript) {
							continue;
						}
					}
	
					if (videoScript) {
						if (videoScript.width) {
							node.attr('width', videoScript.width.toString());
						}
	
						if (videoScript.height) {
							node.attr('height', videoScript.height.toString());
						}
					}
	
					if (node.name == 'iframe' && editor.settings.media_live_embeds !== false && tinymce.Env.ceFalse) {
						placeHolder = createPreviewNode(node);
					} else {
						placeHolder = createPlaceholderNode(node);
					}
	
					node.replace(placeHolder);
				}
			});
	
			// Replaces placeholder images with real elements for video, object, iframe etc
			editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
				var i = nodes.length,
				    node,
				    realElm,
				    ai,
				    attribs,
				    innerHtml,
				    innerNode,
				    realElmName,
				    className;
	
				while (i--) {
					node = nodes[i];
					if (!node.parent) {
						continue;
					}
	
					realElmName = node.attr(name);
					realElm = new tinymce.html.Node(realElmName, 1);
	
					// Add width/height to everything but audio
					if (realElmName != "audio" && realElmName != "script") {
						className = node.attr('class');
						if (className && className.indexOf('mce-preview-object') !== -1) {
							realElm.attr({
								width: node.firstChild.attr('width'),
								height: node.firstChild.attr('height')
							});
						} else {
							realElm.attr({
								width: node.attr('width'),
								height: node.attr('height')
							});
						}
					}
	
					realElm.attr({
						style: node.attr('style')
					});
	
					// Unprefix all placeholder attributes
					attribs = node.attributes;
					ai = attribs.length;
					while (ai--) {
						var attrName = attribs[ai].name;
	
						if (attrName.indexOf('data-mce-p-') === 0) {
							realElm.attr(attrName.substr(11), attribs[ai].value);
						}
					}
	
					if (realElmName == "script") {
						realElm.attr('type', 'text/javascript');
					}
	
					// Inject innerhtml
					innerHtml = node.attr('data-mce-html');
					if (innerHtml) {
						innerNode = new tinymce.html.Node('#text', 3);
						innerNode.raw = true;
						innerNode.value = sanitize(unescape(innerHtml));
						realElm.append(innerNode);
					}
	
					node.replace(realElm);
				}
			});
		});
	
		editor.on('click keyup', function () {
			var selectedNode = editor.selection.getNode();
	
			if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
				if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
					selectedNode.setAttribute('data-mce-selected', '2');
				}
			}
		});
	
		editor.on('ObjectSelected', function (e) {
			var objectType = e.target.getAttribute('data-mce-object');
	
			if (objectType == "audio" || objectType == "script") {
				e.preventDefault();
			}
		});
	
		editor.on('objectResized', function (e) {
			var target = e.target,
			    html;
	
			if (target.getAttribute('data-mce-object')) {
				html = target.getAttribute('data-mce-html');
				if (html) {
					html = unescape(html);
					target.setAttribute('data-mce-html', escape(updateHtml(html, {
						width: e.width,
						height: e.height
					})));
				}
			}
		});
	
		editor.addButton('embed', {
			tooltip: 'Insert/edit embeddable content',
			onclick: showDialog,
			stateSelector: ['img[data-mce-object]', 'span[data-mce-object]']
		});
	
		editor.addMenuItem('embed', {
			icon: 'newdocument',
			text: 'Insert/edit embeddable content',
			onclick: showDialog,
			context: 'insert',
			prependToContext: true
		});
	
		editor.on('setContent', function () {
			// TODO: This shouldn't be needed there should be a way to mark bogus
			// elements so they are never removed except external save
			editor.$('span.mce-preview-object').each(function (index, elm) {
				var $elm = editor.$(elm);
	
				if ($elm.find('span.mce-shim', elm).length === 0) {
					$elm.append('<span class="mce-shim"></span>');
				}
			});
		});
	
		editor.addCommand('mceEmbed', showDialog);
	
		this.showDialog = showDialog;
	});

/***/ },
/* 242 */
/***/ function(module, exports) {

	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*global tinymce:true */
	
	'use strict';
	
	tinymce.PluginManager.add('image', function (editor) {
		function getImageSize(url, callback) {
			var img = document.createElement('img');
	
			function done(width, height) {
				if (img.parentNode) {
					img.parentNode.removeChild(img);
				}
	
				callback({ width: width, height: height });
			}
	
			img.onload = function () {
				done(Math.max(img.width, img.clientWidth), Math.max(img.height, img.clientHeight));
			};
	
			img.onerror = function () {
				done();
			};
	
			var style = img.style;
			style.visibility = 'hidden';
			style.position = 'fixed';
			style.bottom = style.left = 0;
			style.width = style.height = 'auto';
	
			document.body.appendChild(img);
			img.src = url;
		}
	
		function buildListItems(inputList, itemCallback, startItems) {
			function appendItems(values, output) {
				output = output || [];
	
				tinymce.each(values, function (item) {
					var menuItem = { text: item.text || item.title };
	
					if (item.menu) {
						menuItem.menu = appendItems(item.menu);
					} else {
						menuItem.value = item.value;
						itemCallback(menuItem);
					}
	
					output.push(menuItem);
				});
	
				return output;
			}
	
			return appendItems(inputList, startItems || []);
		}
	
		function createImageList(callback) {
			return function () {
				var imageList = editor.settings.image_list;
	
				if (typeof imageList == "string") {
					tinymce.util.XHR.send({
						url: imageList,
						success: function success(text) {
							callback(tinymce.util.JSON.parse(text));
						}
					});
				} else if (typeof imageList == "function") {
					imageList(callback);
				} else {
					callback(imageList);
				}
			};
		}
	
		function showDialog(imageList) {
			var win,
			    data = {},
			    dom = editor.dom,
			    imgElm,
			    figureElm;
			var width,
			    height,
			    imageListCtrl,
			    classListCtrl,
			    imageDimensions = editor.settings.image_dimensions !== false;
	
			// Create empty element to bypass logic bound to editor.windowManager.open
			win = editor.windowManager.open({}).close();
	
			function recalcSize() {
				var widthCtrl, heightCtrl, newWidth, newHeight;
	
				widthCtrl = win.find('#width')[0];
				heightCtrl = win.find('#height')[0];
	
				if (!widthCtrl || !heightCtrl) {
					return;
				}
	
				newWidth = widthCtrl.value();
				newHeight = heightCtrl.value();
	
				if (win.find('#constrain')[0].checked() && width && height && newWidth && newHeight) {
					if (width != newWidth) {
						newHeight = Math.round(newWidth / width * newHeight);
	
						if (!isNaN(newHeight)) {
							heightCtrl.value(newHeight);
						}
					} else {
						newWidth = Math.round(newHeight / height * newWidth);
	
						if (!isNaN(newWidth)) {
							widthCtrl.value(newWidth);
						}
					}
				}
	
				width = newWidth;
				height = newHeight;
			}
	
			function onSubmitForm(e) {
				var figureElm, oldImg;
	
				function waitLoad(imgElm) {
					function selectImage() {
						imgElm.onload = imgElm.onerror = null;
	
						if (editor.selection) {
							editor.selection.select(imgElm);
							editor.nodeChanged();
						}
					}
	
					imgElm.onload = function () {
						if (!data.width && !data.height && imageDimensions) {
							dom.setAttribs(imgElm, {
								width: imgElm.clientWidth,
								height: imgElm.clientHeight
							});
						}
	
						selectImage();
					};
	
					imgElm.onerror = selectImage;
				}
	
				updateStyle();
				recalcSize();
	
				data = tinymce.extend(data, e.data);
	
				if (!data.alt) {
					data.alt = '';
				}
	
				if (!data.title) {
					data.title = '';
				}
	
				if (data.width === '') {
					data.width = null;
				}
	
				if (data.height === '') {
					data.height = null;
				}
	
				if (!data.style) {
					data.style = null;
				}
	
				// Setup new data excluding style properties
				/*eslint dot-notation: 0*/
				data = {
					src: data.src,
					alt: data.alt,
					title: data.title,
					width: data.width,
					height: data.height,
					style: data.style,
					caption: data.caption,
					"class": data["class"]
				};
	
				editor.undoManager.transact(function () {
					if (!data.src) {
						if (imgElm) {
							dom.remove(imgElm);
							editor.focus();
							editor.nodeChanged();
						}
	
						return;
					}
	
					if (data.title === "") {
						data.title = null;
					}
	
					if (!imgElm) {
						data.id = '__mcenew';
						editor.focus();
						editor.selection.setContent(dom.createHTML('img', data));
						imgElm = dom.get('__mcenew');
						dom.setAttrib(imgElm, 'id', null);
					} else {
						dom.setAttribs(imgElm, data);
					}
	
					editor.editorUpload.uploadImagesAuto();
	
					if (data.caption === false) {
						if (dom.is(imgElm.parentNode, 'figure.image')) {
							figureElm = imgElm.parentNode;
							dom.insertAfter(imgElm, figureElm);
							dom.remove(figureElm);
						}
					}
	
					function isTextBlock(node) {
						return editor.schema.getTextBlockElements()[node.nodeName];
					}
	
					if (data.caption === true) {
						if (!dom.is(imgElm.parentNode, 'figure.image')) {
							oldImg = imgElm;
							imgElm = imgElm.cloneNode(true);
							figureElm = dom.create('figure', { 'class': 'image' });
							figureElm.appendChild(imgElm);
							figureElm.appendChild(dom.create('figcaption', { contentEditable: true }, 'Caption'));
							figureElm.contentEditable = false;
	
							var textBlock = dom.getParent(oldImg, isTextBlock);
							if (textBlock) {
								dom.split(textBlock, oldImg, figureElm);
							} else {
								dom.replace(figureElm, oldImg);
							}
	
							editor.selection.select(figureElm);
						}
	
						return;
					}
	
					waitLoad(imgElm);
				});
			}
	
			function removePixelSuffix(value) {
				if (value) {
					value = value.replace(/px$/, '');
				}
	
				return value;
			}
	
			function srcChange(e) {
				var srcURL,
				    prependURL,
				    absoluteURLPattern,
				    meta = e.meta || {};
	
				if (imageListCtrl) {
					imageListCtrl.value(editor.convertURL(this.value(), 'src'));
				}
	
				tinymce.each(meta, function (value, key) {
					win.find('#' + key).value(value);
				});
	
				if (!meta.width && !meta.height) {
					srcURL = editor.convertURL(this.value(), 'src');
	
					// Pattern test the src url and make sure we haven't already prepended the url
					prependURL = editor.settings.image_prepend_url;
					absoluteURLPattern = new RegExp('^(?:[a-z]+:)?//', 'i');
					if (prependURL && !absoluteURLPattern.test(srcURL) && srcURL.substring(0, prependURL.length) !== prependURL) {
						srcURL = prependURL + srcURL;
					}
	
					this.value(srcURL);
	
					getImageSize(editor.documentBaseURI.toAbsolute(this.value()), function (data) {
						if (data.width && data.height && imageDimensions) {
							width = data.width;
							height = data.height;
	
							win.find('#width').value(width);
							win.find('#height').value(height);
						}
					});
				}
			}
	
			imgElm = editor.selection.getNode();
			figureElm = dom.getParent(imgElm, 'figure.image');
			if (figureElm) {
				imgElm = dom.select('img', figureElm)[0];
			}
	
			if (imgElm && (imgElm.nodeName != 'IMG' || imgElm.getAttribute('data-mce-object') || imgElm.getAttribute('data-mce-placeholder'))) {
				imgElm = null;
			}
	
			if (imgElm) {
				width = dom.getAttrib(imgElm, 'width');
				height = dom.getAttrib(imgElm, 'height');
	
				data = {
					src: dom.getAttrib(imgElm, 'src'),
					alt: dom.getAttrib(imgElm, 'alt'),
					title: dom.getAttrib(imgElm, 'title'),
					"class": dom.getAttrib(imgElm, 'class'),
					width: width,
					height: height,
					caption: !!figureElm
				};
			}
	
			if (imageList) {
				imageListCtrl = {
					type: 'listbox',
					label: 'Image list',
					values: buildListItems(imageList, function (item) {
						item.value = editor.convertURL(item.value || item.url, 'src');
					}, [{ text: 'None', value: '' }]),
					value: data.src && editor.convertURL(data.src, 'src'),
					onselect: function onselect(e) {
						var altCtrl = win.find('#alt');
	
						if (!altCtrl.value() || e.lastControl && altCtrl.value() == e.lastControl.text()) {
							altCtrl.value(e.control.text());
						}
	
						win.find('#src').value(e.control.value()).fire('change');
					},
					onPostRender: function onPostRender() {
						/*eslint consistent-this: 0*/
						imageListCtrl = this;
					}
				};
			}
	
			if (editor.settings.image_class_list) {
				classListCtrl = {
					name: 'class',
					type: 'listbox',
					label: 'Class',
					values: buildListItems(editor.settings.image_class_list, function (item) {
						if (item.value) {
							item.textStyle = function () {
								return editor.formatter.getCssText({ inline: 'img', classes: [item.value] });
							};
						}
					})
				};
			}
	
			// General settings shared between simple and advanced dialogs
			var generalFormItems = [{
				name: 'src',
				type: 'filepicker',
				filetype: 'image',
				label: 'Source',
				autofocus: true,
				onchange: srcChange
			}, imageListCtrl];
	
			if (editor.settings.image_description !== false) {
				generalFormItems.push({ name: 'alt', type: 'textbox', label: 'Image description' });
			}
	
			if (editor.settings.image_title) {
				generalFormItems.push({ name: 'title', type: 'textbox', label: 'Image Title' });
			}
	
			if (imageDimensions) {
				generalFormItems.push({
					type: 'container',
					label: 'Dimensions',
					layout: 'flex',
					direction: 'row',
					align: 'center',
					spacing: 5,
					items: [{ name: 'width', type: 'textbox', maxLength: 5, size: 3, onchange: recalcSize, ariaLabel: 'Width' }, { type: 'label', text: 'x' }, { name: 'height', type: 'textbox', maxLength: 5, size: 3, onchange: recalcSize, ariaLabel: 'Height' }, { name: 'constrain', type: 'checkbox', checked: true, text: 'Constrain proportions' }]
				});
			}
	
			generalFormItems.push(classListCtrl);
	
			if (editor.settings.image_caption && tinymce.Env.ceFalse) {
				generalFormItems.push({ name: 'caption', type: 'checkbox', label: 'Caption' });
			}
	
			function mergeMargins(css) {
				if (css.margin) {
	
					var splitMargin = css.margin.split(" ");
	
					switch (splitMargin.length) {
						case 1:
							//margin: toprightbottomleft;
							css['margin-top'] = css['margin-top'] || splitMargin[0];
							css['margin-right'] = css['margin-right'] || splitMargin[0];
							css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
							css['margin-left'] = css['margin-left'] || splitMargin[0];
							break;
						case 2:
							//margin: topbottom rightleft;
							css['margin-top'] = css['margin-top'] || splitMargin[0];
							css['margin-right'] = css['margin-right'] || splitMargin[1];
							css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
							css['margin-left'] = css['margin-left'] || splitMargin[1];
							break;
						case 3:
							//margin: top rightleft bottom;
							css['margin-top'] = css['margin-top'] || splitMargin[0];
							css['margin-right'] = css['margin-right'] || splitMargin[1];
							css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
							css['margin-left'] = css['margin-left'] || splitMargin[1];
							break;
						case 4:
							//margin: top right bottom left;
							css['margin-top'] = css['margin-top'] || splitMargin[0];
							css['margin-right'] = css['margin-right'] || splitMargin[1];
							css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
							css['margin-left'] = css['margin-left'] || splitMargin[3];
					}
					delete css.margin;
				}
				return css;
			}
	
			function updateStyle() {
				function addPixelSuffix(value) {
					if (value.length > 0 && /^[0-9]+$/.test(value)) {
						value += 'px';
					}
	
					return value;
				}
	
				if (!editor.settings.image_advtab) {
					return;
				}
	
				var data = win.toJSON(),
				    css = dom.parseStyle(data.style);
	
				css = mergeMargins(css);
	
				if (data.vspace) {
					css['margin-top'] = css['margin-bottom'] = addPixelSuffix(data.vspace);
				}
				if (data.hspace) {
					css['margin-left'] = css['margin-right'] = addPixelSuffix(data.hspace);
				}
				if (data.border) {
					css['border-width'] = addPixelSuffix(data.border);
				}
	
				win.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
			}
	
			function updateVSpaceHSpaceBorder() {
				if (!editor.settings.image_advtab) {
					return;
				}
	
				var data = win.toJSON(),
				    css = dom.parseStyle(data.style);
	
				win.find('#vspace').value("");
				win.find('#hspace').value("");
	
				css = mergeMargins(css);
	
				//Move opposite equal margins to vspace/hspace field
				if (css['margin-top'] && css['margin-bottom'] || css['margin-right'] && css['margin-left']) {
					if (css['margin-top'] === css['margin-bottom']) {
						win.find('#vspace').value(removePixelSuffix(css['margin-top']));
					} else {
						win.find('#vspace').value('');
					}
					if (css['margin-right'] === css['margin-left']) {
						win.find('#hspace').value(removePixelSuffix(css['margin-right']));
					} else {
						win.find('#hspace').value('');
					}
				}
	
				//Move border-width
				if (css['border-width']) {
					win.find('#border').value(removePixelSuffix(css['border-width']));
				}
	
				win.find('#style').value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
			}
	
			if (editor.settings.image_advtab) {
				// Parse styles from img
				if (imgElm) {
					if (imgElm.style.marginLeft && imgElm.style.marginRight && imgElm.style.marginLeft === imgElm.style.marginRight) {
						data.hspace = removePixelSuffix(imgElm.style.marginLeft);
					}
					if (imgElm.style.marginTop && imgElm.style.marginBottom && imgElm.style.marginTop === imgElm.style.marginBottom) {
						data.vspace = removePixelSuffix(imgElm.style.marginTop);
					}
					if (imgElm.style.borderWidth) {
						data.border = removePixelSuffix(imgElm.style.borderWidth);
					}
	
					data.style = editor.dom.serializeStyle(editor.dom.parseStyle(editor.dom.getAttrib(imgElm, 'style')));
				}
	
				// Create empty element to bypass logic bound to editor.windowManager.open
				win = editor.windowManager.open({}).close();
				// Advanced dialog shows general+advanced tabs
	
				// Shows an external Dialog
				editor.namespaced.showImageDialog({
					title: 'Insert/edit image',
					data: data,
					bodyType: 'tabpanel',
					body: [{
						title: 'General',
						type: 'form',
						items: generalFormItems
					}, {
						title: 'Advanced',
						type: 'form',
						pack: 'start',
						items: [{
							label: 'Style',
							name: 'style',
							type: 'textbox',
							onchange: updateVSpaceHSpaceBorder
						}, {
							type: 'form',
							layout: 'grid',
							packV: 'start',
							columns: 2,
							padding: 0,
							alignH: ['left', 'right'],
							defaults: {
								type: 'textbox',
								maxWidth: 50,
								onchange: updateStyle
							},
							items: [{ label: 'Vertical space', name: 'vspace' }, { label: 'Horizontal space', name: 'hspace' }, { label: 'Border', name: 'border' }]
						}]
					}],
					onSubmit: onSubmitForm
				});
			} else {
				// Simple default dialog
				editor.namespaced.showImageDialog({
					title: 'Insert/edit image',
					data: data,
					body: generalFormItems,
					onSubmit: onSubmitForm
				});
			}
		}
	
		editor.on('preInit', function () {
			function hasImageClass(node) {
				var className = node.attr('class');
				return className && /\bimage\b/.test(className);
			}
	
			function toggleContentEditableState(state) {
				return function (nodes) {
					var i = nodes.length,
					    node;
	
					function toggleContentEditable(node) {
						node.attr('contenteditable', state ? 'true' : null);
					}
	
					while (i--) {
						node = nodes[i];
	
						if (hasImageClass(node)) {
							node.attr('contenteditable', state ? 'false' : null);
							tinymce.each(node.getAll('figcaption'), toggleContentEditable);
						}
					}
				};
			}
	
			editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
			editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
		});
	
		editor.addButton('image', {
			icon: 'image',
			tooltip: 'Insert/edit image',
			onclick: createImageList(showDialog),
			stateSelector: 'img:not([data-mce-object],[data-mce-placeholder]),figure.image'
		});
	
		editor.addMenuItem('image', {
			icon: 'image',
			text: 'Insert/edit image',
			onclick: createImageList(showDialog),
			context: 'insert',
			prependToContext: true
		});
	
		editor.addCommand('mceImage', createImageList(showDialog));
	});

/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/* global tinymce:true */
	
	'use strict';
	
	tinymce.PluginManager.add('link', function (editor) {
		function createLinkList(callback) {
			return function () {
				var linkList = editor.settings.link_list;
	
				if (typeof linkList === 'string') {
					tinymce.util.XHR.send({
						url: linkList,
						success: function success(text) {
							callback(tinymce.util.JSON.parse(text));
						}
					});
				} else if (typeof linkList === 'function') {
					linkList(callback);
				} else {
					callback(linkList);
				}
			};
		}
	
		function buildListItems(inputList, itemCallback, startItems) {
			function appendItems(values, output) {
				output = output || [];
	
				tinymce.each(values, function (item) {
					var menuItem = { text: item.text || item.title };
	
					if (item.menu) {
						menuItem.menu = appendItems(item.menu);
					} else {
						menuItem.value = item.value;
	
						if (itemCallback) {
							itemCallback(menuItem);
						}
					}
	
					output.push(menuItem);
				});
	
				return output;
			}
	
			return appendItems(inputList, startItems || []);
		}
	
		function showDialog(linkList) {
			var data = {},
			    selection = editor.selection,
			    dom = editor.dom,
			    selectedElm,
			    anchorElm,
			    initialText;
			var win, onlyText, textListCtrl, linkListCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;
	
			function linkListChangeHandler(e) {
				var textCtrl = win.find('#text');
	
				if (!textCtrl.value() || e.lastControl && textCtrl.value() == e.lastControl.text()) {
					textCtrl.value(e.control.text());
				}
	
				win.find('#href').value(e.control.value());
			}
	
			function buildAnchorListControl(url) {
				var anchorList = [];
	
				tinymce.each(editor.dom.select('a:not([href])'), function (anchor) {
					var id = anchor.name || anchor.id;
	
					if (id) {
						anchorList.push({
							text: id,
							value: '#' + id,
							selected: url.indexOf('#' + id) != -1
						});
					}
				});
	
				if (anchorList.length) {
					anchorList.unshift({ text: 'None', value: '' });
	
					return {
						name: 'anchor',
						type: 'listbox',
						label: 'Anchors',
						values: anchorList,
						onselect: linkListChangeHandler
					};
				}
			}
	
			function updateText() {
				if (!initialText && data.text.length === 0 && onlyText) {
					this.parent().parent().find('#text')[0].value(this.value());
				}
			}
	
			function urlChange(e) {
				var meta = e.meta || {};
	
				if (linkListCtrl) {
					linkListCtrl.value(editor.convertURL(this.value(), 'href'));
				}
	
				tinymce.each(e.meta, function (value, key) {
					win.find('#' + key).value(value);
				});
	
				if (!meta.text) {
					updateText.call(this);
				}
			}
	
			function isOnlyTextSelected(anchorElm) {
				var html = selection.getContent();
	
				// Partial html and not a fully selected anchor element
				if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') == -1)) {
					return false;
				}
	
				if (anchorElm) {
					var nodes = anchorElm.childNodes,
					    i;
	
					if (nodes.length === 0) {
						return false;
					}
	
					for (i = nodes.length - 1; i >= 0; i--) {
						if (nodes[i].nodeType != 3) {
							return false;
						}
					}
				}
	
				return true;
			}
	
			selectedElm = selection.getNode();
			anchorElm = dom.getParent(selectedElm, 'a[href]');
			onlyText = isOnlyTextSelected();
	
			data.text = initialText = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
			data.href = anchorElm ? dom.getAttrib(anchorElm, 'href') : '';
	
			if (anchorElm) {
				data.target = dom.getAttrib(anchorElm, 'target');
			} else if (editor.settings.default_link_target) {
				data.target = editor.settings.default_link_target;
			}
	
			if (value = dom.getAttrib(anchorElm, 'rel')) {
				data.rel = value;
			}
	
			if (value = dom.getAttrib(anchorElm, 'class')) {
				data['class'] = value;
			}
	
			if (value = dom.getAttrib(anchorElm, 'title')) {
				data.title = value;
			}
	
			if (onlyText) {
				textListCtrl = {
					name: 'text',
					type: 'textbox',
					size: 40,
					label: 'Text to display',
					onchange: function onchange() {
						data.text = this.value();
					}
				};
			}
	
			if (linkList) {
				linkListCtrl = {
					type: 'listbox',
					label: 'Link list',
					values: buildListItems(linkList, function (item) {
						item.value = editor.convertURL(item.value || item.url, 'href');
					}, [{ text: 'None', value: '' }]),
					onselect: linkListChangeHandler,
					value: editor.convertURL(data.href, 'href'),
					onPostRender: function onPostRender() {
						/*eslint consistent-this:0*/
						linkListCtrl = this;
					}
				};
			}
	
			if (editor.settings.target_list !== false) {
				if (!editor.settings.target_list) {
					editor.settings.target_list = [{ text: 'None', value: '' }, { text: 'New window', value: '_blank' }];
				}
	
				targetListCtrl = {
					name: 'target',
					type: 'listbox',
					label: 'Target',
					values: buildListItems(editor.settings.target_list)
				};
			}
	
			if (editor.settings.rel_list) {
				relListCtrl = {
					name: 'rel',
					type: 'listbox',
					label: 'Rel',
					values: buildListItems(editor.settings.rel_list)
				};
			}
	
			if (editor.settings.link_class_list) {
				classListCtrl = {
					name: 'class',
					type: 'listbox',
					label: 'Class',
					values: buildListItems(editor.settings.link_class_list, function (item) {
						if (item.value) {
							item.textStyle = function () {
								return editor.formatter.getCssText({ inline: 'a', classes: [item.value] });
							};
						}
					})
				};
			}
	
			if (editor.settings.link_title !== false) {
				linkTitleCtrl = {
					name: 'title',
					type: 'textbox',
					label: 'Title',
					value: data.title
				};
			}
	
			// win = editor.windowManager.open();
			// Shows an external Dialog
			editor.namespaced.showLinkDialog({
				title: 'Insert link',
				data: data,
				body: [{
					name: 'href',
					type: 'filepicker',
					filetype: 'file',
					size: 40,
					autofocus: true,
					label: 'Url',
					onchange: urlChange,
					onkeyup: updateText
				}, textListCtrl, linkTitleCtrl, buildAnchorListControl(data.href), linkListCtrl, relListCtrl, targetListCtrl, classListCtrl],
				onSubmit: function onSubmit(e) {
					/*eslint dot-notation: 0*/
					var href;
	
					data = tinymce.extend(data, e.data);
					href = data.href;
	
					// Delay confirm since onSubmit will move focus
					function delayedConfirm(message, callback) {
						var rng = editor.selection.getRng();
	
						tinymce.util.Delay.setEditorTimeout(editor, function () {
							editor.windowManager.confirm(message, function (state) {
								editor.selection.setRng(rng);
								callback(state);
							});
						});
					}
	
					function insertLink() {
						var linkAttrs = {
							href: href,
							target: data.target ? data.target : null,
							rel: data.rel ? data.rel : null,
							"class": data["class"] ? data["class"] : null,
							title: data.title ? data.title : null
						};
	
						if (anchorElm) {
							editor.focus();
	
							if (onlyText && data.text != initialText) {
								if ("innerText" in anchorElm) {
									anchorElm.innerText = data.text;
								} else {
									anchorElm.textContent = data.text;
								}
							}
	
							dom.setAttribs(anchorElm, linkAttrs);
	
							selection.select(anchorElm);
							editor.undoManager.add();
						} else {
							if (onlyText) {
								editor.insertContent(dom.createHTML('a', linkAttrs, dom.encode(data.text)));
							} else {
								editor.execCommand('mceInsertLink', false, linkAttrs);
							}
						}
					}
	
					if (!href) {
						editor.execCommand('unlink');
						return;
					}
	
					// Is email and not //user@domain.com
					if (href.indexOf('@') > 0 && href.indexOf('//') == -1 && href.indexOf('mailto:') == -1) {
						delayedConfirm('The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?', function (state) {
							if (state) {
								href = 'mailto:' + href;
							}
	
							insertLink();
						});
	
						return;
					}
	
					// Is not protocol prefixed
					if (editor.settings.link_assume_external_targets && !/^\w+:/i.test(href) || !editor.settings.link_assume_external_targets && /^\s*www[\.|\d\.]/i.test(href)) {
						delayedConfirm('The URL you entered seems to be an external link. Do you want to add the required http:// prefix?', function (state) {
							if (state) {
								href = 'http://' + href;
							}
	
							insertLink();
						});
	
						return;
					}
	
					insertLink();
				}
			});
		}
	
		this.showDialog = showDialog;
	
		editor.addShortcut('Meta+K', '', createLinkList(showDialog));
		editor.addCommand('mceLink', createLinkList(showDialog));
	
		editor.addButton('link', {
			icon: 'link',
			tooltip: 'Insert/edit link',
			shortcut: 'Meta+K',
			onclick: createLinkList(showDialog),
			stateSelector: 'a[href]'
		});
	
		editor.addButton('unlink', {
			icon: 'unlink',
			tooltip: 'Remove link',
			cmd: 'unlink',
			stateSelector: 'a[href]'
		});
	
		editor.addMenuItem('link', {
			icon: 'link',
			text: 'Insert/edit link',
			shortcut: 'Meta+K',
			onclick: createLinkList(showDialog),
			stateSelector: 'a[href]',
			context: 'insert',
			prependToContext: true
		});
	});

/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/* jshint maxlen:255 */
	/* eslint max-len:0 */
	/* global tinymce:true */
	
	'use strict';
	
	tinymce.PluginManager.add('media', function (editor, url) {
		var urlPatterns = [{ regex: /youtu\.be\/([\w\-.]+)/, type: 'iframe', w: 560, h: 314, url: '//www.youtube.com/embed/$1', allowFullscreen: true }, { regex: /youtube\.com(.+)v=([^&]+)/, type: 'iframe', w: 560, h: 314, url: '//www.youtube.com/embed/$2', allowFullscreen: true }, { regex: /youtube.com\/embed\/([a-z0-9\-_]+(?:\?.+)?)/i, type: 'iframe', w: 560, h: 314, url: '//www.youtube.com/embed/$1', allowFullscreen: true }, { regex: /vimeo\.com\/([0-9]+)/, type: 'iframe', w: 425, h: 350, url: '//player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc', allowfullscreen: true }, { regex: /vimeo\.com\/(.*)\/([0-9]+)/, type: "iframe", w: 425, h: 350, url: "//player.vimeo.com/video/$2?title=0&amp;byline=0", allowfullscreen: true }, { regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/, type: 'iframe', w: 425, h: 350, url: '//maps.google.com/maps/ms?msid=$2&output=embed"', allowFullscreen: false }, { regex: /dailymotion\.com\/video\/([^_]+)/, type: 'iframe', w: 480, h: 270, url: '//www.dailymotion.com/embed/video/$1', allowFullscreen: true }];
	
		var embedChange = tinymce.Env.ie && tinymce.Env.ie <= 8 ? 'onChange' : 'onInput';
	
		function guessMime(url) {
			url = url.toLowerCase();
	
			if (url.indexOf('.mp3') != -1) {
				return 'audio/mpeg';
			}
	
			if (url.indexOf('.wav') != -1) {
				return 'audio/wav';
			}
	
			if (url.indexOf('.mp4') != -1) {
				return 'video/mp4';
			}
	
			if (url.indexOf('.webm') != -1) {
				return 'video/webm';
			}
	
			if (url.indexOf('.ogg') != -1) {
				return 'video/ogg';
			}
	
			if (url.indexOf('.swf') != -1) {
				return 'application/x-shockwave-flash';
			}
	
			return '';
		}
	
		function getVideoScriptMatch(src) {
			var prefixes = editor.settings.media_scripts;
	
			if (prefixes) {
				for (var i = 0; i < prefixes.length; i++) {
					if (src.indexOf(prefixes[i].filter) !== -1) {
						return prefixes[i];
					}
				}
			}
		}
	
		function showDialog() {
			var win, width, height, data;
	
			var generalFormItems = [{
				name: 'source1',
				type: 'filepicker',
				filetype: 'media',
				size: 40,
				autofocus: true,
				label: 'Source',
				onchange: function onchange(e) {
					tinymce.each(e.meta, function (value, key) {
						win.find('#' + key).value(value);
					});
				}
			}];
	
			function recalcSize(e) {
				var widthCtrl, heightCtrl, newWidth, newHeight;
	
				widthCtrl = win.find('#width')[0];
				heightCtrl = win.find('#height')[0];
	
				newWidth = widthCtrl.value();
				newHeight = heightCtrl.value();
	
				if (win.find('#constrain')[0].checked() && width && height && newWidth && newHeight) {
					if (e.control == widthCtrl) {
						newHeight = Math.round(newWidth / width * newHeight);
	
						if (!isNaN(newHeight)) {
							heightCtrl.value(newHeight);
						}
					} else {
						newWidth = Math.round(newHeight / height * newWidth);
	
						if (!isNaN(newWidth)) {
							widthCtrl.value(newWidth);
						}
					}
				}
	
				width = newWidth;
				height = newHeight;
			}
	
			if (editor.settings.media_alt_source !== false) {
				generalFormItems.push({ name: 'source2', type: 'filepicker', filetype: 'media', size: 40, label: 'Alternative source' });
			}
	
			if (editor.settings.media_poster !== false) {
				generalFormItems.push({ name: 'poster', type: 'filepicker', filetype: 'image', size: 40, label: 'Poster' });
			}
	
			if (editor.settings.media_dimensions !== false) {
				generalFormItems.push({
					type: 'container',
					label: 'Dimensions',
					layout: 'flex',
					align: 'center',
					spacing: 5,
					items: [{ name: 'width', type: 'textbox', maxLength: 5, size: 3, onchange: recalcSize, ariaLabel: 'Width' }, { type: 'label', text: 'x' }, { name: 'height', type: 'textbox', maxLength: 5, size: 3, onchange: recalcSize, ariaLabel: 'Height' }, { name: 'constrain', type: 'checkbox', checked: true, text: 'Constrain proportions' }]
				});
			}
	
			data = getData(editor.selection.getNode());
			width = data.width;
			height = data.height;
	
			var embedTextBox = {
				id: 'mcemediasource',
				type: 'textbox',
				flex: 1,
				name: 'embed',
				value: getSource(),
				multiline: true,
				label: 'Source'
			};
	
			function updateValueOnChange() {
				data = htmlToData(this.value());
				this.parent().parent().fromJSON(data);
			}
	
			embedTextBox[embedChange] = updateValueOnChange;
	
			//
			editor.namespaced.getMediaData = getData;
			editor.namespaced.getMediaHTML = dataToHtml;
	
			// win = editor.windowManager.open(
			// Shows an external Dialog
			editor.namespaced.showMediaDialog({
				title: 'Insert/edit video',
				data: data,
				bodyType: 'tabpanel',
				body: [{
					title: 'General',
					type: "form",
					onShowTab: function onShowTab() {
						data = htmlToData(this.next().find('#embed').value());
						this.fromJSON(data);
					},
					items: generalFormItems
				}, {
					title: 'Embed',
					type: "container",
					layout: 'flex',
					direction: 'column',
					align: 'stretch',
					padding: 10,
					spacing: 10,
					onShowTab: function onShowTab() {
						this.find('#embed').value(dataToHtml(this.parent().toJSON()));
					},
					items: [{
						type: 'label',
						text: 'Paste your embed code below:',
						forId: 'mcemediasource'
					}, embedTextBox]
				}],
				onSubmit: function onSubmit(e) {
					var beforeObjects, afterObjects, i, y;
	
					var info = {
						'source1': e.data.source,
						'source2': '',
						'poster': '',
						'embed': e.data.embed,
						'width': e.data.width || '',
						'height': e.data.height || '',
						'constrain': true
					};
	
					beforeObjects = editor.dom.select('img[data-mce-object]');
					// editor.insertContent(dataToHtml(this.toJSON()));
					editor.insertContent(dataToHtml(info));
					afterObjects = editor.dom.select('img[data-mce-object]');
	
					// Find new image placeholder so we can select it
					for (i = 0; i < beforeObjects.length; i++) {
						for (y = afterObjects.length - 1; y >= 0; y--) {
							if (beforeObjects[i] == afterObjects[y]) {
								afterObjects.splice(y, 1);
							}
						}
					}
	
					editor.selection.select(afterObjects[0]);
					editor.nodeChanged();
				}
			});
		}
	
		function getSource() {
			var elm = editor.selection.getNode();
	
			if (elm.getAttribute('data-mce-object')) {
				return editor.selection.getContent();
			}
		}
	
		function dataToHtml(data) {
			var html = '';
	
			if (!data.source1) {
				tinymce.extend(data, htmlToData(data.embed));
				if (!data.source1) {
					return '';
				}
			}
	
			if (!data.source2) {
				data.source2 = '';
			}
	
			if (!data.poster) {
				data.poster = '';
			}
	
			data.source1 = editor.convertURL(data.source1, "source");
			data.source2 = editor.convertURL(data.source2, "source");
			data.source1mime = guessMime(data.source1);
			data.source2mime = guessMime(data.source2);
			data.poster = editor.convertURL(data.poster, "poster");
			data.flashPlayerUrl = editor.convertURL(url + '/moxieplayer.swf', "movie");
	
			tinymce.each(urlPatterns, function (pattern) {
				var match, i, url;
	
				if (match = pattern.regex.exec(data.source1)) {
					url = pattern.url;
	
					for (i = 0; match[i]; i++) {
						/*jshint loopfunc:true*/
						/*eslint no-loop-func:0 */
						url = url.replace('$' + i, function () {
							return match[i];
						});
					}
	
					data.source1 = url;
					data.type = pattern.type;
					data.allowFullscreen = pattern.allowFullscreen;
					data.width = data.width || pattern.w;
					data.height = data.height || pattern.h;
				}
			});
	
			if (data.embed) {
				html = updateHtml(data.embed, data, true);
			} else {
				var videoScript = getVideoScriptMatch(data.source1);
				if (videoScript) {
					data.type = 'script';
					data.width = videoScript.width;
					data.height = videoScript.height;
				}
	
				data.width = data.width || 300;
				data.height = data.height || 150;
	
				tinymce.each(data, function (value, key) {
					data[key] = editor.dom.encode(value);
				});
	
				if (data.type == "iframe") {
					var allowFullscreen = data.allowFullscreen ? ' allowFullscreen="1"' : '';
					html += '<iframe src="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
				} else if (data.source1mime == "application/x-shockwave-flash") {
					html += '<object data="' + data.source1 + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
	
					if (data.poster) {
						html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
					}
	
					html += '</object>';
				} else if (data.source1mime.indexOf('audio') != -1) {
					if (editor.settings.audio_template_callback) {
						html = editor.settings.audio_template_callback(data);
					} else {
						html += '<audio controls="controls" src="' + data.source1 + '">' + (data.source2 ? '\n<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</audio>';
					}
				} else if (data.type == "script") {
					html += '<script src="' + data.source1 + '"></script>';
				} else {
					if (editor.settings.video_template_callback) {
						html = editor.settings.video_template_callback(data);
					} else {
						html = '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source1 + '"' + (data.source1mime ? ' type="' + data.source1mime + '"' : '') + ' />\n' + (data.source2 ? '<source src="' + data.source2 + '"' + (data.source2mime ? ' type="' + data.source2mime + '"' : '') + ' />\n' : '') + '</video>';
					}
				}
			}
	
			return html;
		}
	
		function htmlToData(html) {
			var data = {};
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: true,
				special: 'script,noscript',
				start: function start(name, attrs) {
					if (!data.source1 && name == "param") {
						data.source1 = attrs.map.movie;
					}
	
					if (name == "iframe" || name == "object" || name == "embed" || name == "video" || name == "audio") {
						if (!data.type) {
							data.type = name;
						}
	
						data = tinymce.extend(attrs.map, data);
					}
	
					if (name == "script") {
						var videoScript = getVideoScriptMatch(attrs.map.src);
						if (!videoScript) {
							return;
						}
	
						data = {
							type: "script",
							source1: attrs.map.src,
							width: videoScript.width,
							height: videoScript.height
						};
					}
	
					if (name == "source") {
						if (!data.source1) {
							data.source1 = attrs.map.src;
						} else if (!data.source2) {
							data.source2 = attrs.map.src;
						}
					}
	
					if (name == "img" && !data.poster) {
						data.poster = attrs.map.src;
					}
				}
			}).parse(html);
	
			data.source1 = data.source1 || data.src || data.data;
			data.source2 = data.source2 || '';
			data.poster = data.poster || '';
	
			return data;
		}
	
		function getData(element) {
			if (element.getAttribute('data-mce-object')) {
				return htmlToData(editor.serializer.serialize(element, { selection: true }));
			}
	
			return {};
		}
	
		function sanitize(html) {
			if (editor.settings.media_filter_html === false) {
				return html;
			}
	
			var writer = new tinymce.html.Writer(),
			    blocked;
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: false,
				special: 'script,noscript',
	
				comment: function comment(text) {
					writer.comment(text);
				},
	
				cdata: function cdata(text) {
					writer.cdata(text);
				},
	
				text: function text(_text, raw) {
					writer.text(_text, raw);
				},
	
				start: function start(name, attrs, empty) {
					blocked = true;
	
					if (name == 'script' || name == 'noscript') {
						return;
					}
	
					for (var i = 0; i < attrs.length; i++) {
						if (attrs[i].name.indexOf('on') === 0) {
							return;
						}
	
						if (attrs[i].name == 'style') {
							attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
						}
					}
	
					writer.start(name, attrs, empty);
					blocked = false;
				},
	
				end: function end(name) {
					if (blocked) {
						return;
					}
	
					writer.end(name);
				}
			}, new tinymce.html.Schema({})).parse(html);
	
			return writer.getContent();
		}
	
		function updateHtml(html, data, updateAll) {
			var writer = new tinymce.html.Writer();
			var sourceCount = 0,
			    hasImage;
	
			function setAttributes(attrs, updatedAttrs) {
				var name, i, value, attr;
	
				for (name in updatedAttrs) {
					value = "" + updatedAttrs[name];
	
					if (attrs.map[name]) {
						i = attrs.length;
						while (i--) {
							attr = attrs[i];
	
							if (attr.name == name) {
								if (value) {
									attrs.map[name] = value;
									attr.value = value;
								} else {
									delete attrs.map[name];
									attrs.splice(i, 1);
								}
							}
						}
					} else if (value) {
						attrs.push({
							name: name,
							value: value
						});
	
						attrs.map[name] = value;
					}
				}
			}
	
			new tinymce.html.SaxParser({
				validate: false,
				allow_conditional_comments: true,
				special: 'script,noscript',
	
				comment: function comment(text) {
					writer.comment(text);
				},
	
				cdata: function cdata(text) {
					writer.cdata(text);
				},
	
				text: function text(_text2, raw) {
					writer.text(_text2, raw);
				},
	
				start: function start(name, attrs, empty) {
					switch (name) {
						case "video":
						case "object":
						case "embed":
						case "img":
						case "iframe":
							setAttributes(attrs, {
								width: data.width,
								height: data.height
							});
							break;
					}
	
					if (updateAll) {
						switch (name) {
							case "video":
								setAttributes(attrs, {
									poster: data.poster,
									src: ""
								});
	
								if (data.source2) {
									setAttributes(attrs, {
										src: ""
									});
								}
								break;
	
							case "iframe":
								setAttributes(attrs, {
									src: data.source1
								});
								break;
	
							case "source":
								sourceCount++;
	
								if (sourceCount <= 2) {
									setAttributes(attrs, {
										src: data["source" + sourceCount],
										type: data["source" + sourceCount + "mime"]
									});
	
									if (!data["source" + sourceCount]) {
										return;
									}
								}
								break;
	
							case "img":
								if (!data.poster) {
									return;
								}
	
								hasImage = true;
								break;
						}
					}
	
					writer.start(name, attrs, empty);
				},
	
				end: function end(name) {
					if (name == "video" && updateAll) {
						for (var index = 1; index <= 2; index++) {
							if (data["source" + index]) {
								var attrs = [];
								attrs.map = {};
	
								if (sourceCount < index) {
									setAttributes(attrs, {
										src: data["source" + index],
										type: data["source" + index + "mime"]
									});
	
									writer.start("source", attrs, true);
								}
							}
						}
					}
	
					if (data.poster && name == "object" && updateAll && !hasImage) {
						var imgAttrs = [];
						imgAttrs.map = {};
	
						setAttributes(imgAttrs, {
							src: data.poster,
							width: data.width,
							height: data.height
						});
	
						writer.start("img", imgAttrs, true);
					}
	
					writer.end(name);
				}
			}, new tinymce.html.Schema({})).parse(html);
	
			return writer.getContent();
		}
	
		editor.on('ResolveName', function (e) {
			var name;
	
			if (e.target.nodeType == 1 && (name = e.target.getAttribute("data-mce-object"))) {
				e.name = name;
			}
		});
	
		function retainAttributesAndInnerHtml(sourceNode, targetNode) {
			var attrName, attrValue, attribs, ai, innerHtml;
	
			// Prefix all attributes except width, height and style since we
			// will add these to the placeholder
			attribs = sourceNode.attributes;
			ai = attribs.length;
			while (ai--) {
				attrName = attribs[ai].name;
				attrValue = attribs[ai].value;
	
				if (attrName !== "width" && attrName !== "height" && attrName !== "style") {
					if (attrName == "data" || attrName == "src") {
						attrValue = editor.convertURL(attrValue, attrName);
					}
	
					targetNode.attr('data-mce-p-' + attrName, attrValue);
				}
			}
	
			// Place the inner HTML contents inside an escaped attribute
			// This enables us to copy/paste the fake object
			innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
			if (innerHtml) {
				targetNode.attr("data-mce-html", escape(innerHtml));
				targetNode.firstChild = null;
			}
		}
	
		function createPlaceholderNode(node) {
			var placeHolder,
			    name = node.name;
	
			placeHolder = new tinymce.html.Node('img', 1);
			placeHolder.shortEnded = true;
	
			retainAttributesAndInnerHtml(node, placeHolder);
	
			placeHolder.attr({
				width: node.attr('width') || "300",
				height: node.attr('height') || (name == "audio" ? "30" : "150"),
				style: node.attr('style'),
				src: tinymce.Env.transparentSrc,
				"data-mce-object": name,
				"class": "mce-object mce-object-" + name
			});
	
			return placeHolder;
		}
	
		function createPreviewNode(node) {
			var previewWrapper,
			    previewNode,
			    shimNode,
			    name = node.name;
	
			previewWrapper = new tinymce.html.Node('span', 1);
			previewWrapper.attr({
				contentEditable: 'false',
				style: node.attr('style'),
				"data-mce-object": name,
				"class": "mce-preview-object mce-object-" + name
			});
	
			retainAttributesAndInnerHtml(node, previewWrapper);
	
			previewNode = new tinymce.html.Node(name, 1);
			previewNode.attr({
				src: node.attr('src'),
				allowfullscreen: node.attr('allowfullscreen'),
				width: node.attr('width') || "300",
				height: node.attr('height') || (name == "audio" ? "30" : "150"),
				frameborder: '0'
			});
	
			shimNode = new tinymce.html.Node('span', 1);
			shimNode.attr('class', 'mce-shim');
	
			previewWrapper.append(previewNode);
			previewWrapper.append(shimNode);
	
			return previewWrapper;
		}
	
		editor.on('preInit', function () {
			// Make sure that any messy HTML is retained inside these
			var specialElements = editor.schema.getSpecialElements();
			tinymce.each('video audio iframe object'.split(' '), function (name) {
				specialElements[name] = new RegExp('<\/' + name + '[^>]*>', 'gi');
			});
	
			// Allow elements
			//editor.schema.addValidElements('object[id|style|width|height|classid|codebase|*],embed[id|style|width|height|type|src|*],video[*],audio[*]');
	
			// Set allowFullscreen attribs as boolean
			var boolAttrs = editor.schema.getBoolAttrs();
			tinymce.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
				boolAttrs[name] = {};
			});
	
			// Converts iframe, video etc into placeholder images
			editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', function (nodes) {
				var i = nodes.length,
				    node,
				    placeHolder,
				    videoScript;
	
				while (i--) {
					node = nodes[i];
					if (!node.parent) {
						continue;
					}
	
					if (node.parent.attr('data-mce-object')) {
						continue;
					}
	
					if (node.name == 'script') {
						videoScript = getVideoScriptMatch(node.attr('src'));
						if (!videoScript) {
							continue;
						}
					}
	
					if (videoScript) {
						if (videoScript.width) {
							node.attr('width', videoScript.width.toString());
						}
	
						if (videoScript.height) {
							node.attr('height', videoScript.height.toString());
						}
					}
	
					if (node.name == 'iframe' && editor.settings.media_live_embeds !== false && tinymce.Env.ceFalse) {
						placeHolder = createPreviewNode(node);
					} else {
						placeHolder = createPlaceholderNode(node);
					}
	
					node.replace(placeHolder);
				}
			});
	
			// Replaces placeholder images with real elements for video, object, iframe etc
			editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
				var i = nodes.length,
				    node,
				    realElm,
				    ai,
				    attribs,
				    innerHtml,
				    innerNode,
				    realElmName,
				    className;
	
				while (i--) {
					node = nodes[i];
					if (!node.parent) {
						continue;
					}
	
					realElmName = node.attr(name);
					realElm = new tinymce.html.Node(realElmName, 1);
	
					// Add width/height to everything but audio
					if (realElmName != "audio" && realElmName != "script") {
						className = node.attr('class');
						if (className && className.indexOf('mce-preview-object') !== -1) {
							realElm.attr({
								width: node.firstChild.attr('width'),
								height: node.firstChild.attr('height')
							});
						} else {
							realElm.attr({
								width: node.attr('width'),
								height: node.attr('height')
							});
						}
					}
	
					realElm.attr({
						style: node.attr('style')
					});
	
					// Unprefix all placeholder attributes
					attribs = node.attributes;
					ai = attribs.length;
					while (ai--) {
						var attrName = attribs[ai].name;
	
						if (attrName.indexOf('data-mce-p-') === 0) {
							realElm.attr(attrName.substr(11), attribs[ai].value);
						}
					}
	
					if (realElmName == "script") {
						realElm.attr('type', 'text/javascript');
					}
	
					// Inject innerhtml
					innerHtml = node.attr('data-mce-html');
					if (innerHtml) {
						innerNode = new tinymce.html.Node('#text', 3);
						innerNode.raw = true;
						innerNode.value = sanitize(unescape(innerHtml));
						realElm.append(innerNode);
					}
	
					node.replace(realElm);
				}
			});
		});
	
		editor.on('click keyup', function () {
			var selectedNode = editor.selection.getNode();
	
			if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
				if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
					selectedNode.setAttribute('data-mce-selected', '2');
				}
			}
		});
	
		editor.on('ObjectSelected', function (e) {
			var objectType = e.target.getAttribute('data-mce-object');
	
			if (objectType == "audio" || objectType == "script") {
				e.preventDefault();
			}
		});
	
		editor.on('objectResized', function (e) {
			var target = e.target,
			    html;
	
			if (target.getAttribute('data-mce-object')) {
				html = target.getAttribute('data-mce-html');
				if (html) {
					html = unescape(html);
					target.setAttribute('data-mce-html', escape(updateHtml(html, {
						width: e.width,
						height: e.height
					})));
				}
			}
		});
	
		editor.addButton('media', {
			tooltip: 'Insert/edit video',
			onclick: showDialog,
			stateSelector: ['img[data-mce-object]', 'span[data-mce-object]']
		});
	
		editor.addMenuItem('media', {
			icon: 'media',
			text: 'Insert/edit video',
			onclick: showDialog,
			context: 'insert',
			prependToContext: true
		});
	
		editor.on('setContent', function () {
			// TODO: This shouldn't be needed there should be a way to mark bogus
			// elements so they are never removed except external save
			editor.$('span.mce-preview-object').each(function (index, elm) {
				var $elm = editor.$(elm);
	
				if ($elm.find('span.mce-shim', elm).length === 0) {
					$elm.append('<span class="mce-shim"></span>');
				}
			});
		});
	
		editor.addCommand('mceMedia', showDialog);
	
		this.showDialog = showDialog;
	});

/***/ },
/* 245 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 246 */
245,
/* 247 */
245,
/* 248 */
245,
/* 249 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(159);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3['default'])(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3['default'])(this, Accordion);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2['default'].createElement(
	      _PanelGroup2['default'],
	      (0, _extends3['default'])({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2['default'].Component);
	
	exports['default'] = Accordion;
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onDismiss: _react2['default'].PropTypes.func,
	  closeLabel: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3['default'])(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3['default'])(this, Alert);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.renderDismissButton = function renderDismissButton(onDismiss) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onDismiss,
	        'aria-hidden': 'true',
	        tabIndex: '-1'
	      },
	      _react2['default'].createElement(
	        'span',
	        null,
	        '×'
	      )
	    );
	  };
	
	  Alert.prototype.renderSrOnlyDismissButton = function renderSrOnlyDismissButton(onDismiss, closeLabel) {
	    return _react2['default'].createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close sr-only',
	        onClick: onDismiss
	      },
	      closeLabel
	    );
	  };
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var onDismiss = _props.onDismiss;
	    var closeLabel = _props.closeLabel;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      dismissable && this.renderDismissButton(onDismiss),
	      children,
	      dismissable && this.renderSrOnlyDismissButton(onDismiss, closeLabel)
	    );
	  };
	
	  return Alert;
	}(_react2['default'].Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3['default'])(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3['default'])(this, Badge);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props;
	    var pullRight = _props.pullRight;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2['default'].Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(144);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3['default'])(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ol', (0, _extends3['default'])({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2['default'].Component);
	
	Breadcrumb.Item = _BreadcrumbItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(52);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3['default'])(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3['default'])(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('btn-toolbar', (0, _bootstrapUtils.bsSizes)(_Button2['default'].SIZES, ButtonToolbar));
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CarouselCaption = __webpack_require__(256);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(146);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(91);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _react2['default'].PropTypes.bool,
	  indicators: _react2['default'].PropTypes.bool,
	  interval: _react2['default'].PropTypes.number,
	  controls: _react2['default'].PropTypes.bool,
	  pauseOnHover: _react2['default'].PropTypes.bool,
	  wrap: _react2['default'].PropTypes.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _react2['default'].PropTypes.func,
	  onSlideEnd: _react2['default'].PropTypes.func,
	  activeIndex: _react2['default'].PropTypes.number,
	  defaultActiveIndex: _react2['default'].PropTypes.number,
	  direction: _react2['default'].PropTypes.oneOf(['prev', 'next']),
	  prevIcon: _react2['default'].PropTypes.node,
	  nextIcon: _react2['default'].PropTypes.node
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-left' }),
	  nextIcon: _react2['default'].createElement(_Glyphicon2['default'], { glyph: 'chevron-right' })
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3['default'])(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3['default'])(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	  };
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2['default'].count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2['default'].count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.getActiveIndex();
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props;
	    var slide = _props.slide;
	    var interval = _props.interval;
	    var activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2['default'].forEach(children, function (child, index) {
	      indicators.push(_react2['default'].createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2['default'].createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.renderControls = function renderControls(wrap, children, activeIndex, prevIcon, nextIcon, bsProps) {
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2['default'].count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'prev',
	        className: (0, _classnames2['default'])(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon
	    ), (wrap || activeIndex !== count - 1) && _react2['default'].createElement(
	      _SafeAnchor2['default'],
	      {
	        key: 'next',
	        className: (0, _classnames2['default'])(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon
	    )];
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props;
	    var slide = _props2.slide;
	    var indicators = _props2.indicators;
	    var controls = _props2.controls;
	    var wrap = _props2.wrap;
	    var prevIcon = _props2.prevIcon;
	    var nextIcon = _props2.nextIcon;
	    var className = _props2.className;
	    var children = _props2.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'nextIcon', 'className', 'children']);
	    var _state = this.state;
	    var previousActiveIndex = _state.previousActiveIndex;
	    var direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2['default'].map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls(wrap, children, activeIndex, prevIcon, nextIcon, bsProps)
	    );
	  };
	
	  return Carousel;
	}(_react2['default'].Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2['default'];
	Carousel.Item = _CarouselItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3['default'])(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3['default'])(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2['default'].Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props;
	    var inline = _props.inline;
	    var disabled = _props.disabled;
	    var validationState = _props.validationState;
	    var inputRef = _props.inputRef;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _capitalize = __webpack_require__(161);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _react2['default'].PropTypes.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3['default'])(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3['default'])(this, Clearfix);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2['default'])(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2['default'].Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _react2['default'].PropTypes.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _react2['default'].PropTypes.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _react2['default'].PropTypes.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _react2['default'].PropTypes.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _react2['default'].PropTypes.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _react2['default'].PropTypes.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3['default'])(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3['default'])(this, Col);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2['default'].Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _react2['default'].PropTypes.string,
	  srOnly: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3['default'])(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3['default'])(this, ControlLabel);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props;
	    var _props$htmlFor = _props.htmlFor;
	    var htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor;
	    var srOnly = _props.srOnly;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	     false ? (0, _warning2['default'])(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2['default'].createElement('label', (0, _extends3['default'])({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2['default'].Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(68);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(70);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3['default'])(this, DropdownButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props;
	    var bsSize = _props.bsSize;
	    var bsStyle = _props.bsStyle;
	    var title = _props.title;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent);
	
	    var dropdownProps = _splitComponentProps[0];
	    var toggleProps = _splitComponentProps[1];
	
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2['default'].Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports['default'] = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(315);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(113);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(183);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  open: _react2['default'].PropTypes.bool,
	  pullRight: _react2['default'].PropTypes.bool,
	  onClose: _react2['default'].PropTypes.func,
	  labelledBy: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2['default'].codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2['default'].codes.esc:
	      case _keycode2['default'].codes.tab:
	        this.props.onClose(event);
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2['default'].findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2['default'])(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveInd.items;
	    var activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex();
	
	    var items = _getItemsAndActiveInd2.items;
	    var activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props;
	    var open = _props.open;
	    var pullRight = _props.pullRight;
	    var onClose = _props.onClose;
	    var labelledBy = _props.labelledBy;
	    var onSelect = _props.onSelect;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['open', 'pullRight', 'onClose', 'labelledBy', 'onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    var list = _react2['default'].createElement(
	      'ul',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'menu',
	        className: (0, _classnames2['default'])(className, classes),
	        'aria-labelledby': labelledBy
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return _react2['default'].cloneElement(child, {
	          onKeyDown: (0, _createChainedFunction2['default'])(child.props.onKeyDown, _this2.handleKeyDown),
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	
	    if (open) {
	      return _react2['default'].createElement(
	        _RootCloseWrapper2['default'],
	        { noWrap: true, onRootClose: onClose },
	        list
	      );
	    }
	
	    return list;
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  horizontal: _react2['default'].PropTypes.bool,
	  inline: _react2['default'].PropTypes.bool,
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3['default'])(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3['default'])(this, Form);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props;
	    var horizontal = _props.horizontal;
	    var inline = _props.inline;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2['default'].Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(265);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(266);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _react2['default'].PropTypes.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _react2['default'].PropTypes.string
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3['default'])(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3['default'])(this, FormControl);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var type = _props.type;
	    var _props$id = _props.id;
	    var id = _props$id === undefined ? controlId : _props$id;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'type', 'id', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	     false ? (0, _warning2['default'])(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      type: type,
	      id: id,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2['default'].Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2['default'];
	FormControl.Static = _FormControlStatic2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control', FormControl);
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyphicon = __webpack_require__(91);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3['default'])(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2['default'].createElement(_Glyphicon2['default'], (0, _extends3['default'])({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2['default'].Children.only(children);
	    return _react2['default'].cloneElement(child, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2['default'].Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3['default'])(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3['default'])(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2['default'].Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _react2['default'].PropTypes.string,
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error'])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _react2['default'].PropTypes.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3['default'])(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3['default'])(this, FormGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var controlId = _props.controlId;
	    var validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2['default'].some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props;
	    var validationState = _props2.validationState;
	    var className = _props2.className;
	    var children = _props2.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2['default'].Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3['default'])(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3['default'])(this, HelpBlock);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _react2['default'].PropTypes.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3['default'])(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3['default'])(this, Image);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props;
	    var responsive = _props.responsive;
	    var rounded = _props.rounded;
	    var circle = _props.circle;
	    var thumbnail = _props.thumbnail;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2['default'].createElement('img', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2['default'].Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(271);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(272);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3['default'])(this, InputGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2['default'].Component);
	
	InputGroup.Addon = _InputGroupAddon2['default'];
	InputGroup.Button = _InputGroupButton2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3['default'])(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3['default'])(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3['default'])(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('span', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3['default'])(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3['default'])(this, Jumbotron);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2['default'].Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3['default'])(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3['default'])(this, Label);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(149);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2['default']
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2['default'].some(children, function (child) {
	    return child.type !== _ListGroupItem2['default'] || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3['default'])(this, ListGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var _props$componentClass = _props.componentClass;
	    var Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2['default'].every(children, function (child) {
	      return child.type === _ListGroupItem2['default'];
	    });
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2['default'].Component);
	
	ListGroup.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3['default'])(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3['default'])(this, MediaBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2['default'].Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3['default'])(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3['default'])(this, MediaHeading);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2['default'].Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(92);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3['default'])(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3['default'])(this, MediaLeft);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2['default'].Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3['default'])(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3['default'])(this, MediaList);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('ul', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3['default'])(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3['default'])(this, MediaListItem);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Media = __webpack_require__(92);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _react2['default'].PropTypes.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3['default'])(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3['default'])(this, MediaRight);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props;
	    var align = _props.align;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2['default'].defaultProps, align)] = true;
	    }
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2['default'].Component);
	
	MediaRight.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(75);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _react2['default'].PropTypes.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _react2['default'].PropTypes.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2['default'])(_react2['default'].PropTypes.bool, function (_ref) {
	    var divider = _ref.divider;
	    var children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _react2['default'].PropTypes.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _react2['default'].PropTypes.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3['default'])(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3['default'])(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props;
	    var href = _props.href;
	    var disabled = _props.disabled;
	    var onSelect = _props.onSelect;
	    var eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props;
	    var active = _props2.active;
	    var disabled = _props2.disabled;
	    var divider = _props2.divider;
	    var header = _props2.header;
	    var onClick = _props2.onClick;
	    var className = _props2.className;
	    var style = _props2.style;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2['default'])(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2['default'].createElement('li', (0, _extends3['default'])({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(_SafeAnchor2['default'], (0, _extends3['default'])({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2['default'].Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(367);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(46);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(40);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(181);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(378);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(186);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(150);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(284);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(151);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(152);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(153);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(70);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Modal2['default'].propTypes, _ModalDialog2['default'].propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _react2['default'].PropTypes.oneOf(['static', true, false]),
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _react2['default'].PropTypes.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _react2['default'].PropTypes.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2['default'],
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _react2['default'].PropTypes.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _react2['default'].PropTypes.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _react2['default'].PropTypes.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2['default'].propTypes.container
	});
	
	var defaultProps = (0, _extends3['default'])({}, _Modal2['default'].defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2['default']
	});
	
	var childContextTypes = {
	  $bs_modal: _react2['default'].PropTypes.shape({
	    onHide: _react2['default'].PropTypes.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3['default'])(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3['default'])(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2['default'].off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2['default']) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2['default'])(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2['default'])(_reactDom2['default'].findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2['default'])() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props;
	    var backdrop = _props.backdrop;
	    var animation = _props.animation;
	    var show = _props.show;
	    var Dialog = _props.dialogComponentClass;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var onEntering = _props.onEntering;
	    var onExited = _props.onExited;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['backdrop', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Modal2['default']);
	
	    var baseModalProps = _splitComponentProps[0];
	    var dialogProps = _splitComponentProps[1];
	
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2['default'].createElement(
	      _Modal2['default'],
	      (0, _extends3['default'])({}, baseModalProps, {
	        ref: function ref(c) {
	          _this2._modal = c;
	        },
	        show: show,
	        onEntering: (0, _createChainedFunction2['default'])(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2['default'])(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2['default'])((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2['default'] : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2['default'].createElement(
	        Dialog,
	        (0, _extends3['default'])({}, dialogProps, {
	          style: (0, _extends3['default'])({}, this.state.style, style),
	          className: (0, _classnames2['default'])(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2['default'].Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2['default'];
	Modal.Header = _ModalHeader2['default'];
	Modal.Title = _ModalTitle2['default'];
	Modal.Footer = _ModalFooter2['default'];
	
	Modal.Dialog = _ModalDialog2['default'];
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _react2['default'].PropTypes.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3['default'])(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3['default'])(this, ModalDialog);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var dialogClassName = _props.dialogClassName;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4['default'])({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2['default'])(className, bsClassName)
	      }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(dialogClassName, dialogClasses) },
	        _react2['default'].createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2['default'].Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dropdown = __webpack_require__(68);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(70);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  title: _react2['default'].PropTypes.node.isRequired,
	  noCaret: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3['default'])(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3['default'])(this, NavDropdown);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (props.children) {
	      return _ValidComponentChildren2['default'].some(props.children, function (child) {
	        return _this2.isActive(child, activeKey, activeHref);
	      });
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props;
	    var title = _props.title;
	    var activeKey = _props.activeKey;
	    var activeHref = _props.activeHref;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent);
	
	    var dropdownProps = _splitComponentProps[0];
	    var toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2['default'])(className, { active: active }),
	        style: style
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Toggle,
	        (0, _extends3['default'])({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        _ValidComponentChildren2['default'].map(children, function (child) {
	          return _react2['default'].cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2['default'].Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports['default'] = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(78);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(148);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(156);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(287);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(288);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(289);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _react2['default'].PropTypes.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _react2['default'].PropTypes.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _react2['default'].PropTypes.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _react2['default'].PropTypes.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _react2['default'].PropTypes.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2['default'],
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
	   * boolean value.
	   *
	   * @controllable navExpanded
	   */
	  onToggle: _react2['default'].PropTypes.func,
	
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _react2['default'].PropTypes.bool,
	
	  role: _react2['default'].PropTypes.string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3['default'])(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3['default'])(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props;
	    var bsClass = _props.bsClass;
	    var expanded = _props.expanded;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle
	      }
	    };
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props2 = this.props;
	    var onToggle = _props2.onToggle;
	    var expanded = _props2.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props3 = this.props;
	    var Component = _props3.componentClass;
	    var fixedTop = _props3.fixedTop;
	    var fixedBottom = _props3.fixedBottom;
	    var staticTop = _props3.staticTop;
	    var inverse = _props3.inverse;
	    var fluid = _props3.fluid;
	    var className = _props3.className;
	    var children = _props3.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props3, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        _Grid2['default'],
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2['default'].Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2['default'])(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var Component = _ref.componentClass;
	    var className = _ref.className;
	    var pullRight = _ref.pullRight;
	    var pullLeft = _ref.pullLeft;
	    var props = (0, _objectWithoutProperties3['default'])(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    var _ref2$$bs_navbar = _ref2.$bs_navbar;
	    var navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    return _react2['default'].createElement(Component, (0, _extends4['default'])({}, props, {
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2['default'],
	    pullRight: _react2['default'].PropTypes.bool,
	    pullLeft: _react2['default'].PropTypes.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _react.PropTypes.shape({
	      bsClass: _react.PropTypes.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2['default'];
	UncontrollableNavbar.Header = _NavbarHeader2['default'];
	UncontrollableNavbar.Toggle = _NavbarToggle2['default'];
	UncontrollableNavbar.Collapse = _NavbarCollapse2['default'];
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports['default'] = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(90);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3['default'])(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': navbarProps.expanded }, props),
	      _react2['default'].createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2['default'].Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports['default'] = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var contextTypes = {
	  $bs_navbar: _react2['default'].PropTypes.shape({
	    bsClass: _react2['default'].PropTypes.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3['default'])(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, props, { className: (0, _classnames2['default'])(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2['default'].Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports['default'] = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onClick: _react.PropTypes.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _react.PropTypes.node
	};
	
	var contextTypes = {
	  $bs_navbar: _react.PropTypes.shape({
	    bsClass: _react.PropTypes.string,
	    expanded: _react.PropTypes.bool,
	    onToggle: _react.PropTypes.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3['default'])(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3['default'])(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props;
	    var onClick = _props.onClick;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3['default'])({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2['default'])(onClick, navbarProps.onToggle),
	      className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2['default'].createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2['default'].createElement(
	      'button',
	      buttonProps,
	      _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' }),
	      _react2['default'].createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2['default'].Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports['default'] = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(58);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(157);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _react2['default'].PropTypes.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3['default'])({}, _Overlay2['default'].propTypes, {
	
	  /**
	  * Specify which action or actions trigger Overlay visibility
	  */
	  trigger: _react2['default'].PropTypes.oneOfType([triggerType, _react2['default'].PropTypes.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _react2['default'].PropTypes.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _react2['default'].PropTypes.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _react2['default'].PropTypes.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _react2['default'].PropTypes.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onFocus: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOut: _react2['default'].PropTypes.func,
	  /**
	   * @private
	   */
	  onMouseOver: _react2['default'].PropTypes.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _react2['default'].PropTypes.oneOf([null]),
	  /**
	  * @private
	  */
	  onHide: _react2['default'].PropTypes.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _react2['default'].PropTypes.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3['default'])(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2['default'].unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this2 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this2._hoverShowDelay = null;
	      _this2.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this3 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this3._hoverHideDelay = null;
	      _this3.hide();
	    }, delay);
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if (!related || related !== target && !(0, _contains2['default'])(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2['default'].createElement(
	      _Overlay2['default'],
	      (0, _extends3['default'])({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2['default'].unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props;
	    var trigger = _props.trigger;
	    var overlay = _props.overlay;
	    var children = _props.children;
	    var onBlur = _props.onBlur;
	    var onClick = _props.onClick;
	    var onFocus = _props.onFocus;
	    var onMouseOut = _props.onMouseOut;
	    var onMouseOver = _props.onMouseOver;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2['default'].Children.only(children);
	    var childProps = child.props;
	
	    var triggerProps = {
	      'aria-describedby': overlay.props.id
	    };
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2['default'])(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2['default'])(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2['default'])(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2['default'])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2['default'])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2['default'])(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2['default'])(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2['default'].Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports['default'] = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3['default'])(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3['default'])(this, PageHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(158);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(313);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _deprecationWarning2['default'].wrapper(_PagerItem2['default'], '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PagerItem = __webpack_require__(158);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  onSelect: _react2['default'].PropTypes.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3['default'])(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3['default'])(this, Pager);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props;
	    var onSelect = _props.onSelect;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2['default'])(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2['default'].Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2['default'];
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(295);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  activePage: _react2['default'].PropTypes.number,
	  items: _react2['default'].PropTypes.number,
	  maxButtons: _react2['default'].PropTypes.number,
	
	  /**
	   * When `true`, will display the first and the last button page
	   */
	  boundaryLinks: _react2['default'].PropTypes.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.bool, _react2['default'].PropTypes.node]),
	
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3['default'])(this, Pagination);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	    var hasHiddenPagesAfter = void 0;
	
	    if (maxButtons) {
	      var hiddenPagesBefore = activePage - parseInt(maxButtons / 2, 10);
	      startPage = hiddenPagesBefore > 1 ? hiddenPagesBefore : 1;
	      hasHiddenPagesAfter = startPage + maxButtons <= items;
	
	      if (!hasHiddenPagesAfter) {
	        endPage = items;
	        startPage = items - maxButtons + 1;
	        if (startPage < 1) {
	          startPage = 1;
	        }
	      } else {
	        endPage = startPage + maxButtons - 1;
	      }
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var pagenumber = startPage; pagenumber <= endPage; pagenumber++) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: pagenumber,
	          eventKey: pagenumber,
	          active: pagenumber === activePage
	        }),
	        pagenumber
	      ));
	    }
	
	    if (boundaryLinks && ellipsis && startPage !== 1) {
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsisFirst',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '…' : ellipsis
	        )
	      ));
	
	      pageButtons.unshift(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (maxButtons && hasHiddenPagesAfter && ellipsis) {
	      pageButtons.push(_react2['default'].createElement(
	        _PaginationButton2['default'],
	        {
	          key: 'ellipsis',
	          disabled: true,
	          componentClass: buttonProps.componentClass
	        },
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'More' },
	          ellipsis === true ? '…' : ellipsis
	        )
	      ));
	
	      if (boundaryLinks && endPage !== items) {
	        pageButtons.push(_react2['default'].createElement(
	          _PaginationButton2['default'],
	          (0, _extends3['default'])({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props;
	    var activePage = _props.activePage;
	    var items = _props.items;
	    var maxButtons = _props.maxButtons;
	    var boundaryLinks = _props.boundaryLinks;
	    var ellipsis = _props.ellipsis;
	    var first = _props.first;
	    var last = _props.last;
	    var prev = _props.prev;
	    var next = _props.next;
	    var onSelect = _props.onSelect;
	    var buttonComponentClass = _props.buttonComponentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      first && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '«' : first
	        )
	      ),
	      prev && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '‹' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '›' : next
	        )
	      ),
	      last && _react2['default'].createElement(
	        _PaginationButton2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2['default'].createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '»' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(17);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2['default'],
	  className: _react2['default'].PropTypes.string,
	  eventKey: _react2['default'].PropTypes.any,
	  onSelect: _react2['default'].PropTypes.func,
	  disabled: _react2['default'].PropTypes.bool,
	  active: _react2['default'].PropTypes.bool,
	  onClick: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2['default'],
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3['default'])(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3['default'])(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var onSelect = _props.onSelect;
	    var eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props;
	    var Component = _props2.componentClass;
	    var active = _props2.active;
	    var disabled = _props2.disabled;
	    var onClick = _props2.onClick;
	    var className = _props2.className;
	    var style = _props2.style;
	    var props = (0, _objectWithoutProperties3['default'])(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2['default']) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: (0, _classnames2['default'])(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2['default'].createElement(Component, (0, _extends3['default'])({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2['default'])(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2['default'].Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports['default'] = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Collapse = __webpack_require__(90);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _react2['default'].PropTypes.bool,
	  onSelect: _react2['default'].PropTypes.func,
	  header: _react2['default'].PropTypes.node,
	  id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	  footer: _react2['default'].PropTypes.node,
	  defaultExpanded: _react2['default'].PropTypes.bool,
	  expanded: _react2['default'].PropTypes.bool,
	  eventKey: _react2['default'].PropTypes.any,
	  headerRole: _react2['default'].PropTypes.string,
	  panelRole: _react2['default'].PropTypes.string,
	
	  // From Collapse.
	  onEnter: _react2['default'].PropTypes.func,
	  onEntering: _react2['default'].PropTypes.func,
	  onEntered: _react2['default'].PropTypes.func,
	  onExit: _react2['default'].PropTypes.func,
	  onExiting: _react2['default'].PropTypes.func,
	  onExited: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3['default'])(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.shouldRenderFill = function shouldRenderFill(child) {
	    return _react2['default'].isValidElement(child) && child.props.fill != null;
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2['default'].isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2['default'])(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2['default'].isValidElement(header)) {
	      return _react2['default'].createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2['default'])(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2['default'].createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2['default'].createElement(
	      _Collapse2['default'],
	      (0, _extends3['default'])({ 'in': expanded }, animationHooks),
	      _react2['default'].createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2['default'].Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2['default'].isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props;
	    var collapsible = _props.collapsible;
	    var header = _props.header;
	    var id = _props.id;
	    var footer = _props.footer;
	    var propsExpanded = _props.expanded;
	    var headerRole = _props.headerRole;
	    var panelRole = _props.panelRole;
	    var className = _props.className;
	    var children = _props.children;
	    var onEnter = _props.onEnter;
	    var onEntering = _props.onEntering;
	    var onEntered = _props.onEntered;
	    var onExit = _props.onExit;
	    var onExiting = _props.onExiting;
	    var onExited = _props.onExited;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']);
	
	    var bsProps = _splitBsPropsAndOmit[0];
	    var elementProps = _splitBsPropsAndOmit[1];
	
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2['default'].Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2['default'])(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(76);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * Title content
	   */
	  title: _react2['default'].PropTypes.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3['default'])(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3['default'])(this, Popover);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var placement = _props.placement;
	    var positionTop = _props.positionTop;
	    var positionLeft = _props.positionLeft;
	    var arrowOffsetTop = _props.arrowOffsetTop;
	    var arrowOffsetLeft = _props.arrowOffsetLeft;
	    var title = _props.title;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2['default'].createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2['default'].Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(41);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2['default'].Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2['default'].isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _react.PropTypes.number,
	  now: _react.PropTypes.number,
	  max: _react.PropTypes.number,
	  label: _react.PropTypes.node,
	  srOnly: _react.PropTypes.bool,
	  striped: _react.PropTypes.bool,
	  active: _react.PropTypes.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3['default'])(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3['default'])(this, ProgressBar);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min;
	    var now = _ref.now;
	    var max = _ref.max;
	    var label = _ref.label;
	    var srOnly = _ref.srOnly;
	    var striped = _ref.striped;
	    var active = _ref.active;
	    var className = _ref.className;
	    var style = _ref.style;
	    var props = (0, _objectWithoutProperties3['default'])(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2['default'])(className, classes),
	        style: (0, _extends4['default'])({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2['default'].createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props;
	    var isChild = _props.isChild;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min;
	    var now = props.now;
	    var max = props.max;
	    var label = props.label;
	    var srOnly = props.srOnly;
	    var striped = props.striped;
	    var active = props.active;
	    var bsClass = props.bsClass;
	    var bsStyle = props.bsStyle;
	    var className = props.className;
	    var children = props.children;
	    var wrapperProps = (0, _objectWithoutProperties3['default'])(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, wrapperProps, {
	        className: (0, _classnames2['default'])(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2['default'].map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2['default'].Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2['default'])(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  inline: _react2['default'].PropTypes.bool,
	  disabled: _react2['default'].PropTypes.bool,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _react2['default'].PropTypes.func
	};
	
	var defaultProps = {
	  inline: false,
	  disabled: false
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3['default'])(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3['default'])(this, Radio);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props;
	    var inline = _props.inline;
	    var disabled = _props.disabled;
	    var validationState = _props.validationState;
	    var inputRef = _props.inputRef;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var input = _react2['default'].createElement('input', (0, _extends3['default'])({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2['default'])(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2['default'].createElement(
	        'label',
	        { className: (0, _classnames2['default'])(className, _classes), style: style },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(className, classes), style: style },
	      _react2['default'].createElement(
	        'label',
	        null,
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2['default'].Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _react.PropTypes.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _react.PropTypes.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _react.PropTypes.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3['default'])(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3['default'])(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var a16by9 = _props.a16by9;
	    var a4by3 = _props.a4by3;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	     false ? (0, _warning2['default'])(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2['default'])(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2['default'].Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  componentClass: _elementType2['default']
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3['default'])(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3['default'])(this, Row);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props;
	    var Component = _props.componentClass;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(Component, (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2['default'].Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(52);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(68);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(303);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(70);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _Dropdown2['default'].propTypes, {
	
	  // Toggle props.
	  bsStyle: _react2['default'].PropTypes.string,
	  bsSize: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string,
	  onClick: _react2['default'].PropTypes.func,
	  /**
	   * The content of the split button.
	   */
	  title: _react2['default'].PropTypes.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _react2['default'].PropTypes.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _react2['default'].PropTypes.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3['default'])(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3['default'])(this, SplitButton);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props;
	    var bsSize = _props.bsSize;
	    var bsStyle = _props.bsStyle;
	    var title = _props.title;
	    var toggleLabel = _props.toggleLabel;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3['default'])(props, _Dropdown2['default'].ControlledComponent);
	
	    var dropdownProps = _splitComponentProps[0];
	    var buttonProps = _splitComponentProps[1];
	
	
	    return _react2['default'].createElement(
	      _Dropdown2['default'],
	      (0, _extends3['default'])({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Button2['default'],
	        (0, _extends3['default'])({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2['default'].createElement(_SplitToggle2['default'], {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2['default'].createElement(
	        _Dropdown2['default'].Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2['default'].Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2['default'];
	
	exports['default'] = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(147);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3['default'])(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3['default'])(this, SplitToggle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2['default'].createElement(_DropdownToggle2['default'], (0, _extends3['default'])({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2['default'].Component);
	
	SplitToggle.defaultProps = _DropdownToggle2['default'].defaultProps;
	
	exports['default'] = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabContainer = __webpack_require__(93);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(94);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(160);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _extends3['default'])({}, _TabPane2['default'].propTypes, {
	
	  disabled: _react2['default'].PropTypes.bool,
	
	  title: _react2['default'].PropTypes.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _react2['default'].PropTypes.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3['default'])(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3['default'])(this, Tab);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2['default'].createElement(_TabPane2['default'], props);
	  };
	
	  return Tab;
	}(_react2['default'].Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2['default'];
	Tab.Content = _TabContent2['default'];
	Tab.Pane = _TabPane2['default'];
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  striped: _react2['default'].PropTypes.bool,
	  bordered: _react2['default'].PropTypes.bool,
	  condensed: _react2['default'].PropTypes.bool,
	  hover: _react2['default'].PropTypes.bool,
	  responsive: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3['default'])(this, Table);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var striped = _props.striped;
	    var bordered = _props.bordered;
	    var condensed = _props.condensed;
	    var hover = _props.hover;
	    var responsive = _props.responsive;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2['default'].createElement('table', (0, _extends4['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(76);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(78);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(154);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(155);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(93);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(94);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContainer = _TabContainer2['default'].ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _react2['default'].PropTypes.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _react2['default'].PropTypes.oneOf(['tabs', 'pills']),
	
	  animation: _react2['default'].PropTypes.bool,
	
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   * 	Any eventKey,
	   * 	SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _react2['default'].PropTypes.func,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _react2['default'].PropTypes.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2['default'].forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3['default'])(this, Tabs);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props;
	    var title = _child$props.title;
	    var eventKey = _child$props.eventKey;
	    var disabled = _child$props.disabled;
	    var tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      _NavItem2['default'],
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props;
	    var id = _props.id;
	    var onSelect = _props.onSelect;
	    var animation = _props.animation;
	    var unmountOnExit = _props.unmountOnExit;
	    var bsClass = _props.bsClass;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var _props$activeKey = _props.activeKey;
	    var activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['id', 'onSelect', 'animation', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2['default'].createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _Nav2['default'],
	          (0, _extends3['default'])({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2['default'].map(children, this.renderTab)
	        ),
	        _react2['default'].createElement(
	          _TabContent2['default'],
	          {
	            bsClass: bsClass,
	            animation: animation,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2['default'].Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports['default'] = (0, _uncontrollable2['default'])(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SafeAnchor = __webpack_require__(25);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  src: _react2['default'].PropTypes.string,
	  alt: _react2['default'].PropTypes.string,
	  href: _react2['default'].PropTypes.string
	};
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3['default'])(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3['default'])(this, Thumbnail);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props;
	    var src = _props.src;
	    var alt = _props.alt;
	    var className = _props.className;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['src', 'alt', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var Component = elementProps.href ? _SafeAnchor2['default'] : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement(
	      Component,
	      (0, _extends3['default'])({}, elementProps, {
	        className: (0, _classnames2['default'])(className, classes)
	      }),
	      _react2['default'].createElement('img', { src: src, alt: alt }),
	      children && _react2['default'].createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2['default'].Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(5);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isRequiredForA11y = __webpack_require__(76);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2['default'])(_react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _react2['default'].PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.number, _react2['default'].PropTypes.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3['default'])(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3['default'])(this, Tooltip);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props;
	    var placement = _props.placement;
	    var positionTop = _props.positionTop;
	    var positionLeft = _props.positionLeft;
	    var arrowOffsetTop = _props.arrowOffsetTop;
	    var arrowOffsetLeft = _props.arrowOffsetLeft;
	    var className = _props.className;
	    var style = _props.style;
	    var children = _props.children;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _extends4['default'])({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4['default'])({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends4['default'])({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2['default'])(className, classes),
	        style: outerStyle
	      }),
	      _react2['default'].createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2['default'].Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(8);
	
	var _StyleConfig = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3['default'])(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3['default'])(this, Well);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var props = (0, _objectWithoutProperties3['default'])(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props);
	
	    var bsProps = _splitBsProps[0];
	    var elementProps = _splitBsProps[1];
	
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2['default'].createElement('div', (0, _extends3['default'])({}, elementProps, {
	      className: (0, _classnames2['default'])(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2['default'].Component);
	
	exports['default'] = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(250);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(251);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(252);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(253);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(144);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(52);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(145);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(254);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(255);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(146);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(257);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(258);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _ControlLabel2 = __webpack_require__(260);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(259);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(90);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(68);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(261);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(69);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(263);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(264);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(267);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(91);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(148);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(268);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(269);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(270);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(273);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(274);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(275);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(149);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(92);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(282);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(283);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(150);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(151);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(152);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(153);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(154);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(286);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(156);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(285);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(155);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(157);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(290);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(291);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(292);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(293);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(294);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _Panel2 = __webpack_require__(296);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(159);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(297);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(298);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(299);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(300);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(301);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(25);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(302);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(304);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(93);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(94);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(305);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(160);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(306);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(307);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _Tooltip2 = __webpack_require__(308);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(309);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(314);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Accordion = _Accordion3['default'];
	exports.Alert = _Alert3['default'];
	exports.Badge = _Badge3['default'];
	exports.Breadcrumb = _Breadcrumb3['default'];
	exports.BreadcrumbItem = _BreadcrumbItem3['default'];
	exports.Button = _Button3['default'];
	exports.ButtonGroup = _ButtonGroup3['default'];
	exports.ButtonToolbar = _ButtonToolbar3['default'];
	exports.Carousel = _Carousel3['default'];
	exports.CarouselItem = _CarouselItem3['default'];
	exports.Checkbox = _Checkbox3['default'];
	exports.Clearfix = _Clearfix3['default'];
	exports.ControlLabel = _ControlLabel3['default'];
	exports.Col = _Col3['default'];
	exports.Collapse = _Collapse3['default'];
	exports.Dropdown = _Dropdown3['default'];
	exports.DropdownButton = _DropdownButton3['default'];
	exports.Fade = _Fade3['default'];
	exports.Form = _Form3['default'];
	exports.FormControl = _FormControl3['default'];
	exports.FormGroup = _FormGroup3['default'];
	exports.Glyphicon = _Glyphicon3['default'];
	exports.Grid = _Grid3['default'];
	exports.HelpBlock = _HelpBlock3['default'];
	exports.Image = _Image3['default'];
	exports.InputGroup = _InputGroup3['default'];
	exports.Jumbotron = _Jumbotron3['default'];
	exports.Label = _Label3['default'];
	exports.ListGroup = _ListGroup3['default'];
	exports.ListGroupItem = _ListGroupItem3['default'];
	exports.Media = _Media3['default'];
	exports.MenuItem = _MenuItem3['default'];
	exports.Modal = _Modal3['default'];
	exports.ModalBody = _ModalBody3['default'];
	exports.ModalFooter = _ModalFooter3['default'];
	exports.ModalHeader = _ModalHeader3['default'];
	exports.ModalTitle = _ModalTitle3['default'];
	exports.Nav = _Nav3['default'];
	exports.Navbar = _Navbar3['default'];
	exports.NavbarBrand = _NavbarBrand3['default'];
	exports.NavDropdown = _NavDropdown3['default'];
	exports.NavItem = _NavItem3['default'];
	exports.Overlay = _Overlay3['default'];
	exports.OverlayTrigger = _OverlayTrigger3['default'];
	exports.PageHeader = _PageHeader3['default'];
	exports.PageItem = _PageItem3['default'];
	exports.Pager = _Pager3['default'];
	exports.Pagination = _Pagination3['default'];
	exports.Panel = _Panel3['default'];
	exports.PanelGroup = _PanelGroup3['default'];
	exports.Popover = _Popover3['default'];
	exports.ProgressBar = _ProgressBar3['default'];
	exports.Radio = _Radio3['default'];
	exports.ResponsiveEmbed = _ResponsiveEmbed3['default'];
	exports.Row = _Row3['default'];
	exports.SafeAnchor = _SafeAnchor3['default'];
	exports.SplitButton = _SplitButton3['default'];
	exports.Tab = _Tab3['default'];
	exports.TabContainer = _TabContainer3['default'];
	exports.TabContent = _TabContent3['default'];
	exports.Table = _Table3['default'];
	exports.TabPane = _TabPane3['default'];
	exports.Tabs = _Tabs3['default'];
	exports.Thumbnail = _Thumbnail3['default'];
	exports.Tooltip = _Tooltip3['default'];
	exports.Well = _Well3['default'];
	exports.utils = _utils;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(77);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(21);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2['default'].some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2['default'])(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2['default'].filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(95);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3['default'])(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2['default'])(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3['default'])(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3['default'])(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports['default'] = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(8);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(17);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(21);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3['default'];
	exports.ValidComponentChildren = _ValidComponentChildren3['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(324), __esModule: true };

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(326), __esModule: true };

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(327), __esModule: true };

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(174);
	__webpack_require__(351);
	module.exports = __webpack_require__(26).Array.from;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(353);
	module.exports = __webpack_require__(26).Object.assign;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(354);
	var $Object = __webpack_require__(26).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(358);
	module.exports = __webpack_require__(26).Object.entries;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(355);
	module.exports = __webpack_require__(26).Object.setPrototypeOf;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(359);
	module.exports = __webpack_require__(26).Object.values;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(357);
	__webpack_require__(356);
	__webpack_require__(360);
	__webpack_require__(361);
	module.exports = __webpack_require__(26).Symbol;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(174);
	__webpack_require__(362);
	module.exports = __webpack_require__(110).f('iterator');

/***/ },
/* 328 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 329 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(34)
	  , toLength  = __webpack_require__(173)
	  , toIndex   = __webpack_require__(349);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(96)
	  , TAG = __webpack_require__(27)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(39)
	  , createDesc      = __webpack_require__(57);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(45)
	  , gOPS    = __webpack_require__(102)
	  , pIE     = __webpack_require__(56);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(33).document && document.documentElement;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(55)
	  , ITERATOR   = __webpack_require__(27)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(96);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(42);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(101)
	  , descriptor     = __webpack_require__(57)
	  , setToStringTag = __webpack_require__(103)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(44)(IteratorPrototype, __webpack_require__(27)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(27)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 340 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(45)
	  , toIObject = __webpack_require__(34);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(71)('meta')
	  , isObject = __webpack_require__(54)
	  , has      = __webpack_require__(38)
	  , setDesc  = __webpack_require__(39).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(53)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(45)
	  , gOPS     = __webpack_require__(102)
	  , pIE      = __webpack_require__(56)
	  , toObject = __webpack_require__(107)
	  , IObject  = __webpack_require__(166)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(53)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(39)
	  , anObject = __webpack_require__(42)
	  , getKeys  = __webpack_require__(45);
	
	module.exports = __webpack_require__(43) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(34)
	  , gOPN      = __webpack_require__(169).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(38)
	  , toObject    = __webpack_require__(107)
	  , IE_PROTO    = __webpack_require__(104)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(54)
	  , anObject = __webpack_require__(42);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(97)(Function.call, __webpack_require__(168).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(106)
	  , defined   = __webpack_require__(98);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(106)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(331)
	  , ITERATOR  = __webpack_require__(27)('iterator')
	  , Iterators = __webpack_require__(55);
	module.exports = __webpack_require__(26).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(97)
	  , $export        = __webpack_require__(32)
	  , toObject       = __webpack_require__(107)
	  , call           = __webpack_require__(337)
	  , isArrayIter    = __webpack_require__(335)
	  , toLength       = __webpack_require__(173)
	  , createProperty = __webpack_require__(332)
	  , getIterFn      = __webpack_require__(350);
	
	$export($export.S + $export.F * !__webpack_require__(339)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(329)
	  , step             = __webpack_require__(340)
	  , Iterators        = __webpack_require__(55)
	  , toIObject        = __webpack_require__(34);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(167)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(32);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(343)});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(101)});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(32);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(347).set});

/***/ },
/* 356 */
/***/ function(module, exports) {



/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(33)
	  , has            = __webpack_require__(38)
	  , DESCRIPTORS    = __webpack_require__(43)
	  , $export        = __webpack_require__(32)
	  , redefine       = __webpack_require__(172)
	  , META           = __webpack_require__(342).KEY
	  , $fails         = __webpack_require__(53)
	  , shared         = __webpack_require__(105)
	  , setToStringTag = __webpack_require__(103)
	  , uid            = __webpack_require__(71)
	  , wks            = __webpack_require__(27)
	  , wksExt         = __webpack_require__(110)
	  , wksDefine      = __webpack_require__(109)
	  , keyOf          = __webpack_require__(341)
	  , enumKeys       = __webpack_require__(333)
	  , isArray        = __webpack_require__(336)
	  , anObject       = __webpack_require__(42)
	  , toIObject      = __webpack_require__(34)
	  , toPrimitive    = __webpack_require__(108)
	  , createDesc     = __webpack_require__(57)
	  , _create        = __webpack_require__(101)
	  , gOPNExt        = __webpack_require__(345)
	  , $GOPD          = __webpack_require__(168)
	  , $DP            = __webpack_require__(39)
	  , $keys          = __webpack_require__(45)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(169).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(56).f  = $propertyIsEnumerable;
	  __webpack_require__(102).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(100)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(44)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(32)
	  , $entries = __webpack_require__(171)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(32)
	  , $values = __webpack_require__(171)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(109)('asyncIterator');

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(109)('observable');

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(352);
	var global        = __webpack_require__(33)
	  , hide          = __webpack_require__(44)
	  , Iterators     = __webpack_require__(55)
	  , TO_STRING_TAG = __webpack_require__(27)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasClass = __webpack_require__(176);
	
	module.exports = function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!hasClass(element)) element.className = element.className + ' ' + className;
	};

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  addClass: __webpack_require__(363),
	  removeClass: __webpack_require__(365),
	  hasClass: __webpack_require__(176)
	};

/***/ },
/* 365 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var contains = __webpack_require__(58),
	    qsa = __webpack_require__(370);
	
	module.exports = function (selector, handler) {
	  return function (e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = qsa(top, selector);
	
	    if (matches.some(function (match) {
	      return contains(match, target);
	    })) handler.call(this, e);
	  };
	};

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var on = __webpack_require__(111),
	    off = __webpack_require__(177),
	    filter = __webpack_require__(366);
	
	module.exports = { on: on, off: off, filter: filter };

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(74);
	
	exports.__esModule = true;
	exports['default'] = offsetParent;
	
	var _ownerDocument = __webpack_require__(46);
	
	var _ownerDocument2 = babelHelpers.interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(73);
	
	var _style2 = babelHelpers.interopRequireDefault(_style);
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2['default'])(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2['default'])(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(74);
	
	exports.__esModule = true;
	exports['default'] = position;
	
	var _offset = __webpack_require__(178);
	
	var _offset2 = babelHelpers.interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(368);
	
	var _offsetParent2 = babelHelpers.interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(179);
	
	var _scrollTop2 = babelHelpers.interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(371);
	
	var _scrollLeft2 = babelHelpers.interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(73);
	
	var _style2 = babelHelpers.interopRequireDefault(_style);
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2['default'])(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2['default'])(node);
	    offset = (0, _offset2['default'])(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2['default'])(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2['default'])(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2['default'])(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2['default'])(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2['default'])(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return babelHelpers._extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2['default'])(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2['default'])(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports) {

	'use strict';
	//     Zepto.js
	//     (c) 2010-2015 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/,
	    toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	module.exports = function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getWindow = __webpack_require__(72);
	
	module.exports = function scrollTop(node, val) {
	  var win = getWindow(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelHelpers = __webpack_require__(74);
	
	var _utilCamelizeStyle = __webpack_require__(180);
	
	var _utilCamelizeStyle2 = babelHelpers.interopRequireDefault(_utilCamelizeStyle);
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	module.exports = function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : { //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _utilCamelizeStyle2['default'])(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	};

/***/ },
/* 373 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var canUseDOM = __webpack_require__(40);
	
	var has = Object.prototype.hasOwnProperty,
	    transform = 'transform',
	    transition = {},
	    transitionTiming,
	    transitionDuration,
	    transitionProperty,
	    transitionDelay;
	
	if (canUseDOM) {
	  transition = getTransitionProperties();
	
	  transform = transition.prefix + transform;
	
	  transitionProperty = transition.prefix + 'transition-property';
	  transitionDuration = transition.prefix + 'transition-duration';
	  transitionDelay = transition.prefix + 'transition-delay';
	  transitionTiming = transition.prefix + 'transition-timing-function';
	}
	
	module.exports = {
	  transform: transform,
	  end: transition.end,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	function getTransitionProperties() {
	  var endEvent,
	      prefix = '',
	      transitions = {
	    O: 'otransitionend',
	    Moz: 'transitionend',
	    Webkit: 'webkitTransitionEnd',
	    ms: 'MSTransitionEnd'
	  };
	
	  var element = document.createElement('div');
	
	  for (var vendor in transitions) if (has.call(transitions, vendor)) {
	    if (element.style[vendor + 'TransitionProperty'] !== undefined) {
	      prefix = '-' + vendor.toLowerCase() + '-';
	      endEvent = transitions[vendor];
	      break;
	    }
	  }
	
	  if (!endEvent && element.style.transitionProperty !== undefined) endEvent = 'transitionend';
	
	  return { end: endEvent, prefix: prefix };
	}

/***/ },
/* 375 */
/***/ function(module, exports) {

	"use strict";
	
	var rHyphen = /-(.)/g;
	
	module.exports = function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	};

/***/ },
/* 376 */
/***/ function(module, exports) {

	'use strict';
	
	var rUpper = /([A-Z])/g;
	
	module.exports = function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(376);
	var msPattern = /^ms-/;
	
	module.exports = function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, "-ms-");
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _componentOrElement = __webpack_require__(115);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Portal = __webpack_require__(182);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(379);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _ownerDocument = __webpack_require__(59);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(185);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(382);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _inDOM = __webpack_require__(40);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _activeElement = __webpack_require__(175);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(58);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _getContainer = __webpack_require__(114);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	var Modal = _react2.default.createClass({
	  displayName: 'Modal',
	
	
	  propTypes: _extends({}, _Portal2.default.propTypes, {
	
	    /**
	     * Set the visibility of the Modal
	     */
	    show: _react2.default.PropTypes.bool,
	
	    /**
	     * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	     *
	     * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	     * page content can be placed behind a virtual backdrop as well as a visual one.
	     */
	    container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	    /**
	     * A callback fired when the Modal is opening.
	     */
	    onShow: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	     *
	     * The `onHide` callback only signals intent from the Modal,
	     * you must actually set the `show` prop to `false` for the Modal to close.
	     */
	    onHide: _react2.default.PropTypes.func,
	
	    /**
	     * Include a backdrop component.
	     */
	    backdrop: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.oneOf(['static'])]),
	
	    /**
	     * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	     */
	    onEscapeKeyUp: _react2.default.PropTypes.func,
	
	    /**
	     * A callback fired when the backdrop, if specified, is clicked.
	     */
	    onBackdropClick: _react2.default.PropTypes.func,
	
	    /**
	     * A style object for the backdrop component.
	     */
	    backdropStyle: _react2.default.PropTypes.object,
	
	    /**
	     * A css class or classes for the backdrop component.
	     */
	    backdropClassName: _react2.default.PropTypes.string,
	
	    /**
	     * A css class or set of classes applied to the modal container when the modal is open,
	     * and removed when it is closed.
	     */
	    containerClassName: _react2.default.PropTypes.string,
	
	    /**
	     * Close the modal when escape key is pressed
	     */
	    keyboard: _react2.default.PropTypes.bool,
	
	    /**
	     * A `<Transition/>` component to use for the dialog and backdrop components.
	     */
	    transition: _elementType2.default,
	
	    /**
	     * The `timeout` of the dialog transition if specified. This number is used to ensure that
	     * transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    dialogTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * The `timeout` of the backdrop transition if specified. This number is used to
	     * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	     *
	     * See the Transition `timeout` prop for more infomation.
	     */
	    backdropTransitionTimeout: _react2.default.PropTypes.number,
	
	    /**
	     * When `true` The modal will automatically shift focus to itself when it opens, and
	     * replace it to the last focused element when it closes. This also
	     * works correctly with any Modal children that have the `autoFocus` prop.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    autoFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * When `true` The modal will prevent focus from leaving the Modal while open.
	     *
	     * Generally this should never be set to `false` as it makes the Modal less
	     * accessible to assistive technologies, like screen readers.
	     */
	    enforceFocus: _react2.default.PropTypes.bool,
	
	    /**
	     * Callback fired before the Modal transitions in
	     */
	    onEnter: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition in
	     */
	    onEntering: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning in
	     */
	    onEntered: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired right before the Modal transitions out
	     */
	    onExit: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired as the Modal begins to transition out
	     */
	    onExiting: _react2.default.PropTypes.func,
	
	    /**
	     * Callback fired after the Modal finishes transitioning out
	     */
	    onExited: _react2.default.PropTypes.func
	
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    var noop = function noop() {};
	
	    return {
	      show: false,
	      backdrop: true,
	      keyboard: true,
	      autoFocus: true,
	      enforceFocus: true,
	      onHide: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { exited: !this.props.show };
	  },
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var container = _props.container;
	    var children = _props.children;
	    var Transition = _props.transition;
	    var backdrop = _props.backdrop;
	    var dialogTransitionTimeout = _props.dialogTransitionTimeout;
	    var className = _props.className;
	    var style = _props.style;
	    var onExit = _props.onExit;
	    var onExiting = _props.onExiting;
	    var onEnter = _props.onEnter;
	    var onEntering = _props.onEntering;
	    var onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props;
	    var role = _dialog$props.role;
	    var tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          ref: 'modal',
	          role: role || 'dialog',
	          style: style,
	          className: className
	        },
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  },
	  renderBackdrop: function renderBackdrop() {
	    var _props2 = this.props;
	    var Transition = _props2.transition;
	    var backdropTransitionTimeout = _props2.backdropTransitionTimeout;
	
	
	    var backdrop = _react2.default.createElement('div', { ref: 'backdrop',
	      style: this.props.backdropStyle,
	      className: this.props.backdropClassName,
	      onClick: this.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': this.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this.onShow();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props3 = this.props;
	    var show = _props3.show;
	    var transition = _props3.transition;
	
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  },
	  onShow: function onShow() {
	    var doc = (0, _ownerDocument2.default)(this);
	    var container = (0, _getContainer2.default)(this.props.container, doc.body);
	
	    modalManager.add(this, container, this.props.containerClassName);
	
	    this._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	
	    this._onFocusinListener = (0, _addFocusListener2.default)(this.enforceFocus);
	
	    this.focus();
	
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	  onHide: function onHide() {
	    modalManager.remove(this);
	
	    this._onDocumentKeyupListener.remove();
	
	    this._onFocusinListener.remove();
	
	    this.restoreLastFocus();
	  },
	  setMountNode: function setMountNode(ref) {
	    this.mountNode = ref ? ref.getMountNode() : ref;
	  },
	  handleHidden: function handleHidden() {
	    this.setState({ exited: true });
	    this.onHide();
	
	    if (this.props.onExited) {
	      var _props4;
	
	      (_props4 = this.props).onExited.apply(_props4, arguments);
	    }
	  },
	  handleBackdropClick: function handleBackdropClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (this.props.onBackdropClick) {
	      this.props.onBackdropClick(e);
	    }
	
	    if (this.props.backdrop === true) {
	      this.props.onHide();
	    }
	  },
	  handleDocumentKeyUp: function handleDocumentKeyUp(e) {
	    if (this.props.keyboard && e.keyCode === 27 && this.isTopModal()) {
	      if (this.props.onEscapeKeyUp) {
	        this.props.onEscapeKeyUp(e);
	      }
	      this.props.onHide();
	    }
	  },
	  checkForFocus: function checkForFocus() {
	    if (_inDOM2.default) {
	      this.lastFocus = (0, _activeElement2.default)();
	    }
	  },
	  focus: function focus() {
	    var autoFocus = this.props.autoFocus;
	    var modalContent = this.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var focusInModal = current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      this.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  },
	  restoreLastFocus: function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  },
	  enforceFocus: function enforceFocus() {
	    var enforceFocus = this.props.enforceFocus;
	
	
	    if (!enforceFocus || !this.isMounted() || !this.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	    var modal = this.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  },
	
	
	  //instead of a ref, which might conflict with one the parent applied.
	  getDialogElement: function getDialogElement() {
	    var node = this.refs.modal;
	    return node && node.lastChild;
	  },
	  isTopModal: function isTopModal() {
	    return modalManager.isTopModal(this);
	  }
	});
	
	Modal.manager = modalManager;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__(73);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _class = __webpack_require__(364);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _scrollbarSize = __webpack_require__(181);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(186);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function () {
	  function ModalManager() {
	    var hideSiblingNodes = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    _classCallCheck(this, ModalManager);
	
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	  }
	
	  _createClass(ModalManager, [{
	    key: 'add',
	    value: function add(modal, container, className) {
	      var modalIdx = this.modals.indexOf(modal);
	      var containerIdx = this.containers.indexOf(container);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        //right now only the first modal of a container will have its classes applied
	        classes: className ? className.split(/\s+/) : [],
	        //we are only interested in the actual `style` here becasue we will override it
	        style: {
	          overflow: container.style.overflow,
	          paddingRight: container.style.paddingRight
	        }
	      };
	
	      var style = { overflow: 'hidden' };
	
	      data.overflowing = (0, _isOverflowing2.default)(container);
	
	      if (data.overflowing) {
	        // use computed style, here to get the real padding
	        // to add our scrollbar width
	        style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	      }
	
	      (0, _style2.default)(container, style);
	
	      data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	      this.containers.push(container);
	      this.data.push(data);
	
	      return modalIdx;
	    }
	  }, {
	    key: 'remove',
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return;
	      }
	
	      var containerIdx = findContainer(this.data, modal);
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	
	      data.modals.splice(data.modals.indexOf(modal), 1);
	
	      this.modals.splice(modalIdx, 1);
	
	      // if that was the last modal in a container,
	      // clean up the container stylinhg.
	      if (data.modals.length === 0) {
	        Object.keys(data.style).forEach(function (key) {
	          return container.style[key] = data.style[key];
	        });
	
	        data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        //otherwise make sure the next top modal is visible to a SR
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	
	  return ModalManager;
	}();
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(182);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(381);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(183);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _elementType = __webpack_require__(13);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Overlay).call(this, props, context));
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show) {
	        this.setState({ exited: false });
	      } else if (!nextProps.transition) {
	        // Otherwise let handleHidden take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var container = _props.container;
	      var containerPadding = _props.containerPadding;
	      var target = _props.target;
	      var placement = _props.placement;
	      var shouldUpdatePosition = _props.shouldUpdatePosition;
	      var rootClose = _props.rootClose;
	      var children = _props.children;
	      var Transition = _props.transition;
	
	      var props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	      // Don't un-render the overlay while it's transitioning out.
	
	
	      var mountOverlay = props.show || Transition && !this.state.exited;
	      if (!mountOverlay) {
	        // Don't bother showing anything if we don't have to.
	        return null;
	      }
	
	      var child = children;
	
	      // Position is be inner-most because it adds inline styles into the child,
	      // which the other wrappers don't forward correctly.
	      child = _react2.default.createElement(
	        _Position2.default,
	        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	        child
	      );
	
	      if (Transition) {
	        var onExit = props.onExit;
	        var onExiting = props.onExiting;
	        var onEnter = props.onEnter;
	        var onEntering = props.onEntering;
	        var onEntered = props.onEntered;
	
	        // This animates the child node by injecting props, so it must precede
	        // anything that adds a wrapping div.
	
	        child = _react2.default.createElement(
	          Transition,
	          {
	            'in': props.show,
	            transitionAppear: true,
	            onExit: onExit,
	            onExiting: onExiting,
	            onExited: this.onHiddenListener,
	            onEnter: onEnter,
	            onEntering: onEntering,
	            onEntered: onEntered
	          },
	          child
	        );
	      }
	
	      // This goes after everything else because it adds a wrapping div.
	      if (rootClose) {
	        child = _react2.default.createElement(
	          _RootCloseWrapper2.default,
	          { onRootClose: props.onHide },
	          child
	        );
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { container: container },
	        child
	      );
	    }
	  }, {
	    key: 'handleHidden',
	    value: function handleHidden() {
	      this.setState({ exited: true });
	
	      if (this.props.onExited) {
	        var _props2;
	
	        (_props2 = this.props).onExited.apply(_props2, arguments);
	      }
	    }
	  }]);
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _react2.default.PropTypes.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _react2.default.PropTypes.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _react2.default.PropTypes.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _react2.default.PropTypes.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _react2.default.PropTypes.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentOrElement = __webpack_require__(115);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _calculatePosition = __webpack_require__(383);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(114);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(59);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Position).call(this, props, context));
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  _createClass(Position, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updatePosition(this.getTarget());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this._needsFlush = true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this._needsFlush) {
	        this._needsFlush = false;
	        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      var _state = this.state;
	      var positionLeft = _state.positionLeft;
	      var positionTop = _state.positionTop;
	
	      var arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	      // These should not be forwarded to the child.
	
	
	      delete props.target;
	      delete props.container;
	      delete props.containerPadding;
	      delete props.shouldUpdatePosition;
	
	      var child = _react2.default.Children.only(children);
	      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	        // and `props.style`.
	        positionLeft: positionLeft,
	        positionTop: positionTop,
	        className: (0, _classnames2.default)(className, child.props.className),
	        style: _extends({}, child.props.style, {
	          left: positionLeft,
	          top: positionTop
	        })
	      }));
	    }
	  }, {
	    key: 'getTarget',
	    value: function getTarget() {
	      var target = this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    }
	  }, {
	    key: 'maybeUpdatePosition',
	    value: function maybeUpdatePosition(placementChanged) {
	      var target = this.getTarget();
	
	      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      this.updatePosition(target);
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition(target) {
	      this._lastTarget = target;
	
	      if (!target) {
	        this.setState({
	          positionLeft: 0,
	          positionTop: 0,
	          arrowOffsetLeft: null,
	          arrowOffsetTop: null
	        });
	
	        return;
	      }
	
	      var overlay = _reactDom2.default.findDOMNode(this);
	      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	    }
	  }]);
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _react2.default.PropTypes.oneOfType([_componentOrElement2.default, _react2.default.PropTypes.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _react2.default.PropTypes.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _react2.default.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _react2.default.PropTypes.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(178);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(369);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(179);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(59);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode);
	
	  var overlayHeight = _getOffset2.height;
	  var overlayWidth = _getOffset2.width;
	
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 385 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType;
	  var tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(112);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(387);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createUncontrollable(mixins, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var methods = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = _react2.default.createClass(_extends({
	
	      displayName: 'Uncontrolled(' + displayName + ')',
	
	      mixins: mixins,
	
	      propTypes: propTypes
	
	    }, methods, {
	      componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this._values[key] = props[utils.defaultKey(key)];
	        });
	      },
	
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var props = this.props;
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this2._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      },
	      getControlledInstance: function getControlledInstance() {
	        return this.refs.inner;
	      },
	      render: function render() {
	        var _this3 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this3.props[propName];
	
	          if (linkPropName && !isProp(_this3.props, propName) && isProp(_this3.props, linkPropName)) {
	            prop = _this3.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this3._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this3, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      }
	    }));
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(112);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 388 */
/***/ function(module, exports) {

	;(function() {
	"use strict";
	
	if (typeof window === 'undefined') return;
	
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A component handler interface using the revealing module design pattern.
	 * More details on this design pattern here:
	 * https://github.com/jasonmayes/mdl-component-design-pattern
	 *
	 * @author Jason Mayes.
	 */
	/* exported componentHandler */
	
	// Pre-defining the componentHandler interface, for closure documentation and
	// static verification.
	var componentHandler = {
	  /**
	   * Searches existing DOM for elements of our component type and upgrades them
	   * if they have not already been upgraded.
	   *
	   * @param {string=} optJsClass the programatic name of the element class we
	   * need to create a new instance of.
	   * @param {string=} optCssClass the name of the CSS class elements of this
	   * type will have.
	   */
	  upgradeDom: function(optJsClass, optCssClass) {},
	  /**
	   * Upgrades a specific element rather than all in the DOM.
	   *
	   * @param {!Element} element The element we wish to upgrade.
	   * @param {string=} optJsClass Optional name of the class we want to upgrade
	   * the element to.
	   */
	  upgradeElement: function(element, optJsClass) {},
	  /**
	   * Upgrades a specific list of elements rather than all in the DOM.
	   *
	   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	   * The elements we wish to upgrade.
	   */
	  upgradeElements: function(elements) {},
	  /**
	   * Upgrades all registered components found in the current DOM. This is
	   * automatically called on window load.
	   */
	  upgradeAllRegistered: function() {},
	  /**
	   * Allows user to be alerted to any upgrades that are performed for a given
	   * component type
	   *
	   * @param {string} jsClass The class name of the MDL component we wish
	   * to hook into for any upgrades performed.
	   * @param {function(!HTMLElement)} callback The function to call upon an
	   * upgrade. This function should expect 1 parameter - the HTMLElement which
	   * got upgraded.
	   */
	  registerUpgradedCallback: function(jsClass, callback) {},
	  /**
	   * Registers a class for future use and attempts to upgrade existing DOM.
	   *
	   * @param {componentHandler.ComponentConfigPublic} config the registration configuration
	   */
	  register: function(config) {},
	  /**
	   * Downgrade either a given node, an array of nodes, or a NodeList.
	   *
	   * @param {!Node|!Array<!Node>|!NodeList} nodes
	   */
	  downgradeElements: function(nodes) {}
	};
	
	componentHandler = (function() {
	  'use strict';
	
	  /** @type {!Array<componentHandler.ComponentConfig>} */
	  var registeredComponents_ = [];
	
	  /** @type {!Array<componentHandler.Component>} */
	  var createdComponents_ = [];
	
	  var componentConfigProperty_ = 'mdlComponentConfigInternal_';
	
	  /**
	   * Searches registered components for a class we are interested in using.
	   * Optionally replaces a match with passed object if specified.
	   *
	   * @param {string} name The name of a class we want to use.
	   * @param {componentHandler.ComponentConfig=} optReplace Optional object to replace match with.
	   * @return {!Object|boolean}
	   * @private
	   */
	  function findRegisteredClass_(name, optReplace) {
	    for (var i = 0; i < registeredComponents_.length; i++) {
	      if (registeredComponents_[i].className === name) {
	        if (typeof optReplace !== 'undefined') {
	          registeredComponents_[i] = optReplace;
	        }
	        return registeredComponents_[i];
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Returns an array of the classNames of the upgraded classes on the element.
	   *
	   * @param {!Element} element The element to fetch data from.
	   * @return {!Array<string>}
	   * @private
	   */
	  function getUpgradedListOfElement_(element) {
	    var dataUpgraded = element.getAttribute('data-upgraded');
	    // Use `['']` as default value to conform the `,name,name...` style.
	    return dataUpgraded === null ? [''] : dataUpgraded.split(',');
	  }
	
	  /**
	   * Returns true if the given element has already been upgraded for the given
	   * class.
	   *
	   * @param {!Element} element The element we want to check.
	   * @param {string} jsClass The class to check for.
	   * @returns {boolean}
	   * @private
	   */
	  function isElementUpgraded_(element, jsClass) {
	    var upgradedList = getUpgradedListOfElement_(element);
	    return upgradedList.indexOf(jsClass) !== -1;
	  }
	
	  /**
	   * Searches existing DOM for elements of our component type and upgrades them
	   * if they have not already been upgraded.
	   *
	   * @param {string=} optJsClass the programatic name of the element class we
	   * need to create a new instance of.
	   * @param {string=} optCssClass the name of the CSS class elements of this
	   * type will have.
	   */
	  function upgradeDomInternal(optJsClass, optCssClass) {
	    if (typeof optJsClass === 'undefined' &&
	        typeof optCssClass === 'undefined') {
	      for (var i = 0; i < registeredComponents_.length; i++) {
	        upgradeDomInternal(registeredComponents_[i].className,
	            registeredComponents_[i].cssClass);
	      }
	    } else {
	      var jsClass = /** @type {string} */ (optJsClass);
	      if (typeof optCssClass === 'undefined') {
	        var registeredClass = findRegisteredClass_(jsClass);
	        if (registeredClass) {
	          optCssClass = registeredClass.cssClass;
	        }
	      }
	
	      var elements = document.querySelectorAll('.' + optCssClass);
	      for (var n = 0; n < elements.length; n++) {
	        upgradeElementInternal(elements[n], jsClass);
	      }
	    }
	  }
	
	  /**
	   * Upgrades a specific element rather than all in the DOM.
	   *
	   * @param {!Element} element The element we wish to upgrade.
	   * @param {string=} optJsClass Optional name of the class we want to upgrade
	   * the element to.
	   */
	  function upgradeElementInternal(element, optJsClass) {
	    // Verify argument type.
	    if (!(typeof element === 'object' && element instanceof Element)) {
	      throw new Error('Invalid argument provided to upgrade MDL element.');
	    }
	    var upgradedList = getUpgradedListOfElement_(element);
	    var classesToUpgrade = [];
	    // If jsClass is not provided scan the registered components to find the
	    // ones matching the element's CSS classList.
	    if (!optJsClass) {
	      var classList = element.classList;
	      registeredComponents_.forEach(function(component) {
	        // Match CSS & Not to be upgraded & Not upgraded.
	        if (classList.contains(component.cssClass) &&
	            classesToUpgrade.indexOf(component) === -1 &&
	            !isElementUpgraded_(element, component.className)) {
	          classesToUpgrade.push(component);
	        }
	      });
	    } else if (!isElementUpgraded_(element, optJsClass)) {
	      classesToUpgrade.push(findRegisteredClass_(optJsClass));
	    }
	
	    // Upgrade the element for each classes.
	    for (var i = 0, n = classesToUpgrade.length, registeredClass; i < n; i++) {
	      registeredClass = classesToUpgrade[i];
	      if (registeredClass) {
	        // Mark element as upgraded.
	        upgradedList.push(registeredClass.className);
	        element.setAttribute('data-upgraded', upgradedList.join(','));
	        var instance = new registeredClass.classConstructor(element);
	        instance[componentConfigProperty_] = registeredClass;
	        createdComponents_.push(instance);
	        // Call any callbacks the user has registered with this component type.
	        for (var j = 0, m = registeredClass.callbacks.length; j < m; j++) {
	          registeredClass.callbacks[j](element);
	        }
	
	        if (registeredClass.widget) {
	          // Assign per element instance for control over API
	          element[registeredClass.className] = instance;
	        }
	      } else {
	        throw new Error(
	          'Unable to find a registered component for the given class.');
	      }
	
	      var ev;
	      if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
	        ev = new CustomEvent('mdl-componentupgraded', {
	          bubbles: true, cancelable: false
	        });
	      } else {
	        ev = document.createEvent('Events');
	        ev.initEvent('mdl-componentupgraded', true, true);
	      }
	      element.dispatchEvent(ev);
	    }
	  }
	
	  /**
	   * Upgrades a specific list of elements rather than all in the DOM.
	   *
	   * @param {!Element|!Array<!Element>|!NodeList|!HTMLCollection} elements
	   * The elements we wish to upgrade.
	   */
	  function upgradeElementsInternal(elements) {
	    if (!Array.isArray(elements)) {
	      if (elements instanceof Element) {
	        elements = [elements];
	      } else {
	        elements = Array.prototype.slice.call(elements);
	      }
	    }
	    for (var i = 0, n = elements.length, element; i < n; i++) {
	      element = elements[i];
	      if (element instanceof HTMLElement) {
	        upgradeElementInternal(element);
	        if (element.children.length > 0) {
	          upgradeElementsInternal(element.children);
	        }
	      }
	    }
	  }
	
	  /**
	   * Registers a class for future use and attempts to upgrade existing DOM.
	   *
	   * @param {componentHandler.ComponentConfigPublic} config
	   */
	  function registerInternal(config) {
	    // In order to support both Closure-compiled and uncompiled code accessing
	    // this method, we need to allow for both the dot and array syntax for
	    // property access. You'll therefore see the `foo.bar || foo['bar']`
	    // pattern repeated across this method.
	    var widgetMissing = (typeof config.widget === 'undefined' &&
	        typeof config['widget'] === 'undefined');
	    var widget = true;
	
	    if (!widgetMissing) {
	      widget = config.widget || config['widget'];
	    }
	
	    var newConfig = /** @type {componentHandler.ComponentConfig} */ ({
	      classConstructor: config.constructor || config['constructor'],
	      className: config.classAsString || config['classAsString'],
	      cssClass: config.cssClass || config['cssClass'],
	      widget: widget,
	      callbacks: []
	    });
	
	    registeredComponents_.forEach(function(item) {
	      if (item.cssClass === newConfig.cssClass) {
	        throw new Error('The provided cssClass has already been registered: ' + item.cssClass);
	      }
	      if (item.className === newConfig.className) {
	        throw new Error('The provided className has already been registered');
	      }
	    });
	
	    if (config.constructor.prototype
	        .hasOwnProperty(componentConfigProperty_)) {
	      throw new Error(
	          'MDL component classes must not have ' + componentConfigProperty_ +
	          ' defined as a property.');
	    }
	
	    var found = findRegisteredClass_(config.classAsString, newConfig);
	
	    if (!found) {
	      registeredComponents_.push(newConfig);
	    }
	  }
	
	  /**
	   * Allows user to be alerted to any upgrades that are performed for a given
	   * component type
	   *
	   * @param {string} jsClass The class name of the MDL component we wish
	   * to hook into for any upgrades performed.
	   * @param {function(!HTMLElement)} callback The function to call upon an
	   * upgrade. This function should expect 1 parameter - the HTMLElement which
	   * got upgraded.
	   */
	  function registerUpgradedCallbackInternal(jsClass, callback) {
	    var regClass = findRegisteredClass_(jsClass);
	    if (regClass) {
	      regClass.callbacks.push(callback);
	    }
	  }
	
	  /**
	   * Upgrades all registered components found in the current DOM. This is
	   * automatically called on window load.
	   */
	  function upgradeAllRegisteredInternal() {
	    for (var n = 0; n < registeredComponents_.length; n++) {
	      upgradeDomInternal(registeredComponents_[n].className);
	    }
	  }
	
	  /**
	   * Check the component for the downgrade method.
	   * Execute if found.
	   * Remove component from createdComponents list.
	   *
	   * @param {?componentHandler.Component} component
	   */
	  function deconstructComponentInternal(component) {
	    if (component) {
	      var componentIndex = createdComponents_.indexOf(component);
	      createdComponents_.splice(componentIndex, 1);
	
	      var upgrades = component.element_.getAttribute('data-upgraded').split(',');
	      var componentPlace = upgrades.indexOf(component[componentConfigProperty_].classAsString);
	      upgrades.splice(componentPlace, 1);
	      component.element_.setAttribute('data-upgraded', upgrades.join(','));
	
	      var ev;
	      if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
	        ev = new CustomEvent('mdl-componentdowngraded', {
	          bubbles: true, cancelable: false
	        });
	      } else {
	        ev = document.createEvent('Events');
	        ev.initEvent('mdl-componentdowngraded', true, true);
	      }
	      component.element_.dispatchEvent(ev);
	    }
	  }
	
	  /**
	   * Downgrade either a given node, an array of nodes, or a NodeList.
	   *
	   * @param {!Node|!Array<!Node>|!NodeList} nodes
	   */
	  function downgradeNodesInternal(nodes) {
	    /**
	     * Auxiliary function to downgrade a single node.
	     * @param  {!Node} node the node to be downgraded
	     */
	    var downgradeNode = function(node) {
	      createdComponents_.filter(function(item) {
	        return item.element_ === node;
	      }).forEach(deconstructComponentInternal);
	    };
	    if (nodes instanceof Array || nodes instanceof NodeList) {
	      for (var n = 0; n < nodes.length; n++) {
	        downgradeNode(nodes[n]);
	      }
	    } else if (nodes instanceof Node) {
	      downgradeNode(nodes);
	    } else {
	      throw new Error('Invalid argument provided to downgrade MDL nodes.');
	    }
	  }
	
	  // Now return the functions that should be made public with their publicly
	  // facing names...
	  return {
	    upgradeDom: upgradeDomInternal,
	    upgradeElement: upgradeElementInternal,
	    upgradeElements: upgradeElementsInternal,
	    upgradeAllRegistered: upgradeAllRegisteredInternal,
	    registerUpgradedCallback: registerUpgradedCallbackInternal,
	    register: registerInternal,
	    downgradeElements: downgradeNodesInternal
	  };
	})();
	
	/**
	 * Describes the type of a registered component type managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   constructor: Function,
	 *   classAsString: string,
	 *   cssClass: string,
	 *   widget: (string|boolean|undefined)
	 * }}
	 */
	componentHandler.ComponentConfigPublic;  // jshint ignore:line
	
	/**
	 * Describes the type of a registered component type managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   constructor: !Function,
	 *   className: string,
	 *   cssClass: string,
	 *   widget: (string|boolean),
	 *   callbacks: !Array<function(!HTMLElement)>
	 * }}
	 */
	componentHandler.ComponentConfig;  // jshint ignore:line
	
	/**
	 * Created component (i.e., upgraded element) type as managed by
	 * componentHandler. Provided for benefit of the Closure compiler.
	 *
	 * @typedef {{
	 *   element_: !HTMLElement,
	 *   className: string,
	 *   classAsString: string,
	 *   cssClass: string,
	 *   widget: string
	 * }}
	 */
	componentHandler.Component;  // jshint ignore:line
	
	// Export all symbols, for the benefit of Closure compiler.
	// No effect on uncompiled code.
	componentHandler['upgradeDom'] = componentHandler.upgradeDom;
	componentHandler['upgradeElement'] = componentHandler.upgradeElement;
	componentHandler['upgradeElements'] = componentHandler.upgradeElements;
	componentHandler['upgradeAllRegistered'] =
	    componentHandler.upgradeAllRegistered;
	componentHandler['registerUpgradedCallback'] =
	    componentHandler.registerUpgradedCallback;
	componentHandler['register'] = componentHandler.register;
	componentHandler['downgradeElements'] = componentHandler.downgradeElements;
	window.componentHandler = componentHandler;
	window['componentHandler'] = componentHandler;
	
	window.addEventListener('load', function() {
	  'use strict';
	
	  /**
	   * Performs a "Cutting the mustard" test. If the browser supports the features
	   * tested, adds a mdl-js class to the <html> element. It then upgrades all MDL
	   * components requiring JavaScript.
	   */
	  if ('classList' in document.createElement('div') &&
	      'querySelector' in document &&
	      'addEventListener' in window && Array.prototype.forEach) {
	    document.documentElement.classList.add('mdl-js');
	  } else {
	    /**
	     * Dummy function to avoid JS errors.
	     */
	    componentHandler.upgradeElement = function() {};
	    /**
	     * Dummy function to avoid JS errors.
	     */
	    componentHandler.register = function() {};
	  }
	});
	
	// Source: https://github.com/darius/requestAnimationFrame/blob/master/requestAnimationFrame.js
	// Adapted from https://gist.github.com/paulirish/1579671 which derived from
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	// requestAnimationFrame polyfill by Erik Möller.
	// Fixes from Paul Irish, Tino Zijdel, Andrew Mao, Klemen Slavič, Darius Bacon
	// MIT license
	if (!Date.now) {
	    /**
	   * Date.now polyfill.
	   * @return {number} the current Date
	   */
	    Date.now = function () {
	        return new Date().getTime();
	    };
	    Date['now'] = Date.now;
	}
	var vendors = [
	    'webkit',
	    'moz'
	];
	for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
	    var vp = vendors[i];
	    window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
	    window['requestAnimationFrame'] = window.requestAnimationFrame;
	    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	}
	if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
	    var lastTime = 0;
	    /**
	   * requestAnimationFrame polyfill.
	   * @param  {!Function} callback the callback function.
	   */
	    window.requestAnimationFrame = function (callback) {
	        var now = Date.now();
	        var nextTime = Math.max(lastTime + 16, now);
	        return setTimeout(function () {
	            callback(lastTime = nextTime);
	        }, nextTime - now);
	    };
	    window.cancelAnimationFrame = clearTimeout;
	    window['requestAnimationFrame'] = window.requestAnimationFrame;
	    window['cancelAnimationFrame'] = window.cancelAnimationFrame;
	}
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Button MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialButton = function MaterialButton(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialButton'] = MaterialButton;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialButton.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialButton.prototype.CssClasses_ = {
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_CONTAINER: 'mdl-button__ripple-container',
	    RIPPLE: 'mdl-ripple'
	};
	/**
	   * Handle blur of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialButton.prototype.blurHandler_ = function (event) {
	    if (event) {
	        this.element_.blur();
	    }
	};
	// Public methods.
	/**
	   * Disable button.
	   *
	   * @public
	   */
	MaterialButton.prototype.disable = function () {
	    this.element_.disabled = true;
	};
	MaterialButton.prototype['disable'] = MaterialButton.prototype.disable;
	/**
	   * Enable button.
	   *
	   * @public
	   */
	MaterialButton.prototype.enable = function () {
	    this.element_.disabled = false;
	};
	MaterialButton.prototype['enable'] = MaterialButton.prototype.enable;
	/**
	   * Initialize element.
	   */
	MaterialButton.prototype.init = function () {
	    if (this.element_) {
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            var rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleElement_ = document.createElement('span');
	            this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	            rippleContainer.appendChild(this.rippleElement_);
	            this.boundRippleBlurHandler = this.blurHandler_.bind(this);
	            this.rippleElement_.addEventListener('mouseup', this.boundRippleBlurHandler);
	            this.element_.appendChild(rippleContainer);
	        }
	        this.boundButtonBlurHandler = this.blurHandler_.bind(this);
	        this.element_.addEventListener('mouseup', this.boundButtonBlurHandler);
	        this.element_.addEventListener('mouseleave', this.boundButtonBlurHandler);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialButton,
	    classAsString: 'MaterialButton',
	    cssClass: 'mdl-js-button',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Checkbox MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialCheckbox = function MaterialCheckbox(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialCheckbox'] = MaterialCheckbox;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialCheckbox.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialCheckbox.prototype.CssClasses_ = {
	    INPUT: 'mdl-checkbox__input',
	    BOX_OUTLINE: 'mdl-checkbox__box-outline',
	    FOCUS_HELPER: 'mdl-checkbox__focus-helper',
	    TICK_OUTLINE: 'mdl-checkbox__tick-outline',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-checkbox__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialCheckbox.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialCheckbox.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialCheckbox.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the inputs toggle state and update display.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialCheckbox.prototype['checkToggleState'] = MaterialCheckbox.prototype.checkToggleState;
	/**
	   * Check the inputs disabled state and update display.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialCheckbox.prototype['checkDisabled'] = MaterialCheckbox.prototype.checkDisabled;
	/**
	   * Disable checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['disable'] = MaterialCheckbox.prototype.disable;
	/**
	   * Enable checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['enable'] = MaterialCheckbox.prototype.enable;
	/**
	   * Check checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.check = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['check'] = MaterialCheckbox.prototype.check;
	/**
	   * Uncheck checkbox.
	   *
	   * @public
	   */
	MaterialCheckbox.prototype.uncheck = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialCheckbox.prototype['uncheck'] = MaterialCheckbox.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialCheckbox.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        var boxOutline = document.createElement('span');
	        boxOutline.classList.add(this.CssClasses_.BOX_OUTLINE);
	        var tickContainer = document.createElement('span');
	        tickContainer.classList.add(this.CssClasses_.FOCUS_HELPER);
	        var tickOutline = document.createElement('span');
	        tickOutline.classList.add(this.CssClasses_.TICK_OUTLINE);
	        boxOutline.appendChild(tickOutline);
	        this.element_.appendChild(tickContainer);
	        this.element_.appendChild(boxOutline);
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundInputOnChange = this.onChange_.bind(this);
	        this.boundInputOnFocus = this.onFocus_.bind(this);
	        this.boundInputOnBlur = this.onBlur_.bind(this);
	        this.boundElementMouseUp = this.onMouseUp_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundInputOnChange);
	        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	        this.element_.addEventListener('mouseup', this.boundElementMouseUp);
	        this.updateClasses_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialCheckbox,
	    classAsString: 'MaterialCheckbox',
	    cssClass: 'mdl-js-checkbox',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for icon toggle MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialIconToggle = function MaterialIconToggle(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialIconToggle'] = MaterialIconToggle;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialIconToggle.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialIconToggle.prototype.CssClasses_ = {
	    INPUT: 'mdl-icon-toggle__input',
	    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-icon-toggle__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialIconToggle.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialIconToggle.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialIconToggle.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the inputs toggle state and update display.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialIconToggle.prototype['checkToggleState'] = MaterialIconToggle.prototype.checkToggleState;
	/**
	   * Check the inputs disabled state and update display.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialIconToggle.prototype['checkDisabled'] = MaterialIconToggle.prototype.checkDisabled;
	/**
	   * Disable icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['disable'] = MaterialIconToggle.prototype.disable;
	/**
	   * Enable icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['enable'] = MaterialIconToggle.prototype.enable;
	/**
	   * Check icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.check = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['check'] = MaterialIconToggle.prototype.check;
	/**
	   * Uncheck icon toggle.
	   *
	   * @public
	   */
	MaterialIconToggle.prototype.uncheck = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialIconToggle.prototype['uncheck'] = MaterialIconToggle.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialIconToggle.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        if (this.element_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.JS_RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.boundRippleMouseUp = this.onMouseUp_.bind(this);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundRippleMouseUp);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundInputOnChange = this.onChange_.bind(this);
	        this.boundInputOnFocus = this.onFocus_.bind(this);
	        this.boundInputOnBlur = this.onBlur_.bind(this);
	        this.boundElementOnMouseUp = this.onMouseUp_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundInputOnChange);
	        this.inputElement_.addEventListener('focus', this.boundInputOnFocus);
	        this.inputElement_.addEventListener('blur', this.boundInputOnBlur);
	        this.element_.addEventListener('mouseup', this.boundElementOnMouseUp);
	        this.updateClasses_();
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialIconToggle,
	    classAsString: 'MaterialIconToggle',
	    cssClass: 'mdl-js-icon-toggle',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for dropdown MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialMenu = function MaterialMenu(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialMenu'] = MaterialMenu;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialMenu.prototype.Constant_ = {
	    // Total duration of the menu animation.
	    TRANSITION_DURATION_SECONDS: 0.3,
	    // The fraction of the total duration we want to use for menu item animations.
	    TRANSITION_DURATION_FRACTION: 0.8,
	    // How long the menu stays open after choosing an option (so the user can see
	    // the ripple).
	    CLOSE_TIMEOUT: 150
	};
	/**
	   * Keycodes, for code readability.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialMenu.prototype.Keycodes_ = {
	    ENTER: 13,
	    ESCAPE: 27,
	    SPACE: 32,
	    UP_ARROW: 38,
	    DOWN_ARROW: 40
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialMenu.prototype.CssClasses_ = {
	    CONTAINER: 'mdl-menu__container',
	    OUTLINE: 'mdl-menu__outline',
	    ITEM: 'mdl-menu__item',
	    ITEM_RIPPLE_CONTAINER: 'mdl-menu__item-ripple-container',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE: 'mdl-ripple',
	    // Statuses
	    IS_UPGRADED: 'is-upgraded',
	    IS_VISIBLE: 'is-visible',
	    IS_ANIMATING: 'is-animating',
	    // Alignment options
	    BOTTOM_LEFT: 'mdl-menu--bottom-left',
	    // This is the default.
	    BOTTOM_RIGHT: 'mdl-menu--bottom-right',
	    TOP_LEFT: 'mdl-menu--top-left',
	    TOP_RIGHT: 'mdl-menu--top-right',
	    UNALIGNED: 'mdl-menu--unaligned'
	};
	/**
	   * Initialize element.
	   */
	MaterialMenu.prototype.init = function () {
	    if (this.element_) {
	        // Create container for the menu.
	        var container = document.createElement('div');
	        container.classList.add(this.CssClasses_.CONTAINER);
	        this.element_.parentElement.insertBefore(container, this.element_);
	        this.element_.parentElement.removeChild(this.element_);
	        container.appendChild(this.element_);
	        this.container_ = container;
	        // Create outline for the menu (shadow and background).
	        var outline = document.createElement('div');
	        outline.classList.add(this.CssClasses_.OUTLINE);
	        this.outline_ = outline;
	        container.insertBefore(outline, this.element_);
	        // Find the "for" element and bind events to it.
	        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
	        var forEl = null;
	        if (forElId) {
	            forEl = document.getElementById(forElId);
	            if (forEl) {
	                this.forElement_ = forEl;
	                forEl.addEventListener('click', this.handleForClick_.bind(this));
	                forEl.addEventListener('keydown', this.handleForKeyboardEvent_.bind(this));
	            }
	        }
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        this.boundItemKeydown_ = this.handleItemKeyboardEvent_.bind(this);
	        this.boundItemClick_ = this.handleItemClick_.bind(this);
	        for (var i = 0; i < items.length; i++) {
	            // Add a listener to each menu item.
	            items[i].addEventListener('click', this.boundItemClick_);
	            // Add a tab index to each menu item.
	            items[i].tabIndex = '-1';
	            // Add a keyboard listener to each menu item.
	            items[i].addEventListener('keydown', this.boundItemKeydown_);
	        }
	        // Add ripple classes to each item, if the user has enabled ripples.
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            for (i = 0; i < items.length; i++) {
	                var item = items[i];
	                var rippleContainer = document.createElement('span');
	                rippleContainer.classList.add(this.CssClasses_.ITEM_RIPPLE_CONTAINER);
	                var ripple = document.createElement('span');
	                ripple.classList.add(this.CssClasses_.RIPPLE);
	                rippleContainer.appendChild(ripple);
	                item.appendChild(rippleContainer);
	                item.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            }
	        }
	        // Copy alignment classes to the container, so the outline can use them.
	        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_LEFT)) {
	            this.outline_.classList.add(this.CssClasses_.BOTTOM_LEFT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	            this.outline_.classList.add(this.CssClasses_.BOTTOM_RIGHT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	            this.outline_.classList.add(this.CssClasses_.TOP_LEFT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	            this.outline_.classList.add(this.CssClasses_.TOP_RIGHT);
	        }
	        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	            this.outline_.classList.add(this.CssClasses_.UNALIGNED);
	        }
	        container.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	/**
	   * Handles a click on the "for" element, by positioning the menu and then
	   * toggling it.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleForClick_ = function (evt) {
	    if (this.element_ && this.forElement_) {
	        var rect = this.forElement_.getBoundingClientRect();
	        var forRect = this.forElement_.parentElement.getBoundingClientRect();
	        if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	        } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	            // Position below the "for" element, aligned to its right.
	            this.container_.style.right = forRect.right - rect.right + 'px';
	            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	            // Position above the "for" element, aligned to its left.
	            this.container_.style.left = this.forElement_.offsetLeft + 'px';
	            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	        } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	            // Position above the "for" element, aligned to its right.
	            this.container_.style.right = forRect.right - rect.right + 'px';
	            this.container_.style.bottom = forRect.bottom - rect.top + 'px';
	        } else {
	            // Default: position below the "for" element, aligned to its left.
	            this.container_.style.left = this.forElement_.offsetLeft + 'px';
	            this.container_.style.top = this.forElement_.offsetTop + this.forElement_.offsetHeight + 'px';
	        }
	    }
	    this.toggle(evt);
	};
	/**
	   * Handles a keyboard event on the "for" element.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleForKeyboardEvent_ = function (evt) {
	    if (this.element_ && this.container_ && this.forElement_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                evt.preventDefault();
	                items[items.length - 1].focus();
	            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                evt.preventDefault();
	                items[0].focus();
	            }
	        }
	    }
	};
	/**
	   * Handles a keyboard event on an item.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleItemKeyboardEvent_ = function (evt) {
	    if (this.element_ && this.container_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM + ':not([disabled])');
	        if (items && items.length > 0 && this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	            var currentIndex = Array.prototype.slice.call(items).indexOf(evt.target);
	            if (evt.keyCode === this.Keycodes_.UP_ARROW) {
	                evt.preventDefault();
	                if (currentIndex > 0) {
	                    items[currentIndex - 1].focus();
	                } else {
	                    items[items.length - 1].focus();
	                }
	            } else if (evt.keyCode === this.Keycodes_.DOWN_ARROW) {
	                evt.preventDefault();
	                if (items.length > currentIndex + 1) {
	                    items[currentIndex + 1].focus();
	                } else {
	                    items[0].focus();
	                }
	            } else if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	                evt.preventDefault();
	                // Send mousedown and mouseup to trigger ripple.
	                var e = new MouseEvent('mousedown');
	                evt.target.dispatchEvent(e);
	                e = new MouseEvent('mouseup');
	                evt.target.dispatchEvent(e);
	                // Send click.
	                evt.target.click();
	            } else if (evt.keyCode === this.Keycodes_.ESCAPE) {
	                evt.preventDefault();
	                this.hide();
	            }
	        }
	    }
	};
	/**
	   * Handles a click event on an item.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialMenu.prototype.handleItemClick_ = function (evt) {
	    if (evt.target.hasAttribute('disabled')) {
	        evt.stopPropagation();
	    } else {
	        // Wait some time before closing menu, so the user can see the ripple.
	        this.closing_ = true;
	        window.setTimeout(function (evt) {
	            this.hide();
	            this.closing_ = false;
	        }.bind(this), this.Constant_.CLOSE_TIMEOUT);
	    }
	};
	/**
	   * Calculates the initial clip (for opening the menu) or final clip (for closing
	   * it), and applies it. This allows us to animate from or to the correct point,
	   * that is, the point it's aligned to in the "for" element.
	   *
	   * @param {number} height Height of the clip rectangle
	   * @param {number} width Width of the clip rectangle
	   * @private
	   */
	MaterialMenu.prototype.applyClip_ = function (height, width) {
	    if (this.element_.classList.contains(this.CssClasses_.UNALIGNED)) {
	        // Do not clip.
	        this.element_.style.clip = '';
	    } else if (this.element_.classList.contains(this.CssClasses_.BOTTOM_RIGHT)) {
	        // Clip to the top right corner of the menu.
	        this.element_.style.clip = 'rect(0 ' + width + 'px ' + '0 ' + width + 'px)';
	    } else if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT)) {
	        // Clip to the bottom left corner of the menu.
	        this.element_.style.clip = 'rect(' + height + 'px 0 ' + height + 'px 0)';
	    } else if (this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	        // Clip to the bottom right corner of the menu.
	        this.element_.style.clip = 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)';
	    } else {
	        // Default: do not clip (same as clipping to the top left corner).
	        this.element_.style.clip = '';
	    }
	};
	/**
	   * Cleanup function to remove animation listeners.
	   *
	   * @param {Event} evt
	   * @private
	   */
	MaterialMenu.prototype.removeAnimationEndListener_ = function (evt) {
	    evt.target.classList.remove(MaterialMenu.prototype.CssClasses_.IS_ANIMATING);
	};
	/**
	   * Adds an event listener to clean up after the animation ends.
	   *
	   * @private
	   */
	MaterialMenu.prototype.addAnimationEndListener_ = function () {
	    this.element_.addEventListener('transitionend', this.removeAnimationEndListener_);
	    this.element_.addEventListener('webkitTransitionEnd', this.removeAnimationEndListener_);
	};
	/**
	   * Displays the menu.
	   *
	   * @public
	   */
	MaterialMenu.prototype.show = function (evt) {
	    if (this.element_ && this.container_ && this.outline_) {
	        // Measure the inner element.
	        var height = this.element_.getBoundingClientRect().height;
	        var width = this.element_.getBoundingClientRect().width;
	        // Apply the inner element's size to the container and outline.
	        this.container_.style.width = width + 'px';
	        this.container_.style.height = height + 'px';
	        this.outline_.style.width = width + 'px';
	        this.outline_.style.height = height + 'px';
	        var transitionDuration = this.Constant_.TRANSITION_DURATION_SECONDS * this.Constant_.TRANSITION_DURATION_FRACTION;
	        // Calculate transition delays for individual menu items, so that they fade
	        // in one at a time.
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        for (var i = 0; i < items.length; i++) {
	            var itemDelay = null;
	            if (this.element_.classList.contains(this.CssClasses_.TOP_LEFT) || this.element_.classList.contains(this.CssClasses_.TOP_RIGHT)) {
	                itemDelay = (height - items[i].offsetTop - items[i].offsetHeight) / height * transitionDuration + 's';
	            } else {
	                itemDelay = items[i].offsetTop / height * transitionDuration + 's';
	            }
	            items[i].style.transitionDelay = itemDelay;
	        }
	        // Apply the initial clip to the text before we start animating.
	        this.applyClip_(height, width);
	        // Wait for the next frame, turn on animation, and apply the final clip.
	        // Also make it visible. This triggers the transitions.
	        window.requestAnimationFrame(function () {
	            this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	            this.element_.style.clip = 'rect(0 ' + width + 'px ' + height + 'px 0)';
	            this.container_.classList.add(this.CssClasses_.IS_VISIBLE);
	        }.bind(this));
	        // Clean up after the animation is complete.
	        this.addAnimationEndListener_();
	        // Add a click listener to the document, to close the menu.
	        var callback = function (e) {
	            // Check to see if the document is processing the same event that
	            // displayed the menu in the first place. If so, do nothing.
	            // Also check to see if the menu is in the process of closing itself, and
	            // do nothing in that case.
	            // Also check if the clicked element is a menu item
	            // if so, do nothing.
	            if (e !== evt && !this.closing_ && e.target.parentNode !== this.element_) {
	                document.removeEventListener('click', callback);
	                this.hide();
	            }
	        }.bind(this);
	        document.addEventListener('click', callback);
	    }
	};
	MaterialMenu.prototype['show'] = MaterialMenu.prototype.show;
	/**
	   * Hides the menu.
	   *
	   * @public
	   */
	MaterialMenu.prototype.hide = function () {
	    if (this.element_ && this.container_ && this.outline_) {
	        var items = this.element_.querySelectorAll('.' + this.CssClasses_.ITEM);
	        // Remove all transition delays; menu items fade out concurrently.
	        for (var i = 0; i < items.length; i++) {
	            items[i].style.removeProperty('transition-delay');
	        }
	        // Measure the inner element.
	        var rect = this.element_.getBoundingClientRect();
	        var height = rect.height;
	        var width = rect.width;
	        // Turn on animation, and apply the final clip. Also make invisible.
	        // This triggers the transitions.
	        this.element_.classList.add(this.CssClasses_.IS_ANIMATING);
	        this.applyClip_(height, width);
	        this.container_.classList.remove(this.CssClasses_.IS_VISIBLE);
	        // Clean up after the animation is complete.
	        this.addAnimationEndListener_();
	    }
	};
	MaterialMenu.prototype['hide'] = MaterialMenu.prototype.hide;
	/**
	   * Displays or hides the menu, depending on current state.
	   *
	   * @public
	   */
	MaterialMenu.prototype.toggle = function (evt) {
	    if (this.container_.classList.contains(this.CssClasses_.IS_VISIBLE)) {
	        this.hide();
	    } else {
	        this.show(evt);
	    }
	};
	MaterialMenu.prototype['toggle'] = MaterialMenu.prototype.toggle;
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialMenu,
	    classAsString: 'MaterialMenu',
	    cssClass: 'mdl-js-menu',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Progress MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialProgress = function MaterialProgress(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialProgress'] = MaterialProgress;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialProgress.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialProgress.prototype.CssClasses_ = { INDETERMINATE_CLASS: 'mdl-progress__indeterminate' };
	/**
	   * Set the current progress of the progressbar.
	   *
	   * @param {number} p Percentage of the progress (0-100)
	   * @public
	   */
	MaterialProgress.prototype.setProgress = function (p) {
	    if (this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS)) {
	        return;
	    }
	    this.progressbar_.style.width = p + '%';
	};
	MaterialProgress.prototype['setProgress'] = MaterialProgress.prototype.setProgress;
	/**
	   * Set the current progress of the buffer.
	   *
	   * @param {number} p Percentage of the buffer (0-100)
	   * @public
	   */
	MaterialProgress.prototype.setBuffer = function (p) {
	    this.bufferbar_.style.width = p + '%';
	    this.auxbar_.style.width = 100 - p + '%';
	};
	MaterialProgress.prototype['setBuffer'] = MaterialProgress.prototype.setBuffer;
	/**
	   * Initialize element.
	   */
	MaterialProgress.prototype.init = function () {
	    if (this.element_) {
	        var el = document.createElement('div');
	        el.className = 'progressbar bar bar1';
	        this.element_.appendChild(el);
	        this.progressbar_ = el;
	        el = document.createElement('div');
	        el.className = 'bufferbar bar bar2';
	        this.element_.appendChild(el);
	        this.bufferbar_ = el;
	        el = document.createElement('div');
	        el.className = 'auxbar bar bar3';
	        this.element_.appendChild(el);
	        this.auxbar_ = el;
	        this.progressbar_.style.width = '0%';
	        this.bufferbar_.style.width = '100%';
	        this.auxbar_.style.width = '0%';
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialProgress,
	    classAsString: 'MaterialProgress',
	    cssClass: 'mdl-js-progress',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Radio MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialRadio = function MaterialRadio(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialRadio'] = MaterialRadio;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialRadio.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialRadio.prototype.CssClasses_ = {
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked',
	    IS_UPGRADED: 'is-upgraded',
	    JS_RADIO: 'mdl-js-radio',
	    RADIO_BTN: 'mdl-radio__button',
	    RADIO_OUTER_CIRCLE: 'mdl-radio__outer-circle',
	    RADIO_INNER_CIRCLE: 'mdl-radio__inner-circle',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-radio__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onChange_ = function (event) {
	    // Since other radio buttons don't get change events, we need to look for
	    // them to update their classes.
	    var radios = document.getElementsByClassName(this.CssClasses_.JS_RADIO);
	    for (var i = 0; i < radios.length; i++) {
	        var button = radios[i].querySelector('.' + this.CssClasses_.RADIO_BTN);
	        // Different name == different group, so no point updating those.
	        if (button.getAttribute('name') === this.btnElement_.getAttribute('name')) {
	            radios[i]['MaterialRadio'].updateClasses_();
	        }
	    }
	};
	/**
	   * Handle focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRadio.prototype.onMouseup_ = function (event) {
	    this.blur_();
	};
	/**
	   * Update classes.
	   *
	   * @private
	   */
	MaterialRadio.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialRadio.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.btnElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the components disabled state.
	   *
	   * @public
	   */
	MaterialRadio.prototype.checkDisabled = function () {
	    if (this.btnElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialRadio.prototype['checkDisabled'] = MaterialRadio.prototype.checkDisabled;
	/**
	   * Check the components toggled state.
	   *
	   * @public
	   */
	MaterialRadio.prototype.checkToggleState = function () {
	    if (this.btnElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialRadio.prototype['checkToggleState'] = MaterialRadio.prototype.checkToggleState;
	/**
	   * Disable radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.disable = function () {
	    this.btnElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialRadio.prototype['disable'] = MaterialRadio.prototype.disable;
	/**
	   * Enable radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.enable = function () {
	    this.btnElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialRadio.prototype['enable'] = MaterialRadio.prototype.enable;
	/**
	   * Check radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.check = function () {
	    this.btnElement_.checked = true;
	    this.onChange_(null);
	};
	MaterialRadio.prototype['check'] = MaterialRadio.prototype.check;
	/**
	   * Uncheck radio.
	   *
	   * @public
	   */
	MaterialRadio.prototype.uncheck = function () {
	    this.btnElement_.checked = false;
	    this.onChange_(null);
	};
	MaterialRadio.prototype['uncheck'] = MaterialRadio.prototype.uncheck;
	/**
	   * Initialize element.
	   */
	MaterialRadio.prototype.init = function () {
	    if (this.element_) {
	        this.btnElement_ = this.element_.querySelector('.' + this.CssClasses_.RADIO_BTN);
	        this.boundChangeHandler_ = this.onChange_.bind(this);
	        this.boundFocusHandler_ = this.onChange_.bind(this);
	        this.boundBlurHandler_ = this.onBlur_.bind(this);
	        this.boundMouseUpHandler_ = this.onMouseup_.bind(this);
	        var outerCircle = document.createElement('span');
	        outerCircle.classList.add(this.CssClasses_.RADIO_OUTER_CIRCLE);
	        var innerCircle = document.createElement('span');
	        innerCircle.classList.add(this.CssClasses_.RADIO_INNER_CIRCLE);
	        this.element_.appendChild(outerCircle);
	        this.element_.appendChild(innerCircle);
	        var rippleContainer;
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            rippleContainer.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            rippleContainer.addEventListener('mouseup', this.boundMouseUpHandler_);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            rippleContainer.appendChild(ripple);
	            this.element_.appendChild(rippleContainer);
	        }
	        this.btnElement_.addEventListener('change', this.boundChangeHandler_);
	        this.btnElement_.addEventListener('focus', this.boundFocusHandler_);
	        this.btnElement_.addEventListener('blur', this.boundBlurHandler_);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler_);
	        this.updateClasses_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialRadio,
	    classAsString: 'MaterialRadio',
	    cssClass: 'mdl-js-radio',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Slider MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSlider = function MaterialSlider(element) {
	    this.element_ = element;
	    // Browser feature detection.
	    this.isIE_ = window.navigator.msPointerEnabled;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSlider'] = MaterialSlider;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSlider.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSlider.prototype.CssClasses_ = {
	    IE_CONTAINER: 'mdl-slider__ie-container',
	    SLIDER_CONTAINER: 'mdl-slider__container',
	    BACKGROUND_FLEX: 'mdl-slider__background-flex',
	    BACKGROUND_LOWER: 'mdl-slider__background-lower',
	    BACKGROUND_UPPER: 'mdl-slider__background-upper',
	    IS_LOWEST_VALUE: 'is-lowest-value',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Handle input on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onInput_ = function (event) {
	    this.updateValueStyles_();
	};
	/**
	   * Handle change on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onChange_ = function (event) {
	    this.updateValueStyles_();
	};
	/**
	   * Handle mouseup on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSlider.prototype.onMouseUp_ = function (event) {
	    event.target.blur();
	};
	/**
	   * Handle mousedown on container element.
	   * This handler is purpose is to not require the use to click
	   * exactly on the 2px slider element, as FireFox seems to be very
	   * strict about this.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   * @suppress {missingProperties}
	   */
	MaterialSlider.prototype.onContainerMouseDown_ = function (event) {
	    // If this click is not on the parent element (but rather some child)
	    // ignore. It may still bubble up.
	    if (event.target !== this.element_.parentElement) {
	        return;
	    }
	    // Discard the original event and create a new event that
	    // is on the slider element.
	    event.preventDefault();
	    var newEvent = new MouseEvent('mousedown', {
	        target: event.target,
	        buttons: event.buttons,
	        clientX: event.clientX,
	        clientY: this.element_.getBoundingClientRect().y
	    });
	    this.element_.dispatchEvent(newEvent);
	};
	/**
	   * Handle updating of values.
	   *
	   * @private
	   */
	MaterialSlider.prototype.updateValueStyles_ = function () {
	    // Calculate and apply percentages to div structure behind slider.
	    var fraction = (this.element_.value - this.element_.min) / (this.element_.max - this.element_.min);
	    if (fraction === 0) {
	        this.element_.classList.add(this.CssClasses_.IS_LOWEST_VALUE);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_LOWEST_VALUE);
	    }
	    if (!this.isIE_) {
	        this.backgroundLower_.style.flex = fraction;
	        this.backgroundLower_.style.webkitFlex = fraction;
	        this.backgroundUpper_.style.flex = 1 - fraction;
	        this.backgroundUpper_.style.webkitFlex = 1 - fraction;
	    }
	};
	// Public methods.
	/**
	   * Disable slider.
	   *
	   * @public
	   */
	MaterialSlider.prototype.disable = function () {
	    this.element_.disabled = true;
	};
	MaterialSlider.prototype['disable'] = MaterialSlider.prototype.disable;
	/**
	   * Enable slider.
	   *
	   * @public
	   */
	MaterialSlider.prototype.enable = function () {
	    this.element_.disabled = false;
	};
	MaterialSlider.prototype['enable'] = MaterialSlider.prototype.enable;
	/**
	   * Update slider value.
	   *
	   * @param {number} value The value to which to set the control (optional).
	   * @public
	   */
	MaterialSlider.prototype.change = function (value) {
	    if (typeof value !== 'undefined') {
	        this.element_.value = value;
	    }
	    this.updateValueStyles_();
	};
	MaterialSlider.prototype['change'] = MaterialSlider.prototype.change;
	/**
	   * Initialize element.
	   */
	MaterialSlider.prototype.init = function () {
	    if (this.element_) {
	        if (this.isIE_) {
	            // Since we need to specify a very large height in IE due to
	            // implementation limitations, we add a parent here that trims it down to
	            // a reasonable size.
	            var containerIE = document.createElement('div');
	            containerIE.classList.add(this.CssClasses_.IE_CONTAINER);
	            this.element_.parentElement.insertBefore(containerIE, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            containerIE.appendChild(this.element_);
	        } else {
	            // For non-IE browsers, we need a div structure that sits behind the
	            // slider and allows us to style the left and right sides of it with
	            // different colors.
	            var container = document.createElement('div');
	            container.classList.add(this.CssClasses_.SLIDER_CONTAINER);
	            this.element_.parentElement.insertBefore(container, this.element_);
	            this.element_.parentElement.removeChild(this.element_);
	            container.appendChild(this.element_);
	            var backgroundFlex = document.createElement('div');
	            backgroundFlex.classList.add(this.CssClasses_.BACKGROUND_FLEX);
	            container.appendChild(backgroundFlex);
	            this.backgroundLower_ = document.createElement('div');
	            this.backgroundLower_.classList.add(this.CssClasses_.BACKGROUND_LOWER);
	            backgroundFlex.appendChild(this.backgroundLower_);
	            this.backgroundUpper_ = document.createElement('div');
	            this.backgroundUpper_.classList.add(this.CssClasses_.BACKGROUND_UPPER);
	            backgroundFlex.appendChild(this.backgroundUpper_);
	        }
	        this.boundInputHandler = this.onInput_.bind(this);
	        this.boundChangeHandler = this.onChange_.bind(this);
	        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	        this.boundContainerMouseDownHandler = this.onContainerMouseDown_.bind(this);
	        this.element_.addEventListener('input', this.boundInputHandler);
	        this.element_.addEventListener('change', this.boundChangeHandler);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	        this.element_.parentElement.addEventListener('mousedown', this.boundContainerMouseDownHandler);
	        this.updateValueStyles_();
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSlider,
	    classAsString: 'MaterialSlider',
	    cssClass: 'mdl-js-slider',
	    widget: true
	});
	/**
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Snackbar MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSnackbar = function MaterialSnackbar(element) {
	    this.element_ = element;
	    this.textElement_ = this.element_.querySelector('.' + this.cssClasses_.MESSAGE);
	    this.actionElement_ = this.element_.querySelector('.' + this.cssClasses_.ACTION);
	    if (!this.textElement_) {
	        throw new Error('There must be a message element for a snackbar.');
	    }
	    if (!this.actionElement_) {
	        throw new Error('There must be an action element for a snackbar.');
	    }
	    this.active = false;
	    this.actionHandler_ = undefined;
	    this.message_ = undefined;
	    this.actionText_ = undefined;
	    this.queuedNotifications_ = [];
	    this.setActionHidden_(true);
	};
	window['MaterialSnackbar'] = MaterialSnackbar;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSnackbar.prototype.Constant_ = {
	    // The duration of the snackbar show/hide animation, in ms.
	    ANIMATION_LENGTH: 250
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSnackbar.prototype.cssClasses_ = {
	    SNACKBAR: 'mdl-snackbar',
	    MESSAGE: 'mdl-snackbar__text',
	    ACTION: 'mdl-snackbar__action',
	    ACTIVE: 'mdl-snackbar--active'
	};
	/**
	   * Display the snackbar.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.displaySnackbar_ = function () {
	    this.element_.setAttribute('aria-hidden', 'true');
	    if (this.actionHandler_) {
	        this.actionElement_.textContent = this.actionText_;
	        this.actionElement_.addEventListener('click', this.actionHandler_);
	        this.setActionHidden_(false);
	    }
	    this.textElement_.textContent = this.message_;
	    this.element_.classList.add(this.cssClasses_.ACTIVE);
	    this.element_.setAttribute('aria-hidden', 'false');
	    setTimeout(this.cleanup_.bind(this), this.timeout_);
	};
	/**
	   * Show the snackbar.
	   *
	   * @param {Object} data The data for the notification.
	   * @public
	   */
	MaterialSnackbar.prototype.showSnackbar = function (data) {
	    if (data === undefined) {
	        throw new Error('Please provide a data object with at least a message to display.');
	    }
	    if (data['message'] === undefined) {
	        throw new Error('Please provide a message to be displayed.');
	    }
	    if (data['actionHandler'] && !data['actionText']) {
	        throw new Error('Please provide action text with the handler.');
	    }
	    if (this.active) {
	        this.queuedNotifications_.push(data);
	    } else {
	        this.active = true;
	        this.message_ = data['message'];
	        if (data['timeout']) {
	            this.timeout_ = data['timeout'];
	        } else {
	            this.timeout_ = 2750;
	        }
	        if (data['actionHandler']) {
	            this.actionHandler_ = data['actionHandler'];
	        }
	        if (data['actionText']) {
	            this.actionText_ = data['actionText'];
	        }
	        this.displaySnackbar_();
	    }
	};
	MaterialSnackbar.prototype['showSnackbar'] = MaterialSnackbar.prototype.showSnackbar;
	/**
	   * Check if the queue has items within it.
	   * If it does, display the next entry.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.checkQueue_ = function () {
	    if (this.queuedNotifications_.length > 0) {
	        this.showSnackbar(this.queuedNotifications_.shift());
	    }
	};
	/**
	   * Cleanup the snackbar event listeners and accessiblity attributes.
	   *
	   * @private
	   */
	MaterialSnackbar.prototype.cleanup_ = function () {
	    this.element_.classList.remove(this.cssClasses_.ACTIVE);
	    setTimeout(function () {
	        this.element_.setAttribute('aria-hidden', 'true');
	        this.textElement_.textContent = '';
	        if (!Boolean(this.actionElement_.getAttribute('aria-hidden'))) {
	            this.setActionHidden_(true);
	            this.actionElement_.textContent = '';
	            this.actionElement_.removeEventListener('click', this.actionHandler_);
	        }
	        this.actionHandler_ = undefined;
	        this.message_ = undefined;
	        this.actionText_ = undefined;
	        this.active = false;
	        this.checkQueue_();
	    }.bind(this), this.Constant_.ANIMATION_LENGTH);
	};
	/**
	   * Set the action handler hidden state.
	   *
	   * @param {boolean} value
	   * @private
	   */
	MaterialSnackbar.prototype.setActionHidden_ = function (value) {
	    if (value) {
	        this.actionElement_.setAttribute('aria-hidden', 'true');
	    } else {
	        this.actionElement_.removeAttribute('aria-hidden');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSnackbar,
	    classAsString: 'MaterialSnackbar',
	    cssClass: 'mdl-js-snackbar',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Spinner MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @param {HTMLElement} element The element that will be upgraded.
	   * @constructor
	   */
	var MaterialSpinner = function MaterialSpinner(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSpinner'] = MaterialSpinner;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSpinner.prototype.Constant_ = { MDL_SPINNER_LAYER_COUNT: 4 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSpinner.prototype.CssClasses_ = {
	    MDL_SPINNER_LAYER: 'mdl-spinner__layer',
	    MDL_SPINNER_CIRCLE_CLIPPER: 'mdl-spinner__circle-clipper',
	    MDL_SPINNER_CIRCLE: 'mdl-spinner__circle',
	    MDL_SPINNER_GAP_PATCH: 'mdl-spinner__gap-patch',
	    MDL_SPINNER_LEFT: 'mdl-spinner__left',
	    MDL_SPINNER_RIGHT: 'mdl-spinner__right'
	};
	/**
	   * Auxiliary method to create a spinner layer.
	   *
	   * @param {number} index Index of the layer to be created.
	   * @public
	   */
	MaterialSpinner.prototype.createLayer = function (index) {
	    var layer = document.createElement('div');
	    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);
	    layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER + '-' + index);
	    var leftClipper = document.createElement('div');
	    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	    leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);
	    var gapPatch = document.createElement('div');
	    gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);
	    var rightClipper = document.createElement('div');
	    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);
	    rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);
	    var circleOwners = [
	        leftClipper,
	        gapPatch,
	        rightClipper
	    ];
	    for (var i = 0; i < circleOwners.length; i++) {
	        var circle = document.createElement('div');
	        circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);
	        circleOwners[i].appendChild(circle);
	    }
	    layer.appendChild(leftClipper);
	    layer.appendChild(gapPatch);
	    layer.appendChild(rightClipper);
	    this.element_.appendChild(layer);
	};
	MaterialSpinner.prototype['createLayer'] = MaterialSpinner.prototype.createLayer;
	/**
	   * Stops the spinner animation.
	   * Public method for users who need to stop the spinner for any reason.
	   *
	   * @public
	   */
	MaterialSpinner.prototype.stop = function () {
	    this.element_.classList.remove('is-active');
	};
	MaterialSpinner.prototype['stop'] = MaterialSpinner.prototype.stop;
	/**
	   * Starts the spinner animation.
	   * Public method for users who need to manually start the spinner for any reason
	   * (instead of just adding the 'is-active' class to their markup).
	   *
	   * @public
	   */
	MaterialSpinner.prototype.start = function () {
	    this.element_.classList.add('is-active');
	};
	MaterialSpinner.prototype['start'] = MaterialSpinner.prototype.start;
	/**
	   * Initialize element.
	   */
	MaterialSpinner.prototype.init = function () {
	    if (this.element_) {
	        for (var i = 1; i <= this.Constant_.MDL_SPINNER_LAYER_COUNT; i++) {
	            this.createLayer(i);
	        }
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSpinner,
	    classAsString: 'MaterialSpinner',
	    cssClass: 'mdl-js-spinner',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Checkbox MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialSwitch = function MaterialSwitch(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialSwitch'] = MaterialSwitch;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialSwitch.prototype.Constant_ = { TINY_TIMEOUT: 0.001 };
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialSwitch.prototype.CssClasses_ = {
	    INPUT: 'mdl-switch__input',
	    TRACK: 'mdl-switch__track',
	    THUMB: 'mdl-switch__thumb',
	    FOCUS_HELPER: 'mdl-switch__focus-helper',
	    RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE_CONTAINER: 'mdl-switch__ripple-container',
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE: 'mdl-ripple',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_CHECKED: 'is-checked'
	};
	/**
	   * Handle change of state.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onChange_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus of element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle mouseup.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialSwitch.prototype.onMouseUp_ = function (event) {
	    this.blur_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialSwitch.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkToggleState();
	};
	/**
	   * Add blur.
	   *
	   * @private
	   */
	MaterialSwitch.prototype.blur_ = function () {
	    // TODO: figure out why there's a focus event being fired after our blur,
	    // so that we can avoid this hack.
	    window.setTimeout(function () {
	        this.inputElement_.blur();
	    }.bind(this), this.Constant_.TINY_TIMEOUT);
	};
	// Public methods.
	/**
	   * Check the components disabled state.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.checkDisabled = function () {
	    if (this.inputElement_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialSwitch.prototype['checkDisabled'] = MaterialSwitch.prototype.checkDisabled;
	/**
	   * Check the components toggled state.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.checkToggleState = function () {
	    if (this.inputElement_.checked) {
	        this.element_.classList.add(this.CssClasses_.IS_CHECKED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_CHECKED);
	    }
	};
	MaterialSwitch.prototype['checkToggleState'] = MaterialSwitch.prototype.checkToggleState;
	/**
	   * Disable switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.disable = function () {
	    this.inputElement_.disabled = true;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['disable'] = MaterialSwitch.prototype.disable;
	/**
	   * Enable switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.enable = function () {
	    this.inputElement_.disabled = false;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['enable'] = MaterialSwitch.prototype.enable;
	/**
	   * Activate switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.on = function () {
	    this.inputElement_.checked = true;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['on'] = MaterialSwitch.prototype.on;
	/**
	   * Deactivate switch.
	   *
	   * @public
	   */
	MaterialSwitch.prototype.off = function () {
	    this.inputElement_.checked = false;
	    this.updateClasses_();
	};
	MaterialSwitch.prototype['off'] = MaterialSwitch.prototype.off;
	/**
	   * Initialize element.
	   */
	MaterialSwitch.prototype.init = function () {
	    if (this.element_) {
	        this.inputElement_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        var track = document.createElement('div');
	        track.classList.add(this.CssClasses_.TRACK);
	        var thumb = document.createElement('div');
	        thumb.classList.add(this.CssClasses_.THUMB);
	        var focusHelper = document.createElement('span');
	        focusHelper.classList.add(this.CssClasses_.FOCUS_HELPER);
	        thumb.appendChild(focusHelper);
	        this.element_.appendChild(track);
	        this.element_.appendChild(thumb);
	        this.boundMouseUpHandler = this.onMouseUp_.bind(this);
	        if (this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)) {
	            this.element_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            this.rippleContainerElement_ = document.createElement('span');
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CONTAINER);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_EFFECT);
	            this.rippleContainerElement_.classList.add(this.CssClasses_.RIPPLE_CENTER);
	            this.rippleContainerElement_.addEventListener('mouseup', this.boundMouseUpHandler);
	            var ripple = document.createElement('span');
	            ripple.classList.add(this.CssClasses_.RIPPLE);
	            this.rippleContainerElement_.appendChild(ripple);
	            this.element_.appendChild(this.rippleContainerElement_);
	        }
	        this.boundChangeHandler = this.onChange_.bind(this);
	        this.boundFocusHandler = this.onFocus_.bind(this);
	        this.boundBlurHandler = this.onBlur_.bind(this);
	        this.inputElement_.addEventListener('change', this.boundChangeHandler);
	        this.inputElement_.addEventListener('focus', this.boundFocusHandler);
	        this.inputElement_.addEventListener('blur', this.boundBlurHandler);
	        this.element_.addEventListener('mouseup', this.boundMouseUpHandler);
	        this.updateClasses_();
	        this.element_.classList.add('is-upgraded');
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialSwitch,
	    classAsString: 'MaterialSwitch',
	    cssClass: 'mdl-js-switch',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Tabs MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {Element} element The element that will be upgraded.
	   */
	var MaterialTabs = function MaterialTabs(element) {
	    // Stores the HTML element.
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTabs'] = MaterialTabs;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTabs.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTabs.prototype.CssClasses_ = {
	    TAB_CLASS: 'mdl-tabs__tab',
	    PANEL_CLASS: 'mdl-tabs__panel',
	    ACTIVE_CLASS: 'is-active',
	    UPGRADED_CLASS: 'is-upgraded',
	    MDL_JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    MDL_RIPPLE_CONTAINER: 'mdl-tabs__ripple-container',
	    MDL_RIPPLE: 'mdl-ripple',
	    MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events'
	};
	/**
	   * Handle clicks to a tabs component
	   *
	   * @private
	   */
	MaterialTabs.prototype.initTabs_ = function () {
	    if (this.element_.classList.contains(this.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	        this.element_.classList.add(this.CssClasses_.MDL_JS_RIPPLE_EFFECT_IGNORE_EVENTS);
	    }
	    // Select element tabs, document panels
	    this.tabs_ = this.element_.querySelectorAll('.' + this.CssClasses_.TAB_CLASS);
	    this.panels_ = this.element_.querySelectorAll('.' + this.CssClasses_.PANEL_CLASS);
	    // Create new tabs for each tab element
	    for (var i = 0; i < this.tabs_.length; i++) {
	        new MaterialTab(this.tabs_[i], this);
	    }
	    this.element_.classList.add(this.CssClasses_.UPGRADED_CLASS);
	};
	/**
	   * Reset tab state, dropping active classes
	   *
	   * @private
	   */
	MaterialTabs.prototype.resetTabState_ = function () {
	    for (var k = 0; k < this.tabs_.length; k++) {
	        this.tabs_[k].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	    }
	};
	/**
	   * Reset panel state, droping active classes
	   *
	   * @private
	   */
	MaterialTabs.prototype.resetPanelState_ = function () {
	    for (var j = 0; j < this.panels_.length; j++) {
	        this.panels_[j].classList.remove(this.CssClasses_.ACTIVE_CLASS);
	    }
	};
	/**
	   * Initialize element.
	   */
	MaterialTabs.prototype.init = function () {
	    if (this.element_) {
	        this.initTabs_();
	    }
	};
	/**
	   * Constructor for an individual tab.
	   *
	   * @constructor
	   * @param {Element} tab The HTML element for the tab.
	   * @param {MaterialTabs} ctx The MaterialTabs object that owns the tab.
	   */
	function MaterialTab(tab, ctx) {
	    if (tab) {
	        if (ctx.element_.classList.contains(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT)) {
	            var rippleContainer = document.createElement('span');
	            rippleContainer.classList.add(ctx.CssClasses_.MDL_RIPPLE_CONTAINER);
	            rippleContainer.classList.add(ctx.CssClasses_.MDL_JS_RIPPLE_EFFECT);
	            var ripple = document.createElement('span');
	            ripple.classList.add(ctx.CssClasses_.MDL_RIPPLE);
	            rippleContainer.appendChild(ripple);
	            tab.appendChild(rippleContainer);
	        }
	        tab.addEventListener('click', function (e) {
	            e.preventDefault();
	            ctx.resetTabState_();
	            tab.classList.add(ctx.CssClasses_.ACTIVE_CLASS);
	        });
	    }
	}
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTabs,
	    classAsString: 'MaterialTabs',
	    cssClass: 'mdl-js-tabs'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Textfield MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialTextfield = function MaterialTextfield(element) {
	    this.element_ = element;
	    this.maxRows = this.Constant_.NO_MAX_ROWS;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTextfield'] = MaterialTextfield;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialTextfield.prototype.Constant_ = {
	    NO_MAX_ROWS: -1,
	    MAX_ROWS_ATTRIBUTE: 'maxrows'
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTextfield.prototype.CssClasses_ = {
	    LABEL: 'mdl-textfield__label',
	    INPUT: 'mdl-textfield__input',
	    IS_DIRTY: 'is-dirty',
	    IS_FOCUSED: 'is-focused',
	    IS_DISABLED: 'is-disabled',
	    IS_INVALID: 'is-invalid',
	    IS_UPGRADED: 'is-upgraded',
	    HAS_PLACEHOLDER: 'has-placeholder'
	};
	/**
	   * Handle input being entered.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onKeyDown_ = function (event) {
	    var currentRowCount = event.target.value.split('\n').length;
	    if (event.keyCode === 13) {
	        if (currentRowCount >= this.maxRows) {
	            event.preventDefault();
	        }
	    }
	};
	/**
	   * Handle focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onFocus_ = function (event) {
	    this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle lost focus.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onBlur_ = function (event) {
	    this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	};
	/**
	   * Handle reset event from out side.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTextfield.prototype.onReset_ = function (event) {
	    this.updateClasses_();
	};
	/**
	   * Handle class updates.
	   *
	   * @private
	   */
	MaterialTextfield.prototype.updateClasses_ = function () {
	    this.checkDisabled();
	    this.checkValidity();
	    this.checkDirty();
	    this.checkFocus();
	};
	// Public methods.
	/**
	   * Check the disabled state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkDisabled = function () {
	    if (this.input_.disabled) {
	        this.element_.classList.add(this.CssClasses_.IS_DISABLED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DISABLED);
	    }
	};
	MaterialTextfield.prototype['checkDisabled'] = MaterialTextfield.prototype.checkDisabled;
	/**
	  * Check the focus state and update field accordingly.
	  *
	  * @public
	  */
	MaterialTextfield.prototype.checkFocus = function () {
	    if (Boolean(this.element_.querySelector(':focus'))) {
	        this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_FOCUSED);
	    }
	};
	MaterialTextfield.prototype['checkFocus'] = MaterialTextfield.prototype.checkFocus;
	/**
	   * Check the validity state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkValidity = function () {
	    if (this.input_.validity) {
	        if (this.input_.validity.valid) {
	            this.element_.classList.remove(this.CssClasses_.IS_INVALID);
	        } else {
	            this.element_.classList.add(this.CssClasses_.IS_INVALID);
	        }
	    }
	};
	MaterialTextfield.prototype['checkValidity'] = MaterialTextfield.prototype.checkValidity;
	/**
	   * Check the dirty state and update field accordingly.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.checkDirty = function () {
	    if (this.input_.value && this.input_.value.length > 0) {
	        this.element_.classList.add(this.CssClasses_.IS_DIRTY);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_DIRTY);
	    }
	};
	MaterialTextfield.prototype['checkDirty'] = MaterialTextfield.prototype.checkDirty;
	/**
	   * Disable text field.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.disable = function () {
	    this.input_.disabled = true;
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['disable'] = MaterialTextfield.prototype.disable;
	/**
	   * Enable text field.
	   *
	   * @public
	   */
	MaterialTextfield.prototype.enable = function () {
	    this.input_.disabled = false;
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['enable'] = MaterialTextfield.prototype.enable;
	/**
	   * Update text field value.
	   *
	   * @param {string} value The value to which to set the control (optional).
	   * @public
	   */
	MaterialTextfield.prototype.change = function (value) {
	    this.input_.value = value || '';
	    this.updateClasses_();
	};
	MaterialTextfield.prototype['change'] = MaterialTextfield.prototype.change;
	/**
	   * Initialize element.
	   */
	MaterialTextfield.prototype.init = function () {
	    if (this.element_) {
	        this.label_ = this.element_.querySelector('.' + this.CssClasses_.LABEL);
	        this.input_ = this.element_.querySelector('.' + this.CssClasses_.INPUT);
	        if (this.input_) {
	            if (this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)) {
	                this.maxRows = parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE), 10);
	                if (isNaN(this.maxRows)) {
	                    this.maxRows = this.Constant_.NO_MAX_ROWS;
	                }
	            }
	            if (this.input_.hasAttribute('placeholder')) {
	                this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);
	            }
	            this.boundUpdateClassesHandler = this.updateClasses_.bind(this);
	            this.boundFocusHandler = this.onFocus_.bind(this);
	            this.boundBlurHandler = this.onBlur_.bind(this);
	            this.boundResetHandler = this.onReset_.bind(this);
	            this.input_.addEventListener('input', this.boundUpdateClassesHandler);
	            this.input_.addEventListener('focus', this.boundFocusHandler);
	            this.input_.addEventListener('blur', this.boundBlurHandler);
	            this.input_.addEventListener('reset', this.boundResetHandler);
	            if (this.maxRows !== this.Constant_.NO_MAX_ROWS) {
	                // TODO: This should handle pasting multi line text.
	                // Currently doesn't.
	                this.boundKeyDownHandler = this.onKeyDown_.bind(this);
	                this.input_.addEventListener('keydown', this.boundKeyDownHandler);
	            }
	            var invalid = this.element_.classList.contains(this.CssClasses_.IS_INVALID);
	            this.updateClasses_();
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	            if (invalid) {
	                this.element_.classList.add(this.CssClasses_.IS_INVALID);
	            }
	            if (this.input_.hasAttribute('autofocus')) {
	                this.element_.focus();
	                this.checkFocus();
	            }
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTextfield,
	    classAsString: 'MaterialTextfield',
	    cssClass: 'mdl-js-textfield',
	    widget: true
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Tooltip MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialTooltip = function MaterialTooltip(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialTooltip'] = MaterialTooltip;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialTooltip.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialTooltip.prototype.CssClasses_ = {
	    IS_ACTIVE: 'is-active',
	    BOTTOM: 'mdl-tooltip--bottom',
	    LEFT: 'mdl-tooltip--left',
	    RIGHT: 'mdl-tooltip--right',
	    TOP: 'mdl-tooltip--top'
	};
	/**
	   * Handle mouseenter for tooltip.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialTooltip.prototype.handleMouseEnter_ = function (event) {
	    var props = event.target.getBoundingClientRect();
	    var left = props.left + props.width / 2;
	    var top = props.top + props.height / 2;
	    var marginLeft = -1 * (this.element_.offsetWidth / 2);
	    var marginTop = -1 * (this.element_.offsetHeight / 2);
	    if (this.element_.classList.contains(this.CssClasses_.LEFT) || this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	        left = props.width / 2;
	        if (top + marginTop < 0) {
	            this.element_.style.top = '0';
	            this.element_.style.marginTop = '0';
	        } else {
	            this.element_.style.top = top + 'px';
	            this.element_.style.marginTop = marginTop + 'px';
	        }
	    } else {
	        if (left + marginLeft < 0) {
	            this.element_.style.left = '0';
	            this.element_.style.marginLeft = '0';
	        } else {
	            this.element_.style.left = left + 'px';
	            this.element_.style.marginLeft = marginLeft + 'px';
	        }
	    }
	    if (this.element_.classList.contains(this.CssClasses_.TOP)) {
	        this.element_.style.top = props.top - this.element_.offsetHeight - 10 + 'px';
	    } else if (this.element_.classList.contains(this.CssClasses_.RIGHT)) {
	        this.element_.style.left = props.left + props.width + 10 + 'px';
	    } else if (this.element_.classList.contains(this.CssClasses_.LEFT)) {
	        this.element_.style.left = props.left - this.element_.offsetWidth - 10 + 'px';
	    } else {
	        this.element_.style.top = props.top + props.height + 10 + 'px';
	    }
	    this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
	};
	/**
	   * Hide tooltip on mouseleave or scroll
	   *
	   * @private
	   */
	MaterialTooltip.prototype.hideTooltip_ = function () {
	    this.element_.classList.remove(this.CssClasses_.IS_ACTIVE);
	};
	/**
	   * Initialize element.
	   */
	MaterialTooltip.prototype.init = function () {
	    if (this.element_) {
	        var forElId = this.element_.getAttribute('for') || this.element_.getAttribute('data-mdl-for');
	        if (forElId) {
	            this.forElement_ = document.getElementById(forElId);
	        }
	        if (this.forElement_) {
	            // It's left here because it prevents accidental text selection on Android
	            if (!this.forElement_.hasAttribute('tabindex')) {
	                this.forElement_.setAttribute('tabindex', '0');
	            }
	            this.boundMouseEnterHandler = this.handleMouseEnter_.bind(this);
	            this.boundMouseLeaveAndScrollHandler = this.hideTooltip_.bind(this);
	            this.forElement_.addEventListener('mouseenter', this.boundMouseEnterHandler, false);
	            this.forElement_.addEventListener('touchend', this.boundMouseEnterHandler, false);
	            this.forElement_.addEventListener('mouseleave', this.boundMouseLeaveAndScrollHandler, false);
	            window.addEventListener('scroll', this.boundMouseLeaveAndScrollHandler, true);
	            window.addEventListener('touchstart', this.boundMouseLeaveAndScrollHandler);
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialTooltip,
	    classAsString: 'MaterialTooltip',
	    cssClass: 'mdl-tooltip'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Layout MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialLayout = function MaterialLayout(element) {
	    this.element_ = element;
	    this.innerContainer_ = element.querySelector('.' + this.CssClasses_.INNER_CONTAINER);
	    // Initialize instance.
	    this.init();
	};
	window['MaterialLayout'] = MaterialLayout;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialLayout.prototype.Constant_ = {
	    MAX_WIDTH: '(max-width: 1024px)',
	    TAB_SCROLL_PIXELS: 100,
	    RESIZE_TIMEOUT: 100,
	    MENU_ICON: '&#xE5D2;',
	    CHEVRON_LEFT: 'chevron_left',
	    CHEVRON_RIGHT: 'chevron_right'
	};
	/**
	   * Keycodes, for code readability.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialLayout.prototype.Keycodes_ = {
	    ENTER: 13,
	    ESCAPE: 27,
	    SPACE: 32
	};
	/**
	   * Modes.
	   *
	   * @enum {number}
	   * @private
	   */
	MaterialLayout.prototype.Mode_ = {
	    STANDARD: 0,
	    SEAMED: 1,
	    WATERFALL: 2,
	    SCROLL: 3
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialLayout.prototype.CssClasses_ = {
	    INNER_CONTAINER: 'mdl-layout__inner-container',
	    HEADER: 'mdl-layout__header',
	    DRAWER: 'mdl-layout__drawer',
	    CONTENT: 'mdl-layout__content',
	    DRAWER_BTN: 'mdl-layout__drawer-button',
	    ICON: 'material-icons',
	    JS_RIPPLE_EFFECT: 'mdl-js-ripple-effect',
	    RIPPLE_CONTAINER: 'mdl-layout__tab-ripple-container',
	    RIPPLE: 'mdl-ripple',
	    RIPPLE_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    HEADER_SEAMED: 'mdl-layout__header--seamed',
	    HEADER_WATERFALL: 'mdl-layout__header--waterfall',
	    HEADER_SCROLL: 'mdl-layout__header--scroll',
	    FIXED_HEADER: 'mdl-layout--fixed-header',
	    OBFUSCATOR: 'mdl-layout__obfuscator',
	    TAB_BAR: 'mdl-layout__tab-bar',
	    TAB_CONTAINER: 'mdl-layout__tab-bar-container',
	    TAB: 'mdl-layout__tab',
	    TAB_BAR_BUTTON: 'mdl-layout__tab-bar-button',
	    TAB_BAR_LEFT_BUTTON: 'mdl-layout__tab-bar-left-button',
	    TAB_BAR_RIGHT_BUTTON: 'mdl-layout__tab-bar-right-button',
	    PANEL: 'mdl-layout__tab-panel',
	    HAS_DRAWER: 'has-drawer',
	    HAS_TABS: 'has-tabs',
	    HAS_SCROLLING_HEADER: 'has-scrolling-header',
	    CASTING_SHADOW: 'is-casting-shadow',
	    IS_COMPACT: 'is-compact',
	    IS_SMALL_SCREEN: 'is-small-screen',
	    IS_DRAWER_OPEN: 'is-visible',
	    IS_ACTIVE: 'is-active',
	    IS_UPGRADED: 'is-upgraded',
	    IS_ANIMATING: 'is-animating',
	    ON_LARGE_SCREEN: 'mdl-layout--large-screen-only',
	    ON_SMALL_SCREEN: 'mdl-layout--small-screen-only'
	};
	/**
	   * Handles scrolling on the content.
	   *
	   * @private
	   */
	MaterialLayout.prototype.contentScrollHandler_ = function () {
	    if (this.header_.classList.contains(this.CssClasses_.IS_ANIMATING)) {
	        return;
	    }
	    var headerVisible = !this.element_.classList.contains(this.CssClasses_.IS_SMALL_SCREEN) || this.element_.classList.contains(this.CssClasses_.FIXED_HEADER);
	    if (this.content_.scrollTop > 0 && !this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	        this.header_.classList.add(this.CssClasses_.IS_COMPACT);
	        if (headerVisible) {
	            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	        }
	    } else if (this.content_.scrollTop <= 0 && this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	        if (headerVisible) {
	            this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	        }
	    }
	};
	/**
	   * Handles a keyboard event on the drawer.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialLayout.prototype.keyboardEventHandler_ = function (evt) {
	    // Only react when the drawer is open.
	    if (evt.keyCode === this.Keycodes_.ESCAPE && this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
	        this.toggleDrawer();
	    }
	};
	/**
	   * Handles changes in screen size.
	   *
	   * @private
	   */
	MaterialLayout.prototype.screenSizeHandler_ = function () {
	    if (this.screenSizeMediaQuery_.matches) {
	        this.element_.classList.add(this.CssClasses_.IS_SMALL_SCREEN);
	    } else {
	        this.element_.classList.remove(this.CssClasses_.IS_SMALL_SCREEN);
	        // Collapse drawer (if any) when moving to a large screen size.
	        if (this.drawer_) {
	            this.drawer_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	            this.obfuscator_.classList.remove(this.CssClasses_.IS_DRAWER_OPEN);
	        }
	    }
	};
	/**
	   * Handles events of drawer button.
	   *
	   * @param {Event} evt The event that fired.
	   * @private
	   */
	MaterialLayout.prototype.drawerToggleHandler_ = function (evt) {
	    if (evt && evt.type === 'keydown') {
	        if (evt.keyCode === this.Keycodes_.SPACE || evt.keyCode === this.Keycodes_.ENTER) {
	            // prevent scrolling in drawer nav
	            evt.preventDefault();
	        } else {
	            // prevent other keys
	            return;
	        }
	    }
	    this.toggleDrawer();
	};
	/**
	   * Handles (un)setting the `is-animating` class
	   *
	   * @private
	   */
	MaterialLayout.prototype.headerTransitionEndHandler_ = function () {
	    this.header_.classList.remove(this.CssClasses_.IS_ANIMATING);
	};
	/**
	   * Handles expanding the header on click
	   *
	   * @private
	   */
	MaterialLayout.prototype.headerClickHandler_ = function () {
	    if (this.header_.classList.contains(this.CssClasses_.IS_COMPACT)) {
	        this.header_.classList.remove(this.CssClasses_.IS_COMPACT);
	        this.header_.classList.add(this.CssClasses_.IS_ANIMATING);
	    }
	};
	/**
	   * Reset tab state, dropping active classes
	   *
	   * @private
	   */
	MaterialLayout.prototype.resetTabState_ = function (tabBar) {
	    for (var k = 0; k < tabBar.length; k++) {
	        tabBar[k].classList.remove(this.CssClasses_.IS_ACTIVE);
	    }
	};
	/**
	   * Reset panel state, droping active classes
	   *
	   * @private
	   */
	MaterialLayout.prototype.resetPanelState_ = function (panels) {
	    for (var j = 0; j < panels.length; j++) {
	        panels[j].classList.remove(this.CssClasses_.IS_ACTIVE);
	    }
	};
	/**
	  * Toggle drawer state
	  *
	  * @public
	  */
	MaterialLayout.prototype.toggleDrawer = function () {
	    var drawerButton = this.innerContainer_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	    this.drawer_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	    this.obfuscator_.classList.toggle(this.CssClasses_.IS_DRAWER_OPEN);
	    // Set accessibility properties.
	    if (this.drawer_.classList.contains(this.CssClasses_.IS_DRAWER_OPEN)) {
	        this.drawer_.setAttribute('aria-hidden', 'false');
	        drawerButton.setAttribute('aria-expanded', 'true');
	    } else {
	        this.drawer_.setAttribute('aria-hidden', 'true');
	        drawerButton.setAttribute('aria-expanded', 'false');
	    }
	};
	MaterialLayout.prototype['toggleDrawer'] = MaterialLayout.prototype.toggleDrawer;
	/**
	   * Initialize element.
	   */
	MaterialLayout.prototype.init = function () {
	    if (this.element_) {
	        var focusedElement = this.element_.querySelector(':focus');
	        if (focusedElement) {
	            focusedElement.focus();
	        }
	        var directChildren = this.innerContainer_.childNodes;
	        var numChildren = directChildren.length;
	        for (var c = 0; c < numChildren; c++) {
	            var child = directChildren[c];
	            if (child.classList && child.classList.contains(this.CssClasses_.HEADER)) {
	                this.header_ = child;
	            }
	            if (child.classList && child.classList.contains(this.CssClasses_.DRAWER)) {
	                this.drawer_ = child;
	            }
	            if (child.classList && child.classList.contains(this.CssClasses_.CONTENT)) {
	                this.content_ = child;
	            }
	        }
	        window.addEventListener('pageshow', function (e) {
	            if (e.persisted) {
	                // when page is loaded from back/forward cache
	                // trigger repaint to let layout scroll in safari
	                this.innerContainer_.style.overflowY = 'hidden';
	                requestAnimationFrame(function () {
	                    this.innerContainer_.style.overflowY = '';
	                }.bind(this));
	            }
	        }.bind(this), false);
	        if (this.header_) {
	            this.tabBar_ = this.header_.querySelector('.' + this.CssClasses_.TAB_BAR);
	        }
	        var mode = this.Mode_.STANDARD;
	        if (this.header_) {
	            if (this.header_.classList.contains(this.CssClasses_.HEADER_SEAMED)) {
	                mode = this.Mode_.SEAMED;
	            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_WATERFALL)) {
	                mode = this.Mode_.WATERFALL;
	                this.header_.addEventListener('transitionend', this.headerTransitionEndHandler_.bind(this));
	                this.header_.addEventListener('click', this.headerClickHandler_.bind(this));
	            } else if (this.header_.classList.contains(this.CssClasses_.HEADER_SCROLL)) {
	                mode = this.Mode_.SCROLL;
	                this.element_.classList.add(this.CssClasses_.HAS_SCROLLING_HEADER);
	            }
	            if (mode === this.Mode_.STANDARD) {
	                this.header_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                if (this.tabBar_) {
	                    this.tabBar_.classList.add(this.CssClasses_.CASTING_SHADOW);
	                }
	            } else if (mode === this.Mode_.SEAMED || mode === this.Mode_.SCROLL) {
	                this.header_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                if (this.tabBar_) {
	                    this.tabBar_.classList.remove(this.CssClasses_.CASTING_SHADOW);
	                }
	            } else if (mode === this.Mode_.WATERFALL) {
	                // Add and remove shadows depending on scroll position.
	                // Also add/remove auxiliary class for styling of the compact version of
	                // the header.
	                this.content_.addEventListener('scroll', this.contentScrollHandler_.bind(this));
	                this.contentScrollHandler_();
	            }
	        }
	        // Add drawer toggling button to our layout, if we have an openable drawer.
	        if (this.drawer_) {
	            var drawerButton = this.innerContainer_.querySelector('.' + this.CssClasses_.DRAWER_BTN);
	            if (!drawerButton) {
	                drawerButton = document.createElement('div');
	                drawerButton.setAttribute('aria-expanded', 'false');
	                drawerButton.setAttribute('role', 'button');
	                drawerButton.setAttribute('tabindex', '0');
	                drawerButton.classList.add(this.CssClasses_.DRAWER_BTN);
	                var drawerButtonIcon = document.createElement('i');
	                drawerButtonIcon.classList.add(this.CssClasses_.ICON);
	                drawerButtonIcon.innerHTML = this.Constant_.MENU_ICON;
	                drawerButton.appendChild(drawerButtonIcon);
	            }
	            if (this.drawer_.classList.contains(this.CssClasses_.ON_LARGE_SCREEN)) {
	                //If drawer has ON_LARGE_SCREEN class then add it to the drawer toggle button as well.
	                drawerButton.classList.add(this.CssClasses_.ON_LARGE_SCREEN);
	            } else if (this.drawer_.classList.contains(this.CssClasses_.ON_SMALL_SCREEN)) {
	                //If drawer has ON_SMALL_SCREEN class then add it to the drawer toggle button as well.
	                drawerButton.classList.add(this.CssClasses_.ON_SMALL_SCREEN);
	            }
	            drawerButton.addEventListener('click', this.drawerToggleHandler_.bind(this));
	            drawerButton.addEventListener('keydown', this.drawerToggleHandler_.bind(this));
	            // Add a class if the layout has a drawer, for altering the left padding.
	            // Adds the HAS_DRAWER to the elements since this.header_ may or may
	            // not be present.
	            this.element_.classList.add(this.CssClasses_.HAS_DRAWER);
	            // If we have a fixed header, add the button to the header rather than
	            // the layout.
	            if (this.element_.classList.contains(this.CssClasses_.FIXED_HEADER)) {
	                this.header_.insertBefore(drawerButton, this.header_.firstChild);
	            } else {
	                this.innerContainer_.insertBefore(drawerButton, this.content_);
	            }
	            var obfuscator = document.createElement('div');
	            obfuscator.classList.add(this.CssClasses_.OBFUSCATOR);
	            this.innerContainer_.appendChild(obfuscator);
	            obfuscator.addEventListener('click', this.drawerToggleHandler_.bind(this));
	            this.obfuscator_ = obfuscator;
	            this.drawer_.addEventListener('keydown', this.keyboardEventHandler_.bind(this));
	            this.drawer_.setAttribute('aria-hidden', 'true');
	        }
	        // Keep an eye on screen size, and add/remove auxiliary class for styling
	        // of small screens.
	        this.screenSizeMediaQuery_ = window.matchMedia(this.Constant_.MAX_WIDTH);
	        this.screenSizeMediaQuery_.addListener(this.screenSizeHandler_.bind(this));
	        this.screenSizeHandler_();
	        // Initialize tabs, if any.
	        if (this.header_ && this.tabBar_) {
	            this.element_.classList.add(this.CssClasses_.HAS_TABS);
	            var tabContainer = document.createElement('div');
	            tabContainer.classList.add(this.CssClasses_.TAB_CONTAINER);
	            this.header_.insertBefore(tabContainer, this.tabBar_);
	            this.header_.removeChild(this.tabBar_);
	            var leftButton = document.createElement('div');
	            leftButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	            leftButton.classList.add(this.CssClasses_.TAB_BAR_LEFT_BUTTON);
	            var leftButtonIcon = document.createElement('i');
	            leftButtonIcon.classList.add(this.CssClasses_.ICON);
	            leftButtonIcon.textContent = this.Constant_.CHEVRON_LEFT;
	            leftButton.appendChild(leftButtonIcon);
	            leftButton.addEventListener('click', function () {
	                this.tabBar_.scrollLeft -= this.Constant_.TAB_SCROLL_PIXELS;
	            }.bind(this));
	            var rightButton = document.createElement('div');
	            rightButton.classList.add(this.CssClasses_.TAB_BAR_BUTTON);
	            rightButton.classList.add(this.CssClasses_.TAB_BAR_RIGHT_BUTTON);
	            var rightButtonIcon = document.createElement('i');
	            rightButtonIcon.classList.add(this.CssClasses_.ICON);
	            rightButtonIcon.textContent = this.Constant_.CHEVRON_RIGHT;
	            rightButton.appendChild(rightButtonIcon);
	            rightButton.addEventListener('click', function () {
	                this.tabBar_.scrollLeft += this.Constant_.TAB_SCROLL_PIXELS;
	            }.bind(this));
	            tabContainer.appendChild(leftButton);
	            tabContainer.appendChild(this.tabBar_);
	            tabContainer.appendChild(rightButton);
	            // Add and remove tab buttons depending on scroll position and total
	            // window size.
	            var tabUpdateHandler = function () {
	                if (this.tabBar_.scrollLeft > 0) {
	                    leftButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                } else {
	                    leftButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                }
	                if (this.tabBar_.scrollLeft < this.tabBar_.scrollWidth - this.tabBar_.offsetWidth) {
	                    rightButton.classList.add(this.CssClasses_.IS_ACTIVE);
	                } else {
	                    rightButton.classList.remove(this.CssClasses_.IS_ACTIVE);
	                }
	            }.bind(this);
	            this.tabBar_.addEventListener('scroll', tabUpdateHandler);
	            tabUpdateHandler();
	            // Update tabs when the window resizes.
	            var windowResizeHandler = function () {
	                // Use timeouts to make sure it doesn't happen too often.
	                if (this.resizeTimeoutId_) {
	                    clearTimeout(this.resizeTimeoutId_);
	                }
	                this.resizeTimeoutId_ = setTimeout(function () {
	                    tabUpdateHandler();
	                    this.resizeTimeoutId_ = null;
	                }.bind(this), this.Constant_.RESIZE_TIMEOUT);
	            }.bind(this);
	            window.addEventListener('resize', windowResizeHandler);
	            if (this.tabBar_.classList.contains(this.CssClasses_.JS_RIPPLE_EFFECT)) {
	                this.tabBar_.classList.add(this.CssClasses_.RIPPLE_IGNORE_EVENTS);
	            }
	            // Select element tabs, document panels
	            var tabs = this.tabBar_.querySelectorAll('.' + this.CssClasses_.TAB);
	            var panels = this.content_.querySelectorAll('.' + this.CssClasses_.PANEL);
	            // Create new tabs for each tab element
	            for (var i = 0; i < tabs.length; i++) {
	                new MaterialLayoutTab(tabs[i], tabs, panels, this);
	            }
	        }
	        this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	    }
	};
	/**
	   * Constructor for an individual tab.
	   *
	   * @constructor
	   * @param {HTMLElement} tab The HTML element for the tab.
	   * @param {!Array<HTMLElement>} tabs Array with HTML elements for all tabs.
	   * @param {!Array<HTMLElement>} panels Array with HTML elements for all panels.
	   * @param {MaterialLayout} layout The MaterialLayout object that owns the tab.
	   */
	function MaterialLayoutTab(tab, tabs, panels, layout) {
	    /**
	     * Auxiliary method to programmatically select a tab in the UI.
	     */
	    function selectTab() {
	        layout.resetTabState_(tabs);
	        tab.classList.add(layout.CssClasses_.IS_ACTIVE);
	    }
	    if (layout.tabBar_.classList.contains(layout.CssClasses_.JS_RIPPLE_EFFECT)) {
	        var rippleContainer = document.createElement('span');
	        rippleContainer.classList.add(layout.CssClasses_.RIPPLE_CONTAINER);
	        rippleContainer.classList.add(layout.CssClasses_.JS_RIPPLE_EFFECT);
	        var ripple = document.createElement('span');
	        ripple.classList.add(layout.CssClasses_.RIPPLE);
	        rippleContainer.appendChild(ripple);
	        tab.appendChild(rippleContainer);
	    }
	    tab.addEventListener('click', function (e) {
	        e.preventDefault();
	        selectTab();
	    });
	    tab.show = selectTab;
	}
	window['MaterialLayoutTab'] = MaterialLayoutTab;
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialLayout,
	    classAsString: 'MaterialLayout',
	    cssClass: 'mdl-js-layout'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Data Table Card MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {Element} element The element that will be upgraded.
	   */
	var MaterialDataTable = function MaterialDataTable(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialDataTable'] = MaterialDataTable;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialDataTable.prototype.Constant_ = {};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialDataTable.prototype.CssClasses_ = {
	    DATA_TABLE: 'mdl-data-table',
	    SELECTABLE: 'mdl-data-table--selectable',
	    SELECT_ELEMENT: 'mdl-data-table__select',
	    IS_SELECTED: 'is-selected',
	    IS_UPGRADED: 'is-upgraded'
	};
	/**
	   * Generates and returns a function that toggles the selection state of a
	   * single row (or multiple rows).
	   *
	   * @param {Element} checkbox Checkbox that toggles the selection state.
	   * @param {Element} row Row to toggle when checkbox changes.
	   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	   * @private
	   */
	MaterialDataTable.prototype.selectRow_ = function (checkbox, row, opt_rows) {
	    if (row) {
	        return function () {
	            if (checkbox.checked) {
	                row.classList.add(this.CssClasses_.IS_SELECTED);
	            } else {
	                row.classList.remove(this.CssClasses_.IS_SELECTED);
	            }
	        }.bind(this);
	    }
	    if (opt_rows) {
	        return function () {
	            var i;
	            var el;
	            if (checkbox.checked) {
	                for (i = 0; i < opt_rows.length; i++) {
	                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                    el['MaterialCheckbox'].check();
	                    opt_rows[i].classList.add(this.CssClasses_.IS_SELECTED);
	                }
	            } else {
	                for (i = 0; i < opt_rows.length; i++) {
	                    el = opt_rows[i].querySelector('td').querySelector('.mdl-checkbox');
	                    el['MaterialCheckbox'].uncheck();
	                    opt_rows[i].classList.remove(this.CssClasses_.IS_SELECTED);
	                }
	            }
	        }.bind(this);
	    }
	};
	/**
	   * Creates a checkbox for a single or or multiple rows and hooks up the
	   * event handling.
	   *
	   * @param {Element} row Row to toggle when checkbox changes.
	   * @param {(Array<Object>|NodeList)=} opt_rows Rows to toggle when checkbox changes.
	   * @private
	   */
	MaterialDataTable.prototype.createCheckbox_ = function (row, opt_rows) {
	    var label = document.createElement('label');
	    var labelClasses = [
	        'mdl-checkbox',
	        'mdl-js-checkbox',
	        'mdl-js-ripple-effect',
	        this.CssClasses_.SELECT_ELEMENT
	    ];
	    label.className = labelClasses.join(' ');
	    var checkbox = document.createElement('input');
	    checkbox.type = 'checkbox';
	    checkbox.classList.add('mdl-checkbox__input');
	    if (row) {
	        checkbox.checked = row.classList.contains(this.CssClasses_.IS_SELECTED);
	        checkbox.addEventListener('change', this.selectRow_(checkbox, row));
	    } else if (opt_rows) {
	        checkbox.addEventListener('change', this.selectRow_(checkbox, null, opt_rows));
	    }
	    label.appendChild(checkbox);
	    componentHandler.upgradeElement(label, 'MaterialCheckbox');
	    return label;
	};
	/**
	   * Initialize element.
	   */
	MaterialDataTable.prototype.init = function () {
	    if (this.element_) {
	        var firstHeader = this.element_.querySelector('th');
	        var bodyRows = Array.prototype.slice.call(this.element_.querySelectorAll('tbody tr'));
	        var footRows = Array.prototype.slice.call(this.element_.querySelectorAll('tfoot tr'));
	        var rows = bodyRows.concat(footRows);
	        if (this.element_.classList.contains(this.CssClasses_.SELECTABLE)) {
	            var th = document.createElement('th');
	            var headerCheckbox = this.createCheckbox_(null, rows);
	            th.appendChild(headerCheckbox);
	            firstHeader.parentElement.insertBefore(th, firstHeader);
	            for (var i = 0; i < rows.length; i++) {
	                var firstCell = rows[i].querySelector('td');
	                if (firstCell) {
	                    var td = document.createElement('td');
	                    if (rows[i].parentNode.nodeName.toUpperCase() === 'TBODY') {
	                        var rowCheckbox = this.createCheckbox_(rows[i]);
	                        td.appendChild(rowCheckbox);
	                    }
	                    rows[i].insertBefore(td, firstCell);
	                }
	            }
	            this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialDataTable,
	    classAsString: 'MaterialDataTable',
	    cssClass: 'mdl-js-data-table'
	});
	/**
	 * @license
	 * Copyright 2015 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	   * Class constructor for Ripple MDL component.
	   * Implements MDL component design pattern defined at:
	   * https://github.com/jasonmayes/mdl-component-design-pattern
	   *
	   * @constructor
	   * @param {HTMLElement} element The element that will be upgraded.
	   */
	var MaterialRipple = function MaterialRipple(element) {
	    this.element_ = element;
	    // Initialize instance.
	    this.init();
	};
	window['MaterialRipple'] = MaterialRipple;
	/**
	   * Store constants in one place so they can be updated easily.
	   *
	   * @enum {string | number}
	   * @private
	   */
	MaterialRipple.prototype.Constant_ = {
	    INITIAL_SCALE: 'scale(0.0001, 0.0001)',
	    INITIAL_SIZE: '1px',
	    INITIAL_OPACITY: '0.4',
	    FINAL_OPACITY: '0',
	    FINAL_SCALE: ''
	};
	/**
	   * Store strings for class names defined by this component that are used in
	   * JavaScript. This allows us to simply change it in one place should we
	   * decide to modify at a later date.
	   *
	   * @enum {string}
	   * @private
	   */
	MaterialRipple.prototype.CssClasses_ = {
	    RIPPLE_CENTER: 'mdl-ripple--center',
	    RIPPLE_EFFECT_IGNORE_EVENTS: 'mdl-js-ripple-effect--ignore-events',
	    RIPPLE: 'mdl-ripple',
	    IS_ANIMATING: 'is-animating',
	    IS_VISIBLE: 'is-visible'
	};
	/**
	   * Handle mouse / finger down on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRipple.prototype.downHandler_ = function (event) {
	    if (!this.rippleElement_.style.width && !this.rippleElement_.style.height) {
	        var rect = this.element_.getBoundingClientRect();
	        this.boundHeight = rect.height;
	        this.boundWidth = rect.width;
	        this.rippleSize_ = Math.sqrt(rect.width * rect.width + rect.height * rect.height) * 2 + 2;
	        this.rippleElement_.style.width = this.rippleSize_ + 'px';
	        this.rippleElement_.style.height = this.rippleSize_ + 'px';
	    }
	    this.rippleElement_.classList.add(this.CssClasses_.IS_VISIBLE);
	    if (event.type === 'mousedown' && this.ignoringMouseDown_) {
	        this.ignoringMouseDown_ = false;
	    } else {
	        if (event.type === 'touchstart') {
	            this.ignoringMouseDown_ = true;
	        }
	        var frameCount = this.getFrameCount();
	        if (frameCount > 0) {
	            return;
	        }
	        this.setFrameCount(1);
	        var bound = event.currentTarget.getBoundingClientRect();
	        var x;
	        var y;
	        // Check if we are handling a keyboard click.
	        if (event.clientX === 0 && event.clientY === 0) {
	            x = Math.round(bound.width / 2);
	            y = Math.round(bound.height / 2);
	        } else {
	            var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	            var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	            x = Math.round(clientX - bound.left);
	            y = Math.round(clientY - bound.top);
	        }
	        this.setRippleXY(x, y);
	        this.setRippleStyles(true);
	        window.requestAnimationFrame(this.animFrameHandler.bind(this));
	    }
	};
	/**
	   * Handle mouse / finger up on element.
	   *
	   * @param {Event} event The event that fired.
	   * @private
	   */
	MaterialRipple.prototype.upHandler_ = function (event) {
	    // Don't fire for the artificial "mouseup" generated by a double-click.
	    if (event && event.detail !== 2) {
	        // Allow a repaint to occur before removing this class, so the animation
	        // shows for tap events, which seem to trigger a mouseup too soon after
	        // mousedown.
	        window.setTimeout(function () {
	            this.rippleElement_.classList.remove(this.CssClasses_.IS_VISIBLE);
	        }.bind(this), 0);
	    }
	};
	/**
	   * Initialize element.
	   */
	MaterialRipple.prototype.init = function () {
	    if (this.element_) {
	        var recentering = this.element_.classList.contains(this.CssClasses_.RIPPLE_CENTER);
	        if (!this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT_IGNORE_EVENTS)) {
	            this.rippleElement_ = this.element_.querySelector('.' + this.CssClasses_.RIPPLE);
	            this.frameCount_ = 0;
	            this.rippleSize_ = 0;
	            this.x_ = 0;
	            this.y_ = 0;
	            // Touch start produces a compat mouse down event, which would cause a
	            // second ripples. To avoid that, we use this property to ignore the first
	            // mouse down after a touch start.
	            this.ignoringMouseDown_ = false;
	            this.boundDownHandler = this.downHandler_.bind(this);
	            this.element_.addEventListener('mousedown', this.boundDownHandler);
	            this.element_.addEventListener('touchstart', this.boundDownHandler);
	            this.boundUpHandler = this.upHandler_.bind(this);
	            this.element_.addEventListener('mouseup', this.boundUpHandler);
	            this.element_.addEventListener('mouseleave', this.boundUpHandler);
	            this.element_.addEventListener('touchend', this.boundUpHandler);
	            this.element_.addEventListener('blur', this.boundUpHandler);
	            /**
	         * Getter for frameCount_.
	         * @return {number} the frame count.
	         */
	            this.getFrameCount = function () {
	                return this.frameCount_;
	            };
	            /**
	         * Setter for frameCount_.
	         * @param {number} fC the frame count.
	         */
	            this.setFrameCount = function (fC) {
	                this.frameCount_ = fC;
	            };
	            /**
	         * Getter for rippleElement_.
	         * @return {Element} the ripple element.
	         */
	            this.getRippleElement = function () {
	                return this.rippleElement_;
	            };
	            /**
	         * Sets the ripple X and Y coordinates.
	         * @param  {number} newX the new X coordinate
	         * @param  {number} newY the new Y coordinate
	         */
	            this.setRippleXY = function (newX, newY) {
	                this.x_ = newX;
	                this.y_ = newY;
	            };
	            /**
	         * Sets the ripple styles.
	         * @param  {boolean} start whether or not this is the start frame.
	         */
	            this.setRippleStyles = function (start) {
	                if (this.rippleElement_ !== null) {
	                    var transformString;
	                    var scale;
	                    var size;
	                    var offset = 'translate(' + this.x_ + 'px, ' + this.y_ + 'px)';
	                    if (start) {
	                        scale = this.Constant_.INITIAL_SCALE;
	                        size = this.Constant_.INITIAL_SIZE;
	                    } else {
	                        scale = this.Constant_.FINAL_SCALE;
	                        size = this.rippleSize_ + 'px';
	                        if (recentering) {
	                            offset = 'translate(' + this.boundWidth / 2 + 'px, ' + this.boundHeight / 2 + 'px)';
	                        }
	                    }
	                    transformString = 'translate(-50%, -50%) ' + offset + scale;
	                    this.rippleElement_.style.webkitTransform = transformString;
	                    this.rippleElement_.style.msTransform = transformString;
	                    this.rippleElement_.style.transform = transformString;
	                    if (start) {
	                        this.rippleElement_.classList.remove(this.CssClasses_.IS_ANIMATING);
	                    } else {
	                        this.rippleElement_.classList.add(this.CssClasses_.IS_ANIMATING);
	                    }
	                }
	            };
	            /**
	         * Handles an animation frame.
	         */
	            this.animFrameHandler = function () {
	                if (this.frameCount_-- > 0) {
	                    window.requestAnimationFrame(this.animFrameHandler.bind(this));
	                } else {
	                    this.setRippleStyles(false);
	                }
	            };
	        }
	    }
	};
	// The component registers itself. It can assume componentHandler is available
	// in the global scope.
	componentHandler.register({
	    constructor: MaterialRipple,
	    classAsString: 'MaterialRipple',
	    cssClass: 'mdl-js-ripple-effect',
	    widget: false
	});
	}());


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
	    className: _react.PropTypes.string,
	    text: _react.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	    overlap: _react.PropTypes.bool,
	    noBackground: _react.PropTypes.bool
	};
	
	var Badge = function Badge(props) {
	    var children = props.children;
	    var className = props.className;
	    var text = props.text;
	    var overlap = props.overlap;
	    var noBackground = props.noBackground;
	
	    // No badge if no children
	    // TODO: In React 15, we can return null instead
	
	    if (!_react2.default.Children.count(children)) return _react2.default.createElement('noscript', null);
	
	    var element = typeof children === 'string' ? _react2.default.createElement(
	        'span',
	        null,
	        children
	    ) : _react2.default.Children.only(children);
	
	    // No text -> No need of badge
	    if (text === null || typeof text === 'undefined') return element;
	
	    return _react2.default.cloneElement(element, {
	        className: (0, _classnames2.default)(className, element.props.className, 'mdl-badge', {
	            'mdl-badge--overlap': !!overlap,
	            'mdl-badge--no-background': !!noBackground
	        }),
	        'data-badge': text
	    });
	};
	
	Badge.propTypes = propTypes;
	
	exports.default = Badge;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clamp = __webpack_require__(82);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _shadows = __webpack_require__(81);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    shadow: _react.PropTypes.number
	};
	
	var Card = function Card(props) {
	    var className = props.className;
	    var shadow = props.shadow;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'shadow', 'children']);
	
	    var hasShadow = typeof shadow !== 'undefined';
	    var shadowLevel = (0, _clamp2.default)(shadow || 0, 0, _shadows2.default.length - 1);
	
	    var classes = (0, _classnames2.default)('mdl-card', _defineProperty({}, _shadows2.default[shadowLevel], hasShadow), className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	Card.propTypes = propTypes;
	
	exports.default = Card;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    border: _react.PropTypes.bool,
	    className: _react.PropTypes.string
	};
	
	var CardActions = function CardActions(props) {
	    var className = props.className;
	    var border = props.border;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'border', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-card__actions', {
	        'mdl-card--border': border
	    }, className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	CardActions.propTypes = propTypes;
	
	exports.default = CardActions;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    expand: _react.PropTypes.bool
	};
	
	var CardTitle = function CardTitle(props) {
	    var className = props.className;
	    var children = props.children;
	    var expand = props.expand;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'children', 'expand']);
	
	    var classes = (0, _classnames2.default)('mdl-card__title', {
	        'mdl-card--expand': expand
	    }, className);
	
	    var title = typeof children === 'string' ? _react2.default.createElement(
	        'h2',
	        { className: 'mdl-card__title-text' },
	        children
	    ) : children;
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title
	    );
	};
	
	CardTitle.propTypes = propTypes;
	
	exports.default = CardTitle;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMedia = exports.CardActions = exports.CardTitle = exports.CardMenu = exports.CardText = exports.Card = undefined;
	
	var _Card = __webpack_require__(390);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardTitle = __webpack_require__(392);
	
	Object.defineProperty(exports, 'CardTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardTitle).default;
	  }
	});
	
	var _CardActions = __webpack_require__(391);
	
	Object.defineProperty(exports, 'CardActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardActions).default;
	  }
	});
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardText = exports.CardText = (0, _basicClassCreator2.default)('CardText', 'mdl-card__supporting-text');
	var CardMenu = exports.CardMenu = (0, _basicClassCreator2.default)('CardMenu', 'mdl-card__menu');
	var CardMedia = exports.CardMedia = (0, _basicClassCreator2.default)('CardMedia', 'mdl-card__media');

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chip = exports.ChipText = exports.ChipContact = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	var _Icon = __webpack_require__(60);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    onClick: _react.PropTypes.func,
	    onClose: _react.PropTypes.func
	};
	
	var ChipContact = exports.ChipContact = (0, _basicClassCreator2.default)('ChipContact', 'mdl-chip__contact', 'span');
	var ChipText = exports.ChipText = (0, _basicClassCreator2.default)('ChipText', 'mdl-chip__text', 'span');
	
	var Chip = exports.Chip = function Chip(props) {
	    var className = props.className;
	    var onClick = props.onClick;
	    var onClose = props.onClose;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'onClick', 'onClose', 'children']);
	
	    var childrenArray = _react2.default.Children.toArray(children);
	    var contactIndex = childrenArray.findIndex(function (c) {
	        return c.type === ChipContact;
	    });
	
	    var chipContent = [];
	
	    if (contactIndex >= 0) {
	        chipContent.push(childrenArray[contactIndex], _react2.default.createElement(
	            ChipText,
	            { key: 'text' },
	            childrenArray.slice(0, contactIndex).concat(childrenArray.slice(contactIndex + 1))
	        ));
	    } else {
	        chipContent.push(_react2.default.createElement(
	            ChipText,
	            { key: 'text' },
	            children
	        ));
	    }
	
	    if (onClose) {
	        chipContent.push(_react2.default.createElement(
	            'button',
	            { key: 'btn', type: 'button', className: 'mdl-chip__action', onClick: onClose },
	            _react2.default.createElement(_Icon2.default, { name: 'cancel' })
	        ));
	    }
	
	    var elt = onClick ? 'button' : 'span';
	
	    return _react2.default.createElement(elt, _extends({
	        className: (0, _classnames2.default)('mdl-chip', {
	            'mdl-chip--contact': contactIndex > -1,
	            'mdl-chip--deletable': !!onClose
	        }, className),
	        type: onClick ? 'button' : null,
	        onClick: onClick
	    }, otherProps), chipContent);
	};
	
	Chip.propTypes = propTypes;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(433);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _TableHeader = __webpack_require__(79);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _Checkbox = __webpack_require__(187);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    columns: function columns(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use the component `TableHeader` instead.');
	    },
	    data: function data(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use `rows` instead. `' + propName + '` will be removed in the next major release.');
	    },
	    onSelectionChanged: _react.PropTypes.func,
	    rowKeyColumn: _react.PropTypes.string,
	    rows: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    selectable: _react.PropTypes.bool
	};
	
	var defaultProps = {
	    onSelectionChanged: function onSelectionChanged() {
	        // do nothing
	    }
	};
	
	exports.default = function (Component) {
	    var Selectable = function (_React$Component) {
	        _inherits(Selectable, _React$Component);
	
	        function Selectable(props) {
	            _classCallCheck(this, Selectable);
	
	            var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Selectable).call(this, props));
	
	            _this.handleChangeHeaderCheckbox = _this.handleChangeHeaderCheckbox.bind(_this);
	            _this.handleChangeRowCheckbox = _this.handleChangeRowCheckbox.bind(_this);
	            _this.builRowCheckbox = _this.builRowCheckbox.bind(_this);
	
	            if (props.selectable) {
	                _this.state = {
	                    headerSelected: false,
	                    selectedRows: []
	                };
	            }
	            return _this;
	        }
	
	        _createClass(Selectable, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                var _this2 = this;
	
	                if (nextProps.selectable) {
	                    (function () {
	                        var rows = nextProps.rows;
	                        var data = nextProps.data;
	                        var rowKeyColumn = nextProps.rowKeyColumn;
	
	                        var rrows = rows || data;
	
	                        if (!(0, _lodash2.default)(_this2.props.rows || _this2.props.data, rrows)) {
	                            // keep only existing rows
	                            var selectedRows = _this2.state.selectedRows.filter(function (k) {
	                                return rrows.map(function (row, i) {
	                                    return row[rowKeyColumn] || row.key || i;
	                                }).indexOf(k) > -1;
	                            });
	
	                            _this2.setState({
	                                headerSelected: selectedRows.length === rrows.length,
	                                selectedRows: selectedRows
	                            });
	
	                            nextProps.onSelectionChanged(selectedRows);
	                        }
	                    })();
	                }
	            }
	        }, {
	            key: 'handleChangeHeaderCheckbox',
	            value: function handleChangeHeaderCheckbox(e) {
	                var _props = this.props;
	                var rowKeyColumn = _props.rowKeyColumn;
	                var rows = _props.rows;
	                var data = _props.data;
	
	                var selected = e.target.checked;
	                var selectedRows = selected ? (rows || data).map(function (row, idx) {
	                    return row[rowKeyColumn] || row.key || idx;
	                }) : [];
	
	                this.setState({
	                    headerSelected: selected,
	                    selectedRows: selectedRows
	                });
	
	                this.props.onSelectionChanged(selectedRows);
	            }
	        }, {
	            key: 'handleChangeRowCheckbox',
	            value: function handleChangeRowCheckbox(e) {
	                var _props2 = this.props;
	                var rows = _props2.rows;
	                var data = _props2.data;
	
	                var rowId = JSON.parse(e.target.dataset.reactmdl).id;
	                var rowChecked = e.target.checked;
	                var selectedRows = this.state.selectedRows;
	
	                if (rowChecked) {
	                    selectedRows.push(rowId);
	                } else {
	                    var idx = selectedRows.indexOf(rowId);
	                    selectedRows.splice(idx, 1);
	                }
	
	                this.setState({
	                    headerSelected: (rows || data).length === selectedRows.length,
	                    selectedRows: selectedRows
	                });
	
	                this.props.onSelectionChanged(selectedRows);
	            }
	        }, {
	            key: 'builRowCheckbox',
	            value: function builRowCheckbox(content, row, idx) {
	                var rowKey = row[this.props.rowKeyColumn] || row.key || idx;
	                var isSelected = this.state.selectedRows.indexOf(rowKey) > -1;
	                return _react2.default.createElement(_Checkbox2.default, {
	                    className: 'mdl-data-table__select',
	                    'data-reactmdl': JSON.stringify({ id: rowKey }),
	                    checked: isSelected,
	                    onChange: this.handleChangeRowCheckbox
	                });
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _this3 = this;
	
	                var _props3 = this.props;
	                var rows = _props3.rows;
	                var data = _props3.data;
	                var selectable = _props3.selectable;
	                var children = _props3.children;
	                var rowKeyColumn = _props3.rowKeyColumn;
	
	                var otherProps = _objectWithoutProperties(_props3, ['rows', 'data', 'selectable', 'children', 'rowKeyColumn']);
	
	                // remove unwatned props
	                // see https://github.com/Hacker0x01/react-datepicker/issues/517#issuecomment-230171426
	
	
	                delete otherProps.onSelectionChanged;
	
	                var realRows = selectable ? (rows || data).map(function (row, idx) {
	                    var rowKey = row[rowKeyColumn] || row.key || idx;
	                    return _extends({}, row, {
	                        className: (0, _classnames2.default)({
	                            'is-selected': _this3.state.selectedRows.indexOf(rowKey) > -1
	                        }, row.className)
	                    });
	                }) : rows || data;
	
	                return _react2.default.createElement(
	                    Component,
	                    _extends({ rows: realRows }, otherProps),
	                    selectable && _react2.default.createElement(
	                        _TableHeader2.default,
	                        { name: 'mdl-header-select', cellFormatter: this.builRowCheckbox },
	                        _react2.default.createElement(_Checkbox2.default, {
	                            className: 'mdl-data-table__select',
	                            checked: this.state.headerSelected,
	                            onChange: this.handleChangeHeaderCheckbox
	                        })
	                    ),
	                    children
	                );
	            }
	        }]);
	
	        return Selectable;
	    }(_react2.default.Component);
	
	    Selectable.propTypes = propTypes;
	    Selectable.defaultProps = defaultProps;
	    return Selectable;
	};

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TableHeader = __webpack_require__(79);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function initState(props) {
	    return {
	        rows: (props.rows || props.data).slice(),
	        sortHeader: null,
	        isAsc: true
	    };
	}
	
	var propTypes = {
	    columns: function columns(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use the component `TableHeader` instead.');
	    },
	    data: function data(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use `rows` instead. `' + propName + '` will be removed in the next major release.');
	    },
	    rows: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    sortable: _react.PropTypes.bool
	};
	
	exports.default = function (Component) {
	    var Sortable = function (_React$Component) {
	        _inherits(Sortable, _React$Component);
	
	        function Sortable(props) {
	            _classCallCheck(this, Sortable);
	
	            var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Sortable).call(this, props));
	
	            _this.handleClickColumn = _this.handleClickColumn.bind(_this);
	
	            if (props.sortable) {
	                _this.state = initState(props);
	            }
	            return _this;
	        }
	
	        _createClass(Sortable, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if (nextProps.sortable) {
	                    var realRows = nextProps.rows || nextProps.data;
	                    var rows = this.state.sortHeader ? this.getSortedRowsForColumn(this.state.isAsc, this.state.sortHeader, realRows) : realRows;
	
	                    this.setState({
	                        rows: rows
	                    });
	                }
	            }
	        }, {
	            key: 'getColumnClass',
	            value: function getColumnClass(column) {
	                var _state = this.state;
	                var sortHeader = _state.sortHeader;
	                var isAsc = _state.isAsc;
	
	
	                return (0, _classnames2.default)(column.className, {
	                    'mdl-data-table__header--sorted-ascending': sortHeader === column.name && isAsc,
	                    'mdl-data-table__header--sorted-descending': sortHeader === column.name && !isAsc
	                });
	            }
	        }, {
	            key: 'getDefaultSortFn',
	            value: function getDefaultSortFn(a, b, isAsc) {
	                return isAsc ? a.localeCompare(b) : b.localeCompare(a);
	            }
	        }, {
	            key: 'getSortedRowsForColumn',
	            value: function getSortedRowsForColumn(isAsc, columnName, rows) {
	                var columns = !!this.props.children ? _react2.default.Children.map(this.props.children, function (child) {
	                    return child.props;
	                }) : this.props.columns;
	
	                var sortFn = this.getDefaultSortFn;
	                for (var i = 0; i < columns.length; i++) {
	                    if (columns[i].name === columnName && columns[i].sortFn) {
	                        sortFn = columns[i].sortFn;
	                        break;
	                    }
	                }
	
	                return rows.sort(function (a, b) {
	                    return sortFn(String(a[columnName]), String(b[columnName]), isAsc);
	                });
	            }
	        }, {
	            key: 'handleClickColumn',
	            value: function handleClickColumn(e, columnName) {
	                var isAsc = this.state.sortHeader === columnName ? !this.state.isAsc : true;
	                var rows = this.getSortedRowsForColumn(isAsc, columnName, this.state.rows);
	                this.setState({
	                    sortHeader: columnName,
	                    isAsc: isAsc,
	                    rows: rows
	                });
	            }
	        }, {
	            key: 'renderTableHeaders',
	            value: function renderTableHeaders() {
	                var _this2 = this;
	
	                var _props = this.props;
	                var children = _props.children;
	                var columns = _props.columns;
	                var sortable = _props.sortable;
	
	
	                if (sortable) {
	                    return children ? _react2.default.Children.map(children, function (child) {
	                        return _react2.default.cloneElement(child, {
	                            className: _this2.getColumnClass(child.props),
	                            onClick: _this2.handleClickColumn
	                        });
	                    }) : columns.map(function (column) {
	                        return _react2.default.createElement(
	                            _TableHeader2.default,
	                            {
	                                key: column.name,
	                                className: _this2.getColumnClass(column),
	                                name: column.name,
	                                numeric: column.numeric,
	                                tooltip: column.tooltip,
	                                onClick: _this2.handleClickColumn
	                            },
	                            column.label
	                        );
	                    });
	                }
	                return children;
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _props2 = this.props;
	                var rows = _props2.rows;
	                var data = _props2.data;
	
	                var otherProps = _objectWithoutProperties(_props2, ['rows', 'data']);
	
	                var realRows = this.state && this.state.rows || rows || data;
	
	                // remove unwanted props
	                delete otherProps.sortable;
	
	                return _react2.default.createElement(
	                    Component,
	                    _extends({ rows: realRows }, otherProps),
	                    this.renderTableHeaders()
	                );
	            }
	        }]);
	
	        return Sortable;
	    }(_react2.default.Component);
	
	    Sortable.propTypes = propTypes;
	    return Sortable;
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UndecoratedTable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clamp = __webpack_require__(82);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _shadows = __webpack_require__(81);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	var _TableHeader = __webpack_require__(79);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _Selectable = __webpack_require__(395);
	
	var _Selectable2 = _interopRequireDefault(_Selectable);
	
	var _Sortable = __webpack_require__(396);
	
	var _Sortable2 = _interopRequireDefault(_Sortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    columns: function columns(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use the component `TableHeader` instead.');
	    },
	    data: function data(props, propName, componentName) {
	        return props[propName] && new Error(componentName + ': `' + propName + '` is deprecated, please use `rows` instead. `' + propName + '` will be removed in the next major release.');
	    },
	    rowKeyColumn: _react.PropTypes.string,
	    rows: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
	    shadow: _react.PropTypes.number
	};
	
	var Table = function (_React$Component) {
	    _inherits(Table, _React$Component);
	
	    function Table() {
	        _classCallCheck(this, Table);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Table).apply(this, arguments));
	    }
	
	    _createClass(Table, [{
	        key: 'renderCell',
	        value: function renderCell(column, row, idx) {
	            var className = !column.numeric ? 'mdl-data-table__cell--non-numeric' : '';
	            return _react2.default.createElement(
	                'td',
	                { key: column.name, className: className },
	                column.cellFormatter ? column.cellFormatter(row[column.name], row, idx) : row[column.name]
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var className = _props.className;
	            var columns = _props.columns;
	            var shadow = _props.shadow;
	            var children = _props.children;
	            var rowKeyColumn = _props.rowKeyColumn;
	            var rows = _props.rows;
	            var data = _props.data;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'columns', 'shadow', 'children', 'rowKeyColumn', 'rows', 'data']);
	
	            var realRows = rows || data;
	
	            var hasShadow = typeof shadow !== 'undefined';
	            var shadowLevel = (0, _clamp2.default)(shadow || 0, 0, _shadows2.default.length - 1);
	
	            var classes = (0, _classnames2.default)('mdl-data-table', _defineProperty({}, _shadows2.default[shadowLevel], hasShadow), className);
	
	            var columnChildren = !!children ? _react2.default.Children.toArray(children) : columns.map(function (column) {
	                return _react2.default.createElement(
	                    _TableHeader2.default,
	                    {
	                        key: column.name,
	                        className: column.className,
	                        name: column.name,
	                        numeric: column.numeric,
	                        tooltip: column.tooltip
	                    },
	                    column.label
	                );
	            });
	            return _react2.default.createElement(
	                'table',
	                _extends({ className: classes }, otherProps),
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        columnChildren
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    realRows.map(function (row, idx) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: row[rowKeyColumn] || row.key || idx, className: row.className },
	                            columnChildren.map(function (child) {
	                                return _this2.renderCell(child.props, row, idx);
	                            })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	
	exports.default = (0, _Sortable2.default)((0, _Selectable2.default)(Table));
	var UndecoratedTable = exports.UndecoratedTable = Table;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableHeader = __webpack_require__(79);
	
	Object.defineProperty(exports, 'TableHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHeader).default;
	  }
	});
	
	var _Table = __webpack_require__(397);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    onCancel: _react.PropTypes.func,
	    open: _react.PropTypes.bool
	};
	
	var defaultProps = {
	    onCancel: function onCancel(e) {
	        return e.preventDefault();
	    }
	};
	
	var Dialog = function (_React$Component) {
	    _inherits(Dialog, _React$Component);
	
	    function Dialog() {
	        _classCallCheck(this, Dialog);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Dialog).apply(this, arguments));
	    }
	
	    _createClass(Dialog, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.dialogRef.addEventListener('cancel', this.props.onCancel);
	            if (this.props.open) {
	                (0, _reactDom.findDOMNode)(this).showModal();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.open !== prevProps.open) {
	                if (this.props.open) {
	                    (0, _reactDom.findDOMNode)(this).showModal();
	
	                    // display the dialog at the right location
	                    // needed for the polyfill, otherwise it's not at the right position
	                    var windowHeight = window.innerHeight;
	                    if (this.dialogRef) {
	                        var dialogHeight = this.dialogRef.clientHeight;
	                        this.dialogRef.style.position = 'fixed';
	                        this.dialogRef.style.top = (windowHeight - dialogHeight) / 2 + 'px';
	                    }
	                } else {
	                    (0, _reactDom.findDOMNode)(this).close();
	                }
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.dialogRef.removeEventListener('cancel', this.props.onCancel);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            // We cannot set the `open` prop on the Dialog if we manage its state manually with `showModal`,
	            // this the disabled eslint rule
	            // eslint-disable-next-line no-unused-vars
	            var _props = this.props;
	            var className = _props.className;
	            var open = _props.open;
	            var onCancel = _props.onCancel;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'open', 'onCancel', 'children']);
	
	            var classes = (0, _classnames2.default)('mdl-dialog', className);
	
	            return _react2.default.createElement(
	                'dialog',
	                _extends({ ref: function ref(c) {
	                        return _this2.dialogRef = c;
	                    }, className: classes }, otherProps),
	                children
	            );
	        }
	    }]);
	
	    return Dialog;
	}(_react2.default.Component);
	
	Dialog.propTypes = propTypes;
	Dialog.defaultProps = defaultProps;
	
	exports.default = Dialog;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DialogActions = function DialogActions(props) {
	    var className = props.className;
	    var fullWidth = props.fullWidth;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'fullWidth', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-dialog__actions', {
	        'mdl-dialog__actions--full-width': fullWidth
	    }, className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	DialogActions.propTypes = {
	    className: _react.PropTypes.string,
	    fullWidth: _react.PropTypes.bool
	};
	
	exports.default = DialogActions;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DialogTitle = function DialogTitle(props) {
	    var className = props.className;
	    var component = props.component;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'component', 'children']);
	
	    return _react2.default.createElement(component || 'h4', _extends({
	        className: (0, _classnames2.default)('mdl-dialog__title', className)
	    }, otherProps), children);
	};
	
	DialogTitle.propTypes = {
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func])
	};
	
	exports.default = DialogTitle;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DialogActions = exports.DialogContent = exports.DialogTitle = exports.Dialog = undefined;
	
	var _Dialog = __webpack_require__(399);
	
	Object.defineProperty(exports, 'Dialog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  }
	});
	
	var _DialogTitle = __webpack_require__(401);
	
	Object.defineProperty(exports, 'DialogTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogTitle).default;
	  }
	});
	
	var _DialogActions = __webpack_require__(400);
	
	Object.defineProperty(exports, 'DialogActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogActions).default;
	  }
	});
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialogContent = exports.DialogContent = (0, _basicClassCreator2.default)('DialogContent', 'mdl-dialog__content');

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(116);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FABButton = function FABButton(props) {
	    var mini = props.mini;
	    var className = props.className;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['mini', 'className', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-button--fab', {
	        'mdl-button--mini-fab': mini
	    }, className);
	
	    return _react2.default.createElement(
	        _Button2.default,
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	FABButton.propTypes = {
	    className: _react.PropTypes.string,
	    mini: _react.PropTypes.bool
	};
	
	exports.default = FABButton;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneChildren = __webpack_require__(80);
	
	var _cloneChildren2 = _interopRequireDefault(_cloneChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DropDownSection = function DropDownSection(props) {
	    var className = props.className;
	    var size = props.size;
	    var title = props.title;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'size', 'title', 'children']);
	
	    var classes = (0, _classnames2.default)(_defineProperty({}, 'mdl-' + size + '-footer__drop-down-section', true), className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        _react2.default.createElement('input', { className: 'mdl-' + size + '-footer__heading-checkbox', type: 'checkbox', defaultChecked: true }),
	        _react2.default.createElement(
	            'h1',
	            { className: 'mdl-' + size + '-footer__heading' },
	            title
	        ),
	        (0, _cloneChildren2.default)(children, { size: size })
	    );
	};
	
	DropDownSection.propTypes = {
	    className: _react.PropTypes.string,
	    size: _react.PropTypes.oneOf(['mini', 'mega']),
	    title: _react.PropTypes.node.isRequired
	};
	DropDownSection.defaultProps = {
	    size: 'mega'
	};
	
	exports.default = DropDownSection;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneChildren = __webpack_require__(80);
	
	var _cloneChildren2 = _interopRequireDefault(_cloneChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Footer = function Footer(props) {
	    var className = props.className;
	    var size = props.size;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'size', 'children']);
	
	    var classes = (0, _classnames2.default)(_defineProperty({}, 'mdl-' + size + '-footer', true), className);
	
	    return _react2.default.createElement(
	        'footer',
	        _extends({ className: classes }, otherProps),
	        (0, _cloneChildren2.default)(children, { size: size })
	    );
	};
	
	Footer.propTypes = {
	    className: _react.PropTypes.string,
	    size: _react.PropTypes.oneOf(['mini', 'mega'])
	};
	Footer.defaultProps = {
	    size: 'mega'
	};
	
	exports.default = Footer;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LinkList = function LinkList(props) {
	    var className = props.className;
	    var size = props.size;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'size', 'children']);
	
	    var classes = (0, _classnames2.default)(_defineProperty({}, 'mdl-' + size + '-footer__link-list', true), className);
	
	    return _react2.default.createElement(
	        'ul',
	        _extends({ className: classes }, otherProps),
	        _react2.default.Children.map(children, function (child) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                child
	            );
	        })
	    );
	};
	
	LinkList.propTypes = {
	    className: _react.PropTypes.string,
	    size: _react.PropTypes.oneOf(['mini', 'mega'])
	};
	LinkList.defaultProps = {
	    size: 'mega'
	};
	
	exports.default = LinkList;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneChildren = __webpack_require__(80);
	
	var _cloneChildren2 = _interopRequireDefault(_cloneChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Section = function Section(props) {
	    var className = props.className;
	    var logo = props.logo;
	    var size = props.size;
	    var type = props.type;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'logo', 'size', 'type', 'children']);
	
	    var classes = (0, _classnames2.default)(_defineProperty({}, 'mdl-' + size + '-footer__' + type + '-section', true), className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        logo ? _react2.default.createElement(
	            'div',
	            { className: 'mdl-logo' },
	            logo
	        ) : null,
	        (0, _cloneChildren2.default)(children, { size: size })
	    );
	};
	
	Section.propTypes = {
	    className: _react.PropTypes.string,
	    logo: _react.PropTypes.node,
	    size: _react.PropTypes.oneOf(['mini', 'mega']),
	    type: _react.PropTypes.oneOf(['top', 'middle', 'bottom', 'left', 'right'])
	};
	Section.defaultProps = {
	    size: 'mega',
	    type: 'left'
	};
	
	exports.default = Section;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footer = __webpack_require__(405);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});
	
	var _Section = __webpack_require__(407);
	
	Object.defineProperty(exports, 'FooterSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Section).default;
	  }
	});
	
	var _DropDownSection = __webpack_require__(404);
	
	Object.defineProperty(exports, 'FooterDropDownSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DropDownSection).default;
	  }
	});
	
	var _LinkList = __webpack_require__(406);
	
	Object.defineProperty(exports, 'FooterLinkList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkList).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clamp = __webpack_require__(82);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _shadows = __webpack_require__(81);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    align: _react.PropTypes.oneOf(['top', 'middle', 'bottom', 'stretch']),
	    className: _react.PropTypes.string,
	    col: _react.PropTypes.number,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    phone: _react.PropTypes.number,
	    tablet: _react.PropTypes.number,
	    offset: _react.PropTypes.number,
	    offsetDesktop: _react.PropTypes.number,
	    offsetTablet: _react.PropTypes.number,
	    offsetPhone: _react.PropTypes.number,
	    hideDesktop: _react.PropTypes.bool,
	    hidePhone: _react.PropTypes.bool,
	    hideTablet: _react.PropTypes.bool,
	    shadow: _react.PropTypes.number
	};
	
	function isDefined(data) {
	    return typeof data !== 'undefined';
	}
	
	var Cell = function Cell(props) {
	    var _classNames;
	
	    var align = props.align;
	    var className = props.className;
	    var children = props.children;
	    var col = props.col;
	    var phone = props.phone;
	    var tablet = props.tablet;
	    var component = props.component;
	    var hideDesktop = props.hideDesktop;
	    var hidePhone = props.hidePhone;
	    var hideTablet = props.hideTablet;
	    var shadow = props.shadow;
	    var offset = props.offset;
	    var offsetDesktop = props.offsetDesktop;
	    var offsetTablet = props.offsetTablet;
	    var offsetPhone = props.offsetPhone;
	
	    var otherProps = _objectWithoutProperties(props, ['align', 'className', 'children', 'col', 'phone', 'tablet', 'component', 'hideDesktop', 'hidePhone', 'hideTablet', 'shadow', 'offset', 'offsetDesktop', 'offsetTablet', 'offsetPhone']);
	
	    var hasShadow = isDefined(shadow);
	    var shadowLevel = (0, _clamp2.default)(shadow || 0, 0, _shadows2.default.length - 1);
	
	    var classes = (0, _classnames2.default)('mdl-cell', (_classNames = {}, _defineProperty(_classNames, 'mdl-cell--' + col + '-col', isDefined(col)), _defineProperty(_classNames, 'mdl-cell--' + phone + '-col-phone', isDefined(phone)), _defineProperty(_classNames, 'mdl-cell--' + tablet + '-col-tablet', isDefined(tablet)), _defineProperty(_classNames, 'mdl-cell--' + align, isDefined(align)), _defineProperty(_classNames, 'mdl-cell--' + offset + '-offset', isDefined(offset)), _defineProperty(_classNames, 'mdl-cell--' + offsetDesktop + '-offset-desktop', isDefined(offsetDesktop)), _defineProperty(_classNames, 'mdl-cell--' + offsetTablet + '-offset-tablet', isDefined(offsetTablet)), _defineProperty(_classNames, 'mdl-cell--' + offsetPhone + '-offset-phone', isDefined(offsetPhone)), _defineProperty(_classNames, 'mdl-cell--hide-desktop', hideDesktop), _defineProperty(_classNames, 'mdl-cell--hide-phone', hidePhone), _defineProperty(_classNames, 'mdl-cell--hide-tablet', hideTablet), _defineProperty(_classNames, _shadows2.default[shadowLevel], hasShadow), _classNames), className);
	
	    return _react2.default.createElement(component || 'div', _extends({
	        className: classes
	    }, otherProps), children);
	};
	
	Cell.propTypes = propTypes;
	
	exports.default = Cell;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clamp = __webpack_require__(82);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _shadows = __webpack_require__(81);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	    noSpacing: _react.PropTypes.bool,
	    shadow: _react.PropTypes.number
	};
	
	var Grid = function Grid(props) {
	    var noSpacing = props.noSpacing;
	    var className = props.className;
	    var children = props.children;
	    var component = props.component;
	    var shadow = props.shadow;
	
	    var otherProps = _objectWithoutProperties(props, ['noSpacing', 'className', 'children', 'component', 'shadow']);
	
	    var hasShadow = typeof shadow !== 'undefined';
	    var shadowLevel = (0, _clamp2.default)(shadow || 0, 0, _shadows2.default.length - 1);
	
	    var classes = (0, _classnames2.default)('mdl-grid', _defineProperty({
	        'mdl-grid--no-spacing': noSpacing
	    }, _shadows2.default[shadowLevel], hasShadow), className);
	
	    return _react2.default.createElement(component || 'div', _extends({
	        className: classes
	    }, otherProps), children);
	};
	
	Grid.propTypes = propTypes;
	
	exports.default = Grid;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Grid = __webpack_require__(410);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _Cell = __webpack_require__(409);
	
	Object.defineProperty(exports, 'Cell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Cell).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(116);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(60);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconButton = function IconButton(props) {
	    var className = props.className;
	    var name = props.name;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'name']);
	
	    var classes = (0, _classnames2.default)('mdl-button--icon', className);
	
	    return _react2.default.createElement(
	        _Button2.default,
	        _extends({ className: classes }, otherProps),
	        _react2.default.createElement(_Icon2.default, { name: name })
	    );
	};
	
	IconButton.propTypes = {
	    className: _react.PropTypes.string,
	    name: _react.PropTypes.string.isRequired
	};
	
	exports.default = IconButton;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(60);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    checked: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    name: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	var IconToggle = function (_React$Component) {
	    _inherits(IconToggle, _React$Component);
	
	    function IconToggle() {
	        _classCallCheck(this, IconToggle);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(IconToggle).apply(this, arguments));
	    }
	
	    _createClass(IconToggle, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.disabled !== prevProps.disabled) {
	                var fnName = this.props.disabled ? 'disable' : 'enable';
	                (0, _reactDom.findDOMNode)(this).MaterialIconToggle[fnName]();
	            }
	            if (this.props.checked !== prevProps.checked) {
	                var _fnName = this.props.checked ? 'check' : 'uncheck';
	                (0, _reactDom.findDOMNode)(this).MaterialIconToggle[_fnName]();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var name = _props.name;
	            var ripple = _props.ripple;
	
	            var inputProps = _objectWithoutProperties(_props, ['className', 'name', 'ripple']);
	
	            var classes = (0, _classnames2.default)('mdl-icon-toggle mdl-js-icon-toggle', {
	                'mdl-js-ripple-effect': ripple
	            }, className);
	
	            return _react2.default.createElement(
	                'label',
	                { className: classes },
	                _react2.default.createElement('input', _extends({
	                    type: 'checkbox',
	                    className: 'mdl-icon-toggle__input'
	                }, inputProps)),
	                _react2.default.createElement(_Icon2.default, { className: 'mdl-icon-toggle__label', name: name })
	            );
	        }
	    }]);
	
	    return IconToggle;
	}(_react2.default.Component);
	
	IconToggle.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(IconToggle);

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Content = function Content(props) {
	    var children = props.children;
	    var className = props.className;
	    var component = props.component;
	
	    var otherProps = _objectWithoutProperties(props, ['children', 'className', 'component']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__content', className);
	
	    return _react2.default.createElement(component || 'div', _extends({
	        className: classes
	    }, otherProps), children);
	};
	
	Content.propTypes = {
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func])
	};
	
	exports.default = Content;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Drawer = function Drawer(props) {
	    var className = props.className;
	    var title = props.title;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'title', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__drawer', className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        title ? _react2.default.createElement(
	            'span',
	            { className: 'mdl-layout-title' },
	            title
	        ) : null,
	        children
	    );
	};
	Drawer.propTypes = {
	    className: _react.PropTypes.string,
	    title: _react.PropTypes.node
	};
	
	exports.default = Drawer;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HeaderRow = __webpack_require__(188);
	
	var _HeaderRow2 = _interopRequireDefault(_HeaderRow);
	
	var _HeaderTabs = __webpack_require__(189);
	
	var _HeaderTabs2 = _interopRequireDefault(_HeaderTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Header = function Header(props) {
	    var className = props.className;
	    var scroll = props.scroll;
	    var seamed = props.seamed;
	    var title = props.title;
	    var transparent = props.transparent;
	    var waterfall = props.waterfall;
	    var hideTop = props.hideTop;
	    var hideSpacer = props.hideSpacer;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'scroll', 'seamed', 'title', 'transparent', 'waterfall', 'hideTop', 'hideSpacer', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-layout__header', {
	        'mdl-layout__header--scroll': scroll,
	        'mdl-layout__header--seamed': seamed,
	        'mdl-layout__header--transparent': transparent,
	        'mdl-layout__header--waterfall': waterfall,
	        'mdl-layout__header--waterfall-hide-top': waterfall && hideTop
	    }, className);
	
	    var isRowOrTab = false;
	    _react2.default.Children.forEach(children, function (child) {
	        if (child && (child.type === _HeaderRow2.default || child.type === _HeaderTabs2.default)) {
	            isRowOrTab = true;
	        }
	    });
	
	    return _react2.default.createElement(
	        'header',
	        _extends({ className: classes }, otherProps),
	        isRowOrTab ? children : _react2.default.createElement(
	            _HeaderRow2.default,
	            { title: title, hideSpacer: hideSpacer },
	            children
	        )
	    );
	};
	Header.propTypes = {
	    className: _react.PropTypes.string,
	    scroll: _react.PropTypes.bool,
	    seamed: _react.PropTypes.bool,
	    title: _react.PropTypes.node,
	    transparent: _react.PropTypes.bool,
	    waterfall: _react.PropTypes.bool,
	    hideTop: _react.PropTypes.bool,
	    hideSpacer: _react.PropTypes.bool
	};
	
	exports.default = Header;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    fixedDrawer: _react.PropTypes.bool,
	    fixedHeader: _react.PropTypes.bool,
	    fixedTabs: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Layout = function (_React$Component) {
	    _inherits(Layout, _React$Component);
	
	    function Layout() {
	        _classCallCheck(this, Layout);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Layout).apply(this, arguments));
	    }
	
	    _createClass(Layout, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var fixedDrawer = _props.fixedDrawer;
	            var fixedHeader = _props.fixedHeader;
	            var fixedTabs = _props.fixedTabs;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'fixedDrawer', 'fixedHeader', 'fixedTabs']);
	
	            var classes = (0, _classnames2.default)('mdl-layout mdl-js-layout', {
	                'mdl-layout--fixed-drawer': fixedDrawer,
	                'mdl-layout--fixed-header': fixedHeader,
	                'mdl-layout--fixed-tabs': fixedTabs
	            }, className);
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: classes }, otherProps),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mdl-layout__inner-container' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Layout);

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _cloneChildren = __webpack_require__(80);
	
	var _cloneChildren2 = _interopRequireDefault(_cloneChildren);
	
	var _Spacer = __webpack_require__(117);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Navigation = function Navigation(props) {
	    var className = props.className;
	    var children = props.children;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'children']);
	
	    var classes = (0, _classnames2.default)('mdl-navigation', className);
	
	    return _react2.default.createElement(
	        'nav',
	        _extends({ className: classes }, otherProps),
	        (0, _cloneChildren2.default)(children, function (child) {
	            return {
	                className: (0, _classnames2.default)({ 'mdl-navigation__link': child.type !== _Spacer2.default }, child.props.className)
	            };
	        })
	    );
	};
	Navigation.propTypes = {
	    className: _react.PropTypes.string
	};
	
	exports.default = Navigation;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Layout = __webpack_require__(417);
	
	Object.defineProperty(exports, 'Layout', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Layout).default;
	  }
	});
	
	var _Content = __webpack_require__(414);
	
	Object.defineProperty(exports, 'Content', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Content).default;
	  }
	});
	
	var _Drawer = __webpack_require__(415);
	
	Object.defineProperty(exports, 'Drawer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Drawer).default;
	  }
	});
	
	var _Header = __webpack_require__(416);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Header).default;
	  }
	});
	
	var _HeaderRow = __webpack_require__(188);
	
	Object.defineProperty(exports, 'HeaderRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderRow).default;
	  }
	});
	
	var _HeaderTabs = __webpack_require__(189);
	
	Object.defineProperty(exports, 'HeaderTabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HeaderTabs).default;
	  }
	});
	
	var _Navigation = __webpack_require__(418);
	
	Object.defineProperty(exports, 'Navigation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Navigation).default;
	  }
	});
	
	var _Spacer = __webpack_require__(117);
	
	Object.defineProperty(exports, 'Spacer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spacer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ListItemContent = __webpack_require__(190);
	
	var _ListItemContent2 = _interopRequireDefault(_ListItemContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    twoLine: _react.PropTypes.bool,
	    threeLine: _react.PropTypes.bool
	};
	
	var ListItem = function ListItem(props) {
	    var className = props.className;
	    var twoLine = props.twoLine;
	    var threeLine = props.threeLine;
	
	    var otherProps = _objectWithoutProperties(props, ['className', 'twoLine', 'threeLine']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item', {
	        'mdl-list__item--two-line': twoLine && !threeLine,
	        'mdl-list__item--three-line': !twoLine && threeLine
	    }, className);
	
	    var children = _react.Children.map(otherProps.children, function (child) {
	        if (typeof child === 'string') {
	            return _react2.default.createElement(
	                _ListItemContent2.default,
	                null,
	                child
	            );
	        }
	        if (child.type === _ListItemContent2.default) {
	            return (0, _react.cloneElement)(child, {
	                useBodyClass: !!threeLine
	            });
	        }
	        return child;
	    });
	
	    return _react2.default.createElement(
	        'li',
	        _extends({ className: classes }, otherProps),
	        children
	    );
	};
	
	ListItem.propTypes = propTypes;
	
	exports.default = ListItem;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	    children: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    info: _react.PropTypes.string
	};
	
	var ListItemAction = function ListItemAction(props) {
	    var children = props.children;
	    var className = props.className;
	    var info = props.info;
	
	    var otherProps = _objectWithoutProperties(props, ['children', 'className', 'info']);
	
	    var classes = (0, _classnames2.default)('mdl-list__item-secondary-content', className);
	
	    return _react2.default.createElement(
	        'span',
	        _extends({ className: classes }, otherProps),
	        info && _react2.default.createElement(
	            'span',
	            { className: 'mdl-list__item-secondary-info' },
	            info
	        ),
	        _react2.default.createElement(
	            'span',
	            { className: 'mdl-list__item-secondary-action' },
	            children
	        )
	    );
	};
	
	ListItemAction.propTypes = propTypes;
	
	exports.default = ListItemAction;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemContent = exports.ListItemAction = exports.ListItem = exports.List = undefined;
	
	var _ListItem = __webpack_require__(420);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListItemAction = __webpack_require__(421);
	
	Object.defineProperty(exports, 'ListItemAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemAction).default;
	  }
	});
	
	var _ListItemContent = __webpack_require__(190);
	
	Object.defineProperty(exports, 'ListItemContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemContent).default;
	  }
	});
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = exports.List = (0, _basicClassCreator2.default)('List', 'mdl-list', 'ul');

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MenuItem = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	var _basicClassCreator = __webpack_require__(48);
	
	var _basicClassCreator2 = _interopRequireDefault(_basicClassCreator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    align: _react.PropTypes.oneOf(['left', 'right']),
	    className: _react.PropTypes.string,
	    ripple: _react.PropTypes.bool,
	    target: _react.PropTypes.string.isRequired,
	    valign: _react.PropTypes.oneOf(['bottom', 'top'])
	};
	
	var defaultProps = {
	    align: 'left',
	    valign: 'bottom'
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Menu = function (_React$Component) {
	    _inherits(Menu, _React$Component);
	
	    function Menu() {
	        _classCallCheck(this, Menu);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).apply(this, arguments));
	    }
	
	    _createClass(Menu, [{
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props;
	            var align = _props.align;
	            var children = _props.children;
	            var className = _props.className;
	            var ripple = _props.ripple;
	            var target = _props.target;
	            var valign = _props.valign;
	
	            var otherProps = _objectWithoutProperties(_props, ['align', 'children', 'className', 'ripple', 'target', 'valign']);
	
	            var classes = (0, _classnames2.default)('mdl-menu mdl-js-menu', (_classNames = {}, _defineProperty(_classNames, 'mdl-menu--' + valign + '-' + align, true), _defineProperty(_classNames, 'mdl-js-ripple-effect', ripple), _classNames), className);
	
	            return _react2.default.createElement(
	                'ul',
	                _extends({ className: classes, 'data-mdl-for': target }, otherProps),
	                children
	            );
	        }
	    }]);
	
	    return Menu;
	}(_react2.default.Component);
	
	Menu.propTypes = propTypes;
	Menu.defaultProps = defaultProps;
	
	exports.default = (0, _mdlUpgrade2.default)(Menu);
	var MenuItem = exports.MenuItem = (0, _basicClassCreator2.default)('MenuItem', 'mdl-menu__item', 'li');

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    buffer: _react.PropTypes.number,
	    className: _react.PropTypes.string,
	    indeterminate: _react.PropTypes.bool,
	    progress: _react.PropTypes.number
	};
	
	var ProgressBar = function (_React$Component) {
	    _inherits(ProgressBar, _React$Component);
	
	    function ProgressBar() {
	        _classCallCheck(this, ProgressBar);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(ProgressBar).apply(this, arguments));
	    }
	
	    _createClass(ProgressBar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setProgress(this.props.progress);
	            this.setBuffer(this.props.buffer);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.setProgress(this.props.progress);
	            this.setBuffer(this.props.buffer);
	        }
	    }, {
	        key: 'setProgress',
	        value: function setProgress(progress) {
	            if (!this.props.indeterminate && progress !== undefined) {
	                (0, _reactDom.findDOMNode)(this).MaterialProgress.setProgress(progress);
	            }
	        }
	    }, {
	        key: 'setBuffer',
	        value: function setBuffer(buffer) {
	            if (buffer !== undefined) {
	                (0, _reactDom.findDOMNode)(this).MaterialProgress.setBuffer(buffer);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var indeterminate = _props.indeterminate;
	            var buffer = _props.buffer;
	            var progress = _props.progress;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'indeterminate', 'buffer', 'progress']);
	
	            var classes = (0, _classnames2.default)('mdl-progress mdl-js-progress', {
	                'mdl-progress__indeterminate': indeterminate
	            }, className);
	
	            return _react2.default.createElement('div', _extends({ className: classes }, otherProps));
	        }
	    }]);
	
	    return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(ProgressBar);

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Radio = __webpack_require__(191);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RadioGroup = function RadioGroup(props) {
	    var name = props.name;
	    var value = props.value;
	    var children = props.children;
	    var container = props.container;
	    var childContainer = props.childContainer;
	    var onChange = props.onChange;
	
	    var otherProps = _objectWithoutProperties(props, ['name', 'value', 'children', 'container', 'childContainer', 'onChange']);
	
	    var hasOnChange = typeof onChange === 'function';
	    var checked = hasOnChange ? 'checked' : 'defaultChecked';
	
	    return _react2.default.createElement(container, otherProps, _react2.default.Children.map(children, function (child) {
	        var _extends2;
	
	        var clonedChild = _react2.default.cloneElement(child, _extends((_extends2 = {}, _defineProperty(_extends2, checked, child.props.value === value), _defineProperty(_extends2, 'name', name), _defineProperty(_extends2, 'onChange', onChange), _extends2), otherProps));
	
	        return childContainer ? _react2.default.createElement(childContainer, {}, clonedChild) : clonedChild;
	    }));
	};
	
	RadioGroup.propTypes = {
	    childContainer: _react.PropTypes.string,
	    children: _react.PropTypes.arrayOf(function (props, propName, componentName) {
	        var prop = props[propName];
	        return prop.type !== _Radio2.default && new Error('\'' + componentName + '\' only accepts \'Radio\' as children.');
	    }),
	    container: _react.PropTypes.string,
	    name: _react.PropTypes.string.isRequired,
	    onChange: _react.PropTypes.func,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
	};
	
	RadioGroup.defaultProps = {
	    container: 'div'
	};
	
	exports.default = RadioGroup;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    max: _react.PropTypes.number.isRequired,
	    min: _react.PropTypes.number.isRequired,
	    onChange: _react.PropTypes.func,
	    value: _react.PropTypes.number
	};
	
	var Slider = function (_React$Component) {
	    _inherits(Slider, _React$Component);
	
	    function Slider() {
	        _classCallCheck(this, Slider);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Slider).apply(this, arguments));
	    }
	
	    _createClass(Slider, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (typeof this.props.value !== 'undefined') {
	                (0, _reactDom.findDOMNode)(this).MaterialSlider.change(this.props.value);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	
	            var otherProps = _objectWithoutProperties(_props, ['className']);
	
	            var classes = (0, _classnames2.default)('mdl-slider mdl-js-slider', className);
	
	            return _react2.default.createElement('input', _extends({
	                className: classes,
	                type: 'range'
	            }, otherProps));
	        }
	    }]);
	
	    return Slider;
	}(_react2.default.Component);
	
	Slider.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Slider);

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This component doesn't use the javascript from MDL.
	// This is the expected behavior and the reason is because it's not written in
	// a way to make it easy to use with React.
	var ANIMATION_LENGTH = 250;
	
	var propTypes = {
	    action: _react.PropTypes.string,
	    active: _react.PropTypes.bool.isRequired,
	    className: _react.PropTypes.string,
	    onActionClick: _react.PropTypes.func,
	    onTimeout: _react.PropTypes.func.isRequired,
	    timeout: _react.PropTypes.number
	};
	
	var defaultProps = {
	    timeout: 2750
	};
	
	var Snackbar = function (_React$Component) {
	    _inherits(Snackbar, _React$Component);
	
	    function Snackbar(props) {
	        _classCallCheck(this, Snackbar);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Snackbar).call(this, props));
	
	        _this.clearTimer = _this.clearTimer.bind(_this);
	        _this.timeoutId = null;
	        _this.clearTimeoutId = null;
	        _this.state = {
	            open: false
	        };
	        return _this;
	    }
	
	    _createClass(Snackbar, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                open: nextProps.active
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.timeoutId) {
	                clearTimeout(this.timeoutId);
	            }
	
	            if (this.props.active) {
	                this.timeoutId = setTimeout(this.clearTimer, this.props.timeout);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeoutId) {
	                clearTimeout(this.timeoutId);
	                this.timeoutId = null;
	            }
	            if (this.clearTimeoutId) {
	                clearTimeout(this.clearTimeoutId);
	                this.clearTimeoutId = null;
	            }
	        }
	    }, {
	        key: 'clearTimer',
	        value: function clearTimer() {
	            var _this2 = this;
	
	            this.timeoutId = null;
	            this.setState({ open: false });
	
	            this.clearTimeoutId = setTimeout(function () {
	                _this2.clearTimeoutId = null;
	                _this2.props.onTimeout();
	            }, ANIMATION_LENGTH);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var action = _props.action;
	            var active = _props.active;
	            var className = _props.className;
	            var children = _props.children;
	            var onActionClick = _props.onActionClick;
	
	            var otherProps = _objectWithoutProperties(_props, ['action', 'active', 'className', 'children', 'onActionClick']);
	
	            var open = this.state.open;
	
	
	            var classes = (0, _classnames2.default)('mdl-snackbar', {
	                'mdl-snackbar--active': open
	            }, className);
	
	            delete otherProps.onTimeout;
	            delete otherProps.timeout;
	
	            return _react2.default.createElement(
	                'div',
	                _extends({ className: classes, 'aria-hidden': !open }, otherProps),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mdl-snackbar__text' },
	                    active && children
	                ),
	                active && action && _react2.default.createElement(
	                    'button',
	                    { className: 'mdl-snackbar__action', type: 'button', onClick: onActionClick },
	                    action
	                )
	            );
	        }
	    }]);
	
	    return Snackbar;
	}(_react2.default.Component);
	
	Snackbar.propTypes = propTypes;
	Snackbar.defaultProps = defaultProps;
	
	exports.default = Snackbar;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    singleColor: _react.PropTypes.bool
	};
	
	// eslint-disable-next-line react/prefer-stateless-function
	
	var Spinner = function (_React$Component) {
	    _inherits(Spinner, _React$Component);
	
	    function Spinner() {
	        _classCallCheck(this, Spinner);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Spinner).apply(this, arguments));
	    }
	
	    _createClass(Spinner, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var singleColor = _props.singleColor;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'singleColor']);
	
	            var classes = (0, _classnames2.default)('mdl-spinner mdl-js-spinner is-active', {
	                'mdl-spinner--single-color': singleColor
	            }, className);
	
	            return _react2.default.createElement('div', _extends({ className: classes }, otherProps));
	        }
	    }]);
	
	    return Spinner;
	}(_react2.default.Component);
	
	Spinner.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Spinner);

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    checked: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    onChange: _react.PropTypes.func,
	    ripple: _react.PropTypes.bool
	};
	
	var Switch = function (_React$Component) {
	    _inherits(Switch, _React$Component);
	
	    function Switch() {
	        _classCallCheck(this, Switch);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Switch).apply(this, arguments));
	    }
	
	    _createClass(Switch, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.disabled !== prevProps.disabled) {
	                var fnName = this.props.disabled ? 'disable' : 'enable';
	                (0, _reactDom.findDOMNode)(this).MaterialSwitch[fnName]();
	            }
	            if (this.props.checked !== prevProps.checked) {
	                var _fnName = this.props.checked ? 'on' : 'off';
	                (0, _reactDom.findDOMNode)(this).MaterialSwitch[_fnName]();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props;
	            var className = _props.className;
	            var ripple = _props.ripple;
	            var children = _props.children;
	
	            var inputProps = _objectWithoutProperties(_props, ['className', 'ripple', 'children']);
	
	            var classes = (0, _classnames2.default)('mdl-switch mdl-js-switch', {
	                'mdl-js-ripple-effect': ripple
	            }, className);
	
	            return _react2.default.createElement(
	                'label',
	                { className: classes },
	                _react2.default.createElement('input', _extends({
	                    type: 'checkbox',
	                    className: 'mdl-switch__input'
	                }, inputProps)),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'mdl-switch__label' },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Switch;
	}(_react2.default.Component);
	
	Switch.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Switch);

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(192);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabBar = __webpack_require__(118);
	
	var _TabBar2 = _interopRequireDefault(_TabBar);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TabPropType = function TabPropType(props, propName, componentName) {
	    var prop = props[propName];
	    return prop.type !== _Tab2.default && new Error('\'' + componentName + '\' only accepts \'Tab\' as children.');
	};
	
	var propTypes = {
	    activeTab: _react.PropTypes.number,
	    children: _react.PropTypes.oneOfType([TabPropType, _react.PropTypes.arrayOf(TabPropType)]),
	    className: _react.PropTypes.string,
	    onChange: _react.PropTypes.func,
	    tabBarProps: _react.PropTypes.object,
	    ripple: _react.PropTypes.bool
	};
	
	var Tabs = function Tabs(props) {
	    var activeTab = props.activeTab;
	    var className = props.className;
	    var onChange = props.onChange;
	    var children = props.children;
	    var tabBarProps = props.tabBarProps;
	    var ripple = props.ripple;
	
	    var otherProps = _objectWithoutProperties(props, ['activeTab', 'className', 'onChange', 'children', 'tabBarProps', 'ripple']);
	
	    var classes = (0, _classnames2.default)('mdl-tabs mdl-js-tabs', {
	        'mdl-js-ripple-effect': ripple
	    }, className);
	
	    return _react2.default.createElement(
	        'div',
	        _extends({ className: classes }, otherProps),
	        _react2.default.createElement(
	            _TabBar2.default,
	            _extends({ cssPrefix: 'mdl-tabs', activeTab: activeTab, onChange: onChange }, tabBarProps),
	            children
	        )
	    );
	};
	
	Tabs.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Tabs);

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(430);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	
	var _TabBar = __webpack_require__(118);
	
	Object.defineProperty(exports, 'TabBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabBar).default;
	  }
	});
	
	var _Tab = __webpack_require__(192);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tab).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mdlUpgrade = __webpack_require__(19);
	
	var _mdlUpgrade2 = _interopRequireDefault(_mdlUpgrade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    error: _react.PropTypes.node,
	    expandable: _react.PropTypes.bool,
	    expandableIcon: _react.PropTypes.string,
	    floatingLabel: _react.PropTypes.bool,
	    id: _react.PropTypes.string,
	    inputClassName: _react.PropTypes.string,
	    label: _react.PropTypes.string.isRequired,
	    maxRows: _react.PropTypes.number,
	    onChange: _react.PropTypes.func,
	    pattern: _react.PropTypes.string,
	    required: _react.PropTypes.bool,
	    rows: _react.PropTypes.number,
	    style: _react.PropTypes.object,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	};
	
	var Textfield = function (_React$Component) {
	    _inherits(Textfield, _React$Component);
	
	    function Textfield() {
	        _classCallCheck(this, Textfield);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Textfield).apply(this, arguments));
	    }
	
	    _createClass(Textfield, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.error && !this.props.pattern) {
	                this.setAsInvalid();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.required !== prevProps.required || this.props.pattern !== prevProps.pattern || this.props.error !== prevProps.error) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.checkValidity();
	            }
	            if (this.props.disabled !== prevProps.disabled) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.checkDisabled();
	            }
	            if (this.props.value !== prevProps.value && this.inputRef !== document.activeElement) {
	                (0, _reactDom.findDOMNode)(this).MaterialTextfield.change(this.props.value);
	            }
	            if (this.props.error && !this.props.pattern) {
	                // Every time the input gets updated by MDL (checkValidity() or change())
	                // its invalid class gets reset. We have to put it again if the input is specifically set as "invalid"
	                this.setAsInvalid();
	            }
	        }
	    }, {
	        key: 'setAsInvalid',
	        value: function setAsInvalid() {
	            var elt = (0, _reactDom.findDOMNode)(this);
	            if (elt.className.indexOf('is-invalid') < 0) {
	                elt.className = (0, _classnames2.default)(elt.className, 'is-invalid');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props;
	            var className = _props.className;
	            var inputClassName = _props.inputClassName;
	            var id = _props.id;
	            var error = _props.error;
	            var expandable = _props.expandable;
	            var expandableIcon = _props.expandableIcon;
	            var floatingLabel = _props.floatingLabel;
	            var label = _props.label;
	            var maxRows = _props.maxRows;
	            var rows = _props.rows;
	            var style = _props.style;
	            var children = _props.children;
	
	            var otherProps = _objectWithoutProperties(_props, ['className', 'inputClassName', 'id', 'error', 'expandable', 'expandableIcon', 'floatingLabel', 'label', 'maxRows', 'rows', 'style', 'children']);
	
	            var hasRows = !!rows;
	            var customId = id || 'textfield-' + label.replace(/[^a-z0-9]/gi, '');
	            var inputTag = hasRows || maxRows > 1 ? 'textarea' : 'input';
	
	            var inputProps = _extends({
	                className: (0, _classnames2.default)('mdl-textfield__input', inputClassName),
	                id: customId,
	                rows: rows,
	                ref: function ref(c) {
	                    return _this2.inputRef = c;
	                }
	            }, otherProps);
	
	            var input = _react2.default.createElement(inputTag, inputProps);
	            var labelContainer = _react2.default.createElement(
	                'label',
	                { className: 'mdl-textfield__label', htmlFor: customId },
	                label
	            );
	            var errorContainer = !!error && _react2.default.createElement(
	                'span',
	                { className: 'mdl-textfield__error' },
	                error
	            );
	
	            var containerClasses = (0, _classnames2.default)('mdl-textfield mdl-js-textfield', {
	                'mdl-textfield--floating-label': floatingLabel,
	                'mdl-textfield--expandable': expandable
	            }, className);
	
	            return expandable ? _react2.default.createElement(
	                'div',
	                { className: containerClasses, style: style },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'mdl-button mdl-js-button mdl-button--icon', htmlFor: customId },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons' },
	                        expandableIcon
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mdl-textfield__expandable-holder' },
	                    input,
	                    labelContainer,
	                    errorContainer
	                ),
	                children
	            ) : _react2.default.createElement(
	                'div',
	                { className: containerClasses, style: style },
	                input,
	                labelContainer,
	                errorContainer,
	                children
	            );
	        }
	    }]);
	
	    return Textfield;
	}(_react2.default.Component);
	
	Textfield.propTypes = propTypes;
	
	exports.default = (0, _mdlUpgrade2.default)(Textfield);

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are **not** supported.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(249)(module)))

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var focusNode = __webpack_require__(221);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(20);
	var FallbackCompositionState = __webpack_require__(441);
	var SyntheticCompositionEvent = __webpack_require__(479);
	var SyntheticInputEvent = __webpack_require__(482);
	
	var keyOf = __webpack_require__(37);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(194);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(23);
	
	var camelizeStyleName = __webpack_require__(499);
	var dangerousStyleValue = __webpack_require__(489);
	var hyphenateStyleName = __webpack_require__(506);
	var memoizeStringOnly = __webpack_require__(509);
	var warning = __webpack_require__(12);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(61);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(29);
	var SyntheticEvent = __webpack_require__(31);
	
	var getEventTarget = __webpack_require__(138);
	var isEventSupported = __webpack_require__(139);
	var isTextInputElement = __webpack_require__(218);
	var keyOf = __webpack_require__(37);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var DOMLazyTree = __webpack_require__(49);
	var ExecutionEnvironment = __webpack_require__(20);
	
	var createNodesFromMarkup = __webpack_require__(502);
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(37);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(16);
	var SyntheticMouseEvent = __webpack_require__(85);
	
	var keyOf = __webpack_require__(37);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(35);
	
	var getTextContentAccessor = __webpack_require__(216);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactChildren = __webpack_require__(197);
	var ReactComponent = __webpack_require__(126);
	var ReactPureComponent = __webpack_require__(469);
	var ReactClass = __webpack_require__(198);
	var ReactDOMFactories = __webpack_require__(452);
	var ReactElement = __webpack_require__(28);
	var ReactPropTypes = __webpack_require__(208);
	var ReactVersion = __webpack_require__(209);
	
	var onlyChild = __webpack_require__(495);
	var warning = __webpack_require__(12);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(51);
	
	var instantiateReactComponent = __webpack_require__(217);
	var KeyEscapeUtils = __webpack_require__(124);
	var shouldUpdateReactComponent = __webpack_require__(140);
	var traverseAllChildren = __webpack_require__(141);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(128);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('./ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(120);
	var ReactDOMIDOperations = __webpack_require__(454);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var ReactComponentEnvironment = __webpack_require__(127);
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactElement = __webpack_require__(28);
	var ReactErrorUtils = __webpack_require__(129);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactNodeTypes = __webpack_require__(207);
	var ReactPropTypeLocations = __webpack_require__(132);
	var ReactReconciler = __webpack_require__(51);
	
	var checkReactTypeSpec = __webpack_require__(488);
	var emptyObject = __webpack_require__(66);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(143);
	var shouldUpdateReactComponent = __webpack_require__(140);
	var warning = __webpack_require__(12);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent;
	
	    if (false) {
	      renderedComponent = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedComponent = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDefaultInjection = __webpack_require__(462);
	var ReactMount = __webpack_require__(205);
	var ReactReconciler = __webpack_require__(51);
	var ReactUpdates = __webpack_require__(29);
	var ReactVersion = __webpack_require__(209);
	
	var findDOMNode = __webpack_require__(490);
	var getHostComponentFromComposite = __webpack_require__(214);
	var renderSubtreeIntoContainer = __webpack_require__(497);
	var warning = __webpack_require__(12);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(83);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var AutoFocusUtils = __webpack_require__(434);
	var CSSPropertyOperations = __webpack_require__(436);
	var DOMLazyTree = __webpack_require__(49);
	var DOMNamespaces = __webpack_require__(121);
	var DOMProperty = __webpack_require__(50);
	var DOMPropertyOperations = __webpack_require__(196);
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(61);
	var EventPluginRegistry = __webpack_require__(122);
	var ReactBrowserEventEmitter = __webpack_require__(84);
	var ReactDOMButton = __webpack_require__(448);
	var ReactDOMComponentFlags = __webpack_require__(199);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMInput = __webpack_require__(455);
	var ReactDOMOption = __webpack_require__(456);
	var ReactDOMSelect = __webpack_require__(200);
	var ReactDOMTextarea = __webpack_require__(459);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMultiChild = __webpack_require__(467);
	var ReactServerRenderingTransaction = __webpack_require__(472);
	
	var emptyFunction = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(86);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(139);
	var keyOf = __webpack_require__(37);
	var shallowEqual = __webpack_require__(143);
	var validateDOMNesting = __webpack_require__(142);
	var warning = __webpack_require__(12);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(142);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var DOMLazyTree = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(28);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 453 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(120);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DisabledInputUtils = __webpack_require__(83);
	var DOMPropertyOperations = __webpack_require__(196);
	var LinkedValueUtils = __webpack_require__(125);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactChildren = __webpack_require__(197);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMSelect = __webpack_require__(200);
	
	var warning = __webpack_require__(12);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var getNodeForCharacterOffset = __webpack_require__(493);
	var getTextContentAccessor = __webpack_require__(216);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DOMChildrenOperations = __webpack_require__(120);
	var DOMLazyTree = __webpack_require__(49);
	var ReactDOMComponentTree = __webpack_require__(16);
	
	var escapeTextContentForBrowser = __webpack_require__(86);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(142);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11),
	    _assign = __webpack_require__(14);
	
	var DisabledInputUtils = __webpack_require__(83);
	var LinkedValueUtils = __webpack_require__(125);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(29);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactUpdates = __webpack_require__(29);
	var Transaction = __webpack_require__(65);
	
	var emptyFunction = __webpack_require__(24);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(435);
	var ChangeEventPlugin = __webpack_require__(437);
	var DefaultEventPluginOrder = __webpack_require__(439);
	var EnterLeaveEventPlugin = __webpack_require__(440);
	var HTMLDOMPropertyConfig = __webpack_require__(442);
	var ReactComponentBrowserEnvironment = __webpack_require__(445);
	var ReactDOMComponent = __webpack_require__(449);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactDOMEmptyComponent = __webpack_require__(451);
	var ReactDOMTreeTraversal = __webpack_require__(460);
	var ReactDOMTextComponent = __webpack_require__(458);
	var ReactDefaultBatchingStrategy = __webpack_require__(461);
	var ReactEventListener = __webpack_require__(464);
	var ReactInjection = __webpack_require__(465);
	var ReactReconcileTransaction = __webpack_require__(470);
	var SVGDOMPropertyConfig = __webpack_require__(474);
	var SelectEventPlugin = __webpack_require__(475);
	var SimpleEventPlugin = __webpack_require__(476);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(61);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var EventListener = __webpack_require__(220);
	var ExecutionEnvironment = __webpack_require__(20);
	var PooledClass = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(29);
	
	var getEventTarget = __webpack_require__(138);
	var getUnboundedScrollPosition = __webpack_require__(504);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(50);
	var EventPluginHub = __webpack_require__(61);
	var EventPluginUtils = __webpack_require__(123);
	var ReactComponentEnvironment = __webpack_require__(127);
	var ReactClass = __webpack_require__(198);
	var ReactEmptyComponent = __webpack_require__(201);
	var ReactBrowserEventEmitter = __webpack_require__(84);
	var ReactHostComponent = __webpack_require__(203);
	var ReactUpdates = __webpack_require__(29);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(487);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactComponentEnvironment = __webpack_require__(127);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactMultiChildUpdateTypes = __webpack_require__(206);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactReconciler = __webpack_require__(51);
	var ReactChildReconciler = __webpack_require__(444);
	
	var emptyFunction = __webpack_require__(24);
	var flattenChildren = __webpack_require__(491);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var ReactComponent = __webpack_require__(126);
	var ReactNoopUpdateQueue = __webpack_require__(130);
	
	var emptyObject = __webpack_require__(66);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var CallbackQueue = __webpack_require__(195);
	var PooledClass = __webpack_require__(35);
	var ReactBrowserEventEmitter = __webpack_require__(84);
	var ReactInputSelection = __webpack_require__(204);
	var ReactInstrumentation = __webpack_require__(23);
	var Transaction = __webpack_require__(65);
	var ReactUpdateQueue = __webpack_require__(134);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(468);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return (
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(14);
	
	var PooledClass = __webpack_require__(35);
	var Transaction = __webpack_require__(65);
	var ReactInstrumentation = __webpack_require__(23);
	var ReactServerUpdateQueue = __webpack_require__(473);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(134);
	var Transaction = __webpack_require__(65);
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInputSelection = __webpack_require__(204);
	var SyntheticEvent = __webpack_require__(31);
	
	var getActiveElement = __webpack_require__(222);
	var isTextInputElement = __webpack_require__(218);
	var keyOf = __webpack_require__(37);
	var shallowEqual = __webpack_require__(143);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var EventConstants = __webpack_require__(30);
	var EventListener = __webpack_require__(220);
	var EventPropagators = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(16);
	var SyntheticAnimationEvent = __webpack_require__(477);
	var SyntheticClipboardEvent = __webpack_require__(478);
	var SyntheticEvent = __webpack_require__(31);
	var SyntheticFocusEvent = __webpack_require__(481);
	var SyntheticKeyboardEvent = __webpack_require__(483);
	var SyntheticMouseEvent = __webpack_require__(85);
	var SyntheticDragEvent = __webpack_require__(480);
	var SyntheticTouchEvent = __webpack_require__(484);
	var SyntheticTransitionEvent = __webpack_require__(485);
	var SyntheticUIEvent = __webpack_require__(64);
	var SyntheticWheelEvent = __webpack_require__(486);
	
	var emptyFunction = __webpack_require__(24);
	var getEventCharCode = __webpack_require__(136);
	var invariant = __webpack_require__(10);
	var keyOf = __webpack_require__(37);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(85);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventCharCode = __webpack_require__(136);
	var getEventKey = __webpack_require__(492);
	var getEventModifierState = __webpack_require__(137);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventModifierState = __webpack_require__(137);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(31);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(85);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 487 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactPropTypeLocationNames = __webpack_require__(131);
	var ReactPropTypesSecret = __webpack_require__(133);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(128);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(194);
	var warning = __webpack_require__(12);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactCurrentOwner = __webpack_require__(36);
	var ReactDOMComponentTree = __webpack_require__(16);
	var ReactInstanceMap = __webpack_require__(63);
	
	var getHostComponentFromComposite = __webpack_require__(214);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(12);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(124);
	var traverseAllChildren = __webpack_require__(141);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(128);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(136);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 493 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(11);
	
	var ReactElement = __webpack_require__(28);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(86);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(205);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 498 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(498);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(508);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var createArrayFromMixed = __webpack_require__(501);
	var getMarkupWrap = __webpack_require__(503);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(20);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 505 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(505);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(507);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 509 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** demo.js
 **/